/* eslint-disable */
import { cacheExchange } from '@urql/exchange-graphcache';
import { Resolver as GraphCacheResolver, UpdateResolver as GraphCacheUpdateResolver, OptimisticMutationResolver as GraphCacheOptimisticMutationResolver } from '@urql/exchange-graphcache';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A valid URL, transported as a string */
  File: { input: any; output: any; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
  /** A standard ID, represented as a String in a GraphQL response, and Int in ruby (corresponding to a numeric ID in our database) */
  MCID: { input: any; output: any; }
};

export type A2pSms = {
  __typename?: 'A2pSms';
  /** The content of the SMS sent to the user */
  content: Scalars['String']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** Date the a2p sms was sent */
  sentAtDate: Scalars['ISO8601DateTime']['output'];
};

export enum ActivationStatus {
  Activated = 'ACTIVATED',
  NotActivated = 'NOT_ACTIVATED',
  SecondWave = 'SECOND_WAVE'
}

/** An activity log */
export type ActivityLog = {
  __typename?: 'ActivityLog';
  /** The type of event that triggered creation of the activity log */
  eventType: ActivityLogEvent;
  /** The id */
  id: Scalars['ID']['output'];
  /** The associated loggable activity object */
  loggableActivity: LoggableActivity;
  /** The timestamp for when the event occurred */
  occurredAt: Scalars['ISO8601DateTime']['output'];
  /** The activity log */
  program: Program;
};


/** An activity log */
export type ActivityLogLoggableActivityArgs = {
  includeMathingSurveyResponses?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for ActivityLog. */
export type ActivityLogConnection = {
  __typename?: 'ActivityLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ActivityLogEdge>>>;
  /** The collection of activity log objects */
  nodes: Array<ActivityLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of assessment_survey_submitted activity logs in the collection */
  totalAssessmentSurveySubmittedCount: Scalars['Int']['output'];
  /** The total count of connected_via_p2p_relay activity logs in the collection */
  totalConnectedViaP2pRelayCount: Scalars['Int']['output'];
  /** The total count of conversation_reported activity logs in the collection */
  totalConversationReportedCount: Scalars['Int']['output'];
  /** The total count of activity logs in the collection */
  totalCount: Scalars['Int']['output'];
  /** The total count of flag_reported activity logs in the collection */
  totalFlagReportedCount: Scalars['Int']['output'];
  /** The total count of initial_matching_survey_review_notification activity logs in the collection */
  totalInitialMatchingSurveyReviewNotificationCount: Scalars['Int']['output'];
  /** The total count of invited_as_mentee activity logs in the collection */
  totalInvitedAsMenteeCount: Scalars['Int']['output'];
  /** The total count of invited_as_mentor activity logs in the collection */
  totalInvitedAsMentorCount: Scalars['Int']['output'];
  /** The total count of low_ahs_assessment_score_submitted activity logs in the collection */
  totalLowAhsAssessmentScoreSubmittedCount: Scalars['Int']['output'];
  /** The total count of low_ase_assessment_score_submitted activity logs in the collection */
  totalLowAseAssessmentScoreSubmittedCount: Scalars['Int']['output'];
  /** The total count of low_cdse_assessment_score_submitted activity logs in the collection */
  totalLowCdseAssessmentScoreSubmittedCount: Scalars['Int']['output'];
  /** The total count of low_sob_assessment_score_submitted activity logs in the collection */
  totalLowSobAssessmentScoreSubmittedCount: Scalars['Int']['output'];
  /** The total count of low_sr_assessment_score_submitted activity logs in the collection */
  totalLowSrAssessmentScoreSubmittedCount: Scalars['Int']['output'];
  /** The total count of matching_survey_updated_review_notification activity logs in the collection */
  totalMatchingSurveyUpdatedReviewNotificationCount: Scalars['Int']['output'];
  /** The total count of mentee_deregistered activity logs in the collection */
  totalMenteeDeregisteredCount: Scalars['Int']['output'];
  /** The total count of mentor_completed_training activity logs in the collection */
  totalMentorCompletedTrainingCount: Scalars['Int']['output'];
  /** The total count of mentor_deregistered activity logs in the collection */
  totalMentorDeregisteredCount: Scalars['Int']['output'];
  /** The total count of mentor_matching_survey_completed activity logs in the collection */
  totalMentorMatchingSurveyCompletedCount: Scalars['Int']['output'];
  /** The total count of mentor_signed_up_for_training activity logs in the collection */
  totalMentorSignedUpForTrainingCount: Scalars['Int']['output'];
  /** The total count of mentorship_unmatched activity logs in the collection */
  totalMentorshipUnmatchedCount: Scalars['Int']['output'];
  /** The total count of new_mentorship activity logs in the collection */
  totalNewMentorshipCount: Scalars['Int']['output'];
  /** The total count of registered_as_mentee activity logs in the collection */
  totalRegisteredAsMenteeCount: Scalars['Int']['output'];
  /** The total count of registered_as_mentor activity logs in the collection */
  totalRegisteredAsMentorCount: Scalars['Int']['output'];
  /** The total count of student_matching_survey_completed activity logs in the collection */
  totalStudentMatchingSurveyCompletedCount: Scalars['Int']['output'];
};

export type ActivityLogDate = {
  /** defined if filtering is to apply before or after date */
  operator?: InputMaybe<ActivityLogDateOperator>;
  /** filter for selected date value */
  selectedDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export enum ActivityLogDateOperator {
  After = 'AFTER',
  Before = 'BEFORE',
  On = 'ON'
}

/** An edge in a connection. */
export type ActivityLogEdge = {
  __typename?: 'ActivityLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ActivityLog>;
};

export enum ActivityLogEvent {
  AssessmentSurveySubmitted = 'ASSESSMENT_SURVEY_SUBMITTED',
  ConnectedViaP2PRelay = 'CONNECTED_VIA_P2P_RELAY',
  ConversationReported = 'CONVERSATION_REPORTED',
  FlagReported = 'FLAG_REPORTED',
  InitialMatchingSurveyReviewNotification = 'INITIAL_MATCHING_SURVEY_REVIEW_NOTIFICATION',
  InvitedAsMentee = 'INVITED_AS_MENTEE',
  InvitedAsMentor = 'INVITED_AS_MENTOR',
  LowAhsAssessmentScoreSubmitted = 'LOW_AHS_ASSESSMENT_SCORE_SUBMITTED',
  LowAseAssessmentScoreSubmitted = 'LOW_ASE_ASSESSMENT_SCORE_SUBMITTED',
  LowCdseAssessmentScoreSubmitted = 'LOW_CDSE_ASSESSMENT_SCORE_SUBMITTED',
  LowSobAssessmentScoreSubmitted = 'LOW_SOB_ASSESSMENT_SCORE_SUBMITTED',
  LowSrAssessmentScoreSubmitted = 'LOW_SR_ASSESSMENT_SCORE_SUBMITTED',
  MatchingSurveyUpdatedReviewNotification = 'MATCHING_SURVEY_UPDATED_REVIEW_NOTIFICATION',
  MenteeDeregistered = 'MENTEE_DEREGISTERED',
  MentorshipUnmatched = 'MENTORSHIP_UNMATCHED',
  MentorCompletedTraining = 'MENTOR_COMPLETED_TRAINING',
  MentorDeregistered = 'MENTOR_DEREGISTERED',
  MentorMatchingSurveyCompleted = 'MENTOR_MATCHING_SURVEY_COMPLETED',
  MentorSignedUpForTraining = 'MENTOR_SIGNED_UP_FOR_TRAINING',
  NewMentorship = 'NEW_MENTORSHIP',
  RegisteredAsMentee = 'REGISTERED_AS_MENTEE',
  RegisteredAsMentor = 'REGISTERED_AS_MENTOR',
  StudentMatchingSurveyCompleted = 'STUDENT_MATCHING_SURVEY_COMPLETED'
}

export type ActivityLogsFilter = {
  /** filter for created at date */
  date?: InputMaybe<ActivityLogDate>;
  /** filter by type of activity */
  eventTypes?: InputMaybe<Array<ActivityLogEvent>>;
  /** filter by exclusion of type of activity */
  excludeEventTypes?: InputMaybe<Array<ActivityLogEvent>>;
  /** Look for events that occurred after this date */
  occurredAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Look for events that occurred before this date */
  occurredBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The program */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /** The user */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ActivityLogsSort = {
  /** Which field to sort by */
  column: ActivityLogsSortByField;
  direction: SortDirection;
};

export enum ActivityLogsSortByField {
  OccurredAt = 'OCCURRED_AT'
}

/** Autogenerated return type of AddContactsFromExistingProgram. */
export type AddContactsFromExistingProgramPayload = {
  __typename?: 'AddContactsFromExistingProgramPayload';
  batchActionId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of AddContacts. */
export type AddContactsPayload = {
  __typename?: 'AddContactsPayload';
  batchActionId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of AddContactsToExistingUsers. */
export type AddContactsToExistingUsersPayload = {
  __typename?: 'AddContactsToExistingUsersPayload';
  batchActionId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
};

export type AddMessageTemplatesTags = {
  __typename?: 'AddMessageTemplatesTags';
  byFilterSelection: AddMessageTemplatesTagsByFilterSelectionPayload;
  byIds: AddMessageTemplatesTagsByIdsPayload;
};


export type AddMessageTemplatesTagsByFilterSelectionArgs = {
  filter?: InputMaybe<MessageTemplatesFilter>;
  tagIds: Array<Scalars['ID']['input']>;
  tagsToCreate?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type AddMessageTemplatesTagsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  tagIds: Array<Scalars['ID']['input']>;
  tagsToCreate?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of AddMessageTemplatesTagsByFilterSelection. */
export type AddMessageTemplatesTagsByFilterSelectionPayload = {
  __typename?: 'AddMessageTemplatesTagsByFilterSelectionPayload';
  /** Any errors trying to update message template tags */
  errors: Array<MessageTemplateTagsNotAbleToBeAddedError>;
  /** The updated message templates */
  messageTemplates?: Maybe<Array<MessageTemplate>>;
  /** The number of message templates update */
  numberOfMessageTemplatesUpdated?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of AddMessageTemplatesTagsByIds. */
export type AddMessageTemplatesTagsByIdsPayload = {
  __typename?: 'AddMessageTemplatesTagsByIdsPayload';
  /** Any errors trying to update message template tags */
  errors: Array<MessageTemplateTagsNotAbleToBeAddedError>;
  /** The updated message templates */
  messageTemplates?: Maybe<Array<MessageTemplate>>;
  /** The number of message templates update */
  numberOfMessageTemplatesUpdated?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of AddParticipants. */
export type AddParticipantsPayload = {
  __typename?: 'AddParticipantsPayload';
  batchActionId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
};

export type AdminAction = {
  __typename?: 'AdminAction';
  /** Who performed the action */
  adminUser: User;
  /** The id */
  id: Scalars['ID']['output'];
  /** When the action was performed */
  performedAt: Scalars['ISO8601DateTime']['output'];
  /** Changes that happened as a result of this action */
  resultingChanges: ObjectChangesetConnection;
  /** What type of action was taken */
  type: AdminActionType;
};


export type AdminActionResultingChangesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ObjectChangesetsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for AdminAction. */
export type AdminActionConnection = {
  __typename?: 'AdminActionConnection';
  /** The unique action types belonging to actions in the collection */
  actionTypes: Array<AdminActionType>;
  /** The unique users that any actions in the collection were performed by */
  adminUsers: Array<User>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AdminActionEdge>>>;
  /** The collection of admin action objects */
  nodes: Array<AdminAction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all actions in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminActionEdge = {
  __typename?: 'AdminActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AdminAction>;
};

export enum AdminActionType {
  ActivatedOnFirstWave = 'ACTIVATED_ON_FIRST_WAVE',
  ActivatedOnSecondWave = 'ACTIVATED_ON_SECOND_WAVE',
  ActivateContacts = 'ACTIVATE_CONTACTS',
  AutoMatchEnrollmentUsers = 'AUTO_MATCH_ENROLLMENT_USERS',
  AutoMatchStandardUsers = 'AUTO_MATCH_STANDARD_USERS',
  AutoMatchSupermentorUsers = 'AUTO_MATCH_SUPERMENTOR_USERS',
  AutoSaveMatchEnrollmentUsers = 'AUTO_SAVE_MATCH_ENROLLMENT_USERS',
  AutoSaveMatchStandardUsers = 'AUTO_SAVE_MATCH_STANDARD_USERS',
  AutoSaveMatchSupermentorUsers = 'AUTO_SAVE_MATCH_SUPERMENTOR_USERS',
  BatchRegisterExistingUsers = 'BATCH_REGISTER_EXISTING_USERS',
  ChangeTrainingStatus = 'CHANGE_TRAINING_STATUS',
  CreateNewPartner = 'CREATE_NEW_PARTNER',
  CreateProgram = 'CREATE_PROGRAM',
  CreateProgramGoal = 'CREATE_PROGRAM_GOAL',
  CreateProgramSequence = 'CREATE_PROGRAM_SEQUENCE',
  CreateProgramTask = 'CREATE_PROGRAM_TASK',
  DeleteNewProgramTask = 'DELETE_NEW_PROGRAM_TASK',
  DeleteProgramTask = 'DELETE_PROGRAM_TASK',
  MoveUsersToNewProgram = 'MOVE_USERS_TO_NEW_PROGRAM',
  RecruitFromExistingProgram = 'RECRUIT_FROM_EXISTING_PROGRAM',
  ReAssignContacts = 'RE_ASSIGN_CONTACTS',
  SendBulkMessageByCsv = 'SEND_BULK_MESSAGE_BY_CSV',
  StopRecruitment = 'STOP_RECRUITMENT',
  UnmatchUsers = 'UNMATCH_USERS',
  UpdateProgram = 'UPDATE_PROGRAM',
  UpdateProgramCustomMessageTemplates = 'UPDATE_PROGRAM_CUSTOM_MESSAGE_TEMPLATES',
  UpdateProgramGoal = 'UPDATE_PROGRAM_GOAL',
  UpdateProgramSequence = 'UPDATE_PROGRAM_SEQUENCE',
  UpdateProgramTask = 'UPDATE_PROGRAM_TASK',
  UpdateProgramTopics = 'UPDATE_PROGRAM_TOPICS',
  UploadContacts = 'UPLOAD_CONTACTS',
  UploadContactsToExistingUsers = 'UPLOAD_CONTACTS_TO_EXISTING_USERS',
  UploadEnrollmentSchoolIds = 'UPLOAD_ENROLLMENT_SCHOOL_IDS',
  UploadParticipants = 'UPLOAD_PARTICIPANTS',
  UploadPhoneNumbers = 'UPLOAD_PHONE_NUMBERS',
  UploadSchoolIds = 'UPLOAD_SCHOOL_IDS',
  UploadUserProfileData = 'UPLOAD_USER_PROFILE_DATA'
}

export type AdminActionsFilter = {
  /** Filter for actions performed by specific admin users */
  adminUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter for actions relevant to a specific programs */
  relevantToProgramIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by selected action types */
  types?: InputMaybe<Array<AdminActionType>>;
};

export type AdminActionsSort = {
  /** Which field to sort by */
  column: AdminActionsSortByField;
  direction: SortDirection;
};

export enum AdminActionsSortByField {
  AdminUserFirstName = 'ADMIN_USER_FIRST_NAME',
  PerformedDate = 'PERFORMED_DATE'
}

export enum AffectedObject {
  Contact = 'CONTACT',
  Mentorship = 'MENTORSHIP',
  MicroSurvey = 'MICRO_SURVEY',
  NewProgramTask = 'NEW_PROGRAM_TASK',
  Program = 'PROGRAM',
  ProgramCustomMessageTemplate = 'PROGRAM_CUSTOM_MESSAGE_TEMPLATE',
  ProgramGoal = 'PROGRAM_GOAL',
  ProgramSequence = 'PROGRAM_SEQUENCE',
  ProgramTask = 'PROGRAM_TASK',
  ProgramTopic = 'PROGRAM_TOPIC',
  Registrant = 'REGISTRANT',
  SavedMatch = 'SAVED_MATCH',
  SchoolIdentifier = 'SCHOOL_IDENTIFIER',
  User = 'USER'
}

export type AffectedObjectTypeCount = {
  __typename?: 'AffectedObjectTypeCount';
  /** How many of these events happened to this type of object */
  count: Scalars['Int']['output'];
  /** The type of change that happened */
  eventType: ObjectChangeEvent;
  /** The type of object affected */
  objectType: AffectedObject;
};

export enum AllowFallbackToOtherPrograms {
  AllPrograms = 'all_programs',
  None = 'none',
  WithinInstitution = 'within_institution'
}

export type ArchiveRestoreMessageTemplates = {
  __typename?: 'ArchiveRestoreMessageTemplates';
  byFilterSelection: ArchiveRestoreMessageTemplatesByFilterSelectionPayload;
  byIds: ArchiveRestoreMessageTemplatesByIdsPayload;
};


export type ArchiveRestoreMessageTemplatesByFilterSelectionArgs = {
  filter?: InputMaybe<MessageTemplatesFilter>;
  setArchived: Scalars['Boolean']['input'];
};


export type ArchiveRestoreMessageTemplatesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  setArchived: Scalars['Boolean']['input'];
};

/** Autogenerated return type of ArchiveRestoreMessageTemplatesByFilterSelection. */
export type ArchiveRestoreMessageTemplatesByFilterSelectionPayload = {
  __typename?: 'ArchiveRestoreMessageTemplatesByFilterSelectionPayload';
  /** Any errors trying to update message template archived_at */
  errors: Array<ArchiveRestoreMessageTemplatesError>;
  /** The updated message templates */
  messageTemplates?: Maybe<Array<MessageTemplate>>;
  /** The number of message templates updated */
  numberOfMessageTemplatesUpdated?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of ArchiveRestoreMessageTemplatesByIds. */
export type ArchiveRestoreMessageTemplatesByIdsPayload = {
  __typename?: 'ArchiveRestoreMessageTemplatesByIdsPayload';
  /** Any errors trying to update message template archived_at */
  errors: Array<ArchiveRestoreMessageTemplatesError>;
  /** The updated message templates */
  messageTemplates?: Maybe<Array<MessageTemplate>>;
  /** The number of message templates updated */
  numberOfMessageTemplatesUpdated?: Maybe<Scalars['Int']['output']>;
};

export enum ArchiveRestoreMessageTemplatesError {
  /** Unable to update archived_at for message templates */
  UnableToArchiveRestore = 'UNABLE_TO_ARCHIVE_RESTORE'
}

export type AssessmentArea = {
  __typename?: 'AssessmentArea';
  /** The prompts associated with this area */
  assessmentPrompts: Array<AssessmentPrompt>;
  /** The id */
  id: Scalars['ID']['output'];
  /** The assessment identifier or QID equivalent */
  identifier: AssessmentAreaIdentifier;
  /** The name of the assessment area */
  name: Scalars['String']['output'];
};


export type AssessmentAreaAssessmentPromptsArgs = {
  programId?: InputMaybe<Scalars['ID']['input']>;
};

export enum AssessmentAreaIdentifier {
  Ahs = 'ahs',
  Ase = 'ase',
  Cdse = 'cdse',
  Sob = 'sob',
  Sr = 'sr'
}

export type AssessmentPrompt = {
  __typename?: 'AssessmentPrompt';
  /** The id */
  id: Scalars['ID']['output'];
  /** The assessment prompt identifier */
  identifier: Scalars['String']['output'];
  /** The text of the assessment prompt */
  text: Scalars['String']['output'];
};

export type AssessmentScoreResponse = {
  __typename?: 'AssessmentScoreResponse';
  /** The id */
  id: Scalars['ID']['output'];
  /** The program the response was submitted for */
  program: Program;
  /** The user who submitted the response */
  user: User;
};

export type AssessmentScoreResponsesFilter = {
  /** filter by program id */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /** filter by scores attributes */
  scoresFilter?: InputMaybe<AssessmentScoresFilter>;
  /** filter by submitted after date */
  submittedAfterDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter by submitted before date */
  submittedBeforeDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter by users */
  usersFilter?: InputMaybe<UsersFilter>;
};

export type AssessmentScoreResponsesMetrics = {
  __typename?: 'AssessmentScoreResponsesMetrics';
  averageAssessmentScore: Array<Interval>;
};


export type AssessmentScoreResponsesMetricsAverageAssessmentScoreArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<AssessmentScoresGroupBy>;
  intervalBy: TimePeriod;
};

export type AssessmentScoresFilter = {
  /** filter by assessment area identifier */
  assessmentAreaIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** filter by assessment prompt identifier */
  assessmentPromptIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** filter by program id */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /** filter by submitted after date */
  submittedAfterDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter by submitted before date */
  submittedBeforeDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter by survey id */
  surveyId?: InputMaybe<Scalars['ID']['input']>;
  /** filter by users */
  usersFilter?: InputMaybe<UsersFilter>;
};

export enum AssessmentScoresGroupBy {
  AssessmentAreaIdentifier = 'ASSESSMENT_AREA_IDENTIFIER',
  AssessmentAreaName = 'ASSESSMENT_AREA_NAME',
  AssessmentPromptIdentifier = 'ASSESSMENT_PROMPT_IDENTIFIER',
  AssessmentPromptText = 'ASSESSMENT_PROMPT_TEXT'
}

export enum AssessmentSurveyProgramStage {
  End = 'END',
  Mid = 'MID',
  Post = 'POST',
  Pre = 'PRE',
  Start = 'START'
}

export type AssessmentSurveyTaskAssignment = TaskAssignment & {
  __typename?: 'AssessmentSurveyTaskAssignment';
  /** The behavior for the new program task */
  behavior: Behavior;
  /** The display name from the new program task */
  displayName: Scalars['String']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The participant if assigned to particular participant */
  participantId: Scalars['ID']['output'];
  /** The position in checklist */
  position: Scalars['Int']['output'];
  /** The program stage */
  programStage: AssessmentSurveyProgramStage;
  /** The state of the assigned task assignment */
  status: TaskAssignmentStatus;
  /** A id of the assessment survey */
  surveyId: Scalars['ID']['output'];
  /** The user */
  userId: Scalars['ID']['output'];
};

export type AssessmentSurveyTaskContext = {
  __typename?: 'AssessmentSurveyTaskContext';
  /** The id */
  id: Scalars['ID']['output'];
  /** The associated new task */
  newTask?: Maybe<NewTask>;
  /** The program stage */
  programStage: AssessmentSurveyProgramStage;
  /** The associated assessment survey */
  surveyId: Scalars['ID']['output'];
};

export enum AssigneeEntity {
  Mentor = 'Mentor',
  Participant = 'Participant',
  Student = 'Student'
}

export type AutoMatchSettings = {
  __typename?: 'AutoMatchSettings';
  /** The maximum number of mentees that any mentor can be matched with */
  mentorCapacityCap?: Maybe<Scalars['Int']['output']>;
  /** The score threshold for minimum matchability - deprecated */
  scoreThreshold?: Maybe<Scalars['Int']['output']>;
  /** Whether or not to use standard matching */
  standardMatching?: Maybe<Scalars['Boolean']['output']>;
  /** The score threshold for minimum standard matchability */
  standardScoreThreshold?: Maybe<Scalars['Int']['output']>;
  /** Whether or not to use supermentor matching */
  supermentorMatching?: Maybe<Scalars['Boolean']['output']>;
  /** The score threshold for minimum supermentor matchability */
  supermentorScoreThreshold?: Maybe<Scalars['Int']['output']>;
};

export enum AutoMatchStrategy {
  Enrollment = 'ENROLLMENT',
  SpreadTheLove = 'SPREAD_THE_LOVE',
  Standard = 'STANDARD',
  Supermentor = 'SUPERMENTOR',
  SupermentorAndStandard = 'SUPERMENTOR_AND_STANDARD'
}

/** Input for threshold settings for auto match */
export type AutoMatchingSettingsInput = {
  mentorCapacityCap?: InputMaybe<Scalars['Int']['input']>;
  /** Deprecated */
  scoreThreshold?: InputMaybe<Scalars['Int']['input']>;
  standardMatching?: InputMaybe<Scalars['Boolean']['input']>;
  standardScoreThreshold?: InputMaybe<Scalars['Int']['input']>;
  supermentorMatching?: InputMaybe<Scalars['Boolean']['input']>;
  supermentorScoreThreshold?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for auto match suggestions config */
export type AutoSuggestMatchesInput = {
  /** Deprecated - only used in old automatching flow. Multiple strategies can be accommodated within auto_matching_settings */
  autoMatchStrategy?: InputMaybe<AutoMatchStrategy>;
  autoMatchingSettings: AutoMatchingSettingsInput;
  groupMatchingSettings?: InputMaybe<GroupMatchingSettingsInput>;
  matchingCriteria: MatchingCriteriaInput;
  programId: Scalars['ID']['input'];
  questionsWeights?: InputMaybe<Array<QuestionWeightInput>>;
};

/** Autogenerated return type of AutoSuggestMatches. */
export type AutoSuggestMatchesPayload = {
  __typename?: 'AutoSuggestMatchesPayload';
  batchId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type AutomatchingDefault = {
  __typename?: 'AutomatchingDefault';
  /** Date created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User-facing label for the default setting */
  displayName: Scalars['String']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** Identifier for the default setting */
  identifier: Scalars['String']['output'];
  /** The settings used to make suggestions */
  settings: SuggestedBatchSettings;
  /** Date updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input for new matching surveys */
export type BaseMatchingSurveyInput = {
  aboutMeQuestion: OptionListQuestionInput;
  academicInterestsQuestion: OptionListQuestionInput;
  basicInfo: BasicInfoInput;
  careersQuestion: OptionListQuestionInput;
  challengesQuestion: OptionListQuestionInput;
  codeOfConduct: CodeOfConductInput;
  existingCustomQuestions?: InputMaybe<ExistingCustomQuestionInput>;
  genderQuestion: QuestionCustomizationsInput;
  hobbiesQuestion: OptionListQuestionInput;
  languagesQuestion: OptionListQuestionInput;
  majorQuestion: QuestionCustomizationsInput;
  mentorCapacityQuestion: MentorCapacityInput;
  raceOrEthnicityQuestion: QuestionCustomizationsInput;
  toggleQuestionIds: ToggleQuestionInput;
};

/** Basic info for matching survey */
export type BasicInfoInput = {
  /** The survey id to branch off for mentee */
  baseMenteeSurveyId?: InputMaybe<Scalars['ID']['input']>;
  /** The survey id to branch off for mentor */
  baseMentorSurveyId?: InputMaybe<Scalars['ID']['input']>;
  /** The segment to pull base surveys from */
  baseSurveySegment?: InputMaybe<ProgramSegment>;
};

export enum Behavior {
  AssessmentSurvey = 'assessment_survey',
  ClickLink = 'click_link',
  MentorTraining = 'mentor_training',
  NonTrainingCourse = 'non_training_course'
}

export type CachedUserProfileDataAttributeInput = {
  attributeCategoryId?: InputMaybe<Scalars['MCID']['input']>;
  attributeType?: InputMaybe<ProfileAttributeType>;
};

export type CachedUserProfileDataAttributeValue = {
  __typename?: 'CachedUserProfileDataAttributeValue';
  id: Scalars['ID']['output'];
  /** The profile attribute for this attribute value */
  profileAttribute: ProfileAttribute;
  /** The array of values for the profile attribute */
  values: Array<Scalars['String']['output']>;
};

export enum CachedUserProfileDataSettingsFilter {
  AdminDashboardSourceInstitution = 'ADMIN_DASHBOARD_SOURCE_INSTITUTION',
  AdminDashboardSourceUser = 'ADMIN_DASHBOARD_SOURCE_USER',
  ManualMatchingDashboard = 'MANUAL_MATCHING_DASHBOARD',
  ManualMatchingDashboardMajor = 'MANUAL_MATCHING_DASHBOARD_MAJOR',
  ManualMatchingDashboardMentorCapacity = 'MANUAL_MATCHING_DASHBOARD_MENTOR_CAPACITY',
  ManualMatchingDashboardTransferStatus = 'MANUAL_MATCHING_DASHBOARD_TRANSFER_STATUS',
  ParticipantDashboard = 'PARTICIPANT_DASHBOARD',
  PartnerDashboard = 'PARTNER_DASHBOARD',
  PartnerDashboardExport = 'PARTNER_DASHBOARD_EXPORT'
}

export type ChangeInput = {
  customDisplayName?: InputMaybe<Scalars['String']['input']>;
  customSmsCharacter?: InputMaybe<Scalars['String']['input']>;
  flagCategoryId: Scalars['ID']['input'];
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ChangeMentorTrainingStatus. */
export type ChangeMentorTrainingStatusPayload = {
  __typename?: 'ChangeMentorTrainingStatusPayload';
  batchActionId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
};

export type Changes = {
  flags?: InputMaybe<Array<ChangeInput>>;
  showMentorsFlags?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClickLinkTaskAssignment = TaskAssignment & {
  __typename?: 'ClickLinkTaskAssignment';
  /** The behavior for the new program task */
  behavior: Behavior;
  /** The display name from the new program task */
  displayName: Scalars['String']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The participant if assigned to particular participant */
  participantId: Scalars['ID']['output'];
  /** The position in checklist */
  position: Scalars['Int']['output'];
  /** The state of the assigned task assignment */
  status: TaskAssignmentStatus;
  /** A url used to construct a link the user should visit to complete this task */
  url: Scalars['String']['output'];
  /** The user */
  userId: Scalars['ID']['output'];
};

/** Code of conduct text for matching surveys */
export type CodeOfConductInput = {
  /** The text to use for mentee survey Code of Conduct */
  menteeText?: InputMaybe<Scalars['String']['input']>;
  /** The text to use for mentor survey Code of Conduct */
  mentorText?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CompleteTaskAssignment. */
export type CompleteTaskAssignmentPayload = {
  __typename?: 'CompleteTaskAssignmentPayload';
  errors: Array<Error>;
  taskAssignment?: Maybe<TaskAssignment>;
};

/** A user-readable error */
export type ConfigureFlagsError = {
  __typename?: 'ConfigureFlagsError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: Scalars['String']['output'];
};

/** Program resource input on creation */
export type ConfigureFlagsInput = {
  changes: Changes;
  programId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConfigureFlags. */
export type ConfigureFlagsPayload = {
  __typename?: 'ConfigureFlagsPayload';
  errors: Array<ConfigureFlagsError>;
  program?: Maybe<Program>;
};

/** A contact */
export type Contact = {
  /** Any a2p smses sent to this contact */
  a2pSmses: Array<A2pSms>;
  /** The contact's activation status */
  activationStatus: ActivationStatus;
  /** When the contact's activation status last changed */
  activationStatusChangedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Batch action ID the contact was created from */
  batchActionId?: Maybe<Scalars['String']['output']>;
  /** The id */
  id: Scalars['ID']['output'];
  /** Any notes about this contact */
  notes?: Maybe<Scalars['String']['output']>;
  /** The program this mentor belongs to */
  program: Program;
  /** The contact's registration status */
  registered: Scalars['Boolean']['output'];
  /** Who uploaded this contact */
  uploadedBy?: Maybe<User>;
  /** When the contact registered */
  uploadedDate: Scalars['ISO8601DateTime']['output'];
  /** The user */
  user: User;
};

/** The connection type for Contact. */
export type ContactConnection = {
  __typename?: 'ContactConnection';
  /** The total count of all student contacts that are activated for first wave recruitment */
  activatedCount: Scalars['Int']['output'];
  /** The unique batch action IDs that any contacts in the collection were created from */
  batchActionIds: Array<Scalars['String']['output']>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContactEdge>>>;
  /** The total count of all contacts in the collection */
  mentorContactCount: Scalars['Int']['output'];
  /** The collection of mentor contact objects */
  nodes: Array<Contact>;
  /** The total count of all student contacts that are not activated */
  notActivatedCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all contacts that are already registered */
  registeredCount: Scalars['Int']['output'];
  /** The total count of all student contacts that are activated for second wave recruitment */
  secondWaveCount: Scalars['Int']['output'];
  /** The total count of all contacts in the collection */
  studentContactCount: Scalars['Int']['output'];
  /** The total count of all contacts in the collection */
  totalCount: Scalars['Int']['output'];
  /** The total count of unique users in the collection */
  totalCountOfDistinctUsers: Scalars['Int']['output'];
  /** The unique users that any contacts in the collection were uploaded by */
  uploadedByUsers: Array<User>;
};

/** An edge in a connection. */
export type ContactEdge = {
  __typename?: 'ContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Contact>;
};

export enum ContactEnum {
  /** MentorContact */
  MentorContact = 'MENTOR_CONTACT',
  /** StudentContact */
  StudentContact = 'STUDENT_CONTACT'
}

export enum ContactTypeFilter {
  MentorContacts = 'MENTOR_CONTACTS',
  StudentContacts = 'STUDENT_CONTACTS'
}

export type ContactsFilter = {
  /** Look for contacts by activation status */
  activationStatus?: InputMaybe<ActivationStatus>;
  /** Look for contacts created from these batch action IDs */
  batchActionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Look for contacts that have/have not received a2p sms */
  hasReceivedSms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by specific contact IDs */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by specific program IDs */
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by contacts that are registered in this program */
  registeredInProgram?: InputMaybe<RegistrantTypeFilter>;
  /** filter by a search term - USES OLD PROFILE DATA LOCATIONS */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** Program Segment to filter by */
  segment?: InputMaybe<ProgramSegment>;
  /** filter by a search term using the new profile data locations */
  simpleSearchString?: InputMaybe<Scalars['String']['input']>;
  /** Type to filter by */
  type?: InputMaybe<ContactTypeFilter>;
  /** Look for contacts that were uploaded before this date */
  uploadedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Look for contacts that were uploaded before this date */
  uploadedBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Look for contacts that were uploaded by users matching these IDs */
  uploadedByUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ContactsGroupBy = {
  contactsGroupByProfileData?: InputMaybe<ContactsGroupByProfileData>;
};

export type ContactsGroupByProfileData = {
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule>>;
  preferredProgramId: Scalars['ID']['input'];
  preferredSource: ProfileAttributeSource;
  /** The id of the category to filter by */
  profileAttributeCategoryId?: InputMaybe<Scalars['MCID']['input']>;
  profileAttributeNumericValueGroups?: InputMaybe<Array<ProfileAttributeNumericValueGroup>>;
  profileAttributeType?: InputMaybe<ProfileAttributeType>;
};

export type ContactsMetrics = {
  __typename?: 'ContactsMetrics';
  totalInvited: Array<Interval>;
};


export type ContactsMetricsTotalInvitedArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ContactsGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
};

export enum ContactsNotAbleToBeActivatedError {
  /** One or more selected contacts have already been activated for recruitment */
  ContactAlreadyActive = 'CONTACT_ALREADY_ACTIVE',
  /** One or more selected contacts are already registered for this program */
  ContactAlreadyRegistered = 'CONTACT_ALREADY_REGISTERED',
  /** One or more selected contacts is not already on first wave recruitment */
  ContactNotOnFirstWaveRecruitment = 'CONTACT_NOT_ON_FIRST_WAVE_RECRUITMENT'
}

export enum ContactsNotAbleToBeDeactivatedError {
  /** One or more selected contacts has not been activated for recruitment */
  ContactNotActive = 'CONTACT_NOT_ACTIVE'
}

export enum ContactsNotAbleToBeDeletedError {
  /** One or more selected contacts have already been active and have child data which cannot be deleted */
  ContactAlreadyActive = 'CONTACT_ALREADY_ACTIVE'
}

/** We have two collections (participants and contacts)that are separate on the backend but appear to the user as one collection on the frontend.This requires us to perform an "OR" between the two collections when a user only has eithera participant or a contact, but not both. If a user does have both a contact and participant,we want to perform an "AND" between the two collections. */
export type ContactsParticipantsFilter = {
  /** filter a user's contacts */
  contacts?: InputMaybe<ContactsFilter>;
  /** filter a user's participants */
  participants?: InputMaybe<ParticipantsFilter>;
};

export type ContactsSort = {
  /** Which field to sort by */
  column: ContactsSortByField;
  direction: SortDirection;
};

export enum ContactsSortByField {
  ActivatedDate = 'ACTIVATED_DATE',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Type = 'TYPE',
  UploadedDate = 'UPLOADED_DATE'
}

export type ContentfulModuleResource = {
  __typename?: 'ContentfulModuleResource';
  /** The Contentful URL of the resource */
  contentfulUrl: Scalars['String']['output'];
  /** The icon image to represent this guide */
  icon: Scalars['String']['output'];
  /** The internal id of the resource */
  id: Scalars['ID']['output'];
  /** The Contentful identifier of the resource */
  identifier: Scalars['String']['output'];
  /** Sections from the contentful entry */
  sections: Array<ContentfulModuleSection>;
};

export type ContentfulModuleSection = {
  __typename?: 'ContentfulModuleSection';
  /** Optional sub-content we want to display with a different treatment */
  examples?: Maybe<Array<ContentfulModuleSection>>;
  /** The id */
  id: Scalars['ID']['output'];
  /** The name */
  name: Scalars['String']['output'];
  /** Optional sub-content we want to display with a different treatment */
  options?: Maybe<Array<ContentfulModuleSection>>;
  /** The content */
  text?: Maybe<Scalars['String']['output']>;
  /** Hidden from user if false */
  visibleToMentee: Scalars['Boolean']['output'];
  /** Hidden from user if false */
  visibleToMentor: Scalars['Boolean']['output'];
};

/** Context for NewProgramTasks; CourseTaskContext */
export type Context = AssessmentSurveyTaskContext | CourseTaskContext | LinkTaskContext;

export type ConversationLog = {
  __typename?: 'ConversationLog';
  /** Date created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** When the conversation was logged */
  loggedAtDate: Scalars['ISO8601DateTime']['output'];
  /** The mentorship */
  mentorship: Mentorship;
  /** The modes of communication used */
  modesOfCommunication: Array<ModeOfCommunication>;
  /** The topics that were part of the conversation */
  topics: Array<ConversationTopic>;
};

export enum ConversationTopic {
  Academics = 'ACADEMICS',
  Activities = 'ACTIVITIES',
  BenefitsAndCompensation = 'BENEFITS_AND_COMPENSATION',
  BuildingProfessionalBrand = 'BUILDING_PROFESSIONAL_BRAND',
  Career = 'CAREER',
  CareerFairs = 'CAREER_FAIRS',
  ComparingSchools = 'COMPARING_SCHOOLS',
  ConnectingCourseworkToCareer = 'CONNECTING_COURSEWORK_TO_CAREER',
  CorporateCareer = 'CORPORATE_CAREER',
  CurrentEvents = 'CURRENT_EVENTS',
  FamilyLife = 'FAMILY_LIFE',
  FinancialAid = 'FINANCIAL_AID',
  GettingInvolvedAndCompanyProgramming = 'GETTING_INVOLVED_AND_COMPANY_PROGRAMMING',
  GettingToKnowEachOther = 'GETTING_TO_KNOW_EACH_OTHER',
  GraduateSchool = 'GRADUATE_SCHOOL',
  Interviewing = 'INTERVIEWING',
  LinkedIn = 'LINKED_IN',
  ManagingUp = 'MANAGING_UP',
  Movies = 'MOVIES',
  Networking = 'NETWORKING',
  OnboardingToCompanyOrDepartment = 'ONBOARDING_TO_COMPANY_OR_DEPARTMENT',
  Other = 'OTHER',
  OvercomingObstaclesAndNavigatingTheWorkplace = 'OVERCOMING_OBSTACLES_AND_NAVIGATING_THE_WORKPLACE',
  PersonnelChallenges = 'PERSONNEL_CHALLENGES',
  ProfessionalDevelopment = 'PROFESSIONAL_DEVELOPMENT',
  ResearchOpportunities = 'RESEARCH_OPPORTUNITIES',
  Resumes = 'RESUMES',
  SchoolLife = 'SCHOOL_LIFE',
  StayingBalanced = 'STAYING_BALANCED',
  StudentOrCampusLife = 'STUDENT_OR_CAMPUS_LIFE',
  TransferringSchools = 'TRANSFERRING_SCHOOLS',
  Traveling = 'TRAVELING',
  VideoGames = 'VIDEO_GAMES',
  WorkLifeBalance = 'WORK_LIFE_BALANCE'
}

export type Country = {
  __typename?: 'Country';
  /** The ISO 3166-1 alpha-2 country code of the country */
  code: Scalars['String']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The print-friendly name of the country */
  name: Scalars['String']['output'];
};

export type Course = {
  __typename?: 'Course';
  /** Whether or not the course exists in Thinkific */
  active: Scalars['Boolean']['output'];
  /** The external service ID of the course */
  externalServiceId: Scalars['String']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The name of the course */
  name: Scalars['String']['output'];
  /** Whether or not the course is currently published */
  published: Scalars['Boolean']['output'];
  /** The service name of the external service ID */
  serviceName: Scalars['String']['output'];
  /** The slug of the course */
  slug: Scalars['String']['output'];
};

/** The connection type for Course. */
export type CourseConnection = {
  __typename?: 'CourseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CourseEdge>>>;
  /** The collection of course objects */
  nodes: Array<Course>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all courses in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CourseEdge = {
  __typename?: 'CourseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Course>;
};

export type CourseTaskAssignment = TaskAssignment & {
  __typename?: 'CourseTaskAssignment';
  /** The behavior for the new program task */
  behavior: Behavior;
  /** The course that needs to be taken by the participant */
  courseId: Scalars['ID']['output'];
  /** The display name from the new program task */
  displayName: Scalars['String']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The participant if assigned to particular participant */
  participantId: Scalars['ID']['output'];
  /** The position in checklist */
  position: Scalars['Int']['output'];
  /** The state of the assigned task assignment */
  status: TaskAssignmentStatus;
  /** The user */
  userId: Scalars['ID']['output'];
};

export type CourseTaskContext = {
  __typename?: 'CourseTaskContext';
  /** The associated course */
  courseId: Scalars['ID']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The associated new task */
  newTask?: Maybe<NewTask>;
};

export type CoursesSort = {
  /** Which field to sort by */
  column: CoursesSortByField;
  direction: SortDirection;
};

export enum CoursesSortByField {
  Id = 'ID',
  Name = 'NAME'
}

export type CreateEmailTemplateInput = {
  category: MessageCategory;
  content: Scalars['String']['input'];
  customMessageType?: InputMaybe<ProgramCustomMessage>;
  isDefault: Scalars['Boolean']['input'];
  messageType: Message;
  name: Scalars['String']['input'];
  preheaderText?: InputMaybe<Scalars['String']['input']>;
  programSegment?: InputMaybe<ProgramSegment>;
  subjectLine: Scalars['String']['input'];
  tagIds: Array<Scalars['ID']['input']>;
  templateEditorData: Scalars['JSON']['input'];
  userState: UserState;
};

/** Autogenerated return type of CreateEmailTemplate. */
export type CreateEmailTemplatePayload = {
  __typename?: 'CreateEmailTemplatePayload';
  emailTemplate: EmailTemplate;
};

export type CreateEmailTemplateSavedRowInput = {
  category: EmailTemplateSavedRowCategory;
  name: Scalars['String']['input'];
  templateEditorData: Scalars['JSON']['input'];
};

/** Autogenerated return type of CreateEmailTemplateSavedRow. */
export type CreateEmailTemplateSavedRowPayload = {
  __typename?: 'CreateEmailTemplateSavedRowPayload';
  emailTemplateSavedRow: EmailTemplateSavedRow;
};

/** Flag Contact input on create */
export type CreateFlagContactInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  flagCategories: Array<FlagCategoryInput>;
  lastName: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateFlagContact. */
export type CreateFlagContactPayload = {
  __typename?: 'CreateFlagContactPayload';
  errors: Array<InvalidFlagContactInputError>;
  flagContacts?: Maybe<Array<FlagContact>>;
};

/** Autogenerated return type of CreateMatchingLabel. */
export type CreateMatchingLabelPayload = {
  __typename?: 'CreateMatchingLabelPayload';
  /** The created matching label */
  matchingLabel?: Maybe<MatchingLabel>;
  /** The updated participant record */
  participant?: Maybe<Participant>;
};

/** Input for new matching surveys */
export type CreateMatchingSurveyInput = {
  aboutMeQuestion: OptionListQuestionInput;
  academicInterestsQuestion: OptionListQuestionInput;
  basicInfo: BasicInfoInput;
  careersQuestion: OptionListQuestionInput;
  challengesQuestion: OptionListQuestionInput;
  codeOfConduct: CodeOfConductInput;
  existingCustomQuestions?: InputMaybe<ExistingCustomQuestionInput>;
  genderQuestion: QuestionCustomizationsInput;
  hobbiesQuestion: OptionListQuestionInput;
  languagesQuestion: OptionListQuestionInput;
  majorQuestion: QuestionCustomizationsInput;
  mentorCapacityQuestion: MentorCapacityInput;
  programId: Scalars['ID']['input'];
  raceOrEthnicityQuestion: QuestionCustomizationsInput;
  toggleQuestionIds: ToggleQuestionInput;
};

/** Autogenerated return type of CreateMatchingSurvey. */
export type CreateMatchingSurveyPayload = {
  __typename?: 'CreateMatchingSurveyPayload';
  errors: Array<Error>;
  program?: Maybe<Program>;
  surveys?: Maybe<Array<Survey>>;
};

/** Autogenerated return type of CreateMessageTemplateTag. */
export type CreateMessageTemplateTagPayload = {
  __typename?: 'CreateMessageTemplateTagPayload';
  messageTemplateTag: EmailTemplate;
};

/** MicroSurvey Input on create */
export type CreateMicroSurveyInput = {
  expireAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startAt: Scalars['ISO8601DateTime']['input'];
  survey: SurveyInput;
  targetingCriteria?: InputMaybe<MicroSurveyTargetingCriteriaInput>;
};

/** Autogenerated return type of CreateMicroSurvey. */
export type CreateMicroSurveyPayload = {
  __typename?: 'CreateMicroSurveyPayload';
  errors: Array<Scalars['String']['output']>;
  /** The micro_survey that gets created */
  microSurvey?: Maybe<MicroSurvey>;
};

/** Autogenerated return type of CreateNewCourseTaskAndNewProgramTask. */
export type CreateNewCourseTaskAndNewProgramTaskPayload = {
  __typename?: 'CreateNewCourseTaskAndNewProgramTaskPayload';
  duplicateTasks?: Maybe<Array<NewTask>>;
  errors: Array<DuplicateError>;
  newProgramTask?: Maybe<NewProgramTask>;
  newTask?: Maybe<NewTask>;
};

/** Autogenerated return type of CreateNewLinkTaskAndNewProgramTask. */
export type CreateNewLinkTaskAndNewProgramTaskPayload = {
  __typename?: 'CreateNewLinkTaskAndNewProgramTaskPayload';
  duplicateTasks?: Maybe<Array<NewTask>>;
  errors: Array<DuplicateError>;
  newProgramTask?: Maybe<NewProgramTask>;
  newTask?: Maybe<NewTask>;
};

/** Autogenerated return type of CreateNotificationView. */
export type CreateNotificationViewPayload = {
  __typename?: 'CreateNotificationViewPayload';
  /** The updated user with new notification view. */
  user: User;
};

/** Autogenerated return type of CreateOrEnableNewProgramTask. */
export type CreateOrEnableNewProgramTaskPayload = {
  __typename?: 'CreateOrEnableNewProgramTaskPayload';
  errors: Array<Scalars['String']['output']>;
  newProgramTask?: Maybe<NewProgramTask>;
};

/** Partner input on create */
export type CreatePartnerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  programSequenceIds: Array<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreatePartner. */
export type CreatePartnerPayload = {
  __typename?: 'CreatePartnerPayload';
  errors: Array<InvalidPartnerInputError>;
  partners?: Maybe<Array<Partner>>;
};

/** Input for automatching configuration for a specific program, aka saved settings */
export type CreateProgramAutomatchingConfigurationInput = {
  autoMatchingSettings: AutoMatchingSettingsInput;
  groupMatchingSettings?: InputMaybe<GroupMatchingSettingsInput>;
  matchingCriteria: MatchingCriteriaInput;
  programId: Scalars['ID']['input'];
  questionsWeights: Array<QuestionWeightInput>;
  shearwaterAdministratorId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateProgramAutomatchingConfiguration. */
export type CreateProgramAutomatchingConfigurationPayload = {
  __typename?: 'CreateProgramAutomatchingConfigurationPayload';
  errors: Array<Error>;
  programAutomatchingConfiguration?: Maybe<ProgramAutomatchingConfiguration>;
};

/** Autogenerated return type of CreateProgramAutomatchingDefault. */
export type CreateProgramAutomatchingDefaultPayload = {
  __typename?: 'CreateProgramAutomatchingDefaultPayload';
  errors: Array<Error>;
  programAutomatchingDefault?: Maybe<ProgramAutomatchingDefault>;
};

/** A user-readable error */
export type CreateProgramError = {
  __typename?: 'CreateProgramError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: CreateProgramErrorPaths;
};

export enum CreateProgramErrorPaths {
  EndDate = 'endDate',
  IsTemplateProgram = 'isTemplateProgram',
  IsTestProgram = 'isTestProgram',
  MentorType = 'mentorType',
  Name = 'name',
  ProgramSequenceId = 'programSequenceId',
  ShortName = 'shortName',
  StartDate = 'startDate'
}

/** Program input on create */
export type CreateProgramInput = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  isTemplateProgram: Scalars['Boolean']['input'];
  isTestProgram: Scalars['Boolean']['input'];
  mentorType?: InputMaybe<MentorTypes>;
  name: Scalars['String']['input'];
  programSequenceId?: InputMaybe<Scalars['ID']['input']>;
  shortName: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of CreateProgramPageVisit. */
export type CreateProgramPageVisitPayload = {
  __typename?: 'CreateProgramPageVisitPayload';
  programPageVisit?: Maybe<ProgramPageVisit>;
};

/** Autogenerated return type of CreateProgram. */
export type CreateProgramPayload = {
  __typename?: 'CreateProgramPayload';
  errors: Array<CreateProgramError>;
  program?: Maybe<Program>;
};

/** A user-readable error */
export type CreateProgramResourceError = {
  __typename?: 'CreateProgramResourceError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: CreateProgramResourceErrorPaths;
};

export enum CreateProgramResourceErrorPaths {
  ProgramId = 'programId',
  Title = 'title',
  Url = 'url',
  UserId = 'userId'
}

/** Program resource input on creation */
export type CreateProgramResourceInput = {
  programId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateProgramResource. */
export type CreateProgramResourcePayload = {
  __typename?: 'CreateProgramResourcePayload';
  errors: Array<CreateProgramResourceError>;
  programResource?: Maybe<ProgramResource>;
  user: User;
};

/** A user-readable error */
export type CreateProgramSequenceError = {
  __typename?: 'CreateProgramSequenceError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: CreateProgramSequenceErrorPaths;
};

export enum CreateProgramSequenceErrorPaths {
  HigherEdSegment = 'higherEdSegment',
  Kind = 'kind',
  Name = 'name',
  SchoolId = 'schoolId',
  UrlSlug = 'urlSlug'
}

/** Program sequence input on create */
export type CreateProgramSequenceInput = {
  higherEdSegment: ProgramSegment;
  kind: ProgramSequenceKindTypes;
  name: Scalars['String']['input'];
  schoolId: Scalars['ID']['input'];
  urlSlug: Scalars['String']['input'];
};

/** Autogenerated return type of CreateProgramSequence. */
export type CreateProgramSequencePayload = {
  __typename?: 'CreateProgramSequencePayload';
  errors: Array<CreateProgramSequenceError>;
  programSequence?: Maybe<ProgramSequence>;
};

/** Program task input on creation */
export type CreateProgramTaskInput = {
  programSequenceId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
  visibleToMentors: Scalars['Boolean']['input'];
  visibleToStudents: Scalars['Boolean']['input'];
};

/** Autogenerated return type of CreateProgramTask. */
export type CreateProgramTaskPayload = {
  __typename?: 'CreateProgramTaskPayload';
  errors: Array<Scalars['String']['output']>;
  programTask?: Maybe<ProgramTask>;
};

export type CreateProgramTopicInput = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  name: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  topicId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateProgramTopic. */
export type CreateProgramTopicPayload = {
  __typename?: 'CreateProgramTopicPayload';
  programTopic: ProgramTopic;
};

/** Autogenerated return type of CreateSavedMatch. */
export type CreateSavedMatchPayload = {
  __typename?: 'CreateSavedMatchPayload';
  errors: Array<Error>;
  /** The created saved match */
  savedMatch?: Maybe<SavedMatch>;
};

/** A user-readable error */
export type CreateSchoolError = {
  __typename?: 'CreateSchoolError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: CreateSchoolErrorPaths;
};

export enum CreateSchoolErrorPaths {
  Name = 'name',
  ShortName = 'shortName',
  Subdomain = 'subdomain'
}

/** School input on create */
export type CreateSchoolInput = {
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
  subdomain: Scalars['String']['input'];
};

/** Autogenerated return type of CreateSchool. */
export type CreateSchoolPayload = {
  __typename?: 'CreateSchoolPayload';
  errors: Array<CreateSchoolError>;
  school?: Maybe<School>;
};

export type CreateSkeletonMessageTemplateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  templateEditorData: Scalars['JSON']['input'];
};

/** Autogenerated return type of CreateSkeletonMessageTemplate. */
export type CreateSkeletonMessageTemplatePayload = {
  __typename?: 'CreateSkeletonMessageTemplatePayload';
  skeletonMessageTemplate: SkeletonMessageTemplate;
};

export type CreateSmsTemplateInput = {
  category: MessageCategory;
  content: Scalars['String']['input'];
  customMessageType?: InputMaybe<ProgramCustomMessage>;
  isDefault: Scalars['Boolean']['input'];
  messageType: Message;
  name: Scalars['String']['input'];
  programSegment?: InputMaybe<ProgramSegment>;
  tagIds: Array<Scalars['ID']['input']>;
  userState: UserState;
};

/** Autogenerated return type of CreateSmsTemplate. */
export type CreateSmsTemplatePayload = {
  __typename?: 'CreateSmsTemplatePayload';
  smsTemplate: SmsTemplate;
};

export type CreateTopicConditionInput = {
  key: TopicConditionKey;
  value: Scalars['Boolean']['input'];
};

export type CreateTopicInput = {
  category: TopicCategory;
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  priority: Scalars['Float']['input'];
  programSegment?: InputMaybe<ProgramSegment>;
  topicConditions: Array<CreateTopicConditionInput>;
  topicMessages: Array<CreateTopicMessageInput>;
  userState: UserState;
};

export type CreateTopicMessageInput = {
  emailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  hoursDelayAfterMessage: Scalars['Int']['input'];
  index: Scalars['Int']['input'];
  preferredMedium: Message;
  smsTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateTopic. */
export type CreateTopicPayload = {
  __typename?: 'CreateTopicPayload';
  topic: Topic;
};

/** Autogenerated return type of CreateUploadedVideo. */
export type CreateUploadedVideoPayload = {
  __typename?: 'CreateUploadedVideoPayload';
  errors: Array<Scalars['String']['output']>;
  /** The updated participant record */
  participant?: Maybe<Participant>;
};

export type CsvExport = {
  __typename?: 'CsvExport';
  /** Any errors that occurred while generating the csv */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The name of the csv */
  filename?: Maybe<Scalars['String']['output']>;
  /** The ID of the export */
  id: Scalars['ID']['output'];
  /** The export is being processed */
  isProcessing: Scalars['Boolean']['output'];
  /** The url of the csv */
  url?: Maybe<Scalars['String']['output']>;
};

export type CsvExportContextInput = {
  /** The time zone to display for any dates in the export */
  displayTimeZone?: InputMaybe<Scalars['String']['input']>;
  /** A string key passed to MCLogger for the requested export */
  loggingKey?: InputMaybe<Scalars['String']['input']>;
  /** This is used to perform operations that are specific to a program such as automated relabeling of the headers or handling of conditional rows */
  programId?: InputMaybe<Scalars['ID']['input']>;
};

export type CsvExports = {
  __typename?: 'CsvExports';
  /** A CSV containg the count of matched users grouped by demographic segments */
  matchedUsersReport: CsvExport;
  /** A CSV of participant quotes */
  menteeMentorQuotes: CsvExport;
  /** A CSV of mentorship engagement data + shared qualities per mentorship */
  mentorshipEngagementData: CsvExport;
  /** A CSV of participant profile data */
  participantsProfileData: CsvExport;
  /** Metrics related to contacts, participants and mentorships displayed on the partner dashboard */
  partnerDashboardExports: PartnerDashboardExports;
  /** Recruitment opportunities based on data about available mentors and preferences of mentees waiting to be matched */
  recruitmentOpportunities: CsvExport;
  /** Survey responses */
  surveyResponses: CsvExport;
  /** A CSV of pre-match written testimonials */
  writtenTestimonials: CsvExport;
};


export type CsvExportsMatchedUsersReportArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  enrollment?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type CsvExportsMenteeMentorQuotesArgs = {
  analyzeSentiment?: InputMaybe<Scalars['Boolean']['input']>;
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type CsvExportsMentorshipEngagementDataArgs = {
  programId: Scalars['ID']['input'];
};


export type CsvExportsParticipantsProfileDataArgs = {
  csvExportContext: CsvExportContextInput;
  filter?: InputMaybe<UsersFilter>;
  profileDataColumns: Array<ParticipantsProfileDataColumnInput>;
};


export type CsvExportsRecruitmentOpportunitiesArgs = {
  csvExportContext: CsvExportContextInput;
  mentorsUsersFilter: UsersFilter;
  opportunityArea: OpportunityArea;
  programId: Scalars['ID']['input'];
  studentsUsersFilter: UsersFilter;
};


export type CsvExportsSurveyResponsesArgs = {
  csvExportContext: CsvExportContextInput;
  includeProgramProfileData?: InputMaybe<Scalars['Boolean']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  surveyId: Scalars['ID']['input'];
};


export type CsvExportsWrittenTestimonialsArgs = {
  analyzeSentiment?: InputMaybe<Scalars['Boolean']['input']>;
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CustomMessageTypeTemplateRequirement = {
  __typename?: 'CustomMessageTypeTemplateRequirement';
  /** When the template requirement was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The custom message type ex. mentor email standard match */
  customMessageType: ProgramCustomMessage;
  /** The id */
  id: Scalars['ID']['output'];
  /** The template message category required for the custom message type */
  messageCategory: MessageCategory;
  /** The message type required for the custom message type */
  messageType: Message;
  /** When the template requirement was updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The user state required for the custom message type */
  userState: UserState;
};

/** The connection type for CustomMessageTypeTemplateRequirement. */
export type CustomMessageTypeTemplateRequirementConnection = {
  __typename?: 'CustomMessageTypeTemplateRequirementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomMessageTypeTemplateRequirementEdge>>>;
  /** The collection of custom message type template requirements */
  nodes: Array<CustomMessageTypeTemplateRequirement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all requirements in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomMessageTypeTemplateRequirementEdge = {
  __typename?: 'CustomMessageTypeTemplateRequirementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CustomMessageTypeTemplateRequirement>;
};

export type DateRange = {
  /** End date */
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Start date */
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type DeleteContacts = {
  __typename?: 'DeleteContacts';
  byFilterSelection: DeleteContactsByFilterSelectionPayload;
  byIds: DeleteContactsByIdsPayload;
};


export type DeleteContactsByFilterSelectionArgs = {
  filter: ContactsFilter;
};


export type DeleteContactsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of DeleteContactsByFilterSelection. */
export type DeleteContactsByFilterSelectionPayload = {
  __typename?: 'DeleteContactsByFilterSelectionPayload';
  /** Any errors trying to delete contacts */
  errors: Array<ContactsNotAbleToBeDeletedError>;
  /** The number of contacts deleted */
  numberOfContactsDeleted?: Maybe<Scalars['Int']['output']>;
  /** The updated program */
  program?: Maybe<Program>;
};

/** Autogenerated return type of DeleteContactsByIds. */
export type DeleteContactsByIdsPayload = {
  __typename?: 'DeleteContactsByIdsPayload';
  /** Any errors trying to delete contacts */
  errors: Array<ContactsNotAbleToBeDeletedError>;
  /** The number of contacts deleted */
  numberOfContactsDeleted?: Maybe<Scalars['Int']['output']>;
  /** The updated program */
  program?: Maybe<Program>;
};

/** Autogenerated return type of DeleteFlagContact. */
export type DeleteFlagContactPayload = {
  __typename?: 'DeleteFlagContactPayload';
  errors: Array<Scalars['String']['output']>;
};

export enum DeleteMatchingLabelError {
  /** Label does not exist */
  LabelDoesNotExist = 'LABEL_DOES_NOT_EXIST'
}

/** Autogenerated return type of DeleteMatchingLabel. */
export type DeleteMatchingLabelPayload = {
  __typename?: 'DeleteMatchingLabelPayload';
  /** These are errors in the input response data that we want to catch and handle appropriately (these won't prevent the rest of the GraphQL query from running), as opposed to execution errors */
  errors: Array<DeleteMatchingLabelError>;
  /** The updated participant record */
  participant?: Maybe<Participant>;
};

/** Autogenerated return type of DeleteProgram. */
export type DeleteProgramPayload = {
  __typename?: 'DeleteProgramPayload';
  /** Any errors trying to delete the program */
  errors: Array<ProgramNotAbleToBeDeletedError>;
};

/** Autogenerated return type of DeleteProgramResource. */
export type DeleteProgramResourcePayload = {
  __typename?: 'DeleteProgramResourcePayload';
  /** The updated program */
  program?: Maybe<Program>;
};

/** Autogenerated return type of DeleteProgramSequence. */
export type DeleteProgramSequencePayload = {
  __typename?: 'DeleteProgramSequencePayload';
  /** Any errors trying to delete the program sequence */
  errors: Array<ProgramSequenceNotAbleToBeDeletedError>;
};

/** Autogenerated return type of DeleteProgramTask. */
export type DeleteProgramTaskPayload = {
  __typename?: 'DeleteProgramTaskPayload';
  /** The updated program */
  program?: Maybe<Program>;
  /** The updated program sequence */
  programSequence?: Maybe<ProgramSequence>;
};

/** Autogenerated return type of DeleteProgramTopic. */
export type DeleteProgramTopicPayload = {
  __typename?: 'DeleteProgramTopicPayload';
  /** Any errors trying to delete the program topic */
  errors: Array<ProgramTopicNotAbleToBeDeletedError>;
};

export type DeleteSavedMatches = {
  __typename?: 'DeleteSavedMatches';
  byFilter: DeleteSavedMatchesByFilterPayload;
  byIds: DeleteSavedMatchesByIdsPayload;
};


export type DeleteSavedMatchesByFilterArgs = {
  filter: SavedMatchesFilter;
  totalCount: Scalars['Int']['input'];
};


export type DeleteSavedMatchesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of DeleteSavedMatchesByFilter. */
export type DeleteSavedMatchesByFilterPayload = {
  __typename?: 'DeleteSavedMatchesByFilterPayload';
  deletedCount: Scalars['Int']['output'];
  errors: Array<Error>;
};

/** Autogenerated return type of DeleteSavedMatchesByIds. */
export type DeleteSavedMatchesByIdsPayload = {
  __typename?: 'DeleteSavedMatchesByIdsPayload';
  deletedCount: Scalars['Int']['output'];
  errors: Array<Error>;
};

/** Autogenerated return type of DeleteSchool. */
export type DeleteSchoolPayload = {
  __typename?: 'DeleteSchoolPayload';
  /** Any errors trying to delete the school */
  errors: Array<SchoolNotAbleToBeDeletedError>;
};

/** Autogenerated return type of DeleteSuggestedBatch. */
export type DeleteSuggestedBatchPayload = {
  __typename?: 'DeleteSuggestedBatchPayload';
  deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of DenylistEmails. */
export type DenylistEmailsPayload = {
  __typename?: 'DenylistEmailsPayload';
  batchActionId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
};

/** Input for participant deregistration */
export type DeregisterParticipantInput = {
  additionalFeedback?: InputMaybe<Scalars['String']['input']>;
  deregistrationReasonId: Scalars['ID']['input'];
  disengagedCounterpartMentorship?: InputMaybe<Scalars['ID']['input']>;
  participantId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeregisterParticipant. */
export type DeregisterParticipantPayload = {
  __typename?: 'DeregisterParticipantPayload';
  errors: Array<Error>;
  /** The updated participant */
  participant?: Maybe<Participant>;
};

export type DeregistrationReason = {
  __typename?: 'DeregistrationReason';
  /** Date created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The reason grouping */
  grouping: GroupingEnum;
  /** The id */
  id: Scalars['ID']['output'];
  /** The reason identifier */
  identifier: Scalars['String']['output'];
  /** The reason name */
  name: Scalars['String']['output'];
  /** The reason name shown to participants */
  participantFacingName?: Maybe<Scalars['String']['output']>;
};

/** The connection type for DeregistrationReason. */
export type DeregistrationReasonConnection = {
  __typename?: 'DeregistrationReasonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeregistrationReasonEdge>>>;
  /** The collection of deregistration reason objects */
  nodes: Array<DeregistrationReason>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all deregistration reasons in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeregistrationReasonEdge = {
  __typename?: 'DeregistrationReasonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeregistrationReason>;
};

export type DeregistrationStatusEvent = {
  __typename?: 'DeregistrationStatusEvent';
  /** Date created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The reason for deregistration */
  deregistrationReason: DeregistrationReason;
  /** The id */
  id: Scalars['ID']['output'];
  /** The type of deregistration event */
  kind: Scalars['String']['output'];
  /** Details about why the participant deregistered */
  otherReasonNotes?: Maybe<Scalars['String']['output']>;
  /** Participant this deregistration event is related to */
  participant: Participant;
};

export enum DirectionEnum {
  /** Move task down */
  Down = 'DOWN',
  /** Move task up */
  Up = 'UP'
}

/** New Program Task input */
export type DisableNewProgramTaskInput = {
  newProgramTaskId: Scalars['ID']['input'];
};

/** Autogenerated return type of DisableNewProgramTask. */
export type DisableNewProgramTaskPayload = {
  __typename?: 'DisableNewProgramTaskPayload';
  errors: Array<Error>;
  newProgramTask: NewProgramTask;
};

export enum DisengagementResolution {
  /** Chose to leave the program */
  ChoseToLeaveTheProgram = 'CHOSE_TO_LEAVE_THE_PROGRAM',
  /** Unmatched and requested rematch */
  RequestedRematch = 'REQUESTED_REMATCH',
  /** Unmatched and no rematch requested */
  RequestedUnmatch = 'REQUESTED_UNMATCH',
  /** Re-engaged */
  ReEngaged = 'RE_ENGAGED'
}

export type DisengagementResolutionsAverageTimeToRematchResult = {
  __typename?: 'DisengagementResolutionsAverageTimeToRematchResult';
  averageRematchTimeInDays?: Maybe<Scalars['Float']['output']>;
};

export type DisengagementResolutionsMetricsResult = {
  __typename?: 'DisengagementResolutionsMetricsResult';
  metric: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

/** Autogenerated return type of DismissProgramAlert. */
export type DismissProgramAlertPayload = {
  __typename?: 'DismissProgramAlertPayload';
  /** The updated program */
  program: Program;
};

/** A user-readable error */
export type DuplicateError = {
  __typename?: 'DuplicateError';
  /** The ID of the new task that already exists */
  duplicateNewTaskId: Scalars['ID']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: Scalars['String']['output'];
};

export type DuplicateMessageTemplates = {
  __typename?: 'DuplicateMessageTemplates';
  byFilterSelection: DuplicateMessageTemplatesByFilterSelectionPayload;
  byIds: DuplicateMessageTemplatesByIdsPayload;
};


export type DuplicateMessageTemplatesByFilterSelectionArgs = {
  filter: MessageTemplatesFilter;
  isDefault: Scalars['Boolean']['input'];
  tagIdsToAdd: Array<Scalars['ID']['input']>;
  tagIdsToRemove: Array<Scalars['ID']['input']>;
};


export type DuplicateMessageTemplatesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  isDefault: Scalars['Boolean']['input'];
  tagIdsToAdd: Array<Scalars['ID']['input']>;
  tagIdsToRemove: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of DuplicateMessageTemplatesByFilterSelection. */
export type DuplicateMessageTemplatesByFilterSelectionPayload = {
  __typename?: 'DuplicateMessageTemplatesByFilterSelectionPayload';
  /** The updated program */
  newMessageTemplates: MessageTemplateConnection;
};


/** Autogenerated return type of DuplicateMessageTemplatesByFilterSelection. */
export type DuplicateMessageTemplatesByFilterSelectionPayloadNewMessageTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of DuplicateMessageTemplatesByIds. */
export type DuplicateMessageTemplatesByIdsPayload = {
  __typename?: 'DuplicateMessageTemplatesByIdsPayload';
  /** The updated program */
  newMessageTemplates?: Maybe<MessageTemplateConnection>;
};


/** Autogenerated return type of DuplicateMessageTemplatesByIds. */
export type DuplicateMessageTemplatesByIdsPayloadNewMessageTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of DuplicateProgram. */
export type DuplicateProgramPayload = {
  __typename?: 'DuplicateProgramPayload';
  /** Any errors trying to duplicate the program */
  errors: Array<Scalars['String']['output']>;
  /** The newly created program */
  program?: Maybe<Program>;
  /** Any success messages from the duplication process */
  successMessages?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated return type of DuplicateProgramSequence. */
export type DuplicateProgramSequencePayload = {
  __typename?: 'DuplicateProgramSequencePayload';
  /** Any errors trying to duplicate the program sequence */
  errors: Array<Scalars['String']['output']>;
  /** The newly created program sequence */
  programSequence?: Maybe<ProgramSequence>;
};

/** Metrics related to participants in the data warehouse */
export type DwhParticipantsMetrics = {
  __typename?: 'DwhParticipantsMetrics';
  menteesRegistered: Scalars['Int']['output'];
  mentorsRegistered: Scalars['Int']['output'];
  participantsRegistered: Scalars['Int']['output'];
  programId: Scalars['ID']['output'];
  programName: Scalars['String']['output'];
};

export type DwhParticipantsMetricsConnection = {
  __typename?: 'DwhParticipantsMetricsConnection';
  /** The filtered list of participants metrics by program */
  nodes?: Maybe<Array<DwhParticipantsMetrics>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total mentees registered for all filtered programs */
  totalMenteesRegisteredCount: Scalars['Int']['output'];
  /** Total mentors registered for all filtered programs */
  totalMentorsRegisteredCount: Scalars['Int']['output'];
  /** Total participants registered for all filtered programs */
  totalParticipantsRegisteredCount: Scalars['Int']['output'];
};

/** Filter for participants metrics */
export type DwhParticipantsMetricsFilter = {
  /** filter for participants in specific programs */
  programIds: Array<Scalars['ID']['input']>;
};

export type DwhQueryableMetrics = {
  __typename?: 'DwhQueryableMetrics';
  participants: DwhParticipantsMetricsConnection;
};


export type DwhQueryableMetricsParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DwhParticipantsMetricsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type EmailTemplate = MessageTemplate & {
  __typename?: 'EmailTemplate';
  /** Date archived */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The template message category */
  category: MessageCategory;
  /** The actual template string of content */
  content: Scalars['String']['output'];
  /** When this message template was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The user that created this message template */
  createdBy: User;
  /** The custom message type */
  customMessageType?: Maybe<ProgramCustomMessage>;
  /** The id */
  id: Scalars['ID']['output'];
  /** The template identifier */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Whether or not this template is a default template */
  isDefault: Scalars['Boolean']['output'];
  /** When this message template was last edited */
  lastEditedAt: Scalars['ISO8601DateTime']['output'];
  /** The user that last edited this message template */
  lastEditedBy: User;
  /** The type of message this template is used for */
  messageType: Message;
  /** The template name */
  name: Scalars['String']['output'];
  /** The preheader text to use when sending the email */
  preheaderText: Scalars['String']['output'];
  /** The program segment this template will be used for */
  programSegment?: Maybe<ProgramSegment>;
  /** The subject line to use when sending the email */
  subjectLine: Scalars['String']['output'];
  /** The tags tied to this message template (used for organization) */
  tags: Array<MessageTemplateTag>;
  /** The bee plugin data used to store the editable email template */
  templateEditorData: Scalars['JSON']['output'];
  /** The user state this template must be used with (will control things like what variables are available to use) */
  userState: UserState;
};

export type EmailTemplateSavedRow = {
  __typename?: 'EmailTemplateSavedRow';
  /** The row category */
  category: EmailTemplateSavedRowCategory;
  /** The id */
  id: Scalars['ID']['output'];
  /** The name */
  name: Scalars['String']['output'];
  /** The row data */
  templateEditorData: Scalars['JSON']['output'];
};

export enum EmailTemplateSavedRowCategory {
  Body = 'BODY',
  Footers = 'FOOTERS',
  Headers = 'HEADERS',
  Signatures = 'SIGNATURES'
}

export type EngagementBenchmarkData = {
  __typename?: 'EngagementBenchmarkData';
  /** Average percent of mentees disengaged in previous program */
  disengagedMenteesInPreviousProgram?: Maybe<Scalars['Int']['output']>;
  /** Average percent of mentors disengaged in previous program */
  disengagedMentorsInPreviousProgram?: Maybe<Scalars['Int']['output']>;
  /** Average percent of mentorships in previous program where they have logged at least 1 conversation */
  mentorshipsInPreviousProgramEngagedInLast30Days?: Maybe<Scalars['Int']['output']>;
  /** Average percent of mentorships in previous program where both participants sent a message via relay */
  mentorshipsInPreviousProgramUsingSmsRelay?: Maybe<Scalars['Int']['output']>;
  /** Average percent of mentorships in previous program with 0 conversations */
  mentorshipsInPreviousProgramWith0Conversations?: Maybe<Scalars['Int']['output']>;
  /** Average percent of mentorships in previous program with 3+ conversations */
  mentorshipsInPreviousProgramWith3OrMoreConversations?: Maybe<Scalars['Int']['output']>;
  /** Total count of mentorships with conversations in the last 30 days */
  totalCountWithConversationInTheLast30Days?: Maybe<Scalars['Int']['output']>;
  /** Total count of mentorships with three or more conversations */
  totalCountWithThreeOrMoreConversations?: Maybe<Scalars['Int']['output']>;
  /** Total count of mentorships with zero conversations */
  totalCountWithZeroConversations?: Maybe<Scalars['Int']['output']>;
  /** Total mentees in previous program */
  totalMenteesInPreviousProgram?: Maybe<Scalars['Int']['output']>;
  /** Total mentors in previous program */
  totalMentorsInPreviousProgram?: Maybe<Scalars['Int']['output']>;
  /** Total mentorships for previous program */
  totalMentorshipsForPreviousProgram?: Maybe<Scalars['Int']['output']>;
};

export enum EnrollmentMenteeMatchingCriteria {
  /** This indicates that PS is defining requirements for include_mentees_without_matching_surveys and mentee_wants_mentorship manually */
  Custom = 'CUSTOM',
  /** A mentee must opt in to matching AND either have matching survey OR enough time must have passed since we last reached out */
  Standard = 'STANDARD'
}

/** A user-readable error */
export type Error = {
  __typename?: 'Error';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: Scalars['String']['output'];
};

export enum ExecutiveHigherEdRole {
  AcademicVicePresidentOrProvost = 'academic_vice_president_or_provost',
  AdministrativeVicePresident = 'administrative_vice_president',
  Dean = 'dean',
  PresidentOrChancellor = 'president_or_chancellor'
}

/** Existing custom questions to be added to the matching surveys */
export type ExistingCustomQuestionInput = {
  /** The list of existing question ids to add to the mentee matching survey */
  menteeQuestionIds: Array<Scalars['ID']['input']>;
  /** The list of existing question ids to add to the mentor matching survey */
  mentorQuestionIds: Array<Scalars['ID']['input']>;
};

export enum ExistingPoolEnum {
  /** Mentors */
  Mentors = 'MENTORS',
  /** Mentors and Mentor Contacts */
  MentorsAndMentorContacts = 'MENTORS_AND_MENTOR_CONTACTS',
  /** Students */
  Students = 'STUDENTS',
  /** Students and Student Contacts */
  StudentsAndStudentContacts = 'STUDENTS_AND_STUDENT_CONTACTS'
}

export type ExternalLink = {
  __typename?: 'ExternalLink';
  /** The external link url (typeform for old surveys) */
  href: Scalars['String']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** What kind of survey link is this */
  kind: ExternalLinkKind;
  /** The name */
  name: Scalars['String']['output'];
};

export enum ExternalLinkKind {
  MatchingSurvey = 'MATCHING_SURVEY',
  TypeformSurvey = 'TYPEFORM_SURVEY'
}

export enum FacultyHigherEdRole {
  Agriculture = 'agriculture',
  Business = 'business',
  Communications = 'communications',
  Education = 'education',
  Engineering = 'engineering',
  FineAndAppliedArts = 'fine_and_applied_arts',
  HealthSciences = 'health_sciences',
  LawAndLegalStudies = 'law_and_legal_studies',
  LiberalArts = 'liberal_arts',
  Medicine = 'medicine',
  Science = 'science',
  TechnicalAndCareer = 'technical_and_career'
}

export type Flag = {
  __typename?: 'Flag';
  /** Additional info provided by the mentor */
  additionalInfo?: Maybe<Scalars['String']['output']>;
  /** Date created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Flag categories this flag belongs to */
  flagCategories: Array<FlagCategory>;
  /** The id */
  id: Scalars['ID']['output'];
  /** The mentorship */
  mentorship: Mentorship;
  /** The conversation the Flag is tied to */
  participantConversationContent?: Maybe<ParticipantConversationContent>;
  /** Additional info provided by the partner */
  partnerNotes: Scalars['String']['output'];
  /** Whether a partner has marked this as actionable or not */
  status: FlagStatus;
  /** The user that submitted the flag (admin or mentor) */
  submittedBy: User;
  /** Priority level for this flag */
  supportPriority: SupportPriority;
};


export type FlagFlagCategoriesArgs = {
  relabeled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagCategory = {
  __typename?: 'FlagCategory';
  /** The id */
  id: Scalars['ID']['output'];
  /** The string identifier */
  identifier: Scalars['String']['output'];
  /** The long label to display to users */
  label: Scalars['String']['output'];
  /** The name */
  name: Scalars['String']['output'];
  /** The SMS character */
  smsCharacter?: Maybe<Scalars['String']['output']>;
};

export type FlagCategoryFilter = {
  /** filter for deprecated categories */
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter to include or exclude categories marked as hidden for program */
  includeProgramHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for a specific program, this will use custom labels */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /** filter for segment. Only one of segment or program_id should be included */
  segment?: InputMaybe<ProgramSegment>;
};

/** Flag category true or false */
export type FlagCategoryInput = {
  id: Scalars['ID']['input'];
  selected: Scalars['Boolean']['input'];
};

/** The connection type for Flag. */
export type FlagConnection = {
  __typename?: 'FlagConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FlagEdge>>>;
  /** List of flag categories with a submission */
  flagCategoriesSubmitted: Array<Scalars['String']['output']>;
  /** The collection of flag objects */
  nodes: Array<Flag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all flags in the collection */
  totalCount: Scalars['Int']['output'];
};

export type FlagContact = {
  __typename?: 'FlagContact';
  /** The contacts email */
  email: Scalars['String']['output'];
  /** The contacts first name */
  firstName: Scalars['String']['output'];
  /** Flags for the user */
  flagCategories: Array<FlagCategory>;
  /** The id */
  id: Scalars['ID']['output'];
  /** The contacts last name */
  lastName: Scalars['String']['output'];
};


export type FlagContactFlagCategoriesArgs = {
  programId?: InputMaybe<Scalars['ID']['input']>;
};

/** Flag contact input */
export type FlagContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flagCategories?: InputMaybe<Array<FlagCategoryInput>>;
  flagContactId: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
};

/** An edge in a connection. */
export type FlagEdge = {
  __typename?: 'FlagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Flag>;
};

export type FlagPageVisit = {
  __typename?: 'FlagPageVisit';
  /** Date created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The id */
  id: Scalars['ID']['output'];
};

/** The connection type for FlagPageVisit. */
export type FlagPageVisitConnection = {
  __typename?: 'FlagPageVisitConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FlagPageVisitEdge>>>;
  /** The collection of flag page visit objects */
  nodes: Array<FlagPageVisit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all flag page visits in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FlagPageVisitEdge = {
  __typename?: 'FlagPageVisitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FlagPageVisit>;
};

export type FlagPageVisitsSort = {
  /** Which field to sort by */
  column: FlagPageVisitsSortByField;
  direction: SortDirection;
};

export enum FlagPageVisitsSortByField {
  ViewDate = 'VIEW_DATE'
}

export enum FlagStatus {
  IsActionable = 'is_actionable',
  IsNotActionable = 'is_not_actionable',
  IsResolved = 'is_resolved',
  PendingAction = 'pending_action'
}

export enum FlagSubmitter {
  Admin = 'ADMIN',
  Mentor = 'MENTOR'
}

export type FlagsFilter = {
  /** filter for confidence scores */
  confidenceScore?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by created after */
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Filter by created before */
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Whether or not to exclude flags from programs that hide them from mentors */
  excludeProgramsWithFlagsHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Category to filter by */
  flagCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter for mentor notes present */
  hasMentorNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by a mentee's attributes */
  menteeFilter?: InputMaybe<ParticipantsFilter>;
  /** filter for the mentor in the mentorship tied to this flag */
  mentorUserId?: InputMaybe<Scalars['MCID']['input']>;
  /** Programs to filter by */
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** search by name or email of both mentee+mentor */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** Status to filter by */
  status?: InputMaybe<Array<FlagStatus>>;
  /** filter for submitter type */
  submittedBy?: InputMaybe<Array<FlagSubmitter>>;
  /** Filter for support priority type */
  supportPriority?: InputMaybe<Array<SupportPriority>>;
  /** filter for conversation categories */
  topicsFlagged?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FlagsGroupBy = {
  flagsGroupByProfileData?: InputMaybe<FlagsGroupByProfileData>;
  groupByFlagCategory: Scalars['Boolean']['input'];
};

export type FlagsGroupByProfileData = {
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule>>;
  preferredProgramId: Scalars['ID']['input'];
  preferredSource: ProfileAttributeSource;
  /** The id of the category to filter by */
  profileAttributeCategoryId?: InputMaybe<Scalars['MCID']['input']>;
  profileAttributeNumericValueGroups?: InputMaybe<Array<ProfileAttributeNumericValueGroup>>;
  profileAttributeType?: InputMaybe<ProfileAttributeType>;
  type: FlagsGroupBySelection;
};

export enum FlagsGroupBySelection {
  MenteeProfileAttributeType = 'MENTEE_PROFILE_ATTRIBUTE_TYPE',
  MentorProfileAttributeType = 'MENTOR_PROFILE_ATTRIBUTE_TYPE'
}

export type FlagsMetrics = {
  __typename?: 'FlagsMetrics';
  totalFlagged: Array<Interval>;
};


export type FlagsMetricsTotalFlaggedArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<FlagsGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
};

export type FlagsSort = {
  /** Which field to sort by */
  column: FlagsSortByField;
  direction: SortDirection;
};

export enum FlagsSortByField {
  ConfidenceScore = 'CONFIDENCE_SCORE',
  CreatedAt = 'CREATED_AT',
  MenteeName = 'MENTEE_NAME',
  MentorName = 'MENTOR_NAME',
  SupportPriority = 'SUPPORT_PRIORITY',
  TopicFlagged = 'TOPIC_FLAGGED'
}

export enum Gender {
  ChooseNotToDisclose = 'CHOOSE_NOT_TO_DISCLOSE',
  Female = 'FEMALE',
  GenderFluid = 'GENDER_FLUID',
  GenderQueer = 'GENDER_QUEER',
  GenderTrans = 'GENDER_TRANS',
  GenderVariantOrNonConforming = 'GENDER_VARIANT_OR_NON_CONFORMING',
  IIdentifyAs = 'I_IDENTIFY_AS',
  Male = 'MALE',
  Man = 'MAN',
  NonBinary = 'NON_BINARY',
  NonBinaryAgenderGenderqueer = 'NON_BINARY_AGENDER_GENDERQUEER',
  Other = 'OTHER',
  Questioning = 'QUESTIONING',
  TransgenderFemale = 'TRANSGENDER_FEMALE',
  TransgenderMale = 'TRANSGENDER_MALE',
  Woman = 'WOMAN'
}

export type Goal = {
  __typename?: 'Goal';
  /** Archived true/false */
  archived: Scalars['Boolean']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** Goal identifier */
  identifier: Scalars['String']['output'];
  /** Goal name */
  name: Scalars['String']['output'];
};

/** The connection type for Goal. */
export type GoalConnection = {
  __typename?: 'GoalConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GoalEdge>>>;
  /** The collection of goals in the connection */
  nodes: Array<Goal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all goals in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GoalEdge = {
  __typename?: 'GoalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Goal>;
};

export type GoalsFilter = {
  /** filter by archived true/false */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return goals that are attached to a resource */
  attachedToResource?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return goals that are attached to a resource in a program */
  attachedToResourcesInProgramId?: InputMaybe<Scalars['ID']['input']>;
  /** filter by identifier */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** filter by ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only return goals that are relevant to a program */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /** filter by resource ids */
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GoalsSort = {
  /** Which field to sort by */
  column: GoalsSortByField;
  direction: SortDirection;
};

export enum GoalsSortByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type GroupMatchingSettings = {
  __typename?: 'GroupMatchingSettings';
  /** The maximm group size */
  maxGroupSize: Scalars['Int']['output'];
  /** The minimum group size */
  minGroupSize: Scalars['Int']['output'];
};

/** Input for group matching settings */
export type GroupMatchingSettingsInput = {
  maxGroupSize: Scalars['Int']['input'];
  minGroupSize: Scalars['Int']['input'];
};

export enum GroupingEnum {
  General = 'GENERAL',
  NoLongerAttendsInstitution = 'NO_LONGER_ATTENDS_INSTITUTION',
  ParticipantRequested = 'PARTICIPANT_REQUESTED'
}

/** The hard match question being used a matching criteria */
export type HardMatchQuestion = MultiSelectHardMatchQuestion | SingleSelectHardMatchQuestion;

/** Input for hard matching question settings */
export type HardMatchingQuestionsInput = {
  matchType: Scalars['String']['input'];
  qid: Scalars['String']['input'];
};

/** Whether or not to hide question */
export type HideForKeyValuesOrInput = {
  /** Hide based on GDPR acceptance */
  gdpr_accepted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HigherEdCategory {
  Executive = 'executive',
  Faculty = 'faculty',
  Staff = 'staff'
}

export enum HigherEdRole {
  AcademicAdvising = 'academic_advising',
  AcademicVicePresidentOrProvost = 'academic_vice_president_or_provost',
  AdministrativeAssistant = 'administrative_assistant',
  AdministrativeVicePresident = 'administrative_vice_president',
  AdmissionsAndEnrollment = 'admissions_and_enrollment',
  AdultAndContinuingEducationPrograms = 'adult_and_continuing_education_programs',
  Agriculture = 'agriculture',
  AlumniRelations = 'alumni_relations',
  ArtsAndMuseumAdministration = 'arts_and_museum_administration',
  AssessmentAccreditationAndCompliance = 'assessment_accreditation_and_compliance',
  AthleticsAndCoaching = 'athletics_and_coaching',
  BroadcastingRadioAndTelevision = 'broadcasting_radio_and_television',
  BursarAndStudentAccounts = 'bursar_and_student_accounts',
  Business = 'business',
  BusinessAndFinancialServices = 'business_and_financial_services',
  CareerDevelopmentAndServices = 'career_development_and_services',
  ChildCareServices = 'child_care_services',
  CommuncationsMarketingAndPublicAffairs = 'communcations_marketing_and_public_affairs',
  Communications = 'communications',
  ComputerAndInformationTechnology = 'computer_and_information_technology',
  ConferenceAndEventsAdministration = 'conference_and_events_administration',
  CounselingAndPsychologicalServices = 'counseling_and_psychological_services',
  CurriculumDesign = 'curriculum_design',
  Dean = 'dean',
  DevelopmentAndFundraising = 'development_and_fundraising',
  DisabilityAndAccessibilityServices = 'disability_and_accessibility_services',
  DistanceEducationPrograms = 'distance_education_programs',
  DiversityAndMulticulturalAffairs = 'diversity_and_multicultural_affairs',
  EconomicAndBusinessDevelopment = 'economic_and_business_development',
  Education = 'education',
  Engineering = 'engineering',
  ExecutiveAssistant = 'executive_assistant',
  ExtensionAndOutreach = 'extension_and_outreach',
  FacilitiesManagement = 'facilities_management',
  FacultyDevelopment = 'faculty_development',
  FinancialAid = 'financial_aid',
  FineAndAppliedArts = 'fine_and_applied_arts',
  FoodServices = 'food_services',
  HealthAndMedicalServices = 'health_and_medical_services',
  HealthSciences = 'health_sciences',
  HumanResources = 'human_resources',
  InstitutionalResearchAndPlanning = 'institutional_research_and_planning',
  InstructionalTechnologyAndDesign = 'instructional_technology_and_design',
  InternationalProgramsAndServices = 'international_programs_and_services',
  LaboratoryAndResearch = 'laboratory_and_research',
  LawAndLegalStudies = 'law_and_legal_studies',
  LegalAffairs = 'legal_affairs',
  LiberalArts = 'liberal_arts',
  Libraries = 'libraries',
  Medicine = 'medicine',
  OccupationalAndEnvironmentalSafety = 'occupational_and_environmental_safety',
  PoliceAndPublicSafety = 'police_and_public_safety',
  PresidentOrChancellor = 'president_or_chancellor',
  PublicationsAndEditing = 'publications_and_editing',
  Registrar = 'registrar',
  ReligiousAndSpiritualLife = 'religious_and_spiritual_life',
  ResidenceLifeAndHousing = 'residence_life_and_housing',
  Sales = 'sales',
  Science = 'science',
  SponsoredProgramsGrantsAndContracts = 'sponsored_programs_grants_and_contracts',
  StudentAffairsAndServices = 'student_affairs_and_services',
  TechnicalAndCareer = 'technical_and_career',
  TutorsAndLearningResources = 'tutors_and_learning_resources',
  VolunteerProgramsAndServiceLearning = 'volunteer_programs_and_service_learning'
}

export enum HigherEducation {
  FourYear = 'FOUR_YEAR',
  TwoYear = 'TWO_YEAR'
}

export type Image = {
  __typename?: 'Image';
  /** The id */
  id: Scalars['ID']['output'];
  /** The image url for the requested variant */
  url: Scalars['String']['output'];
};


export type ImageUrlArgs = {
  resize?: InputMaybe<ResizeImageInput>;
};

export enum Institution {
  HighSchool = 'HIGH_SCHOOL',
  University = 'UNIVERSITY'
}

export enum InstitutionRegion {
  Hlc = 'HLC',
  Msche = 'MSCHE',
  Neche = 'NECHE',
  Nwccu = 'NWCCU',
  NonUs = 'Non_US',
  Sacs = 'SACS',
  Wscuc = 'WSCUC'
}

export type Interval = {
  __typename?: 'Interval';
  /** The start date/time of the interval */
  date: Scalars['ISO8601DateTime']['output'];
  /** If present, whatever group this interval is associated with */
  group?: Maybe<Scalars['String']['output']>;
  /** The number of values included in the calculation */
  sampleSize?: Maybe<Scalars['Int']['output']>;
  /** The value of whatever metric is being calculated for this time interval */
  value: Scalars['Float']['output'];
  /** The type of value being returned (e.g. 'count', 'average', 'sum') */
  valueType: IntervalValue;
};

export enum IntervalValue {
  Average = 'AVERAGE',
  Sum = 'SUM'
}

export enum InvalidFlagContactInputError {
  /** Select flag categories to assign them to this user */
  CategoriesRequired = 'CATEGORIES_REQUIRED',
  /** Flag contact was not created for some reason, please check with engineering */
  ContactNotCreated = 'CONTACT_NOT_CREATED',
  /** This email exists with a different name */
  EmailExistsButDifferentName = 'EMAIL_EXISTS_BUT_DIFFERENT_NAME',
  /** Invalid email address provided */
  InvalidEmailAddress = 'INVALID_EMAIL_ADDRESS',
  /** Invalid first name provided */
  InvalidFirstName = 'INVALID_FIRST_NAME',
  /** Invalid last name provided */
  InvalidLastName = 'INVALID_LAST_NAME',
  /** Invalid program provided */
  InvalidProgram = 'INVALID_PROGRAM',
  /** User already exists */
  UserExists = 'USER_EXISTS'
}

export enum InvalidMarkParticipantReachedOutError {
  /** Combination is invalid */
  InvalidCombination = 'INVALID_COMBINATION'
}

export enum InvalidParticipantInputError {
  /** Participant is not found */
  InvalidParticipantId = 'INVALID_PARTICIPANT_ID'
}

export enum InvalidPartnerInputError {
  /** Invalid email provided */
  InvalidEmailAddress = 'INVALID_EMAIL_ADDRESS',
  /** Invalid first name provided */
  InvalidFirstName = 'INVALID_FIRST_NAME',
  /** Invalid last name provided */
  InvalidLastName = 'INVALID_LAST_NAME',
  /** Invalid program sequence provided */
  InvalidProgramSequence = 'INVALID_PROGRAM_SEQUENCE',
  /** Partner was not created for some reason, please check with engineering */
  PartnerNotCreated = 'PARTNER_NOT_CREATED',
  /** User already exists */
  UserExists = 'USER_EXISTS'
}

export enum InvalidSurveyResponseInputError {
  /** The chat group id either doesn't exist or doesn't belong to this participant */
  InvalidMentorshipChatGroup = 'INVALID_MENTORSHIP_CHAT_GROUP',
  /** The participant id doesn't exist */
  InvalidParticipantId = 'INVALID_PARTICIPANT_ID',
  /** The survey id sent was not found */
  InvalidSurveyId = 'INVALID_SURVEY_ID',
  /** This error means that not all required questions were answered, or one answer didn't match a question in the specified survey */
  SurveyResponseMismatch = 'SURVEY_RESPONSE_MISMATCH'
}

export enum InvalidUserInputError {
  /** Invalid email provided */
  InvalidEmailAddress = 'INVALID_EMAIL_ADDRESS',
  /** The email address is in use by another user */
  InvalidEmailTaken = 'INVALID_EMAIL_TAKEN',
  /** Invalid first name provided */
  InvalidFirstName = 'INVALID_FIRST_NAME',
  /** Invalid last name provided */
  InvalidLastName = 'INVALID_LAST_NAME',
  /** Invalid password provided */
  InvalidPassword = 'INVALID_PASSWORD',
  /** Invalid password confirmation provided */
  InvalidPasswordConfirmation = 'INVALID_PASSWORD_CONFIRMATION',
  /** Invalid phone provided or invalid phone format */
  InvalidPhone = 'INVALID_PHONE',
  /** Invalid phone number provided for country */
  InvalidPhoneForCountry = 'INVALID_PHONE_FOR_COUNTRY',
  /** User is not found */
  InvalidUserId = 'INVALID_USER_ID'
}

export enum KindOfContext {
  AssessmentSurvey = 'assessment_survey',
  Course = 'course',
  Link = 'link'
}

export enum KindOfTask {
  ExternalLinkTask = 'EXTERNAL_LINK_TASK'
}

export type LinkTaskContext = {
  __typename?: 'LinkTaskContext';
  /** The id */
  id: Scalars['ID']['output'];
  /** The associated new task */
  newTask?: Maybe<NewTask>;
  /** The url */
  url: Scalars['String']['output'];
};

/** A participant of a program */
export type Log = {
  /** The id */
  id: Scalars['ID']['output'];
  /** When the event was logged */
  loggedAtDate: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated return type of LogTookTypeformSurvey. */
export type LogTookTypeformSurveyPayload = {
  __typename?: 'LogTookTypeformSurveyPayload';
  /** The updated participant record */
  participant: Participant;
};

/** Autogenerated return type of LogWatchedCommunityVideo. */
export type LogWatchedCommunityVideoPayload = {
  __typename?: 'LogWatchedCommunityVideoPayload';
  /** The updated participant record */
  participant: Participant;
};

/** Autogenerated return type of LogWatchedWistiaVideo. */
export type LogWatchedWistiaVideoPayload = {
  __typename?: 'LogWatchedWistiaVideoPayload';
  /** The updated participant record */
  participant: Participant;
};

/** The related record that triggered creation of the activity log */
export type LoggableActivity = AssessmentScoreResponse | DeregistrationStatusEvent | Flag | Mentor | MentorContact | Mentorship | PartnerNotification | Student | StudentContact | SurveyResponse | TrainingEventLog;

/** Autogenerated return type of MakeBatchMatches. */
export type MakeBatchMatchesPayload = {
  __typename?: 'MakeBatchMatchesPayload';
  errors: Array<Error>;
  suggestedBatch: SuggestedBatch;
};

/** Autogenerated return type of MakeMatch. */
export type MakeMatchPayload = {
  __typename?: 'MakeMatchPayload';
  /** The deleted saved match ID */
  deletedSavedMatchId?: Maybe<Scalars['ID']['output']>;
  errors: Array<Error>;
  /** Query a mentor by ID */
  mentor?: Maybe<Mentor>;
  /** Flag to show additional confirmation for rematch */
  showAllowRematchConfirm: Scalars['Boolean']['output'];
  /** Query a student by ID */
  student?: Maybe<Student>;
};

export type MakeSavedGroupMatches = {
  __typename?: 'MakeSavedGroupMatches';
  byFilter: MakeSavedGroupMatchesByFilterPayload;
  byIds: MakeSavedGroupMatchesByIdsPayload;
};


export type MakeSavedGroupMatchesByFilterArgs = {
  filter: SavedMatchesFilter;
  isSupermentorGroup: Scalars['Boolean']['input'];
  totalCount: Scalars['Int']['input'];
};


export type MakeSavedGroupMatchesByIdsArgs = {
  addToExistingGroup?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['ID']['input']>;
  isSupermentorGroup: Scalars['Boolean']['input'];
};

/** Autogenerated return type of MakeSavedGroupMatchesByFilter. */
export type MakeSavedGroupMatchesByFilterPayload = {
  __typename?: 'MakeSavedGroupMatchesByFilterPayload';
  errors: Array<Error>;
  queuedGroupsCount: Scalars['Int']['output'];
  queuedMatchesCount: Scalars['Int']['output'];
  savedMatchIds: Array<Scalars['ID']['output']>;
};

/** Autogenerated return type of MakeSavedGroupMatchesByIds. */
export type MakeSavedGroupMatchesByIdsPayload = {
  __typename?: 'MakeSavedGroupMatchesByIdsPayload';
  errors: Array<Error>;
  queuedGroupsCount: Scalars['Int']['output'];
  queuedMatchesCount: Scalars['Int']['output'];
  savedMatchIds: Array<Scalars['ID']['output']>;
};

export type MakeSavedMatches = {
  __typename?: 'MakeSavedMatches';
  byFilter: MakeSavedMatchesByFilterPayload;
  byIds: MakeSavedMatchesByIdsPayload;
};


export type MakeSavedMatchesByFilterArgs = {
  filter: SavedMatchesFilter;
  totalCount: Scalars['Int']['input'];
};


export type MakeSavedMatchesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of MakeSavedMatchesByFilter. */
export type MakeSavedMatchesByFilterPayload = {
  __typename?: 'MakeSavedMatchesByFilterPayload';
  errors: Array<Error>;
  queuedMatchesCount: Scalars['Int']['output'];
  savedMatchIds: Array<Scalars['ID']['output']>;
};

/** Autogenerated return type of MakeSavedMatchesByIds. */
export type MakeSavedMatchesByIdsPayload = {
  __typename?: 'MakeSavedMatchesByIdsPayload';
  errors: Array<Error>;
  queuedMatchesCount: Scalars['Int']['output'];
  savedMatchIds: Array<Scalars['ID']['output']>;
};

/** Autogenerated return type of MarkParticipantReachedOut. */
export type MarkParticipantReachedOutPayload = {
  __typename?: 'MarkParticipantReachedOutPayload';
  /** These are errors in the input response data that we want to catch and handle appropriately (these won't prevent the rest of the GraphQL query from running), as opposed to execution errors */
  errors: Array<InvalidMarkParticipantReachedOutError>;
  /** The modified mentorship */
  mentorship?: Maybe<Mentorship>;
  /** The updated participant record */
  participant?: Maybe<Participant>;
};

export enum MatchedStatus {
  Either = 'EITHER',
  Matched = 'MATCHED',
  Unmatched = 'UNMATCHED'
}

export type MatchingCriteria = {
  __typename?: 'MatchingCriteria';
  /** Deprecated: Enrollment specific matching criteria, old automatching UI only */
  enrollmentMenteeMatchingCriteria?: Maybe<EnrollmentMenteeMatchingCriteria>;
  /** The hard match questions to use as part of suggesting automatches */
  hardMatchQuestions?: Maybe<Array<HardMatchQuestion>>;
  includeAvailableToMatchEnrollmentMentees?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to include students that were previously in an enrollment program for this school */
  includeEverMatchedEnrollmentMentees?: Maybe<Scalars['Boolean']['output']>;
  includeMenteesUnder17: Scalars['Boolean']['output'];
  /** Whether or not to include mentees who were pushed through to match */
  includeMenteesWhoArePushedThroughToMatch?: Maybe<Scalars['Boolean']['output']>;
  includeMenteesWhoHaveBeenUnmatched?: Maybe<Scalars['Boolean']['output']>;
  includeMenteesWithFreeResponses: Scalars['Boolean']['output'];
  includeMenteesWithSupermentorOptIn?: Maybe<Scalars['Boolean']['output']>;
  includeMenteesWithoutMatchingSurveys: Scalars['Boolean']['output'];
  /** Whether or not to include mentors who were pushed through to match */
  includeMentorsWhoArePushedThroughToMatch?: Maybe<Scalars['Boolean']['output']>;
  includeMentorsWhoHaveBeenUnmatched?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to fill out existing megaphone groups */
  includeMentorsWithMentorships?: Maybe<Scalars['Boolean']['output']>;
  includeMentorsWithSupermentorOptIn?: Maybe<Scalars['Boolean']['output']>;
  includeMentorsWithoutMatchingSurveys: Scalars['Boolean']['output'];
  includeMentorsWithoutTraining: Scalars['Boolean']['output'];
  onlyEnrollmentOptInMentees?: Maybe<Scalars['Boolean']['output']>;
  requireMenteeSupermentorOptIn?: Maybe<Scalars['Boolean']['output']>;
  requireMentorSupermentorOptIn?: Maybe<Scalars['Boolean']['output']>;
  sharedMajor: Scalars['Boolean']['output'];
  sharedTransferStatus: Scalars['Boolean']['output'];
};

/** Input for matching criteria */
export type MatchingCriteriaInput = {
  /** Deprecated criteria, only used in old UI */
  enrollmentMenteeMatchingCriteria?: InputMaybe<EnrollmentMenteeMatchingCriteria>;
  hardMatchQuestions?: InputMaybe<Array<HardMatchingQuestionsInput>>;
  includeAvailableToMatchEnrollmentMentees?: InputMaybe<Scalars['Boolean']['input']>;
  includeEverMatchedEnrollmentMentees?: InputMaybe<Scalars['Boolean']['input']>;
  includeMenteesUnder17: Scalars['Boolean']['input'];
  includeMenteesWhoArePushedThroughToMatch?: InputMaybe<Scalars['Boolean']['input']>;
  includeMenteesWhoHaveBeenUnmatched?: InputMaybe<Scalars['Boolean']['input']>;
  includeMenteesWithFreeResponses: Scalars['Boolean']['input'];
  includeMenteesWithSupermentorOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  includeMenteesWithoutMatchingSurveys: Scalars['Boolean']['input'];
  includeMentorsWhoArePushedThroughToMatch?: InputMaybe<Scalars['Boolean']['input']>;
  includeMentorsWhoHaveBeenUnmatched?: InputMaybe<Scalars['Boolean']['input']>;
  includeMentorsWithMentorships?: InputMaybe<Scalars['Boolean']['input']>;
  includeMentorsWithSupermentorOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  includeMentorsWithoutMatchingSurveys: Scalars['Boolean']['input'];
  includeMentorsWithoutTraining: Scalars['Boolean']['input'];
  onlyEnrollmentOptInMentees?: InputMaybe<Scalars['Boolean']['input']>;
  requireMenteeSupermentorOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  requireMentorSupermentorOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated criteria, only used in old UI */
  sharedMajor?: InputMaybe<Scalars['Boolean']['input']>;
  sharedTransferStatus: Scalars['Boolean']['input'];
};

export type MatchingLabel = {
  __typename?: 'MatchingLabel';
  /** Date created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The source of the saved match */
  kind: MatchingLabelKindTypes;
  /** The participant that the label applies to */
  participant: Participant;
};

export enum MatchingLabelAction {
  /** Add the label to participant */
  Add = 'ADD',
  /** Remove the label from participant */
  Remove = 'REMOVE'
}

export enum MatchingLabelKindTypes {
  MatchingHold = 'MATCHING_HOLD',
  PrioritizeForRematching = 'PRIORITIZE_FOR_REMATCHING',
  PushThroughToMatch = 'PUSH_THROUGH_TO_MATCH',
  RegisteredWithoutCode = 'REGISTERED_WITHOUT_CODE',
  ReturningMentor = 'RETURNING_MENTOR',
  SkippedOnboarding = 'SKIPPED_ONBOARDING'
}

export enum MatchingSource {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

/** Questions enabled for mentee matching survey */
export type MenteeToggleQuestionInput = {
  /** If true, mentee survey should include academic questions */
  academicInterests?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentee survey should include age questions */
  age?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentee survey should include desired mentoring frequency question */
  desiredMentoringFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentee survey should include graduation year */
  graduationYear?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentee survey should include hobbies */
  hobbies?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentee survey should include major question */
  major?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentee survey should include transfer mentor preference question */
  prefersTransferMentor?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentee survey should include social media question */
  socialMedia?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentee survey should include supermentor question */
  supermentorOptIn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Mentor = Participant & {
  __typename?: 'Mentor';
  /** Any logs of this participant's activity */
  activityLogs: Array<Log>;
  /** Whether the mentor is allowed to skip the matching survey before being matched. Specifically, if the program allows re-recruited mentors who have already taken the survey to skip the survey for a match, and this mentor specifically has already taken the survey for another program. */
  allowedToSkipMatchingSurvey: Scalars['Boolean']['output'];
  /**
   * The user's avatar, or the program default if nil
   * @deprecated Use avatarImage instead, which leverages activestorage to provide on-the-fly image variants
   */
  avatar: Scalars['String']['output'];
  /** The user's avatar, or the program default if nil */
  avatarImage?: Maybe<Image>;
  /** The user's profile attribute values */
  cachedUserProfileData?: Maybe<Array<CachedUserProfileDataAttributeValue>>;
  /** The capacity of the mentor */
  capacity?: Maybe<Scalars['Int']['output']>;
  /** When the participant has completed their matching survey */
  completedMatchingSurveyAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the participant was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date participant was deregistered */
  deregisterDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The participant's deregistration status events */
  deregistrationStatusEvents: Array<DeregistrationStatusEvent>;
  /** The id */
  id: Scalars['ID']['output'];
  /** When the participant has completed any required training (shared across ALL MENTORS) */
  lastCompletedRequiredTrainingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Any matching labels associated with the participant */
  matchingLabels: Array<MatchingLabel>;
  mentorTrainingCourseLink?: Maybe<Scalars['String']['output']>;
  /**
   * The mentorships
   * @deprecated Use participant_mentorships instead, which is a connection type and provides the same data but with pagination
   */
  mentorships: Array<Mentorship>;
  /** Notes on participant */
  notes?: Maybe<Scalars['String']['output']>;
  /** Mentorships associated with a participant */
  participantMentorships?: Maybe<MentorshipConnection>;
  /** Whether this participant is prioritized and pending for rematch */
  prioritizedAndPendingForRematching: Scalars['Boolean']['output'];
  /** The program this mentor belongs to */
  program: Program;
  /** Whether this participant has been marked as pushed through to match, allowing them to skip onboarding */
  pushedThroughToMatch: Scalars['Boolean']['output'];
  /** Whether this participant is registered for a program or not */
  registered: Scalars['Boolean']['output'];
  /** When the participant registered */
  registrationDate: Scalars['ISO8601DateTime']['output'];
  /** The training status of a mentor. NOTE: this will return null if the program just does not require training (meaning the mentor would still be eligible for match) */
  requiredTrainingStatus?: Maybe<Scalars['String']['output']>;
  /** A list of saved matches relating to the mentor */
  savedMatches: Array<SavedMatch>;
  /** Response for opting in to supermentorships (Currently on the user level) */
  supermentorOptIn?: Maybe<Scalars['String']['output']>;
  /**
   * This participants survey responses
   * @deprecated Accessing survey_responses from participant will be removed. Please re-write this query to get survey_responses from user.
   */
  surveyResponses: Array<SurveyResponse>;
  /** A link to the calendly scheduling app */
  trainingSignupLink?: Maybe<Scalars['String']['output']>;
  /** Any videos uploaded by this participant */
  uploadedVideos: Array<UploadedVideo>;
  /** The user */
  user: User;
  /** The user's profile attribute values */
  userProfileData: Array<UserProfileData>;
  /** Link to the program specific URL in the participant dashboard for this participant */
  webappBaseUrl?: Maybe<Scalars['String']['output']>;
  /** The written messages for this participant */
  writtenMessages: Array<WrittenMessage>;
};


export type MentorCachedUserProfileDataArgs = {
  attributes: Array<CachedUserProfileDataAttributeInput>;
  cacheSettings: CachedUserProfileDataSettingsFilter;
};


export type MentorMentorshipsArgs = {
  status?: InputMaybe<MatchedStatus>;
};


export type MentorParticipantMentorshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MentorshipsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MentorshipsSort>;
};


export type MentorSurveyResponsesArgs = {
  context?: InputMaybe<SurveyResponseContextFilter>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};


export type MentorUploadedVideosArgs = {
  onlySharable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MentorUserProfileDataArgs = {
  attributes: Array<UserProfileDataAttributeInput>;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule>>;
  source: ProfileAttributeSource;
};

/** Mentor capacity selection for matching surveys */
export type MentorCapacityInput = {
  /** Maximum mentor capacity */
  maxCapacity?: InputMaybe<Scalars['String']['input']>;
  /** Minimum mentor capacity */
  minCapacity?: InputMaybe<Scalars['String']['input']>;
};

export type MentorContact = Contact & {
  __typename?: 'MentorContact';
  /** Any a2p smses sent to this contact */
  a2pSmses: Array<A2pSms>;
  /** The contact's activation status */
  activationStatus: ActivationStatus;
  /** When the contact's activation status last changed */
  activationStatusChangedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Batch action ID the contact was created from */
  batchActionId?: Maybe<Scalars['String']['output']>;
  /** The id */
  id: Scalars['ID']['output'];
  /** Any notes about this contact */
  notes?: Maybe<Scalars['String']['output']>;
  /** The program this mentor belongs to */
  program: Program;
  /** The contact's registration status */
  registered: Scalars['Boolean']['output'];
  /** Who uploaded this contact */
  uploadedBy?: Maybe<User>;
  /** When the contact registered */
  uploadedDate: Scalars['ISO8601DateTime']['output'];
  /** The user */
  user: User;
};

export type MentorNumberOfMenteesFilter = {
  /** filter for participants (mentors) who have more than the given number of mentees */
  numberOfMenteesIsGreaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** filter for participants (mentors) who have less than the given number of mentees */
  numberOfMenteesIsLessThan?: InputMaybe<Scalars['Int']['input']>;
  /** filter for participants (mentors) with mentees in the given program */
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Questions enabled for mentor matching survey */
export type MentorToggleQuestionInput = {
  /** If true, mentor survey should include academic questions */
  academicInterests?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentor survey should include age questions */
  age?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentor survey should include Student vs Alum questions */
  currentStudentOrAlum?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentor survey should include desired mentoring frequency question */
  desiredMentoringFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentor survey should include graduation year */
  graduationYear?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentor survey should include hobbies */
  hobbies?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentor survey should include major question */
  major?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentor survey should include capacity questions */
  maximumNumberOfMentees?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentor survey should include social media question */
  socialMedia?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentor survey should include supermentor question */
  supermentorOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, mentor survey should include transfer status questions */
  transferStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MentorTrainingStatusEnum {
  /** Attended */
  AttendedTraining = 'ATTENDED_TRAINING',
  /** Ghosted */
  Ghosted = 'GHOSTED',
  /** Signed-up */
  SignedUp = 'SIGNED_UP'
}

export enum MentorTypes {
  Alumni = 'ALUMNI',
  MixedPeerAndAlumni = 'MIXED_PEER_AND_ALUMNI',
  Other = 'OTHER',
  Peer = 'PEER',
  Unaffiliated = 'UNAFFILIATED'
}

export type Mentorship = {
  __typename?: 'Mentorship';
  /** The chat group */
  chatGroup?: Maybe<MentorshipChatGroup>;
  /** All survey responses for mentee and mentor */
  combinedMenteeMentorSurveyResponses?: Maybe<SurveyResponseConnection>;
  /** A list of qualities the mentor and mentee have in common */
  commonQualities?: Maybe<Array<Scalars['String']['output']>>;
  /** A sentence of qualities the mentor and mentee have in common */
  commonQualitiesSentence?: Maybe<Scalars['String']['output']>;
  /** The higher count between student and mentor conversation logs */
  conversationLogsCount: Scalars['Int']['output'];
  /** The programs flags */
  flags: FlagConnection;
  /** The id */
  id: Scalars['ID']['output'];
  /** Whether this mentorship is matched or not */
  isMatched: Scalars['Boolean']['output'];
  /** The last recorded conversation in the mentorship */
  lastConversation?: Maybe<ConversationLog>;
  /** When the pair was matched */
  matchDate: Scalars['ISO8601DateTime']['output'];
  /** The megaphone group */
  megaphoneGroup?: Maybe<MentorshipMegaphoneGroup>;
  /** The phone number the mentee can text, where we will relay the messages to the mentor */
  menteeSmsRelayPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** The mentor */
  mentor: Mentor;
  /** The conversations logged by the mentor in this mentorship */
  mentorConversationLogs: Array<ConversationLog>;
  /** Whether or not the mentor is disengaged */
  mentorIsDisengaged: Scalars['Boolean']['output'];
  /** The DateTime when the mentor has reached out to the counterpart */
  mentorReachedOutAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The phone number the mentor can text, where we will relay the messages to the mentee */
  mentorSmsRelayPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** The match score for the mentorship */
  score?: Maybe<Scalars['Int']['output']>;
  /** The matching source type */
  source: MatchingSource;
  /** The student */
  student: Student;
  /** The conversations logged by the student in this mentorship */
  studentConversationLogs: Array<ConversationLog>;
  /** Whether or not the student is disengaged */
  studentIsDisengaged: Scalars['Boolean']['output'];
  /** The DateTime when the student has reached out to the counterpart */
  studentReachedOutAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the pair was unmatched */
  unmatchDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Participant that requested to be unmatched */
  unmatchInitiatedBy?: Maybe<Scalars['String']['output']>;
  /** Notes about why the mentorship was unmatched */
  unmatchNotes?: Maybe<Scalars['String']['output']>;
  /** The reason for unmatching */
  unmatchReason?: Maybe<UnmatchReason>;
};


export type MentorshipCombinedMenteeMentorSurveyResponsesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SurveyResponsesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SurveyResponsesSort>;
};


export type MentorshipFlagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FlagsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<FlagsSort>;
};

export type MentorshipChatGroup = {
  __typename?: 'MentorshipChatGroup';
  /** The id */
  id: Scalars['ID']['output'];
};

/** The connection type for Mentorship. */
export type MentorshipConnection = {
  __typename?: 'MentorshipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MentorshipEdge>>>;
  /** The collection of mentorship objects */
  nodes: Array<Mentorship>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all mentorships in the collection */
  totalCount: Scalars['Int']['output'];
  /** The total count of students disengaged */
  totalCountMenteesDisengaged: Scalars['Int']['output'];
  /** The total count of mentors disengaged */
  totalCountMentorsDisengaged: Scalars['Int']['output'];
  /** The total count of mentorships using the SMS relay */
  totalCountUsingSmsRelay: Scalars['Int']['output'];
  /** The total count of mentorships with 1+ conversations in the last 30 days */
  totalCountWithConversationInTheLast30Days: Scalars['Int']['output'];
  /** The total count of mentorships with 3 or more conversations reported */
  totalCountWithThreeOrMoreConversations: Scalars['Int']['output'];
  /** The total count of mentorships with 0 conversations reported */
  totalCountWithZeroConversations: Scalars['Int']['output'];
};

export type MentorshipCredential = {
  __typename?: 'MentorshipCredential';
  /** The name of the credential */
  credential: MentorshipCredentialCredentials;
  /** The id */
  id: Scalars['ID']['output'];
};

export enum MentorshipCredentialCredentials {
  CareerMentees = 'career_mentees',
  CareerMentorTraining = 'career_mentor_training',
  CorporateMentees = 'corporate_mentees',
  CorporateMentorTraining = 'corporate_mentor_training',
  DeiFoundations = 'dei_foundations',
  EnrollmentMentees = 'enrollment_mentees',
  EnrollmentMentorTraining = 'enrollment_mentor_training',
  StudentSuccessMentees = 'student_success_mentees',
  StudentSuccessMentorTraining = 'student_success_mentor_training'
}

/** An edge in a connection. */
export type MentorshipEdge = {
  __typename?: 'MentorshipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Mentorship>;
};

export type MentorshipMegaphoneGroup = {
  __typename?: 'MentorshipMegaphoneGroup';
  /** The id */
  id: Scalars['ID']['output'];
  /** Whether this group is a supermentor group */
  isSupermentorGroup: Scalars['Boolean']['output'];
};

export enum MentorshipsExport {
  Default = 'DEFAULT',
  Matched = 'MATCHED',
  MenteeMatched = 'MENTEE_MATCHED',
  MentorMatched = 'MENTOR_MATCHED',
  ThreePlusConversationsLogged = 'THREE_PLUS_CONVERSATIONS_LOGGED',
  TotalConversationsLogged = 'TOTAL_CONVERSATIONS_LOGGED',
  UsingP2PRelay = 'USING_P2P_RELAY'
}

export type MentorshipsExportResultModifiers = {
  /** This modifies the results for conversations logged count so that we only count up to the date indicated here */
  conversationsLoggedBeforeDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** This modifies the results to show whether the pair used the relay after this date */
  usedRelayAfterDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** This modifies the results to show whether the pair used the relay before this date */
  usedRelayBeforeDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type MentorshipsFilter = {
  /** filter for mentorships that have priority flags in the given categories */
  categoriesPriorityFlagged?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter for mentorships that have discussed the given conversation topics */
  conversationTopics?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter for mentorships that have logged more than the given number of conversations */
  conversationsLoggedCountIsGreaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** filter for mentorships that have logged less than the given number of conversations */
  conversationsLoggedCountIsLessThan?: InputMaybe<Scalars['Int']['input']>;
  /** filter by match status */
  isMatched?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for mentorships that have used the p2p relay */
  isUsingP2pRelay?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for mentorships where the last conversation took place after the given date */
  lastConversationLoggedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter for mentorships where the last conversation took place before the given date */
  lastConversationLoggedBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter for mentorships matched after a given date */
  matchedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter for mentorships matched before a given date */
  matchedBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter by a mentee's attributes */
  menteeFilter?: InputMaybe<ParticipantsFilter>;
  /** filter by mentee id */
  menteeId?: InputMaybe<Scalars['ID']['input']>;
  /** filter by a mentor's attributes */
  mentorFilter?: InputMaybe<ParticipantsFilter>;
  /** filter by mentor id */
  mentorId?: InputMaybe<Scalars['ID']['input']>;
  /** filter by a specific mentorship id */
  mentorshipId?: InputMaybe<Scalars['ID']['input']>;
  /** filter for mentorships with mentees that have a minimum number touchpoints */
  minimumNumberOfStudentTouchpoints?: InputMaybe<MinimumNumberOfTouchpointsFilter>;
  /** filter for mentorships with mentees that have a specific number of touchpoints */
  numberOfStudentTouchpoints?: InputMaybe<NumberOfTouchpointsFilter>;
  /** filter by program id */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /** search by name or email of both mentee+mentor */
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type MentorshipsGroupBy = {
  groupByConversationCategory: Scalars['Boolean']['input'];
  participantGroupBy?: InputMaybe<MentorshipsGroupByProfileData>;
};

export type MentorshipsGroupByProfileData = {
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule>>;
  preferredProgramId: Scalars['ID']['input'];
  preferredSource: ProfileAttributeSource;
  /** The id of the category to filter by */
  profileAttributeCategoryId?: InputMaybe<Scalars['MCID']['input']>;
  profileAttributeNumericValueGroups?: InputMaybe<Array<ProfileAttributeNumericValueGroup>>;
  profileAttributeType?: InputMaybe<ProfileAttributeType>;
  type: MentorshipsGroupBySelection;
};

export enum MentorshipsGroupBySelection {
  MenteeProfileAttributeType = 'MENTEE_PROFILE_ATTRIBUTE_TYPE',
  MentorProfileAttributeType = 'MENTOR_PROFILE_ATTRIBUTE_TYPE'
}

export type MentorshipsMetrics = {
  __typename?: 'MentorshipsMetrics';
  totalConversationsLogged: Array<Interval>;
  totalFirstUsedSmsRelay: Array<Interval>;
  totalLoggedMinimumNumberConversations: Array<Interval>;
  totalMatched: Array<Interval>;
  totalSmsRelayMessagesSent: Array<Interval>;
};


export type MentorshipsMetricsTotalConversationsLoggedArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<MentorshipsGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
};


export type MentorshipsMetricsTotalFirstUsedSmsRelayArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<MentorshipsGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
};


export type MentorshipsMetricsTotalLoggedMinimumNumberConversationsArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<MentorshipsGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  minimumNumberConversations: Scalars['Int']['input'];
};


export type MentorshipsMetricsTotalMatchedArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<MentorshipsGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
};


export type MentorshipsMetricsTotalSmsRelayMessagesSentArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<MentorshipsGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
};

export type MentorshipsSort = {
  /** Which field to sort by */
  column: MentorshipsSortByField;
  direction: SortDirection;
};

export enum MentorshipsSortByField {
  CreatedAt = 'CREATED_AT',
  MenteeFirstName = 'MENTEE_FIRST_NAME',
  MentorFirstName = 'MENTOR_FIRST_NAME',
  NumberOfConversations = 'NUMBER_OF_CONVERSATIONS',
  NumberOfPriorityFlags = 'NUMBER_OF_PRIORITY_FLAGS'
}

export enum Message {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export enum MessageCategory {
  AssessmentSurvey = 'assessment_survey',
  BulkMessage = 'bulk_message',
  Matching = 'matching',
  PostMatch = 'post_match',
  PreMatch = 'pre_match',
  Recruitment = 'recruitment',
  Transactional = 'transactional'
}

export type MessageTemplate = {
  /** Date archived */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The template message category */
  category: MessageCategory;
  /** The actual template string of content */
  content: Scalars['String']['output'];
  /** When this message template was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The user that created this message template */
  createdBy: User;
  /** The custom message type */
  customMessageType?: Maybe<ProgramCustomMessage>;
  /** The id */
  id: Scalars['ID']['output'];
  /** The template identifier */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Whether or not this template is a default template */
  isDefault: Scalars['Boolean']['output'];
  /** When this message template was last edited */
  lastEditedAt: Scalars['ISO8601DateTime']['output'];
  /** The user that last edited this message template */
  lastEditedBy: User;
  /** The type of message this template is used for */
  messageType: Message;
  /** The template name */
  name: Scalars['String']['output'];
  /** The program segment this template will be used for */
  programSegment?: Maybe<ProgramSegment>;
  /** The tags tied to this message template (used for organization) */
  tags: Array<MessageTemplateTag>;
  /** The user state this template must be used with (will control things like what variables are available to use) */
  userState: UserState;
};

/** The connection type for MessageTemplate. */
export type MessageTemplateConnection = {
  __typename?: 'MessageTemplateConnection';
  /** The total count of default templates in the collection */
  defaultCount: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MessageTemplateEdge>>>;
  /** The collection of template objects */
  nodes: Array<MessageTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** What tags are used by templates in this collection */
  tagCounts: Array<MessageTemplateTagCount>;
  /** The total count of all templates in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MessageTemplateEdge = {
  __typename?: 'MessageTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MessageTemplate>;
};

export type MessageTemplateTag = {
  __typename?: 'MessageTemplateTag';
  /** The id */
  id: Scalars['ID']['output'];
  /** The name of the tag */
  name: Scalars['String']['output'];
};

/** The connection type for MessageTemplateTag. */
export type MessageTemplateTagConnection = {
  __typename?: 'MessageTemplateTagConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MessageTemplateTagEdge>>>;
  /** The collection of template tags objects */
  nodes: Array<MessageTemplateTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all template tags in the collection */
  totalCount: Scalars['Int']['output'];
};

export type MessageTemplateTagCount = {
  __typename?: 'MessageTemplateTagCount';
  count: Scalars['Int']['output'];
  tag: MessageTemplateTag;
};

/** An edge in a connection. */
export type MessageTemplateTagEdge = {
  __typename?: 'MessageTemplateTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MessageTemplateTag>;
};

export enum MessageTemplateTagsNotAbleToBeAddedError {
  /** Unable to add tags */
  UnableToAddTags = 'UNABLE_TO_ADD_TAGS'
}

export enum MessageTemplateTagsNotAbleToBeRemovedError {
  /** Unable to remove tags */
  UnableToRemoveTags = 'UNABLE_TO_REMOVE_TAGS'
}

export type MessageTemplatesFilter = {
  /** filter by template categories */
  categories?: InputMaybe<Array<MessageCategory>>;
  /** filter by program custom message type */
  customMessageTypes?: InputMaybe<Array<ProgramCustomMessage>>;
  /** filter by message template identifiers */
  identifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter by message template ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter for message templates that are/are not archived */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for templates that are/are not default templates */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by message types */
  messageTypes?: InputMaybe<Array<Message>>;
  /** filter for the absence of program segments (nil) */
  multipleProgramSegments?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by program segments */
  programSegments?: InputMaybe<Array<ProgramSegment>>;
  /** filter by a search term */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** filter by a tags */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by user states */
  userStates?: InputMaybe<Array<UserState>>;
};

export type MessageTemplatesSort = {
  /** Which field to sort by */
  column: MessageTemplatesSortByField;
  direction: SortDirection;
};

export enum MessageTemplatesSortByField {
  ArchivedAt = 'ARCHIVED_AT',
  LastEditedAt = 'LAST_EDITED_AT',
  Name = 'NAME'
}

export type MicroSurvey = {
  __typename?: 'MicroSurvey';
  /** When the micro survey will stop being administered to users */
  expireAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The id */
  id: Scalars['ID']['output'];
  /** When the micro survey will go live to users */
  startAt: Scalars['ISO8601DateTime']['output'];
  /** The survey to be administered */
  survey: Survey;
  /** The string text for the button one */
  targetingCriteria?: Maybe<MicroSurveyTargetingCriteria>;
};

/** The connection type for MicroSurvey. */
export type MicroSurveyConnection = {
  __typename?: 'MicroSurveyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MicroSurveyEdge>>>;
  /** The collection of micro survey objects */
  nodes: Array<MicroSurvey>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all micro surveys in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MicroSurveyEdge = {
  __typename?: 'MicroSurveyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MicroSurvey>;
};

export enum MicroSurveyStatusFilter {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type MicroSurveyTargetingCriteria = {
  __typename?: 'MicroSurveyTargetingCriteria';
  /** The id */
  id: Scalars['ID']['output'];
  participants?: Maybe<ParticipantsFilterCriteria>;
};

/** MicroSurvey Targeting Criteria Input */
export type MicroSurveyTargetingCriteriaInput = {
  participants?: InputMaybe<ParticipantsFilter>;
};

export type MicroSurveysFilter = {
  /** Filter by program id */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by status */
  status?: InputMaybe<MicroSurveyStatusFilter>;
};

export type MicroSurveysSort = {
  /** Which field to sort by */
  column: MicroSurveysSortByField;
  direction: SortDirection;
};

export enum MicroSurveysSortByField {
  EndDate = 'END_DATE',
  StartDate = 'START_DATE',
  SurveyName = 'SURVEY_NAME'
}

export type MinimumNumberOfTouchpointsFilter = {
  count: Scalars['Int']['input'];
  programId: Scalars['ID']['input'];
  touchpointsCreatedAfterDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  touchpointsCreatedBeforeDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export enum ModeOfCommunication {
  Email = 'EMAIL',
  MeetingInPerson = 'MEETING_IN_PERSON',
  Other = 'OTHER',
  SocialMedia = 'SOCIAL_MEDIA',
  TalkingOnPhone = 'TALKING_ON_PHONE',
  Texting = 'TEXTING',
  Videochat = 'VIDEOCHAT'
}

/** Autogenerated return type of MoveParticipants. */
export type MoveParticipantsPayload = {
  __typename?: 'MoveParticipantsPayload';
  batchActionId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
};

export type MultiSelectHardMatchQuestion = {
  __typename?: 'MultiSelectHardMatchQuestion';
  /** The match type to be used for the multi-select hard match question */
  matchType: MultiSelectHardMatchQuestionMatch;
  /** The qid of the multi-select question */
  qid: Scalars['String']['output'];
};

export enum MultiSelectHardMatchQuestionMatch {
  MatchAll = 'MATCH_ALL',
  MatchNone = 'MATCH_NONE',
  MatchOne = 'MATCH_ONE'
}

export type Mutation = {
  __typename?: 'Mutation';
  addContacts?: Maybe<AddContactsPayload>;
  addContactsFromExistingProgram?: Maybe<AddContactsFromExistingProgramPayload>;
  addContactsToExistingUsers?: Maybe<AddContactsToExistingUsersPayload>;
  addMessageTemplatesTags: AddMessageTemplatesTags;
  addParticipants?: Maybe<AddParticipantsPayload>;
  archiveRestoreMessageTemplates: ArchiveRestoreMessageTemplates;
  autoSuggestMatches?: Maybe<AutoSuggestMatchesPayload>;
  changeMentorTrainingStatus?: Maybe<ChangeMentorTrainingStatusPayload>;
  completeTaskAssignment?: Maybe<CompleteTaskAssignmentPayload>;
  configureFlags?: Maybe<ConfigureFlagsPayload>;
  createEmailTemplate?: Maybe<CreateEmailTemplatePayload>;
  createEmailTemplateSavedRow?: Maybe<CreateEmailTemplateSavedRowPayload>;
  createFlagContact?: Maybe<CreateFlagContactPayload>;
  createMatchingLabel?: Maybe<CreateMatchingLabelPayload>;
  createMatchingSurvey?: Maybe<CreateMatchingSurveyPayload>;
  createMessageTemplateTag?: Maybe<CreateMessageTemplateTagPayload>;
  createMicroSurvey?: Maybe<CreateMicroSurveyPayload>;
  createNewCourseTaskAndNewProgramTask?: Maybe<CreateNewCourseTaskAndNewProgramTaskPayload>;
  createNewLinkTaskAndNewProgramTask?: Maybe<CreateNewLinkTaskAndNewProgramTaskPayload>;
  createNotificationView?: Maybe<CreateNotificationViewPayload>;
  createOrEnableNewProgramTask?: Maybe<CreateOrEnableNewProgramTaskPayload>;
  createPartner?: Maybe<CreatePartnerPayload>;
  createProgram?: Maybe<CreateProgramPayload>;
  createProgramAutomatchingConfiguration?: Maybe<CreateProgramAutomatchingConfigurationPayload>;
  createProgramAutomatchingDefault?: Maybe<CreateProgramAutomatchingDefaultPayload>;
  createProgramPageVisit?: Maybe<CreateProgramPageVisitPayload>;
  createProgramResource?: Maybe<CreateProgramResourcePayload>;
  createProgramSequence?: Maybe<CreateProgramSequencePayload>;
  createProgramTask?: Maybe<CreateProgramTaskPayload>;
  createProgramTopic?: Maybe<CreateProgramTopicPayload>;
  createSavedMatch?: Maybe<CreateSavedMatchPayload>;
  createSchool?: Maybe<CreateSchoolPayload>;
  createSkeletonMessageTemplate?: Maybe<CreateSkeletonMessageTemplatePayload>;
  createSmsTemplate?: Maybe<CreateSmsTemplatePayload>;
  createTopic?: Maybe<CreateTopicPayload>;
  createUploadedVideo?: Maybe<CreateUploadedVideoPayload>;
  deleteFlagContact?: Maybe<DeleteFlagContactPayload>;
  deleteMatchingLabel?: Maybe<DeleteMatchingLabelPayload>;
  deleteProgram?: Maybe<DeleteProgramPayload>;
  deleteProgramContacts?: Maybe<DeleteContacts>;
  deleteProgramResource?: Maybe<DeleteProgramResourcePayload>;
  deleteProgramSequence?: Maybe<DeleteProgramSequencePayload>;
  deleteProgramTask?: Maybe<DeleteProgramTaskPayload>;
  deleteProgramTopic?: Maybe<DeleteProgramTopicPayload>;
  deleteSavedMatches: DeleteSavedMatches;
  deleteSchool?: Maybe<DeleteSchoolPayload>;
  deleteSuggestedBatch?: Maybe<DeleteSuggestedBatchPayload>;
  denylistEmails?: Maybe<DenylistEmailsPayload>;
  deregisterParticipant?: Maybe<DeregisterParticipantPayload>;
  disableNewProgramTask?: Maybe<DisableNewProgramTaskPayload>;
  dismissProgramAlert?: Maybe<DismissProgramAlertPayload>;
  duplicateMessageTemplates: DuplicateMessageTemplates;
  duplicateProgram?: Maybe<DuplicateProgramPayload>;
  duplicateProgramSequence?: Maybe<DuplicateProgramSequencePayload>;
  logTookTypeformSurvey?: Maybe<LogTookTypeformSurveyPayload>;
  logWatchedCommunityVideo?: Maybe<LogWatchedCommunityVideoPayload>;
  logWatchedWistiaVideo?: Maybe<LogWatchedWistiaVideoPayload>;
  makeBatchMatches?: Maybe<MakeBatchMatchesPayload>;
  makeMatch?: Maybe<MakeMatchPayload>;
  makeSavedGroupMatches: MakeSavedGroupMatches;
  makeSavedMatches: MakeSavedMatches;
  markParticipantReachedOut?: Maybe<MarkParticipantReachedOutPayload>;
  moveParticipants?: Maybe<MoveParticipantsPayload>;
  previewMatchingSurvey?: Maybe<PreviewMatchingSurveyPayload>;
  reactivateProgramAlert?: Maybe<ReactivateProgramAlertPayload>;
  removeMessageTemplatesTags: RemoveMessageTemplatesTags;
  saveBatchMatches?: Maybe<SaveBatchMatchesPayload>;
  saveSurveyResponse?: Maybe<SaveSurveyResponsePayload>;
  saveWrittenMessage?: Maybe<SaveWrittenMessagePayload>;
  sendBulkMessageByCsv?: Maybe<SendBulkMessageByCsvPayload>;
  sendPartnerNotifications?: Maybe<SendPartnerNotificationsPayload>;
  sendSsoTestingTemplate?: Maybe<SendSsoTestingTemplatePayload>;
  sendTestMessage?: Maybe<SendTestMessagePayload>;
  sendUpdateEmailDraftForMentorship?: Maybe<SendUpdateEmailDraftForMentorshipPayload>;
  setupSftp?: Maybe<SetupSftpPayload>;
  startFirstWaveRecruitment?: Maybe<StartFirstWaveRecruitment>;
  startSecondWaveRecruitment?: Maybe<StartSecondWaveRecruitment>;
  stopRecruitment?: Maybe<StopRecruitment>;
  unmatchParticipant?: Maybe<UnmatchParticipantPayload>;
  unmatchParticipants?: Maybe<UnmatchParticipantsPayload>;
  updateAssessmentSurveyNewProgramTask?: Maybe<UpdateAssessmentSurveyNewProgramTaskPayload>;
  updateClickLinkNewProgramTask?: Maybe<UpdateClickLinkNewProgramTaskPayload>;
  updateClickLinkNewTask?: Maybe<UpdateClickLinkNewTaskPayload>;
  updateCourseNewProgramTask?: Maybe<UpdateCourseNewProgramTaskPayload>;
  updateCourseNewTask?: Maybe<UpdateCourseNewTaskPayload>;
  updateEmailTemplate?: Maybe<UpdateEmailTemplatePayload>;
  updateFlag?: Maybe<UpdateFlagPayload>;
  updateFlagContact?: Maybe<UpdateFlagContactPayload>;
  updateMenteeMentorSettings?: Maybe<UpdateMenteeMentorSettingsPayload>;
  updateMicroSurvey?: Maybe<UpdateMicroSurveyPayload>;
  updateNewProgramTask?: Maybe<UpdateNewProgramTaskPayload>;
  updateParticipant?: Maybe<UpdateParticipantPayload>;
  updateParticipantsMatchingLabels?: Maybe<UpdateParticipantsMatchingLabelsPayload>;
  updatePartner?: Maybe<UpdatePartnerPayload>;
  updateProgramAdmins?: Maybe<UpdateProgramAdminsPayload>;
  updateProgramCommunicationSettings?: Maybe<UpdateProgramCommunicationSettingsPayload>;
  updateProgramCustomLabel?: Maybe<UpdateProgramCustomLabelPayload>;
  updateProgramCustomMessageTemplates?: Maybe<UpdateProgramCustomMessageTemplatesPayload>;
  updateProgramFlagContacts?: Maybe<UpdateProgramFlagContactsPayload>;
  updateProgramInfo?: Maybe<UpdateProgramInfoPayload>;
  updateProgramPointPeople?: Maybe<UpdateProgramPointPeoplePayload>;
  updateProgramSequenceInfo?: Maybe<UpdateProgramSequenceInfoPayload>;
  updateProgramSetup?: Maybe<UpdateProgramSetupPayload>;
  updateProgramTask?: Maybe<UpdateProgramTaskPayload>;
  updateProgramTopic?: Maybe<UpdateProgramTopicPayload>;
  updateProgramTopics?: Maybe<UpdateProgramTopicsPayload>;
  updateSchoolInfo?: Maybe<UpdateSchoolInfoPayload>;
  updateSmsTemplate?: Maybe<UpdateSmsTemplatePayload>;
  updateSurveysAndQuizzes?: Maybe<UpdateSurveysAndQuizzesPayload>;
  updateTopic?: Maybe<UpdateTopicPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updatedProgramProfileAttributes?: Maybe<UpdateProgramProfileAttributesPayload>;
  uploadUserProfileData?: Maybe<UploadUserProfileDataPayload>;
};


export type MutationAddContactsArgs = {
  contactType: ContactEnum;
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationAddContactsFromExistingProgramArgs = {
  contactType: ContactEnum;
  existingPool: ExistingPoolEnum;
  fromProgramId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationAddContactsToExistingUsersArgs = {
  contactType: ContactEnum;
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationAddParticipantsArgs = {
  file: Scalars['File']['input'];
  fromAnotherProgram: Scalars['Boolean']['input'];
  participantType: ParticipantEnum;
  programId: Scalars['ID']['input'];
};


export type MutationAutoSuggestMatchesArgs = {
  autoMatchOptions: AutoSuggestMatchesInput;
};


export type MutationChangeMentorTrainingStatusArgs = {
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
  trainingStatus: MentorTrainingStatusEnum;
};


export type MutationCompleteTaskAssignmentArgs = {
  taskAssignmentId: Scalars['ID']['input'];
};


export type MutationConfigureFlagsArgs = {
  configureFlagsInput: ConfigureFlagsInput;
};


export type MutationCreateEmailTemplateArgs = {
  createEmailTemplateInput: CreateEmailTemplateInput;
};


export type MutationCreateEmailTemplateSavedRowArgs = {
  newRowInput: CreateEmailTemplateSavedRowInput;
};


export type MutationCreateFlagContactArgs = {
  flagContactInput: CreateFlagContactInput;
};


export type MutationCreateMatchingLabelArgs = {
  matchingLabelKind: MatchingLabelKindTypes;
  participantId: Scalars['ID']['input'];
};


export type MutationCreateMatchingSurveyArgs = {
  customQuestionsFromAdminTool?: InputMaybe<Array<SurveyCustomizationQuestionInput>>;
  matchingSurveyOptions: CreateMatchingSurveyInput;
};


export type MutationCreateMessageTemplateTagArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateMicroSurveyArgs = {
  microSurveyInput: CreateMicroSurveyInput;
};


export type MutationCreateNewCourseTaskAndNewProgramTaskArgs = {
  newCourseTaskAndNewProgramTaskInput: NewCourseTaskAndNewProgramTaskInput;
};


export type MutationCreateNewLinkTaskAndNewProgramTaskArgs = {
  newLinkTaskAndNewProgramTaskInput: NewLinkTaskAndNewProgramTaskInput;
};


export type MutationCreateNotificationViewArgs = {
  displayMedium: Scalars['String']['input'];
  notificationViewableId: Scalars['ID']['input'];
  notificationViewableType: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateOrEnableNewProgramTaskArgs = {
  assigneeEntity: AssigneeEntity;
  displayName: Scalars['String']['input'];
  newTaskId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationCreatePartnerArgs = {
  partnerInput: CreatePartnerInput;
};


export type MutationCreateProgramArgs = {
  programInput: CreateProgramInput;
};


export type MutationCreateProgramAutomatchingConfigurationArgs = {
  configuration: CreateProgramAutomatchingConfigurationInput;
};


export type MutationCreateProgramAutomatchingDefaultArgs = {
  automatchingDefaultId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationCreateProgramPageVisitArgs = {
  path: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateProgramResourceArgs = {
  programResourceInput: CreateProgramResourceInput;
};


export type MutationCreateProgramSequenceArgs = {
  programSequenceInput: CreateProgramSequenceInput;
};


export type MutationCreateProgramTaskArgs = {
  programTaskInput: CreateProgramTaskInput;
};


export type MutationCreateProgramTopicArgs = {
  createProgramTopicInput: CreateProgramTopicInput;
};


export type MutationCreateSavedMatchArgs = {
  mentorId: Scalars['ID']['input'];
  source: MatchingSource;
  studentId: Scalars['ID']['input'];
};


export type MutationCreateSchoolArgs = {
  schoolInput: CreateSchoolInput;
};


export type MutationCreateSkeletonMessageTemplateArgs = {
  skeletonMessageTemplateInput: CreateSkeletonMessageTemplateInput;
};


export type MutationCreateSmsTemplateArgs = {
  createSmsTemplateInput: CreateSmsTemplateInput;
};


export type MutationCreateTopicArgs = {
  createTopicInput: CreateTopicInput;
};


export type MutationCreateUploadedVideoArgs = {
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  participantId: Scalars['ID']['input'];
  sharePublicly: Scalars['Boolean']['input'];
  shareWithStudents: Scalars['Boolean']['input'];
  ziggeoToken: Scalars['String']['input'];
};


export type MutationDeleteFlagContactArgs = {
  id: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationDeleteMatchingLabelArgs = {
  matchingLabelKind: MatchingLabelKindTypes;
  participantId: Scalars['ID']['input'];
};


export type MutationDeleteProgramArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProgramContactsArgs = {
  programId: Scalars['ID']['input'];
};


export type MutationDeleteProgramResourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProgramSequenceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProgramTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProgramTopicArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSchoolArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSuggestedBatchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDenylistEmailsArgs = {
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationDeregisterParticipantArgs = {
  deregisterParticipantInput: DeregisterParticipantInput;
};


export type MutationDisableNewProgramTaskArgs = {
  disableNewProgramTaskInput: DisableNewProgramTaskInput;
};


export type MutationDismissProgramAlertArgs = {
  dismissalInput: ProgramAlertDismissalInput;
};


export type MutationDuplicateProgramArgs = {
  duplicateLegacyTasks?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  toProgramSequenceId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDuplicateProgramSequenceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLogTookTypeformSurveyArgs = {
  externalLinkId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};


export type MutationLogWatchedCommunityVideoArgs = {
  participantId: Scalars['ID']['input'];
  taskName: Scalars['String']['input'];
  ziggeoToken: Scalars['String']['input'];
};


export type MutationLogWatchedWistiaVideoArgs = {
  participantId: Scalars['ID']['input'];
  wistiaVideoId: Scalars['String']['input'];
};


export type MutationMakeBatchMatchesArgs = {
  suggestedBatchId: Scalars['ID']['input'];
};


export type MutationMakeMatchArgs = {
  allowRematch?: InputMaybe<Scalars['Boolean']['input']>;
  mentorId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type MutationMarkParticipantReachedOutArgs = {
  mentorshipId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};


export type MutationMoveParticipantsArgs = {
  destinationProgramId: Scalars['ID']['input'];
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
  reasonForMove?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPreviewMatchingSurveyArgs = {
  customQuestionsFromAdminTool?: InputMaybe<Array<SurveyCustomizationQuestionInput>>;
  matchingSurveyOptions: BaseMatchingSurveyInput;
  programId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationReactivateProgramAlertArgs = {
  alertTypeIdentifier: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationSaveBatchMatchesArgs = {
  suggestedBatchId: Scalars['ID']['input'];
};


export type MutationSaveSurveyResponseArgs = {
  response: SurveyResponseInput;
};


export type MutationSaveWrittenMessageArgs = {
  content: Scalars['String']['input'];
  participantId: Scalars['ID']['input'];
  sharePublicly?: InputMaybe<Scalars['Boolean']['input']>;
  shareWithStudents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSendBulkMessageByCsvArgs = {
  file: Scalars['File']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationSendPartnerNotificationsArgs = {
  programId: Scalars['ID']['input'];
  recipients: Array<Scalars['ID']['input']>;
  templateId: Scalars['ID']['input'];
};


export type MutationSendSsoTestingTemplateArgs = {
  schoolId: Scalars['ID']['input'];
};


export type MutationSendTestMessageArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  recipientId?: InputMaybe<Scalars['ID']['input']>;
  templateId: Scalars['ID']['input'];
};


export type MutationSendUpdateEmailDraftForMentorshipArgs = {
  mentorshipId: Scalars['ID']['input'];
};


export type MutationSetupSftpArgs = {
  programId: Scalars['ID']['input'];
  publicKey: Scalars['String']['input'];
};


export type MutationStartFirstWaveRecruitmentArgs = {
  programId: Scalars['ID']['input'];
};


export type MutationStartSecondWaveRecruitmentArgs = {
  programId: Scalars['ID']['input'];
};


export type MutationStopRecruitmentArgs = {
  programId: Scalars['ID']['input'];
};


export type MutationUnmatchParticipantArgs = {
  initiatedBy: UnmatchInitiatedBy;
  mentorshipId: Scalars['ID']['input'];
  reasonToShareWithMentee?: InputMaybe<Scalars['String']['input']>;
  reasonToShareWithMentor?: InputMaybe<Scalars['String']['input']>;
  requesterNotes?: InputMaybe<Scalars['String']['input']>;
  sendUnmatchingEmails?: InputMaybe<Scalars['Boolean']['input']>;
  unmatchNotes?: InputMaybe<Scalars['String']['input']>;
  unmatchReason: UnmatchReason;
  wantsRematch: Scalars['Boolean']['input'];
};


export type MutationUnmatchParticipantsArgs = {
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
  sendUnmatchEmails?: InputMaybe<Scalars['Boolean']['input']>;
  unmatchNotes?: InputMaybe<Scalars['String']['input']>;
  unmatchReason: UnmatchReason;
};


export type MutationUpdateAssessmentSurveyNewProgramTaskArgs = {
  updateAssessmentSurveyNewProgramTaskInput: UpdateAssessmentSurveyNewProgramTaskInput;
};


export type MutationUpdateClickLinkNewProgramTaskArgs = {
  updateClickLinkNewProgramTaskInput: UpdateClickLinkNewProgramTaskInput;
};


export type MutationUpdateClickLinkNewTaskArgs = {
  updateClickLinkNewTaskInput: UpdateClickLinkNewTaskInput;
};


export type MutationUpdateCourseNewProgramTaskArgs = {
  updateCourseNewProgramTaskInput: UpdateCourseNewProgramTaskInput;
};


export type MutationUpdateCourseNewTaskArgs = {
  updateCourseNewTaskInput: UpdateCourseNewTaskInput;
};


export type MutationUpdateEmailTemplateArgs = {
  updatedEmailTemplateInput: UpdateEmailTemplateInput;
};


export type MutationUpdateFlagArgs = {
  id: Scalars['ID']['input'];
  partnerNotes: Scalars['String']['input'];
  status: FlagStatus;
};


export type MutationUpdateFlagContactArgs = {
  flagContactInput: FlagContactInput;
};


export type MutationUpdateMenteeMentorSettingsArgs = {
  settings: UpdateMenteeMentorSettingsInput;
};


export type MutationUpdateMicroSurveyArgs = {
  microSurvey: UpdateMicroSurveyInput;
};


export type MutationUpdateNewProgramTaskArgs = {
  updateNewProgramTaskInput: UpdateNewProgramTaskInput;
};


export type MutationUpdateParticipantArgs = {
  participantInput: ParticipantInput;
};


export type MutationUpdateParticipantsMatchingLabelsArgs = {
  action: MatchingLabelAction;
  file: Scalars['File']['input'];
  labelKinds: Array<MatchingLabelKindTypes>;
  programId: Scalars['ID']['input'];
};


export type MutationUpdatePartnerArgs = {
  higherEdCategory?: InputMaybe<HigherEdCategory>;
  higherEdRole?: InputMaybe<HigherEdRole>;
  organizationType?: InputMaybe<OrganizationType>;
  userInput: UserInput;
};


export type MutationUpdateProgramAdminsArgs = {
  programAdmins: UpdateProgramAdminsInput;
};


export type MutationUpdateProgramCommunicationSettingsArgs = {
  updateProgramCommunicationSettingsInput: UpdateProgramCommunicationSettingsInput;
};


export type MutationUpdateProgramCustomLabelArgs = {
  updateProgramCustomLabelInput: UpdateProgramCustomLabelInput;
};


export type MutationUpdateProgramCustomMessageTemplatesArgs = {
  programCustomMessageTemplates: UpdateProgramCustomMessageTemplatesInput;
};


export type MutationUpdateProgramFlagContactsArgs = {
  programFlagContacts: UpdateProgramFlagContactsInput;
};


export type MutationUpdateProgramInfoArgs = {
  programInfo: UpdateProgramInfoInput;
};


export type MutationUpdateProgramPointPeopleArgs = {
  programPointPeople: UpdateProgramPointPeopleInput;
};


export type MutationUpdateProgramSequenceInfoArgs = {
  programSequenceInfo: UpdateProgramSequenceInfoInput;
};


export type MutationUpdateProgramSetupArgs = {
  programSetup: UpdateProgramSetupInput;
};


export type MutationUpdateProgramTaskArgs = {
  programTask: UpdateProgramTaskInput;
};


export type MutationUpdateProgramTopicArgs = {
  updateProgramTopicInput: UpdateProgramTopicInput;
};


export type MutationUpdateProgramTopicsArgs = {
  programTopics: UpdateProgramTopicsInput;
};


export type MutationUpdateSchoolInfoArgs = {
  schoolInfo: UpdateSchoolInfoInput;
};


export type MutationUpdateSmsTemplateArgs = {
  updatedSmsTemplateInput: UpdateSmsTemplateInput;
};


export type MutationUpdateSurveysAndQuizzesArgs = {
  surveysAndQuizzes: UpdateSurveysAndQuizzesInput;
};


export type MutationUpdateTopicArgs = {
  updatedTopicInput: UpdateTopicInput;
};


export type MutationUpdateUserArgs = {
  userInput: UserInput;
};


export type MutationUpdatedProgramProfileAttributesArgs = {
  programProfileAttributesInput: Array<UpdateProgramProfileAttributeInput>;
};


export type MutationUploadUserProfileDataArgs = {
  uploadUserProfileDataInput: UploadUserProfileDataInput;
};

/** Create new task and new program task input */
export type NewCourseTaskAndNewProgramTaskInput = {
  assigneeEntity: AssigneeEntity;
  behavior: Behavior;
  courseSelection?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  internalTaskName: Scalars['String']['input'];
  mentorshipCredential: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
  requiredForMatching?: InputMaybe<Scalars['Boolean']['input']>;
  segmentTags: Array<NewTaskSegmentTag>;
};

/** Create new task and new program task input */
export type NewLinkTaskAndNewProgramTaskInput = {
  assigneeEntity: AssigneeEntity;
  behavior: Behavior;
  clickLinkUrl?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  internalTaskName: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
  segmentTags: Array<NewTaskSegmentTag>;
};

export type NewProgramTask = {
  __typename?: 'NewProgramTask';
  assigneeEntity: AssigneeEntity;
  behavior: Behavior;
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The new task this program task inherits from */
  newTask: NewTask;
  programId: Scalars['ID']['output'];
  /** The assigned tasks */
  taskAssignments: Array<TaskAssignment>;
};

/** The connection type for NewProgramTask. */
export type NewProgramTaskConnection = {
  __typename?: 'NewProgramTaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NewProgramTaskEdge>>>;
  /** The collection of new program task objects */
  nodes: Array<NewProgramTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all new program tasks in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NewProgramTaskEdge = {
  __typename?: 'NewProgramTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NewProgramTask>;
};

export type NewProgramTasksFilter = {
  /** filter by assignee entities */
  assigneeEntities?: InputMaybe<Array<AssigneeEntity>>;
  /** filter by behaviors */
  behaviors?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter by context types */
  contextTypes?: InputMaybe<Array<KindOfContext>>;
  /** filter by enabled status */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by specific program IDs */
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by segment */
  segments?: InputMaybe<Array<NewTaskSegmentTag>>;
};

export type NewProgramTasksSort = {
  /** Which field to sort by */
  column: NewProgramTasksSortByField;
  direction: SortDirection;
};

export enum NewProgramTasksSortByField {
  DisplayName = 'DISPLAY_NAME',
  Id = 'ID',
  InternalTaskName = 'INTERNAL_TASK_NAME',
  Target = 'TARGET',
  TaskType = 'TASK_TYPE'
}

export type NewTask = {
  __typename?: 'NewTask';
  /** Context type */
  context?: Maybe<Context>;
  /** A default for the assignee_entity */
  defaultAssigneeEntity?: Maybe<AssigneeEntity>;
  /** A default for the display name */
  defaultDisplayName?: Maybe<Scalars['String']['output']>;
  /** The id */
  id: Scalars['ID']['output'];
  /** The internal task name */
  internalTaskName: Scalars['String']['output'];
  /** Mentorship credential that is fulfilled when this task is completed */
  mentorshipCredential?: Maybe<MentorshipCredential>;
  /** A required_for_matching boolean */
  requiredForMatching?: Maybe<Scalars['Boolean']['output']>;
  /** Segment tags */
  segmentTags: Array<NewTaskSegmentTag>;
};

/** The connection type for NewTask. */
export type NewTaskConnection = {
  __typename?: 'NewTaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NewTaskEdge>>>;
  /** The collection of new task objects */
  nodes: Array<NewTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all new tasks in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NewTaskEdge = {
  __typename?: 'NewTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NewTask>;
};

export enum NewTaskSegmentTag {
  AdultOnline = 'adult_online',
  Corporate = 'corporate',
  Enrollment = 'enrollment',
  FirstYearExperience = 'first_year_experience',
  Returning = 'returning'
}

export type NewTasksFilter = {
  /** filter by context types */
  contextTypes?: InputMaybe<Array<KindOfContext>>;
  /** filter by ids */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter by participant type */
  participantTypes?: InputMaybe<Array<AssigneeEntity>>;
  /** filter by a search term */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** filter by segment */
  segments?: InputMaybe<Array<NewTaskSegmentTag>>;
  /** filter by task types */
  taskTypes?: InputMaybe<Array<KindOfContext>>;
};

export type NewTasksSort = {
  /** Which field to sort by */
  column: NewTasksSortByField;
  direction: SortDirection;
};

export enum NewTasksSortByField {
  Id = 'ID',
  InternalTaskName = 'INTERNAL_TASK_NAME'
}

export type NewTopicMessageInput = {
  emailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  hoursDelayAfterMessage: Scalars['Int']['input'];
  index: Scalars['Int']['input'];
  preferredMedium: Message;
  smsTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

export type NotificationData = {
  __typename?: 'NotificationData';
  /** The string text for the button one */
  buttonOneText?: Maybe<Scalars['String']['output']>;
  /** The type of medium used to display this notification */
  displayMedium?: Maybe<Scalars['String']['output']>;
  /** The notification id, constructed via resolver */
  id: Scalars['ID']['output'];
  /** The URL of the notification image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The markdown to be rendered on the body */
  markdownBody?: Maybe<Scalars['String']['output']>;
  /** The polymorphic notification_viewable id */
  notificationViewableId: Scalars['ID']['output'];
  /** The polymorphic notification_viewable type */
  notificationViewableType: Scalars['String']['output'];
};

export type NumberOfTouchpointsFilter = {
  count: Scalars['Int']['input'];
  programId: Scalars['ID']['input'];
  touchpointsCreatedAfterDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  touchpointsCreatedBeforeDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type ObjectChange = {
  __typename?: 'ObjectChange';
  /** The attribute that changed */
  attribute: Scalars['String']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The new updated value of the attribute */
  newValue?: Maybe<Scalars['String']['output']>;
  /** The original value of the attribute */
  originalValue?: Maybe<Scalars['String']['output']>;
};

export enum ObjectChangeEvent {
  Create = 'CREATE',
  Destroy = 'DESTROY',
  Update = 'UPDATE'
}

export type ObjectChangeset = {
  __typename?: 'ObjectChangeset';
  /** The admin action that resulted in this change */
  adminAction?: Maybe<AdminAction>;
  /** All the changes that occured as part of this changeset */
  changes: Array<ObjectChange>;
  /** The type of event that triggered the change */
  eventType: ObjectChangeEvent;
  /** The id */
  id: Scalars['ID']['output'];
  /** The tracked object (could be null if the record has since been deleted) */
  trackedObject?: Maybe<TrackedObject>;
};

/** The connection type for ObjectChangeset. */
export type ObjectChangesetConnection = {
  __typename?: 'ObjectChangesetConnection';
  /** Aggregate counts of the types of changes that happened */
  affectedObjectTypeCounts: Array<AffectedObjectTypeCount>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ObjectChangesetEdge>>>;
  /** The collection of changeset objects */
  nodes: Array<ObjectChangeset>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all changsets in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ObjectChangesetEdge = {
  __typename?: 'ObjectChangesetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ObjectChangeset>;
};

export type ObjectChangesetsFilter = {
  /** filter by specific types of objects change events */
  changedObjectEventTypes?: InputMaybe<Array<ObjectChangeEvent>>;
  /** filter by specific types of objects changed */
  changedObjectTypes?: InputMaybe<Array<AffectedObject>>;
};

export type OmniauthCredentialLatestSession = {
  __typename?: 'OmniauthCredentialLatestSession';
  /** Date of the first time session data was captured */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Email of the user captured from the session */
  email?: Maybe<Scalars['String']['output']>;
  /** First name of the user captured from the session */
  firstName?: Maybe<Scalars['String']['output']>;
  /** ID of the latest session data */
  id: Scalars['ID']['output'];
  /** Institution ID of the user captured from the session (ID from the school's SIS) */
  institutionId?: Maybe<Scalars['String']['output']>;
  /** Date of the last time the user authenticated and session data was evaluated */
  lastAuthAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Last name of the user captured from the session */
  lastName?: Maybe<Scalars['String']['output']>;
  /** ID of the omniauth credential this session is attached to */
  omniauthCredentialId: Scalars['ID']['output'];
  /** Date of the last time session data was updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the user the session was attached to */
  userId: Scalars['ID']['output'];
};

export enum OpportunityArea {
  AcademicsFirstChoice = 'ACADEMICS_FIRST_CHOICE',
  CareerInterest = 'CAREER_INTEREST',
  Challenge = 'CHALLENGE',
  Hobby = 'HOBBY',
  Language = 'LANGUAGE',
  Overview = 'OVERVIEW'
}

export type OptedInForMentorshipFilter = {
  programId: Scalars['ID']['input'];
  value: Scalars['Boolean']['input'];
  wantsMentorshipEventsAfterDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  wantsMentorshipEventsBeforeDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** List of options for a survey question */
export type OptionListQuestionInput = {
  /** The list of options enabled for a question */
  options?: InputMaybe<Array<SurveyQuestionOptionInput>>;
};

export enum OrganizationType {
  CompanyOrCorporation = 'company_or_corporation',
  HigherEducationInstitution = 'higher_education_institution',
  NonProfit = 'non_profit'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** A participant of a program */
export type Participant = {
  /** Any logs of this participant's activity */
  activityLogs: Array<Log>;
  /**
   * The user's avatar, or the program default if nil
   * @deprecated Use avatarImage instead, which leverages activestorage to provide on-the-fly image variants
   */
  avatar: Scalars['String']['output'];
  /** The user's avatar, or the program default if nil */
  avatarImage?: Maybe<Image>;
  /** The user's profile attribute values */
  cachedUserProfileData?: Maybe<Array<CachedUserProfileDataAttributeValue>>;
  /** When the participant has completed their matching survey */
  completedMatchingSurveyAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the participant was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date participant was deregistered */
  deregisterDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The participant's deregistration status events */
  deregistrationStatusEvents: Array<DeregistrationStatusEvent>;
  /** The id */
  id: Scalars['ID']['output'];
  /** Any matching labels associated with the participant */
  matchingLabels: Array<MatchingLabel>;
  /**
   * The mentorships
   * @deprecated Use participant_mentorships instead, which is a connection type and provides the same data but with pagination
   */
  mentorships: Array<Mentorship>;
  /** Notes on participant */
  notes?: Maybe<Scalars['String']['output']>;
  /** Mentorships associated with a participant */
  participantMentorships?: Maybe<MentorshipConnection>;
  /** Whether this participant is prioritized and pending for rematch */
  prioritizedAndPendingForRematching: Scalars['Boolean']['output'];
  /** The program this mentor belongs to */
  program: Program;
  /** Whether this participant has been marked as pushed through to match, allowing them to skip onboarding */
  pushedThroughToMatch: Scalars['Boolean']['output'];
  /** Whether this participant is registered for a program or not */
  registered: Scalars['Boolean']['output'];
  /** When the participant registered */
  registrationDate: Scalars['ISO8601DateTime']['output'];
  /** Response for opting in to supermentorships (Currently on the user level) */
  supermentorOptIn?: Maybe<Scalars['String']['output']>;
  /**
   * This participants survey responses
   * @deprecated Accessing survey_responses from participant will be removed. Please re-write this query to get survey_responses from user.
   */
  surveyResponses: Array<SurveyResponse>;
  /** Any videos uploaded by this participant */
  uploadedVideos: Array<UploadedVideo>;
  /** The user */
  user: User;
  /** The user's profile attribute values */
  userProfileData: Array<UserProfileData>;
  /** Link to the program specific URL in the participant dashboard for this participant */
  webappBaseUrl?: Maybe<Scalars['String']['output']>;
  /** The written messages for this participant */
  writtenMessages: Array<WrittenMessage>;
};


/** A participant of a program */
export type ParticipantCachedUserProfileDataArgs = {
  attributes: Array<CachedUserProfileDataAttributeInput>;
  cacheSettings: CachedUserProfileDataSettingsFilter;
};


/** A participant of a program */
export type ParticipantMentorshipsArgs = {
  status?: InputMaybe<MatchedStatus>;
};


/** A participant of a program */
export type ParticipantParticipantMentorshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MentorshipsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MentorshipsSort>;
};


/** A participant of a program */
export type ParticipantSurveyResponsesArgs = {
  context?: InputMaybe<SurveyResponseContextFilter>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};


/** A participant of a program */
export type ParticipantUploadedVideosArgs = {
  onlySharable?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A participant of a program */
export type ParticipantUserProfileDataArgs = {
  attributes: Array<UserProfileDataAttributeInput>;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule>>;
  source: ProfileAttributeSource;
};

/** The connection type for Participant. */
export type ParticipantConnection = {
  __typename?: 'ParticipantConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ParticipantEdge>>>;
  /** The collection of participant objects */
  nodes: Array<Participant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all participants in the collection */
  totalCount: Scalars['Int']['output'];
  /** The total count of mentors in this collection that have attended training */
  totalCountHavingAttendedTraining: Scalars['Int']['output'];
  /** The total count of participants in this collection that have completed a matching survey */
  totalCountHavingCompletedMatchingSurvey: Scalars['Int']['output'];
  /** The total count of mentors in this collection that have not attended training */
  totalCountHavingNotAttendedTraining: Scalars['Int']['output'];
  /** The total count of participants in this collection that have not completed a matching survey */
  totalCountHavingNotCompletedMatchingSurvey: Scalars['Int']['output'];
  /** The total count of mentors in this collection that have not signed up for training */
  totalCountHavingNotSignedUpForTraining: Scalars['Int']['output'];
  /** The total count of mentors in this collection that have signed up for training */
  totalCountHavingSignedUpForTraining: Scalars['Int']['output'];
  /** The total count of all participants in programs with training in the collection */
  totalCountInProgramsWithTraining: Scalars['Int']['output'];
  /** The total count of distinct users in the collection */
  totalCountOfDistinctUsers: Scalars['Int']['output'];
  /** The total count of participants in this collection that are prioritized and pending for rematch */
  totalPrioritizedAndPendingForRematching: Scalars['Int']['output'];
};


/** The connection type for Participant. */
export type ParticipantConnectionTotalCountHavingAttendedTrainingArgs = {
  onlyProgramsWithTraining?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Whether the conversation was logged by a student or mentor */
export enum ParticipantConversation {
  MentorConversation = 'MENTOR_CONVERSATION',
  StudentConversation = 'STUDENT_CONVERSATION'
}

export type ParticipantConversationCategory = {
  __typename?: 'ParticipantConversationCategory';
  /** The id */
  id: Scalars['ID']['output'];
  /** String identifier */
  identifier: Scalars['String']['output'];
  /** Extended label for user scenarios that need more detail */
  label: Scalars['String']['output'];
  /** User facing name */
  name: Scalars['String']['output'];
};

export type ParticipantConversationContent = {
  __typename?: 'ParticipantConversationContent';
  /** Notes given by ??? */
  confidenceNotes?: Maybe<Scalars['String']['output']>;
  /** Score given by ??? */
  confidenceScore?: Maybe<Scalars['Int']['output']>;
  /** The conversation logged */
  conversationLog: ConversationLog;
  /** Date created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** A related flag */
  flag?: Maybe<Flag>;
  /** The id */
  id: Scalars['ID']['output'];
  /** Categories */
  participantConversationCategories?: Maybe<Array<ParticipantConversationCategory>>;
  /** Student or Mentor conversation */
  participantConversationType: ParticipantConversation;
  /** The user that submitted the flag (admin or participant) */
  submittedBy: User;
};

/** The connection type for ParticipantConversationContent. */
export type ParticipantConversationContentConnection = {
  __typename?: 'ParticipantConversationContentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ParticipantConversationContentEdge>>>;
  /** The collection of participant conversation content objects */
  nodes: Array<ParticipantConversationContent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all conversations in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ParticipantConversationContentEdge = {
  __typename?: 'ParticipantConversationContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ParticipantConversationContent>;
};

export type ParticipantConversationContentsFilter = {
  /** filter for conversation categories */
  conversationTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter for conversations after a given date */
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter for conversations before a given date */
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter by a mentee's attributes */
  mentorshipFilter?: InputMaybe<MentorshipsFilter>;
  /** filter by program id */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /** filter for conversations submitted by given participant types */
  submittedBy?: InputMaybe<Array<ParticipantConversationContentsSubmitter>>;
};

export type ParticipantConversationContentsSort = {
  /** Which field to sort by */
  column: ParticipantConversationContentsSortByField;
  direction: SortDirection;
};

export enum ParticipantConversationContentsSortByField {
  ConversationTopic = 'CONVERSATION_TOPIC',
  CreatedAt = 'CREATED_AT'
}

export enum ParticipantConversationContentsSubmitter {
  Admin = 'ADMIN',
  Mentee = 'MENTEE',
  Mentor = 'MENTOR'
}

/** An edge in a connection. */
export type ParticipantEdge = {
  __typename?: 'ParticipantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Participant>;
};

export enum ParticipantEnum {
  /** Mentor */
  Mentor = 'MENTOR',
  /** Student */
  Student = 'STUDENT'
}

/** Participant Input */
export type ParticipantInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  participantId: Scalars['ID']['input'];
};

export enum ParticipantTypeFilter {
  Mentors = 'MENTORS',
  Students = 'STUDENTS'
}

export type ParticipantsFilter = {
  /** filter for participants (mentors) that have attended training or not */
  attendedTraining?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for available to be matched */
  availableToBeMatched?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for mentors that are available to be matched (inclusive - Registered, with matching survey and training OR pushed through to match, with open capacity, but not on hold) */
  availableToBeMatchedMentors?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by category id for flags reported as needing immediate/priority support in the mentorship */
  categoriesPriorityFlagged?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter for participants that have completed matching survey or not */
  completedMatchingSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  /** Look for participants that completed their matching survey after this date */
  completedMatchingSurveyAfterDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Look for participants that completed their matching survey before this date */
  completedMatchingSurveyBeforeDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter for participants that have completed any of the tasks specified */
  completedTaskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Look for participants that completed training after this date */
  completedTrainingAfterDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Look for participants that completed training before this date */
  completedTrainingBeforeDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter for participants currently matched */
  currentlyMatched?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for users that have a specific mentorship disengagement resolution result */
  disengagementResolution?: InputMaybe<DisengagementResolution>;
  /** filter for participants that are engaged in mentorships (ie 1+ conversation logged) */
  engaged?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for participants ever matched */
  everMatched?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter participants not in specific programs */
  excludeProgramIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter for participants in a program with mentor training */
  inProgramWithMentorTraining?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for candidates that have logged up to a maximun number conversations */
  maximumNumberOfConversations?: InputMaybe<Scalars['Int']['input']>;
  /** filter for participants (mentees) matched to program capacity */
  menteesMatchedToProgramCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for participants (mentors) with open capacity */
  mentorsWithOpenCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for candidates that have logged a minimum number conversations */
  minimumNumberOfConversations?: InputMaybe<Scalars['Int']['input']>;
  /** filter for candidates that have logged a specific number of conversations */
  numberOfConversations?: InputMaybe<Scalars['Int']['input']>;
  /** filter by a mentor's mentee count */
  numberOfMentees?: InputMaybe<MentorNumberOfMenteesFilter>;
  /** filter for participants on hold */
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for participants in specific programs */
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter for participants in programs that are ending in less than 4 weeks */
  programIsEndingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for participants pushed through to match */
  pushedThroughToMatch?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for candidates with a high satisfaction score */
  recentHighSatisfactionScore?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for candidates with a low satisfaction score */
  recentLowSatisfactionScore?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for participants that are registered or not */
  registered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Look for participants that were registered after this date */
  registeredAfterDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Look for participants that were registered before this date */
  registeredBeforeDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** filter by a search term */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** filter by segment type */
  segment?: InputMaybe<ProgramSegment>;
  /** filter for participants (mentors) that have signed up for training or not */
  signedUpForTraining?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by a search term, limited to user first/last name and email */
  simpleSearchString?: InputMaybe<Scalars['String']['input']>;
  /** filter participants by student goal */
  studentGoals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter for users that have a student registrant that has opted in for mentorship */
  studentOptedInForMentorship?: InputMaybe<OptedInForMentorshipFilter>;
  /** filter for participants who have or have not completed specific surveys */
  surveyCompletionStatus?: InputMaybe<Array<SurveyCompletionFilter>>;
  /** filter by participant_conversation_categories id, aka topics from conversation logs */
  topicsDiscussedWithCounterpart?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by participant type */
  type?: InputMaybe<ParticipantTypeFilter>;
  /** filter by whether at least one person in the mentorship has used text relay */
  usedTextRelayInMentorship?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for participants whose user meet the criteria specified */
  usersFilter?: InputMaybe<UsersFilter>;
  /** filter for participants (mentees) that have opted in to mentorship */
  wantsMentorshipAnswer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParticipantsFilterCriteria = {
  __typename?: 'ParticipantsFilterCriteria';
  /** a filter for participants available to be matched */
  availableToBeMatched?: Maybe<Scalars['Boolean']['output']>;
  /** a filter for participants that have completed matching survey or not */
  completedMatchingSurvey?: Maybe<Scalars['Boolean']['output']>;
  /** a filter for participants currently matched */
  currentlyMatched?: Maybe<Scalars['Boolean']['output']>;
  /** a filter for participants that are engaged in mentorships (ie 1+ conversation logged) */
  engaged?: Maybe<Scalars['Boolean']['output']>;
  /** a filter for participants ever matched */
  everMatched?: Maybe<Scalars['Boolean']['output']>;
  /** a filter for participants not in specific programs */
  excludeProgramIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** id for the saved filter criteria */
  id: Scalars['ID']['output'];
  /** a filter for participants in specific programs */
  programIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** a filter for participants that are registered or not */
  registered?: Maybe<Scalars['Boolean']['output']>;
  /** a filter for segment type */
  segment?: Maybe<ProgramSegment>;
  /** a filter for participants (mentors) that have signed up for training or not */
  signedUpForTraining?: Maybe<Scalars['Boolean']['output']>;
  /** a filter for participants type */
  type?: Maybe<ParticipantTypeFilter>;
};

export type ParticipantsGroupBy = {
  groupByGoals: Scalars['Boolean']['input'];
  participantsGroupByProfileData?: InputMaybe<ParticipantsGroupByProfileData>;
};

export type ParticipantsGroupByProfileData = {
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule>>;
  preferredProgramId: Scalars['ID']['input'];
  preferredSource: ProfileAttributeSource;
  /** The id of the category to filter by */
  profileAttributeCategoryId?: InputMaybe<Scalars['MCID']['input']>;
  profileAttributeNumericValueGroups?: InputMaybe<Array<ProfileAttributeNumericValueGroup>>;
  profileAttributeType?: InputMaybe<ProfileAttributeType>;
};

export type ParticipantsMetrics = {
  __typename?: 'ParticipantsMetrics';
  totalCompletedSurveys: Array<Interval>;
  totalCredentialed: Array<Interval>;
  totalMatched: Array<Interval>;
  totalMatchingSurveyCompleted: Array<Interval>;
  totalRegistered: Array<Interval>;
  totalWantsMentorship: Array<Interval>;
};


export type ParticipantsMetricsTotalCompletedSurveysArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ParticipantsGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  surveyIds: Array<Scalars['ID']['input']>;
};


export type ParticipantsMetricsTotalCredentialedArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ParticipantsGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  useRegistrationDate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ParticipantsMetricsTotalMatchedArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ParticipantsGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
};


export type ParticipantsMetricsTotalMatchingSurveyCompletedArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ParticipantsGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
};


export type ParticipantsMetricsTotalRegisteredArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ParticipantsGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
};


export type ParticipantsMetricsTotalWantsMentorshipArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ParticipantsGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  wantsMentorshipAnswer: Scalars['Boolean']['input'];
};

export type ParticipantsProfileDataColumnInput = {
  attribute: UserProfileDataAttributeInput;
  columnName: Scalars['String']['input'];
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule>>;
  programId: Scalars['MCID']['input'];
  source: ProfileAttributeSource;
};

export type ParticipantsSort = {
  /** Which field to sort by */
  column: ParticipantsSortByField;
  direction: SortDirection;
  prioritizedForRematchFirst?: InputMaybe<Scalars['Boolean']['input']>;
  scoreCriteria?: InputMaybe<ScoreCriteria>;
};

export enum ParticipantsSortByField {
  ByBestMatchForStudentId = 'BY_BEST_MATCH_FOR_STUDENT_ID',
  CompletedMatchingSurveyAt = 'COMPLETED_MATCHING_SURVEY_AT',
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

export type Partner = {
  __typename?: 'Partner';
  /** Executive higher education department in which the partner works */
  executiveHigherEdRole?: Maybe<ExecutiveHigherEdRole>;
  /** Faculty higher education department in which the partner works */
  facultyHigherEdRole?: Maybe<FacultyHigherEdRole>;
  /** Category of higher education role the partner holds - staff, faculty or executive */
  higherEdCategory?: Maybe<HigherEdCategory>;
  /** Higher education department in which the partner works */
  higherEdRole?: Maybe<HigherEdRole>;
  /** The id */
  id: Scalars['ID']['output'];
  /** Type of organization at which the partner is employed */
  organizationType?: Maybe<OrganizationType>;
  /** The program sequence this partner belongs to */
  programSequence: ProgramSequence;
  /** Whether the partner is registered for the program sequence */
  registered: Scalars['Boolean']['output'];
  /** Staff higher education department in which the partner works */
  staffHigherEdRole?: Maybe<StaffHigherEdRole>;
  /** The user */
  user: User;
};

/** The connection type for Partner. */
export type PartnerConnection = {
  __typename?: 'PartnerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerEdge>>>;
  /** The collection of partner objects */
  nodes: Array<Partner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all partners in the collection */
  totalCount: Scalars['Int']['output'];
  /** The total count of distinct users in the collection */
  totalCountOfDistinctUsers: Scalars['Int']['output'];
};

export type PartnerDashboardExports = {
  __typename?: 'PartnerDashboardExports';
  conversations?: Maybe<CsvExport>;
  flags?: Maybe<CsvExport>;
  mentorships?: Maybe<CsvExport>;
  /** A CSV of participant profile data */
  users: CsvExport;
};


export type PartnerDashboardExportsConversationsArgs = {
  csvExportContext?: InputMaybe<CsvExportContextInput>;
  filter?: InputMaybe<ParticipantConversationContentsFilter>;
  profileDataColumns: Array<UserProfileDataColumnInput>;
  programId: Scalars['ID']['input'];
};


export type PartnerDashboardExportsFlagsArgs = {
  csvExportContext?: InputMaybe<CsvExportContextInput>;
  filter: FlagsFilter;
  profileDataColumns: Array<UserProfileDataColumnInput>;
};


export type PartnerDashboardExportsMentorshipsArgs = {
  csvExportContext?: InputMaybe<CsvExportContextInput>;
  exportType: MentorshipsExport;
  filter: MentorshipsFilter;
  includeTouchpointMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  profileDataColumns: Array<UserProfileDataColumnInput>;
  resultModifiers?: InputMaybe<MentorshipsExportResultModifiers>;
};


export type PartnerDashboardExportsUsersArgs = {
  csvExportContext: CsvExportContextInput;
  filter: UsersFilter;
  firstColumn?: InputMaybe<UsersExportFirstColumn>;
  profileDataColumns: Array<UserProfileDataColumnInput>;
  resultModifiers?: InputMaybe<UsersExportResultModifiers>;
};

/** An edge in a connection. */
export type PartnerEdge = {
  __typename?: 'PartnerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Partner>;
};

export type PartnerNotification = {
  __typename?: 'PartnerNotification';
  /** The id */
  id: Scalars['ID']['output'];
  /** The partner associated with this notification */
  partner: Partner;
  /** The program associated with this notification */
  program: Program;
  /** The MC Admin who triggered the notification to be sent */
  sender: User;
};

export type PartnersFilter = {
  /** filter partners not in specific programs */
  excludeProgramIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter for partners in specific programs */
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum Permission {
  CanEditTemplatePrograms = 'CAN_EDIT_TEMPLATE_PROGRAMS'
}

/** Autogenerated return type of PreviewMatchingSurvey. */
export type PreviewMatchingSurveyPayload = {
  __typename?: 'PreviewMatchingSurveyPayload';
  errors: Array<Error>;
  menteeSurvey?: Maybe<Scalars['JSON']['output']>;
  mentorSurvey?: Maybe<Scalars['JSON']['output']>;
  previewParticipantFromSameProgram?: Maybe<Scalars['Boolean']['output']>;
};

export type Profile = {
  __typename?: 'Profile';
  /** The id */
  id: Scalars['ID']['output'];
  /** Program specific questions answered by the user */
  programSpecificAttributes: Scalars['JSON']['output'];
};

export type ProfileAttribute = {
  __typename?: 'ProfileAttribute';
  /** The id */
  id: Scalars['ID']['output'];
  /** The name of the profile attribute */
  name: Scalars['String']['output'];
  /** The type of the profile attribute such as 'major' or 'first_name' */
  profileAttributeType?: Maybe<ProfileAttributeType>;
  /** The profile attribute values belonging to this attribute */
  profileAttributeValues: Array<ProfileAttributeValue>;
};

export type ProfileAttributeCategory = {
  __typename?: 'ProfileAttributeCategory';
  /** The id */
  id: Scalars['ID']['output'];
  /** The name of the mapping category */
  name: Scalars['String']['output'];
  /** The mapping items in this category */
  profileAttributeCategoryItems: Array<ProfileAttributeCategoryItem>;
};

export type ProfileAttributeCategoryItem = {
  __typename?: 'ProfileAttributeCategoryItem';
  /** The id */
  id: Scalars['ID']['output'];
  /** The name of the mapping category item */
  name: Scalars['String']['output'];
  /** The category this items belongs to */
  profileAttributeCategory: ProfileAttributeCategory;
};

export type ProfileAttributeNumericValueGroup = {
  exactNumericValue?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  maxNumericValue?: InputMaybe<Scalars['Float']['input']>;
  minNumericValue?: InputMaybe<Scalars['Float']['input']>;
};

export enum ProfileAttributeSource {
  Institution = 'institution',
  User = 'user'
}

export enum ProfileAttributeType {
  AboutMe = 'about_me',
  AcademicsFirstChoice = 'academics_first_choice',
  AcademicsSecondChoice = 'academics_second_choice',
  AdditionalInfo = 'additional_info',
  AdditionalInfoReasonsForVolunteering = 'additional_info_reasons_for_volunteering',
  BiggestChallenge = 'biggest_challenge',
  CareerInterest = 'career_interest',
  Challenge = 'challenge',
  CurrentStudentOrAlum = 'current_student_or_alum',
  Custom = 'custom',
  DesiredEnrollmentHelp = 'desired_enrollment_help',
  DesiredMentoringFrequency = 'desired_mentoring_frequency',
  Email = 'email',
  EnrollmentSchoolId = 'enrollment_school_id',
  FacebookUrl = 'facebook_url',
  FirstGenerationStatus = 'first_generation_status',
  FirstName = 'first_name',
  Gender = 'gender',
  Gpa = 'gpa',
  GraduationYear = 'graduation_year',
  Hobby = 'hobby',
  InstagramUrl = 'instagram_url',
  InstitutionalId = 'institutional_id',
  InternationalStudentStatus = 'international_student_status',
  IsEuCitizen = 'is_eu_citizen',
  IsUsCitizen = 'is_us_citizen',
  Language = 'language',
  LastName = 'last_name',
  LastReportedAge = 'last_reported_age',
  LastReportedGradeLevel = 'last_reported_grade_level',
  LastReportedSchoolPosition = 'last_reported_school_position',
  LinkedinUrl = 'linkedin_url',
  Major = 'major',
  MenteeRequestedAgeGap = 'mentee_requested_age_gap',
  MentorCapacity = 'mentor_capacity',
  MentorRequestedMenteeGender = 'mentor_requested_mentee_gender',
  OnlyMatchOlderMentors = 'only_match_older_mentors',
  Phone = 'phone',
  PrefersTransferMentor = 'prefers_transfer_mentor',
  ProfessionalExperience = 'professional_experience',
  RaceOrEthnicity = 'race_or_ethnicity',
  RequestedMentorBackground = 'requested_mentor_background',
  StrongestPreferenceDisplayValue = 'strongest_preference_display_value',
  StrongestPreferenceKey = 'strongest_preference_key',
  StrongestPreferenceOpenAnswer = 'strongest_preference_open_answer',
  StudentAdvisorEmail = 'student_advisor_email',
  StudentAdvisorFirstName = 'student_advisor_first_name',
  StudentAdvisorLastName = 'student_advisor_last_name',
  SupermentorOptIn = 'supermentor_opt_in',
  TransferStatus = 'transfer_status',
  TwitterUrl = 'twitter_url'
}

export type ProfileAttributeValue = {
  __typename?: 'ProfileAttributeValue';
  /** The id */
  id: Scalars['ID']['output'];
  /** The profile attribute to which this value belongs */
  profileAttribute: ProfileAttribute;
  /** The profile attribute value string */
  value: Scalars['String']['output'];
};

/** Profile Input */
export type ProfileInput = {
  gender?: InputMaybe<Gender>;
};

export type Program = {
  __typename?: 'Program';
  /** The program's account notes */
  accountNotes?: Maybe<Scalars['String']['output']>;
  /** If the program is still active or not */
  active: Scalars['Boolean']['output'];
  /** Activity logs for this program */
  activityLogs: ActivityLogConnection;
  /** Additional flag contact recipients */
  additionalFlagContactRecipients: Array<FlagContact>;
  /** Any program alert dismissals */
  alertDismissals: Array<ProgramAlertDismissal>;
  /** Is matching enabled */
  allowMatching: Scalars['Boolean']['output'];
  /** Is mentee registration open */
  allowMenteeSignUp: Scalars['Boolean']['output'];
  /** Is mentor registration open */
  allowMentorSignUp: Scalars['Boolean']['output'];
  /** Enables mentees to use a shorter registration version */
  allowsMenteesToPushThemselvesThroughToMatch: Scalars['Boolean']['output'];
  askForMenteeSidInSignup: Scalars['Boolean']['output'];
  /** Whether the program's mentee matching survey includes a question with qid 'strongest_preference' and the following profile attributes exist: strongest_preference_key and strongest_preference_display_value */
  asksStrongestPreferenceQuestionInMenteeMatchingSurveyAndProfileAttributesExist: Scalars['Boolean']['output'];
  /** Cohort tags describing the program, separately from segment */
  cohorts?: Maybe<Array<ProgramCohort>>;
  /** The communication medium or message type that is preferred for this program */
  communicationMediumPreference?: Maybe<Message>;
  /** The student contacts in the program */
  contacts: ContactConnection;
  /** Date created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** What phase is this program currently in? */
  currentPhase: ProgramPhase;
  /** What stage is this program currently in? */
  currentStage: ProgramStage;
  /** All custom matching message templates set for this program */
  customMessageTemplates?: Maybe<Array<ProgramCustomMessageTemplate>>;
  /** The default profile image for this program */
  defaultProfileImage?: Maybe<Scalars['String']['output']>;
  /** The end date */
  endDate: Scalars['ISO8601Date']['output'];
  /** Engagement benchmark data */
  engagementBenchmarkData?: Maybe<EngagementBenchmarkData>;
  /** URL for the Program Engagement Chart */
  engagementChartUrl?: Maybe<Scalars['String']['output']>;
  /** The first date in which a participant registers to the program */
  firstParticipantCreatedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The flag contact's email address */
  flagContactEmail?: Maybe<Scalars['String']['output']>;
  /** The flag contact's first name */
  flagContactFirstName?: Maybe<Scalars['String']['output']>;
  /** The flag contact's last name */
  flagContactLastName?: Maybe<Scalars['String']['output']>;
  /** The flag page visits in the program */
  flagPageVisits: FlagPageVisitConnection;
  /** Whether the program has matching surveys migrated from old framework */
  hasMatchingSuveysMigratedFromOldFramework: Scalars['Boolean']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** If this is a template program, just to be used internally */
  isTemplateProgram: Scalars['Boolean']['output'];
  /** If this is a test program, just to be used internally */
  isTestProgram: Scalars['Boolean']['output'];
  /** The maximum number of matches to make */
  matchingCap?: Maybe<Scalars['Int']['output']>;
  /** Date where the matching cap was reached */
  matchingCapReachedDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date where the matching goal was reached */
  matchingGoalReachedDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** What is the registration login mode defined for the mentee? */
  menteeLoginMode: ProgramMenteeLoginMode;
  /** The end of year assesment survey for mentors */
  mentorEndAssessmentSurvey?: Maybe<Survey>;
  /** What is the registration login mode defined for the mentor? */
  mentorLoginMode: ProgramMentorLoginMode;
  /** The matching survey for mentors */
  mentorMatchingSurvey: Survey;
  /** The mid year assesment survey for mentors */
  mentorMidAssessmentSurvey?: Maybe<Survey>;
  /** The opening assesment survey for mentors */
  mentorOpeningAssessmentSurvey?: Maybe<Survey>;
  /** The mentor point person's email */
  mentorPointPersonEmail?: Maybe<Scalars['String']['output']>;
  /** The mentor point person's first name */
  mentorPointPersonFirstName?: Maybe<Scalars['String']['output']>;
  /** The mentor point person's last name */
  mentorPointPersonLastName?: Maybe<Scalars['String']['output']>;
  /** The mentor point person's title */
  mentorPointPersonTitle?: Maybe<Scalars['String']['output']>;
  /** The post session survey for mentors */
  mentorPostSessionSurvey: Survey;
  /** The mentor training task */
  mentorTrainingTask?: Maybe<ProgramTask>;
  /** The type of mentors in this program */
  mentorType?: Maybe<MentorTypes>;
  /** The mentors in the program */
  mentors: ParticipantConnection;
  /** The mentorships in the program */
  mentorships: MentorshipConnection;
  /** The program name */
  name: Scalars['String']['output'];
  /** If non-priority emails for a program are turned on. */
  nonPriorityFlagEmailEnabled: Scalars['Boolean']['output'];
  /** The program's matching notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** The number of mentor slots available for matching */
  numberOfOpenMentorSlots: Scalars['Int']['output'];
  /** The PSM assigned to this program */
  partnerSuccessManager?: Maybe<User>;
  /** The PSO assigned to this program */
  partnerSuccessOperator?: Maybe<User>;
  /** The program assessment areas for this program */
  programAssessmentAreas: Array<ProgramAssessmentArea>;
  /** Custom labels for program */
  programCustomLabel?: Maybe<ProgramCustomLabel>;
  /** Any program flag categories belonging to this program */
  programFlagCategories?: Maybe<Array<ProgramFlagCategory>>;
  /** The goal created for this program */
  programGoal?: Maybe<ProgramGoal>;
  /** The program's info url */
  programInfoUrl?: Maybe<Scalars['String']['output']>;
  /** The logo for this program */
  programLogo?: Maybe<Scalars['String']['output']>;
  /** The program's attached program profile attribute values */
  programProfileAttributes: Array<ProgramProfileAttribute>;
  /** URL for the Recruitment and Onboarding dashboard */
  programRecruitmentAndOnboardingDashboardUrl?: Maybe<Scalars['String']['output']>;
  /** The program's resources */
  programResources: ProgramResourceConnection;
  /** The program sequence this program is in */
  programSequence: ProgramSequence;
  /** The program tasks */
  programTasks: Array<ProgramTask>;
  /** The records that represent the programs that are using this topic */
  programTopics: ProgramTopicConnection;
  /** Mentors recruited from past programs allowed to skip matching survey if they've taken it previously? */
  reRecruitedMentorsCanSkipMatchingSurvey: Scalars['Boolean']['output'];
  /** The program's required mentor training credential */
  requiredMentorTrainingCredential?: Maybe<Scalars['String']['output']>;
  resources: ResourceConnection;
  /** The Opportunity ID associated to this program in salesforce. */
  salesforceOpportunityId?: Maybe<Scalars['String']['output']>;
  /** URL for the Program Satisfaction Benchmark Chart */
  satisfactionBenchmarkChartUrl?: Maybe<Scalars['String']['output']>;
  /** The satisfaction report for the program in the last 30 days. */
  satisfactionReport: SatisfactionReport;
  /** The secondary flag CC email addresses */
  secondaryFlagContactCcEmails?: Maybe<Scalars['String']['output']>;
  /** The user segment this program addresses */
  segment: ProgramSegment;
  /** Whether to send flags to external contacts */
  sendFlagsToExternalContact: Scalars['Boolean']['output'];
  /** If SFTP exports are enabled for a program */
  sftpExportEnabled: Scalars['Boolean']['output'];
  /** the SFTP prefix for this program */
  sftpPrefix?: Maybe<Scalars['String']['output']>;
  /** Does the program allow mentee email to be shared with counterpart? */
  shareMenteeEmail: Scalars['Boolean']['output'];
  /** Does the program allow mentee phone to be shared with counterpart? */
  shareMenteePhone: Scalars['Boolean']['output'];
  /** Does the program allow mentor email to be shared with counterpart? */
  shareMentorEmail: Scalars['Boolean']['output'];
  /** Does the program allow mentor phone to be shared with counterpart? */
  shareMentorPhone: Scalars['Boolean']['output'];
  /** The program short name */
  shortName: Scalars['String']['output'];
  /** Whether or not to show the matching surveys to partners */
  showMatchingSurveysToPartner: Scalars['Boolean']['output'];
  /** Whether to show the flags table in the participant dashboard for mentors */
  showMentorsFlags: Scalars['Boolean']['output'];
  /** The start date */
  startDate: Scalars['ISO8601Date']['output'];
  /** The end of year assesment survey for students */
  studentEndAssessmentSurvey?: Maybe<Survey>;
  /** A list of the key/human readable values for the goals selected by students in the program */
  studentGoalsList?: Maybe<Array<StudentGoalsList>>;
  /** The matching survey for students */
  studentMatchingSurvey: Survey;
  /** The mid year assesment survey for students */
  studentMidAssessmentSurvey?: Maybe<Survey>;
  /** The opening assesment survey for students */
  studentOpeningAssessmentSurvey?: Maybe<Survey>;
  /** The student point person's email */
  studentPointPersonEmail?: Maybe<Scalars['String']['output']>;
  /** The student point person's first name */
  studentPointPersonFirstName?: Maybe<Scalars['String']['output']>;
  /** The student point person's last name */
  studentPointPersonLastName?: Maybe<Scalars['String']['output']>;
  /** The student point person's title */
  studentPointPersonTitle?: Maybe<Scalars['String']['output']>;
  /** The post session survey for students */
  studentPostSessionSurvey: Survey;
  /** The students in the program */
  students: ParticipantConnection;
  /** The program title */
  title: Scalars['String']['output'];
  /** The training mode for the program's training task: live or on_demand */
  trainingMode?: Maybe<ProgramTrainingMode>;
  /** The URD assigned to this program */
  universityRelationsDirector?: Maybe<User>;
  /** If the program uses the new communication system */
  usesNewCommunications: Scalars['Boolean']['output'];
};


export type ProgramActivityLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ActivityLogsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ActivityLogsSort>;
};


export type ProgramContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ContactsSort>;
};


export type ProgramFlagPageVisitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<FlagPageVisitsSort>;
};


export type ProgramMentorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ParticipantsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ParticipantsSort>;
};


export type ProgramMentorshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MentorshipsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MentorshipsSort>;
};


export type ProgramProgramResourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProgramProgramTasksArgs = {
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramProgramTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProgramTopicsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProgramTopicsSort>;
};


export type ProgramResourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProgramResourcesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ResourcesSort>;
};


export type ProgramStudentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ParticipantsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ParticipantsSort>;
};

export type ProgramAlertDismissal = {
  __typename?: 'ProgramAlertDismissal';
  /** Any extra metadata for the alert that was dismissed */
  alertMetadata?: Maybe<Scalars['JSON']['output']>;
  /** The alert type (unique within a program) */
  alertTypeIdentifier: Scalars['String']['output'];
  /** The user who dismissed the alert */
  dismissedBy: User;
  /** The id */
  id: Scalars['ID']['output'];
  /** When the alert should become active again (if null, the alert is permanently dismissed) */
  snoozeUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Program alert dismissal input */
export type ProgramAlertDismissalInput = {
  /** Any extra metadata for the alert */
  alertMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The unique identifier for this alert type */
  alertTypeIdentifier: Scalars['String']['input'];
  /** The program we're dismissing the alert for */
  programId: Scalars['ID']['input'];
  /** When the alert should become active again (if null, the alert is permanently dismissed) */
  snoozeUntil?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type ProgramAssessmentArea = {
  __typename?: 'ProgramAssessmentArea';
  /** The assessment area for this program */
  assessmentArea: AssessmentArea;
  /** Whether this assessment area is enabled for mentees */
  enabledForMentees: Scalars['Boolean']['output'];
  /** Whether this assessment area is enabled for mentors */
  enabledForMentors: Scalars['Boolean']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The likert scale maximum value */
  scaleMax: Scalars['Int']['output'];
  /** The likert scale minimum value */
  scaleMin: Scalars['Int']['output'];
};

export type ProgramAutomatchingConfiguration = {
  __typename?: 'ProgramAutomatchingConfiguration';
  /** When this configuration was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The program of the saved automatching configuration */
  program: Program;
  /** The settings used to make suggestions */
  settings: SuggestedBatchSettings;
  /** Admin who performed the action */
  shearwaterAdministrator: ShearwaterAdministrator;
  /** When this batch was updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ProgramAutomatchingDefault = {
  __typename?: 'ProgramAutomatchingDefault';
  /** The automatching default setting */
  automatchingDefault: AutomatchingDefault;
  /** Date created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The program using the automatching setting */
  program: Program;
  /** The admin saving the setting */
  shearwaterAdministrator: ShearwaterAdministrator;
  /** Date updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum ProgramCohort {
  Grad = 'grad',
  Hbcu = 'hbcu',
  Hsi = 'hsi',
  Sophomore = 'sophomore',
  TwoYear = 'two_year'
}

/** The connection type for Program. */
export type ProgramConnection = {
  __typename?: 'ProgramConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProgramEdge>>>;
  /** The collection of program objects */
  nodes: Array<Program>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all programs in the collection */
  totalCount: Scalars['Int']['output'];
};

export type ProgramCustomLabel = {
  __typename?: 'ProgramCustomLabel';
  /** The id */
  id: Scalars['ID']['output'];
  /** The custom label for Mentees */
  pluralMentee?: Maybe<Scalars['String']['output']>;
  /** The custom label for Mentors */
  pluralMentor?: Maybe<Scalars['String']['output']>;
  /** The custom label for Mentorships */
  pluralMentorship?: Maybe<Scalars['String']['output']>;
  /** The custom label for Schools */
  pluralSchool?: Maybe<Scalars['String']['output']>;
  /** The custom label for Students */
  pluralStudent?: Maybe<Scalars['String']['output']>;
  /** The program this belongs to */
  program: Program;
  /** Flag that determines if uppercase should be respected for Mentee label */
  respectMenteeUppercase?: Maybe<Scalars['Boolean']['output']>;
  /** Flag that determines if uppercase should be respected for Mentor label */
  respectMentorUppercase?: Maybe<Scalars['Boolean']['output']>;
  /** Flag that determines if uppercase should be respected for Mentorship label */
  respectMentorshipUppercase?: Maybe<Scalars['Boolean']['output']>;
  /** Flag that determines if uppercase should be respected for School label */
  respectSchoolUppercase?: Maybe<Scalars['Boolean']['output']>;
  /** Flag that determines if uppercase should be respected for Student label */
  respectStudentUppercase?: Maybe<Scalars['Boolean']['output']>;
  /** The custom label for Mentee */
  singularMentee?: Maybe<Scalars['String']['output']>;
  /** The custom label for a Mentee */
  singularMenteeWithIndeterminateArticle?: Maybe<Scalars['String']['output']>;
  /** The custom label for Mentor */
  singularMentor?: Maybe<Scalars['String']['output']>;
  /** The custom label for a Mentor */
  singularMentorWithIndeterminateArticle?: Maybe<Scalars['String']['output']>;
  /** The custom label for Mentorship */
  singularMentorship?: Maybe<Scalars['String']['output']>;
  /** The custom label for a Mentorship */
  singularMentorshipWithIndeterminateArticle?: Maybe<Scalars['String']['output']>;
  /** The custom label for School */
  singularSchool?: Maybe<Scalars['String']['output']>;
  /** The custom label for a School */
  singularSchoolWithIndeterminateArticle?: Maybe<Scalars['String']['output']>;
  /** The custom label for Student */
  singularStudent?: Maybe<Scalars['String']['output']>;
  /** The custom label for a Student */
  singularStudentWithIndeterminateArticle?: Maybe<Scalars['String']['output']>;
};

export enum ProgramCustomMessage {
  MenteeEmailStandardMatch = 'MENTEE_EMAIL_STANDARD_MATCH',
  MenteeEmailSupermentorMatch = 'MENTEE_EMAIL_SUPERMENTOR_MATCH',
  MenteeSmsInitiateP2PRelay = 'MENTEE_SMS_INITIATE_P2P_RELAY',
  MenteeSmsP2PRelayFollowUp = 'MENTEE_SMS_P2P_RELAY_FOLLOW_UP',
  MentorEmailAddMenteesToGroup = 'MENTOR_EMAIL_ADD_MENTEES_TO_GROUP',
  MentorEmailStandardGroupMatch = 'MENTOR_EMAIL_STANDARD_GROUP_MATCH',
  MentorEmailStandardIndividualMatch = 'MENTOR_EMAIL_STANDARD_INDIVIDUAL_MATCH',
  MentorEmailSupermentorMatch = 'MENTOR_EMAIL_SUPERMENTOR_MATCH',
  MentorSmsAddMenteesToP2GRelay = 'MENTOR_SMS_ADD_MENTEES_TO_P2G_RELAY',
  MentorSmsInitiateP2GRelay = 'MENTOR_SMS_INITIATE_P2G_RELAY',
  MentorSmsInitiateP2PRelay = 'MENTOR_SMS_INITIATE_P2P_RELAY',
  MentorSmsP2PRelayFollowUp = 'MENTOR_SMS_P2P_RELAY_FOLLOW_UP'
}

export type ProgramCustomMessageTemplate = {
  __typename?: 'ProgramCustomMessageTemplate';
  /** When the customizaton was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The custom message type ex. mentor email standard match */
  customMessageType: ProgramCustomMessage;
  /** The id */
  id: Scalars['ID']['output'];
  /** The message template */
  messageTemplate: MessageTemplate;
  /** The program */
  program: Program;
  /** When the customization was updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** An edge in a connection. */
export type ProgramEdge = {
  __typename?: 'ProgramEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Program>;
};

export type ProgramFlagCategory = {
  __typename?: 'ProgramFlagCategory';
  /** The display name */
  customDisplayName: Scalars['String']['output'];
  /** The custom SMS character */
  customSmsCharacter?: Maybe<Scalars['String']['output']>;
  flagCategory: FlagCategory;
  /** The id */
  id: Scalars['ID']['output'];
  /** The visibility of the flag in the program */
  isVisible: Scalars['Boolean']['output'];
};

export type ProgramGoal = {
  __typename?: 'ProgramGoal';
  /** The id */
  id: Scalars['ID']['output'];
  /** The Program this goal belongs to */
  program: Program;
  /** The goal target */
  target: Scalars['Int']['output'];
  /** The type of goal */
  type: ProgramGoalTypes;
};

export enum ProgramGoalTypes {
  ConversationsReported = 'CONVERSATIONS_REPORTED',
  MentorsMatched = 'MENTORS_MATCHED',
  MentorsRegistered = 'MENTORS_REGISTERED',
  PairsWithAtLeastOneConversation = 'PAIRS_WITH_AT_LEAST_ONE_CONVERSATION',
  StudentsMatched = 'STUDENTS_MATCHED',
  StudentsRegistered = 'STUDENTS_REGISTERED'
}

export enum ProgramGoalWithNoGoalTypes {
  ConversationsReported = 'CONVERSATIONS_REPORTED',
  MentorsMatched = 'MENTORS_MATCHED',
  MentorsRegistered = 'MENTORS_REGISTERED',
  NoGoal = 'NO_GOAL',
  PairsWithAtLeastOneConversation = 'PAIRS_WITH_AT_LEAST_ONE_CONVERSATION',
  StudentsMatched = 'STUDENTS_MATCHED',
  StudentsRegistered = 'STUDENTS_REGISTERED'
}

export enum ProgramMenteeLoginMode {
  McLogin = 'MC_LOGIN',
  SsoLogin = 'SSO_LOGIN'
}

export enum ProgramMentorLoginMode {
  McLogin = 'MC_LOGIN',
  SsoLogin = 'SSO_LOGIN'
}

export enum ProgramNotAbleToBeDeletedError {
  /** This program has additional flag contact recipients */
  ProgramHasAdditionalFlagContactRecipients = 'PROGRAM_HAS_ADDITIONAL_FLAG_CONTACT_RECIPIENTS',
  /** This program has contacts */
  ProgramHasContacts = 'PROGRAM_HAS_CONTACTS',
  /** This program has mentors */
  ProgramHasMentors = 'PROGRAM_HAS_MENTORS',
  /** This program has students */
  ProgramHasStudents = 'PROGRAM_HAS_STUDENTS'
}

/** Represents a visit to the activity page of a program */
export type ProgramPageVisit = {
  __typename?: 'ProgramPageVisit';
  /** The timestamp for when the visit occurred */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The path of the page that was visited */
  path: Scalars['String']['output'];
  /** The program related to this page visit */
  program: Program;
  /** The user */
  user: User;
};

export enum ProgramPhase {
  Engagement = 'ENGAGEMENT',
  Matching = 'MATCHING',
  PreLaunch = 'PRE_LAUNCH',
  Recruitment = 'RECRUITMENT'
}

export type ProgramProfileAttribute = {
  __typename?: 'ProgramProfileAttribute';
  /** Whether this attribute displays in exports for this program on the partner dashboard */
  availableInPartnerDashboardExports: Scalars['Boolean']['output'];
  /** Whether this attribute displays in filters for this program on the partner dashboard */
  availableInPartnerDashboardFilters: Scalars['Boolean']['output'];
  /** Whether this attribute displays in the program intelligence chart for this program on the partner dashboard */
  availableInPartnerDashboardProgramIntelligenceChart: Scalars['Boolean']['output'];
  /** The segment default settings for the associated profile attribute, if it exists */
  defaultSettings?: Maybe<ProgramProfileAttributeDefaultSettings>;
  /** The id */
  id: Scalars['ID']['output'];
  /** The profile data profile attribute */
  profileAttribute: ProfileAttribute;
};

export type ProgramProfileAttributeCategoryResult = {
  __typename?: 'ProgramProfileAttributeCategoryResult';
  /** The profile attribute that was found */
  profileAttribute: ProfileAttribute;
  /** Any mapping profile attribute categories tied to the found profile attribute */
  profileAttributeCategories: Array<ProfileAttributeCategory>;
};

export type ProgramProfileAttributeDefaultSettings = {
  __typename?: 'ProgramProfileAttributeDefaultSettings';
  /** Whether this attribute displays in exports for this program on the partner dashboard */
  availableInPartnerDashboardExports: Scalars['Boolean']['output'];
  /** Whether this attribute displays in filters for this program on the partner dashboard */
  availableInPartnerDashboardFilters: Scalars['Boolean']['output'];
  /** Whether this attribute displays in the program intelligence chart for this program on the partner dashboard */
  availableInPartnerDashboardProgramIntelligenceChart: Scalars['Boolean']['output'];
  /** The default name applied to this attribute by the ProgramProfileAttributesCreator for the associated segment */
  name?: Maybe<Scalars['String']['output']>;
};

export type ProgramProfileAttributeUnableToBeUpdated = {
  __typename?: 'ProgramProfileAttributeUnableToBeUpdated';
  /** Any errors trying to update the program profile attribute */
  errors: Array<ProgramProfileAttributeUpdateError>;
  /** The id of the program profile attribute that could not be updated */
  programProfileAttributeId: Scalars['MCID']['output'];
};

export enum ProgramProfileAttributeUpdateError {
  /** The name cannot exceed 60 characters */
  NameExceedsCharacterLimit = 'NAME_EXCEEDS_CHARACTER_LIMIT'
}

export type ProgramResource = {
  __typename?: 'ProgramResource';
  /** The id */
  id: Scalars['ID']['output'];
  /** The resource title */
  title: Scalars['String']['output'];
  /** Date added */
  uploadedAt: Scalars['ISO8601DateTime']['output'];
  /** The resource URL */
  url: Scalars['String']['output'];
  /** The user who uploaded the resource */
  user: User;
};

/** The connection type for ProgramResource. */
export type ProgramResourceConnection = {
  __typename?: 'ProgramResourceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProgramResourceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProgramResource>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProgramResourceEdge = {
  __typename?: 'ProgramResourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProgramResource>;
};

export type ProgramResourcesFilter = {
  /** Filter by goal identifiers */
  goalIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter by ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by resource type */
  resourceTypes?: InputMaybe<Array<ResourceType>>;
  /** filter by a search term */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** filter by topic ids */
  topicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProgramResourcesTopicsFilter = {
  /** filter by archived true/false */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return topics that are attached to a resource */
  attachedToResource?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return topics that are attached to a resource linked to a program */
  attachedToResourcesWithProgramIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by resource ids */
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum ProgramSegment {
  AdultOnline = 'ADULT_ONLINE',
  Career = 'CAREER',
  Corporate = 'CORPORATE',
  Enrollment = 'ENROLLMENT',
  Fye = 'FYE'
}

export type ProgramSequence = {
  __typename?: 'ProgramSequence';
  /** Possible flag categories for a mentor to flag about their mentee including their Ids */
  flagCategories: Array<FlagCategory>;
  /** The higher ed segment of the program sequence */
  higherEdSegment?: Maybe<ProgramSegment>;
  /** The id */
  id: Scalars['ID']['output'];
  /** The kind of program sequence */
  kind: ProgramSequenceKindTypes;
  /** Mentee quiz task */
  menteeQuizTask?: Maybe<TakeExternalLinkTask>;
  /** The mentee recruitment link for this program sequence */
  menteeRecruitmentLink: Scalars['String']['output'];
  /** The matching survey for mentors */
  mentorMatchingSurvey: Survey;
  /** The mentor recruitment link for this program sequence */
  mentorRecruitmentLink: Scalars['String']['output'];
  /** The program sequence name */
  name: Scalars['String']['output'];
  /** All of the partner records for this program sequence */
  partners: Array<Partner>;
  /** The programs in the program sequence */
  programs: Array<Program>;
  /** The school this program sequence belongs to */
  school: School;
  /** The matching survey for students */
  studentMatchingSurvey: Survey;
  /** The url slug for the program sequence */
  urlSlug: Scalars['String']['output'];
};


export type ProgramSequencePartnersArgs = {
  registered?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for ProgramSequence. */
export type ProgramSequenceConnection = {
  __typename?: 'ProgramSequenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProgramSequenceEdge>>>;
  /** The collection of program sequence objects */
  nodes: Array<ProgramSequence>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all program sequences in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProgramSequenceEdge = {
  __typename?: 'ProgramSequenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProgramSequence>;
};

export enum ProgramSequenceKindTypes {
  HighSchool = 'HIGH_SCHOOL',
  University = 'UNIVERSITY'
}

export enum ProgramSequenceNotAbleToBeDeletedError {
  /** This program sequence has associated programs */
  ProgramSequenceHasPrograms = 'PROGRAM_SEQUENCE_HAS_PROGRAMS'
}

export type ProgramSequencesFilter = {
  /** Program Sequence ids to filter by */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** School ids to filter by */
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by a search term */
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramSequencesSort = {
  /** Which field to sort by */
  column: ProgramSequencesSortByField;
  direction: SortDirection;
};

export enum ProgramSequencesSortByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export enum ProgramStage {
  End = 'END',
  Mid = 'MID',
  Post = 'POST',
  Pre = 'PRE',
  Start = 'START'
}

export type ProgramTask = {
  __typename?: 'ProgramTask';
  /** The id of this program task (different than the id of the task itself, which can be shared between programs) */
  id: Scalars['ID']['output'];
  /** The order of this task */
  position: Scalars['Int']['output'];
  /** The program sequence this task is in */
  programSequence: ProgramSequence;
  /** If true, this task MUST be completed as a participant in this program. Otherwise we will check to see if the participant had completed this task an another program */
  programSpecific: Scalars['Boolean']['output'];
  /** Does this task need to be completed, or is it optional? */
  required: Scalars['Boolean']['output'];
  /** The task to be completed by a participant */
  task: Task;
  /** To be marked complete, what role must the participant perform the task as? */
  toBeCompletedAs: TaskParticipantRole;
};

export type ProgramTopic = {
  __typename?: 'ProgramTopic';
  /** Whether or not we should send any messages from this program outreach topic */
  active: Scalars['Boolean']['output'];
  /** The hours to delay before restarting a recurring campaign, defaults to 0 */
  delayBeforeRestart: Scalars['Int']['output'];
  /** The program topic end date */
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The number of hours since the last message to wait before sending another message */
  hoursBetweenOutreach: Scalars['Int']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The timestamp for when the program topic was last edited */
  lastEditedAt: Scalars['ISO8601DateTime']['output'];
  /** The name of the program topic, used for naming 'bulk message' program topics */
  name?: Maybe<Scalars['String']['output']>;
  /** The program this belongs to */
  program: Program;
  /** The program topic start date */
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The topic this belongs to */
  topic: Topic;
};

/** The connection type for ProgramTopic. */
export type ProgramTopicConnection = {
  __typename?: 'ProgramTopicConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProgramTopicEdge>>>;
  /** The collection of program topic objects */
  nodes: Array<ProgramTopic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all program topics in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProgramTopicEdge = {
  __typename?: 'ProgramTopicEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProgramTopic>;
};

export enum ProgramTopicNotAbleToBeDeletedError {
  /** This program topic is a bulk message that is completed */
  BulkMessageIsCompleted = 'BULK_MESSAGE_IS_COMPLETED',
  /** This program topic is a bulk message that is in progress */
  BulkMessageIsInProgress = 'BULK_MESSAGE_IS_IN_PROGRESS'
}

export enum ProgramTopicStatusField {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Scheduled = 'SCHEDULED'
}

export type ProgramTopicsFilter = {
  /** filter by topic category */
  categories?: InputMaybe<Array<TopicCategory>>;
  /** filter by topic status */
  status?: InputMaybe<ProgramTopicStatusField>;
};

export type ProgramTopicsSort = {
  /** Which field to sort by */
  column: ProgramTopicsSortByField;
  direction: SortDirection;
};

export enum ProgramTopicsSortByField {
  CampaignName = 'CAMPAIGN_NAME',
  LastEditedAt = 'LAST_EDITED_AT',
  Name = 'NAME'
}

export enum ProgramTrainingMode {
  Live = 'LIVE',
  OnDemand = 'ON_DEMAND'
}

export type ProgramsFilter = {
  /** Filter by active status */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter for programs that allow matching */
  allowMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter for programs in specific higher ed segment */
  higherEdSegment?: InputMaybe<ProgramSegment>;
  /** Program ids to filter by */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter for template programs */
  isTemplateProgram?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for programs managed by specific PSMs */
  partnerSuccessManagerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter for programs operated by specific PSOs */
  partnerSuccessOperatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Program sequences to filter by */
  programSequenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** School id to filter by */
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  /** filter by a search term */
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramsSort = {
  /** Which field to sort by */
  column: ProgramsSortByField;
  direction: SortDirection;
};

export enum ProgramsSortByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME'
}

export enum PublicOrPrivate {
  Private = 'private',
  Public = 'public'
}

export type Query = {
  __typename?: 'Query';
  /** A tracked admin */
  adminAction: AdminAction;
  /** Tracked admin actions */
  adminActions: AdminActionConnection;
  /** Assessment Areas for a given survey */
  assessmentAreasForSurvey: Array<AssessmentArea>;
  /** All automatching default settings for various program segments */
  automatchingDefaults: Array<AutomatchingDefault>;
  /** Query all contacts */
  contacts: ContactConnection;
  /** Possible conversation topics between a student and mentor - returns full category type */
  conversationTopicCategories: Array<ParticipantConversationCategory>;
  /** Possible conversation topics between a student and mentor */
  conversationTopics: Array<ConversationTopic>;
  /** Query a country by ID */
  country: Country;
  /** Course */
  course: Course;
  /** Courses */
  courses: CourseConnection;
  /** CSV Exports accessible via GraphQL */
  csvExports: CsvExports;
  /** Message template requirements for a given custom message type */
  customMessageTypeTemplateRequirements: CustomMessageTypeTemplateRequirementConnection;
  /** List of deregistration reasons */
  deregistrationReasons: DeregistrationReasonConnection;
  /** flag categories for a mentor to flag about their mentee */
  flagCategories: Array<FlagCategory>;
  /** Flag contacts for a given program */
  flagContacts: Array<FlagContact>;
  /** Flags */
  flags: FlagConnection;
  /** Query a matching label by ID */
  matchingLabel: MatchingLabel;
  /** Query a mentor by ID */
  mentor: Mentor;
  /** Query a mentorship by ID */
  mentorship: Mentorship;
  /** The mentorships in the program */
  mentorships: MentorshipConnection;
  /** A single message template */
  messageTemplate: MessageTemplate;
  /** All message template tags */
  messageTemplateTags: MessageTemplateTagConnection;
  /** All message templates */
  messageTemplates: MessageTemplateConnection;
  /** Queryable metrics related to our data. These are related to, but separate from, our actual data-models - so they live in a separate part of the schema */
  metrics: QueryableMetrics;
  /** A micro survey */
  microSurvey: MicroSurvey;
  /** Micro surveys */
  microSurveys: MicroSurveyConnection;
  /** New Program Task */
  newProgramTask: NewProgramTask;
  /** New Program Tasks */
  newProgramTasks: NewProgramTaskConnection;
  /** New Task */
  newTask: NewTask;
  /** New Tasks */
  newTasks: NewTaskConnection;
  /** A single campaign, or Outreach topic */
  outreachTopic: Topic;
  /** Outreach topics, also known as campaigns */
  outreachTopicCollections: Array<TopicCollection>;
  /** Outreach topics, also known as campaigns */
  outreachTopics: TopicConnection;
  /** Query a participant by ID */
  participant: Participant;
  /** List of available Participant Conversation Categories for a program */
  participantConversationCategories: Array<ParticipantConversationCategory>;
  /** Participant conversation contents */
  participantConversationContents: ParticipantConversationContentConnection;
  /** The goals that a participant can choose from */
  participantGoals: GoalConnection;
  /** Query all participants */
  participants: ParticipantConnection;
  /** Query a partner by ID */
  partner: Partner;
  /** Query all partners */
  partners: PartnerConnection;
  /** Query a program by ID */
  program: Program;
  /** Most recently saved automatching configuration for a given program */
  programAutomatchingConfiguration?: Maybe<ProgramAutomatchingConfiguration>;
  /** Program default automatching settings */
  programAutomatchingDefault: ProgramAutomatchingDefault;
  /** Handlebars compiled texts for program */
  programCompiledTexts: Array<Scalars['String']['output']>;
  /** A query to find any relevant profile attributes for a program, and their associated mapping categories */
  programProfileAttributeCategories: Array<ProgramProfileAttributeCategoryResult>;
  /** A list of all program sequences */
  programSequences: ProgramSequenceConnection;
  /** Query a ProgramTopic by ID */
  programTopic: ProgramTopic;
  /** A list of all programs */
  programs: ProgramConnection;
  /** Resource */
  resource?: Maybe<Resource>;
  /** Topics or tags that can be applied to resources */
  resourceTopics: ResourceTopicConnection;
  /** Get resources */
  resources: ResourceConnection;
  /** A saved match */
  savedMatch: SavedMatch;
  /** Saved matches */
  savedMatches: SavedMatchConnection;
  /** School */
  school: School;
  /** Schools */
  schools: SchoolConnection;
  /** SFTP CSV Exports accessible via GraphQL */
  sftpCsvExports: SftpCsvExports;
  /** A list of SFTP related AWS S3 objects */
  sftpS3Objects?: Maybe<Array<S3Object>>;
  /** A single skeleton message template */
  skeletonMessageTemplate: SkeletonMessageTemplate;
  /** All skeleton message templates */
  skeletonMessageTemplates: SkeletonMessageTemplateConnection;
  /** Query a state machine by ID */
  stateMachine: StateMachine;
  /** A list of all state machines */
  stateMachines: StateMachineConnection;
  /** Query a student by ID */
  student: Student;
  /** A suggested batch */
  suggestedBatch: SuggestedBatch;
  /** List of suggested batches */
  suggestedBatches: SuggestedBatchConnection;
  /** A suggested match */
  suggestedMatch: SuggestedMatch;
  /** Suggested matches */
  suggestedMatches: SuggestedMatchConnection;
  /** Query a survey by ID */
  survey: Survey;
  /** Queries for a list of restricted options for a question */
  surveyQuestionRestrictedOptions: SurveyQuestionRestrictedOptionConnection;
  /** Queries all the responses of a survey by ID */
  surveyResponses?: Maybe<SurveyResponseConnection>;
  /** A list of all surveys (using the NEW survey framwork) */
  surveys: SurveyConnection;
  /** All of the assigned tasks for this user */
  taskAssignments: Array<TaskAssignment>;
  /** Tasks */
  tasks: TaskConnection;
  /** Uploaded Videos */
  uploadedVideos: UploadedVideoConnection;
  /** Query a user by ID */
  user: User;
  /** User state variables */
  userStateVariables: Array<UserStateVariable>;
  /** A list of all users */
  users: UserConnection;
  /** Queryable metrics related to our data warehouse. */
  warehouseMetrics: DwhQueryableMetrics;
  /** Written Messages */
  writtenMessages: WrittenMessageConnection;
};


export type QueryAdminActionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminActionsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AdminActionsSort>;
};


export type QueryAssessmentAreasForSurveyArgs = {
  surveyId: Scalars['ID']['input'];
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConversationTopicCategoriesArgs = {
  segment: ProgramSegment;
};


export type QueryConversationTopicsArgs = {
  programId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  segment: ProgramSegment;
};


export type QueryCountryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCourseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCoursesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CoursesSort>;
};


export type QueryCustomMessageTypeTemplateRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDeregistrationReasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFlagCategoriesArgs = {
  filter?: InputMaybe<FlagCategoryFilter>;
};


export type QueryFlagContactsArgs = {
  programId: Scalars['ID']['input'];
};


export type QueryFlagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FlagsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  programId: Scalars['ID']['input'];
  sort?: InputMaybe<FlagsSort>;
};


export type QueryMatchingLabelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMentorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMentorshipArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMentorshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MentorshipsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MentorshipsSort>;
};


export type QueryMessageTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessageTemplateTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMessageTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MessageTemplatesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MessageTemplatesSort>;
};


export type QueryMicroSurveyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMicroSurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MicroSurveysFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MicroSurveysSort>;
};


export type QueryNewProgramTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewProgramTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<NewProgramTasksFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<NewProgramTasksSort>;
};


export type QueryNewTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<NewTasksFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<NewTasksSort>;
};


export type QueryOutreachTopicArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOutreachTopicCollectionsArgs = {
  filters: Array<TopicCollectionInput>;
};


export type QueryOutreachTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TopicsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TopicsSort>;
};


export type QueryParticipantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryParticipantConversationCategoriesArgs = {
  programId: Scalars['ID']['input'];
};


export type QueryParticipantConversationContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ParticipantConversationContentsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  programId: Scalars['ID']['input'];
  sort?: InputMaybe<ParticipantConversationContentsSort>;
};


export type QueryParticipantGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GoalsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GoalsSort>;
};


export type QueryParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ParticipantsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ParticipantsSort>;
};


export type QueryPartnerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartnersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProgramArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramAutomatchingConfigurationArgs = {
  programId: Scalars['ID']['input'];
};


export type QueryProgramAutomatchingDefaultArgs = {
  programId: Scalars['ID']['input'];
};


export type QueryProgramCompiledTextsArgs = {
  originalTexts: Array<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
};


export type QueryProgramProfileAttributeCategoriesArgs = {
  programId: Scalars['MCID']['input'];
};


export type QueryProgramSequencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProgramSequencesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProgramSequencesSort>;
};


export type QueryProgramTopicArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProgramsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProgramsSort>;
};


export type QueryResourceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResourceTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProgramResourcesTopicsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ResourceTopicsSort>;
};


export type QueryResourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ResourcesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ResourcesSort>;
};


export type QuerySavedMatchArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySavedMatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SavedMatchesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SavedMatchesSort>;
};


export type QuerySchoolArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySchoolsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SchoolsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SchoolsSort>;
};


export type QuerySftpS3ObjectsArgs = {
  awsUsername: Scalars['String']['input'];
  programNamePrefix: Scalars['String']['input'];
};


export type QuerySkeletonMessageTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySkeletonMessageTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStateMachineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStateMachinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStudentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySuggestedBatchArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySuggestedBatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: SuggestedBatchFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SuggestedBatchSort>;
};


export type QuerySuggestedMatchArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySuggestedMatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SuggestedMatchesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SuggestedMatchesSort>;
};


export type QuerySurveyArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySurveyQuestionRestrictedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  qid: Scalars['String']['input'];
};


export type QuerySurveyResponsesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SurveyResponsesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SurveysFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaskAssignmentsArgs = {
  participantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};


export type QueryTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TasksFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUploadedVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UploadedVideoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UploadedVideoSort>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserStateVariablesArgs = {
  filterList?: InputMaybe<UserStateFilter>;
  userState: UserState;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UsersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UsersSort>;
};


export type QueryWrittenMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WrittenMessageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<WrittenMessageSort>;
};

export type QueryableMetrics = {
  __typename?: 'QueryableMetrics';
  assessmentScoreResponses: AssessmentScoreResponsesMetrics;
  contacts: ContactsMetrics;
  disengagementResolutions: Array<DisengagementResolutionsMetricsResult>;
  disengagementResolutionsAverageTimeToRematch?: Maybe<DisengagementResolutionsAverageTimeToRematchResult>;
  flags: FlagsMetrics;
  mentorships: MentorshipsMetrics;
  participants: ParticipantsMetrics;
  recruitmentOpportunities: Array<RecruitmentOpportunitiesMetricsResult>;
  users: UsersMetrics;
};


export type QueryableMetricsAssessmentScoreResponsesArgs = {
  filter: AssessmentScoreResponsesFilter;
};


export type QueryableMetricsContactsArgs = {
  filter?: InputMaybe<ContactsFilter>;
};


export type QueryableMetricsDisengagementResolutionsArgs = {
  disengagementEventDateFilter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  programId: Scalars['ID']['input'];
};


export type QueryableMetricsDisengagementResolutionsAverageTimeToRematchArgs = {
  disengagementEventDateFilter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  programId: Scalars['ID']['input'];
};


export type QueryableMetricsFlagsArgs = {
  filter?: InputMaybe<FlagsFilter>;
};


export type QueryableMetricsMentorshipsArgs = {
  filter?: InputMaybe<MentorshipsFilter>;
};


export type QueryableMetricsParticipantsArgs = {
  filter?: InputMaybe<ParticipantsFilter>;
};


export type QueryableMetricsRecruitmentOpportunitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mentorsUsersFilter: UsersFilter;
  opportunityArea: OpportunityArea;
  studentsUsersFilter: UsersFilter;
};


export type QueryableMetricsUsersArgs = {
  filter?: InputMaybe<UsersFilter>;
};

/** Customizations for matching survey questions (options and prompt) */
export type QuestionCustomizationsInput = {
  /** The prompt to display for the mentee question */
  menteeQuestionPrompt: Scalars['String']['input'];
  /** The prompt to display for the mentor question */
  mentorQuestionPrompt: Scalars['String']['input'];
  /** The list of options enabled for a question */
  options?: InputMaybe<Array<SurveyQuestionOptionInput>>;
};

export type QuestionWeight = {
  __typename?: 'QuestionWeight';
  qid: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

/** Input for question custom weight */
export type QuestionWeightInput = {
  qid: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

/** Autogenerated return type of ReactivateProgramAlert. */
export type ReactivateProgramAlertPayload = {
  __typename?: 'ReactivateProgramAlertPayload';
  /** The updated program */
  program: Program;
};

export type RecruitmentOpportunitiesMetricsResult = {
  __typename?: 'RecruitmentOpportunitiesMetricsResult';
  attributeType: Scalars['String']['output'];
  attributeValue: Scalars['String']['output'];
  menteesWaiting: Scalars['Int']['output'];
  mentorsCount: Scalars['Int']['output'];
  mentorsGap: Scalars['Int']['output'];
  mentorsOpenSlots: Scalars['Int']['output'];
  strongestPreferenceDisplayValue: Scalars['String']['output'];
  strongestPreferenceKey: Scalars['String']['output'];
};

export enum RegistrantTypeFilter {
  Either = 'EITHER',
  Mentors = 'MENTORS',
  NotRegistered = 'NOT_REGISTERED',
  Students = 'STUDENTS'
}

export type RemoveMessageTemplatesTags = {
  __typename?: 'RemoveMessageTemplatesTags';
  byFilterSelection: RemoveMessageTemplatesTagsByFilterSelectionPayload;
  byIds: RemoveMessageTemplatesTagsByIdsPayload;
};


export type RemoveMessageTemplatesTagsByFilterSelectionArgs = {
  filter?: InputMaybe<MessageTemplatesFilter>;
  tagIds: Array<Scalars['ID']['input']>;
};


export type RemoveMessageTemplatesTagsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  tagIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of RemoveMessageTemplatesTagsByFilterSelection. */
export type RemoveMessageTemplatesTagsByFilterSelectionPayload = {
  __typename?: 'RemoveMessageTemplatesTagsByFilterSelectionPayload';
  /** Any errors trying to update message template tags */
  errors: Array<MessageTemplateTagsNotAbleToBeRemovedError>;
  /** The updated message templates */
  messageTemplates?: Maybe<Array<MessageTemplate>>;
  /** The number of message templates update */
  numberOfMessageTemplatesUpdated?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of RemoveMessageTemplatesTagsByIds. */
export type RemoveMessageTemplatesTagsByIdsPayload = {
  __typename?: 'RemoveMessageTemplatesTagsByIdsPayload';
  /** Any errors trying to update message template tags */
  errors: Array<MessageTemplateTagsNotAbleToBeRemovedError>;
  /** The updated message templates */
  messageTemplates?: Maybe<Array<MessageTemplate>>;
  /** The number of message templates update */
  numberOfMessageTemplatesUpdated?: Maybe<Scalars['Int']['output']>;
};

/** Resize command for image variant */
export type ResizeImageInput = {
  /** The height of the variant in pixels */
  height: Scalars['Int']['input'];
  /** The width of the variant in pixels */
  width: Scalars['Int']['input'];
};

export type Resource = {
  __typename?: 'Resource';
  /** The description of the resource */
  description?: Maybe<Scalars['String']['output']>;
  /** The display name of the resource */
  displayName: Scalars['String']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The internal name of the resource */
  name: Scalars['String']['output'];
  /** The type of the resource */
  resourceType: ResourceType;
  /** The details of the resource */
  resourceable: Resourceable;
  /** The topics of the resource */
  topics: Array<ResourceTopic>;
};

/** The connection type for Resource. */
export type ResourceConnection = {
  __typename?: 'ResourceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ResourceEdge>>>;
  /** The collection of resource objects */
  nodes: Array<Resource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all resources in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ResourceEdge = {
  __typename?: 'ResourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Resource>;
};

export type ResourceTopic = {
  __typename?: 'ResourceTopic';
  /** Whether the topic is archived */
  archived: Scalars['Boolean']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The name of the topic */
  name: Scalars['String']['output'];
};

/** The connection type for ResourceTopic. */
export type ResourceTopicConnection = {
  __typename?: 'ResourceTopicConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ResourceTopicEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ResourceTopic>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ResourceTopicEdge = {
  __typename?: 'ResourceTopicEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ResourceTopic>;
};

export type ResourceTopicsSort = {
  /** Which field to sort by */
  column: ResourceTopicsSortByField;
  direction: SortDirection;
};

export enum ResourceTopicsSortByField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export enum ResourceType {
  ContentfulModule = 'CONTENTFUL_MODULE',
  SupportService = 'SUPPORT_SERVICE'
}

/** The entity that containes the details of a resource */
export type Resourceable = ContentfulModuleResource | SupportServiceResource;

export type ResourcesFilter = {
  /** filter by ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by resource type */
  resourceTypes?: InputMaybe<Array<ResourceType>>;
  /** filter by a search term */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** filter by topic ids */
  topicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ResourcesSort = {
  /** Which field to sort by */
  column?: InputMaybe<ResourcesSortByField>;
  direction?: InputMaybe<SortDirection>;
  /** Array of IDs specifying the custom sort order */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum ResourcesSortByField {
  CreatedAt = 'CREATED_AT',
  DisplayName = 'DISPLAY_NAME',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type S3Object = {
  __typename?: 'S3Object';
  /** The S3 Object id, equivalent to the key */
  id: Scalars['ID']['output'];
  /** The key of the object */
  key: Scalars['String']['output'];
  /** The key of the object without any prefixes */
  keyWithoutPrefix: Scalars['String']['output'];
};

export type SatisfactionAverage = {
  __typename?: 'SatisfactionAverage';
  /** The mentors average satisfaction score */
  mentorAverage?: Maybe<Scalars['Float']['output']>;
  /** The students average satisfaction score */
  studentAverage?: Maybe<Scalars['Float']['output']>;
};

export type SatisfactionReport = {
  __typename?: 'SatisfactionReport';
  /** The satisfaction averages for the previous program in the current program\s program sequence */
  previousProgramSatisfaction?: Maybe<SatisfactionAverage>;
  /** The satisfaction averages for the current program */
  programSatisfaction: SatisfactionAverage;
  /** The satisfaction averages for the current program higher ed segment */
  segmentSatisfaction: SatisfactionAverage;
};

/** Autogenerated return type of SaveBatchMatches. */
export type SaveBatchMatchesPayload = {
  __typename?: 'SaveBatchMatchesPayload';
  errors: Array<Error>;
  suggestedBatch: SuggestedBatch;
};

/** Autogenerated return type of SaveSurveyResponse. */
export type SaveSurveyResponsePayload = {
  __typename?: 'SaveSurveyResponsePayload';
  /** These are errors in the input response data that we want to catch and handle appropriately (these won't prevent the rest of the GraphQL query from running), as opposed to execution errors */
  errors: Array<InvalidSurveyResponseInputError>;
  /** The newly created survey response */
  response?: Maybe<SurveyResponse>;
  /** The updated user record */
  user: User;
};

/** Autogenerated return type of SaveWrittenMessage. */
export type SaveWrittenMessagePayload = {
  __typename?: 'SaveWrittenMessagePayload';
  /** The saved participant */
  participant: Participant;
};

export type SavedMatch = {
  __typename?: 'SavedMatch';
  /** Additional sorting criteria questions for the specific program */
  additionalProgramSortingCriteria: Scalars['JSON']['output'];
  /** Who performed the action */
  adminUser: User;
  /** The strategy of the suggested batch type if the source is automatic */
  autoMatchStrategy?: Maybe<AutoMatchStrategy>;
  /** Date created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The mentor counterpart for the saved match */
  mentor: Mentor;
  /** The match score for the saved match */
  score?: Maybe<Scalars['Int']['output']>;
  /** The source of the saved match */
  source: MatchingSource;
  /** The student counterpart for the saved match */
  student: Student;
};

/** The connection type for SavedMatch. */
export type SavedMatchConnection = {
  __typename?: 'SavedMatchConnection';
  /** The list of unique admin users for all saved matches in the collection */
  adminUsers?: Maybe<Array<User>>;
  /** The list of strategies for all saved matches in the collection */
  autoMatchStrategies?: Maybe<Array<AutoMatchStrategy>>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SavedMatchEdge>>>;
  /** The list of strategies for all saved matches in the collection */
  mentorSupermentorOptInTypes?: Maybe<Array<SupermentorOptInAnswer>>;
  /** The collection of saved matches objects */
  nodes: Array<SavedMatch>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all saved matches in the collection */
  totalCount: Scalars['Int']['output'];
  /** The list of unique programs for all saved matches in the collection */
  uniquePrograms?: Maybe<Array<Program>>;
};

/** An edge in a connection. */
export type SavedMatchEdge = {
  __typename?: 'SavedMatchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SavedMatch>;
};

export type SavedMatchesFilter = {
  /** filter for suggested batch matches by specific admin user IDs (not admin IDs) */
  adminUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter for saved match automatic strategy types */
  autoMatchStrategies?: InputMaybe<Array<AutoMatchStrategy>>;
  /** filter for mentors response for supermentor opt in question */
  mentorSupermentorOptInTypes?: InputMaybe<Array<SupermentorOptInAnswer>>;
  /** filter for suggested batch matches by specific program IDs */
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter for saved matches that are or are not queued to be matched */
  queuedToBeMatched?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for matching source types */
  sources?: InputMaybe<Array<MatchingSource>>;
};

export type SavedMatchesSort = {
  /** Which field to sort by */
  column: SavedMatchesSortByField;
  direction: SortDirection;
};

export enum SavedMatchesSortByField {
  MentorName = 'MENTOR_NAME',
  Score = 'SCORE',
  StudentName = 'STUDENT_NAME'
}

export type ScheduleTrainingTask = Task & {
  __typename?: 'ScheduleTrainingTask';
  /** The calendly link */
  calendlyUrl: Scalars['String']['output'];
  /** Custom text for the task's call to action button after the user clicks it */
  customAfterCallToAction?: Maybe<Scalars['String']['output']>;
  /** Custom text for the task's call to action button before the user clicks it */
  customCallToAction?: Maybe<Scalars['String']['output']>;
  /** The id of this task */
  id: Scalars['ID']['output'];
  /** The name of this task stored in the DB */
  name?: Maybe<Scalars['String']['output']>;
  /** The prompt to show users when showing this as a task to be completed */
  prompt: Scalars['String']['output'];
};

export type School = {
  __typename?: 'School';
  /** AWS username for SFTP */
  awsUsername?: Maybe<Scalars['String']['output']>;
  /** The id */
  id: Scalars['ID']['output'];
  /** The school's institution region */
  institutionRegion?: Maybe<InstitutionRegion>;
  /** What type of institution is this */
  institutionType?: Maybe<Institution>;
  /** Is the school minority-serving */
  isMinorityServingInstitution?: Maybe<Scalars['Boolean']['output']>;
  /** The school's logo */
  logo?: Maybe<Scalars['String']['output']>;
  /** The school name */
  name: Scalars['String']['output'];
  /** The identifier the school uses for their students */
  nameOfSchoolIdentifier: Scalars['String']['output'];
  /** Gets data for the last 5 SSO login sessions for this school */
  omniauthCredentialLatestSessions?: Maybe<Array<OmniauthCredentialLatestSession>>;
  /** Any program sequences belonging to this school */
  programSequences: Array<ProgramSequence>;
  /** Is the school public or private */
  publicOrPrivate?: Maybe<PublicOrPrivate>;
  /** The school short name */
  shortName: Scalars['String']['output'];
  /** The school's SSO IDP */
  ssoBrand?: Maybe<Scalars['String']['output']>;
  /** Is SSO active for the school? */
  ssoEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The SSO provider identifier */
  ssoProviderIdentifier?: Maybe<Scalars['String']['output']>;
  /** Is SSO required for Partner accounts for the school? */
  ssoRequiredForPartners: Scalars['Boolean']['output'];
  /** Is school enabled to actively test SSO? */
  ssoTestingEnabled: Scalars['Boolean']['output'];
  /** The school subdomain */
  subdomain: Scalars['String']['output'];
  /** Is the school a 2-year or 4-year school */
  twoOrFourYear?: Maybe<HigherEducation>;
};

/** The connection type for School. */
export type SchoolConnection = {
  __typename?: 'SchoolConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SchoolEdge>>>;
  /** The collection of school objects */
  nodes: Array<School>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all schools in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SchoolEdge = {
  __typename?: 'SchoolEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<School>;
};

/** A school identifier */
export type SchoolIdentifier = {
  __typename?: 'SchoolIdentifier';
  /** The id */
  id: Scalars['ID']['output'];
  /** The identifier */
  identificationString: Scalars['String']['output'];
  /** Who provided the identifier */
  providedBy: SchoolIdentifierProvider;
  /** The school associated with this identifier */
  school: School;
};

export enum SchoolIdentifierProvider {
  School = 'SCHOOL',
  User = 'USER'
}

export enum SchoolNotAbleToBeDeletedError {
  /** This school is used by one or more program sequences */
  SchoolIsActive = 'SCHOOL_IS_ACTIVE'
}

export type SchoolsFilter = {
  /** filter by a search term */
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolsSort = {
  /** Which field to sort by */
  column: SchoolsSortByField;
  direction: SortDirection;
};

export enum SchoolsSortByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type ScoreCriteria = {
  /** List of criteria to match */
  criteria: Array<ScoreCriterion>;
  /** The id of the student to score against */
  studentId?: InputMaybe<Scalars['ID']['input']>;
};

export type ScoreCriterion = {
  mentorKey: Scalars['String']['input'];
  studentKey: Scalars['String']['input'];
};

/** Autogenerated return type of SendBulkMessageByCsv. */
export type SendBulkMessageByCsvPayload = {
  __typename?: 'SendBulkMessageByCsvPayload';
  batchActionId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of SendPartnerNotifications. */
export type SendPartnerNotificationsPayload = {
  __typename?: 'SendPartnerNotificationsPayload';
  errors?: Maybe<Array<Error>>;
  successRecipients?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Autogenerated return type of SendSsoTestingTemplate. */
export type SendSsoTestingTemplatePayload = {
  __typename?: 'SendSsoTestingTemplatePayload';
  errors?: Maybe<Array<Error>>;
  programSequenceId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of SendTestMessage. */
export type SendTestMessagePayload = {
  __typename?: 'SendTestMessagePayload';
  errors?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of SendUpdateEmailDraftForMentorship. */
export type SendUpdateEmailDraftForMentorshipPayload = {
  __typename?: 'SendUpdateEmailDraftForMentorshipPayload';
  errors?: Maybe<Scalars['String']['output']>;
  notice?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of SetupSftp. */
export type SetupSftpPayload = {
  __typename?: 'SetupSftpPayload';
  isSuccess: Scalars['Boolean']['output'];
  program?: Maybe<Program>;
};

export type SftpCsvExports = {
  __typename?: 'SftpCsvExports';
  /** Csv export download information about an SFTP file */
  csvExportInfo: CsvExport;
};


export type SftpCsvExportsCsvExportInfoArgs = {
  programId: Scalars['ID']['input'];
  s3Key: Scalars['String']['input'];
};

export type ShearwaterAdministrator = {
  __typename?: 'ShearwaterAdministrator';
  /** Asana id */
  asanaId?: Maybe<Scalars['ID']['output']>;
  /** When the admin was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When the admin was deactivated */
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The id */
  id: Scalars['ID']['output'];
  /** Permissions for the shearwater administrator */
  permissions: Array<Permission>;
  /** Salesforce user id */
  salesforceUserId?: Maybe<Scalars['ID']['output']>;
  /** When the admin was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The user */
  user: User;
};

export type SingleSelectHardMatchQuestion = {
  __typename?: 'SingleSelectHardMatchQuestion';
  /** The match type to be used for the single-select hard match question */
  matchType: SingleSelectHardMatchQuestionMatch;
  /** The qid of the single-select question */
  qid: Scalars['String']['output'];
};

export enum SingleSelectHardMatchQuestionMatch {
  MatchingAnswers = 'MATCHING_ANSWERS',
  NonMatchingAnswers = 'NON_MATCHING_ANSWERS'
}

export type SkeletonMessageTemplate = {
  __typename?: 'SkeletonMessageTemplate';
  /** When this message template was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** When this message template was last edited */
  lastEditedAt: Scalars['ISO8601DateTime']['output'];
  /** The skeleton template name */
  name: Scalars['String']['output'];
  /** The bee plugin data used to store the editable template - ONLY used for email templates (not SMS) */
  templateEditorData: Scalars['JSON']['output'];
};

/** The connection type for SkeletonMessageTemplate. */
export type SkeletonMessageTemplateConnection = {
  __typename?: 'SkeletonMessageTemplateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SkeletonMessageTemplateEdge>>>;
  /** The collection of template objects */
  nodes: Array<SkeletonMessageTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all skeleton templates in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SkeletonMessageTemplateEdge = {
  __typename?: 'SkeletonMessageTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SkeletonMessageTemplate>;
};

export type SmsTemplate = MessageTemplate & {
  __typename?: 'SmsTemplate';
  /** Date archived */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The template message category */
  category: MessageCategory;
  /** The actual template string of content */
  content: Scalars['String']['output'];
  /** When this message template was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The user that created this message template */
  createdBy: User;
  /** The custom message type */
  customMessageType?: Maybe<ProgramCustomMessage>;
  /** The id */
  id: Scalars['ID']['output'];
  /** The template identifier */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Whether or not this template is a default template */
  isDefault: Scalars['Boolean']['output'];
  /** When this message template was last edited */
  lastEditedAt: Scalars['ISO8601DateTime']['output'];
  /** The user that last edited this message template */
  lastEditedBy: User;
  /** The type of message this template is used for */
  messageType: Message;
  /** The template name */
  name: Scalars['String']['output'];
  /** The program segment this template will be used for */
  programSegment?: Maybe<ProgramSegment>;
  /** The tags tied to this message template (used for organization) */
  tags: Array<MessageTemplateTag>;
  /** The user state this template must be used with (will control things like what variables are available to use) */
  userState: UserState;
};

export enum SortDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export enum StaffHigherEdRole {
  AcademicAdvising = 'academic_advising',
  AdministrativeAssistant = 'administrative_assistant',
  AdmissionsAndEnrollment = 'admissions_and_enrollment',
  AdultAndContinuingEducationPrograms = 'adult_and_continuing_education_programs',
  AlumniRelations = 'alumni_relations',
  ArtsAndMuseumAdministration = 'arts_and_museum_administration',
  AssessmentAccreditationAndCompliance = 'assessment_accreditation_and_compliance',
  AthleticsAndCoaching = 'athletics_and_coaching',
  BroadcastingRadioAndTelevision = 'broadcasting_radio_and_television',
  BursarAndStudentAccounts = 'bursar_and_student_accounts',
  BusinessAndFinancialServices = 'business_and_financial_services',
  CareerDevelopmentAndServices = 'career_development_and_services',
  ChildCareServices = 'child_care_services',
  CommuncationsMarketingAndPublicAffairs = 'communcations_marketing_and_public_affairs',
  ComputerAndInformationTechnology = 'computer_and_information_technology',
  ConferenceAndEventsAdministration = 'conference_and_events_administration',
  CounselingAndPsychologicalServices = 'counseling_and_psychological_services',
  CurriculumDesign = 'curriculum_design',
  DevelopmentAndFundraising = 'development_and_fundraising',
  DisabilityAndAccessibilityServices = 'disability_and_accessibility_services',
  DistanceEducationPrograms = 'distance_education_programs',
  DiversityAndMulticulturalAffairs = 'diversity_and_multicultural_affairs',
  EconomicAndBusinessDevelopment = 'economic_and_business_development',
  ExecutiveAssistant = 'executive_assistant',
  ExtensionAndOutreach = 'extension_and_outreach',
  FacilitiesManagement = 'facilities_management',
  FacultyDevelopment = 'faculty_development',
  FinancialAid = 'financial_aid',
  FoodServices = 'food_services',
  HealthAndMedicalServices = 'health_and_medical_services',
  HumanResources = 'human_resources',
  InstitutionalResearchAndPlanning = 'institutional_research_and_planning',
  InstructionalTechnologyAndDesign = 'instructional_technology_and_design',
  InternationalProgramsAndServices = 'international_programs_and_services',
  LaboratoryAndResearch = 'laboratory_and_research',
  LegalAffairs = 'legal_affairs',
  Libraries = 'libraries',
  OccupationalAndEnvironmentalSafety = 'occupational_and_environmental_safety',
  PoliceAndPublicSafety = 'police_and_public_safety',
  PublicationsAndEditing = 'publications_and_editing',
  Registrar = 'registrar',
  ReligiousAndSpiritualLife = 'religious_and_spiritual_life',
  ResidenceLifeAndHousing = 'residence_life_and_housing',
  Sales = 'sales',
  SponsoredProgramsGrantsAndContracts = 'sponsored_programs_grants_and_contracts',
  StudentAffairsAndServices = 'student_affairs_and_services',
  TutorsAndLearningResources = 'tutors_and_learning_resources',
  VolunteerProgramsAndServiceLearning = 'volunteer_programs_and_service_learning'
}

export type StartFirstWaveRecruitment = {
  __typename?: 'StartFirstWaveRecruitment';
  byFilterSelection: StartFirstWaveRecruitmentByFilterSelectionPayload;
  byIds: StartFirstWaveRecruitmentByIdsPayload;
};


export type StartFirstWaveRecruitmentByFilterSelectionArgs = {
  filter: ContactsFilter;
};


export type StartFirstWaveRecruitmentByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of StartFirstWaveRecruitmentByFilterSelection. */
export type StartFirstWaveRecruitmentByFilterSelectionPayload = {
  __typename?: 'StartFirstWaveRecruitmentByFilterSelectionPayload';
  /** Any errors trying to activate recruitment for contacts */
  errors: Array<ContactsNotAbleToBeActivatedError>;
  /** The number of contacts activated for recruitment */
  numberOfContactsActivated?: Maybe<Scalars['Int']['output']>;
  /** The updated program */
  program?: Maybe<Program>;
};

/** Autogenerated return type of StartFirstWaveRecruitmentByIds. */
export type StartFirstWaveRecruitmentByIdsPayload = {
  __typename?: 'StartFirstWaveRecruitmentByIdsPayload';
  /** Any errors trying to activate recruitment for contacts */
  errors: Array<ContactsNotAbleToBeActivatedError>;
  /** The number of contacts activated for recruitment */
  numberOfContactsActivated?: Maybe<Scalars['Int']['output']>;
  /** The updated program */
  program?: Maybe<Program>;
};

export type StartSecondWaveRecruitment = {
  __typename?: 'StartSecondWaveRecruitment';
  byFilterSelection: StartSecondWaveRecruitmentByFilterSelectionPayload;
  byIds: StartSecondWaveRecruitmentByIdsPayload;
};


export type StartSecondWaveRecruitmentByFilterSelectionArgs = {
  filter: ContactsFilter;
};


export type StartSecondWaveRecruitmentByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of StartSecondWaveRecruitmentByFilterSelection. */
export type StartSecondWaveRecruitmentByFilterSelectionPayload = {
  __typename?: 'StartSecondWaveRecruitmentByFilterSelectionPayload';
  /** Any errors trying to activate recruitment for contacts */
  errors: Array<ContactsNotAbleToBeActivatedError>;
  /** The number of contacts activated for recruitment */
  numberOfContactsActivated?: Maybe<Scalars['Int']['output']>;
  /** The updated program */
  program?: Maybe<Program>;
};

/** Autogenerated return type of StartSecondWaveRecruitmentByIds. */
export type StartSecondWaveRecruitmentByIdsPayload = {
  __typename?: 'StartSecondWaveRecruitmentByIdsPayload';
  /** Any errors trying to activate second wave recruitment for contacts */
  errors: Array<ContactsNotAbleToBeActivatedError>;
  /** The number of contacts activated for second wave recruitment */
  numberOfContactsActivated?: Maybe<Scalars['Int']['output']>;
  /** The updated program */
  program?: Maybe<Program>;
};

export type StateMachine = {
  __typename?: 'StateMachine';
  /** The id */
  id: Scalars['ID']['output'];
  /** The identifier name */
  identifier: Scalars['String']['output'];
  /** Position information for visualzation */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** The state machine schema */
  schema: Scalars['JSON']['output'];
};

/** The connection type for StateMachine. */
export type StateMachineConnection = {
  __typename?: 'StateMachineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StateMachineEdge>>>;
  /** The collection of state machine objects */
  nodes: Array<StateMachine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all state machines in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StateMachineEdge = {
  __typename?: 'StateMachineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<StateMachine>;
};

export type StatusInProgramFilter = {
  programId: Scalars['ID']['input'];
  statuses: Array<UserProgramStatus>;
};

export type StopRecruitment = {
  __typename?: 'StopRecruitment';
  byFilterSelection: StopRecruitmentByFilterSelectionPayload;
  byIds: StopRecruitmentByIdsPayload;
};


export type StopRecruitmentByFilterSelectionArgs = {
  filter: ContactsFilter;
};


export type StopRecruitmentByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of StopRecruitmentByFilterSelection. */
export type StopRecruitmentByFilterSelectionPayload = {
  __typename?: 'StopRecruitmentByFilterSelectionPayload';
  /** Any errors trying to deactivate recruitment for contacts */
  errors: Array<ContactsNotAbleToBeDeactivatedError>;
  /** The number of contacts deactivated for recruitment */
  numberOfContactsDeactivated?: Maybe<Scalars['Int']['output']>;
  /** The updated program */
  program?: Maybe<Program>;
};

/** Autogenerated return type of StopRecruitmentByIds. */
export type StopRecruitmentByIdsPayload = {
  __typename?: 'StopRecruitmentByIdsPayload';
  /** Any errors trying to deactivate recruitment for contacts */
  errors: Array<ContactsNotAbleToBeDeactivatedError>;
  /** The number of contacts deactivated for recruitment */
  numberOfContactsDeactivated?: Maybe<Scalars['Int']['output']>;
  /** The updated program */
  program?: Maybe<Program>;
};

export type Student = Participant & {
  __typename?: 'Student';
  /** Any logs of this participant's activity */
  activityLogs: Array<Log>;
  /**
   * The user's avatar, or the program default if nil
   * @deprecated Use avatarImage instead, which leverages activestorage to provide on-the-fly image variants
   */
  avatar: Scalars['String']['output'];
  /** The user's avatar, or the program default if nil */
  avatarImage?: Maybe<Image>;
  /** The user's profile attribute values */
  cachedUserProfileData?: Maybe<Array<CachedUserProfileDataAttributeValue>>;
  /** When the participant has completed their matching survey */
  completedMatchingSurveyAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the participant was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date participant was deregistered */
  deregisterDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The participant's deregistration status events */
  deregistrationStatusEvents: Array<DeregistrationStatusEvent>;
  /** What kind of support this student is looking for from their mentor */
  desiredMentoringSupport: Array<Scalars['String']['output']>;
  /** The goals derived from responses to the goal question in the matching survey */
  goals: Array<StudentGoal>;
  /** The id */
  id: Scalars['ID']['output'];
  /** Any matching labels associated with the participant */
  matchingLabels: Array<MatchingLabel>;
  /**
   * The mentorships
   * @deprecated Use participant_mentorships instead, which is a connection type and provides the same data but with pagination
   */
  mentorships: Array<Mentorship>;
  /** Notes on participant */
  notes?: Maybe<Scalars['String']['output']>;
  /** Mentorships associated with a participant */
  participantMentorships?: Maybe<MentorshipConnection>;
  /** Whether this participant is prioritized and pending for rematch */
  prioritizedAndPendingForRematching: Scalars['Boolean']['output'];
  /** The program this mentor belongs to */
  program: Program;
  /** This student's goal they specified in their matching survey */
  programGoal?: Maybe<Scalars['String']['output']>;
  /** Whether this participant has been marked as pushed through to match, allowing them to skip onboarding */
  pushedThroughToMatch: Scalars['Boolean']['output'];
  /** A question this student gave during the matching process, that they'd like answered by their mentor */
  questionForMentor?: Maybe<Scalars['String']['output']>;
  /** Whether this participant is registered for a program or not */
  registered: Scalars['Boolean']['output'];
  /** When the participant registered */
  registrationDate: Scalars['ISO8601DateTime']['output'];
  /** When the student was rematched */
  rematchDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** A list of saved matches relating to the student */
  savedMatches: Array<SavedMatch>;
  /** Response for opting in to supermentorships (Currently on the user level) */
  supermentorOptIn?: Maybe<Scalars['String']['output']>;
  /**
   * This participants survey responses
   * @deprecated Accessing survey_responses from participant will be removed. Please re-write this query to get survey_responses from user.
   */
  surveyResponses: Array<SurveyResponse>;
  /** Any videos uploaded by this participant */
  uploadedVideos: Array<UploadedVideo>;
  /** The user */
  user: User;
  /** The user's profile attribute values */
  userProfileData: Array<UserProfileData>;
  /** Link to the program specific URL in the participant dashboard for this participant */
  webappBaseUrl?: Maybe<Scalars['String']['output']>;
  /** The written messages for this participant */
  writtenMessages: Array<WrittenMessage>;
};


export type StudentCachedUserProfileDataArgs = {
  attributes: Array<CachedUserProfileDataAttributeInput>;
  cacheSettings: CachedUserProfileDataSettingsFilter;
};


export type StudentMentorshipsArgs = {
  status?: InputMaybe<MatchedStatus>;
};


export type StudentParticipantMentorshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MentorshipsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MentorshipsSort>;
};


export type StudentSurveyResponsesArgs = {
  context?: InputMaybe<SurveyResponseContextFilter>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};


export type StudentUploadedVideosArgs = {
  onlySharable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StudentUserProfileDataArgs = {
  attributes: Array<UserProfileDataAttributeInput>;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule>>;
  source: ProfileAttributeSource;
};

export type StudentContact = Contact & {
  __typename?: 'StudentContact';
  /** Any a2p smses sent to this contact */
  a2pSmses: Array<A2pSms>;
  /** The contact's activation status */
  activationStatus: ActivationStatus;
  /** When the contact's activation status last changed */
  activationStatusChangedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Batch action ID the contact was created from */
  batchActionId?: Maybe<Scalars['String']['output']>;
  /** The id */
  id: Scalars['ID']['output'];
  /** Any notes about this contact */
  notes?: Maybe<Scalars['String']['output']>;
  /** The program this mentor belongs to */
  program: Program;
  /** The contact's registration status */
  registered: Scalars['Boolean']['output'];
  /** Who uploaded this contact */
  uploadedBy?: Maybe<User>;
  /** When the contact registered */
  uploadedDate: Scalars['ISO8601DateTime']['output'];
  /** The user */
  user: User;
};

export type StudentGoal = {
  __typename?: 'StudentGoal';
  /** The answer */
  answer: SurveyAnswer;
  /** The answer key */
  answerKey: Scalars['String']['output'];
  /** The answer text */
  answerText: Scalars['String']['output'];
  /** The goal */
  goal?: Maybe<Goal>;
  /** The id */
  id: Scalars['ID']['output'];
};

export type StudentGoalsList = {
  __typename?: 'StudentGoalsList';
  /** The standardized underscored goal key */
  answerKey: Scalars['String']['output'];
  /** The human readable text for the goal */
  answerText: Scalars['String']['output'];
};

export type SuggestedBatch = {
  __typename?: 'SuggestedBatch';
  /** Who performed the action */
  adminUser: User;
  /** When this batch was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The overview result for the suggestions batch */
  overview?: Maybe<Scalars['JSON']['output']>;
  /** The program of the suggested match */
  program: Program;
  /** The settings used to make suggestions */
  settings: SuggestedBatchSettings;
  /** The status of the batch */
  status: SuggestedBatchStatus;
  /** The strategy of the suggested batch */
  strategyType?: Maybe<AutoMatchStrategy>;
};

/** The connection type for SuggestedBatch. */
export type SuggestedBatchConnection = {
  __typename?: 'SuggestedBatchConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SuggestedBatchEdge>>>;
  /** The collection of suggested batch objects */
  nodes: Array<SuggestedBatch>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all suggested batches in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SuggestedBatchEdge = {
  __typename?: 'SuggestedBatchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SuggestedBatch>;
};

export type SuggestedBatchFilter = {
  /** strategy used to match */
  autoMatchStrategy?: InputMaybe<AutoMatchStrategy>;
  /** filter by program id */
  programId: Scalars['ID']['input'];
};

export type SuggestedBatchSettings = {
  __typename?: 'SuggestedBatchSettings';
  /** The settings used for auto match */
  autoMatchingSettings: AutoMatchSettings;
  /** The group sizes for matching enrollment */
  groupMatchingSettings?: Maybe<GroupMatchingSettings>;
  /** The matching criteria selected */
  matchingCriteria: MatchingCriteria;
  /** The program id */
  programId?: Maybe<Scalars['ID']['output']>;
  /** The weights to be used for scoring attributes from the matching survey */
  questionsWeights?: Maybe<Array<QuestionWeight>>;
};

export type SuggestedBatchSort = {
  /** Which field to sort by */
  column: SuggestedBatchSortByField;
  direction: SortDirection;
};

export enum SuggestedBatchSortByField {
  CreatedAt = 'CREATED_AT'
}

export enum SuggestedBatchStatus {
  Accepted = 'ACCEPTED',
  Accepting = 'ACCEPTING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED',
  Rejected = 'REJECTED'
}

export type SuggestedMatch = {
  __typename?: 'SuggestedMatch';
  /** Date created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The match score for the suggested match */
  matchScore: Scalars['Float']['output'];
  /** The mentor counterpart for the suggested match */
  mentor: Mentor;
  /** The student counterpart for the suggested match */
  student: Student;
  /** The suggested batch for the suggested match */
  suggestedBatch: SuggestedBatch;
};

/** The connection type for SuggestedMatch. */
export type SuggestedMatchConnection = {
  __typename?: 'SuggestedMatchConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SuggestedMatchEdge>>>;
  /** The collection of suggested matches objects */
  nodes: Array<SuggestedMatch>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all suggested matches in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SuggestedMatchEdge = {
  __typename?: 'SuggestedMatchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SuggestedMatch>;
};

export type SuggestedMatchesFilter = {
  /** filter for suggested batch matches by specific admin user IDs (not admin IDs) */
  adminUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter for the batch statuses */
  batchStatuses?: InputMaybe<Array<SuggestedBatchStatus>>;
  /** filter for suggested batch matches by specific program IDs */
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter for suggested batch match strategy types */
  strategyTypes?: InputMaybe<Array<AutoMatchStrategy>>;
  /** filter for suggested batch matches by specific suggested batch IDs */
  suggestedBatchIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SuggestedMatchesSort = {
  /** Which field to sort by */
  column: SuggestedMatchesSortByField;
  direction: SortDirection;
};

export enum SuggestedMatchesSortByField {
  MatchScore = 'MATCH_SCORE',
  MentorName = 'MENTOR_NAME',
  StudentName = 'STUDENT_NAME'
}

export enum SupermentorOptInAnswer {
  /** Maybe; I want to know more */
  Maybe = 'MAYBE',
  /** No */
  No = 'NO',
  /** Yes */
  Yes = 'YES'
}

export enum SupportPriority {
  Immediate = 'immediate',
  NotNeeded = 'not_needed'
}

export enum SupportServiceCategory {
  AcademicServicesAdvisingOffice = 'academic_services_advising_office',
  BursarsOffice = 'bursars_office',
  CareerDevelopmentOffice = 'career_development_office',
  CulturalCenters = 'cultural_centers',
  DiningServices = 'dining_services',
  FinancialAidOffice = 'financial_aid_office',
  HealthAndWellness = 'health_and_wellness',
  InclusionAndBelonging = 'inclusion_and_belonging',
  InformationTechnology = 'information_technology',
  RecreationOffice = 'recreation_office',
  RegistrarsOffice = 'registrars_office',
  ResidentialLifeHousing = 'residential_life_housing',
  ServicesForStudentsWithDisabilities = 'services_for_students_with_disabilities',
  StudyAbroad = 'study_abroad',
  TransferStudents = 'transfer_students',
  TutoringWritingCenter = 'tutoring_writing_center'
}

export type SupportServiceResource = {
  __typename?: 'SupportServiceResource';
  /** The additional info of the support service resource */
  additionalInfo?: Maybe<Scalars['String']['output']>;
  /** The address of the support service resource */
  address?: Maybe<Scalars['String']['output']>;
  /** The categories of the support service resource */
  categories: Array<SupportServiceCategory>;
  /** The contact email of the support service resource */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** The contact name of the support service resource */
  contactName?: Maybe<Scalars['String']['output']>;
  /** The contact phone of the support service resource */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** The description of the support service resource */
  description: Scalars['String']['output'];
  /** The email of the support service resource */
  email: Scalars['String']['output'];
  /** The internal id of the support service resource */
  id: Scalars['ID']['output'];
  /** The name of the support service resource */
  name: Scalars['String']['output'];
  /** The phone number of the support service resource */
  phone: Scalars['String']['output'];
  /** The url of the support service resource */
  url?: Maybe<Scalars['String']['output']>;
};

export type Survey = {
  __typename?: 'Survey';
  /** Whether the survey is archived */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The description used when presenting the survey */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the survey has any responses */
  hasResponses?: Maybe<Scalars['Boolean']['output']>;
  /** The id */
  id: Scalars['ID']['output'];
  /** Whether the survey is a migration from the old framework */
  migrated?: Maybe<Scalars['Boolean']['output']>;
  /** The name */
  name: Scalars['String']['output'];
  /** The questions, options for filtering by entity context */
  questions: Array<SurveyQuestion>;
  /** The type of survey this is */
  surveyType?: Maybe<SurveyType>;
};


export type SurveyDescriptionArgs = {
  participantId?: InputMaybe<Scalars['ID']['input']>;
  surveyCustomRenderOverride?: InputMaybe<SurveyCustomRenderOverride>;
};


export type SurveyHasResponsesArgs = {
  programId?: InputMaybe<Scalars['ID']['input']>;
};


export type SurveyQuestionsArgs = {
  filter?: InputMaybe<SurveyQuestionFilter>;
  participantId?: InputMaybe<Scalars['ID']['input']>;
  qids?: InputMaybe<Array<Scalars['String']['input']>>;
  qidsToExclude?: InputMaybe<Array<Scalars['String']['input']>>;
  surveyCustomRenderOverride?: InputMaybe<SurveyCustomRenderOverride>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SurveyAnswer = {
  __typename?: 'SurveyAnswer';
  /** The answer json blob */
  answerJson: Scalars['JSON']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The question */
  question: SurveyQuestion;
};

/** Answer test */
export type SurveyAnswerInput = {
  /** The answer json blob */
  answerJson: Scalars['JSON']['input'];
  /** The ID of the survey question this answer is for */
  questionId: Scalars['ID']['input'];
};

export type SurveyCompletionFilter = {
  /** filter by completed or not */
  completed: Scalars['Boolean']['input'];
  /** filter by participant type */
  participantType?: InputMaybe<ParticipantTypeFilter>;
  /** filter by survey id */
  surveyIds: Array<Scalars['ID']['input']>;
};

/** The connection type for Survey. */
export type SurveyConnection = {
  __typename?: 'SurveyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SurveyEdge>>>;
  /** The collection of survey objects */
  nodes: Array<Survey>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of surveys in the collection */
  totalCount: Scalars['Int']['output'];
};

export type SurveyCustomRenderOverride = {
  /** the program to fetch data for */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /** user_id of the current user */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SurveyCustomizationPromptInput = {
  /** The mentee-facing display text for the question */
  menteeText?: InputMaybe<Scalars['String']['input']>;
  /** The mentor-facing display text for the question */
  mentorText?: InputMaybe<Scalars['String']['input']>;
};

export enum SurveyCustomizationQuestionForInput {
  Both = 'BOTH',
  Mentee = 'MENTEE',
  Mentor = 'MENTOR'
}

export type SurveyCustomizationQuestionInput = {
  /** Text to display on exports and matching dashboard. Also used to generate the question ID plus the program sequence ID */
  displayName: Scalars['String']['input'];
  /** Is the question displayed on the matching dashboard */
  displayOnMatchingDashboard: Scalars['Boolean']['input'];
  /** The descriptive text for the question prompt */
  helperText?: InputMaybe<Scalars['String']['input']>;
  /** Customized options */
  options: Array<SurveyQuestionOptionInput>;
  /** Who is this question for */
  questionFor: SurveyCustomizationQuestionForInput;
  /** The user-facing display text for the question */
  questionPrompt: SurveyCustomizationPromptInput;
  /** Which type the question is. For now, single or multi select */
  questionType: SurveyCustomizationValidQuestionTypeInput;
  /** Is the question required */
  required: Scalars['Boolean']['input'];
  /** Is the question displayed on the matching dashboard as sortable */
  sortable: Scalars['Boolean']['input'];
  /** If the options list should include an "other" option with write-in ability */
  withOtherOption: Scalars['Boolean']['input'];
};

export enum SurveyCustomizationValidQuestionTypeInput {
  MultiSelect = 'MULTI_SELECT',
  OpenResponse = 'OPEN_RESPONSE',
  Select = 'SELECT'
}

/** An edge in a connection. */
export type SurveyEdge = {
  __typename?: 'SurveyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Survey>;
};

/** Survey Input */
export type SurveyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  questions: Array<SurveyQuestionInput>;
};

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  /** Whether or not the question was created using the survey editor */
  createdInAdminTool: Scalars['Boolean']['output'];
  /** Customization options ex. for major, gender, race */
  customizationOptions?: Maybe<Array<SurveyQuestionCustomizationOption>>;
  /** The question customizations */
  customizations?: Maybe<Scalars['JSON']['output']>;
  /** The id */
  id: Scalars['ID']['output'];
  /** The index */
  index: Scalars['Int']['output'];
  /** Whether or not the question is a base question */
  isBaseQuestion?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the question is optional */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** The human readable identifier */
  qid?: Maybe<Scalars['String']['output']>;
  /** Metadata about question display on the matching dashboard */
  questionMdDisplay?: Maybe<SurveyQuestionMdDisplay>;
  /** The question template */
  template: SurveyQuestionTemplate;
};

export type SurveyQuestionCustomizationOption = {
  __typename?: 'SurveyQuestionCustomizationOption';
  /** The customization option id */
  id: Scalars['ID']['output'];
  /** The user-facing display text for the option */
  text: Scalars['String']['output'];
};

export type SurveyQuestionFilter = {
  /** filter by base survey questions */
  isBaseQuestion?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by custom survey questions */
  isCustomQuestion?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the participant */
  participantId?: InputMaybe<Scalars['ID']['input']>;
  /** filter by survey qid */
  qids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** exclude questions with given qids */
  qidsToExclude?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter by type of survey question */
  questionTypes?: InputMaybe<Array<SurveyQuestionTemplateId>>;
  /** ID of the user */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Survey Question Input */
export type SurveyQuestionInput = {
  customizations?: InputMaybe<Scalars['JSON']['input']>;
  index: Scalars['Int']['input'];
  templateId: SurveyQuestionTemplateId;
};

export type SurveyQuestionMdDisplay = {
  __typename?: 'SurveyQuestionMdDisplay';
  /** The display name */
  displayName: Scalars['String']['output'];
  /** Whether or not the question should be displayed on the matching dashboard */
  displayOnMatchingDashboard: Scalars['Boolean']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The respective question */
  question: SurveyQuestion;
  /** Whether or not the question should be displayed as sortable */
  sortable: Scalars['Boolean']['output'];
};

/** Single option for a survey question */
export type SurveyQuestionOptionInput = {
  /** The option to hide a question under certain conditions */
  hideForKeyValuesOr?: InputMaybe<HideForKeyValuesOrInput>;
  /** The image URL for the option */
  image?: InputMaybe<Scalars['String']['input']>;
  /** The option id to use for an option */
  oid: Scalars['String']['input'];
  /** The text to display for an option */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyQuestionRestrictedOption = {
  __typename?: 'SurveyQuestionRestrictedOption';
  /** The string identifier */
  id: Scalars['String']['output'];
  /** The user-facing display text for the option */
  label: Scalars['String']['output'];
};

/** The connection type for SurveyQuestionRestrictedOption. */
export type SurveyQuestionRestrictedOptionConnection = {
  __typename?: 'SurveyQuestionRestrictedOptionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SurveyQuestionRestrictedOptionEdge>>>;
  /** The collection of survey question restricted option objects */
  nodes: Array<SurveyQuestionRestrictedOption>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all options in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SurveyQuestionRestrictedOptionEdge = {
  __typename?: 'SurveyQuestionRestrictedOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SurveyQuestionRestrictedOption>;
};

export type SurveyQuestionTemplate = {
  __typename?: 'SurveyQuestionTemplate';
  /** The id */
  id: Scalars['ID']['output'];
  /** The template id */
  templateId: SurveyQuestionTemplateId;
};

export enum SurveyQuestionTemplateId {
  Conversation = 'CONVERSATION',
  CounterpartsInfo = 'COUNTERPARTS_INFO',
  DatePicker = 'DATE_PICKER',
  Flags = 'FLAGS',
  Generic = 'GENERIC',
  /** @deprecated Removed concept of initial conversation */
  InitialConversation = 'INITIAL_CONVERSATION',
  Likert = 'LIKERT',
  MentorshipChatGroupOptionalStudentInfo = 'MENTORSHIP_CHAT_GROUP_OPTIONAL_STUDENT_INFO',
  MentorshipChatGroupStudentSelect = 'MENTORSHIP_CHAT_GROUP_STUDENT_SELECT',
  MultiSelect = 'MULTI_SELECT',
  MultiSelectDropdown = 'MULTI_SELECT_DROPDOWN',
  Nps = 'NPS',
  NumberInput = 'NUMBER_INPUT',
  OpenResponse = 'OPEN_RESPONSE',
  RotatingCareerOpenResponse = 'ROTATING_CAREER_OPEN_RESPONSE',
  RotatingLikert = 'ROTATING_LIKERT',
  RotatingOpenResponse = 'ROTATING_OPEN_RESPONSE',
  Select = 'SELECT',
  SelectWithSelectFollowUp = 'SELECT_WITH_SELECT_FOLLOW_UP'
}

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  /** The answers */
  answers: Array<SurveyAnswer>;
  /** The context under which the survey was taken, for the person who took the survey. This survey response could be in reference to a particular counterpart, mentorship, etc */
  context: SurveyResponseContext;
  /** The id */
  id: Scalars['ID']['output'];
  /** The mentorship context of the response, if available */
  mentorship?: Maybe<Mentorship>;
  /** The participant that submited the response */
  participant?: Maybe<Participant>;
  /** Date the response was submitted */
  submittedAt: Scalars['ISO8601DateTime']['output'];
  /** The survey */
  survey: Survey;
  /** Survey prompts and answers, formatted for user display */
  surveyResponseAnswerStrings?: Maybe<Array<SurveyResponseAnswerStrings>>;
};


export type SurveyResponseAnswersArgs = {
  withVariablesReplaced?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SurveyResponseSurveyResponseAnswerStringsArgs = {
  filter?: InputMaybe<SurveyResponseAnswerStringsFilter>;
  programId: Scalars['ID']['input'];
};

export type SurveyResponseAnswerStrings = {
  __typename?: 'SurveyResponseAnswerStrings';
  answerString: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Question identifier, used to identify similar question prompts */
  qid: Scalars['String']['output'];
  questionPrompt: Scalars['String']['output'];
  subprompt?: Maybe<Scalars['String']['output']>;
  surveyResponseAnswerId: Scalars['ID']['output'];
};

export type SurveyResponseAnswerStringsFilter = {
  /** filter by qids */
  qids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter by survey response answer */
  surveyResponseAnswerId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for SurveyResponse. */
export type SurveyResponseConnection = {
  __typename?: 'SurveyResponseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SurveyResponseEdge>>>;
  /** The collection of survey response objects */
  nodes: Array<SurveyResponse>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all survey responses in the collection */
  totalCount: Scalars['Int']['output'];
};

/** Context relating to the survey */
export type SurveyResponseContext = {
  __typename?: 'SurveyResponseContext';
  /** ID of the chat group this survey is related to */
  mentorshipChatGroupId?: Maybe<Scalars['ID']['output']>;
  /** ID of the chat group this survey is related to */
  mentorshipId?: Maybe<Scalars['ID']['output']>;
  /** ID of participant this survey is related to  */
  participantId?: Maybe<Scalars['ID']['output']>;
};

/** Context relating to the survey */
export type SurveyResponseContextFilter = {
  /** ID of the chat group this survey is related to */
  mentorshipChatGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the chat group this survey is related to */
  mentorshipId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of participant this survey is related to  */
  participantId?: InputMaybe<Scalars['ID']['input']>;
};

/** Context relating to the survey */
export type SurveyResponseContextInput = {
  /** ID of the chat group this survey is related to */
  mentorshipChatGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the chat group this survey is related to */
  mentorshipId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of participant this survey is related to  */
  participantId?: InputMaybe<Scalars['ID']['input']>;
};

/** An edge in a connection. */
export type SurveyResponseEdge = {
  __typename?: 'SurveyResponseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SurveyResponse>;
};

/** Response test */
export type SurveyResponseInput = {
  answers: Array<SurveyAnswerInput>;
  contextInput?: InputMaybe<SurveyResponseContextInput>;
  surveyId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type SurveyResponsesFilter = {
  /** filter by participant ids */
  participantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by survey id */
  programId?: InputMaybe<Scalars['String']['input']>;
  /** filter by qids from survey_response_answer_strings */
  qids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter by program id */
  surveyId?: InputMaybe<Scalars['String']['input']>;
  /** filter by survey types ex. matching, assessment */
  surveyTypes?: InputMaybe<Array<SurveyType>>;
};

export type SurveyResponsesSort = {
  column: SurveyResponsesSortByField;
  direction: SortDirection;
};

export enum SurveyResponsesSortByField {
  UpdatedAt = 'UPDATED_AT'
}

export enum SurveyType {
  Assessment = 'ASSESSMENT',
  Matching = 'MATCHING',
  Micro = 'MICRO',
  PostSession = 'POST_SESSION'
}

export type SurveysFilter = {
  /** filter by exclusion of survey tags, opposite of tags filter */
  exceptTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter by type of survey */
  surveyType?: InputMaybe<SurveyType>;
  /** filter by types of survey */
  surveyTypes?: InputMaybe<Array<SurveyType>>;
  /** filter by survey tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TakeExternalLinkTask = Task & {
  __typename?: 'TakeExternalLinkTask';
  /** Custom text for the task's call to action button after the user clicks it */
  customAfterCallToAction?: Maybe<Scalars['String']['output']>;
  /** Custom text for the task's call to action button before the user clicks it */
  customCallToAction?: Maybe<Scalars['String']['output']>;
  /** The external link that needs to be taken by the participant */
  externalLink: ExternalLink;
  /** The id of this task */
  id: Scalars['ID']['output'];
  /** The name of this task stored in the DB */
  name?: Maybe<Scalars['String']['output']>;
  /** The prompt to show users when showing this as a task to be completed */
  prompt: Scalars['String']['output'];
};

export type TakeSurveyTask = Task & {
  __typename?: 'TakeSurveyTask';
  /** Custom text for the task's call to action button after the user clicks it */
  customAfterCallToAction?: Maybe<Scalars['String']['output']>;
  /** Custom text for the task's call to action button before the user clicks it */
  customCallToAction?: Maybe<Scalars['String']['output']>;
  /** The id of this task */
  id: Scalars['ID']['output'];
  /** The name of this task stored in the DB */
  name?: Maybe<Scalars['String']['output']>;
  /** The prompt to show users when showing this as a task to be completed */
  prompt: Scalars['String']['output'];
  /** The survey that needs to be taken by the participant */
  survey: Survey;
};

/** A task to be completed by a participant. The task itself doesn't mean anything, unless it is bound to a program via a Program Task. */
export type Task = {
  /** Custom text for the task's call to action button after the user clicks it */
  customAfterCallToAction?: Maybe<Scalars['String']['output']>;
  /** Custom text for the task's call to action button before the user clicks it */
  customCallToAction?: Maybe<Scalars['String']['output']>;
  /** The id of this task */
  id: Scalars['ID']['output'];
  /** The name of this task stored in the DB */
  name?: Maybe<Scalars['String']['output']>;
  /** The prompt to show users when showing this as a task to be completed */
  prompt: Scalars['String']['output'];
};

export type TaskAssignment = {
  /** The behavior for the new program task */
  behavior: Behavior;
  /** The display name from the new program task */
  displayName: Scalars['String']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The participant if assigned to particular participant */
  participantId?: Maybe<Scalars['ID']['output']>;
  /** The position in checklist */
  position: Scalars['Int']['output'];
  /** The state of the assigned task assignment */
  status: TaskAssignmentStatus;
  /** The user */
  userId: Scalars['ID']['output'];
};

export enum TaskAssignmentStatus {
  Complete = 'complete',
  Incomplete = 'incomplete'
}

/** The connection type for Task. */
export type TaskConnection = {
  __typename?: 'TaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TaskEdge>>>;
  /** The collection of school objects */
  nodes: Array<Task>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all old surveys in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TaskEdge = {
  __typename?: 'TaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Task>;
};

export enum TaskParticipantRole {
  Either = 'EITHER',
  Mentor = 'MENTOR',
  Student = 'STUDENT'
}

export type TasksFilter = {
  /** filter by tasks that are mentee quizzes */
  isMenteeQuiz?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by task type */
  type?: InputMaybe<KindOfTask>;
};

export enum TimePeriod {
  Day = 'DAY',
  Hour = 'HOUR',
  Millennium = 'MILLENNIUM',
  Month = 'MONTH',
  Week = 'WEEK'
}

/** Questions enabled for matching surveys */
export type ToggleQuestionInput = {
  /** The list of questions to include/exclude for mentee survey */
  mentees?: InputMaybe<MenteeToggleQuestionInput>;
  /** The list of questions to include/exclude for mentor survey */
  mentors?: InputMaybe<MentorToggleQuestionInput>;
};

export type TookTypeformSurveyLog = Log & {
  __typename?: 'TookTypeformSurveyLog';
  /** The external_link */
  externalLink: ExternalLink;
  /** The id */
  id: Scalars['ID']['output'];
  /** When the event was logged */
  loggedAtDate: Scalars['ISO8601DateTime']['output'];
};

export type Topic = {
  __typename?: 'Topic';
  /** Date archived */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The category of topic (e.g prematch, recruitment, etc...) */
  category: TopicCategory;
  /** The default number of hours to wait before restarting this topic if it is recurring */
  hoursDelayBeforeRestart: Scalars['Int']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** Whether the topic is a default topic or not */
  isDefault: Scalars['Boolean']['output'];
  /** The name of the topic */
  name: Scalars['String']['output'];
  /** The priority of the topic ( lower value = higher priority) */
  priority: Scalars['Float']['output'];
  /** The program segment this topic will be used for */
  programSegment?: Maybe<ProgramSegment>;
  /** The records that represent the programs that are using this topic */
  programTopics: ProgramTopicConnection;
  /** The conditions that need to be matched to a user state for this topic to be eligible to be sent */
  topicConditions: Array<TopicCondition>;
  /** The messages to be sent */
  topicMessages: Array<TopicMessage>;
  /** The user state */
  userState: UserState;
};


export type TopicProgramTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum TopicCategory {
  AssessmentSurveyReminder = 'assessment_survey_reminder',
  BulkMessage = 'bulk_message',
  ConversationReminder = 'conversation_reminder',
  CustomPostMatch = 'custom_post_match',
  DisengagementCheckIn = 'disengagement_check_in',
  FlagReminder = 'flag_reminder',
  NewRecruitment = 'new_recruitment',
  PartnerCampaigns = 'partner_campaigns',
  PreMatch = 'pre_match',
  PreviouslyRegisteredAsMentorRecruitment = 'previously_registered_as_mentor_recruitment',
  PreviouslyRegisteredAsStudentRecruitment = 'previously_registered_as_student_recruitment',
  SecondWaveRecruitment = 'second_wave_recruitment',
  StudentSuccessPlanReminder = 'student_success_plan_reminder'
}

export type TopicCollection = {
  __typename?: 'TopicCollection';
  /** string to identify the collection in the response, which may contain many collections */
  key: Scalars['String']['output'];
  /** The topics for the collection */
  topics: TopicConnection;
};


export type TopicCollectionTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TopicCollectionInput = {
  /** filter to get the collection */
  filter?: InputMaybe<TopicsFilter>;
  /** string to identify the collection in the response, which may contain many collections */
  key: Scalars['String']['input'];
  /** sort to apply to the collection */
  sort?: InputMaybe<TopicsSort>;
};

export type TopicCondition = {
  __typename?: 'TopicCondition';
  /** The id */
  id: Scalars['ID']['output'];
  /** The key for this condition (e.g. registered, disengaged, etc...) */
  key: TopicConditionKey;
  /** The topics that use this condition */
  topics: Array<Topic>;
  /** The value for this condition */
  value: Scalars['Boolean']['output'];
};

export type TopicConditionInput = {
  /** The key of the topic condition */
  key: TopicConditionKey;
  /** The value of the topic condition */
  value: Scalars['Boolean']['input'];
};

export enum TopicConditionKey {
  ActiveOnNormalRecruitment = 'ACTIVE_ON_NORMAL_RECRUITMENT',
  ActiveOnSecondWaveRecruitment = 'ACTIVE_ON_SECOND_WAVE_RECRUITMENT',
  CompletedCareerMentoringSuccessPlan = 'COMPLETED_CAREER_MENTORING_SUCCESS_PLAN',
  CompletedFirstConnectedFuturesTask = 'COMPLETED_FIRST_CONNECTED_FUTURES_TASK',
  CompletedMatchingSurvey = 'COMPLETED_MATCHING_SURVEY',
  CompletedMentoringRelationshipAgreement = 'COMPLETED_MENTORING_RELATIONSHIP_AGREEMENT',
  CompletedMentoringRelationshipClosure = 'COMPLETED_MENTORING_RELATIONSHIP_CLOSURE',
  CompletedOnboarding = 'COMPLETED_ONBOARDING',
  FirstWeekOfTheMonth = 'FIRST_WEEK_OF_THE_MONTH',
  FlagRecipient = 'FLAG_RECIPIENT',
  HasCompletedEndAssessment = 'HAS_COMPLETED_END_ASSESSMENT',
  HasCompletedMidAssessment = 'HAS_COMPLETED_MID_ASSESSMENT',
  HasCompletedStartAssessment = 'HAS_COMPLETED_START_ASSESSMENT',
  InSupermentorGroup = 'IN_SUPERMENTOR_GROUP',
  IsSupermentor = 'IS_SUPERMENTOR',
  LoggedOneOrMoreConversations = 'LOGGED_ONE_OR_MORE_CONVERSATIONS',
  LoggedOneOrTwoConversations = 'LOGGED_ONE_OR_TWO_CONVERSATIONS',
  LoggedThreeOrMoreConversations = 'LOGGED_THREE_OR_MORE_CONVERSATIONS',
  LoggedZeroConversations = 'LOGGED_ZERO_CONVERSATIONS',
  Matched = 'MATCHED',
  MentorshipReportedAnyConversations = 'MENTORSHIP_REPORTED_ANY_CONVERSATIONS',
  MultipleMentorships = 'MULTIPLE_MENTORSHIPS',
  NeedsConversationReportReminder = 'NEEDS_CONVERSATION_REPORT_REMINDER',
  NeedsFlagReminder = 'NEEDS_FLAG_REMINDER',
  NeedsMentorCounterpartDisengagedMessage = 'NEEDS_MENTOR_COUNTERPART_DISENGAGED_MESSAGE',
  NeedsMentorSelfDisengagedMessage = 'NEEDS_MENTOR_SELF_DISENGAGED_MESSAGE',
  NeedsPendingFlagsReminder = 'NEEDS_PENDING_FLAGS_REMINDER',
  NeedsStudentCounterpartDisengagedMessage = 'NEEDS_STUDENT_COUNTERPART_DISENGAGED_MESSAGE',
  NeedsStudentSelfDisengagedMessage = 'NEEDS_STUDENT_SELF_DISENGAGED_MESSAGE',
  NeedsSuccessPlanReminder = 'NEEDS_SUCCESS_PLAN_REMINDER',
  PreviouslyRegisteredAsMentor = 'PREVIOUSLY_REGISTERED_AS_MENTOR',
  PreviouslyRegisteredAsStudent = 'PREVIOUSLY_REGISTERED_AS_STUDENT',
  ProgramHasEndAssessment = 'PROGRAM_HAS_END_ASSESSMENT',
  ProgramHasMidAssessment = 'PROGRAM_HAS_MID_ASSESSMENT',
  ProgramHasStartAssessment = 'PROGRAM_HAS_START_ASSESSMENT',
  ProgramIsEndingSoon = 'PROGRAM_IS_ENDING_SOON',
  ProgramStageIsEnd = 'PROGRAM_STAGE_IS_END',
  ProgramStageIsMid = 'PROGRAM_STAGE_IS_MID',
  ProgramStageIsStart = 'PROGRAM_STAGE_IS_START',
  PushedThroughToMatch = 'PUSHED_THROUGH_TO_MATCH',
  RecentHighSatisfactionScore = 'RECENT_HIGH_SATISFACTION_SCORE',
  RecentLowSatisfactionScore = 'RECENT_LOW_SATISFACTION_SCORE',
  Registered = 'REGISTERED',
  SignedUpForMentorTraining = 'SIGNED_UP_FOR_MENTOR_TRAINING',
  Uncommunicative = 'UNCOMMUNICATIVE'
}

/** The connection type for Topic. */
export type TopicConnection = {
  __typename?: 'TopicConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TopicEdge>>>;
  /** The collection of topic objects */
  nodes: Array<Topic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all outreach topics in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TopicEdge = {
  __typename?: 'TopicEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Topic>;
};

export type TopicMessage = {
  __typename?: 'TopicMessage';
  /** The new system email template */
  emailTemplate?: Maybe<EmailTemplate>;
  /** The number of days since the last message in this topic to wait before sending another message */
  hoursDelayAfterMessage: Scalars['Int']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The placement of this message relative to other messages in the topic */
  index: Scalars['Int']['output'];
  /** The preferred topic message medium */
  preferredMedium: Message;
  /** The new system sms template */
  smsTemplate?: Maybe<SmsTemplate>;
};

export type TopicsFilter = {
  /** filter by topic category */
  categories?: InputMaybe<Array<TopicCategory>>;
  /** filter topics that match any of the given conditions */
  conditions?: InputMaybe<Array<TopicConditionInput>>;
  /** filter topics that match exactly all of the conditions */
  exactConditions?: InputMaybe<Array<TopicConditionInput>>;
  /** filter by ids */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter for topics that are/are not archived */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for topics that are/are not default topics/campaigns */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for programs operated by specific PSOs */
  partnerSuccessOperatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by program segments */
  programSegments?: InputMaybe<Array<ProgramSegment>>;
  /** filter by a search term */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** filter by user states */
  userStates?: InputMaybe<Array<UserState>>;
};

export type TopicsSort = {
  /** Which field to sort by */
  column: TopicsSortByField;
  direction: SortDirection;
};

export enum TopicsSortByField {
  Name = 'NAME'
}

/** Objects tracked by PaperTrail */
export type TrackedObject = Mentor | MentorContact | Mentorship | MicroSurvey | Program | ProgramAlertDismissal | ProgramCustomMessageTemplate | ProgramGoal | ProgramSequence | ProgramTask | ProgramTopic | SavedMatch | SchoolIdentifier | Student | StudentContact | User;

export enum TrainingEvent {
  AttendedTraining = 'ATTENDED_TRAINING',
  Ghosted = 'GHOSTED',
  SignedUp = 'SIGNED_UP'
}

export type TrainingEventLog = Log & {
  __typename?: 'TrainingEventLog';
  /** The id */
  id: Scalars['ID']['output'];
  /** The type of event */
  kind: TrainingEvent;
  /** When the event was logged */
  loggedAtDate: Scalars['ISO8601DateTime']['output'];
  /** The participant who completed the event */
  participant: Participant;
};

export enum UnmatchInitiatedBy {
  McStaff = 'MC_STAFF',
  Mentor = 'MENTOR',
  ProgramAdministrator = 'PROGRAM_ADMINISTRATOR',
  Student = 'STUDENT'
}

/** Autogenerated return type of UnmatchParticipant. */
export type UnmatchParticipantPayload = {
  __typename?: 'UnmatchParticipantPayload';
  errors: Array<Error>;
  mentorship?: Maybe<Mentorship>;
  participant?: Maybe<Participant>;
};

/** Autogenerated return type of UnmatchParticipants. */
export type UnmatchParticipantsPayload = {
  __typename?: 'UnmatchParticipantsPayload';
  batchActionId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
};

export enum UnmatchReason {
  MenteeDisengaged = 'MENTEE_DISENGAGED',
  MenteeRemovedFromProgram = 'MENTEE_REMOVED_FROM_PROGRAM',
  MentorDisengaged = 'MENTOR_DISENGAGED',
  MentorRemovedFromProgram = 'MENTOR_REMOVED_FROM_PROGRAM',
  NotAGoodFit = 'NOT_A_GOOD_FIT',
  Other = 'OTHER'
}

/** Update Assessment Survey New Program Task input */
export type UpdateAssessmentSurveyNewProgramTaskInput = {
  assigneeEntity?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  newProgramTaskId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateAssessmentSurveyNewProgramTask. */
export type UpdateAssessmentSurveyNewProgramTaskPayload = {
  __typename?: 'UpdateAssessmentSurveyNewProgramTaskPayload';
  errors: Array<Error>;
  newProgramTask?: Maybe<NewProgramTask>;
};

/** Update Click Link New Program Task input */
export type UpdateClickLinkNewProgramTaskInput = {
  assigneeEntity?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  newProgramTaskId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateClickLinkNewProgramTask. */
export type UpdateClickLinkNewProgramTaskPayload = {
  __typename?: 'UpdateClickLinkNewProgramTaskPayload';
  errors: Array<Error>;
  newProgramTask?: Maybe<NewProgramTask>;
};

/** Update Click Link New Task input */
export type UpdateClickLinkNewTaskInput = {
  defaultAssigneeEntity?: InputMaybe<Scalars['String']['input']>;
  defaultDisplayName?: InputMaybe<Scalars['String']['input']>;
  internalTaskName?: InputMaybe<Scalars['String']['input']>;
  newTaskId: Scalars['ID']['input'];
  requiredForMatching?: InputMaybe<Scalars['Boolean']['input']>;
  segmentTags?: InputMaybe<Array<NewTaskSegmentTag>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateClickLinkNewTask. */
export type UpdateClickLinkNewTaskPayload = {
  __typename?: 'UpdateClickLinkNewTaskPayload';
  errors: Array<Error>;
  newTask?: Maybe<NewTask>;
};

/** Update Course New Program Task input */
export type UpdateCourseNewProgramTaskInput = {
  assigneeEntity?: InputMaybe<Scalars['String']['input']>;
  courseRequiredForMatching?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  newProgramTaskId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCourseNewProgramTask. */
export type UpdateCourseNewProgramTaskPayload = {
  __typename?: 'UpdateCourseNewProgramTaskPayload';
  errors: Array<Error>;
  newProgramTask?: Maybe<NewProgramTask>;
};

/** Update Course New Task input */
export type UpdateCourseNewTaskInput = {
  defaultAssigneeEntity?: InputMaybe<Scalars['String']['input']>;
  defaultDisplayName?: InputMaybe<Scalars['String']['input']>;
  mentorshipCredentialCredential?: InputMaybe<MentorshipCredentialCredentials>;
  newTaskId: Scalars['ID']['input'];
  requiredForMatching?: InputMaybe<Scalars['Boolean']['input']>;
  segmentTags?: InputMaybe<Array<NewTaskSegmentTag>>;
};

/** Autogenerated return type of UpdateCourseNewTask. */
export type UpdateCourseNewTaskPayload = {
  __typename?: 'UpdateCourseNewTaskPayload';
  errors: Array<Error>;
  newTask?: Maybe<NewTask>;
};

export type UpdateEmailTemplateInput = {
  category?: InputMaybe<MessageCategory>;
  content?: InputMaybe<Scalars['String']['input']>;
  customMessageType?: InputMaybe<ProgramCustomMessage>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplateId: Scalars['ID']['input'];
  messageType?: InputMaybe<Message>;
  name?: InputMaybe<Scalars['String']['input']>;
  preheaderText?: InputMaybe<Scalars['String']['input']>;
  programSegment?: InputMaybe<ProgramSegment>;
  subjectLine?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateEditorData?: InputMaybe<Scalars['JSON']['input']>;
  userState?: InputMaybe<UserState>;
};

/** Autogenerated return type of UpdateEmailTemplate. */
export type UpdateEmailTemplatePayload = {
  __typename?: 'UpdateEmailTemplatePayload';
  emailTemplate: EmailTemplate;
};

/** Autogenerated return type of UpdateFlagContact. */
export type UpdateFlagContactPayload = {
  __typename?: 'UpdateFlagContactPayload';
  errors: Array<InvalidFlagContactInputError>;
  flagContact?: Maybe<FlagContact>;
};

/** Autogenerated return type of UpdateFlag. */
export type UpdateFlagPayload = {
  __typename?: 'UpdateFlagPayload';
  errors: Array<Error>;
  /** The updated flag */
  flag: Flag;
};

/** A user-readable error */
export type UpdateMenteeMentorSettingsError = {
  __typename?: 'UpdateMenteeMentorSettingsError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: UpdateMenteeMentorSettingsErrorPaths;
};

export enum UpdateMenteeMentorSettingsErrorPaths {
  AllowsMenteesToPushThemselvesThroughToMatch = 'allowsMenteesToPushThemselvesThroughToMatch',
  AskForMenteeSidInSignup = 'askForMenteeSidInSignup',
  ReRecruitedMentorsCanSkipMatchingSurvey = 'reRecruitedMentorsCanSkipMatchingSurvey'
}

/** Mentee and Mentor settings */
export type UpdateMenteeMentorSettingsInput = {
  allowsMenteesToPushThemselvesThroughToMatch?: InputMaybe<Scalars['Boolean']['input']>;
  askForMenteeSidInSignup?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  reRecruitedMentorsCanSkipMatchingSurvey?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateMenteeMentorSettings. */
export type UpdateMenteeMentorSettingsPayload = {
  __typename?: 'UpdateMenteeMentorSettingsPayload';
  errors: Array<UpdateMenteeMentorSettingsError>;
  program?: Maybe<Program>;
};

/** MicroSurvey Input on update */
export type UpdateMicroSurveyInput = {
  expireAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id: Scalars['ID']['input'];
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  surveyName?: InputMaybe<Scalars['String']['input']>;
  surveyQuestion?: InputMaybe<SurveyQuestionInput>;
  targetingCriteria?: InputMaybe<MicroSurveyTargetingCriteriaInput>;
};

/** Autogenerated return type of UpdateMicroSurvey. */
export type UpdateMicroSurveyPayload = {
  __typename?: 'UpdateMicroSurveyPayload';
  microSurvey: MicroSurvey;
};

/** Update New Program Task input */
export type UpdateNewProgramTaskInput = {
  assigneeEntity?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  newProgramTaskId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateNewProgramTask. */
export type UpdateNewProgramTaskPayload = {
  __typename?: 'UpdateNewProgramTaskPayload';
  errors: Array<Error>;
  newProgramTask?: Maybe<NewProgramTask>;
};

/** Autogenerated return type of UpdateParticipant. */
export type UpdateParticipantPayload = {
  __typename?: 'UpdateParticipantPayload';
  /** These are errors in the input response data that we want to catch and handle appropriately (these won't prevent the rest of the GraphQL query from running), as opposed to execution errors */
  errors: Array<InvalidParticipantInputError>;
  participant?: Maybe<Participant>;
};

/** Autogenerated return type of UpdateParticipantsMatchingLabels. */
export type UpdateParticipantsMatchingLabelsPayload = {
  __typename?: 'UpdateParticipantsMatchingLabelsPayload';
  batchActionId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdatePartner. */
export type UpdatePartnerPayload = {
  __typename?: 'UpdatePartnerPayload';
  /** These are errors in the input response data that we want to catch and handle appropriately (these won't prevent the rest of the GraphQL query from running), as opposed to execution errors */
  errors: Array<InvalidUserInputError>;
  partner?: Maybe<Partner>;
  user?: Maybe<User>;
};

/** A user-readable error */
export type UpdateProgramAdminsError = {
  __typename?: 'UpdateProgramAdminsError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: UpdateProgramAdminsErrorPaths;
};

export enum UpdateProgramAdminsErrorPaths {
  PartnerSuccessOperatorId = 'partnerSuccessOperatorId',
  PartnerSuccessPointPersonId = 'partnerSuccessPointPersonId',
  UniversityRelationsDirectorId = 'universityRelationsDirectorId'
}

/** Program Admin Input on update */
export type UpdateProgramAdminsInput = {
  id: Scalars['ID']['input'];
  partnerSuccessOperatorId?: InputMaybe<Scalars['ID']['input']>;
  partnerSuccessPointPersonId?: InputMaybe<Scalars['ID']['input']>;
  universityRelationsDirectorId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateProgramAdmins. */
export type UpdateProgramAdminsPayload = {
  __typename?: 'UpdateProgramAdminsPayload';
  errors: Array<UpdateProgramAdminsError>;
  program?: Maybe<Program>;
};

export type UpdateProgramCommunicationSettingsInput = {
  communicationMediumPreference?: InputMaybe<Message>;
  programId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateProgramCommunicationSettings. */
export type UpdateProgramCommunicationSettingsPayload = {
  __typename?: 'UpdateProgramCommunicationSettingsPayload';
  program: Program;
};

export type UpdateProgramCustomLabelInput = {
  pluralMentee?: InputMaybe<Scalars['String']['input']>;
  pluralMentor?: InputMaybe<Scalars['String']['input']>;
  pluralMentorship?: InputMaybe<Scalars['String']['input']>;
  pluralSchool?: InputMaybe<Scalars['String']['input']>;
  pluralStudent?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  respectMenteeUppercase?: InputMaybe<Scalars['Boolean']['input']>;
  respectMentorUppercase?: InputMaybe<Scalars['Boolean']['input']>;
  respectMentorshipUppercase?: InputMaybe<Scalars['Boolean']['input']>;
  respectSchoolUppercase?: InputMaybe<Scalars['Boolean']['input']>;
  respectStudentUppercase?: InputMaybe<Scalars['Boolean']['input']>;
  singularMentee?: InputMaybe<Scalars['String']['input']>;
  singularMentor?: InputMaybe<Scalars['String']['input']>;
  singularMentorship?: InputMaybe<Scalars['String']['input']>;
  singularSchool?: InputMaybe<Scalars['String']['input']>;
  singularStudent?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateProgramCustomLabel. */
export type UpdateProgramCustomLabelPayload = {
  __typename?: 'UpdateProgramCustomLabelPayload';
  errors: Array<Error>;
  program?: Maybe<Program>;
};

export type UpdateProgramCustomMessageTemplatesDetailsInput = {
  /** The custom message type */
  customMessageType: ProgramCustomMessage;
  /** The message template id */
  templateId: Scalars['ID']['input'];
};

/** A user-readable error */
export type UpdateProgramCustomMessageTemplatesError = {
  __typename?: 'UpdateProgramCustomMessageTemplatesError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: UpdateProgramCustomMessageTemplatesErrorPaths;
};

export enum UpdateProgramCustomMessageTemplatesErrorPaths {
  TemplatesToUpdate = 'templatesToUpdate'
}

/** Program Content - configuring custom message templates (mentor/mentee matching) */
export type UpdateProgramCustomMessageTemplatesInput = {
  /** The program id */
  id: Scalars['ID']['input'];
  /** Template IDs and corresponding custom message types to update */
  templatesToUpdate: Array<UpdateProgramCustomMessageTemplatesDetailsInput>;
};

/** Autogenerated return type of UpdateProgramCustomMessageTemplates. */
export type UpdateProgramCustomMessageTemplatesPayload = {
  __typename?: 'UpdateProgramCustomMessageTemplatesPayload';
  errors: Array<UpdateProgramCustomMessageTemplatesError>;
  program?: Maybe<Program>;
};

/** A user-readable error */
export type UpdateProgramFlagContactsError = {
  __typename?: 'UpdateProgramFlagContactsError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: UpdateProgramFlagContactsErrorPaths;
};

export enum UpdateProgramFlagContactsErrorPaths {
  Base = 'base',
  FlagContactEmail = 'flagContactEmail',
  FlagContactFirstName = 'flagContactFirstName',
  FlagContactLastName = 'flagContactLastName',
  SecondaryFlagContactCcEmails = 'secondaryFlagContactCcEmails',
  SendFlagsToExternalContact = 'sendFlagsToExternalContact'
}

/** Program Point People Input on update */
export type UpdateProgramFlagContactsInput = {
  flagContactEmail?: InputMaybe<Scalars['String']['input']>;
  flagContactFirstName?: InputMaybe<Scalars['String']['input']>;
  flagContactLastName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  secondaryFlagContactCcEmails?: InputMaybe<Scalars['String']['input']>;
  sendFlagsToExternalContact?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateProgramFlagContacts. */
export type UpdateProgramFlagContactsPayload = {
  __typename?: 'UpdateProgramFlagContactsPayload';
  errors: Array<UpdateProgramFlagContactsError>;
  program?: Maybe<Program>;
};

/** A user-readable error */
export type UpdateProgramInfoError = {
  __typename?: 'UpdateProgramInfoError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: UpdateProgramInfoErrorPaths;
};

export enum UpdateProgramInfoErrorPaths {
  AccountNotes = 'accountNotes',
  AllowMatching = 'allowMatching',
  AllowMenteeSignUp = 'allowMenteeSignUp',
  AllowMentorSignUp = 'allowMentorSignUp',
  CurrentStage = 'currentStage',
  DefaultProfileImage = 'defaultProfileImage',
  IsTemplateProgram = 'isTemplateProgram',
  IsTestProgram = 'isTestProgram',
  MenteeLoginMode = 'menteeLoginMode',
  MentorLoginMode = 'mentorLoginMode',
  Name = 'name',
  NonPriorityFlagEmailEnabled = 'nonPriorityFlagEmailEnabled',
  Notes = 'notes',
  ProgramInfoUrl = 'programInfoUrl',
  ProgramLogo = 'programLogo',
  SftpExportEnabled = 'sftpExportEnabled',
  ShareMenteeEmail = 'shareMenteeEmail',
  ShareMenteePhone = 'shareMenteePhone',
  ShareMentorEmail = 'shareMentorEmail',
  ShareMentorPhone = 'shareMentorPhone',
  ShortName = 'shortName',
  Title = 'title'
}

/** Program Info Input on update */
export type UpdateProgramInfoInput = {
  accountNotes?: InputMaybe<Scalars['String']['input']>;
  allowMatching?: InputMaybe<Scalars['Boolean']['input']>;
  allowMenteeSignUp?: InputMaybe<Scalars['Boolean']['input']>;
  allowMentorSignUp?: InputMaybe<Scalars['Boolean']['input']>;
  currentStage?: InputMaybe<ProgramStage>;
  defaultProfileImage?: InputMaybe<Scalars['File']['input']>;
  id: Scalars['ID']['input'];
  isTemplateProgram?: InputMaybe<Scalars['Boolean']['input']>;
  isTestProgram?: InputMaybe<Scalars['Boolean']['input']>;
  menteeLoginMode?: InputMaybe<ProgramMenteeLoginMode>;
  mentorLoginMode?: InputMaybe<ProgramMentorLoginMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonPriorityFlagEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  programInfoUrl?: InputMaybe<Scalars['String']['input']>;
  programLogo?: InputMaybe<Scalars['File']['input']>;
  sftpExportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  shareMenteeEmail?: InputMaybe<Scalars['Boolean']['input']>;
  shareMenteePhone?: InputMaybe<Scalars['Boolean']['input']>;
  shareMentorEmail?: InputMaybe<Scalars['Boolean']['input']>;
  shareMentorPhone?: InputMaybe<Scalars['Boolean']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateProgramInfo. */
export type UpdateProgramInfoPayload = {
  __typename?: 'UpdateProgramInfoPayload';
  errors: Array<UpdateProgramInfoError>;
  program?: Maybe<Program>;
};

/** A user-readable error */
export type UpdateProgramPointPeopleError = {
  __typename?: 'UpdateProgramPointPeopleError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: UpdateProgramPointPeopleErrorPaths;
};

export enum UpdateProgramPointPeopleErrorPaths {
  Base = 'base',
  MentorPointPersonEmail = 'mentorPointPersonEmail',
  MentorPointPersonFirstName = 'mentorPointPersonFirstName',
  MentorPointPersonLastName = 'mentorPointPersonLastName',
  MentorPointPersonTitle = 'mentorPointPersonTitle',
  StudentPointPersonEmail = 'studentPointPersonEmail',
  StudentPointPersonFirstName = 'studentPointPersonFirstName',
  StudentPointPersonLastName = 'studentPointPersonLastName',
  StudentPointPersonTitle = 'studentPointPersonTitle'
}

/** Program Point People Input on update */
export type UpdateProgramPointPeopleInput = {
  id: Scalars['ID']['input'];
  mentorPointPersonEmail?: InputMaybe<Scalars['String']['input']>;
  mentorPointPersonFirstName?: InputMaybe<Scalars['String']['input']>;
  mentorPointPersonLastName?: InputMaybe<Scalars['String']['input']>;
  mentorPointPersonTitle?: InputMaybe<Scalars['String']['input']>;
  studentPointPersonEmail?: InputMaybe<Scalars['String']['input']>;
  studentPointPersonFirstName?: InputMaybe<Scalars['String']['input']>;
  studentPointPersonLastName?: InputMaybe<Scalars['String']['input']>;
  studentPointPersonTitle?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateProgramPointPeople. */
export type UpdateProgramPointPeoplePayload = {
  __typename?: 'UpdateProgramPointPeoplePayload';
  errors: Array<UpdateProgramPointPeopleError>;
  program?: Maybe<Program>;
};

/** Update program profile attribute input */
export type UpdateProgramProfileAttributeInput = {
  availableInPartnerDashboardExports: Scalars['Boolean']['input'];
  availableInPartnerDashboardFilters: Scalars['Boolean']['input'];
  availableInPartnerDashboardProgramIntelligenceChart: Scalars['Boolean']['input'];
  id: Scalars['MCID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateProgramProfileAttributes. */
export type UpdateProgramProfileAttributesPayload = {
  __typename?: 'UpdateProgramProfileAttributesPayload';
  /** Any errors trying to update the program profile attribute */
  errors: Array<ProgramProfileAttributeUnableToBeUpdated>;
  /** The updated program profile attributes */
  updatedProgramProfileAttributes: Array<ProgramProfileAttribute>;
};

/** A user-readable error */
export type UpdateProgramSequenceInfoError = {
  __typename?: 'UpdateProgramSequenceInfoError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: UpdateProgramSequenceInfoErrorPaths;
};

export enum UpdateProgramSequenceInfoErrorPaths {
  Name = 'name',
  SchoolId = 'schoolId',
  UrlSlug = 'urlSlug'
}

/** Program Sequence Info Input on update */
export type UpdateProgramSequenceInfoInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  urlSlug?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateProgramSequenceInfo. */
export type UpdateProgramSequenceInfoPayload = {
  __typename?: 'UpdateProgramSequenceInfoPayload';
  errors: Array<UpdateProgramSequenceInfoError>;
  programSequence?: Maybe<ProgramSequence>;
};

/** A user-readable error */
export type UpdateProgramSetupError = {
  __typename?: 'UpdateProgramSetupError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: UpdateProgramSetupErrorPaths;
};

export enum UpdateProgramSetupErrorPaths {
  EndDate = 'endDate',
  MatchingCap = 'matchingCap',
  MentorType = 'mentorType',
  ProgramCohorts = 'programCohorts',
  ProgramGoalTarget = 'programGoalTarget',
  ProgramGoalType = 'programGoalType',
  ProgramSequenceHigherEdSegment = 'programSequenceHigherEdSegment',
  ProgramSequenceId = 'programSequenceId',
  ProgramSequenceKind = 'programSequenceKind',
  SalesforceOpportunityId = 'salesforceOpportunityId',
  StartDate = 'startDate'
}

/** Program Setup Input on update */
export type UpdateProgramSetupInput = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  id: Scalars['ID']['input'];
  matchingCap?: InputMaybe<Scalars['Int']['input']>;
  mentorType?: InputMaybe<MentorTypes>;
  programCohorts?: InputMaybe<Array<ProgramCohort>>;
  programGoalTarget?: InputMaybe<Scalars['Int']['input']>;
  programGoalType?: InputMaybe<ProgramGoalWithNoGoalTypes>;
  programSequenceHigherEdSegment?: InputMaybe<ProgramSegment>;
  programSequenceId?: InputMaybe<Scalars['ID']['input']>;
  programSequenceKind?: InputMaybe<ProgramSequenceKindTypes>;
  salesforceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of UpdateProgramSetup. */
export type UpdateProgramSetupPayload = {
  __typename?: 'UpdateProgramSetupPayload';
  errors: Array<UpdateProgramSetupError>;
  program?: Maybe<Program>;
};

/** Program task input */
export type UpdateProgramTaskInput = {
  direction?: InputMaybe<DirectionEnum>;
  id?: InputMaybe<Scalars['ID']['input']>;
  visibleToMentors?: InputMaybe<Scalars['Boolean']['input']>;
  visibleToStudents?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateProgramTask. */
export type UpdateProgramTaskPayload = {
  __typename?: 'UpdateProgramTaskPayload';
  programTask: ProgramTask;
};

export type UpdateProgramTopicInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programTopicId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  topicId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateProgramTopic. */
export type UpdateProgramTopicPayload = {
  __typename?: 'UpdateProgramTopicPayload';
  programTopic: ProgramTopic;
};

export type UpdateProgramTopicsDetailsInput = {
  delayBeforeRestart?: InputMaybe<Scalars['Int']['input']>;
  topicId: Scalars['ID']['input'];
};

/** A user-readable error */
export type UpdateProgramTopicsError = {
  __typename?: 'UpdateProgramTopicsError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: UpdateProgramTopicsErrorPaths;
};

export enum UpdateProgramTopicsErrorPaths {
  TopicIdsToDisable = 'topicIdsToDisable',
  TopicsToEnable = 'topicsToEnable'
}

/** Program Communications */
export type UpdateProgramTopicsInput = {
  /** The ID of the Program is for */
  id: Scalars['ID']['input'];
  /** The IDs of the topics that will be disabled for this program */
  topicIdsToDisable?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The IDs & delay before restart of the topics that will be enabled for this program */
  topicsToEnable?: InputMaybe<Array<UpdateProgramTopicsDetailsInput>>;
};

/** Autogenerated return type of UpdateProgramTopics. */
export type UpdateProgramTopicsPayload = {
  __typename?: 'UpdateProgramTopicsPayload';
  errors: Array<UpdateProgramTopicsError>;
  program?: Maybe<Program>;
};

/** A user-readable error */
export type UpdateSchoolInfoError = {
  __typename?: 'UpdateSchoolInfoError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: UpdateSchoolInfoErrorPaths;
};

export enum UpdateSchoolInfoErrorPaths {
  InstitutionRegion = 'institutionRegion',
  InstitutionType = 'institutionType',
  IsMinorityServingInstitution = 'isMinorityServingInstitution',
  Logo = 'logo',
  Name = 'name',
  PublicOrPrivate = 'publicOrPrivate',
  ShortName = 'shortName',
  SsoBrand = 'ssoBrand',
  SsoEnabled = 'ssoEnabled',
  SsoProviderIdentifier = 'ssoProviderIdentifier',
  SsoRequiredForPartners = 'ssoRequiredForPartners',
  Subdomain = 'subdomain',
  TwoOrFourYear = 'twoOrFourYear'
}

/** School Info Input on update */
export type UpdateSchoolInfoInput = {
  id: Scalars['ID']['input'];
  institutionRegion?: InputMaybe<InstitutionRegion>;
  institutionType?: InputMaybe<Institution>;
  isMinorityServingInstitution?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['File']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicOrPrivate?: InputMaybe<PublicOrPrivate>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  ssoBrand?: InputMaybe<Scalars['String']['input']>;
  ssoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ssoProviderIdentifier?: InputMaybe<Scalars['String']['input']>;
  ssoRequiredForPartners?: InputMaybe<Scalars['Boolean']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  twoOrFourYear?: InputMaybe<HigherEducation>;
};

/** Autogenerated return type of UpdateSchoolInfo. */
export type UpdateSchoolInfoPayload = {
  __typename?: 'UpdateSchoolInfoPayload';
  errors: Array<UpdateSchoolInfoError>;
  school?: Maybe<School>;
};

export type UpdateSmsTemplateInput = {
  category?: InputMaybe<MessageCategory>;
  content?: InputMaybe<Scalars['String']['input']>;
  customMessageType?: InputMaybe<ProgramCustomMessage>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplateId: Scalars['ID']['input'];
  messageType?: InputMaybe<Message>;
  name?: InputMaybe<Scalars['String']['input']>;
  programSegment?: InputMaybe<ProgramSegment>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userState?: InputMaybe<UserState>;
};

/** Autogenerated return type of UpdateSmsTemplate. */
export type UpdateSmsTemplatePayload = {
  __typename?: 'UpdateSmsTemplatePayload';
  smsTemplate: SmsTemplate;
};

/** A user-readable error */
export type UpdateSurveysAndQuizzesError = {
  __typename?: 'UpdateSurveysAndQuizzesError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: UpdateSurveysAndQuizzesErrorPaths;
};

export enum UpdateSurveysAndQuizzesErrorPaths {
  MenteeQuizTaskId = 'menteeQuizTaskId',
  MentorMatchingSurveyId = 'mentorMatchingSurveyId',
  MentorPostSessionSurveyId = 'mentorPostSessionSurveyId',
  ShowMatchingSurveysToPartner = 'showMatchingSurveysToPartner',
  StudentMatchingSurveyId = 'studentMatchingSurveyId',
  StudentPostSessionSurveyId = 'studentPostSessionSurveyId'
}

/** Program Surveys and Quizzes Input on update */
export type UpdateSurveysAndQuizzesInput = {
  id: Scalars['ID']['input'];
  menteeQuizTaskId?: InputMaybe<Scalars['ID']['input']>;
  mentorMatchingSurveyId?: InputMaybe<Scalars['ID']['input']>;
  mentorPostSessionSurveyId?: InputMaybe<Scalars['ID']['input']>;
  showMatchingSurveysToPartner?: InputMaybe<Scalars['Boolean']['input']>;
  studentMatchingSurveyId?: InputMaybe<Scalars['ID']['input']>;
  studentPostSessionSurveyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateSurveysAndQuizzes. */
export type UpdateSurveysAndQuizzesPayload = {
  __typename?: 'UpdateSurveysAndQuizzesPayload';
  errors: Array<UpdateSurveysAndQuizzesError>;
  program?: Maybe<Program>;
};

export type UpdateTopicConditionInput = {
  key: TopicConditionKey;
  value: Scalars['Boolean']['input'];
};

export type UpdateTopicInput = {
  archivedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  category?: InputMaybe<TopicCategory>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
  programSegment?: InputMaybe<ProgramSegment>;
  topicConditions?: InputMaybe<Array<UpdateTopicConditionInput>>;
  topicId: Scalars['ID']['input'];
  topicMessagesToAdd?: InputMaybe<Array<NewTopicMessageInput>>;
  topicMessagesToRemoveIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  topicMessagesToUpdate?: InputMaybe<Array<UpdateTopicMessageInput>>;
  userState?: InputMaybe<UserState>;
};

export type UpdateTopicMessageInput = {
  emailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  hoursDelayAfterMessage?: InputMaybe<Scalars['Int']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  preferredMedium?: InputMaybe<Message>;
  smsTemplateId?: InputMaybe<Scalars['ID']['input']>;
  topicMessageId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTopic. */
export type UpdateTopicPayload = {
  __typename?: 'UpdateTopicPayload';
  topic: Topic;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** These are errors in the input response data that we want to catch and handle appropriately (these won't prevent the rest of the GraphQL query from running), as opposed to execution errors */
  errors: Array<InvalidUserInputError>;
  user?: Maybe<User>;
};

export type UploadPhotoTask = Task & {
  __typename?: 'UploadPhotoTask';
  /** Custom text for the task's call to action button after the user clicks it */
  customAfterCallToAction?: Maybe<Scalars['String']['output']>;
  /** Custom text for the task's call to action button before the user clicks it */
  customCallToAction?: Maybe<Scalars['String']['output']>;
  /** The id of this task */
  id: Scalars['ID']['output'];
  /** The name of this task stored in the DB */
  name?: Maybe<Scalars['String']['output']>;
  /** The prompt to show users when showing this as a task to be completed */
  prompt: Scalars['String']['output'];
};

export type UploadUserProfileDataColumnMappingInput = {
  column: Scalars['String']['input'];
  existingAttributeId?: InputMaybe<Scalars['ID']['input']>;
  newAttributeValues?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UploadUserProfileDataInput = {
  columnMappings: Array<UploadUserProfileDataColumnMappingInput>;
  emailIdentifierColumn: Scalars['String']['input'];
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
};

/** Autogenerated return type of UploadUserProfileData. */
export type UploadUserProfileDataPayload = {
  __typename?: 'UploadUserProfileDataPayload';
  batchActionId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
};

export type UploadVideoTask = Task & {
  __typename?: 'UploadVideoTask';
  /** Custom text for the task's call to action button after the user clicks it */
  customAfterCallToAction?: Maybe<Scalars['String']['output']>;
  /** Custom text for the task's call to action button before the user clicks it */
  customCallToAction?: Maybe<Scalars['String']['output']>;
  /** The id of this task */
  id: Scalars['ID']['output'];
  /** The name of this task stored in the DB */
  name?: Maybe<Scalars['String']['output']>;
  /** The prompt to show users when showing this as a task to be completed */
  prompt: Scalars['String']['output'];
};

export type UploadedVideo = {
  __typename?: 'UploadedVideo';
  /** The id */
  id: Scalars['ID']['output'];
  /** The creator of the video */
  participant: Participant;
  /** Can video be shared with MentorCollective */
  sharePublicly?: Maybe<Scalars['Boolean']['output']>;
  /** Can video be shared with students */
  shareWithStudents?: Maybe<Scalars['Boolean']['output']>;
  /** The url of the video */
  url?: Maybe<Scalars['String']['output']>;
  /** The ziggeo identifier */
  ziggeoToken: Scalars['String']['output'];
};

/** The connection type for UploadedVideo. */
export type UploadedVideoConnection = {
  __typename?: 'UploadedVideoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UploadedVideoEdge>>>;
  /** The collection of participant objects */
  nodes: Array<UploadedVideo>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all participants in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UploadedVideoEdge = {
  __typename?: 'UploadedVideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UploadedVideo>;
};

export type UploadedVideoFilter = {
  /** Returns only the most recent video uploaded by participant */
  onlyLatestForEachParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  /** Program id to filter by */
  programId: Scalars['ID']['input'];
  /** Search string to filter by participant first name and last name */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** Returns public or private videos depending on the value */
  sharePublicly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Returns videos that can be shared with students */
  shareWithStudents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UploadedVideoSort = {
  /** Which field to sort by */
  column: UploadedVideosSortByField;
  direction: SortDirection;
};

export enum UploadedVideosSortByField {
  CreatedAt = 'CREATED_AT'
}

export type User = {
  __typename?: 'User';
  /** The active shearwater admin record for this user */
  activeShearwaterAdministrator?: Maybe<ShearwaterAdministrator>;
  /**
   * URL to the user's avatar if any (does not include any program default avatars)
   * @deprecated Use avatarImage instead, which leverages activestorage to provide on-the-fly image variants
   */
  avatar?: Maybe<Scalars['String']['output']>;
  /** URL to the user's avatar if any (does not include any program default avatars) */
  avatarImage?: Maybe<Image>;
  /** The user's profile attribute values */
  cachedUserProfileData?: Maybe<Array<CachedUserProfileDataAttributeValue>>;
  /** All of the contacts for this user */
  contacts: Array<Contact>;
  /** When the user was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The users's email address */
  email?: Maybe<Scalars['String']['output']>;
  /** The url of this user's facebook profile */
  facebookUrl?: Maybe<Scalars['String']['output']>;
  /** A user's first name */
  firstName: Scalars['String']['output'];
  /** Does this user have a valid SSO token? */
  hasValidSsoToken: Scalars['Boolean']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The url of this user's instagram profile */
  instagramUrl?: Maybe<Scalars['String']['output']>;
  /** Is the user an MC admin? */
  isAdmin: Scalars['Boolean']['output'];
  /** Whether a user has access to this feature */
  isFeatureEnabledFor: Scalars['Boolean']['output'];
  /** Whether a user is a mentor in any matched mentorships which are part of a chat group */
  isMentorInChatGroup: Scalars['Boolean']['output'];
  /** Is the user an partner? */
  isPartner: Scalars['Boolean']['output'];
  /** A users's last name */
  lastName: Scalars['String']['output'];
  /** The last time a user visited the the activity page of the program specified. This field is available at the user level because it is a closer representation of the current structure of our data model. */
  lastProgramPageVisit?: Maybe<ProgramPageVisit>;
  /** When the user last signed in */
  lastSignInAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the request comes from 'partner_dashboard' or 'participant'dashboard' */
  latestDashboardNotificationData?: Maybe<NotificationData>;
  /** Latest program the user has been a partner in for a school */
  latestPartnerProgramForSchool?: Maybe<Program>;
  /** The url of this user's linkedin profile */
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  /** The credentials for the user has earned */
  mentorshipCredentials: Array<UserMentorshipCredential>;
  /** The user's microsurvey - if available */
  microSurvey?: Maybe<MicroSurvey>;
  /** All of the participants for this user */
  participants: Array<Participant>;
  /** All of the partner records for this user */
  partners: Array<Partner>;
  /** A user's provided phone (not school-provided) */
  phone?: Maybe<Scalars['String']['output']>;
  /** A user's provided phone's country */
  phoneCountry?: Maybe<Country>;
  /** A user's profile */
  profile: Profile;
  /** Any school identifiers for the user */
  schoolIdentifiers: Array<SchoolIdentifier>;
  /** Did this user sign up with SSO? */
  signedUpWithSso: Scalars['Boolean']['output'];
  /** This participants survey responses */
  surveyResponses: Array<SurveyResponse>;
  /** The url of this user's twitter profile */
  twitterUrl?: Maybe<Scalars['String']['output']>;
  /** Is the user unsubscribed from emails? */
  unsubscribedFromEmails: Scalars['Boolean']['output'];
  /** Is the user unsubscribed from SMSes? */
  unsubscribedFromSmses: Scalars['Boolean']['output'];
  /** The user's profile attribute values */
  userProfileData?: Maybe<Array<UserProfileData>>;
  /** The user status for a given program */
  userStatusInProgram?: Maybe<UserProgramStatus>;
};


export type UserAvatarImageArgs = {
  programId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserCachedUserProfileDataArgs = {
  attributes: Array<CachedUserProfileDataAttributeInput>;
  cacheSettings: CachedUserProfileDataSettingsFilter;
  programId: Scalars['ID']['input'];
};


export type UserContactsArgs = {
  programId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserHasValidSsoTokenArgs = {
  programId: Scalars['ID']['input'];
};


export type UserIsFeatureEnabledForArgs = {
  feature: Scalars['String']['input'];
};


export type UserLastProgramPageVisitArgs = {
  path: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
};


export type UserLatestDashboardNotificationDataArgs = {
  requestOrigin: Scalars['String']['input'];
};


export type UserLatestPartnerProgramForSchoolArgs = {
  schoolId: Scalars['ID']['input'];
};


export type UserMentorshipCredentialsArgs = {
  credentials?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type UserParticipantsArgs = {
  programId?: InputMaybe<Scalars['ID']['input']>;
  registered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserPartnersArgs = {
  registered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserSurveyResponsesArgs = {
  context?: InputMaybe<SurveyResponseContextFilter>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserUserProfileDataArgs = {
  attributes: Array<UserProfileDataAttributeInput>;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule>>;
  programId: Scalars['ID']['input'];
  source: ProfileAttributeSource;
};


export type UserUserStatusInProgramArgs = {
  programId: Scalars['ID']['input'];
};

export type UserAssessmentScoresFilter = {
  /** The identifier of the assessment area (e.g. sob for Sense of Belonging) to filter by */
  assessmentAreaIdentifier: Scalars['String']['input'];
  /** The exact score to filter by */
  exactScore?: InputMaybe<Scalars['Float']['input']>;
  /** The maximum score to filter by */
  maxScore?: InputMaybe<Scalars['Float']['input']>;
  /** The minimum score to filter by */
  minScore?: InputMaybe<Scalars['Float']['input']>;
  /** The id of the program to filter by */
  programId: Scalars['MCID']['input'];
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** The collection of school objects */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all old users in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** User Input */
export type UserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<ProfileInput>;
  userId: Scalars['ID']['input'];
};

export type UserMentorshipCredential = {
  __typename?: 'UserMentorshipCredential';
  /** The date the credential was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** Mentorship credential that is fulfilled when this task is completed */
  mentorshipCredential?: Maybe<MentorshipCredential>;
  /** The date the credential was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type UserMentorshipCredentialsFilter = {
  /** The identifier of the credential to filter by */
  credential: Scalars['String']['input'];
  /** Whether the credential has been earned or not */
  earned: Scalars['Boolean']['input'];
  /** Whether the credential has been earned after the given date */
  earnedAfterDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Whether the credential has been earned before the given date */
  earnedBeforeDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type UserProfileAttributeValue = {
  __typename?: 'UserProfileAttributeValue';
  /** The id */
  id: Scalars['ID']['output'];
  /** The open response provided by the user, if applicable */
  openResponse?: Maybe<Scalars['String']['output']>;
  /** The profile attribute value object */
  profileAttributeValue: ProfileAttributeValue;
  /** The user profile attribute value update object */
  userProfileAttributeValueUpdate: UserProfileAttributeValueUpdate;
};

export type UserProfileAttributeValueFilter = {
  /** The id of the category to filter by */
  attributeCategoryId?: InputMaybe<Scalars['MCID']['input']>;
  /** The id of the attribute to filter by */
  attributeId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of the attribute to filter by */
  attributeType?: InputMaybe<ProfileAttributeType>;
  /** The values to filter by */
  attributeValues: Array<Scalars['String']['input']>;
  /** The exact numeric value to filter by */
  exactNumericValue?: InputMaybe<Scalars['Float']['input']>;
  /** Fallback rules */
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule>>;
  /** The maximum numeric value to filter by */
  maxNumericValue?: InputMaybe<Scalars['Float']['input']>;
  /** The minimum numeric value to filter by */
  minNumericValue?: InputMaybe<Scalars['Float']['input']>;
  /** The source of the value */
  source: ProfileAttributeSource;
};

export type UserProfileAttributeValueUpdate = {
  __typename?: 'UserProfileAttributeValueUpdate';
  /** The date the updated was recorded on */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The program this update was recorded in */
  programId: Scalars['ID']['output'];
  /** The source of the update, such as user or institution */
  source: ProfileAttributeSource;
};

export type UserProfileData = {
  __typename?: 'UserProfileData';
  /** The profile data associated with the user */
  profileAttribute: ProfileAttribute;
  /** The array of values a user selected for this attribute */
  values: Array<UserProfileAttributeValue>;
};

export type UserProfileDataAttributeInput = {
  attributeCategoryId?: InputMaybe<Scalars['MCID']['input']>;
  attributeId?: InputMaybe<Scalars['Int']['input']>;
  attributeType?: InputMaybe<ProfileAttributeType>;
};

export type UserProfileDataColumnInput = {
  attribute: UserProfileDataAttributeInput;
  columnName: Scalars['String']['input'];
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule>>;
  programId: Scalars['MCID']['input'];
  source: ProfileAttributeSource;
};

export type UserProfileDataFallbackRule = {
  allowFallbackToOtherPrograms?: InputMaybe<AllowFallbackToOtherPrograms>;
  allowFallbackToOtherSource?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UserProgramStatus {
  CompletedOnboarding = 'COMPLETED_ONBOARDING',
  ExitedAfterBeingUnmatched = 'EXITED_AFTER_BEING_UNMATCHED',
  ExitedAfterCompletingOnboarding = 'EXITED_AFTER_COMPLETING_ONBOARDING',
  ExitedAfterRegistering = 'EXITED_AFTER_REGISTERING',
  Invited = 'INVITED',
  Matched = 'MATCHED',
  Registered = 'REGISTERED',
  Unmatched = 'UNMATCHED'
}

export enum UserState {
  Contact = 'CONTACT',
  McAdmin = 'MC_ADMIN',
  Mentor = 'MENTOR',
  MentorContact = 'MENTOR_CONTACT',
  MentorMentorship = 'MENTOR_MENTORSHIP',
  Participant = 'PARTICIPANT',
  Partner = 'PARTNER',
  Student = 'STUDENT',
  StudentContact = 'STUDENT_CONTACT',
  StudentMentorship = 'STUDENT_MENTORSHIP'
}

export enum UserStateFilter {
  SurveyTemplateList = 'SURVEY_TEMPLATE_LIST'
}

export type UserStateVariable = {
  __typename?: 'UserStateVariable';
  /** The name */
  name: Scalars['String']['output'];
  /** The variable path */
  path: Scalars['String']['output'];
  /** Preview value */
  previewValue?: Maybe<Scalars['String']['output']>;
};

export enum UsersExportFirstColumn {
  MatchingSurveyCompleted = 'MATCHING_SURVEY_COMPLETED',
  MentorshipOptIn = 'MENTORSHIP_OPT_IN',
  Registered = 'REGISTERED',
  TrainingCompleted = 'TRAINING_COMPLETED'
}

export type UsersExportResultModifiers = {
  /** This modifies the results to only include touchpoints created after this date when calculating the total number of touchpoints */
  touchpointsCreatedAfterDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** This modifies the results to only include touchpoints created before this date when calculating the total number of touchpoints */
  touchpointsCreatedBeforeDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type UsersFilter = {
  /** filter by assessment score value */
  assessmentFilters?: InputMaybe<Array<UserAssessmentScoresFilter>>;
  /** filter by attributes on the participant AND/OR contact */
  contactsParticipantsFilter?: InputMaybe<ContactsParticipantsFilter>;
  /** filter by a user's credentials */
  credentialFilters?: InputMaybe<Array<UserMentorshipCredentialsFilter>>;
  /** filter by whether user is an admin */
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter for users that have a minimum number touchpoints */
  minimumNumberOfStudentTouchpoints?: InputMaybe<MinimumNumberOfTouchpointsFilter>;
  /** filter for users that have a specific number of touchpoints */
  numberOfStudentTouchpoints?: InputMaybe<NumberOfTouchpointsFilter>;
  /** filter by a user's primary email address in the email_addresses table */
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  /** filter by a search term, limited to user first/last name and email */
  simpleSearchString?: InputMaybe<Scalars['String']['input']>;
  /** filter by a users status in a particular program */
  statusInProgram?: InputMaybe<StatusInProgramFilter>;
  /** filter by user ids */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by profile attribute values that match the criteria of each filter */
  valueFilters?: InputMaybe<Array<UserProfileAttributeValueFilter>>;
};

export type UsersGroupBy = {
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule>>;
  preferredProgramId: Scalars['ID']['input'];
  preferredSource: ProfileAttributeSource;
  /** The id of the category to filter by */
  profileAttributeCategoryId?: InputMaybe<Scalars['MCID']['input']>;
  profileAttributeNumericValueGroups?: InputMaybe<Array<ProfileAttributeNumericValueGroup>>;
  profileAttributeType?: InputMaybe<ProfileAttributeType>;
};

export type UsersMetrics = {
  __typename?: 'UsersMetrics';
  totalEnteredProgram: Array<Interval>;
  totalMinimumTouchpoints: Array<Interval>;
  totalRepliesToMcTextMessages: Array<Interval>;
  totalZeroTouchpoints: Array<Interval>;
};


export type UsersMetricsTotalEnteredProgramArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<UsersGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  programIds: Array<Scalars['ID']['input']>;
};


export type UsersMetricsTotalMinimumTouchpointsArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<UsersGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  minimumNumberTouchpoints: Scalars['Int']['input'];
  programIds: Array<Scalars['ID']['input']>;
};


export type UsersMetricsTotalRepliesToMcTextMessagesArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<UsersGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  programIds: Array<Scalars['ID']['input']>;
};


export type UsersMetricsTotalZeroTouchpointsArgs = {
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<UsersGroupBy>;
  intervalBy: TimePeriod;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  programIds: Array<Scalars['ID']['input']>;
};

export type UsersSort = {
  /** Which field to sort by */
  column: UsersSortByField;
  direction: SortDirection;
};

export enum UsersSortByField {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastName = 'LAST_NAME'
}

export type WatchVideoTask = Task & {
  __typename?: 'WatchVideoTask';
  /** Custom text for the task's call to action button after the user clicks it */
  customAfterCallToAction?: Maybe<Scalars['String']['output']>;
  /** Custom text for the task's call to action button before the user clicks it */
  customCallToAction?: Maybe<Scalars['String']['output']>;
  /** The id of this task */
  id: Scalars['ID']['output'];
  /** The name of this task stored in the DB */
  name?: Maybe<Scalars['String']['output']>;
  /** The prompt to show users when showing this as a task to be completed */
  prompt: Scalars['String']['output'];
  /** The id provided by Wistia to link to the uploaded video */
  wistiaVideoId: Scalars['String']['output'];
};

export type WatchedCommunityVideoLog = Log & {
  __typename?: 'WatchedCommunityVideoLog';
  /** The id */
  id: Scalars['ID']['output'];
  /** When the event was logged */
  loggedAtDate: Scalars['ISO8601DateTime']['output'];
  /** The ziggeo_token of the video logged */
  ziggeoToken: Scalars['String']['output'];
};

export type WatchedVideoLog = Log & {
  __typename?: 'WatchedVideoLog';
  /** The id */
  id: Scalars['ID']['output'];
  /** When the event was logged */
  loggedAtDate: Scalars['ISO8601DateTime']['output'];
  /** The id of the video logged */
  wistiaVideoId: Scalars['String']['output'];
};

export type WrittenMessage = {
  __typename?: 'WrittenMessage';
  /** The content of a written message */
  content: Scalars['String']['output'];
  /** The id */
  id: Scalars['ID']['output'];
  /** The owner of the message */
  participant: Participant;
};

/** The connection type for WrittenMessage. */
export type WrittenMessageConnection = {
  __typename?: 'WrittenMessageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WrittenMessageEdge>>>;
  /** The collection of written message objects */
  nodes: Array<WrittenMessage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total count of all written messages in the collection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WrittenMessageEdge = {
  __typename?: 'WrittenMessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WrittenMessage>;
};

export type WrittenMessageFilter = {
  /** A minimum character length for message to be returned */
  messageLengthMinimum?: InputMaybe<Scalars['Int']['input']>;
  /** Returns only the most recent message added by participant */
  onlyLatestForEachParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  /** Program id to filter by */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /** Search string to filter by participant first name and last name */
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user marked this message as okay to share publicly or not */
  sharePublicly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WrittenMessageSort = {
  /** Which field to sort by */
  column: WrittenMessagesSortByField;
  direction: SortDirection;
};

export enum WrittenMessagesSortByField {
  CreatedAt = 'CREATED_AT'
}

export type MessageTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MessageTemplateQuery = { __typename?: 'Query', messageTemplate: { __typename?: 'EmailTemplate', id: string, messageType: Message, name: string, archivedAt?: any | null } | { __typename?: 'SmsTemplate', id: string, messageType: Message, name: string, archivedAt?: any | null } };

export type AllProgramsListQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProgramsListQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', nodes: Array<{ __typename?: 'Program', id: string, name: string }> } };

export type DistinctParticipantsCountQueryVariables = Exact<{
  filter: ParticipantsFilter;
}>;


export type DistinctParticipantsCountQuery = { __typename?: 'Query', participants: { __typename?: 'ParticipantConnection', totalCountOfDistinctUsers: number } };

export type DistinctContactsCountQueryVariables = Exact<{
  filter: ContactsFilter;
}>;


export type DistinctContactsCountQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactConnection', totalCountOfDistinctUsers: number } };

export type DistinctPartnersCountQueryVariables = Exact<{
  programIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DistinctPartnersCountQuery = { __typename?: 'Query', partners: { __typename?: 'PartnerConnection', totalCountOfDistinctUsers: number } };

export type DistinctAdminUsersCountQueryVariables = Exact<{ [key: string]: never; }>;


export type DistinctAdminUsersCountQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number } };

export type CreateNewOutreachTopicMutationVariables = Exact<{
  input: CreateTopicInput;
}>;


export type CreateNewOutreachTopicMutation = { __typename?: 'Mutation', createTopic?: { __typename?: 'CreateTopicPayload', topic: { __typename?: 'Topic', id: string } } | null };

export type UpdateOutreachTopicMutationVariables = Exact<{
  input: UpdateTopicInput;
}>;


export type UpdateOutreachTopicMutation = { __typename?: 'Mutation', updateTopic?: { __typename?: 'UpdateTopicPayload', topic: { __typename?: 'Topic', id: string, name: string, userState: UserState, isDefault: boolean, programSegment?: ProgramSegment | null, category: TopicCategory, priority: number, archivedAt?: any | null, topicMessages: Array<{ __typename?: 'TopicMessage', id: string, index: number, hoursDelayAfterMessage: number, preferredMedium: Message, emailTemplate?: { __typename?: 'EmailTemplate', id: string, name: string } | null, smsTemplate?: { __typename?: 'SmsTemplate', id: string, name: string } | null }>, topicConditions: Array<{ __typename?: 'TopicCondition', id: string, key: TopicConditionKey, value: boolean }> } } | null };

export type EditCampaignQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type EditCampaignQuery = { __typename?: 'Query', outreachTopic: { __typename?: 'Topic', id: string, name: string, userState: UserState, isDefault: boolean, programSegment?: ProgramSegment | null, category: TopicCategory, priority: number, archivedAt?: any | null, topicMessages: Array<{ __typename?: 'TopicMessage', id: string, index: number, hoursDelayAfterMessage: number, preferredMedium: Message, emailTemplate?: { __typename?: 'EmailTemplate', id: string, name: string } | null, smsTemplate?: { __typename?: 'SmsTemplate', id: string, name: string } | null }>, topicConditions: Array<{ __typename?: 'TopicCondition', id: string, key: TopicConditionKey, value: boolean }> } };

export type CampaignsListTotalsQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignsListTotalsQuery = { __typename?: 'Query', outreachTopics: { __typename?: 'TopicConnection', totalCount: number } };

export type CampaignsListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TopicsSort>;
  filter?: InputMaybe<TopicsFilter>;
}>;


export type CampaignsListQuery = { __typename?: 'Query', outreachTopics: { __typename?: 'TopicConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Topic', id: string, name: string, isDefault: boolean, userState: UserState, category: TopicCategory, programSegment?: ProgramSegment | null, archivedAt?: any | null, topicConditions: Array<{ __typename?: 'TopicCondition', id: string, key: TopicConditionKey, value: boolean }>, programTopics: { __typename?: 'ProgramTopicConnection', totalCount: number }, topicMessages: Array<{ __typename?: 'TopicMessage', id: string, index: number, hoursDelayAfterMessage: number, preferredMedium: Message, emailTemplate?: { __typename?: 'EmailTemplate', id: string, name: string } | null, smsTemplate?: { __typename?: 'SmsTemplate', id: string, name: string } | null }> }> } };

export type IndividualCampaignProgramsQueryVariables = Exact<{
  filter?: InputMaybe<TopicsFilter>;
}>;


export type IndividualCampaignProgramsQuery = { __typename?: 'Query', outreachTopics: { __typename?: 'TopicConnection', nodes: Array<{ __typename?: 'Topic', id: string, programTopics: { __typename?: 'ProgramTopicConnection', nodes: Array<{ __typename?: 'ProgramTopic', id: string, program: { __typename?: 'Program', id: string, name: string, startDate: any, endDate: any, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null }, partnerSuccessOperator?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } }> } }> } };

export type UserStateVariablesQueryVariables = Exact<{
  userState: UserState;
  filterList?: InputMaybe<UserStateFilter>;
}>;


export type UserStateVariablesQuery = { __typename?: 'Query', userStateVariables: Array<{ __typename?: 'UserStateVariable', name: string, path: string, previewValue?: string | null }> };

export type CreateEmailTemplateSavedRowMutationVariables = Exact<{
  input: CreateEmailTemplateSavedRowInput;
}>;


export type CreateEmailTemplateSavedRowMutation = { __typename?: 'Mutation', createEmailTemplateSavedRow?: { __typename?: 'CreateEmailTemplateSavedRowPayload', emailTemplateSavedRow: { __typename?: 'EmailTemplateSavedRow', id: string, name: string, category: EmailTemplateSavedRowCategory, templateEditorData: any } } | null };

export type AllActiveProgramsListQueryVariables = Exact<{ [key: string]: never; }>;


export type AllActiveProgramsListQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', nodes: Array<{ __typename?: 'Program', id: string, name: string }> } };

export type CustomMessageTypeTemplateRequirementsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomMessageTypeTemplateRequirementsQuery = { __typename?: 'Query', customMessageTypeTemplateRequirements: { __typename?: 'CustomMessageTypeTemplateRequirementConnection', nodes: Array<{ __typename?: 'CustomMessageTypeTemplateRequirement', id: string, customMessageType: ProgramCustomMessage, messageCategory: MessageCategory, userState: UserState, messageType: Message }> } };

export type TemplateDetailsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type TemplateDetailsDataQuery = { __typename?: 'Query', messageTemplateTags: { __typename?: 'MessageTemplateTagConnection', nodes: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> }, skeletonMessageTemplates: { __typename?: 'SkeletonMessageTemplateConnection', nodes: Array<{ __typename: 'SkeletonMessageTemplate', id: string, name: string, templateEditorData: any }> } };

export type CreateMessageTemplateTagMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateMessageTemplateTagMutation = { __typename?: 'Mutation', createMessageTemplateTag?: { __typename?: 'CreateMessageTemplateTagPayload', messageTemplateTag: { __typename?: 'EmailTemplate', id: string, name: string } } | null };

export type CreateSkeletonMessageTemplateMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  templateEditorData: Scalars['JSON']['input'];
}>;


export type CreateSkeletonMessageTemplateMutation = { __typename?: 'Mutation', createSkeletonMessageTemplate?: { __typename?: 'CreateSkeletonMessageTemplatePayload', skeletonMessageTemplate: { __typename: 'SkeletonMessageTemplate', id: string, name: string, templateEditorData: any } } | null };

export type SendBulkMessageByCsvMutationVariables = Exact<{
  file: Scalars['File']['input'];
  templateId: Scalars['ID']['input'];
}>;


export type SendBulkMessageByCsvMutation = { __typename?: 'Mutation', sendBulkMessageByCsv?: { __typename?: 'SendBulkMessageByCsvPayload', templateId?: string | null, batchActionId?: string | null, errors?: string | null } | null };

export type SendTestMessageMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['ID']['input'];
  recipientId?: InputMaybe<Scalars['ID']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SendTestMessageMutation = { __typename?: 'Mutation', sendTestMessage?: { __typename?: 'SendTestMessagePayload', templateId?: string | null, errors?: string | null } | null };

export type CreateMessageTemplateUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type CreateMessageTemplateUserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null } };

export type CreateSmsTemplateMutationVariables = Exact<{
  smsTemplateInput: CreateSmsTemplateInput;
}>;


export type CreateSmsTemplateMutation = { __typename?: 'Mutation', createSmsTemplate?: { __typename?: 'CreateSmsTemplatePayload', smsTemplate: { __typename: 'SmsTemplate', id: string, name: string, messageType: Message, content: string, userState: UserState, isDefault: boolean, programSegment?: ProgramSegment | null, category: MessageCategory, customMessageType?: ProgramCustomMessage | null, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> } } | null };

export type CreateEmailTemplateMutationVariables = Exact<{
  emailTemplateInput: CreateEmailTemplateInput;
}>;


export type CreateEmailTemplateMutation = { __typename?: 'Mutation', createEmailTemplate?: { __typename?: 'CreateEmailTemplatePayload', emailTemplate: { __typename: 'EmailTemplate', id: string, name: string, messageType: Message, content: string, userState: UserState, isDefault: boolean, programSegment?: ProgramSegment | null, category: MessageCategory, customMessageType?: ProgramCustomMessage | null, templateEditorData: any, subjectLine: string, preheaderText: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> } } | null };

export type EditMessageTemplateQueryVariables = Exact<{
  templateId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type EditMessageTemplateQuery = { __typename?: 'Query', messageTemplate: { __typename: 'EmailTemplate', templateEditorData: any, subjectLine: string, preheaderText: string, id: string, name: string, messageType: Message, content: string, userState: UserState, isDefault: boolean, programSegment?: ProgramSegment | null, category: MessageCategory, customMessageType?: ProgramCustomMessage | null, archivedAt?: any | null, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> } | { __typename: 'SmsTemplate', id: string, name: string, messageType: Message, content: string, userState: UserState, isDefault: boolean, programSegment?: ProgramSegment | null, category: MessageCategory, customMessageType?: ProgramCustomMessage | null, archivedAt?: any | null, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> }, user: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, firstName: string, lastName: string } };

export type UpdateEmailTemplateMutationVariables = Exact<{
  updateInput: UpdateEmailTemplateInput;
}>;


export type UpdateEmailTemplateMutation = { __typename?: 'Mutation', updateEmailTemplate?: { __typename?: 'UpdateEmailTemplatePayload', emailTemplate: { __typename: 'EmailTemplate', id: string, name: string, messageType: Message, content: string, userState: UserState, isDefault: boolean, programSegment?: ProgramSegment | null, category: MessageCategory, customMessageType?: ProgramCustomMessage | null, templateEditorData: any, subjectLine: string, preheaderText: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> } } | null };

export type UpdateSmsTemplateMutationVariables = Exact<{
  updateInput: UpdateSmsTemplateInput;
}>;


export type UpdateSmsTemplateMutation = { __typename?: 'Mutation', updateSmsTemplate?: { __typename?: 'UpdateSmsTemplatePayload', smsTemplate: { __typename: 'SmsTemplate', id: string, name: string, messageType: Message, content: string, userState: UserState, isDefault: boolean, programSegment?: ProgramSegment | null, category: MessageCategory, customMessageType?: ProgramCustomMessage | null, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> } } | null };

export type MessageTemplateTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type MessageTemplateTagsQuery = { __typename?: 'Query', messageTemplateTags: { __typename?: 'MessageTemplateTagConnection', nodes: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> } };

export type AddMessageTemplatesTagsByIdsMutationVariables = Exact<{
  templateIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagsToCreate?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AddMessageTemplatesTagsByIdsMutation = { __typename?: 'Mutation', addMessageTemplatesTags: { __typename?: 'AddMessageTemplatesTags', byIds: { __typename?: 'AddMessageTemplatesTagsByIdsPayload', messageTemplates?: Array<{ __typename?: 'EmailTemplate', id: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> } | { __typename?: 'SmsTemplate', id: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> }> | null } } };

export type AddMessageTemplatesTagsByFiltersMutationVariables = Exact<{
  filter?: InputMaybe<MessageTemplatesFilter>;
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagsToCreate?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AddMessageTemplatesTagsByFiltersMutation = { __typename?: 'Mutation', addMessageTemplatesTags: { __typename?: 'AddMessageTemplatesTags', byFilterSelection: { __typename?: 'AddMessageTemplatesTagsByFilterSelectionPayload', messageTemplates?: Array<{ __typename?: 'EmailTemplate', id: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> } | { __typename?: 'SmsTemplate', id: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> }> | null } } };

export type DuplicateTemplatesInfoQueryVariables = Exact<{
  filter?: InputMaybe<MessageTemplatesFilter>;
}>;


export type DuplicateTemplatesInfoQuery = { __typename?: 'Query', messageTemplateTags: { __typename?: 'MessageTemplateTagConnection', nodes: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> }, messageTemplates: { __typename?: 'MessageTemplateConnection', totalCount: number, tagCounts: Array<{ __typename?: 'MessageTemplateTagCount', count: number, tag: { __typename?: 'MessageTemplateTag', name: string, id: string } }> } };

export type DuplicateMessageTemplatesFromIdsMutationVariables = Exact<{
  templateIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagIdsToAdd: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagIdsToRemove: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  isDefault: Scalars['Boolean']['input'];
}>;


export type DuplicateMessageTemplatesFromIdsMutation = { __typename?: 'Mutation', duplicateMessageTemplates: { __typename?: 'DuplicateMessageTemplates', byIds: { __typename?: 'DuplicateMessageTemplatesByIdsPayload', newMessageTemplates?: { __typename?: 'MessageTemplateConnection', totalCount: number, nodes: Array<{ __typename?: 'EmailTemplate', id: string } | { __typename?: 'SmsTemplate', id: string }> } | null } } };

export type DuplicateMessageTemplatesFromFilterSelectionMutationVariables = Exact<{
  templateFilters: MessageTemplatesFilter;
  tagIdsToAdd: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagIdsToRemove: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  isDefault: Scalars['Boolean']['input'];
}>;


export type DuplicateMessageTemplatesFromFilterSelectionMutation = { __typename?: 'Mutation', duplicateMessageTemplates: { __typename?: 'DuplicateMessageTemplates', byFilterSelection: { __typename?: 'DuplicateMessageTemplatesByFilterSelectionPayload', newMessageTemplates: { __typename?: 'MessageTemplateConnection', totalCount: number } } } };

export type MessageTemplateTagsCountQueryVariables = Exact<{
  filter?: InputMaybe<MessageTemplatesFilter>;
}>;


export type MessageTemplateTagsCountQuery = { __typename?: 'Query', messageTemplates: { __typename?: 'MessageTemplateConnection', totalCount: number, tagCounts: Array<{ __typename?: 'MessageTemplateTagCount', count: number, tag: { __typename?: 'MessageTemplateTag', name: string, id: string } }> } };

export type RemoveMessageTemplatesTagsByIdsMutationVariables = Exact<{
  templateIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveMessageTemplatesTagsByIdsMutation = { __typename?: 'Mutation', removeMessageTemplatesTags: { __typename?: 'RemoveMessageTemplatesTags', byIds: { __typename?: 'RemoveMessageTemplatesTagsByIdsPayload', messageTemplates?: Array<{ __typename?: 'EmailTemplate', id: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> } | { __typename?: 'SmsTemplate', id: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> }> | null } } };

export type RemoveMessageTemplatesTagsByFiltersMutationVariables = Exact<{
  filter?: InputMaybe<MessageTemplatesFilter>;
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveMessageTemplatesTagsByFiltersMutation = { __typename?: 'Mutation', removeMessageTemplatesTags: { __typename?: 'RemoveMessageTemplatesTags', byFilterSelection: { __typename?: 'RemoveMessageTemplatesTagsByFilterSelectionPayload', messageTemplates?: Array<{ __typename?: 'EmailTemplate', id: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> } | { __typename?: 'SmsTemplate', id: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> }> | null } } };

export type MessageTemplatesListTotalsQueryVariables = Exact<{ [key: string]: never; }>;


export type MessageTemplatesListTotalsQuery = { __typename?: 'Query', messageTemplates: { __typename?: 'MessageTemplateConnection', totalCount: number, tagCounts: Array<{ __typename?: 'MessageTemplateTagCount', count: number, tag: { __typename?: 'MessageTemplateTag', id: string, name: string } }> } };

export type MessageTemplatesListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<MessageTemplatesFilter>;
  sort?: InputMaybe<MessageTemplatesSort>;
}>;


export type MessageTemplatesListQuery = { __typename?: 'Query', messageTemplates: { __typename?: 'MessageTemplateConnection', totalCount: number, defaultCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'EmailTemplate', id: string, name: string, messageType: Message, programSegment?: ProgramSegment | null, userState: UserState, isDefault: boolean, category: MessageCategory, lastEditedAt: any, archivedAt?: any | null, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> } | { __typename?: 'SmsTemplate', id: string, name: string, messageType: Message, programSegment?: ProgramSegment | null, userState: UserState, isDefault: boolean, category: MessageCategory, lastEditedAt: any, archivedAt?: any | null, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> }> } };

export type ArchiveRestoreMessageTemplatesByIdsMutationVariables = Exact<{
  templateIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  setArchived: Scalars['Boolean']['input'];
}>;


export type ArchiveRestoreMessageTemplatesByIdsMutation = { __typename?: 'Mutation', archiveRestoreMessageTemplates: { __typename?: 'ArchiveRestoreMessageTemplates', byIds: { __typename?: 'ArchiveRestoreMessageTemplatesByIdsPayload', messageTemplates?: Array<{ __typename?: 'EmailTemplate', id: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> } | { __typename?: 'SmsTemplate', id: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> }> | null } } };

export type ArchiveRestoreMessageTemplatesByFiltersMutationVariables = Exact<{
  filter?: InputMaybe<MessageTemplatesFilter>;
  setArchived: Scalars['Boolean']['input'];
}>;


export type ArchiveRestoreMessageTemplatesByFiltersMutation = { __typename?: 'Mutation', archiveRestoreMessageTemplates: { __typename?: 'ArchiveRestoreMessageTemplates', byFilterSelection: { __typename?: 'ArchiveRestoreMessageTemplatesByFilterSelectionPayload', messageTemplates?: Array<{ __typename?: 'EmailTemplate', id: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> } | { __typename?: 'SmsTemplate', id: string, tags: Array<{ __typename?: 'MessageTemplateTag', id: string, name: string }> }> | null } } };

export type ActiveCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveCampaignsQuery = { __typename?: 'Query', outreachTopics: { __typename?: 'TopicConnection', nodes: Array<{ __typename?: 'Topic', id: string, topicMessages: Array<{ __typename?: 'TopicMessage', id: string, emailTemplate?: { __typename?: 'EmailTemplate', id: string, name: string } | null, smsTemplate?: { __typename?: 'SmsTemplate', id: string, name: string } | null }> }> } };

export type MatchedUsersReportExportQueryVariables = Exact<{
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
  enrollment?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MatchedUsersReportExportQuery = { __typename?: 'Query', csvExports: { __typename?: 'CsvExports', matchedUsersReport: { __typename?: 'CsvExport', id: string, filename?: string | null, isProcessing: boolean, url?: string | null } } };

export type MenteeMentorQuotesExportQueryVariables = Exact<{
  programIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  analyzeSentiment?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MenteeMentorQuotesExportQuery = { __typename?: 'Query', csvExports: { __typename?: 'CsvExports', menteeMentorQuotes: { __typename?: 'CsvExport', id: string, filename?: string | null, isProcessing: boolean, url?: string | null } } };

export type SurveyResponsesExportQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  programId?: InputMaybe<Scalars['ID']['input']>;
  includeProgramProfileData?: InputMaybe<Scalars['Boolean']['input']>;
  context: CsvExportContextInput;
}>;


export type SurveyResponsesExportQuery = { __typename?: 'Query', csvExports: { __typename?: 'CsvExports', surveyResponses: { __typename?: 'CsvExport', id: string, url?: string | null, isProcessing: boolean, filename?: string | null } } };

export type WrittenTestimonialsExportQueryVariables = Exact<{
  programIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  analyzeSentiment?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WrittenTestimonialsExportQuery = { __typename?: 'Query', csvExports: { __typename?: 'CsvExports', writtenTestimonials: { __typename?: 'CsvExport', id: string, filename?: string | null, isProcessing: boolean, url?: string | null } } };

export type UserLogoForAdminHeaderQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  avatarHeight: Scalars['Int']['input'];
  avatarWidth: Scalars['Int']['input'];
}>;


export type UserLogoForAdminHeaderQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatarImage?: { __typename?: 'Image', id: string, url: string } | null } };

export type DismissProgramAlertMutationVariables = Exact<{
  input: ProgramAlertDismissalInput;
}>;


export type DismissProgramAlertMutation = { __typename?: 'Mutation', dismissProgramAlert?: { __typename?: 'DismissProgramAlertPayload', program: { __typename?: 'Program', id: string, alertDismissals: Array<{ __typename?: 'ProgramAlertDismissal', id: string, alertTypeIdentifier: string, snoozeUntil?: any | null, alertMetadata?: any | null }> } } | null };

export type ReactivateProgramAlertMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  alertTypeIdentifier: Scalars['String']['input'];
}>;


export type ReactivateProgramAlertMutation = { __typename?: 'Mutation', reactivateProgramAlert?: { __typename?: 'ReactivateProgramAlertPayload', program: { __typename?: 'Program', id: string, alertDismissals: Array<{ __typename?: 'ProgramAlertDismissal', id: string, alertTypeIdentifier: string, snoozeUntil?: any | null, alertMetadata?: any | null }> } } | null };

export type ProgramFieldsForAdminDashboardFragment = { __typename?: 'Program', id: string, shortName: string, name: string, allowMenteeSignUp: boolean, allowMentorSignUp: boolean, currentPhase: ProgramPhase, alertDismissals: Array<{ __typename?: 'ProgramAlertDismissal', id: string, alertTypeIdentifier: string, alertMetadata?: any | null, snoozeUntil?: any | null }>, partnerSuccessManager?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, partnerSuccessOperator?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, programGoal?: { __typename?: 'ProgramGoal', id: string, target: number, type: ProgramGoalTypes } | null, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, name: string, shortName: string } }, satisfactionReport: { __typename?: 'SatisfactionReport', programSatisfaction: { __typename?: 'SatisfactionAverage', mentorAverage?: number | null, studentAverage?: number | null }, segmentSatisfaction: { __typename?: 'SatisfactionAverage', mentorAverage?: number | null, studentAverage?: number | null }, previousProgramSatisfaction?: { __typename?: 'SatisfactionAverage', mentorAverage?: number | null, studentAverage?: number | null } | null }, currentlyMatchedStudents: { __typename?: 'ParticipantConnection', totalCount: number } };

export type ProgramInfoForAdminDashboardQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ProgramInfoForAdminDashboardQuery = { __typename?: 'Query', programsAsPSO: { __typename?: 'ProgramConnection', totalCount: number, nodes: Array<{ __typename?: 'Program', id: string, shortName: string, name: string, allowMenteeSignUp: boolean, allowMentorSignUp: boolean, currentPhase: ProgramPhase, alertDismissals: Array<{ __typename?: 'ProgramAlertDismissal', id: string, alertTypeIdentifier: string, alertMetadata?: any | null, snoozeUntil?: any | null }>, partnerSuccessManager?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, partnerSuccessOperator?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, programGoal?: { __typename?: 'ProgramGoal', id: string, target: number, type: ProgramGoalTypes } | null, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, name: string, shortName: string } }, satisfactionReport: { __typename?: 'SatisfactionReport', programSatisfaction: { __typename?: 'SatisfactionAverage', mentorAverage?: number | null, studentAverage?: number | null }, segmentSatisfaction: { __typename?: 'SatisfactionAverage', mentorAverage?: number | null, studentAverage?: number | null }, previousProgramSatisfaction?: { __typename?: 'SatisfactionAverage', mentorAverage?: number | null, studentAverage?: number | null } | null }, currentlyMatchedStudents: { __typename?: 'ParticipantConnection', totalCount: number } }> }, programsAsPSM: { __typename?: 'ProgramConnection', totalCount: number, nodes: Array<{ __typename?: 'Program', id: string, shortName: string, name: string, allowMenteeSignUp: boolean, allowMentorSignUp: boolean, currentPhase: ProgramPhase, alertDismissals: Array<{ __typename?: 'ProgramAlertDismissal', id: string, alertTypeIdentifier: string, alertMetadata?: any | null, snoozeUntil?: any | null }>, partnerSuccessManager?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, partnerSuccessOperator?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, programGoal?: { __typename?: 'ProgramGoal', id: string, target: number, type: ProgramGoalTypes } | null, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, name: string, shortName: string } }, satisfactionReport: { __typename?: 'SatisfactionReport', programSatisfaction: { __typename?: 'SatisfactionAverage', mentorAverage?: number | null, studentAverage?: number | null }, segmentSatisfaction: { __typename?: 'SatisfactionAverage', mentorAverage?: number | null, studentAverage?: number | null }, previousProgramSatisfaction?: { __typename?: 'SatisfactionAverage', mentorAverage?: number | null, studentAverage?: number | null } | null }, currentlyMatchedStudents: { __typename?: 'ParticipantConnection', totalCount: number } }> }, user: { __typename?: 'User', id: string, firstName: string, lastName: string } };

export type AdminPermissionsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type AdminPermissionsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, activeShearwaterAdministrator?: { __typename?: 'ShearwaterAdministrator', id: string, permissions: Array<Permission> } | null } };

export type TargetingCriteriaUserCountQueryVariables = Exact<{
  filter: ParticipantsFilter;
}>;


export type TargetingCriteriaUserCountQuery = { __typename?: 'Query', participants: { __typename?: 'ParticipantConnection', totalCountOfDistinctUsers: number } };

export type ProgramSelectDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgramSelectDataQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', nodes: Array<{ __typename?: 'Program', id: string, name: string }> } };

export type CreateMicroSurveyMutationVariables = Exact<{
  inputData: CreateMicroSurveyInput;
}>;


export type CreateMicroSurveyMutation = { __typename?: 'Mutation', createMicroSurvey?: { __typename?: 'CreateMicroSurveyPayload', microSurvey?: { __typename?: 'MicroSurvey', id: string, startAt: any, expireAt?: any | null, survey: { __typename?: 'Survey', id: string, name: string, questions: Array<{ __typename?: 'SurveyQuestion', id: string, customizations?: any | null, index: number, template: { __typename?: 'SurveyQuestionTemplate', id: string, templateId: SurveyQuestionTemplateId } }> }, targetingCriteria?: { __typename?: 'MicroSurveyTargetingCriteria', id: string, participants?: { __typename?: 'ParticipantsFilterCriteria', id: string, programIds?: Array<string> | null, excludeProgramIds?: Array<string> | null, type?: ParticipantTypeFilter | null, engaged?: boolean | null } | null } | null } | null } | null };

export type ManageMicroSurveyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ManageMicroSurveyQuery = { __typename?: 'Query', microSurvey: { __typename?: 'MicroSurvey', id: string, startAt: any, expireAt?: any | null, survey: { __typename?: 'Survey', id: string, name: string, questions: Array<{ __typename?: 'SurveyQuestion', id: string, customizations?: any | null, index: number, template: { __typename?: 'SurveyQuestionTemplate', id: string, templateId: SurveyQuestionTemplateId } }> }, targetingCriteria?: { __typename?: 'MicroSurveyTargetingCriteria', id: string, participants?: { __typename?: 'ParticipantsFilterCriteria', id: string, programIds?: Array<string> | null, excludeProgramIds?: Array<string> | null, type?: ParticipantTypeFilter | null, engaged?: boolean | null } | null } | null } };

export type UpdateMicroSurveyMutationVariables = Exact<{
  inputData: UpdateMicroSurveyInput;
}>;


export type UpdateMicroSurveyMutation = { __typename?: 'Mutation', updateMicroSurvey?: { __typename?: 'UpdateMicroSurveyPayload', microSurvey: { __typename?: 'MicroSurvey', id: string, startAt: any, expireAt?: any | null, survey: { __typename?: 'Survey', id: string, name: string, questions: Array<{ __typename?: 'SurveyQuestion', id: string, customizations?: any | null, index: number, template: { __typename?: 'SurveyQuestionTemplate', id: string, templateId: SurveyQuestionTemplateId } }> }, targetingCriteria?: { __typename?: 'MicroSurveyTargetingCriteria', id: string, participants?: { __typename?: 'ParticipantsFilterCriteria', id: string, programIds?: Array<string> | null, excludeProgramIds?: Array<string> | null, type?: ParticipantTypeFilter | null, engaged?: boolean | null } | null } | null } } | null };

export type AllMicroSurveysQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<MicroSurveysFilter>;
  sort?: InputMaybe<MicroSurveysSort>;
}>;


export type AllMicroSurveysQuery = { __typename?: 'Query', microSurveys: { __typename?: 'MicroSurveyConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'MicroSurvey', id: string, startAt: any, expireAt?: any | null, survey: { __typename?: 'Survey', id: string, name: string } }> } };

export type UpdateCourseNewTaskMutationVariables = Exact<{
  updateCourseNewTaskInput: UpdateCourseNewTaskInput;
}>;


export type UpdateCourseNewTaskMutation = { __typename?: 'Mutation', updateCourseNewTask?: { __typename?: 'UpdateCourseNewTaskPayload', newTask?: { __typename?: 'NewTask', id: string, segmentTags: Array<NewTaskSegmentTag>, internalTaskName: string, defaultDisplayName?: string | null, defaultAssigneeEntity?: AssigneeEntity | null, mentorshipCredential?: { __typename?: 'MentorshipCredential', id: string, credential: MentorshipCredentialCredentials } | null, context?: { __typename: 'AssessmentSurveyTaskContext' } | { __typename: 'CourseTaskContext', id: string, courseId: string } | { __typename: 'LinkTaskContext' } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path: string }> } | null };

export type UpdateClickLinkNewTaskMutationVariables = Exact<{
  updateClickLinkNewTaskInput: UpdateClickLinkNewTaskInput;
}>;


export type UpdateClickLinkNewTaskMutation = { __typename?: 'Mutation', updateClickLinkNewTask?: { __typename?: 'UpdateClickLinkNewTaskPayload', newTask?: { __typename?: 'NewTask', id: string, segmentTags: Array<NewTaskSegmentTag>, internalTaskName: string, defaultDisplayName?: string | null, defaultAssigneeEntity?: AssigneeEntity | null, context?: { __typename: 'AssessmentSurveyTaskContext' } | { __typename: 'CourseTaskContext' } | { __typename: 'LinkTaskContext', id: string, url: string } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path: string }> } | null };

export type NewTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NewTaskQuery = { __typename?: 'Query', newTask: { __typename?: 'NewTask', id: string, segmentTags: Array<NewTaskSegmentTag>, internalTaskName: string, defaultDisplayName?: string | null, defaultAssigneeEntity?: AssigneeEntity | null, requiredForMatching?: boolean | null, mentorshipCredential?: { __typename?: 'MentorshipCredential', id: string, credential: MentorshipCredentialCredentials } | null, context?: { __typename: 'AssessmentSurveyTaskContext' } | { __typename: 'CourseTaskContext', id: string, courseId: string } | { __typename: 'LinkTaskContext', id: string, url: string } | null } };

export type NewTasksQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<NewTasksFilter>;
  sort?: InputMaybe<NewTasksSort>;
}>;


export type NewTasksQuery = { __typename?: 'Query', newTasks: { __typename?: 'NewTaskConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'NewTask', id: string, internalTaskName: string, defaultDisplayName?: string | null, defaultAssigneeEntity?: AssigneeEntity | null, requiredForMatching?: boolean | null, segmentTags: Array<NewTaskSegmentTag>, mentorshipCredential?: { __typename?: 'MentorshipCredential', id: string, credential: MentorshipCredentialCredentials } | null, context?: { __typename: 'AssessmentSurveyTaskContext', id: string, surveyId: string, programStage: AssessmentSurveyProgramStage } | { __typename: 'CourseTaskContext', id: string, courseId: string } | { __typename: 'LinkTaskContext', id: string, url: string } | null }> } };

export type ProgramFieldsForAdminDashboardAllProgramsListFragment = { __typename?: 'Program', id: string, shortName: string, name: string, currentPhase: ProgramPhase, allowMenteeSignUp: boolean, allowMentorSignUp: boolean, alertDismissals: Array<{ __typename?: 'ProgramAlertDismissal', id: string, alertTypeIdentifier: string, alertMetadata?: any | null, snoozeUntil?: any | null }>, partnerSuccessManager?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, partnerSuccessOperator?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, programGoal?: { __typename?: 'ProgramGoal', id: string, target: number, type: ProgramGoalTypes } | null, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, name: string, shortName: string } }, currentlyMatchedStudents: { __typename?: 'ParticipantConnection', totalCount: number } };

export type AdminDashboardAllProgramsListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProgramsFilter>;
  sort?: InputMaybe<ProgramsSort>;
}>;


export type AdminDashboardAllProgramsListQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Program', id: string, shortName: string, name: string, currentPhase: ProgramPhase, allowMenteeSignUp: boolean, allowMentorSignUp: boolean, alertDismissals: Array<{ __typename?: 'ProgramAlertDismissal', id: string, alertTypeIdentifier: string, alertMetadata?: any | null, snoozeUntil?: any | null }>, partnerSuccessManager?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, partnerSuccessOperator?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, programGoal?: { __typename?: 'ProgramGoal', id: string, target: number, type: ProgramGoalTypes } | null, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, name: string, shortName: string } }, currentlyMatchedStudents: { __typename?: 'ParticipantConnection', totalCount: number } }> } };

export type UpdateSchoolInfoMutationVariables = Exact<{
  inputData: UpdateSchoolInfoInput;
}>;


export type UpdateSchoolInfoMutation = { __typename?: 'Mutation', updateSchoolInfo?: { __typename?: 'UpdateSchoolInfoPayload', errors: Array<{ __typename?: 'UpdateSchoolInfoError', message: string, path: UpdateSchoolInfoErrorPaths }>, school?: { __typename?: 'School', id: string, name: string, logo?: string | null, shortName: string, subdomain: string, institutionType?: Institution | null, institutionRegion?: InstitutionRegion | null, isMinorityServingInstitution?: boolean | null, twoOrFourYear?: HigherEducation | null, publicOrPrivate?: PublicOrPrivate | null } | null } | null };

export type AdminDashboardSchoolInfoQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
}>;


export type AdminDashboardSchoolInfoQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, name: string, logo?: string | null, shortName: string, subdomain: string, institutionType?: Institution | null, institutionRegion?: InstitutionRegion | null, isMinorityServingInstitution?: boolean | null, twoOrFourYear?: HigherEducation | null, publicOrPrivate?: PublicOrPrivate | null, ssoBrand?: string | null, ssoEnabled?: boolean | null, ssoTestingEnabled: boolean, ssoRequiredForPartners: boolean, ssoProviderIdentifier?: string | null, programSequences: Array<{ __typename?: 'ProgramSequence', id: string, name: string, programs: Array<{ __typename?: 'Program', active: boolean, mentorLoginMode: ProgramMentorLoginMode, menteeLoginMode: ProgramMenteeLoginMode }> }> } };

export type UpdateSsoConfigurationMutationVariables = Exact<{
  inputData: UpdateSchoolInfoInput;
}>;


export type UpdateSsoConfigurationMutation = { __typename?: 'Mutation', updateSchoolInfo?: { __typename?: 'UpdateSchoolInfoPayload', errors: Array<{ __typename?: 'UpdateSchoolInfoError', message: string, path: UpdateSchoolInfoErrorPaths }>, school?: { __typename?: 'School', id: string, ssoEnabled?: boolean | null, ssoTestingEnabled: boolean, ssoProviderIdentifier?: string | null, ssoRequiredForPartners: boolean, ssoBrand?: string | null } | null } | null };

export type SendSsoTestingTemplateMutationVariables = Exact<{
  schoolId: Scalars['ID']['input'];
}>;


export type SendSsoTestingTemplateMutation = { __typename?: 'Mutation', sendSsoTestingTemplate?: { __typename?: 'SendSsoTestingTemplatePayload', programSequenceId?: string | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } | null };

export type LatestSsoSessionDataQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
}>;


export type LatestSsoSessionDataQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, omniauthCredentialLatestSessions?: Array<{ __typename?: 'OmniauthCredentialLatestSession', id: string, userId: string, firstName?: string | null, lastName?: string | null, email?: string | null, institutionId?: string | null, lastAuthAt?: any | null }> | null } };

export type AdminDashboardSchoolQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminDashboardSchoolQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, name: string, logo?: string | null, shortName: string, subdomain: string, institutionType?: Institution | null, nameOfSchoolIdentifier: string, programSequences: Array<{ __typename?: 'ProgramSequence', id: string, name: string }> } };

export type AllSchoolsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSchoolsQuery = { __typename?: 'Query', schools: { __typename?: 'SchoolConnection', nodes: Array<{ __typename?: 'School', id: string, name: string }> } };

export type AdminDashboardProgramSequenceDetailsQueryVariables = Exact<{
  programSequenceId: Scalars['ID']['input'];
}>;


export type AdminDashboardProgramSequenceDetailsQuery = { __typename?: 'Query', programSequences: { __typename?: 'ProgramSequenceConnection', nodes: Array<{ __typename?: 'ProgramSequence', id: string, name: string, urlSlug: string, school: { __typename?: 'School', id: string, name: string }, programs: Array<{ __typename?: 'Program', id: string, name: string }> }> } };

export type UpdateProgramSequenceInfoMutationVariables = Exact<{
  inputData: UpdateProgramSequenceInfoInput;
}>;


export type UpdateProgramSequenceInfoMutation = { __typename?: 'Mutation', updateProgramSequenceInfo?: { __typename?: 'UpdateProgramSequenceInfoPayload', errors: Array<{ __typename?: 'UpdateProgramSequenceInfoError', message: string, path: UpdateProgramSequenceInfoErrorPaths }>, programSequence?: { __typename?: 'ProgramSequence', id: string, name: string, urlSlug: string, school: { __typename?: 'School', id: string, name: string } } | null } | null };

export type CreateProgramSequenceMutationVariables = Exact<{
  inputData: CreateProgramSequenceInput;
}>;


export type CreateProgramSequenceMutation = { __typename?: 'Mutation', createProgramSequence?: { __typename?: 'CreateProgramSequencePayload', errors: Array<{ __typename?: 'CreateProgramSequenceError', message: string, path: CreateProgramSequenceErrorPaths }>, programSequence?: { __typename?: 'ProgramSequence', id: string, name: string } | null } | null };

export type AdminDashboardSchoolProgramSequencesQueryVariables = Exact<{
  filter?: InputMaybe<ProgramSequencesFilter>;
  sort?: InputMaybe<ProgramSequencesSort>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminDashboardSchoolProgramSequencesQuery = { __typename?: 'Query', programSequences: { __typename?: 'ProgramSequenceConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProgramSequence', id: string, name: string, urlSlug: string, menteeRecruitmentLink: string, mentorRecruitmentLink: string, programs: Array<{ __typename?: 'Program', id: string }> }> } };

export type DeleteProgramSequenceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProgramSequenceMutation = { __typename?: 'Mutation', deleteProgramSequence?: { __typename?: 'DeleteProgramSequencePayload', errors: Array<ProgramSequenceNotAbleToBeDeletedError> } | null };

export type DuplicateProgramSequenceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateProgramSequenceMutation = { __typename?: 'Mutation', duplicateProgramSequence?: { __typename?: 'DuplicateProgramSequencePayload', errors: Array<string>, programSequence?: { __typename?: 'ProgramSequence', id: string } | null } | null };

export type CreateProgramMutationVariables = Exact<{
  inputData: CreateProgramInput;
}>;


export type CreateProgramMutation = { __typename?: 'Mutation', createProgram?: { __typename?: 'CreateProgramPayload', errors: Array<{ __typename?: 'CreateProgramError', message: string, path: CreateProgramErrorPaths }>, program?: { __typename?: 'Program', id: string, name: string, shortName: string, title: string, startDate: any, endDate: any, isTestProgram: boolean, isTemplateProgram: boolean, programSequence: { __typename?: 'ProgramSequence', id: string, name: string } } | null } | null };

export type AdminUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null }> } };

export type UpdateProgramAdminsMutationVariables = Exact<{
  inputData: UpdateProgramAdminsInput;
}>;


export type UpdateProgramAdminsMutation = { __typename?: 'Mutation', updateProgramAdmins?: { __typename?: 'UpdateProgramAdminsPayload', errors: Array<{ __typename?: 'UpdateProgramAdminsError', message: string, path: UpdateProgramAdminsErrorPaths }>, program?: { __typename?: 'Program', id: string, partnerSuccessManager?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, partnerSuccessOperator?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, universityRelationsDirector?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } | null } | null };

export type CreatePartnerMutationVariables = Exact<{
  partnerInput: CreatePartnerInput;
}>;


export type CreatePartnerMutation = { __typename?: 'Mutation', createPartner?: { __typename?: 'CreatePartnerPayload', errors: Array<InvalidPartnerInputError>, partners?: Array<{ __typename?: 'Partner', id: string }> | null } | null };

export type AdminDashboardCheckIfUserExistsQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type AdminDashboardCheckIfUserExistsQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, nodes: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null }> } };

export type UpdateProgramFlagEmailPreferencesMutationVariables = Exact<{
  inputData: UpdateProgramInfoInput;
}>;


export type UpdateProgramFlagEmailPreferencesMutation = { __typename?: 'Mutation', updateProgramInfo?: { __typename?: 'UpdateProgramInfoPayload', errors: Array<{ __typename?: 'UpdateProgramInfoError', message: string, path: UpdateProgramInfoErrorPaths }>, program?: { __typename?: 'Program', id: string, nonPriorityFlagEmailEnabled: boolean } | null } | null };

export type UpdateProgramFlagEmailPreferencesProgramTopicMutationVariables = Exact<{
  input: UpdateProgramTopicInput;
}>;


export type UpdateProgramFlagEmailPreferencesProgramTopicMutation = { __typename?: 'Mutation', updateProgramTopic?: { __typename?: 'UpdateProgramTopicPayload', programTopic: { __typename?: 'ProgramTopic', id: string, active: boolean, topic: { __typename?: 'Topic', id: string, category: TopicCategory, userState: UserState } } } | null };

export type UpdateProgramFlagContactsMutationVariables = Exact<{
  inputData: UpdateProgramFlagContactsInput;
}>;


export type UpdateProgramFlagContactsMutation = { __typename?: 'Mutation', updateProgramFlagContacts?: { __typename?: 'UpdateProgramFlagContactsPayload', errors: Array<{ __typename?: 'UpdateProgramFlagContactsError', message: string, path: UpdateProgramFlagContactsErrorPaths }>, program?: { __typename?: 'Program', id: string, flagContactFirstName?: string | null, flagContactLastName?: string | null, flagContactEmail?: string | null, secondaryFlagContactCcEmails?: string | null, sendFlagsToExternalContact: boolean } | null } | null };

export type FlagContactsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type FlagContactsQuery = { __typename?: 'Query', flagContacts: Array<{ __typename: 'FlagContact', id: string, firstName: string, lastName: string, email: string, flagCategories: Array<{ __typename?: 'FlagCategory', id: string, name: string, identifier: string, label: string }> }> };

export type DeleteFlagContactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type DeleteFlagContactMutation = { __typename?: 'Mutation', deleteFlagContact?: { __typename: 'DeleteFlagContactPayload', errors: Array<string> } | null };

export type UpdateMentorPointPersonMutationVariables = Exact<{
  inputData: UpdateProgramPointPeopleInput;
}>;


export type UpdateMentorPointPersonMutation = { __typename?: 'Mutation', updateProgramPointPeople?: { __typename?: 'UpdateProgramPointPeoplePayload', errors: Array<{ __typename?: 'UpdateProgramPointPeopleError', message: string, path: UpdateProgramPointPeopleErrorPaths }>, program?: { __typename?: 'Program', id: string, mentorPointPersonTitle?: string | null, mentorPointPersonFirstName?: string | null, mentorPointPersonLastName?: string | null, mentorPointPersonEmail?: string | null } | null } | null };

export type CreateFlagContactMutationVariables = Exact<{
  input: CreateFlagContactInput;
  programId: Scalars['ID']['input'];
}>;


export type CreateFlagContactMutation = { __typename?: 'Mutation', createFlagContact?: { __typename?: 'CreateFlagContactPayload', errors: Array<InvalidFlagContactInputError>, flagContacts?: Array<{ __typename: 'FlagContact', id: string, firstName: string, lastName: string, email: string, flagCategories: Array<{ __typename?: 'FlagCategory', id: string, name: string }> }> | null } | null };

export type UpdateFlagContactMutationVariables = Exact<{
  input: FlagContactInput;
  programId: Scalars['ID']['input'];
}>;


export type UpdateFlagContactMutation = { __typename?: 'Mutation', updateFlagContact?: { __typename?: 'UpdateFlagContactPayload', errors: Array<InvalidFlagContactInputError>, flagContact?: { __typename: 'FlagContact', id: string, firstName: string, lastName: string, email: string, flagCategories: Array<{ __typename?: 'FlagCategory', id: string, name: string }> } | null } | null };

export type UpdateStudentPointPersonMutationVariables = Exact<{
  inputData: UpdateProgramPointPeopleInput;
}>;


export type UpdateStudentPointPersonMutation = { __typename?: 'Mutation', updateProgramPointPeople?: { __typename?: 'UpdateProgramPointPeoplePayload', errors: Array<{ __typename?: 'UpdateProgramPointPeopleError', message: string, path: UpdateProgramPointPeopleErrorPaths }>, program?: { __typename?: 'Program', id: string, studentPointPersonTitle?: string | null, studentPointPersonFirstName?: string | null, studentPointPersonLastName?: string | null, studentPointPersonEmail?: string | null } | null } | null };

export type AdminDashboardProgramAdminQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type AdminDashboardProgramAdminQuery = { __typename?: 'Query', relatedProgramSequences: { __typename?: 'Program', programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, programSequences: Array<{ __typename?: 'ProgramSequence', id: string, name: string }> } } }, program: { __typename?: 'Program', id: string, studentPointPersonTitle?: string | null, studentPointPersonFirstName?: string | null, studentPointPersonLastName?: string | null, studentPointPersonEmail?: string | null, mentorPointPersonTitle?: string | null, mentorPointPersonFirstName?: string | null, mentorPointPersonLastName?: string | null, mentorPointPersonEmail?: string | null, flagContactFirstName?: string | null, flagContactLastName?: string | null, flagContactEmail?: string | null, secondaryFlagContactCcEmails?: string | null, sendFlagsToExternalContact: boolean, nonPriorityFlagEmailEnabled: boolean, partnerSuccessManager?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, partnerSuccessOperator?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, universityRelationsDirector?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, programSequence: { __typename?: 'ProgramSequence', id: string, name: string, school: { __typename?: 'School', id: string, name: string } }, programTopics: { __typename?: 'ProgramTopicConnection', nodes: Array<{ __typename?: 'ProgramTopic', id: string, active: boolean, topic: { __typename?: 'Topic', id: string, name: string, category: TopicCategory, userState: UserState } }> } } };

export type UnmatchParticipantsMutationVariables = Exact<{
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
  unmatchReason: UnmatchReason;
  unmatchNotes?: InputMaybe<Scalars['String']['input']>;
  sendUnmatchEmails?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UnmatchParticipantsMutation = { __typename?: 'Mutation', unmatchParticipants?: { __typename?: 'UnmatchParticipantsPayload', batchActionId?: string | null, errors?: string | null } | null };

export type UpdateParticipantsMatchingLabelsMutationVariables = Exact<{
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
  action: MatchingLabelAction;
  labelKinds: Array<MatchingLabelKindTypes> | MatchingLabelKindTypes;
}>;


export type UpdateParticipantsMatchingLabelsMutation = { __typename?: 'Mutation', updateParticipantsMatchingLabels?: { __typename?: 'UpdateParticipantsMatchingLabelsPayload', batchActionId?: string | null, errors?: string | null } | null };

export type CreateProgramAutomatchingDefaultMutationVariables = Exact<{
  automatchingDefaultId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type CreateProgramAutomatchingDefaultMutation = { __typename?: 'Mutation', createProgramAutomatchingDefault?: { __typename?: 'CreateProgramAutomatchingDefaultPayload', programAutomatchingDefault?: { __typename?: 'ProgramAutomatchingDefault', id: string, automatchingDefault: { __typename?: 'AutomatchingDefault', id: string, identifier: string, displayName: string, createdAt: any, settings: { __typename?: 'SuggestedBatchSettings', matchingCriteria: { __typename?: 'MatchingCriteria', includeMentorsWithoutTraining: boolean, includeMenteesWithoutMatchingSurveys: boolean, includeMentorsWithoutMatchingSurveys: boolean, sharedTransferStatus: boolean, includeMenteesUnder17: boolean, includeMenteesWithFreeResponses: boolean, requireMenteeSupermentorOptIn?: boolean | null, requireMentorSupermentorOptIn?: boolean | null, includeMenteesWithSupermentorOptIn?: boolean | null, includeMentorsWithSupermentorOptIn?: boolean | null, enrollmentMenteeMatchingCriteria?: EnrollmentMenteeMatchingCriteria | null, onlyEnrollmentOptInMentees?: boolean | null, includeAvailableToMatchEnrollmentMentees?: boolean | null, includeMentorsWithMentorships?: boolean | null, includeEverMatchedEnrollmentMentees?: boolean | null, includeMenteesWhoHaveBeenUnmatched?: boolean | null, includeMentorsWhoHaveBeenUnmatched?: boolean | null, includeMenteesWhoArePushedThroughToMatch?: boolean | null, includeMentorsWhoArePushedThroughToMatch?: boolean | null, hardMatchQuestions?: Array<{ __typename: 'MultiSelectHardMatchQuestion', qid: string } | { __typename: 'SingleSelectHardMatchQuestion', qid: string }> | null }, autoMatchingSettings: { __typename?: 'AutoMatchSettings', scoreThreshold?: number | null, standardScoreThreshold?: number | null, supermentorScoreThreshold?: number | null, mentorCapacityCap?: number | null, standardMatching?: boolean | null, supermentorMatching?: boolean | null }, groupMatchingSettings?: { __typename?: 'GroupMatchingSettings', minGroupSize: number, maxGroupSize: number } | null } } } | null, errors: Array<{ __typename?: 'Error', path: string, message: string }> } | null };

export type AutomatchingDefaultsQueryVariables = Exact<{ [key: string]: never; }>;


export type AutomatchingDefaultsQuery = { __typename?: 'Query', automatchingDefaults: Array<{ __typename?: 'AutomatchingDefault', id: string, identifier: string, displayName: string, createdAt: any }> };

export type AutoSuggestMatchesMutationVariables = Exact<{
  inputData: AutoSuggestMatchesInput;
}>;


export type AutoSuggestMatchesMutation = { __typename?: 'Mutation', autoSuggestMatches?: { __typename?: 'AutoSuggestMatchesPayload', batchId?: string | null, errors: Array<{ __typename?: 'Error', message: string, path: string }> } | null };

export type SuggestedBatchesQueryVariables = Exact<{
  filter: SuggestedBatchFilter;
  sort?: InputMaybe<SuggestedBatchSort>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuggestedBatchesQuery = { __typename?: 'Query', suggestedBatches: { __typename?: 'SuggestedBatchConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes: Array<{ __typename?: 'SuggestedBatch', id: string, status: SuggestedBatchStatus, strategyType?: AutoMatchStrategy | null, createdAt: any, overview?: any | null, adminUser: { __typename?: 'User', id: string, firstName: string, lastName: string }, settings: { __typename?: 'SuggestedBatchSettings', matchingCriteria: { __typename?: 'MatchingCriteria', sharedMajor: boolean, includeMentorsWithoutTraining: boolean, includeMenteesWithoutMatchingSurveys: boolean, includeMentorsWithoutMatchingSurveys: boolean, sharedTransferStatus: boolean, includeMenteesUnder17: boolean, includeMenteesWithFreeResponses: boolean, requireMenteeSupermentorOptIn?: boolean | null, requireMentorSupermentorOptIn?: boolean | null, includeMenteesWithSupermentorOptIn?: boolean | null, includeMentorsWithSupermentorOptIn?: boolean | null, enrollmentMenteeMatchingCriteria?: EnrollmentMenteeMatchingCriteria | null, onlyEnrollmentOptInMentees?: boolean | null, includeAvailableToMatchEnrollmentMentees?: boolean | null, includeMentorsWithMentorships?: boolean | null, includeEverMatchedEnrollmentMentees?: boolean | null, includeMenteesWhoHaveBeenUnmatched?: boolean | null, includeMentorsWhoHaveBeenUnmatched?: boolean | null, includeMenteesWhoArePushedThroughToMatch?: boolean | null, includeMentorsWhoArePushedThroughToMatch?: boolean | null, hardMatchQuestions?: Array<{ __typename: 'MultiSelectHardMatchQuestion', qid: string } | { __typename: 'SingleSelectHardMatchQuestion', qid: string }> | null }, questionsWeights?: Array<{ __typename?: 'QuestionWeight', qid: string, weight: number }> | null, autoMatchingSettings: { __typename?: 'AutoMatchSettings', scoreThreshold?: number | null, supermentorScoreThreshold?: number | null, standardScoreThreshold?: number | null, mentorCapacityCap?: number | null, supermentorMatching?: boolean | null, standardMatching?: boolean | null }, groupMatchingSettings?: { __typename?: 'GroupMatchingSettings', maxGroupSize: number, minGroupSize: number } | null } }> } };

export type DeleteSuggestedBatchMutationVariables = Exact<{
  batchId: Scalars['ID']['input'];
}>;


export type DeleteSuggestedBatchMutation = { __typename?: 'Mutation', deleteSuggestedBatch?: { __typename?: 'DeleteSuggestedBatchPayload', deletedId?: string | null } | null };

export type MakeBatchMatchesMutationVariables = Exact<{
  inputData: Scalars['ID']['input'];
}>;


export type MakeBatchMatchesMutation = { __typename?: 'Mutation', makeBatchMatches?: { __typename?: 'MakeBatchMatchesPayload', errors: Array<{ __typename?: 'Error', message: string, path: string }>, suggestedBatch: { __typename?: 'SuggestedBatch', id: string, status: SuggestedBatchStatus } } | null };

export type SaveBatchMatchesMutationVariables = Exact<{
  inputData: Scalars['ID']['input'];
}>;


export type SaveBatchMatchesMutation = { __typename?: 'Mutation', saveBatchMatches?: { __typename?: 'SaveBatchMatchesPayload', errors: Array<{ __typename?: 'Error', message: string, path: string }>, suggestedBatch: { __typename?: 'SuggestedBatch', id: string, status: SuggestedBatchStatus } } | null };

export type CreateProgramAutomatchingConfigurationMutationVariables = Exact<{
  configuration: CreateProgramAutomatchingConfigurationInput;
}>;


export type CreateProgramAutomatchingConfigurationMutation = { __typename?: 'Mutation', createProgramAutomatchingConfiguration?: { __typename?: 'CreateProgramAutomatchingConfigurationPayload', programAutomatchingConfiguration?: { __typename?: 'ProgramAutomatchingConfiguration', id: string, settings: { __typename?: 'SuggestedBatchSettings', matchingCriteria: { __typename?: 'MatchingCriteria', includeMentorsWithoutTraining: boolean, includeMenteesWithoutMatchingSurveys: boolean, includeMentorsWithoutMatchingSurveys: boolean, sharedTransferStatus: boolean, sharedMajor: boolean, includeMenteesUnder17: boolean, includeMenteesWithFreeResponses: boolean, requireMenteeSupermentorOptIn?: boolean | null, requireMentorSupermentorOptIn?: boolean | null, includeMenteesWithSupermentorOptIn?: boolean | null, includeMentorsWithSupermentorOptIn?: boolean | null, enrollmentMenteeMatchingCriteria?: EnrollmentMenteeMatchingCriteria | null, onlyEnrollmentOptInMentees?: boolean | null, includeAvailableToMatchEnrollmentMentees?: boolean | null, includeMentorsWithMentorships?: boolean | null, includeEverMatchedEnrollmentMentees?: boolean | null, includeMenteesWhoHaveBeenUnmatched?: boolean | null, includeMentorsWhoHaveBeenUnmatched?: boolean | null, includeMenteesWhoArePushedThroughToMatch?: boolean | null, includeMentorsWhoArePushedThroughToMatch?: boolean | null, hardMatchQuestions?: Array<{ __typename: 'MultiSelectHardMatchQuestion', qid: string } | { __typename: 'SingleSelectHardMatchQuestion', qid: string }> | null }, autoMatchingSettings: { __typename?: 'AutoMatchSettings', scoreThreshold?: number | null, standardScoreThreshold?: number | null, supermentorScoreThreshold?: number | null, mentorCapacityCap?: number | null, standardMatching?: boolean | null, supermentorMatching?: boolean | null }, groupMatchingSettings?: { __typename?: 'GroupMatchingSettings', minGroupSize: number, maxGroupSize: number } | null } } | null, errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type ProgramAutomatchingDefaultQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramAutomatchingDefaultQuery = { __typename?: 'Query', programAutomatchingDefault: { __typename?: 'ProgramAutomatchingDefault', id: string, automatchingDefault: { __typename?: 'AutomatchingDefault', id: string, identifier: string, displayName: string, settings: { __typename?: 'SuggestedBatchSettings', matchingCriteria: { __typename?: 'MatchingCriteria', includeMentorsWithoutTraining: boolean, includeMenteesWithoutMatchingSurveys: boolean, includeMentorsWithoutMatchingSurveys: boolean, sharedTransferStatus: boolean, includeMenteesUnder17: boolean, includeMenteesWithFreeResponses: boolean, requireMenteeSupermentorOptIn?: boolean | null, requireMentorSupermentorOptIn?: boolean | null, includeMenteesWithSupermentorOptIn?: boolean | null, includeMentorsWithSupermentorOptIn?: boolean | null, enrollmentMenteeMatchingCriteria?: EnrollmentMenteeMatchingCriteria | null, onlyEnrollmentOptInMentees?: boolean | null, includeAvailableToMatchEnrollmentMentees?: boolean | null, includeMentorsWithMentorships?: boolean | null, includeEverMatchedEnrollmentMentees?: boolean | null, includeMenteesWhoHaveBeenUnmatched?: boolean | null, includeMentorsWhoHaveBeenUnmatched?: boolean | null, includeMenteesWhoArePushedThroughToMatch?: boolean | null, includeMentorsWhoArePushedThroughToMatch?: boolean | null, hardMatchQuestions?: Array<{ __typename: 'MultiSelectHardMatchQuestion', qid: string } | { __typename: 'SingleSelectHardMatchQuestion', qid: string }> | null }, autoMatchingSettings: { __typename?: 'AutoMatchSettings', scoreThreshold?: number | null, standardScoreThreshold?: number | null, supermentorScoreThreshold?: number | null, mentorCapacityCap?: number | null, standardMatching?: boolean | null, supermentorMatching?: boolean | null }, groupMatchingSettings?: { __typename?: 'GroupMatchingSettings', minGroupSize: number, maxGroupSize: number } | null, questionsWeights?: Array<{ __typename?: 'QuestionWeight', qid: string, weight: number }> | null } } } };

export type ProgramAutomatchingConfigurationQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramAutomatchingConfigurationQuery = { __typename?: 'Query', programAutomatchingConfiguration?: { __typename?: 'ProgramAutomatchingConfiguration', id: string, settings: { __typename?: 'SuggestedBatchSettings', matchingCriteria: { __typename?: 'MatchingCriteria', includeMentorsWithoutTraining: boolean, includeMenteesWithoutMatchingSurveys: boolean, includeMentorsWithoutMatchingSurveys: boolean, sharedTransferStatus: boolean, includeMenteesUnder17: boolean, includeMenteesWithFreeResponses: boolean, requireMenteeSupermentorOptIn?: boolean | null, requireMentorSupermentorOptIn?: boolean | null, includeMenteesWithSupermentorOptIn?: boolean | null, includeMentorsWithSupermentorOptIn?: boolean | null, enrollmentMenteeMatchingCriteria?: EnrollmentMenteeMatchingCriteria | null, onlyEnrollmentOptInMentees?: boolean | null, includeAvailableToMatchEnrollmentMentees?: boolean | null, includeMentorsWithMentorships?: boolean | null, includeEverMatchedEnrollmentMentees?: boolean | null, includeMenteesWhoHaveBeenUnmatched?: boolean | null, includeMentorsWhoHaveBeenUnmatched?: boolean | null, includeMenteesWhoArePushedThroughToMatch?: boolean | null, includeMentorsWhoArePushedThroughToMatch?: boolean | null, hardMatchQuestions?: Array<{ __typename: 'MultiSelectHardMatchQuestion', qid: string } | { __typename: 'SingleSelectHardMatchQuestion', qid: string }> | null }, autoMatchingSettings: { __typename?: 'AutoMatchSettings', scoreThreshold?: number | null, standardScoreThreshold?: number | null, supermentorScoreThreshold?: number | null, mentorCapacityCap?: number | null, standardMatching?: boolean | null, supermentorMatching?: boolean | null }, groupMatchingSettings?: { __typename?: 'GroupMatchingSettings', minGroupSize: number, maxGroupSize: number } | null, questionsWeights?: Array<{ __typename?: 'QuestionWeight', qid: string, weight: number }> | null } } | null };

export type ProgramMatchingEnabledQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProgramMatchingEnabledQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, allowMatching: boolean } };

export type ProgramCountOfPrioritizedAndPendingForRematchQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProgramCountOfPrioritizedAndPendingForRematchQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, students: { __typename?: 'ParticipantConnection', totalPrioritizedAndPendingForRematching: number }, mentors: { __typename?: 'ParticipantConnection', totalPrioritizedAndPendingForRematching: number } } };

export type UpdateProgramMatchingEnabledMutationVariables = Exact<{
  inputData: UpdateProgramInfoInput;
}>;


export type UpdateProgramMatchingEnabledMutation = { __typename?: 'Mutation', updateProgramInfo?: { __typename?: 'UpdateProgramInfoPayload', errors: Array<{ __typename?: 'UpdateProgramInfoError', message: string, path: UpdateProgramInfoErrorPaths }>, program?: { __typename?: 'Program', id: string, allowMatching: boolean } | null } | null };

export type SelectedContactsQueryVariables = Exact<{
  contactsFilter: ContactsFilter;
}>;


export type SelectedContactsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactConnection', nodes: Array<{ __typename: 'MentorContact', id: string, activationStatus: ActivationStatus, activationStatusChangedAt?: any | null, registered: boolean } | { __typename: 'StudentContact', id: string, activationStatus: ActivationStatus, activationStatusChangedAt?: any | null, registered: boolean }> } };

export type DeleteContactsByIdsMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteContactsByIdsMutation = { __typename?: 'Mutation', deleteProgramContacts?: { __typename?: 'DeleteContacts', byIds: { __typename?: 'DeleteContactsByIdsPayload', numberOfContactsDeleted?: number | null, errors: Array<ContactsNotAbleToBeDeletedError> } } | null };

export type DeleteContactsByFilterSelectionMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  filter: ContactsFilter;
}>;


export type DeleteContactsByFilterSelectionMutation = { __typename?: 'Mutation', deleteProgramContacts?: { __typename?: 'DeleteContacts', byFilterSelection: { __typename?: 'DeleteContactsByFilterSelectionPayload', numberOfContactsDeleted?: number | null, errors: Array<ContactsNotAbleToBeDeletedError> } } | null };

export type StartFirstWaveRecruitmentByIdsMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type StartFirstWaveRecruitmentByIdsMutation = { __typename?: 'Mutation', startFirstWaveRecruitment?: { __typename?: 'StartFirstWaveRecruitment', byIds: { __typename?: 'StartFirstWaveRecruitmentByIdsPayload', numberOfContactsActivated?: number | null, errors: Array<ContactsNotAbleToBeActivatedError> } } | null };

export type StartFirstWaveRecruitmentByFiltersMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  filter: ContactsFilter;
}>;


export type StartFirstWaveRecruitmentByFiltersMutation = { __typename?: 'Mutation', startFirstWaveRecruitment?: { __typename?: 'StartFirstWaveRecruitment', byFilterSelection: { __typename?: 'StartFirstWaveRecruitmentByFilterSelectionPayload', numberOfContactsActivated?: number | null, errors: Array<ContactsNotAbleToBeActivatedError> } } | null };

export type StartSecondWaveRecruitmentByIdsMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type StartSecondWaveRecruitmentByIdsMutation = { __typename?: 'Mutation', startSecondWaveRecruitment?: { __typename?: 'StartSecondWaveRecruitment', byIds: { __typename?: 'StartSecondWaveRecruitmentByIdsPayload', numberOfContactsActivated?: number | null, errors: Array<ContactsNotAbleToBeActivatedError> } } | null };

export type StartSecondWaveRecruitmentByFiltersMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  filter: ContactsFilter;
}>;


export type StartSecondWaveRecruitmentByFiltersMutation = { __typename?: 'Mutation', startSecondWaveRecruitment?: { __typename?: 'StartSecondWaveRecruitment', byFilterSelection: { __typename?: 'StartSecondWaveRecruitmentByFilterSelectionPayload', numberOfContactsActivated?: number | null, errors: Array<ContactsNotAbleToBeActivatedError> } } | null };

export type StopRecruitmentByIdsMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type StopRecruitmentByIdsMutation = { __typename?: 'Mutation', stopRecruitment?: { __typename?: 'StopRecruitment', byIds: { __typename?: 'StopRecruitmentByIdsPayload', numberOfContactsDeactivated?: number | null, errors: Array<ContactsNotAbleToBeDeactivatedError> } } | null };

export type StopRecruitmentByFiltersMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  filter: ContactsFilter;
}>;


export type StopRecruitmentByFiltersMutation = { __typename?: 'Mutation', stopRecruitment?: { __typename?: 'StopRecruitment', byFilterSelection: { __typename?: 'StopRecruitmentByFilterSelectionPayload', numberOfContactsDeactivated?: number | null, errors: Array<ContactsNotAbleToBeDeactivatedError> } } | null };

export type ProgramContactsSummaryQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramContactsSummaryQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, usesNewCommunications: boolean, contacts: { __typename?: 'ContactConnection', totalCount: number, mentorContactCount: number, studentContactCount: number, notActivatedCount: number, activatedCount: number, secondWaveCount: number, registeredCount: number, batchActionIds: Array<string>, uploadedByUsers: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string }> } } };

export type UserProfileDataFragmentFragment = { __typename?: 'User', userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null };

export type FilteredProgramContactsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  contactsFilter?: InputMaybe<ContactsFilter>;
  contactsSort?: InputMaybe<ContactsSort>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
}>;


export type FilteredProgramContactsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, usesNewCommunications: boolean, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null }, contacts: { __typename?: 'ContactConnection', totalCount: number, mentorContactCount: number, studentContactCount: number, notActivatedCount: number, activatedCount: number, secondWaveCount: number, registeredCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename: 'MentorContact', id: string, uploadedDate: any, activationStatus: ActivationStatus, activationStatusChangedAt?: any | null, batchActionId?: string | null, user: { __typename?: 'User', id: string, participants: Array<{ __typename: 'Mentor', id: string, registered: boolean, program: { __typename?: 'Program', id: string } } | { __typename: 'Student', id: string, registered: boolean, program: { __typename?: 'Program', id: string } }>, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null }, uploadedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, a2pSmses: Array<{ __typename?: 'A2pSms', id: string }> } | { __typename: 'StudentContact', id: string, uploadedDate: any, activationStatus: ActivationStatus, activationStatusChangedAt?: any | null, batchActionId?: string | null, user: { __typename?: 'User', id: string, participants: Array<{ __typename: 'Mentor', id: string, registered: boolean, program: { __typename?: 'Program', id: string } } | { __typename: 'Student', id: string, registered: boolean, program: { __typename?: 'Program', id: string } }>, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null }, uploadedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, a2pSmses: Array<{ __typename?: 'A2pSms', id: string }> }> } } };

export type UpdateProgramOutreachStageMutationVariables = Exact<{
  inputData: UpdateProgramInfoInput;
}>;


export type UpdateProgramOutreachStageMutation = { __typename?: 'Mutation', updateProgramInfo?: { __typename?: 'UpdateProgramInfoPayload', errors: Array<{ __typename?: 'UpdateProgramInfoError', message: string, path: UpdateProgramInfoErrorPaths }>, program?: { __typename?: 'Program', id: string, currentStage: ProgramStage } | null } | null };

export type CreateProgramTopicMutationVariables = Exact<{
  input: CreateProgramTopicInput;
}>;


export type CreateProgramTopicMutation = { __typename?: 'Mutation', createProgramTopic?: { __typename?: 'CreateProgramTopicPayload', programTopic: { __typename?: 'ProgramTopic', id: string, startDate?: any | null, endDate?: any | null, name?: string | null, topic: { __typename?: 'Topic', id: string, category: TopicCategory } } } | null };

export type DeleteProgramTopicMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProgramTopicMutation = { __typename?: 'Mutation', deleteProgramTopic?: { __typename?: 'DeleteProgramTopicPayload', errors: Array<ProgramTopicNotAbleToBeDeletedError> } | null };

export type UpdateProgramTopicMutationVariables = Exact<{
  input: UpdateProgramTopicInput;
}>;


export type UpdateProgramTopicMutation = { __typename?: 'Mutation', updateProgramTopic?: { __typename?: 'UpdateProgramTopicPayload', programTopic: { __typename?: 'ProgramTopic', id: string, startDate?: any | null, endDate?: any | null, name?: string | null, topic: { __typename?: 'Topic', id: string, category: TopicCategory } } } | null };

export type ProgramTopicsForProgramQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  filter?: InputMaybe<ProgramTopicsFilter>;
  sort?: InputMaybe<ProgramTopicsSort>;
}>;


export type ProgramTopicsForProgramQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, active: boolean, usesNewCommunications: boolean, programTopics: { __typename?: 'ProgramTopicConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, startCursor?: string | null }, nodes: Array<{ __typename?: 'ProgramTopic', id: string, name?: string | null, active: boolean, lastEditedAt: any, startDate?: any | null, endDate?: any | null, topic: { __typename?: 'Topic', id: string, name: string, category: TopicCategory } }> } } };

export type ProgramCommunicationsAvailableCampaignsQueryVariables = Exact<{
  input: Array<TopicCollectionInput> | TopicCollectionInput;
}>;


export type ProgramCommunicationsAvailableCampaignsQuery = { __typename?: 'Query', outreachTopicCollections: Array<{ __typename?: 'TopicCollection', key: string, topics: { __typename?: 'TopicConnection', totalCount: number, nodes: Array<{ __typename?: 'Topic', id: string, name: string, archivedAt?: any | null }> } }> };

export type UpdateProgramTopicsMutationVariables = Exact<{
  programTopics: UpdateProgramTopicsInput;
}>;


export type UpdateProgramTopicsMutation = { __typename?: 'Mutation', updateProgramTopics?: { __typename?: 'UpdateProgramTopicsPayload', errors: Array<{ __typename?: 'UpdateProgramTopicsError', message: string, path: UpdateProgramTopicsErrorPaths }>, program?: { __typename?: 'Program', id: string, programTopics: { __typename?: 'ProgramTopicConnection', nodes: Array<{ __typename?: 'ProgramTopic', id: string, active: boolean, delayBeforeRestart: number, lastEditedAt: any, topic: { __typename?: 'Topic', id: string, name: string, userState: UserState, hoursDelayBeforeRestart: number, archivedAt?: any | null, topicConditions: Array<{ __typename?: 'TopicCondition', id: string, key: TopicConditionKey, value: boolean }> } }> } } | null } | null };

export type UpdateProgramCommunicationSettingsMutationVariables = Exact<{
  input: UpdateProgramCommunicationSettingsInput;
}>;


export type UpdateProgramCommunicationSettingsMutation = { __typename?: 'Mutation', updateProgramCommunicationSettings?: { __typename?: 'UpdateProgramCommunicationSettingsPayload', program: { __typename?: 'Program', id: string, communicationMediumPreference?: Message | null, usesNewCommunications: boolean } } | null };

export type MessageTemplatesForProgramConfigurationQueryVariables = Exact<{
  filter: MessageTemplatesFilter;
  sort: MessageTemplatesSort;
}>;


export type MessageTemplatesForProgramConfigurationQuery = { __typename?: 'Query', messageTemplates: { __typename?: 'MessageTemplateConnection', nodes: Array<{ __typename?: 'EmailTemplate', id: string, name: string, customMessageType?: ProgramCustomMessage | null, archivedAt?: any | null } | { __typename?: 'SmsTemplate', id: string, name: string, customMessageType?: ProgramCustomMessage | null, archivedAt?: any | null }> } };

export type UpdateProgramCustomMessageTemplatesMutationVariables = Exact<{
  programCustomMessageTemplates: UpdateProgramCustomMessageTemplatesInput;
}>;


export type UpdateProgramCustomMessageTemplatesMutation = { __typename?: 'Mutation', updateProgramCustomMessageTemplates?: { __typename?: 'UpdateProgramCustomMessageTemplatesPayload', program?: { __typename?: 'Program', id: string, customMessageTemplates?: Array<{ __typename?: 'ProgramCustomMessageTemplate', id: string, customMessageType: ProgramCustomMessage, messageTemplate: { __typename?: 'EmailTemplate', id: string, name: string, archivedAt?: any | null } | { __typename?: 'SmsTemplate', id: string, name: string, archivedAt?: any | null } }> | null } | null, errors: Array<{ __typename?: 'UpdateProgramCustomMessageTemplatesError', path: UpdateProgramCustomMessageTemplatesErrorPaths, message: string }> } | null };

export type ProgramContentInfoQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramContentInfoQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, active: boolean, reRecruitedMentorsCanSkipMatchingSurvey: boolean, currentStage: ProgramStage, endDate: any, usesNewCommunications: boolean, communicationMediumPreference?: Message | null, defaultProfileImage?: string | null, showMatchingSurveysToPartner: boolean, customMessageTemplates?: Array<{ __typename?: 'ProgramCustomMessageTemplate', id: string, customMessageType: ProgramCustomMessage, messageTemplate: { __typename?: 'EmailTemplate', id: string, name: string } | { __typename?: 'SmsTemplate', id: string, name: string } }> | null, programTopics: { __typename?: 'ProgramTopicConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, startCursor?: string | null }, nodes: Array<{ __typename?: 'ProgramTopic', id: string, active: boolean, delayBeforeRestart: number, lastEditedAt: any, topic: { __typename?: 'Topic', id: string, name: string, userState: UserState, category: TopicCategory, hoursDelayBeforeRestart: number, topicConditions: Array<{ __typename?: 'TopicCondition', id: string, key: TopicConditionKey, value: boolean }> } }> }, mentorTrainingTask?: { __typename?: 'ProgramTask', id: string, required: boolean, programSpecific: boolean, toBeCompletedAs: TaskParticipantRole, position: number, task: { __typename?: 'ScheduleTrainingTask', calendlyUrl: string, id: string, prompt: string } | { __typename?: 'TakeExternalLinkTask', id: string, prompt: string } | { __typename?: 'TakeSurveyTask', id: string, prompt: string } | { __typename?: 'UploadPhotoTask', id: string, prompt: string } | { __typename?: 'UploadVideoTask', id: string, prompt: string } | { __typename?: 'WatchVideoTask', id: string, prompt: string } } | null, programTasks: Array<{ __typename?: 'ProgramTask', id: string, required: boolean, programSpecific: boolean, toBeCompletedAs: TaskParticipantRole, position: number, task: { __typename?: 'ScheduleTrainingTask', calendlyUrl: string, id: string, prompt: string } | { __typename?: 'TakeExternalLinkTask', id: string, prompt: string, externalLink: { __typename?: 'ExternalLink', id: string, href: string, kind: ExternalLinkKind } } | { __typename?: 'TakeSurveyTask', id: string, prompt: string, survey: { __typename?: 'Survey', id: string, surveyType?: SurveyType | null } } | { __typename?: 'UploadPhotoTask', id: string, prompt: string } | { __typename?: 'UploadVideoTask', id: string, prompt: string } | { __typename?: 'WatchVideoTask', wistiaVideoId: string, id: string, prompt: string } }>, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null, menteeQuizTask?: { __typename?: 'TakeExternalLinkTask', id: string, name?: string | null } | null, school: { __typename?: 'School', id: string, logo?: string | null } }, studentMatchingSurvey: { __typename: 'Survey', id: string, name: string, archived?: boolean | null, migrated?: boolean | null }, mentorMatchingSurvey: { __typename: 'Survey', id: string, name: string, archived?: boolean | null, migrated?: boolean | null }, mentorPostSessionSurvey: { __typename?: 'Survey', id: string, name: string }, studentPostSessionSurvey: { __typename?: 'Survey', id: string, name: string }, resources: { __typename?: 'ResourceConnection', totalCount: number } } };

export type ProgramMatchingSurveyCommunicationActivitiesQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ActivityLogsSort>;
  filter: ActivityLogsFilter;
}>;


export type ProgramMatchingSurveyCommunicationActivitiesQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, activityLogs: { __typename?: 'ActivityLogConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ActivityLog', id: string, eventType: ActivityLogEvent, occurredAt: any, loggableActivity: { __typename: 'AssessmentScoreResponse' } | { __typename: 'DeregistrationStatusEvent' } | { __typename: 'Flag' } | { __typename: 'Mentor' } | { __typename: 'MentorContact' } | { __typename: 'Mentorship' } | { __typename: 'PartnerNotification', id: string, partner: { __typename?: 'Partner', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } }, sender: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } } | { __typename: 'Student' } | { __typename: 'StudentContact' } | { __typename: 'SurveyResponse' } | { __typename: 'TrainingEventLog' } }> } } };

export type SendPartnerNotificationsMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  recipients: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SendPartnerNotificationsMutation = { __typename?: 'Mutation', sendPartnerNotifications?: { __typename?: 'SendPartnerNotificationsPayload', successRecipients?: Array<string> | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } | null };

export type RegisteredPartnersInProgramQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type RegisteredPartnersInProgramQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, programSequence: { __typename?: 'ProgramSequence', id: string, partners: Array<{ __typename?: 'Partner', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } }> } } };

export type MatchingSurveyPartnerNotificationPreferencesQueryVariables = Exact<{
  templatesFilter: MessageTemplatesFilter;
  programId: Scalars['ID']['input'];
  filterInitial: ActivityLogsFilter;
  filterUpdate: ActivityLogsFilter;
  sort: ActivityLogsSort;
}>;


export type MatchingSurveyPartnerNotificationPreferencesQuery = { __typename?: 'Query', messageTemplates: { __typename?: 'MessageTemplateConnection', nodes: Array<{ __typename?: 'EmailTemplate', id: string, identifier?: string | null } | { __typename?: 'SmsTemplate', id: string, identifier?: string | null }> }, program: { __typename?: 'Program', id: string, lastInitialNotification: { __typename?: 'ActivityLogConnection', nodes: Array<{ __typename?: 'ActivityLog', id: string, occurredAt: any }> }, lastUpdateNotification: { __typename?: 'ActivityLogConnection', nodes: Array<{ __typename?: 'ActivityLog', id: string, occurredAt: any }> } } };

export type CustomQuestionsOnProgramQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  filter?: InputMaybe<SurveyQuestionFilter>;
}>;


export type CustomQuestionsOnProgramQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, studentMatchingSurvey: { __typename?: 'Survey', id: string, questions: Array<{ __typename?: 'SurveyQuestion', id: string, qid?: string | null, customizations?: any | null }> }, mentorMatchingSurvey: { __typename?: 'Survey', id: string, questions: Array<{ __typename?: 'SurveyQuestion', id: string, qid?: string | null, customizations?: any | null }> } } };

export type QuestionRestrictedOptionsQueryVariables = Exact<{
  qid: Scalars['String']['input'];
}>;


export type QuestionRestrictedOptionsQuery = { __typename?: 'Query', surveyQuestionRestrictedOptions: { __typename?: 'SurveyQuestionRestrictedOptionConnection', nodes: Array<{ __typename?: 'SurveyQuestionRestrictedOption', id: string, label: string }> } };

export type BaseSurveyQuestionsQueryVariables = Exact<{
  filter?: InputMaybe<SurveysFilter>;
}>;


export type BaseSurveyQuestionsQuery = { __typename?: 'Query', surveys: { __typename?: 'SurveyConnection', totalCount: number, nodes: Array<{ __typename?: 'Survey', id: string, name: string, questions: Array<{ __typename?: 'SurveyQuestion', id: string, qid?: string | null, customizations?: any | null }> }> } };

export type CreateMatchingSurveyMutationVariables = Exact<{
  inputData: CreateMatchingSurveyInput;
  customQuestionInputData?: InputMaybe<Array<SurveyCustomizationQuestionInput> | SurveyCustomizationQuestionInput>;
}>;


export type CreateMatchingSurveyMutation = { __typename?: 'Mutation', createMatchingSurvey?: { __typename?: 'CreateMatchingSurveyPayload', errors: Array<{ __typename?: 'Error', message: string, path: string }>, surveys?: Array<{ __typename?: 'Survey', id: string, name: string }> | null, program?: { __typename?: 'Program', id: string, studentMatchingSurvey: { __typename: 'Survey', id: string, name: string }, mentorMatchingSurvey: { __typename: 'Survey', id: string, name: string } } | null } | null };

export type PreviewMatchingSurveyMutationVariables = Exact<{
  inputData: BaseMatchingSurveyInput;
  customQuestionInputData?: InputMaybe<Array<SurveyCustomizationQuestionInput> | SurveyCustomizationQuestionInput>;
  programId: Scalars['ID']['input'];
}>;


export type PreviewMatchingSurveyMutation = { __typename?: 'Mutation', previewMatchingSurvey?: { __typename?: 'PreviewMatchingSurveyPayload', mentorSurvey?: any | null, menteeSurvey?: any | null, previewParticipantFromSameProgram?: boolean | null, errors: Array<{ __typename?: 'Error', message: string, path: string }> } | null };

export type CreateOrEnableNewProgramTaskMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  newTaskId: Scalars['ID']['input'];
  assigneeEntity: AssigneeEntity;
  displayName: Scalars['String']['input'];
}>;


export type CreateOrEnableNewProgramTaskMutation = { __typename?: 'Mutation', createOrEnableNewProgramTask?: { __typename?: 'CreateOrEnableNewProgramTaskPayload', errors: Array<string>, newProgramTask?: { __typename?: 'NewProgramTask', id: string, displayName: string, assigneeEntity: AssigneeEntity, behavior: Behavior, enabled: boolean, programId: string, newTask: { __typename?: 'NewTask', id: string, internalTaskName: string } } | null } | null };

export type ExistingRequiredTrainingNewProgramTasksQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ExistingRequiredTrainingNewProgramTasksQuery = { __typename?: 'Query', newProgramTasks: { __typename?: 'NewProgramTaskConnection', nodes: Array<{ __typename?: 'NewProgramTask', id: string, displayName: string }> } };

export type GetSurveyDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSurveyDetailsQuery = { __typename?: 'Query', survey: { __typename?: 'Survey', id: string, name: string }, assessmentAreasForSurvey: Array<{ __typename?: 'AssessmentArea', id: string, name: string }> };

export type NewSurveysQueryVariables = Exact<{
  filter?: InputMaybe<SurveysFilter>;
}>;


export type NewSurveysQuery = { __typename?: 'Query', surveys: { __typename?: 'SurveyConnection', totalCount: number, nodes: Array<{ __typename: 'Survey', id: string, name: string, archived?: boolean | null, migrated?: boolean | null, surveyType?: SurveyType | null }> } };

export type MenteeQuizExternalLinkTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type MenteeQuizExternalLinkTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskConnection', totalCount: number, nodes: Array<{ __typename?: 'ScheduleTrainingTask', id: string, name?: string | null } | { __typename?: 'TakeExternalLinkTask', id: string, name?: string | null } | { __typename?: 'TakeSurveyTask', id: string, name?: string | null } | { __typename?: 'UploadPhotoTask', id: string, name?: string | null } | { __typename?: 'UploadVideoTask', id: string, name?: string | null } | { __typename?: 'WatchVideoTask', id: string, name?: string | null }> } };

export type UpdateProgramSurveysAndQuizzesMutationVariables = Exact<{
  inputData: UpdateSurveysAndQuizzesInput;
}>;


export type UpdateProgramSurveysAndQuizzesMutation = { __typename?: 'Mutation', updateSurveysAndQuizzes?: { __typename?: 'UpdateSurveysAndQuizzesPayload', errors: Array<{ __typename?: 'UpdateSurveysAndQuizzesError', message: string, path: UpdateSurveysAndQuizzesErrorPaths }>, program?: { __typename?: 'Program', id: string, showMatchingSurveysToPartner: boolean, programSequence: { __typename?: 'ProgramSequence', id: string, menteeQuizTask?: { __typename?: 'TakeExternalLinkTask', id: string, name?: string | null } | null }, studentMatchingSurvey: { __typename: 'Survey', id: string, name: string, archived?: boolean | null, migrated?: boolean | null }, mentorMatchingSurvey: { __typename: 'Survey', id: string, name: string, archived?: boolean | null, migrated?: boolean | null }, mentorPostSessionSurvey: { __typename?: 'Survey', id: string, name: string }, studentPostSessionSurvey: { __typename?: 'Survey', id: string, name: string } } | null } | null };

export type TasksQueryVariables = Exact<{ [key: string]: never; }>;


export type TasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TaskConnection', nodes: Array<{ __typename?: 'ScheduleTrainingTask', id: string, name?: string | null } | { __typename?: 'TakeExternalLinkTask', id: string, name?: string | null } | { __typename?: 'TakeSurveyTask', id: string, name?: string | null } | { __typename?: 'UploadPhotoTask', id: string, name?: string | null } | { __typename?: 'UploadVideoTask', id: string, name?: string | null } | { __typename?: 'WatchVideoTask', id: string, name?: string | null }> } };

export type CreateProgramTaskMutationVariables = Exact<{
  programTaskInput: CreateProgramTaskInput;
}>;


export type CreateProgramTaskMutation = { __typename?: 'Mutation', createProgramTask?: { __typename?: 'CreateProgramTaskPayload', errors: Array<string>, programTask?: { __typename?: 'ProgramTask', id: string } | null } | null };

export type CoursesQueryVariables = Exact<{
  coursesSort?: InputMaybe<CoursesSort>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CoursesQuery = { __typename?: 'Query', courses: { __typename?: 'CourseConnection', totalCount: number, nodes: Array<{ __typename?: 'Course', id: string, name: string }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateNewCourseTaskAndNewProgramTaskMutationVariables = Exact<{
  newCourseTaskAndNewProgramTaskInput: NewCourseTaskAndNewProgramTaskInput;
}>;


export type CreateNewCourseTaskAndNewProgramTaskMutation = { __typename?: 'Mutation', createNewCourseTaskAndNewProgramTask?: { __typename?: 'CreateNewCourseTaskAndNewProgramTaskPayload', newTask?: { __typename?: 'NewTask', id: string } | null, newProgramTask?: { __typename?: 'NewProgramTask', id: string } | null, duplicateTasks?: Array<{ __typename: 'NewTask', id: string, internalTaskName: string, segmentTags: Array<NewTaskSegmentTag>, context?: { __typename: 'AssessmentSurveyTaskContext', id: string, surveyId: string, programStage: AssessmentSurveyProgramStage } | { __typename: 'CourseTaskContext', id: string, courseId: string } | { __typename: 'LinkTaskContext', id: string, url: string } | null }> | null, errors: Array<{ __typename?: 'DuplicateError', duplicateNewTaskId: string, path: string, message: string }> } | null };

export type AvailableCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableCoursesQuery = { __typename?: 'Query', courses: { __typename?: 'CourseConnection', nodes: Array<{ __typename?: 'Course', name: string, active: boolean, id: string, published: boolean }> }, newTasks: { __typename?: 'NewTaskConnection', nodes: Array<{ __typename?: 'NewTask', internalTaskName: string, id: string, context?: { __typename?: 'AssessmentSurveyTaskContext', id: string, surveyId: string, programStage: AssessmentSurveyProgramStage } | { __typename?: 'CourseTaskContext', id: string, courseId: string } | { __typename?: 'LinkTaskContext', id: string } | null }> } };

export type ProgramLiveTrainingQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramLiveTrainingQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, mentorTrainingTask?: { __typename?: 'ProgramTask', id: string, task: { __typename?: 'ScheduleTrainingTask', id: string, prompt: string } | { __typename?: 'TakeExternalLinkTask', id: string, prompt: string } | { __typename?: 'TakeSurveyTask', id: string, prompt: string } | { __typename?: 'UploadPhotoTask', id: string, prompt: string } | { __typename?: 'UploadVideoTask', id: string, prompt: string } | { __typename?: 'WatchVideoTask', id: string, prompt: string } } | null } };

export type CreateNewLinkTaskAndNewProgramTaskMutationVariables = Exact<{
  newLinkTaskAndNewProgramTaskInput: NewLinkTaskAndNewProgramTaskInput;
}>;


export type CreateNewLinkTaskAndNewProgramTaskMutation = { __typename?: 'Mutation', createNewLinkTaskAndNewProgramTask?: { __typename?: 'CreateNewLinkTaskAndNewProgramTaskPayload', newTask?: { __typename?: 'NewTask', id: string } | null, newProgramTask?: { __typename?: 'NewProgramTask', id: string } | null, duplicateTasks?: Array<{ __typename: 'NewTask', id: string, internalTaskName: string, segmentTags: Array<NewTaskSegmentTag>, context?: { __typename: 'AssessmentSurveyTaskContext', id: string, surveyId: string, programStage: AssessmentSurveyProgramStage } | { __typename: 'CourseTaskContext', id: string, courseId: string } | { __typename: 'LinkTaskContext', id: string, url: string } | null }> | null, errors: Array<{ __typename?: 'DuplicateError', duplicateNewTaskId: string, path: string, message: string }> } | null };

export type ProgramShortNameQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramShortNameQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, shortName: string } };

export type UpdateAssessmentSurveyNewProgramTaskMutationVariables = Exact<{
  updateAssessmentSurveyNewProgramTaskInput: UpdateAssessmentSurveyNewProgramTaskInput;
}>;


export type UpdateAssessmentSurveyNewProgramTaskMutation = { __typename?: 'Mutation', updateAssessmentSurveyNewProgramTask?: { __typename?: 'UpdateAssessmentSurveyNewProgramTaskPayload', newProgramTask?: { __typename?: 'NewProgramTask', id: string, displayName: string, assigneeEntity: AssigneeEntity } | null, errors: Array<{ __typename?: 'Error', message: string, path: string }> } | null };

export type UpdateClickLinkNewProgramTaskMutationVariables = Exact<{
  updateClickLinkNewProgramTaskInput: UpdateClickLinkNewProgramTaskInput;
}>;


export type UpdateClickLinkNewProgramTaskMutation = { __typename?: 'Mutation', updateClickLinkNewProgramTask?: { __typename?: 'UpdateClickLinkNewProgramTaskPayload', newProgramTask?: { __typename?: 'NewProgramTask', id: string, displayName: string, assigneeEntity: AssigneeEntity } | null, errors: Array<{ __typename?: 'Error', message: string, path: string }> } | null };

export type CourseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CourseQuery = { __typename?: 'Query', course: { __typename?: 'Course', id: string, name: string } };

export type UpdateCourseNewProgramTaskMutationVariables = Exact<{
  updateCourseNewProgramTaskInput: UpdateCourseNewProgramTaskInput;
}>;


export type UpdateCourseNewProgramTaskMutation = { __typename?: 'Mutation', updateCourseNewProgramTask?: { __typename?: 'UpdateCourseNewProgramTaskPayload', newProgramTask?: { __typename?: 'NewProgramTask', id: string, displayName: string, behavior: Behavior, assigneeEntity: AssigneeEntity, newTask: { __typename?: 'NewTask', id: string, context?: { __typename: 'AssessmentSurveyTaskContext' } | { __typename: 'CourseTaskContext', id: string, courseId: string } | { __typename: 'LinkTaskContext' } | null } } | null, errors: Array<{ __typename?: 'Error', message: string, path: string }> } | null };

export type GetNewProgramTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetNewProgramTaskQuery = { __typename?: 'Query', newProgramTask: { __typename?: 'NewProgramTask', id: string, displayName: string, behavior: Behavior, assigneeEntity: AssigneeEntity, enabled: boolean, newTask: { __typename?: 'NewTask', id: string, internalTaskName: string, segmentTags: Array<NewTaskSegmentTag>, requiredForMatching?: boolean | null, mentorshipCredential?: { __typename?: 'MentorshipCredential', id: string, credential: MentorshipCredentialCredentials } | null, context?: { __typename: 'AssessmentSurveyTaskContext', id: string, surveyId: string, programStage: AssessmentSurveyProgramStage } | { __typename: 'CourseTaskContext', id: string, courseId: string } | { __typename: 'LinkTaskContext', id: string, url: string } | null } } };

export type ParticipantDetailsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ParticipantDetailsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, firstParticipantCreatedAt?: any | null, registeredMentorCount: { __typename?: 'ParticipantConnection', totalCount: number }, registeredStudentCount: { __typename?: 'ParticipantConnection', totalCount: number } } };

export type UpdateProgramTaskMutationVariables = Exact<{
  inputData: UpdateProgramTaskInput;
}>;


export type UpdateProgramTaskMutation = { __typename?: 'Mutation', updateProgramTask?: { __typename?: 'UpdateProgramTaskPayload', programTask: { __typename?: 'ProgramTask', id: string, position: number, toBeCompletedAs: TaskParticipantRole } } | null };

export type DeleteProgramTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProgramTaskMutation = { __typename?: 'Mutation', deleteProgramTask?: { __typename?: 'DeleteProgramTaskPayload', program?: { __typename?: 'Program', id: string, mentorTrainingTask?: { __typename: 'ProgramTask', id: string, required: boolean, programSpecific: boolean, toBeCompletedAs: TaskParticipantRole, position: number, task: { __typename: 'ScheduleTrainingTask', calendlyUrl: string, id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } | { __typename: 'TakeExternalLinkTask', id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } | { __typename: 'TakeSurveyTask', id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } | { __typename: 'UploadPhotoTask', id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } | { __typename: 'UploadVideoTask', id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } | { __typename: 'WatchVideoTask', id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } } | null, programTasks: Array<{ __typename?: 'ProgramTask', id: string, required: boolean, programSpecific: boolean, toBeCompletedAs: TaskParticipantRole, position: number, task: { __typename?: 'ScheduleTrainingTask', id: string, prompt: string } | { __typename?: 'TakeExternalLinkTask', id: string, prompt: string, externalLink: { __typename?: 'ExternalLink', id: string, href: string, kind: ExternalLinkKind } } | { __typename?: 'TakeSurveyTask', id: string, prompt: string, survey: { __typename?: 'Survey', id: string } } | { __typename?: 'UploadPhotoTask', id: string, prompt: string } | { __typename?: 'UploadVideoTask', id: string, prompt: string } | { __typename?: 'WatchVideoTask', wistiaVideoId: string, id: string, prompt: string } }> } | null } | null };

export type ProgramTasksQueryVariables = Exact<{
  filter: NewProgramTasksFilter;
  sort: NewProgramTasksSort;
}>;


export type ProgramTasksQuery = { __typename?: 'Query', newProgramTasks: { __typename?: 'NewProgramTaskConnection', nodes: Array<{ __typename?: 'NewProgramTask', id: string, displayName: string, assigneeEntity: AssigneeEntity, behavior: Behavior, enabled: boolean, programId: string, newTask: { __typename?: 'NewTask', id: string, segmentTags: Array<NewTaskSegmentTag>, internalTaskName: string, defaultDisplayName?: string | null, defaultAssigneeEntity?: AssigneeEntity | null, mentorshipCredential?: { __typename?: 'MentorshipCredential', id: string, credential: MentorshipCredentialCredentials } | null, context?: { __typename: 'AssessmentSurveyTaskContext', id: string, surveyId: string, programStage: AssessmentSurveyProgramStage } | { __typename: 'CourseTaskContext', id: string, courseId: string } | { __typename: 'LinkTaskContext', id: string, url: string } | null } }> } };

export type DisableNewProgramTaskMutationVariables = Exact<{
  disableNewProgramTaskInput: DisableNewProgramTaskInput;
}>;


export type DisableNewProgramTaskMutation = { __typename?: 'Mutation', disableNewProgramTask?: { __typename?: 'DisableNewProgramTaskPayload', newProgramTask: { __typename?: 'NewProgramTask', id: string, displayName: string, assigneeEntity: AssigneeEntity, behavior: Behavior, enabled: boolean, programId: string, newTask: { __typename?: 'NewTask', id: string, internalTaskName: string } } } | null };

export type AdminDashboardMentorshipEngagementDataExportQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type AdminDashboardMentorshipEngagementDataExportQuery = { __typename?: 'Query', csvExports: { __typename?: 'CsvExports', mentorshipEngagementData: { __typename?: 'CsvExport', id: string, filename?: string | null, isProcessing: boolean, url?: string | null } } };

export type ProgramSurveyResponsesCountQueryVariables = Exact<{
  programId: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
}>;


export type ProgramSurveyResponsesCountQuery = { __typename?: 'Query', surveyResponses?: { __typename?: 'SurveyResponseConnection', totalCount: number } | null };

export type ProgramSurveysQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProgramSurveysQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, currentPhase: ProgramPhase, studentOpeningAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, studentMidAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, studentEndAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, mentorOpeningAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, mentorMidAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, mentorEndAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, mentorMatchingSurvey: { __typename: 'Survey', id: string }, studentMatchingSurvey: { __typename: 'Survey', id: string }, mentorPostSessionSurvey: { __typename?: 'Survey', id: string }, studentPostSessionSurvey: { __typename?: 'Survey', id: string } } };

export type CompileRowsForProgramQueryVariables = Exact<{
  originalTexts: Array<Scalars['String']['input']> | Scalars['String']['input'];
  programId: Scalars['ID']['input'];
}>;


export type CompileRowsForProgramQuery = { __typename?: 'Query', programCompiledTexts: Array<string> };

export type CreateProgramResourceMutationVariables = Exact<{
  programResourceInput: CreateProgramResourceInput;
}>;


export type CreateProgramResourceMutation = { __typename?: 'Mutation', createProgramResource?: { __typename?: 'CreateProgramResourcePayload', errors: Array<{ __typename?: 'CreateProgramResourceError', message: string, path: CreateProgramResourceErrorPaths }>, programResource?: { __typename?: 'ProgramResource', title: string, url: string, user: { __typename?: 'User', firstName: string, lastName: string } } | null } | null };

export type UpdateProgramAuthenticationSettingsMutationVariables = Exact<{
  inputData: UpdateProgramInfoInput;
}>;


export type UpdateProgramAuthenticationSettingsMutation = { __typename?: 'Mutation', updateProgramInfo?: { __typename?: 'UpdateProgramInfoPayload', errors: Array<{ __typename?: 'UpdateProgramInfoError', message: string, path: UpdateProgramInfoErrorPaths }>, program?: { __typename?: 'Program', id: string, menteeLoginMode: ProgramMenteeLoginMode, mentorLoginMode: ProgramMentorLoginMode, mentorType?: MentorTypes | null } | null } | null };

export type UpdateProgramInfoMutationVariables = Exact<{
  inputData: UpdateProgramInfoInput;
}>;


export type UpdateProgramInfoMutation = { __typename?: 'Mutation', updateProgramInfo?: { __typename?: 'UpdateProgramInfoPayload', errors: Array<{ __typename?: 'UpdateProgramInfoError', message: string, path: UpdateProgramInfoErrorPaths }>, program?: { __typename?: 'Program', id: string, name: string, isTestProgram: boolean, isTemplateProgram: boolean, shortName: string, title: string, notes?: string | null, accountNotes?: string | null, defaultProfileImage?: string | null, programInfoUrl?: string | null, programLogo?: string | null, sftpExportEnabled: boolean, nonPriorityFlagEmailEnabled: boolean } | null } | null };

export type RegisteredParticipantsCountQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type RegisteredParticipantsCountQuery = { __typename?: 'Query', participants: { __typename?: 'ParticipantConnection', totalCount: number } };

export type UpdateProgramSignUpSettingsMutationVariables = Exact<{
  inputData: UpdateProgramInfoInput;
}>;


export type UpdateProgramSignUpSettingsMutation = { __typename?: 'Mutation', updateProgramInfo?: { __typename?: 'UpdateProgramInfoPayload', errors: Array<{ __typename?: 'UpdateProgramInfoError', message: string, path: UpdateProgramInfoErrorPaths }>, program?: { __typename?: 'Program', id: string, allowMentorSignUp: boolean, allowMenteeSignUp: boolean } | null } | null };

export type UpdateProgramCustomLabelMutationVariables = Exact<{
  inputData: UpdateProgramCustomLabelInput;
}>;


export type UpdateProgramCustomLabelMutation = { __typename?: 'Mutation', updateProgramCustomLabel?: { __typename?: 'UpdateProgramCustomLabelPayload', errors: Array<{ __typename?: 'Error', message: string, path: string }>, program?: { __typename?: 'Program', id: string, programSequence: { __typename?: 'ProgramSequence', id: string, menteeRecruitmentLink: string, mentorRecruitmentLink: string }, programCustomLabel?: { __typename?: 'ProgramCustomLabel', id: string, singularMentor?: string | null, singularMentorWithIndeterminateArticle?: string | null, pluralMentor?: string | null, respectMentorUppercase?: boolean | null, singularMentee?: string | null, singularMenteeWithIndeterminateArticle?: string | null, pluralMentee?: string | null, respectMenteeUppercase?: boolean | null, singularStudent?: string | null, singularStudentWithIndeterminateArticle?: string | null, pluralStudent?: string | null, respectStudentUppercase?: boolean | null, singularMentorship?: string | null, singularMentorshipWithIndeterminateArticle?: string | null, respectMentorshipUppercase?: boolean | null, pluralMentorship?: string | null, singularSchool?: string | null, singularSchoolWithIndeterminateArticle?: string | null, pluralSchool?: string | null, respectSchoolUppercase?: boolean | null } | null } | null } | null };

export type ProgramResourcesQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramResourcesQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, programResources: { __typename?: 'ProgramResourceConnection', nodes?: Array<{ __typename?: 'ProgramResource', id: string, title: string, url: string, uploadedAt: any, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } | null> | null } } };

export type DeleteProgramResourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProgramResourceMutation = { __typename?: 'Mutation', deleteProgramResource?: { __typename?: 'DeleteProgramResourcePayload', program?: { __typename?: 'Program', id: string, programResources: { __typename?: 'ProgramResourceConnection', nodes?: Array<{ __typename?: 'ProgramResource', id: string } | null> | null } } | null } | null };

export type UpdateProgramSetupMutationVariables = Exact<{
  inputData: UpdateProgramSetupInput;
}>;


export type UpdateProgramSetupMutation = { __typename?: 'Mutation', updateProgramSetup?: { __typename?: 'UpdateProgramSetupPayload', errors: Array<{ __typename?: 'UpdateProgramSetupError', message: string, path: UpdateProgramSetupErrorPaths }>, program?: { __typename?: 'Program', id: string, startDate: any, endDate: any, mentorType?: MentorTypes | null, matchingCap?: number | null, salesforceOpportunityId?: string | null, cohorts?: Array<ProgramCohort> | null, mentorLoginMode: ProgramMentorLoginMode, programSequence: { __typename?: 'ProgramSequence', id: string, kind: ProgramSequenceKindTypes, higherEdSegment?: ProgramSegment | null, school: { __typename?: 'School', id: string, programSequences: Array<{ __typename?: 'ProgramSequence', id: string, name: string }> } }, programGoal?: { __typename?: 'ProgramGoal', id: string, type: ProgramGoalTypes, target: number } | null, programTopics: { __typename?: 'ProgramTopicConnection', nodes: Array<{ __typename?: 'ProgramTopic', id: string, active: boolean, topic: { __typename?: 'Topic', id: string } }> } } | null } | null };

export type AllProgramSequencesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProgramSequencesQuery = { __typename?: 'Query', programSequences: { __typename?: 'ProgramSequenceConnection', nodes: Array<{ __typename?: 'ProgramSequence', id: string, name: string }> } };

export type AdminDashboardProgramDetailsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type AdminDashboardProgramDetailsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, shortName: string, title: string, notes?: string | null, accountNotes?: string | null, startDate: any, endDate: any, mentorType?: MentorTypes | null, matchingCap?: number | null, salesforceOpportunityId?: string | null, cohorts?: Array<ProgramCohort> | null, isTestProgram: boolean, isTemplateProgram: boolean, mentorLoginMode: ProgramMentorLoginMode, menteeLoginMode: ProgramMenteeLoginMode, allowMentorSignUp: boolean, allowMenteeSignUp: boolean, allowsMenteesToPushThemselvesThroughToMatch: boolean, defaultProfileImage?: string | null, programInfoUrl?: string | null, programLogo?: string | null, programGoal?: { __typename?: 'ProgramGoal', id: string, type: ProgramGoalTypes, target: number } | null, programSequence: { __typename?: 'ProgramSequence', id: string, kind: ProgramSequenceKindTypes, higherEdSegment?: ProgramSegment | null, menteeRecruitmentLink: string, mentorRecruitmentLink: string, school: { __typename?: 'School', id: string, ssoEnabled?: boolean | null, programSequences: Array<{ __typename?: 'ProgramSequence', id: string, name: string }> } } } };

export type ConfigureFlagsMutationVariables = Exact<{
  configureFlagsInput: ConfigureFlagsInput;
}>;


export type ConfigureFlagsMutation = { __typename?: 'Mutation', configureFlags?: { __typename?: 'ConfigureFlagsPayload', program?: { __typename?: 'Program', id: string, showMentorsFlags: boolean, programFlagCategories?: Array<{ __typename?: 'ProgramFlagCategory', id: string, isVisible: boolean, customDisplayName: string, customSmsCharacter?: string | null, flagCategory: { __typename?: 'FlagCategory', id: string, name: string, smsCharacter?: string | null } }> | null, programSequence: { __typename?: 'ProgramSequence', id: string, flagCategories: Array<{ __typename?: 'FlagCategory', id: string, name: string, smsCharacter?: string | null }> } } | null, errors: Array<{ __typename?: 'ConfigureFlagsError', path: string, message: string }> } | null };

export type FlagConfigurationDataQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type FlagConfigurationDataQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, showMentorsFlags: boolean, programFlagCategories?: Array<{ __typename?: 'ProgramFlagCategory', id: string, isVisible: boolean, customDisplayName: string, customSmsCharacter?: string | null, flagCategory: { __typename?: 'FlagCategory', id: string, name: string, smsCharacter?: string | null } }> | null, programSequence: { __typename?: 'ProgramSequence', id: string, flagCategories: Array<{ __typename?: 'FlagCategory', id: string, name: string, smsCharacter?: string | null }> } }, flags: { __typename?: 'FlagConnection', flagCategoriesSubmitted: Array<string> } };

export type EngagementDataQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type EngagementDataQuery = { __typename?: 'Query', mentorships: { __typename?: 'MentorshipConnection', totalCount: number, totalCountWithZeroConversations: number, totalCountWithThreeOrMoreConversations: number, totalCountWithConversationInTheLast30Days: number, totalCountUsingSmsRelay: number, totalCountMentorsDisengaged: number, totalCountMenteesDisengaged: number }, program: { __typename?: 'Program', id: string, engagementBenchmarkData?: { __typename?: 'EngagementBenchmarkData', mentorshipsInPreviousProgramWith0Conversations?: number | null, mentorshipsInPreviousProgramWith3OrMoreConversations?: number | null, mentorshipsInPreviousProgramUsingSmsRelay?: number | null, disengagedMentorsInPreviousProgram?: number | null, disengagedMenteesInPreviousProgram?: number | null } | null, students: { __typename?: 'ParticipantConnection', totalCount: number }, mentors: { __typename?: 'ParticipantConnection', totalCount: number } } };

export type ProgramContextQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramContextQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, createdAt: any, segment: ProgramSegment, endDate: any, trainingMode?: ProgramTrainingMode | null, currentPhase: ProgramPhase, contacts: { __typename?: 'ContactConnection', mentorContactCount: number, studentContactCount: number }, programGoal?: { __typename?: 'ProgramGoal', id: string, type: ProgramGoalTypes, target: number } | null, previousPrograms: { __typename?: 'ProgramSequence', id: string, programs: Array<{ __typename?: 'Program', id: string, createdAt: any }> } } };

export type ParticipantsCountForQueryVariables = Exact<{
  currentProgramFilter: ParticipantsFilter;
  includePreviousProgramQueries?: InputMaybe<Scalars['Boolean']['input']>;
  previousProgramFilter?: InputMaybe<ParticipantsFilter>;
  includeSegmentQueries?: InputMaybe<Scalars['Boolean']['input']>;
  segmentFilter?: InputMaybe<ParticipantsFilter>;
}>;


export type ParticipantsCountForQuery = { __typename?: 'Query', currentProgramParticipantsCount: { __typename?: 'ParticipantConnection', totalCount: number }, previousProgramParticipantsCount?: { __typename?: 'ParticipantConnection', totalCount: number }, segmentParticipantsCount?: { __typename?: 'ParticipantConnection', totalCount: number } };

export type ProgramMatchingGoalQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramMatchingGoalQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, programGoal?: { __typename?: 'ProgramGoal', id: string, type: ProgramGoalTypes, target: number } | null } };

export type ContactsCsvForQueryVariables = Exact<{
  contactsFilter: ContactsFilter;
}>;


export type ContactsCsvForQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactConnection', nodes: Array<{ __typename?: 'MentorContact', id: string, uploadedDate: any, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, unsubscribedFromEmails: boolean, unsubscribedFromSmses: boolean } } | { __typename?: 'StudentContact', id: string, uploadedDate: any, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, unsubscribedFromEmails: boolean, unsubscribedFromSmses: boolean } }> } };

export type MentorsCsvForQueryVariables = Exact<{
  participantsFilter: ParticipantsFilter;
}>;


export type MentorsCsvForQuery = { __typename?: 'Query', participants: { __typename?: 'ParticipantConnection', totalCount: number, nodes: Array<{ __typename?: 'Mentor', requiredTrainingStatus?: string | null, lastCompletedRequiredTrainingAt?: any | null, id: string, registered: boolean, registrationDate: any, completedMatchingSurveyAt?: any | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, unsubscribedFromEmails: boolean, unsubscribedFromSmses: boolean } } | { __typename?: 'Student', id: string, registered: boolean, registrationDate: any, completedMatchingSurveyAt?: any | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, unsubscribedFromEmails: boolean, unsubscribedFromSmses: boolean } }> } };

export type StudentsCsvForQueryVariables = Exact<{
  participantsFilter: ParticipantsFilter;
}>;


export type StudentsCsvForQuery = { __typename?: 'Query', participants: { __typename?: 'ParticipantConnection', totalCount: number, nodes: Array<{ __typename?: 'Mentor', id: string, registered: boolean, registrationDate: any, completedMatchingSurveyAt?: any | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, unsubscribedFromEmails: boolean, unsubscribedFromSmses: boolean } } | { __typename?: 'Student', id: string, registered: boolean, registrationDate: any, completedMatchingSurveyAt?: any | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, unsubscribedFromEmails: boolean, unsubscribedFromSmses: boolean } }> } };

export type AdminDashboardCompletedTrainingProgramInfoQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type AdminDashboardCompletedTrainingProgramInfoQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, segment: ProgramSegment, startDate: any, endDate: any, requiredMentorTrainingCredential?: string | null, programSequence: { __typename?: 'ProgramSequence', id: string, programs: Array<{ __typename?: 'Program', id: string, createdAt: any, startDate: any, endDate: any }> } } };

export type CredentialedMentorsCsvForQueryVariables = Exact<{
  participantsFilter: ParticipantsFilter;
  credential: Scalars['String']['input'];
}>;


export type CredentialedMentorsCsvForQuery = { __typename?: 'Query', participants: { __typename?: 'ParticipantConnection', nodes: Array<{ __typename?: 'Mentor', id: string, completedMatchingSurveyAt?: any | null, registered: boolean, registrationDate: any, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, unsubscribedFromEmails: boolean, unsubscribedFromSmses: boolean, mentorshipCredentials: Array<{ __typename?: 'UserMentorshipCredential', id: string, createdAt: any, updatedAt: any, mentorshipCredential?: { __typename?: 'MentorshipCredential', id: string, credential: MentorshipCredentialCredentials } | null }> } } | { __typename?: 'Student', id: string, completedMatchingSurveyAt?: any | null, registered: boolean, registrationDate: any, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, unsubscribedFromEmails: boolean, unsubscribedFromSmses: boolean, mentorshipCredentials: Array<{ __typename?: 'UserMentorshipCredential', id: string, createdAt: any, updatedAt: any, mentorshipCredential?: { __typename?: 'MentorshipCredential', id: string, credential: MentorshipCredentialCredentials } | null }> } }> } };

export type AdminDashboardCredentialedParticipantMetricsQueryVariables = Exact<{
  filter?: InputMaybe<ParticipantsFilter>;
  dateRange?: InputMaybe<DateRange>;
}>;


export type AdminDashboardCredentialedParticipantMetricsQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', participants: { __typename?: 'ParticipantsMetrics', totalCredentialed: Array<{ __typename?: 'Interval', value: number, date: any }>, totalRegistered: Array<{ __typename?: 'Interval', value: number, date: any }> } } };

export type OpenMentorSlotsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type OpenMentorSlotsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, numberOfOpenMentorSlots: number } };

export type BatchRegisterExistingUsersAdminActionListQueryVariables = Exact<{
  adminActionId: Scalars['ID']['input'];
}>;


export type BatchRegisterExistingUsersAdminActionListQuery = { __typename?: 'Query', adminAction: { __typename?: 'AdminAction', id: string, performedAt: any, resultingChanges: { __typename?: 'ObjectChangesetConnection', totalCount: number, nodes: Array<{ __typename: 'ObjectChangeset', id: string, changes: Array<{ __typename?: 'ObjectChange', id: string, attribute: string, originalValue?: string | null, newValue?: string | null }>, trackedObject?: { __typename: 'Mentor', id: string, user: { __typename?: 'User', id: string, email?: string | null, firstName: string, lastName: string } } | { __typename: 'MentorContact' } | { __typename: 'Mentorship' } | { __typename: 'MicroSurvey' } | { __typename: 'Program' } | { __typename: 'ProgramAlertDismissal' } | { __typename: 'ProgramCustomMessageTemplate' } | { __typename: 'ProgramGoal' } | { __typename: 'ProgramSequence' } | { __typename: 'ProgramTask' } | { __typename: 'ProgramTopic' } | { __typename: 'SavedMatch' } | { __typename: 'SchoolIdentifier' } | { __typename: 'Student', id: string, user: { __typename?: 'User', id: string, email?: string | null, firstName: string, lastName: string } } | { __typename: 'StudentContact' } | { __typename: 'User' } | null }> } } };

export type ActivateContactsAdminActionListQueryVariables = Exact<{
  adminActionId: Scalars['ID']['input'];
}>;


export type ActivateContactsAdminActionListQuery = { __typename?: 'Query', adminAction: { __typename?: 'AdminAction', id: string, performedAt: any, resultingChanges: { __typename?: 'ObjectChangesetConnection', totalCount: number, nodes: Array<{ __typename: 'ObjectChangeset', id: string, changes: Array<{ __typename?: 'ObjectChange', id: string, attribute: string, originalValue?: string | null, newValue?: string | null }>, trackedObject?: { __typename: 'Mentor' } | { __typename: 'MentorContact', id: string, program: { __typename?: 'Program', usesNewCommunications: boolean }, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } | { __typename: 'Mentorship' } | { __typename: 'MicroSurvey' } | { __typename: 'Program' } | { __typename: 'ProgramAlertDismissal' } | { __typename: 'ProgramCustomMessageTemplate' } | { __typename: 'ProgramGoal' } | { __typename: 'ProgramSequence' } | { __typename: 'ProgramTask' } | { __typename: 'ProgramTopic' } | { __typename: 'SavedMatch' } | { __typename: 'SchoolIdentifier' } | { __typename: 'Student' } | { __typename: 'StudentContact', id: string, program: { __typename?: 'Program', usesNewCommunications: boolean }, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } | { __typename: 'User' } | null }> } } };

export type ContactUploadAdminActionListQueryVariables = Exact<{
  adminActionId: Scalars['ID']['input'];
}>;


export type ContactUploadAdminActionListQuery = { __typename?: 'Query', adminAction: { __typename?: 'AdminAction', id: string, performedAt: any, resultingChanges: { __typename?: 'ObjectChangesetConnection', totalCount: number, nodes: Array<{ __typename: 'ObjectChangeset', id: string, changes: Array<{ __typename?: 'ObjectChange', id: string, attribute: string, originalValue?: string | null, newValue?: string | null }>, trackedObject?: { __typename: 'Mentor' } | { __typename: 'MentorContact', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } | { __typename: 'Mentorship' } | { __typename: 'MicroSurvey' } | { __typename: 'Program' } | { __typename: 'ProgramAlertDismissal' } | { __typename: 'ProgramCustomMessageTemplate' } | { __typename: 'ProgramGoal' } | { __typename: 'ProgramSequence' } | { __typename: 'ProgramTask' } | { __typename: 'ProgramTopic' } | { __typename: 'SavedMatch' } | { __typename: 'SchoolIdentifier' } | { __typename: 'Student' } | { __typename: 'StudentContact', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } | { __typename: 'User' } | null }> } } };

export type ProgramTrackingSummaryQueryVariables = Exact<{
  filter: AdminActionsFilter;
}>;


export type ProgramTrackingSummaryQuery = { __typename?: 'Query', adminActions: { __typename?: 'AdminActionConnection', totalCount: number, actionTypes: Array<AdminActionType>, adminUsers: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string }> } };

export type ProgramTrackingHistoryQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<AdminActionsFilter>;
  sort?: InputMaybe<AdminActionsSort>;
}>;


export type ProgramTrackingHistoryQuery = { __typename?: 'Query', adminActions: { __typename?: 'AdminActionConnection', totalCount: number, actionTypes: Array<AdminActionType>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, adminUsers: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string }>, nodes: Array<{ __typename: 'AdminAction', id: string, type: AdminActionType, performedAt: any, adminUser: { __typename?: 'User', id: string, firstName: string, lastName: string }, resultingChanges: { __typename?: 'ObjectChangesetConnection', affectedObjectTypeCounts: Array<{ __typename?: 'AffectedObjectTypeCount', objectType: AffectedObject, eventType: ObjectChangeEvent, count: number }>, nodes: Array<{ __typename: 'ObjectChangeset', id: string, trackedObject?: { __typename?: 'Mentor' } | { __typename?: 'MentorContact' } | { __typename?: 'Mentorship' } | { __typename?: 'MicroSurvey' } | { __typename?: 'Program' } | { __typename?: 'ProgramAlertDismissal' } | { __typename?: 'ProgramCustomMessageTemplate', id: string, customMessageType: ProgramCustomMessage, messageTemplate: { __typename?: 'EmailTemplate', id: string, name: string } | { __typename?: 'SmsTemplate', id: string, name: string } } | { __typename?: 'ProgramGoal' } | { __typename?: 'ProgramSequence' } | { __typename?: 'ProgramTask' } | { __typename?: 'ProgramTopic', id: string, topic: { __typename?: 'Topic', id: string, name: string } } | { __typename?: 'SavedMatch' } | { __typename?: 'SchoolIdentifier' } | { __typename?: 'Student' } | { __typename?: 'StudentContact' } | { __typename?: 'User' } | null, changes: Array<{ __typename?: 'ObjectChange', id: string, attribute: string, originalValue?: string | null, newValue?: string | null }> }> } }> } };

export type ProgramMilestonesQueryVariables = Exact<{
  programIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ProgramMilestonesQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', nodes: Array<{ __typename?: 'Program', id: string, matchingCap?: number | null, matchingCapReachedDate?: any | null, matchingGoalReachedDate?: any | null, menteeContactUpload: { __typename?: 'ContactConnection', nodes: Array<{ __typename?: 'MentorContact', id: string, uploadedDate: any } | { __typename?: 'StudentContact', id: string, uploadedDate: any }> }, mentorContactUpload: { __typename?: 'ContactConnection', nodes: Array<{ __typename?: 'MentorContact', id: string, uploadedDate: any } | { __typename?: 'StudentContact', id: string, uploadedDate: any }> }, menteeContactActivation: { __typename?: 'ContactConnection', nodes: Array<{ __typename?: 'MentorContact', id: string, activationStatusChangedAt?: any | null } | { __typename?: 'StudentContact', id: string, activationStatusChangedAt?: any | null }> }, mentorContactActivation: { __typename?: 'ContactConnection', nodes: Array<{ __typename?: 'MentorContact', id: string, activationStatusChangedAt?: any | null } | { __typename?: 'StudentContact', id: string, activationStatusChangedAt?: any | null }> }, firstMenteeRegistration: { __typename?: 'ParticipantConnection', nodes: Array<{ __typename?: 'Mentor', id: string, registrationDate: any } | { __typename?: 'Student', id: string, registrationDate: any }> }, firstMentorRegistration: { __typename?: 'ParticipantConnection', nodes: Array<{ __typename?: 'Mentor', id: string, registrationDate: any } | { __typename?: 'Student', id: string, registrationDate: any }> }, firstMatch: { __typename?: 'MentorshipConnection', nodes: Array<{ __typename?: 'Mentorship', id: string, matchDate: any }> }, programGoal?: { __typename?: 'ProgramGoal', id: string, type: ProgramGoalTypes } | null, studentOpeningAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, studentMidAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, studentEndAssessmentSurvey?: { __typename?: 'Survey', id: string } | null }> } };

export type AdminActionsForProgramQueryVariables = Exact<{
  programIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AdminActionsForProgramQuery = { __typename?: 'Query', adminActions: { __typename?: 'AdminActionConnection', nodes: Array<{ __typename?: 'AdminAction', id: string, performedAt: any, resultingChanges: { __typename?: 'ObjectChangesetConnection', nodes: Array<{ __typename?: 'ObjectChangeset', id: string, changes: Array<{ __typename?: 'ObjectChange', id: string, attribute: string, originalValue?: string | null, newValue?: string | null }> }> } }> } };

export type AdminDashboardProgramQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminDashboardProgramQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, currentPhase: ProgramPhase, usesNewCommunications: boolean, allowMatching: boolean, partnerSuccessOperator?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null, school: { __typename?: 'School', id: string } }, students: { __typename?: 'ParticipantConnection', totalCount: number }, mentors: { __typename?: 'ParticipantConnection', totalCount: number }, contacts: { __typename?: 'ContactConnection', totalCount: number } } };

export type ProgramSequenceForNewProgramQueryVariables = Exact<{
  programSequenceId: Scalars['ID']['input'];
}>;


export type ProgramSequenceForNewProgramQuery = { __typename?: 'Query', programSequences: { __typename?: 'ProgramSequenceConnection', nodes: Array<{ __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null, name: string, urlSlug: string, school: { __typename?: 'School', id: string, name: string }, programs: Array<{ __typename?: 'Program', id: string, name: string }> }> } };

export type TemplateProgramsOnSpecificHigherEdSegmentQueryVariables = Exact<{
  filter?: InputMaybe<ProgramsFilter>;
}>;


export type TemplateProgramsOnSpecificHigherEdSegmentQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', nodes: Array<{ __typename?: 'Program', id: string, name: string }> } };

export type DuplicateProgramForSpecificSchoolMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  toProgramSequenceId: Scalars['ID']['input'];
  duplicateLegacyTasks?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DuplicateProgramForSpecificSchoolMutation = { __typename?: 'Mutation', duplicateProgram?: { __typename?: 'DuplicateProgramPayload', successMessages?: Array<string> | null, errors: Array<string>, program?: { __typename?: 'Program', id: string } | null } | null };

export type AddContactsMutationVariables = Exact<{
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
  contactType: ContactEnum;
}>;


export type AddContactsMutation = { __typename?: 'Mutation', addContacts?: { __typename?: 'AddContactsPayload', batchActionId?: string | null, errors?: string | null } | null };

export type AddContactsToExistingUsersMutationVariables = Exact<{
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
  contactType: ContactEnum;
}>;


export type AddContactsToExistingUsersMutation = { __typename?: 'Mutation', addContactsToExistingUsers?: { __typename?: 'AddContactsToExistingUsersPayload', batchActionId?: string | null, errors?: string | null } | null };

export type AddContactsFromExistingProgramMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  fromProgramId: Scalars['ID']['input'];
  existingPool: ExistingPoolEnum;
  contactType: ContactEnum;
}>;


export type AddContactsFromExistingProgramMutation = { __typename?: 'Mutation', addContactsFromExistingProgram?: { __typename?: 'AddContactsFromExistingProgramPayload', batchActionId?: string | null, errors?: string | null } | null };

export type AddParticipantsMutationVariables = Exact<{
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
  participantType: ParticipantEnum;
  fromAnotherProgram: Scalars['Boolean']['input'];
}>;


export type AddParticipantsMutation = { __typename?: 'Mutation', addParticipants?: { __typename?: 'AddParticipantsPayload', batchActionId?: string | null, errors?: string | null } | null };

export type ChangeMentorTrainingStatusMutationVariables = Exact<{
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
  trainingStatus: MentorTrainingStatusEnum;
}>;


export type ChangeMentorTrainingStatusMutation = { __typename?: 'Mutation', changeMentorTrainingStatus?: { __typename?: 'ChangeMentorTrainingStatusPayload', batchActionId?: string | null, errors?: string | null } | null };

export type DenylistEmailsMutationVariables = Exact<{
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
}>;


export type DenylistEmailsMutation = { __typename?: 'Mutation', denylistEmails?: { __typename?: 'DenylistEmailsPayload', batchActionId?: string | null, errors?: string | null } | null };

export type AdminDashboardProgramTogglesQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type AdminDashboardProgramTogglesQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, askForMenteeSidInSignup: boolean, reRecruitedMentorsCanSkipMatchingSurvey: boolean, usesNewCommunications: boolean, allowsMenteesToPushThemselvesThroughToMatch: boolean, menteeLoginMode: ProgramMenteeLoginMode } };

export type UpdateMenteeMentorSettingsMutationVariables = Exact<{
  inputData: UpdateMenteeMentorSettingsInput;
}>;


export type UpdateMenteeMentorSettingsMutation = { __typename?: 'Mutation', updateMenteeMentorSettings?: { __typename?: 'UpdateMenteeMentorSettingsPayload', errors: Array<{ __typename?: 'UpdateMenteeMentorSettingsError', message: string, path: UpdateMenteeMentorSettingsErrorPaths }>, program?: { __typename?: 'Program', id: string, askForMenteeSidInSignup: boolean, reRecruitedMentorsCanSkipMatchingSurvey: boolean, usesNewCommunications: boolean, allowsMenteesToPushThemselvesThroughToMatch: boolean, menteeLoginMode: ProgramMenteeLoginMode } | null } | null };

export type MoveParticipantsMutationVariables = Exact<{
  file: Scalars['File']['input'];
  programId: Scalars['ID']['input'];
  destinationProgramId: Scalars['ID']['input'];
  reasonForMove?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveParticipantsMutation = { __typename?: 'Mutation', moveParticipants?: { __typename?: 'MoveParticipantsPayload', batchActionId?: string | null, errors?: string | null } | null };

export type AdminDashboardProgramProfileAttributesQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  programProfileAttributeCategoriesProgramId: Scalars['MCID']['input'];
}>;


export type AdminDashboardProgramProfileAttributesQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, programProfileAttributes: Array<{ __typename?: 'ProgramProfileAttribute', id: string, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> }, programProfileAttributeCategories: Array<{ __typename?: 'ProgramProfileAttributeCategoryResult', profileAttribute: { __typename?: 'ProfileAttribute', id: string }, profileAttributeCategories: Array<{ __typename?: 'ProfileAttributeCategory', id: string }> }> };

export type ParticipantsProfileDataCsvExportQueryVariables = Exact<{
  filter?: InputMaybe<UsersFilter>;
  csvExportContext: CsvExportContextInput;
  profileDataColumns: Array<ParticipantsProfileDataColumnInput> | ParticipantsProfileDataColumnInput;
}>;


export type ParticipantsProfileDataCsvExportQuery = { __typename?: 'Query', csvExports: { __typename?: 'CsvExports', participantsProfileData: { __typename?: 'CsvExport', id: string, isProcessing: boolean, filename?: string | null, url?: string | null } } };

export type UpdateProgramPrivacySettingsMutationVariables = Exact<{
  inputData: UpdateProgramInfoInput;
}>;


export type UpdateProgramPrivacySettingsMutation = { __typename?: 'Mutation', updateProgramInfo?: { __typename?: 'UpdateProgramInfoPayload', errors: Array<{ __typename?: 'UpdateProgramInfoError', message: string, path: UpdateProgramInfoErrorPaths }>, program?: { __typename?: 'Program', id: string, shareMentorEmail: boolean, shareMentorPhone: boolean, shareMenteeEmail: boolean, shareMenteePhone: boolean } | null } | null };

export type AdminDashboardProgramProfileAttributeSettingsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type AdminDashboardProgramProfileAttributeSettingsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, segment: ProgramSegment, programProfileAttributes: Array<{ __typename?: 'ProgramProfileAttribute', id: string, availableInPartnerDashboardExports: boolean, availableInPartnerDashboardFilters: boolean, availableInPartnerDashboardProgramIntelligenceChart: boolean, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, defaultSettings?: { __typename?: 'ProgramProfileAttributeDefaultSettings', availableInPartnerDashboardExports: boolean, availableInPartnerDashboardFilters: boolean, availableInPartnerDashboardProgramIntelligenceChart: boolean, name?: string | null } | null }> } };

export type UpdateProgramProfileAttributeSettingsMutationVariables = Exact<{
  input: Array<UpdateProgramProfileAttributeInput> | UpdateProgramProfileAttributeInput;
}>;


export type UpdateProgramProfileAttributeSettingsMutation = { __typename?: 'Mutation', updatedProgramProfileAttributes?: { __typename?: 'UpdateProgramProfileAttributesPayload', updatedProgramProfileAttributes: Array<{ __typename?: 'ProgramProfileAttribute', id: string, availableInPartnerDashboardExports: boolean, availableInPartnerDashboardFilters: boolean, availableInPartnerDashboardProgramIntelligenceChart: boolean, profileAttribute: { __typename?: 'ProfileAttribute', id: string, profileAttributeType?: ProfileAttributeType | null, name: string }, defaultSettings?: { __typename?: 'ProgramProfileAttributeDefaultSettings', availableInPartnerDashboardExports: boolean, availableInPartnerDashboardFilters: boolean, availableInPartnerDashboardProgramIntelligenceChart: boolean, name?: string | null } | null }>, errors: Array<{ __typename?: 'ProgramProfileAttributeUnableToBeUpdated', programProfileAttributeId: any, errors: Array<ProgramProfileAttributeUpdateError> }> } | null };

export type ProgramPrivacySettingsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramPrivacySettingsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, shareMentorEmail: boolean, shareMentorPhone: boolean, shareMenteeEmail: boolean, shareMenteePhone: boolean } };

export type ProgramProfileAttributesForUploadQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramProfileAttributesForUploadQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, programProfileAttributes: Array<{ __typename?: 'ProgramProfileAttribute', id: string, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null, profileAttributeValues: Array<{ __typename?: 'ProfileAttributeValue', id: string, value: string }> } }> } };

export type UpdateProgramProfileAttributesMutationVariables = Exact<{
  input: UploadUserProfileDataInput;
}>;


export type UpdateProgramProfileAttributesMutation = { __typename?: 'Mutation', uploadUserProfileData?: { __typename?: 'UploadUserProfileDataPayload', batchActionId?: string | null, errors?: string | null } | null };

export type ActiveProgramSftpStatusQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ActiveProgramSftpStatusQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, active: boolean, endDate: any, sftpExportEnabled: boolean, sftpPrefix?: string | null, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, subdomain: string, awsUsername?: string | null } } } };

export type SetupSftpMutationVariables = Exact<{
  publicKey: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
}>;


export type SetupSftpMutation = { __typename?: 'Mutation', setupSftp?: { __typename?: 'SetupSftpPayload', isSuccess: boolean, program?: { __typename?: 'Program', id: string, sftpExportEnabled: boolean, sftpPrefix?: string | null, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, subdomain: string, awsUsername?: string | null } } } | null } | null };

export type SftpS3ObjectsQueryVariables = Exact<{
  awsUsername: Scalars['String']['input'];
  programNamePrefix: Scalars['String']['input'];
}>;


export type SftpS3ObjectsQuery = { __typename?: 'Query', sftpS3Objects?: Array<{ __typename?: 'S3Object', id: string, key: string, keyWithoutPrefix: string }> | null };

export type SftpCsvExportsQueryVariables = Exact<{
  s3Key: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
}>;


export type SftpCsvExportsQuery = { __typename?: 'Query', sftpCsvExports: { __typename?: 'SftpCsvExports', csvExportInfo: { __typename?: 'CsvExport', id: string, isProcessing: boolean, url?: string | null, filename?: string | null } } };

export type CreateSchoolMutationVariables = Exact<{
  inputData: CreateSchoolInput;
}>;


export type CreateSchoolMutation = { __typename?: 'Mutation', createSchool?: { __typename?: 'CreateSchoolPayload', errors: Array<{ __typename?: 'CreateSchoolError', message: string, path: CreateSchoolErrorPaths }>, school?: { __typename?: 'School', id: string, name: string, shortName: string, subdomain: string } | null } | null };

export type AdminDashboardSchoolProgramsQueryVariables = Exact<{
  filter?: InputMaybe<ProgramsFilter>;
  sort?: InputMaybe<ProgramsSort>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminDashboardSchoolProgramsQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Program', id: string, name: string, currentPhase: ProgramPhase, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string } }, students: { __typename?: 'ParticipantConnection', totalCount: number }, mentors: { __typename?: 'ParticipantConnection', totalCount: number }, contacts: { __typename?: 'ContactConnection', totalCount: number }, additionalFlagContactRecipients: Array<{ __typename?: 'FlagContact', id: string }>, partnerSuccessOperator?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, partnerSuccessManager?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } };

export type DeleteProgramMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProgramMutation = { __typename?: 'Mutation', deleteProgram?: { __typename?: 'DeleteProgramPayload', errors: Array<ProgramNotAbleToBeDeletedError> } | null };

export type DuplicateProgramMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateProgramMutation = { __typename?: 'Mutation', duplicateProgram?: { __typename?: 'DuplicateProgramPayload', successMessages?: Array<string> | null, errors: Array<string>, program?: { __typename?: 'Program', id: string } | null } | null };

export type AdminDashboardSchoolsListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SchoolsFilter>;
  sort?: InputMaybe<SchoolsSort>;
}>;


export type AdminDashboardSchoolsListQuery = { __typename?: 'Query', schools: { __typename?: 'SchoolConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'School', id: string, name: string, shortName: string, subdomain: string, institutionType?: Institution | null, publicOrPrivate?: PublicOrPrivate | null, twoOrFourYear?: HigherEducation | null, institutionRegion?: InstitutionRegion | null, isMinorityServingInstitution?: boolean | null, programSequences: Array<{ __typename?: 'ProgramSequence', id: string }> }> } };

export type DeleteSchoolMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSchoolMutation = { __typename?: 'Mutation', deleteSchool?: { __typename?: 'DeleteSchoolPayload', errors: Array<SchoolNotAbleToBeDeletedError> } | null };

export type AdminDataExportsAvailableSurveysQueryVariables = Exact<{
  type: SurveyType;
}>;


export type AdminDataExportsAvailableSurveysQuery = { __typename?: 'Query', surveys: { __typename?: 'SurveyConnection', nodes: Array<{ __typename?: 'Survey', id: string, name: string }> } };

export type ProgramActionItemsQueryVariables = Exact<{
  programIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  fourDaysAgo: Scalars['ISO8601DateTime']['input'];
  activationStatus?: InputMaybe<ActivationStatus>;
}>;


export type ProgramActionItemsQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', nodes: Array<{ __typename?: 'Program', id: string, startDate: any, endDate: any, currentPhase: ProgramPhase, currentStage: ProgramStage, programLogo?: string | null, matchingCap?: number | null, defaultProfileImage?: string | null, usesNewCommunications: boolean, programGoal?: { __typename?: 'ProgramGoal', id: string } | null, partnerSuccessOperator?: { __typename?: 'User', id: string } | null, partnerSuccessManager?: { __typename?: 'User', id: string } | null, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string } }, studentContacts: { __typename?: 'ContactConnection', totalCount: number }, mentorContacts: { __typename?: 'ContactConnection', totalCount: number }, pendingStudentContactsNewComms: { __typename?: 'ContactConnection', totalCount: number }, pendingMentorContactsNewComms: { __typename?: 'ContactConnection', totalCount: number } }> } };

export type ProgramBenchmarkProgramListQueryVariables = Exact<{
  programIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProgramBenchmarkProgramListQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', nodes: Array<{ __typename?: 'Program', id: string, createdAt: any, segment: ProgramSegment, programSequence: { __typename?: 'ProgramSequence', id: string, programs: Array<{ __typename?: 'Program', id: string, createdAt: any }> } }> } };

export type ProgramBenchmarkDataQueryVariables = Exact<{
  programIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProgramBenchmarkDataQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', nodes: Array<{ __typename?: 'Program', id: string, segment: ProgramSegment, satisfactionReport: { __typename?: 'SatisfactionReport', programSatisfaction: { __typename?: 'SatisfactionAverage', mentorAverage?: number | null, studentAverage?: number | null }, segmentSatisfaction: { __typename?: 'SatisfactionAverage', mentorAverage?: number | null, studentAverage?: number | null }, previousProgramSatisfaction?: { __typename?: 'SatisfactionAverage', mentorAverage?: number | null, studentAverage?: number | null } | null }, mentorContacts: { __typename?: 'ContactConnection', totalCount: number }, studentContacts: { __typename?: 'ContactConnection', totalCount: number }, students: { __typename?: 'ParticipantConnection', totalCount: number, totalCountHavingCompletedMatchingSurvey: number }, allStudents: { __typename?: 'ParticipantConnection', totalCount: number }, mentors: { __typename?: 'ParticipantConnection', totalCount: number, totalCountHavingCompletedMatchingSurvey: number, totalCountHavingSignedUpForTraining: number }, engagementBenchmarkData?: { __typename?: 'EngagementBenchmarkData', mentorshipsInPreviousProgramEngagedInLast30Days?: number | null, mentorshipsInPreviousProgramWith3OrMoreConversations?: number | null, mentorshipsInPreviousProgramWith0Conversations?: number | null, totalCountWithConversationInTheLast30Days?: number | null, totalCountWithThreeOrMoreConversations?: number | null, totalCountWithZeroConversations?: number | null } | null }> } };

export type UserInfoForApmQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserInfoForApmQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, email?: string | null, isPartner: boolean, isAdmin: boolean, participants: Array<{ __typename?: 'Mentor', id: string, registrationDate: any, program: { __typename?: 'Program', id: string } } | { __typename?: 'Student', id: string, registrationDate: any, program: { __typename?: 'Program', id: string } }> } };

export type ContentfulModuleResourceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type ContentfulModuleResourceQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, isPartner: boolean, isAdmin: boolean, participants: Array<{ __typename: 'Mentor', id: string } | { __typename: 'Student', id: string }> }, program: { __typename?: 'Program', id: string, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, subdomain: string } } }, participantGoals: { __typename?: 'GoalConnection', totalCount: number, nodes: Array<{ __typename?: 'Goal', id: string, name: string, identifier: string, archived: boolean }> }, resource?: { __typename?: 'Resource', id: string, name: string, displayName: string, description?: string | null, resourceType: ResourceType, topics: Array<{ __typename?: 'ResourceTopic', id: string, name: string, archived: boolean }>, resourceable: { __typename: 'ContentfulModuleResource', id: string, icon: string, contentfulUrl: string, sections: Array<{ __typename?: 'ContentfulModuleSection', id: string, visibleToMentor: boolean, visibleToMentee: boolean, text?: string | null, name: string, options?: Array<{ __typename?: 'ContentfulModuleSection', id: string, text?: string | null, name: string }> | null, examples?: Array<{ __typename?: 'ContentfulModuleSection', id: string, text?: string | null, name: string }> | null }> } | { __typename: 'SupportServiceResource' } } | null };

export type MakeMatchMutationVariables = Exact<{
  mentorId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
  allowRematch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MakeMatchMutation = { __typename?: 'Mutation', makeMatch?: { __typename?: 'MakeMatchPayload', deletedSavedMatchId?: string | null, showAllowRematchConfirm: boolean, student?: { __typename?: 'Student', id: string, mentorships: Array<{ __typename?: 'Mentorship', id: string }> } | null, mentor?: { __typename?: 'Mentor', capacity?: number | null, id: string } | null, errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type MatchingDashboardProgramDataQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type MatchingDashboardProgramDataQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, shortName: string, notes?: string | null, studentMatchingSurvey: { __typename?: 'Survey', id: string, questions: Array<{ __typename?: 'SurveyQuestion', id: string, qid?: string | null, createdInAdminTool: boolean, questionMdDisplay?: { __typename?: 'SurveyQuestionMdDisplay', id: string, displayName: string, displayOnMatchingDashboard: boolean, sortable: boolean } | null }> }, mentorMatchingSurvey: { __typename?: 'Survey', id: string, questions: Array<{ __typename?: 'SurveyQuestion', id: string, qid?: string | null, createdInAdminTool: boolean, questionMdDisplay?: { __typename?: 'SurveyQuestionMdDisplay', id: string, displayName: string, displayOnMatchingDashboard: boolean, sortable: boolean } | null }> } } };

export type UpdateProgramNotesMutationVariables = Exact<{
  inputData: UpdateProgramInfoInput;
}>;


export type UpdateProgramNotesMutation = { __typename?: 'Mutation', updateProgramInfo?: { __typename?: 'UpdateProgramInfoPayload', errors: Array<{ __typename?: 'UpdateProgramInfoError', message: string, path: UpdateProgramInfoErrorPaths }>, program?: { __typename?: 'Program', id: string, notes?: string | null } | null } | null };

export type MarkParticipantMatchingHoldMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type MarkParticipantMatchingHoldMutation = { __typename?: 'Mutation', createMatchingLabel?: { __typename?: 'CreateMatchingLabelPayload', participant?: { __typename?: 'Mentor', id: string, matchingLabels: Array<{ __typename?: 'MatchingLabel', id: string, kind: MatchingLabelKindTypes }> } | { __typename?: 'Student', id: string, matchingLabels: Array<{ __typename?: 'MatchingLabel', id: string, kind: MatchingLabelKindTypes }> } | null } | null };

export type RemoveParticipantMatchingHoldMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type RemoveParticipantMatchingHoldMutation = { __typename?: 'Mutation', deleteMatchingLabel?: { __typename?: 'DeleteMatchingLabelPayload', participant?: { __typename?: 'Mentor', id: string, matchingLabels: Array<{ __typename?: 'MatchingLabel', id: string, kind: MatchingLabelKindTypes }> } | { __typename?: 'Student', id: string, matchingLabels: Array<{ __typename?: 'MatchingLabel', id: string, kind: MatchingLabelKindTypes }> } | null } | null };

type MatchingProfileDataFieldsWithCustomFallbacks_Mentor_Fragment = { __typename?: 'Mentor', userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null };

type MatchingProfileDataFieldsWithCustomFallbacks_Student_Fragment = { __typename?: 'Student', userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null };

export type MatchingProfileDataFieldsWithCustomFallbacksFragment = MatchingProfileDataFieldsWithCustomFallbacks_Mentor_Fragment | MatchingProfileDataFieldsWithCustomFallbacks_Student_Fragment;

type MentorUserProfileDataFields_Mentor_Fragment = { __typename: 'Mentor', cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }>, userProfileDataMentorCapacity?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null };

type MentorUserProfileDataFields_Student_Fragment = { __typename: 'Student', cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }>, userProfileDataMentorCapacity?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null };

export type MentorUserProfileDataFieldsFragment = MentorUserProfileDataFields_Mentor_Fragment | MentorUserProfileDataFields_Student_Fragment;

type StudentUserProfileDataFields_Mentor_Fragment = { __typename: 'Mentor', cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }>, userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null };

type StudentUserProfileDataFields_Student_Fragment = { __typename: 'Student', cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }>, userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null };

export type StudentUserProfileDataFieldsFragment = StudentUserProfileDataFields_Mentor_Fragment | StudentUserProfileDataFields_Student_Fragment;

export type MatchingDashboardMentorsQueryVariables = Exact<{
  filter?: InputMaybe<ParticipantsFilter>;
  sort?: InputMaybe<ParticipantsSort>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mentorCacheSettings: CachedUserProfileDataSettingsFilter;
  mentorAttributes: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  majorAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  majorCacheSettings: CachedUserProfileDataSettingsFilter;
  transferStatusAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  transferStatusCacheSettings: CachedUserProfileDataSettingsFilter;
  supermentorOptInAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  supermentorOptInCacheSettings: CachedUserProfileDataSettingsFilter;
  mentorCapacityAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  mentorCapacityCacheSettings: CachedUserProfileDataSettingsFilter;
}>;


export type MatchingDashboardMentorsQuery = { __typename?: 'Query', participants: { __typename?: 'ParticipantConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename: 'Mentor', notes?: string | null, completedMatchingSurveyAt?: any | null, lastCompletedRequiredTrainingAt?: any | null, id: string, savedMatches: Array<{ __typename?: 'SavedMatch', id: string }>, mentorships: Array<{ __typename?: 'Mentorship', id: string, megaphoneGroup?: { __typename?: 'MentorshipMegaphoneGroup', id: string, isSupermentorGroup: boolean } | null }>, user: { __typename?: 'User', id: string, profile: { __typename?: 'Profile', id: string, programSpecificAttributes: any } }, matchingLabels: Array<{ __typename?: 'MatchingLabel', id: string, kind: MatchingLabelKindTypes, createdAt: any }>, program: { __typename?: 'Program', id: string, programTasks: Array<{ __typename?: 'ProgramTask', id: string, task: { __typename: 'ScheduleTrainingTask', id: string } | { __typename: 'TakeExternalLinkTask', id: string } | { __typename: 'TakeSurveyTask', id: string } | { __typename: 'UploadPhotoTask', id: string } | { __typename: 'UploadVideoTask', id: string } | { __typename: 'WatchVideoTask', id: string } }> }, cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }>, userProfileDataMentorCapacity?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null } | { __typename: 'Student', id: string, user: { __typename?: 'User', id: string, profile: { __typename?: 'Profile', id: string, programSpecificAttributes: any } }, matchingLabels: Array<{ __typename?: 'MatchingLabel', id: string, kind: MatchingLabelKindTypes, createdAt: any }>, program: { __typename?: 'Program', id: string, programTasks: Array<{ __typename?: 'ProgramTask', id: string, task: { __typename: 'ScheduleTrainingTask', id: string } | { __typename: 'TakeExternalLinkTask', id: string } | { __typename: 'TakeSurveyTask', id: string } | { __typename: 'UploadPhotoTask', id: string } | { __typename: 'UploadVideoTask', id: string } | { __typename: 'WatchVideoTask', id: string } }> }, cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }>, userProfileDataMentorCapacity?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null }> } };

export type MatchingDashboardMenteesQueryVariables = Exact<{
  filter?: InputMaybe<ParticipantsFilter>;
  sort?: InputMaybe<ParticipantsSort>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  menteeCacheSettings: CachedUserProfileDataSettingsFilter;
  menteeAttributes: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  majorAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  majorCacheSettings: CachedUserProfileDataSettingsFilter;
  transferStatusAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  transferStatusCacheSettings: CachedUserProfileDataSettingsFilter;
  supermentorOptInAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  supermentorOptInCacheSettings: CachedUserProfileDataSettingsFilter;
}>;


export type MatchingDashboardMenteesQuery = { __typename?: 'Query', participants: { __typename?: 'ParticipantConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename: 'Mentor', id: string, user: { __typename?: 'User', id: string, profile: { __typename?: 'Profile', id: string, programSpecificAttributes: any } }, matchingLabels: Array<{ __typename?: 'MatchingLabel', id: string, kind: MatchingLabelKindTypes }>, cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }>, userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null } | { __typename: 'Student', completedMatchingSurveyAt?: any | null, notes?: string | null, id: string, savedMatches: Array<{ __typename?: 'SavedMatch', id: string }>, mentorships: Array<{ __typename?: 'Mentorship', id: string }>, user: { __typename?: 'User', id: string, profile: { __typename?: 'Profile', id: string, programSpecificAttributes: any } }, matchingLabels: Array<{ __typename?: 'MatchingLabel', id: string, kind: MatchingLabelKindTypes }>, cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }>, userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null }> } };

export type UpdateParticipantNotesMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateParticipantNotesMutation = { __typename?: 'Mutation', updateParticipant?: { __typename?: 'UpdateParticipantPayload', participant?: { __typename: 'Mentor', id: string, notes?: string | null } | { __typename: 'Student', id: string, notes?: string | null } | null } | null };

export type CreateSavedMatchMutationVariables = Exact<{
  mentorId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
  source: MatchingSource;
}>;


export type CreateSavedMatchMutation = { __typename?: 'Mutation', createSavedMatch?: { __typename?: 'CreateSavedMatchPayload', savedMatch?: { __typename?: 'SavedMatch', id: string, student: { __typename: 'Student', id: string, savedMatches: Array<{ __typename?: 'SavedMatch', id: string }> }, mentor: { __typename: 'Mentor', id: string, capacity?: number | null, savedMatches: Array<{ __typename?: 'SavedMatch', id: string }> } } | null, errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type MatchingDashboardSelectableProgramsQueryVariables = Exact<{
  filter?: InputMaybe<ProgramsFilter>;
  sort?: InputMaybe<ProgramsSort>;
}>;


export type MatchingDashboardSelectableProgramsQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', nodes: Array<{ __typename?: 'Program', id: string, name: string }> } };

export type AutomaticSavedMatchesAggregateDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AutomaticSavedMatchesAggregateDataQuery = { __typename?: 'Query', savedMatches: { __typename?: 'SavedMatchConnection', totalCount: number, autoMatchStrategies?: Array<AutoMatchStrategy> | null, adminUsers?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string }> | null, uniquePrograms?: Array<{ __typename?: 'Program', id: string, name: string }> | null } };

export type SavedMatchesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SavedMatchesFilter>;
  sort?: InputMaybe<SavedMatchesSort>;
  mentorCacheSettings: CachedUserProfileDataSettingsFilter;
  mentorAttributes: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  menteeCacheSettings: CachedUserProfileDataSettingsFilter;
  menteeAttributes: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  majorAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  majorCacheSettings: CachedUserProfileDataSettingsFilter;
  transferStatusAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  transferStatusCacheSettings: CachedUserProfileDataSettingsFilter;
  supermentorOptInAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  supermentorOptInCacheSettings: CachedUserProfileDataSettingsFilter;
  mentorCapacityAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  mentorCapacityCacheSettings: CachedUserProfileDataSettingsFilter;
}>;


export type SavedMatchesQuery = { __typename?: 'Query', savedMatches: { __typename?: 'SavedMatchConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'SavedMatch', id: string, score?: number | null, autoMatchStrategy?: AutoMatchStrategy | null, createdAt: any, adminUser: { __typename?: 'User', id: string, firstName: string, lastName: string }, mentor: { __typename: 'Mentor', id: string, mentorships: Array<{ __typename?: 'Mentorship', id: string, megaphoneGroup?: { __typename?: 'MentorshipMegaphoneGroup', id: string, isSupermentorGroup: boolean } | null }>, cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }>, userProfileDataMentorCapacity?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null }, student: { __typename: 'Student', id: string, program: { __typename?: 'Program', id: string, name: string }, cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }>, userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null } }> } };

export type SavedMatchDetailsQueryVariables = Exact<{
  savedMatchId: Scalars['ID']['input'];
  mentorCacheSettings: CachedUserProfileDataSettingsFilter;
  mentorAttributes: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  menteeCacheSettings: CachedUserProfileDataSettingsFilter;
  menteeAttributes: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  majorAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  majorCacheSettings: CachedUserProfileDataSettingsFilter;
  transferStatusAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  transferStatusCacheSettings: CachedUserProfileDataSettingsFilter;
  supermentorOptInAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  supermentorOptInCacheSettings: CachedUserProfileDataSettingsFilter;
  mentorCapacityAttribute: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  mentorCapacityCacheSettings: CachedUserProfileDataSettingsFilter;
}>;


export type SavedMatchDetailsQuery = { __typename?: 'Query', savedMatch: { __typename?: 'SavedMatch', id: string, additionalProgramSortingCriteria: any, student: { __typename: 'Student', id: string, completedMatchingSurveyAt?: any | null, notes?: string | null, user: { __typename?: 'User', id: string, profile: { __typename?: 'Profile', id: string, programSpecificAttributes: any } }, program: { __typename?: 'Program', id: string }, cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }>, userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null }, mentor: { __typename: 'Mentor', id: string, notes?: string | null, user: { __typename?: 'User', id: string, profile: { __typename?: 'Profile', id: string, programSpecificAttributes: any } }, cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }>, userProfileDataMentorCapacity?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataMajor?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataTransferStatus?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, userProfileDataSupermentorOptIn?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null } } };

export type DeleteSavedMatchesFromIdsMutationVariables = Exact<{
  savedMatchIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteSavedMatchesFromIdsMutation = { __typename?: 'Mutation', deleteSavedMatches: { __typename?: 'DeleteSavedMatches', byIds: { __typename?: 'DeleteSavedMatchesByIdsPayload', deletedCount: number, errors: Array<{ __typename: 'Error', message: string, path: string }> } } };

export type DeleteSavedMatchesFromFilterMutationVariables = Exact<{
  filter: SavedMatchesFilter;
  totalCount: Scalars['Int']['input'];
}>;


export type DeleteSavedMatchesFromFilterMutation = { __typename?: 'Mutation', deleteSavedMatches: { __typename?: 'DeleteSavedMatches', byFilter: { __typename?: 'DeleteSavedMatchesByFilterPayload', deletedCount: number, errors: Array<{ __typename: 'Error', message: string, path: string }> } } };

export type MakeSavedGroupMatchesFromIdsMutationVariables = Exact<{
  savedMatchIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  isSupermentorGroup: Scalars['Boolean']['input'];
  addToExistingGroup?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MakeSavedGroupMatchesFromIdsMutation = { __typename?: 'Mutation', makeSavedGroupMatches: { __typename?: 'MakeSavedGroupMatches', byIds: { __typename?: 'MakeSavedGroupMatchesByIdsPayload', queuedGroupsCount: number, queuedMatchesCount: number, savedMatchIds: Array<string>, errors: Array<{ __typename: 'Error', message: string, path: string }> } } };

export type MakeSavedGroupMatchesFromFilterMutationVariables = Exact<{
  filter: SavedMatchesFilter;
  totalCount: Scalars['Int']['input'];
  isSupermentorGroup: Scalars['Boolean']['input'];
}>;


export type MakeSavedGroupMatchesFromFilterMutation = { __typename?: 'Mutation', makeSavedGroupMatches: { __typename?: 'MakeSavedGroupMatches', byFilter: { __typename?: 'MakeSavedGroupMatchesByFilterPayload', queuedGroupsCount: number, queuedMatchesCount: number, savedMatchIds: Array<string>, errors: Array<{ __typename: 'Error', message: string, path: string }> } } };

export type MakeSavedMatchesFromIdsMutationVariables = Exact<{
  savedMatchIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MakeSavedMatchesFromIdsMutation = { __typename?: 'Mutation', makeSavedMatches: { __typename?: 'MakeSavedMatches', byIds: { __typename?: 'MakeSavedMatchesByIdsPayload', queuedMatchesCount: number, savedMatchIds: Array<string>, errors: Array<{ __typename: 'Error', message: string, path: string }> } } };

export type MakeSavedMatchesFromFilterMutationVariables = Exact<{
  filter: SavedMatchesFilter;
  totalCount: Scalars['Int']['input'];
}>;


export type MakeSavedMatchesFromFilterMutation = { __typename?: 'Mutation', makeSavedMatches: { __typename?: 'MakeSavedMatches', byFilter: { __typename?: 'MakeSavedMatchesByFilterPayload', queuedMatchesCount: number, savedMatchIds: Array<string>, errors: Array<{ __typename: 'Error', message: string, path: string }> } } };

export type ManualSavedMatchesAggregateDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ManualSavedMatchesAggregateDataQuery = { __typename?: 'Query', savedMatches: { __typename?: 'SavedMatchConnection', totalCount: number, mentorSupermentorOptInTypes?: Array<SupermentorOptInAnswer> | null, adminUsers?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string }> | null, uniquePrograms?: Array<{ __typename?: 'Program', id: string, name: string }> | null } };

export type SavedMatchesCountQueryVariables = Exact<{
  filter?: InputMaybe<SavedMatchesFilter>;
}>;


export type SavedMatchesCountQuery = { __typename?: 'Query', savedMatches: { __typename?: 'SavedMatchConnection', totalCount: number } };

export type BasicMentorInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BasicMentorInfoQuery = { __typename?: 'Query', mentor: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string }, program: { __typename?: 'Program', id: string, name: string, segment: ProgramSegment, programSequence: { __typename?: 'ProgramSequence', id: string }, mentorPostSessionSurvey: { __typename?: 'Survey', id: string, name: string, questions: Array<{ __typename?: 'SurveyQuestion', id: string, index: number, customizations?: any | null, createdInAdminTool: boolean, template: { __typename?: 'SurveyQuestionTemplate', id: string, templateId: SurveyQuestionTemplateId } }> } }, mentorships: Array<{ __typename?: 'Mentorship', id: string, student: { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }, mentorConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, chatGroup?: { __typename?: 'MentorshipChatGroup', id: string } | null }> } };

export type ProgramShortNameAndTitleQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramShortNameAndTitleQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, shortName: string, title: string } };

export type UserInfoForCommunityPageQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserInfoForCommunityPageQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, participants: Array<{ __typename?: 'Mentor', id: string, registrationDate: any, program: { __typename?: 'Program', id: string, name: string, shortName: string, segment: ProgramSegment } } | { __typename?: 'Student', id: string, registrationDate: any, program: { __typename?: 'Program', id: string, name: string, shortName: string, segment: ProgramSegment } }> } };

export type LogWatchedCommunityVideoMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
  ziggeoToken: Scalars['String']['input'];
  taskName: Scalars['String']['input'];
}>;


export type LogWatchedCommunityVideoMutation = { __typename?: 'Mutation', logWatchedCommunityVideo?: { __typename?: 'LogWatchedCommunityVideoPayload', participant: { __typename?: 'Mentor', id: string } | { __typename?: 'Student', id: string } } | null };

export type CommunityVideosQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UploadedVideoFilter>;
  sort?: InputMaybe<UploadedVideoSort>;
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
}>;


export type CommunityVideosQuery = { __typename?: 'Query', uploadedVideos: { __typename?: 'UploadedVideoConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'UploadedVideo', id: string, url?: string | null, ziggeoToken: string, shareWithStudents?: boolean | null, sharePublicly?: boolean | null, participant: { __typename: 'Mentor', id: string, user: { __typename?: 'User', id: string }, program: { __typename?: 'Program', id: string, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, shortName: string } } }, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> } | { __typename: 'Student', id: string, user: { __typename?: 'User', id: string }, program: { __typename?: 'Program', id: string, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, shortName: string } } }, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> } }> } };

export type MentorChatGroupsSelectQueryVariables = Exact<{
  mentorId: Scalars['ID']['input'];
}>;


export type MentorChatGroupsSelectQuery = { __typename?: 'Query', mentor: { __typename?: 'Mentor', id: string, program: { __typename?: 'Program', id: string, shortName: string, title: string }, mentorships: Array<{ __typename?: 'Mentorship', id: string, chatGroup?: { __typename?: 'MentorshipChatGroup', id: string } | null, student: { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } }> } };

export type FlagsForMentorshipInfoQueryVariables = Exact<{
  mentorshipId: Scalars['ID']['input'];
}>;


export type FlagsForMentorshipInfoQuery = { __typename?: 'Query', mentorship: { __typename?: 'Mentorship', id: string, student: { __typename?: 'Student', id: string, avatar: string, user: { __typename?: 'User', id: string, firstName: string }, program: { __typename?: 'Program', id: string, name: string, segment: ProgramSegment } }, mentor: { __typename?: 'Mentor', id: string } } };

export type LogConversationForMentorshipInfoQueryVariables = Exact<{
  mentorshipId: Scalars['ID']['input'];
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
}>;


export type LogConversationForMentorshipInfoQuery = { __typename?: 'Query', mentorship: { __typename?: 'Mentorship', id: string, student: { __typename?: 'Student', id: string, avatar: string, user: { __typename?: 'User', id: string }, program: { __typename?: 'Program', id: string, name: string, segment: ProgramSegment, programSequence: { __typename?: 'ProgramSequence', id: string }, studentPostSessionSurvey: { __typename?: 'Survey', id: string }, mentorPostSessionSurvey: { __typename?: 'Survey', id: string } }, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> }, mentor: { __typename?: 'Mentor', id: string, avatar: string, user: { __typename?: 'User', id: string }, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> }, mentorConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, studentConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, chatGroup?: { __typename?: 'MentorshipChatGroup', id: string } | null } };

export type ParticipantDashboardFlagsCountQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  filter?: InputMaybe<FlagsFilter>;
  sort?: InputMaybe<FlagsSort>;
}>;


export type ParticipantDashboardFlagsCountQuery = { __typename?: 'Query', flags: { __typename?: 'FlagConnection', totalCount: number } };

export type ParticipantDashboardFlagsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<FlagsFilter>;
  sort?: InputMaybe<FlagsSort>;
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
}>;


export type ParticipantDashboardFlagsQuery = { __typename?: 'Query', flags: { __typename?: 'FlagConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Flag', id: string, createdAt: any, status: FlagStatus, additionalInfo?: string | null, supportPriority: SupportPriority, flagCategories: Array<{ __typename?: 'FlagCategory', id: string, label: string, name: string, identifier: string }>, mentorship: { __typename?: 'Mentorship', id: string, student: { __typename?: 'Student', id: string, program: { __typename?: 'Program', id: string, name: string }, user: { __typename?: 'User', id: string }, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> } } }> }, program: { __typename?: 'Program', id: string, createdAt: any, showMentorsFlags: boolean, name: string, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, name: string } }, programCustomLabel?: { __typename?: 'ProgramCustomLabel', id: string, pluralMentee?: string | null, singularSchool?: string | null } | null } };

export type WhatIsThisInfoQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type WhatIsThisInfoQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, name: string } } } };

export type ProgramLogoForHeaderQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  avatarHeight: Scalars['Int']['input'];
  avatarWidth: Scalars['Int']['input'];
}>;


export type ProgramLogoForHeaderQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, isPartner: boolean, isAdmin: boolean, email?: string | null, participants: Array<{ __typename?: 'Mentor', id: string, registrationDate: any, webappBaseUrl?: string | null, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, program: { __typename?: 'Program', id: string, name: string, programLogo?: string | null, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null } } } | { __typename?: 'Student', id: string, registrationDate: any, webappBaseUrl?: string | null, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, program: { __typename?: 'Program', id: string, name: string, programLogo?: string | null, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null } } }> } };

export type ParticipantDashboardHomeCallToActionFragmentFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, lastSignInAt?: any | null, isMentorInChatGroup: boolean, participants: Array<{ __typename: 'Mentor', id: string, allowedToSkipMatchingSurvey: boolean, requiredTrainingStatus?: string | null, mentorTrainingCourseLink?: string | null, capacity?: number | null, registrationDate: any, registered: boolean, completedMatchingSurveyAt?: any | null, pushedThroughToMatch: boolean, prioritizedAndPendingForRematching: boolean, matchingLabels: Array<{ __typename?: 'MatchingLabel', id: string, kind: MatchingLabelKindTypes }>, program: { __typename?: 'Program', id: string, active: boolean, shortName: string, title: string, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, shortName: string } }, studentMatchingSurvey: { __typename?: 'Survey', id: string }, mentorMatchingSurvey: { __typename?: 'Survey', id: string } }, mentorships: Array<{ __typename?: 'Mentorship', id: string, isMatched: boolean, matchDate: any, unmatchDate?: any | null }> } | { __typename: 'Student', id: string, registrationDate: any, registered: boolean, completedMatchingSurveyAt?: any | null, pushedThroughToMatch: boolean, prioritizedAndPendingForRematching: boolean, matchingLabels: Array<{ __typename?: 'MatchingLabel', id: string, kind: MatchingLabelKindTypes }>, program: { __typename?: 'Program', id: string, active: boolean, shortName: string, title: string, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, shortName: string } }, studentMatchingSurvey: { __typename?: 'Survey', id: string }, mentorMatchingSurvey: { __typename?: 'Survey', id: string } }, mentorships: Array<{ __typename?: 'Mentorship', id: string, isMatched: boolean, matchDate: any, unmatchDate?: any | null }> }> };

type ParticipantProfileDataFragment_Mentor_Fragment = { __typename?: 'Mentor', userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> };

type ParticipantProfileDataFragment_Student_Fragment = { __typename?: 'Student', userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> };

export type ParticipantProfileDataFragmentFragment = ParticipantProfileDataFragment_Mentor_Fragment | ParticipantProfileDataFragment_Student_Fragment;

export type ParticipantDashboardIndexQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  avatarHeight: Scalars['Int']['input'];
  avatarWidth: Scalars['Int']['input'];
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
}>;


export type ParticipantDashboardIndexQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, lastSignInAt?: any | null, isMentorInChatGroup: boolean, participants: Array<{ __typename: 'Mentor', requiredTrainingStatus?: string | null, id: string, allowedToSkipMatchingSurvey: boolean, mentorTrainingCourseLink?: string | null, capacity?: number | null, prioritizedAndPendingForRematching: boolean, registrationDate: any, registered: boolean, completedMatchingSurveyAt?: any | null, pushedThroughToMatch: boolean, program: { __typename?: 'Program', id: string, active: boolean, endDate: any, shortName: string, title: string, studentMatchingSurvey: { __typename?: 'Survey', id: string, questions: Array<{ __typename?: 'SurveyQuestion', id: string, qid?: string | null, optional?: boolean | null }> }, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, shortName: string } }, mentorMatchingSurvey: { __typename?: 'Survey', id: string } }, mentorships: Array<{ __typename?: 'Mentorship', id: string, isMatched: boolean, studentIsDisengaged: boolean, mentorIsDisengaged: boolean, studentReachedOutAt?: any | null, mentorReachedOutAt?: any | null, matchDate: any, unmatchDate?: any | null, mentor: { __typename: 'Mentor', id: string, user: { __typename?: 'User', id: string }, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> }, student: { __typename: 'Student', id: string, user: { __typename?: 'User', id: string }, goals: Array<{ __typename?: 'StudentGoal', id: string, goal?: { __typename?: 'Goal', id: string, name: string, archived: boolean, identifier: string } | null }>, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, program: { __typename?: 'Program', id: string, name: string, endDate: any, active: boolean, segment: ProgramSegment, shareMenteePhone: boolean, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null } }, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> }, chatGroup?: { __typename?: 'MentorshipChatGroup', id: string } | null, studentConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, mentorConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }> }>, matchingLabels: Array<{ __typename?: 'MatchingLabel', id: string, kind: MatchingLabelKindTypes }> } | { __typename: 'Student', id: string, prioritizedAndPendingForRematching: boolean, registrationDate: any, registered: boolean, completedMatchingSurveyAt?: any | null, pushedThroughToMatch: boolean, goals: Array<{ __typename?: 'StudentGoal', id: string, goal?: { __typename?: 'Goal', id: string, name: string, archived: boolean, identifier: string } | null }>, program: { __typename?: 'Program', id: string, active: boolean, endDate: any, shortName: string, title: string, studentMatchingSurvey: { __typename?: 'Survey', id: string, questions: Array<{ __typename?: 'SurveyQuestion', id: string, qid?: string | null, optional?: boolean | null }> }, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, shortName: string } }, mentorMatchingSurvey: { __typename?: 'Survey', id: string } }, mentorships: Array<{ __typename?: 'Mentorship', id: string, isMatched: boolean, studentIsDisengaged: boolean, mentorIsDisengaged: boolean, studentReachedOutAt?: any | null, mentorReachedOutAt?: any | null, matchDate: any, unmatchDate?: any | null, mentor: { __typename: 'Mentor', id: string, user: { __typename?: 'User', id: string }, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> }, student: { __typename: 'Student', id: string, user: { __typename?: 'User', id: string }, goals: Array<{ __typename?: 'StudentGoal', id: string, goal?: { __typename?: 'Goal', id: string, name: string, archived: boolean, identifier: string } | null }>, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, program: { __typename?: 'Program', id: string, name: string, endDate: any, active: boolean, segment: ProgramSegment, shareMenteePhone: boolean, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null } }, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> }, chatGroup?: { __typename?: 'MentorshipChatGroup', id: string } | null, studentConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, mentorConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }> }>, matchingLabels: Array<{ __typename?: 'MatchingLabel', id: string, kind: MatchingLabelKindTypes }> }> } };

export type ProgramTaskAssignmentsForUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  participantIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  programId: Scalars['ID']['input'];
}>;


export type ProgramTaskAssignmentsForUserQuery = { __typename?: 'Query', taskAssignments: Array<{ __typename: 'AssessmentSurveyTaskAssignment', id: string, surveyId: string, programStage: AssessmentSurveyProgramStage, participantId: string, status: TaskAssignmentStatus, position: number, displayName: string } | { __typename: 'ClickLinkTaskAssignment', id: string, url: string, participantId: string, status: TaskAssignmentStatus, position: number, displayName: string } | { __typename: 'CourseTaskAssignment', courseId: string, participantId: string, behavior: Behavior, id: string, status: TaskAssignmentStatus, position: number, displayName: string }>, user: { __typename?: 'User', id: string, participants: Array<{ __typename: 'Mentor', trainingSignupLink?: string | null, id: string, avatar: string, completedMatchingSurveyAt?: any | null, registrationDate: any, mentorships: Array<{ __typename?: 'Mentorship', id: string, isMatched: boolean }>, activityLogs: Array<{ __typename: 'TookTypeformSurveyLog', id: string, loggedAtDate: any, externalLink: { __typename?: 'ExternalLink', id: string } } | { __typename: 'TrainingEventLog', kind: TrainingEvent, id: string, loggedAtDate: any } | { __typename: 'WatchedCommunityVideoLog', id: string, loggedAtDate: any } | { __typename: 'WatchedVideoLog', wistiaVideoId: string, id: string, loggedAtDate: any }>, uploadedVideos: Array<{ __typename?: 'UploadedVideo', id: string }>, writtenMessages: Array<{ __typename?: 'WrittenMessage', id: string }>, surveyResponses: Array<{ __typename?: 'SurveyResponse', id: string, survey: { __typename?: 'Survey', id: string } }>, program: { __typename?: 'Program', id: string, defaultProfileImage?: string | null } } | { __typename: 'Student', id: string, avatar: string, completedMatchingSurveyAt?: any | null, registrationDate: any, mentorships: Array<{ __typename?: 'Mentorship', id: string, isMatched: boolean }>, activityLogs: Array<{ __typename: 'TookTypeformSurveyLog', id: string, loggedAtDate: any, externalLink: { __typename?: 'ExternalLink', id: string } } | { __typename: 'TrainingEventLog', kind: TrainingEvent, id: string, loggedAtDate: any } | { __typename: 'WatchedCommunityVideoLog', id: string, loggedAtDate: any } | { __typename: 'WatchedVideoLog', wistiaVideoId: string, id: string, loggedAtDate: any }>, uploadedVideos: Array<{ __typename?: 'UploadedVideo', id: string }>, writtenMessages: Array<{ __typename?: 'WrittenMessage', id: string }>, surveyResponses: Array<{ __typename?: 'SurveyResponse', id: string, survey: { __typename?: 'Survey', id: string } }>, program: { __typename?: 'Program', id: string, defaultProfileImage?: string | null } }> }, program: { __typename?: 'Program', id: string, name: string, active: boolean, reRecruitedMentorsCanSkipMatchingSurvey: boolean, currentStage: ProgramStage, defaultProfileImage?: string | null, mentorTrainingTask?: { __typename: 'ProgramTask', id: string, required: boolean, programSpecific: boolean, toBeCompletedAs: TaskParticipantRole, position: number, task: { __typename: 'ScheduleTrainingTask', calendlyUrl: string, id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } | { __typename: 'TakeExternalLinkTask', id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null, externalLink: { __typename?: 'ExternalLink', id: string, href: string, kind: ExternalLinkKind } } | { __typename: 'TakeSurveyTask', id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null, survey: { __typename?: 'Survey', id: string, surveyType?: SurveyType | null } } | { __typename: 'UploadPhotoTask', id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } | { __typename: 'UploadVideoTask', id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } | { __typename: 'WatchVideoTask', wistiaVideoId: string, id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } } | null, programTasks: Array<{ __typename: 'ProgramTask', id: string, required: boolean, programSpecific: boolean, toBeCompletedAs: TaskParticipantRole, position: number, task: { __typename: 'ScheduleTrainingTask', calendlyUrl: string, id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } | { __typename: 'TakeExternalLinkTask', id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null, externalLink: { __typename?: 'ExternalLink', id: string, href: string, kind: ExternalLinkKind } } | { __typename: 'TakeSurveyTask', id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null, survey: { __typename?: 'Survey', id: string, surveyType?: SurveyType | null } } | { __typename: 'UploadPhotoTask', id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } | { __typename: 'UploadVideoTask', id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } | { __typename: 'WatchVideoTask', wistiaVideoId: string, id: string, prompt: string, customCallToAction?: string | null, customAfterCallToAction?: string | null } }> } };

export type CompleteTaskAssignmentMutationVariables = Exact<{
  taskAssignmentId: Scalars['ID']['input'];
}>;


export type CompleteTaskAssignmentMutation = { __typename?: 'Mutation', completeTaskAssignment?: { __typename?: 'CompleteTaskAssignmentPayload', taskAssignment?: { __typename: 'AssessmentSurveyTaskAssignment', id: string, status: TaskAssignmentStatus, position: number, displayName: string } | { __typename: 'ClickLinkTaskAssignment', id: string, url: string, participantId: string, status: TaskAssignmentStatus, position: number, displayName: string } | { __typename: 'CourseTaskAssignment', id: string, status: TaskAssignmentStatus, position: number, displayName: string } | null } | null };

export type LogTookTypeformSurveyMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
  externalLinkId: Scalars['ID']['input'];
}>;


export type LogTookTypeformSurveyMutation = { __typename?: 'Mutation', logTookTypeformSurvey?: { __typename?: 'LogTookTypeformSurveyPayload', participant: { __typename?: 'Mentor', id: string, activityLogs: Array<{ __typename?: 'TookTypeformSurveyLog', id: string, loggedAtDate: any, externalLink: { __typename?: 'ExternalLink', id: string } } | { __typename?: 'TrainingEventLog', kind: TrainingEvent, id: string, loggedAtDate: any } | { __typename?: 'WatchedCommunityVideoLog', id: string, loggedAtDate: any } | { __typename?: 'WatchedVideoLog', wistiaVideoId: string, id: string, loggedAtDate: any }> } | { __typename?: 'Student', id: string, activityLogs: Array<{ __typename?: 'TookTypeformSurveyLog', id: string, loggedAtDate: any, externalLink: { __typename?: 'ExternalLink', id: string } } | { __typename?: 'TrainingEventLog', kind: TrainingEvent, id: string, loggedAtDate: any } | { __typename?: 'WatchedCommunityVideoLog', id: string, loggedAtDate: any } | { __typename?: 'WatchedVideoLog', wistiaVideoId: string, id: string, loggedAtDate: any }> } } | null };

export type LogWatchedWistiaVideoMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
  wistiaVideoId: Scalars['String']['input'];
}>;


export type LogWatchedWistiaVideoMutation = { __typename?: 'Mutation', logWatchedWistiaVideo?: { __typename?: 'LogWatchedWistiaVideoPayload', participant: { __typename?: 'Mentor', id: string, activityLogs: Array<{ __typename?: 'TookTypeformSurveyLog', id: string, loggedAtDate: any, externalLink: { __typename?: 'ExternalLink', id: string } } | { __typename?: 'TrainingEventLog', kind: TrainingEvent, id: string, loggedAtDate: any } | { __typename?: 'WatchedCommunityVideoLog', id: string, loggedAtDate: any } | { __typename?: 'WatchedVideoLog', wistiaVideoId: string, id: string, loggedAtDate: any }> } | { __typename?: 'Student', id: string, activityLogs: Array<{ __typename?: 'TookTypeformSurveyLog', id: string, loggedAtDate: any, externalLink: { __typename?: 'ExternalLink', id: string } } | { __typename?: 'TrainingEventLog', kind: TrainingEvent, id: string, loggedAtDate: any } | { __typename?: 'WatchedCommunityVideoLog', id: string, loggedAtDate: any } | { __typename?: 'WatchedVideoLog', wistiaVideoId: string, id: string, loggedAtDate: any }> } } | null };

export type UserInfoForParticipantDashboardQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserInfoForParticipantDashboardQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, isPartner: boolean, participants: Array<{ __typename: 'Mentor', id: string, createdAt?: any | null, registrationDate: any, registered: boolean, program: { __typename?: 'Program', id: string, name: string, showMentorsFlags: boolean, programLogo?: string | null, startDate: any, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null, school: { __typename?: 'School', id: string } } } } | { __typename: 'Student', id: string, createdAt?: any | null, registrationDate: any, registered: boolean, program: { __typename?: 'Program', id: string, name: string, showMentorsFlags: boolean, programLogo?: string | null, startDate: any, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null, school: { __typename?: 'School', id: string } } } }> } };

export type UnmatchParticipantWithDisengagedCounterpartMutationVariables = Exact<{
  mentorshipId: Scalars['ID']['input'];
  initiatedBy: UnmatchInitiatedBy;
  wantsRematch: Scalars['Boolean']['input'];
  unmatchReason: UnmatchReason;
  requesterNotes?: InputMaybe<Scalars['String']['input']>;
  sendUnmatchingEmails?: InputMaybe<Scalars['Boolean']['input']>;
  reasonToShareWithMentee?: InputMaybe<Scalars['String']['input']>;
  reasonToShareWithMentor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnmatchParticipantWithDisengagedCounterpartMutation = { __typename?: 'Mutation', unmatchParticipant?: { __typename?: 'UnmatchParticipantPayload', mentorship?: { __typename?: 'Mentorship', id: string, isMatched: boolean } | null, participant?: { __typename?: 'Mentor', id: string, prioritizedAndPendingForRematching: boolean, user: { __typename?: 'User', id: string, participants: Array<{ __typename?: 'Mentor', capacity?: number | null, id: string, mentorships: Array<{ __typename?: 'Mentorship', id: string, isMatched: boolean, matchDate: any, unmatchDate?: any | null }> } | { __typename?: 'Student', id: string, mentorships: Array<{ __typename?: 'Mentorship', id: string, isMatched: boolean, matchDate: any, unmatchDate?: any | null }> }> } } | { __typename?: 'Student', id: string, prioritizedAndPendingForRematching: boolean, user: { __typename?: 'User', id: string, participants: Array<{ __typename?: 'Mentor', capacity?: number | null, id: string, mentorships: Array<{ __typename?: 'Mentorship', id: string, isMatched: boolean, matchDate: any, unmatchDate?: any | null }> } | { __typename?: 'Student', id: string, mentorships: Array<{ __typename?: 'Mentorship', id: string, isMatched: boolean, matchDate: any, unmatchDate?: any | null }> }> } } | null, errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type CannotGetInTouchFlowInfoQueryVariables = Exact<{
  mentorshipId: Scalars['ID']['input'];
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
  avatarHeight: Scalars['Int']['input'];
  avatarWidth: Scalars['Int']['input'];
}>;


export type CannotGetInTouchFlowInfoQuery = { __typename?: 'Query', mentorship: { __typename?: 'Mentorship', id: string, isMatched: boolean, studentIsDisengaged: boolean, mentorIsDisengaged: boolean, menteeSmsRelayPhoneNumber?: string | null, mentorSmsRelayPhoneNumber?: string | null, student: { __typename: 'Student', id: string, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, user: { __typename?: 'User', id: string }, program: { __typename?: 'Program', id: string, name: string, shortName: string, title: string, active: boolean, studentPointPersonFirstName?: string | null, studentPointPersonLastName?: string | null, studentPointPersonTitle?: string | null, studentPointPersonEmail?: string | null, mentorPointPersonFirstName?: string | null, mentorPointPersonLastName?: string | null, mentorPointPersonTitle?: string | null, mentorPointPersonEmail?: string | null, shareMenteeEmail: boolean, shareMentorEmail: boolean, shareMenteePhone: boolean, shareMentorPhone: boolean, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null, school: { __typename?: 'School', id: string, shortName: string } } }, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> }, mentor: { __typename: 'Mentor', id: string, capacity?: number | null, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, user: { __typename?: 'User', id: string }, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> } } };

export type ParticipantDashboardDeregistrationInfoQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
  mentorshipStatus: MatchedStatus;
}>;


export type ParticipantDashboardDeregistrationInfoQuery = { __typename?: 'Query', participant: { __typename?: 'Mentor', id: string, mentorships: Array<{ __typename?: 'Mentorship', id: string }> } | { __typename?: 'Student', id: string, mentorships: Array<{ __typename?: 'Mentorship', id: string }> }, deregistrationReasons: { __typename?: 'DeregistrationReasonConnection', nodes: Array<{ __typename?: 'DeregistrationReason', id: string, identifier: string, grouping: GroupingEnum, participantFacingName?: string | null }> } };

export type IndividualMentorshipConversationQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  postSessionSurveyId: Scalars['ID']['input'];
  mentorshipContext: SurveyResponseContextFilter;
}>;


export type IndividualMentorshipConversationQuery = { __typename?: 'Query', participant: { __typename?: 'Mentor', id: string, surveyResponses: Array<{ __typename?: 'SurveyResponse', id: string, submittedAt: any, survey: { __typename?: 'Survey', id: string, surveyType?: SurveyType | null }, surveyResponseAnswerStrings?: Array<{ __typename?: 'SurveyResponseAnswerStrings', id: string, qid: string, questionPrompt: string, subprompt?: string | null, answerString: string }> | null }> } | { __typename?: 'Student', id: string, surveyResponses: Array<{ __typename?: 'SurveyResponse', id: string, submittedAt: any, survey: { __typename?: 'Survey', id: string, surveyType?: SurveyType | null }, surveyResponseAnswerStrings?: Array<{ __typename?: 'SurveyResponseAnswerStrings', id: string, qid: string, questionPrompt: string, subprompt?: string | null, answerString: string }> | null }> } };

export type MentorshipFlagsQueryVariables = Exact<{
  mentorshipId: Scalars['ID']['input'];
  flagsFilter?: InputMaybe<FlagsFilter>;
  flagsSort?: InputMaybe<FlagsSort>;
}>;


export type MentorshipFlagsQuery = { __typename?: 'Query', mentorship: { __typename?: 'Mentorship', id: string, student: { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, firstName: string }, program: { __typename?: 'Program', id: string, programCustomLabel?: { __typename?: 'ProgramCustomLabel', id: string, singularMentee?: string | null } | null, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, name: string } } } }, mentor: { __typename?: 'Mentor', id: string }, flags: { __typename?: 'FlagConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Flag', id: string, createdAt: any, status: FlagStatus, additionalInfo?: string | null, supportPriority: SupportPriority, flagCategories: Array<{ __typename?: 'FlagCategory', id: string, label: string, name: string, identifier: string }> }> } } };

export type StudentGoalResourcesQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  studentGoalIdentifier: Scalars['String']['input'];
}>;


export type StudentGoalResourcesQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, resources: { __typename?: 'ResourceConnection', nodes: Array<{ __typename?: 'Resource', id: string, displayName: string, description?: string | null, topics: Array<{ __typename?: 'ResourceTopic', id: string, name: string, archived: boolean }>, resourceable: { __typename?: 'ContentfulModuleResource', id: string, icon: string } | { __typename?: 'SupportServiceResource' } }> } } };

export type IndividualMentorshipQueryVariables = Exact<{
  mentorshipId: Scalars['ID']['input'];
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
  avatarHeight: Scalars['Int']['input'];
  avatarWidth: Scalars['Int']['input'];
}>;


export type IndividualMentorshipQuery = { __typename?: 'Query', mentorship: { __typename?: 'Mentorship', id: string, studentIsDisengaged: boolean, mentorIsDisengaged: boolean, mentorSmsRelayPhoneNumber?: string | null, menteeSmsRelayPhoneNumber?: string | null, mentorConversationLogs: Array<{ __typename?: 'ConversationLog', id: string, topics: Array<ConversationTopic>, modesOfCommunication: Array<ModeOfCommunication> }>, studentConversationLogs: Array<{ __typename?: 'ConversationLog', id: string, topics: Array<ConversationTopic>, modesOfCommunication: Array<ModeOfCommunication> }>, chatGroup?: { __typename?: 'MentorshipChatGroup', id: string } | null, student: { __typename: 'Student', id: string, programGoal?: string | null, questionForMentor?: string | null, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, program: { __typename?: 'Program', id: string, name: string, endDate: any, shortName: string, active: boolean, title: string, shareMentorEmail: boolean, shareMentorPhone: boolean, shareMenteeEmail: boolean, shareMenteePhone: boolean, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null }, mentorPostSessionSurvey: { __typename?: 'Survey', id: string }, studentPostSessionSurvey: { __typename?: 'Survey', id: string } }, goals: Array<{ __typename?: 'StudentGoal', id: string, goal?: { __typename?: 'Goal', id: string, name: string, archived: boolean, identifier: string } | null }>, user: { __typename?: 'User', id: string, phone?: string | null, email?: string | null }, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> }, mentor: { __typename: 'Mentor', id: string, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, user: { __typename?: 'User', id: string, phone?: string | null, email?: string | null }, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> } } };

export type UserParticipantDashboardNotificationQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  requestOrigin: Scalars['String']['input'];
}>;


export type UserParticipantDashboardNotificationQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, microSurvey?: { __typename?: 'MicroSurvey', id: string, survey: { __typename?: 'Survey', id: string }, targetingCriteria?: { __typename?: 'MicroSurveyTargetingCriteria', id: string, participants?: { __typename?: 'ParticipantsFilterCriteria', id: string, programIds?: Array<string> | null } | null } | null } | null, latestDashboardNotificationData?: { __typename?: 'NotificationData', id: string, displayMedium?: string | null, imageUrl?: string | null, markdownBody?: string | null, buttonOneText?: string | null, notificationViewableType: string, notificationViewableId: string } | null } };

export type CreateNotificationViewMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  notificationViewableType: Scalars['String']['input'];
  notificationViewableId: Scalars['ID']['input'];
  displayMedium: Scalars['String']['input'];
}>;


export type CreateNotificationViewMutation = { __typename?: 'Mutation', createNotificationView?: { __typename?: 'CreateNotificationViewPayload', user: { __typename?: 'User', id: string } } | null };

export type IndividualResourceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type IndividualResourceQuery = { __typename?: 'Query', resource?: { __typename?: 'Resource', id: string, name: string, displayName: string, description?: string | null, resourceType: ResourceType } | null, program: { __typename?: 'Program', id: string, resources: { __typename?: 'ResourceConnection', totalCount: number } } };

export type ParticipantDashboardGoalsFilterOptionsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ParticipantDashboardGoalsFilterOptionsQuery = { __typename?: 'Query', participantGoals: { __typename?: 'GoalConnection', nodes: Array<{ __typename?: 'Goal', id: string, name: string, identifier: string }> } };

export type ParticipantDashboardTopicsFilterOptionsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ParticipantDashboardTopicsFilterOptionsQuery = { __typename?: 'Query', resourceTopics: { __typename?: 'ResourceTopicConnection', nodes?: Array<{ __typename?: 'ResourceTopic', id: string, name: string } | null> | null } };

export type ParticipantDashboardResourcesQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProgramResourcesFilter>;
}>;


export type ParticipantDashboardResourcesQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, resources: { __typename?: 'ResourceConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null }, nodes: Array<{ __typename?: 'Resource', description?: string | null, displayName: string, id: string, name: string, topics: Array<{ __typename?: 'ResourceTopic', id: string, name: string, archived: boolean }> }> } } };

export type UserInformationForSettingsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserInformationForSettingsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, avatar?: string | null, signedUpWithSso: boolean, phoneCountry?: { __typename?: 'Country', id: string, code: string } | null, participants: Array<{ __typename?: 'Mentor', id: string, program: { __typename?: 'Program', id: string } } | { __typename?: 'Student', id: string, program: { __typename?: 'Program', id: string } }> } };

export type UpdateUserInformationMutationVariables = Exact<{
  userInput: UserInput;
}>;


export type UpdateUserInformationMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', errors: Array<InvalidUserInputError>, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, phoneCountry?: { __typename?: 'Country', id: string, code: string } | null } | null } | null };

export type UserAvatarsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserAvatarsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, participants: Array<{ __typename?: 'Mentor', id: string, avatar: string } | { __typename?: 'Student', id: string, avatar: string }> } };

export type CurrentProgramShortNameForParticipantQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type CurrentProgramShortNameForParticipantQuery = { __typename?: 'Query', participant: { __typename: 'Mentor', id: string, program: { __typename?: 'Program', id: string, shortName: string, title: string } } | { __typename: 'Student', id: string, program: { __typename?: 'Program', id: string, shortName: string, title: string } } };

export type SaveWrittenMessageMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  shareWithStudents?: InputMaybe<Scalars['Boolean']['input']>;
  sharePublicly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaveWrittenMessageMutation = { __typename?: 'Mutation', saveWrittenMessage?: { __typename?: 'SaveWrittenMessagePayload', participant: { __typename?: 'Mentor', id: string, writtenMessages: Array<{ __typename?: 'WrittenMessage', id: string }> } | { __typename?: 'Student', id: string, writtenMessages: Array<{ __typename?: 'WrittenMessage', id: string }> } } | null };

export type CreateUploadedVideoMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
  ziggeoToken: Scalars['String']['input'];
  fileType?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  sharePublicly: Scalars['Boolean']['input'];
  shareWithStudents: Scalars['Boolean']['input'];
}>;


export type CreateUploadedVideoMutation = { __typename?: 'Mutation', createUploadedVideo?: { __typename?: 'CreateUploadedVideoPayload', errors: Array<string>, participant?: { __typename?: 'Mentor', id: string, uploadedVideos: Array<{ __typename?: 'UploadedVideo', id: string, ziggeoToken: string }> } | { __typename?: 'Student', id: string, uploadedVideos: Array<{ __typename?: 'UploadedVideo', id: string, ziggeoToken: string }> } | null } | null };

export type EmailForParticipantQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type EmailForParticipantQuery = { __typename?: 'Query', participant: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, email?: string | null } } | { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, email?: string | null } } };

export type UserParticipantsForTaskAssignmentQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  registered?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UserParticipantsForTaskAssignmentQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, participants: Array<{ __typename: 'Mentor', id: string } | { __typename: 'Student', id: string }> } };

export type UserNameFragmentFragment = { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null };

export type PartnerDashboardActivitiesQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ActivityLogsSort>;
  filter: ActivityLogsFilter;
  includeMathingSurveyResponses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PartnerDashboardActivitiesQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, activityLogs: { __typename?: 'ActivityLogConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ActivityLog', id: string, eventType: ActivityLogEvent, occurredAt: any, loggableActivity: { __typename: 'AssessmentScoreResponse', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } | { __typename: 'DeregistrationStatusEvent', id: string, deregistrationReason: { __typename?: 'DeregistrationReason', id: string, name: string }, participant: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } | { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } } | { __typename: 'Flag', id: string, mentorship: { __typename?: 'Mentorship', id: string, mentor: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } }, student: { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } } } | { __typename: 'Mentor', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } | { __typename: 'MentorContact', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } | { __typename: 'Mentorship', id: string, mentor: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } }, student: { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } } | { __typename: 'PartnerNotification' } | { __typename: 'Student', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } | { __typename: 'StudentContact', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } | { __typename: 'SurveyResponse', id: string, surveyResponseAnswerStrings?: Array<{ __typename?: 'SurveyResponseAnswerStrings', id: string, questionPrompt: string, answerString: string, subprompt?: string | null, qid: string }> | null, respondent?: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } | { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } | null } | { __typename: 'TrainingEventLog', id: string, participant: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } | { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } } }> } } };

export type CommunityMessagesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WrittenMessageFilter>;
  sort?: InputMaybe<WrittenMessageSort>;
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
}>;


export type CommunityMessagesQuery = { __typename?: 'Query', writtenMessages: { __typename?: 'WrittenMessageConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'WrittenMessage', id: string, content: string, participant: { __typename: 'Mentor', id: string, user: { __typename?: 'User', id: string, avatarImage?: { __typename?: 'Image', id: string, url: string } | null }, program: { __typename?: 'Program', id: string, defaultProfileImage?: string | null, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, shortName: string } } }, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> } | { __typename: 'Student', id: string, user: { __typename?: 'User', id: string, avatarImage?: { __typename?: 'Image', id: string, url: string } | null }, program: { __typename?: 'Program', id: string, defaultProfileImage?: string | null, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, shortName: string } } }, userProfileData: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> } }> } };

export type ProgramInfoForPartnerDashboardHeaderQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramInfoForPartnerDashboardHeaderQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, programLogo?: string | null, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null, school: { __typename?: 'School', id: string, name: string, logo?: string | null } } } };

export type UserInfoForPartnerDashboardNotificationsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
}>;


export type UserInfoForPartnerDashboardNotificationsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, lastProgramPageVisit?: { __typename?: 'ProgramPageVisit', id: string, createdAt: any, path: string } | null } };

export type ReviewMatchingSurveyForPartnerDashboardNotificationsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  occurredAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;


export type ReviewMatchingSurveyForPartnerDashboardNotificationsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, showMatchingSurveysToPartner: boolean, activityLogs: { __typename?: 'ActivityLogConnection', totalInitialMatchingSurveyReviewNotificationCount: number, totalMatchingSurveyUpdatedReviewNotificationCount: number } } };

export type ActivitiesForPartnerDashboardNotificationsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  occurredAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  excludeEventTypes?: InputMaybe<Array<ActivityLogEvent> | ActivityLogEvent>;
  eventTypes?: InputMaybe<Array<ActivityLogEvent> | ActivityLogEvent>;
}>;


export type ActivitiesForPartnerDashboardNotificationsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, activityLogs: { __typename?: 'ActivityLogConnection', totalCount: number } } };

export type FlagsForPartnerDashboardNotificationsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  occurredAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;


export type FlagsForPartnerDashboardNotificationsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, activityLogs: { __typename?: 'ActivityLogConnection', totalFlagReportedCount: number } } };

export type LowAssessmentScoresForPartnerDashboardNotificationsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  occurredAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;


export type LowAssessmentScoresForPartnerDashboardNotificationsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, activityLogs: { __typename?: 'ActivityLogConnection', totalLowSobAssessmentScoreSubmittedCount: number, totalLowAseAssessmentScoreSubmittedCount: number, totalLowCdseAssessmentScoreSubmittedCount: number, totalLowAhsAssessmentScoreSubmittedCount: number } } };

export type UserInfoForUserMenuQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserInfoForUserMenuQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, isPartner: boolean, isAdmin: boolean, participants: Array<{ __typename?: 'Mentor', id: string, registrationDate: any, program: { __typename?: 'Program', id: string, name: string } } | { __typename?: 'Student', id: string, registrationDate: any, program: { __typename?: 'Program', id: string, name: string } }>, partners: Array<{ __typename?: 'Partner', id: string, programSequence: { __typename?: 'ProgramSequence', id: string, programs: Array<{ __typename?: 'Program', id: string, name: string }> } }> } };

export type PartnerDashboardProgramMetricsAverageAssessmentScoresQueryVariables = Exact<{
  intervalBy: TimePeriod;
  groupBy?: InputMaybe<AssessmentScoresGroupBy>;
  dateRange?: InputMaybe<DateRange>;
  filter: AssessmentScoreResponsesFilter;
}>;


export type PartnerDashboardProgramMetricsAverageAssessmentScoresQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', assessmentScoreResponses: { __typename?: 'AssessmentScoreResponsesMetrics', averageAssessmentScore: Array<{ __typename?: 'Interval', value: number, date: any, group?: string | null, valueType: IntervalValue }> } } };

export type PartnerDashboardAssessmentAreaScoreDistributionChartDataQueryVariables = Exact<{
  filter: UsersFilter;
}>;


export type PartnerDashboardAssessmentAreaScoreDistributionChartDataQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number } };

export type PartnerDashboardProgramAssessmentAreasPromptsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type PartnerDashboardProgramAssessmentAreasPromptsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, programAssessmentAreas: Array<{ __typename?: 'ProgramAssessmentArea', id: string, enabledForMentees: boolean, enabledForMentors: boolean, scaleMax: number, assessmentArea: { __typename?: 'AssessmentArea', id: string, identifier: AssessmentAreaIdentifier, name: string, assessmentPrompts: Array<{ __typename?: 'AssessmentPrompt', id: string, text: string, identifier: string }> } }> } };

export type PartnerDashboardAverageAssessmentScorePerPromptChartDataQueryVariables = Exact<{
  filter: AssessmentScoreResponsesFilter;
  intervalBy: TimePeriod;
  groupBy: AssessmentScoresGroupBy;
  aggregateInTimeZone: Scalars['String']['input'];
  dateRange?: InputMaybe<DateRange>;
}>;


export type PartnerDashboardAverageAssessmentScorePerPromptChartDataQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', assessmentScoreResponses: { __typename?: 'AssessmentScoreResponsesMetrics', averageAssessmentScore: Array<{ __typename?: 'Interval', value: number, date: any, group?: string | null, sampleSize?: number | null, valueType: IntervalValue }> } } };

export type PartnerDashboardEngagementTopicConversationsQueryVariables = Exact<{
  filter?: InputMaybe<MentorshipsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<MentorshipsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardEngagementTopicConversationsQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'MentorshipsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardEngagementTopicFlagsQueryVariables = Exact<{
  filter?: InputMaybe<FlagsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<FlagsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardEngagementTopicFlagsQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'FlagsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardDisengagementResolutionsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  disengagementEventDateFilter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;


export type PartnerDashboardDisengagementResolutionsQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', disengagementResolutions: Array<{ __typename?: 'DisengagementResolutionsMetricsResult', metric: string, value: number }>, disengagementResolutionsAverageTimeToRematch?: { __typename?: 'DisengagementResolutionsAverageTimeToRematchResult', averageRematchTimeInDays?: number | null } | null } };

export type ProgramAdditionalFunnelInfoQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramAdditionalFunnelInfoQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, trainingMode?: ProgramTrainingMode | null, startDate: any } };

export type MentorTrainingAdditionalFunnelInfoQueryVariables = Exact<{
  filter: ParticipantsFilter;
  dateRange?: InputMaybe<DateRange>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type MentorTrainingAdditionalFunnelInfoQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', participants: { __typename?: 'ParticipantsMetrics', totalCredentialed: Array<{ __typename?: 'Interval', value: number }> } } };

export type OnboardingMenteesWaitingToBeMatchedQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type OnboardingMenteesWaitingToBeMatchedQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number } };

export type PartnerDashboardTopMentorRecruitmentOpportunitiesQueryVariables = Exact<{
  studentsUsersFilter: UsersFilter;
  mentorsUsersFilter: UsersFilter;
  opportunityArea: OpportunityArea;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PartnerDashboardTopMentorRecruitmentOpportunitiesQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', recruitmentOpportunities: Array<{ __typename?: 'RecruitmentOpportunitiesMetricsResult', attributeType: string, attributeValue: string, menteesWaiting: number, mentorsCount: number, mentorsOpenSlots: number, mentorsGap: number, strongestPreferenceKey: string, strongestPreferenceDisplayValue: string }> } };

export type PartnerDashboardProgramAsksStrongestPreferenceInMenteeMatchingSurveyAndProfileAttributesExistQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type PartnerDashboardProgramAsksStrongestPreferenceInMenteeMatchingSurveyAndProfileAttributesExistQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, asksStrongestPreferenceQuestionInMenteeMatchingSurveyAndProfileAttributesExist: boolean } };

export type PartnerDashboardProgramHasMatchingSuveysMigratedFromOldFrameworkQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type PartnerDashboardProgramHasMatchingSuveysMigratedFromOldFrameworkQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, hasMatchingSuveysMigratedFromOldFramework: boolean } };

export type RecruitmentOpportunitiesExportQueryVariables = Exact<{
  studentsUsersFilter: UsersFilter;
  mentorsUsersFilter: UsersFilter;
  programId: Scalars['ID']['input'];
  opportunityArea: OpportunityArea;
  csvExportContext: CsvExportContextInput;
}>;


export type RecruitmentOpportunitiesExportQuery = { __typename?: 'Query', csvExports: { __typename?: 'CsvExports', recruitmentOpportunities: { __typename?: 'CsvExport', id: string, filename?: string | null, isProcessing: boolean, url?: string | null } } };

export type OnboardingAndMatchingContactsDataQueryVariables = Exact<{
  filter: ContactsFilter;
  dateRange?: InputMaybe<DateRange>;
  intervalBy: TimePeriod;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type OnboardingAndMatchingContactsDataQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', contacts: { __typename?: 'ContactsMetrics', totalInvited: Array<{ __typename?: 'Interval', value: number, date: any }> } } };

export type OnboardingAndMatchingParticipantsDataQueryVariables = Exact<{
  filter: ParticipantsFilter;
  dateRange?: InputMaybe<DateRange>;
  intervalBy: TimePeriod;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type OnboardingAndMatchingParticipantsDataQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', participants: { __typename?: 'ParticipantsMetrics', totalMatchingSurveyCompleted: Array<{ __typename?: 'Interval', value: number }>, totalCredentialed: Array<{ __typename?: 'Interval', value: number }>, totalMatched: Array<{ __typename?: 'Interval', value: number }>, totalRegistered: Array<{ __typename?: 'Interval', value: number }> } } };

export type LogProgramPageVisitMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
}>;


export type LogProgramPageVisitMutation = { __typename?: 'Mutation', createProgramPageVisit?: { __typename?: 'CreateProgramPageVisitPayload', programPageVisit?: { __typename?: 'ProgramPageVisit', id: string, createdAt: any, path: string } | null } | null };

export type FilteredConversationsCountQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  filter?: InputMaybe<ParticipantConversationContentsFilter>;
}>;


export type FilteredConversationsCountQuery = { __typename?: 'Query', participantConversationContents: { __typename?: 'ParticipantConversationContentConnection', totalCount: number } };

export type AllConversationsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  filter?: InputMaybe<ParticipantConversationContentsFilter>;
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ParticipantConversationContentsSort>;
}>;


export type AllConversationsQuery = { __typename?: 'Query', participantConversationContents: { __typename?: 'ParticipantConversationContentConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null, hasNextPage: boolean }, nodes: Array<{ __typename?: 'ParticipantConversationContent', id: string, createdAt: any, participantConversationType: ParticipantConversation, submittedBy: { __typename?: 'User', id: string, isAdmin: boolean, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null }, participantConversationCategories?: Array<{ __typename?: 'ParticipantConversationCategory', id: string, name: string }> | null, conversationLog: { __typename?: 'ConversationLog', id: string, mentorship: { __typename?: 'Mentorship', id: string, student: { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } }, mentor: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } } } }> } };

export type ProgramInfoForPartnerDashboardQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramInfoForPartnerDashboardQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, currentPhase: ProgramPhase, currentStage: ProgramStage, startDate: any, endDate: any, requiredMentorTrainingCredential?: string | null, programGoal?: { __typename?: 'ProgramGoal', id: string, target: number, type: ProgramGoalTypes } | null, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null }, studentOpeningAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, studentMidAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, studentEndAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, mentorOpeningAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, mentorMidAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, mentorEndAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, programAssessmentAreas: Array<{ __typename?: 'ProgramAssessmentArea', id: string, enabledForMentees: boolean, enabledForMentors: boolean, scaleMax: number, assessmentArea: { __typename?: 'AssessmentArea', id: string, identifier: AssessmentAreaIdentifier, name: string } }> } };

export type PartnerDashboardUpdateUserInformationMutationVariables = Exact<{
  userInput: UserInput;
  organizationType?: InputMaybe<OrganizationType>;
  higherEdCategory?: InputMaybe<HigherEdCategory>;
  higherEdRole?: InputMaybe<HigherEdRole>;
}>;


export type PartnerDashboardUpdateUserInformationMutation = { __typename?: 'Mutation', updatePartner?: { __typename?: 'UpdatePartnerPayload', errors: Array<InvalidUserInputError>, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, phoneCountry?: { __typename?: 'Country', id: string, code: string } | null } | null, partner?: { __typename?: 'Partner', id: string, organizationType?: OrganizationType | null, higherEdCategory?: HigherEdCategory | null, higherEdRole?: HigherEdRole | null } | null } | null };

export type SurveyInfoForPartnerDashboardExportsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type SurveyInfoForPartnerDashboardExportsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, currentStage: ProgramStage, studentOpeningAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, mentorOpeningAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, studentMidAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, mentorMidAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, studentEndAssessmentSurvey?: { __typename?: 'Survey', id: string } | null, mentorEndAssessmentSurvey?: { __typename?: 'Survey', id: string } | null } };

export type ProgramMatchingSurveysExportsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramMatchingSurveysExportsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, mentorMatchingSurvey: { __typename?: 'Survey', id: string }, studentMatchingSurvey: { __typename?: 'Survey', id: string } } };

export type ProgramMicroSurveysExportsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramMicroSurveysExportsQuery = { __typename?: 'Query', microSurveys: { __typename?: 'MicroSurveyConnection', nodes: Array<{ __typename?: 'MicroSurvey', id: string, survey: { __typename?: 'Survey', id: string, name: string, hasResponses?: boolean | null } }> } };

export type PartnerDashboardUsersCsvExportQueryVariables = Exact<{
  filter: UsersFilter;
  csvExportContext: CsvExportContextInput;
  profileDataColumns: Array<UserProfileDataColumnInput> | UserProfileDataColumnInput;
  firstColumn?: InputMaybe<UsersExportFirstColumn>;
  resultModifiers?: InputMaybe<UsersExportResultModifiers>;
}>;


export type PartnerDashboardUsersCsvExportQuery = { __typename?: 'Query', csvExports: { __typename?: 'CsvExports', partnerDashboardExports: { __typename?: 'PartnerDashboardExports', users: { __typename?: 'CsvExport', id: string, isProcessing: boolean, filename?: string | null, url?: string | null } } } };

export type PartnerDashboardMentorshipsExportQueryVariables = Exact<{
  filter: MentorshipsFilter;
  profileDataColumns: Array<UserProfileDataColumnInput> | UserProfileDataColumnInput;
  csvExportContext?: InputMaybe<CsvExportContextInput>;
  includeTouchpointMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  resultModifiers?: InputMaybe<MentorshipsExportResultModifiers>;
  exportType?: InputMaybe<MentorshipsExport>;
}>;


export type PartnerDashboardMentorshipsExportQuery = { __typename?: 'Query', csvExports: { __typename?: 'CsvExports', partnerDashboardExports: { __typename?: 'PartnerDashboardExports', mentorships?: { __typename?: 'CsvExport', id: string, isProcessing: boolean, filename?: string | null, url?: string | null, errors?: Array<string> | null } | null } } };

export type PartnerDashboardFlagsExportQueryVariables = Exact<{
  filter: FlagsFilter;
  csvExportContext?: InputMaybe<CsvExportContextInput>;
  profileDataColumns: Array<UserProfileDataColumnInput> | UserProfileDataColumnInput;
}>;


export type PartnerDashboardFlagsExportQuery = { __typename?: 'Query', csvExports: { __typename?: 'CsvExports', partnerDashboardExports: { __typename?: 'PartnerDashboardExports', flags?: { __typename?: 'CsvExport', id: string, isProcessing: boolean, filename?: string | null, url?: string | null, errors?: Array<string> | null } | null } } };

export type PartnerDashboardConversationsExportQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  filter?: InputMaybe<ParticipantConversationContentsFilter>;
  csvExportContext?: InputMaybe<CsvExportContextInput>;
  profileDataColumns: Array<UserProfileDataColumnInput> | UserProfileDataColumnInput;
}>;


export type PartnerDashboardConversationsExportQuery = { __typename?: 'Query', csvExports: { __typename?: 'CsvExports', partnerDashboardExports: { __typename?: 'PartnerDashboardExports', conversations?: { __typename?: 'CsvExport', id: string, isProcessing: boolean, filename?: string | null, url?: string | null, errors?: Array<string> | null } | null } } };

export type PartnerDashboardExportsProgramProfileAttributesQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  programProfileAttributeCategoriesProgramId: Scalars['MCID']['input'];
}>;


export type PartnerDashboardExportsProgramProfileAttributesQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, programProfileAttributes: Array<{ __typename?: 'ProgramProfileAttribute', id: string, availableInPartnerDashboardExports: boolean, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> }, programProfileAttributeCategories: Array<{ __typename?: 'ProgramProfileAttributeCategoryResult', profileAttribute: { __typename?: 'ProfileAttribute', id: string }, profileAttributeCategories: Array<{ __typename?: 'ProfileAttributeCategory', id: string }> }> };

export type SurveyResponsesForExportQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  context: CsvExportContextInput;
}>;


export type SurveyResponsesForExportQuery = { __typename?: 'Query', csvExports: { __typename?: 'CsvExports', surveyResponses: { __typename?: 'CsvExport', id: string, url?: string | null, filename?: string | null, isProcessing: boolean } } };

export type UpdateFlagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: FlagStatus;
  partnerNotes: Scalars['String']['input'];
}>;


export type UpdateFlagMutation = { __typename?: 'Mutation', updateFlag?: { __typename?: 'UpdateFlagPayload', errors: Array<{ __typename?: 'Error', message: string, path: string }>, flag: { __typename?: 'Flag', id: string, status: FlagStatus, partnerNotes: string } } | null };

export type FilteredFlagsCountQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  filter?: InputMaybe<FlagsFilter>;
}>;


export type FilteredFlagsCountQuery = { __typename?: 'Query', flags: { __typename?: 'FlagConnection', totalCount: number } };

export type FlagsForQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<FlagsFilter>;
  sort?: InputMaybe<FlagsSort>;
}>;


export type FlagsForQuery = { __typename?: 'Query', flags: { __typename?: 'FlagConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Flag', id: string, createdAt: any, supportPriority: SupportPriority, status: FlagStatus, partnerNotes: string, additionalInfo?: string | null, flagCategories: Array<{ __typename?: 'FlagCategory', id: string, name: string, identifier: string, label: string }>, submittedBy: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null, isAdmin: boolean }, participantConversationContent?: { __typename?: 'ParticipantConversationContent', id: string, participantConversationType: ParticipantConversation, confidenceScore?: number | null, confidenceNotes?: string | null, createdAt: any, participantConversationCategories?: Array<{ __typename?: 'ParticipantConversationCategory', id: string, name: string }> | null } | null, mentorship: { __typename?: 'Mentorship', id: string, flags: { __typename?: 'FlagConnection', totalCount: number }, student: { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } }, mentor: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } } }> } };

export type UserInfoForPartnerDashboardQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserInfoForPartnerDashboardQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', nodes: Array<{ __typename?: 'Program', id: string, name: string }> }, user: { __typename?: 'User', id: string, isAdmin: boolean, firstName: string, lastName: string, email?: string | null, partners: Array<{ __typename?: 'Partner', id: string, organizationType?: OrganizationType | null, higherEdRole?: HigherEdRole | null, higherEdCategory?: HigherEdCategory | null, registered: boolean, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, ssoEnabled?: boolean | null, ssoRequiredForPartners: boolean, ssoProviderIdentifier?: string | null }, programs: Array<{ __typename?: 'Program', id: string, startDate: any, createdAt: any, students: { __typename?: 'ParticipantConnection', totalCount: number }, mentors: { __typename?: 'ParticipantConnection', totalCount: number } }> } }>, participants: Array<{ __typename?: 'Mentor', id: string } | { __typename?: 'Student', id: string }> } };

export type UserSsoInfoForPartnerDashboardQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type UserSsoInfoForPartnerDashboardQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramConnection', nodes: Array<{ __typename?: 'Program', id: string, name: string }> }, user: { __typename?: 'User', id: string, isAdmin: boolean, hasValidSsoToken: boolean, partners: Array<{ __typename?: 'Partner', id: string, organizationType?: OrganizationType | null, higherEdRole?: HigherEdRole | null, higherEdCategory?: HigherEdCategory | null, registered: boolean, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, ssoEnabled?: boolean | null, ssoRequiredForPartners: boolean, ssoProviderIdentifier?: string | null }, programs: Array<{ __typename?: 'Program', id: string, startDate: any }> } }> } };

export type MentorshipSurveyResponsesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  filter: SurveyResponsesFilter;
  programId: Scalars['ID']['input'];
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
  sort?: InputMaybe<SurveyResponsesSort>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  qidFilter?: InputMaybe<SurveyResponseAnswerStringsFilter>;
}>;


export type MentorshipSurveyResponsesQuery = { __typename?: 'Query', mentorship: { __typename?: 'Mentorship', id: string, combinedMenteeMentorSurveyResponses?: { __typename?: 'SurveyResponseConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'SurveyResponse', id: string, submittedAt: any, participant?: { __typename?: 'Mentor', id: string } | { __typename?: 'Student', id: string } | null, surveyResponseAnswerStrings?: Array<{ __typename?: 'SurveyResponseAnswerStrings', id: string, qid: string, questionPrompt: string, answerString: string, subprompt?: string | null }> | null, survey: { __typename?: 'Survey', id: string, surveyType?: SurveyType | null } }> } | null, student: { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } }, mentor: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } } };

export type SendUpdateEmailDraftForMentorshipMutationVariables = Exact<{
  mentorshipId: Scalars['ID']['input'];
}>;


export type SendUpdateEmailDraftForMentorshipMutation = { __typename?: 'Mutation', sendUpdateEmailDraftForMentorship?: { __typename?: 'SendUpdateEmailDraftForMentorshipPayload', errors?: string | null, notice?: string | null } | null };

export type MentorshipDetailsUserFragment = { __typename?: 'User', id: string, email?: string | null, phone?: string | null, linkedInUrl?: string | null, firstName: string, lastName: string, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null };

export type ProgramMentorshipQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  mentorshipId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
  flagsFilter?: InputMaybe<FlagsFilter>;
}>;


export type ProgramMentorshipQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string }, user: { __typename?: 'User', id: string, isAdmin: boolean }, mentorship: { __typename?: 'Mentorship', id: string, matchDate: any, unmatchDate?: any | null, unmatchReason?: UnmatchReason | null, unmatchNotes?: string | null, commonQualities?: Array<string> | null, mentorConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, studentConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, flags: { __typename?: 'FlagConnection', totalCount: number }, lastConversation?: { __typename?: 'ConversationLog', id: string, loggedAtDate: any } | null, student: { __typename?: 'Student', id: string, goals: Array<{ __typename?: 'StudentGoal', id: string, answerText: string }>, user: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, linkedInUrl?: string | null, firstName: string, lastName: string, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } }, mentor: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, linkedInUrl?: string | null, firstName: string, lastName: string, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } } };

export type MentorshipPriorityFlagsQueryVariables = Exact<{
  mentorshipId: Scalars['ID']['input'];
  flagsFilter?: InputMaybe<FlagsFilter>;
  programId: Scalars['ID']['input'];
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
  sort?: InputMaybe<FlagsSort>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type MentorshipPriorityFlagsQuery = { __typename?: 'Query', mentorship: { __typename?: 'Mentorship', id: string, student: { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } }, mentor: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string } }, flags: { __typename?: 'FlagConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Flag', id: string, additionalInfo?: string | null, createdAt: any, flagCategories: Array<{ __typename?: 'FlagCategory', id: string, label: string }>, submittedBy: { __typename?: 'User', id: string, isAdmin: boolean } }> } } };

export type PartnerDashboardMentorshipsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  cacheSettings: CachedUserProfileDataSettingsFilter;
  userAttributes: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<MentorshipsFilter>;
  sort?: InputMaybe<MentorshipsSort>;
  flagsFilter?: InputMaybe<FlagsFilter>;
}>;


export type PartnerDashboardMentorshipsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, showMatchingSurveysToPartner: boolean, mentorMatchingSurvey: { __typename?: 'Survey', id: string, migrated?: boolean | null }, studentMatchingSurvey: { __typename?: 'Survey', id: string, migrated?: boolean | null }, partnerSuccessManager?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null }, mentorships: { __typename?: 'MentorshipConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Mentorship', id: string, matchDate: any, student: { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null } }, mentor: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null } }, flags: { __typename?: 'FlagConnection', totalCount: number }, mentorConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, studentConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }> }> } } };

export type PartnerDashboardMentorshipsCountQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  filter?: InputMaybe<MentorshipsFilter>;
}>;


export type PartnerDashboardMentorshipsCountQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, mentorships: { __typename?: 'MentorshipConnection', totalCount: number } } };

export type ProgramMatchingSurveysQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramMatchingSurveysQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, showMatchingSurveysToPartner: boolean, partnerSuccessManager?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, logo?: string | null } }, studentMatchingSurvey: { __typename: 'Survey', id: string, name: string }, mentorMatchingSurvey: { __typename: 'Survey', id: string, name: string } } };

export type DeregisterParticipantMutationVariables = Exact<{
  input: DeregisterParticipantInput;
}>;


export type DeregisterParticipantMutation = { __typename?: 'Mutation', deregisterParticipant?: { __typename?: 'DeregisterParticipantPayload', participant?: { __typename?: 'Mentor', id: string, registered: boolean, user: { __typename?: 'User', id: string } } | { __typename?: 'Student', id: string, registered: boolean, user: { __typename?: 'User', id: string } } | null, errors: Array<{ __typename?: 'Error', message: string, path: string }> } | null };

export type PartnerDashboardDeregistrationReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnerDashboardDeregistrationReasonsQuery = { __typename?: 'Query', deregistrationReasons: { __typename?: 'DeregistrationReasonConnection', nodes: Array<{ __typename?: 'DeregistrationReason', id: string, identifier: string, name: string, grouping: GroupingEnum }> } };

export type ParticipantMentorshipsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  source: ProfileAttributeSource;
  userAttributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
  filter?: InputMaybe<MentorshipsFilter>;
  sort?: InputMaybe<MentorshipsSort>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ParticipantMentorshipsQuery = { __typename?: 'Query', participant: { __typename?: 'Mentor', id: string, participantMentorships?: { __typename?: 'MentorshipConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean }, nodes: Array<{ __typename?: 'Mentorship', id: string, matchDate: any, conversationLogsCount: number, student: { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } }, mentor: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } }> } | null } | { __typename?: 'Student', id: string, participantMentorships?: { __typename?: 'MentorshipConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean }, nodes: Array<{ __typename?: 'Mentorship', id: string, matchDate: any, conversationLogsCount: number, student: { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } }, mentor: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null } } }> } | null } };

export type UserParticipantAndContactQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  flagsFilter?: InputMaybe<FlagsFilter>;
  source: ProfileAttributeSource;
  attributes: Array<UserProfileDataAttributeInput> | UserProfileDataAttributeInput;
  fallbackRules?: InputMaybe<Array<UserProfileDataFallbackRule> | UserProfileDataFallbackRule>;
  credentials?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UserParticipantAndContactQuery = { __typename?: 'Query', program: { __typename: 'Program', name: string, id: string, segment: ProgramSegment, requiredMentorTrainingCredential?: string | null }, user: { __typename: 'User', id: string, email?: string | null, phone?: string | null, linkedInUrl?: string | null, firstName: string, lastName: string, userStatusInProgram?: UserProgramStatus | null, mentorshipCredentials: Array<{ __typename?: 'UserMentorshipCredential', id: string, createdAt: any, updatedAt: any, mentorshipCredential?: { __typename?: 'MentorshipCredential', id: string, credential: MentorshipCredentialCredentials } | null }>, userProfileData?: Array<{ __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> }> | null, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, participants: Array<{ __typename: 'Mentor', id: string, registrationDate: any, registered: boolean, mentorships: Array<{ __typename?: 'Mentorship', id: string, isMatched: boolean, conversationLogsCount: number, flags: { __typename?: 'FlagConnection', totalCount: number } }>, deregistrationStatusEvents: Array<{ __typename?: 'DeregistrationStatusEvent', id: string, otherReasonNotes?: string | null, createdAt: any, deregistrationReason: { __typename?: 'DeregistrationReason', id: string, name: string, identifier: string } }> } | { __typename: 'Student', questionForMentor?: string | null, id: string, registrationDate: any, registered: boolean, goals: Array<{ __typename?: 'StudentGoal', id: string, answerText: string }>, mentorships: Array<{ __typename?: 'Mentorship', id: string, isMatched: boolean, conversationLogsCount: number, flags: { __typename?: 'FlagConnection', totalCount: number } }>, deregistrationStatusEvents: Array<{ __typename?: 'DeregistrationStatusEvent', id: string, otherReasonNotes?: string | null, createdAt: any, deregistrationReason: { __typename?: 'DeregistrationReason', id: string, name: string, identifier: string } }> }>, contacts: Array<{ __typename: 'MentorContact', id: string } | { __typename: 'StudentContact', id: string }> } };

export type ConversationTopicCategoriesQueryVariables = Exact<{
  segment: ProgramSegment;
}>;


export type ConversationTopicCategoriesQuery = { __typename?: 'Query', conversationTopicCategories: Array<{ __typename?: 'ParticipantConversationCategory', id: string, identifier: string, label: string, name: string }> };

export type PartnerDashboardParticipantsCountQueryVariables = Exact<{
  filter?: InputMaybe<UsersFilter>;
}>;


export type PartnerDashboardParticipantsCountQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number } };

export type PartnerDashboardParticipantsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  cacheSettings: CachedUserProfileDataSettingsFilter;
  userAttributes: Array<CachedUserProfileDataAttributeInput> | CachedUserProfileDataAttributeInput;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<UsersFilter>;
  sort?: InputMaybe<UsersSort>;
  registered?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PartnerDashboardParticipantsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, requiredMentorTrainingCredential?: string | null, defaultProfileImage?: string | null, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null } }, users: { __typename?: 'UserConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'User', id: string, userStatusInProgram?: UserProgramStatus | null, cachedUserProfileData?: Array<{ __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } }> | null, avatarImage?: { __typename?: 'Image', id: string, url: string } | null, participants: Array<{ __typename: 'Mentor', id: string, registrationDate: any } | { __typename: 'Student', id: string, registrationDate: any, goals: Array<{ __typename?: 'StudentGoal', id: string, answerKey: string, answerText: string }> }>, contacts: Array<{ __typename: 'MentorContact', id: string, uploadedDate: any } | { __typename: 'StudentContact', id: string, uploadedDate: any }> }> } };

export type PartnerDashboardProgramStudentGoalsListQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type PartnerDashboardProgramStudentGoalsListQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, studentGoalsList?: Array<{ __typename?: 'StudentGoalsList', answerKey: string, answerText: string }> | null } };

export type SurveyCustomizationsForProgramQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  questionFilter?: InputMaybe<SurveyQuestionFilter>;
}>;


export type SurveyCustomizationsForProgramQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, mentorMatchingSurvey: { __typename: 'Survey', id: string, archived?: boolean | null, migrated?: boolean | null, questions: Array<{ __typename?: 'SurveyQuestion', id: string, qid?: string | null, customizationOptions?: Array<{ __typename?: 'SurveyQuestionCustomizationOption', id: string, text: string }> | null }> }, studentMatchingSurvey: { __typename: 'Survey', id: string, archived?: boolean | null, migrated?: boolean | null, questions: Array<{ __typename?: 'SurveyQuestion', id: string, qid?: string | null, customizationOptions?: Array<{ __typename?: 'SurveyQuestionCustomizationOption', id: string, text: string }> | null }> } } };

export type LatestPsmForSchoolQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  schoolId: Scalars['ID']['input'];
}>;


export type LatestPsmForSchoolQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, latestPartnerProgramForSchool?: { __typename?: 'Program', partnerSuccessManager?: { __typename?: 'User', firstName: string, lastName: string, email?: string | null } | null } | null } };

export type PartnerDashboardProgramMetricsContactsTotalInvitedQueryVariables = Exact<{
  filter?: InputMaybe<ContactsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ContactsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsContactsTotalInvitedQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'ContactsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardCredentialedParticipantMetricsQueryVariables = Exact<{
  filter?: InputMaybe<ParticipantsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ParticipantsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardCredentialedParticipantMetricsQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'ParticipantsMetrics', metric: Array<{ __typename?: 'Interval', value: number, date: any, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsParticipantsTotalMatchedQueryVariables = Exact<{
  filter?: InputMaybe<ParticipantsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ParticipantsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsParticipantsTotalMatchedQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'ParticipantsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsParticipantsTotalMatchingSurveyCompletedQueryVariables = Exact<{
  filter?: InputMaybe<ParticipantsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ParticipantsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsParticipantsTotalMatchingSurveyCompletedQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'ParticipantsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsParticipantsTotalCompletedSurveysQueryVariables = Exact<{
  filter?: InputMaybe<ParticipantsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ParticipantsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  surveyIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsParticipantsTotalCompletedSurveysQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'ParticipantsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsParticipantsTotalRegisteredQueryVariables = Exact<{
  filter?: InputMaybe<ParticipantsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ParticipantsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsParticipantsTotalRegisteredQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'ParticipantsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsParticipantsTotalTrainedQueryVariables = Exact<{
  filter?: InputMaybe<ParticipantsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ParticipantsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsParticipantsTotalTrainedQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'ParticipantsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsParticipantsTotalWantsMentorshipQueryVariables = Exact<{
  filter?: InputMaybe<ParticipantsFilter>;
  wantsMentorshipAnswer: Scalars['Boolean']['input'];
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<ParticipantsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsParticipantsTotalWantsMentorshipQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'ParticipantsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsMentorshipsTotalMatchedQueryVariables = Exact<{
  filter?: InputMaybe<MentorshipsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<MentorshipsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsMentorshipsTotalMatchedQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'MentorshipsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsMentorshipsTotalConversationsLoggedQueryVariables = Exact<{
  filter?: InputMaybe<MentorshipsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<MentorshipsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsMentorshipsTotalConversationsLoggedQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'MentorshipsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsMentorshipsTotalLoggedThreeConversationsQueryVariables = Exact<{
  filter?: InputMaybe<MentorshipsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<MentorshipsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsMentorshipsTotalLoggedThreeConversationsQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'MentorshipsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsMentorshipsTotalFirstUsedSmsRelayQueryVariables = Exact<{
  filter?: InputMaybe<MentorshipsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<MentorshipsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsMentorshipsTotalFirstUsedSmsRelayQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'MentorshipsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsMentorshipsTotalSmsRelayMessagesSentQueryVariables = Exact<{
  filter?: InputMaybe<MentorshipsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<MentorshipsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsMentorshipsTotalSmsRelayMessagesSentQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'MentorshipsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsFlagsTotalFlaggedQueryVariables = Exact<{
  filter?: InputMaybe<FlagsFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<FlagsGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsFlagsTotalFlaggedQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'FlagsMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramsRequiredMentorTrainingCredentialQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type PartnerDashboardProgramsRequiredMentorTrainingCredentialQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, requiredMentorTrainingCredential?: string | null } };

export type PartnerDashboardProgramMetricsUsersTotalRepliesToMcTextsQueryVariables = Exact<{
  filter?: InputMaybe<UsersFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<UsersGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  programIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsUsersTotalRepliesToMcTextsQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'UsersMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsUsersTotalMinimumTouchpointsQueryVariables = Exact<{
  filter?: InputMaybe<UsersFilter>;
  minimumNumberTouchpoints: Scalars['Int']['input'];
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<UsersGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  programIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsUsersTotalMinimumTouchpointsQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'UsersMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsUsersTotalZeroTouchpointsQueryVariables = Exact<{
  filter?: InputMaybe<UsersFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<UsersGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  programIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsUsersTotalZeroTouchpointsQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'UsersMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsUsersTotalEnteredProgramQueryVariables = Exact<{
  filter?: InputMaybe<UsersFilter>;
  interval: TimePeriod;
  dateRange?: InputMaybe<DateRange>;
  groupBy?: InputMaybe<UsersGroupBy>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  programIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  aggregateInTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartnerDashboardProgramMetricsUsersTotalEnteredProgramQuery = { __typename?: 'Query', metrics: { __typename?: 'QueryableMetrics', entity: { __typename?: 'UsersMetrics', metric: Array<{ __typename?: 'Interval', date: any, value: number, group?: string | null }> } } };

export type PartnerDashboardProgramMetricsProgramInfoQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type PartnerDashboardProgramMetricsProgramInfoQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, startDate: any, endDate: any, currentPhase: ProgramPhase, segment: ProgramSegment, requiredMentorTrainingCredential?: string | null } };

export type PartnerDashboardIndividualResourceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type PartnerDashboardIndividualResourceQuery = { __typename?: 'Query', resource?: { __typename?: 'Resource', id: string, name: string, displayName: string, description?: string | null, resourceType: ResourceType } | null, program: { __typename?: 'Program', id: string, resources: { __typename?: 'ResourceConnection', totalCount: number } } };

export type PartnerDashboardGoalsFilterOptionsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type PartnerDashboardGoalsFilterOptionsQuery = { __typename?: 'Query', participantGoals: { __typename?: 'GoalConnection', nodes: Array<{ __typename?: 'Goal', id: string, name: string, identifier: string }> } };

export type PartnerDashboardTopicsFilterOptionsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type PartnerDashboardTopicsFilterOptionsQuery = { __typename?: 'Query', resourceTopics: { __typename?: 'ResourceTopicConnection', nodes?: Array<{ __typename?: 'ResourceTopic', id: string, name: string } | null> | null } };

export type PartnerDashboardResourcesQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProgramResourcesFilter>;
  sort?: InputMaybe<ResourcesSort>;
}>;


export type PartnerDashboardResourcesQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, resources: { __typename?: 'ResourceConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null }, nodes: Array<{ __typename?: 'Resource', description?: string | null, displayName: string, id: string, name: string, topics: Array<{ __typename?: 'ResourceTopic', id: string, name: string, archived: boolean }> }> } } };

export type PartnerDashboardProgramAssessmentAreasQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type PartnerDashboardProgramAssessmentAreasQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, programAssessmentAreas: Array<{ __typename?: 'ProgramAssessmentArea', id: string, scaleMax: number, scaleMin: number, enabledForMentees: boolean, enabledForMentors: boolean, assessmentArea: { __typename?: 'AssessmentArea', id: string, name: string, identifier: AssessmentAreaIdentifier } }> } };

export type ProgramAssessmentSurveysDataQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramAssessmentSurveysDataQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, currentStage: ProgramStage, studentOpeningAssessmentSurvey?: { __typename?: 'Survey', id: string, name: string } | null, studentMidAssessmentSurvey?: { __typename?: 'Survey', id: string, name: string } | null, studentEndAssessmentSurvey?: { __typename?: 'Survey', id: string, name: string } | null, mentorOpeningAssessmentSurvey?: { __typename?: 'Survey', id: string, name: string } | null, mentorMidAssessmentSurvey?: { __typename?: 'Survey', id: string, name: string } | null, mentorEndAssessmentSurvey?: { __typename?: 'Survey', id: string, name: string } | null } };

export type PartnerDashboardProgramProfileAttributesQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  programProfileAttributeCategoriesProgramId: Scalars['MCID']['input'];
}>;


export type PartnerDashboardProgramProfileAttributesQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, programProfileAttributes: Array<{ __typename?: 'ProgramProfileAttribute', id: string, availableInPartnerDashboardFilters: boolean, availableInPartnerDashboardProgramIntelligenceChart: boolean, availableInPartnerDashboardExports: boolean, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null, profileAttributeValues: Array<{ __typename?: 'ProfileAttributeValue', id: string, value: string }> } }> }, programProfileAttributeCategories: Array<{ __typename?: 'ProgramProfileAttributeCategoryResult', profileAttribute: { __typename?: 'ProfileAttribute', id: string }, profileAttributeCategories: Array<{ __typename?: 'ProfileAttributeCategory', id: string }> }> };

export type UserInfoForPartnerSsoLoginQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type UserInfoForPartnerSsoLoginQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, partners: Array<{ __typename?: 'Partner', id: string, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string } } }>, participants: Array<{ __typename?: 'Mentor', id: string } | { __typename?: 'Student', id: string }> }, program: { __typename?: 'Program', id: string, name: string, title: string, shortName: string, defaultProfileImage?: string | null, partnerSuccessManager?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, name: string, logo?: string | null, ssoBrand?: string | null, ssoProviderIdentifier?: string | null } } } };

export type FeatureEnabledForUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  feature: Scalars['String']['input'];
}>;


export type FeatureEnabledForUserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, isFeatureEnabledFor: boolean } };

export type ProgramMatchingSurveyQuestionsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  filter?: InputMaybe<SurveyQuestionFilter>;
}>;


export type ProgramMatchingSurveyQuestionsQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, studentMatchingSurvey: { __typename?: 'Survey', id: string, questions: Array<{ __typename?: 'SurveyQuestion', id: string, index: number, qid?: string | null, customizations?: any | null, questionMdDisplay?: { __typename?: 'SurveyQuestionMdDisplay', id: string, displayName: string } | null, template: { __typename?: 'SurveyQuestionTemplate', id: string, templateId: SurveyQuestionTemplateId } }> }, mentorMatchingSurvey: { __typename?: 'Survey', id: string, questions: Array<{ __typename?: 'SurveyQuestion', id: string, index: number, qid?: string | null, customizations?: any | null, questionMdDisplay?: { __typename?: 'SurveyQuestionMdDisplay', id: string, displayName: string } | null, template: { __typename?: 'SurveyQuestionTemplate', id: string, templateId: SurveyQuestionTemplateId } }> } } };

export type CustomLabelsForProgramQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type CustomLabelsForProgramQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null }, programCustomLabel?: { __typename?: 'ProgramCustomLabel', id: string, singularMentor?: string | null, singularMentorWithIndeterminateArticle?: string | null, pluralMentor?: string | null, respectMentorUppercase?: boolean | null, singularMentee?: string | null, singularMenteeWithIndeterminateArticle?: string | null, pluralMentee?: string | null, respectMenteeUppercase?: boolean | null, singularStudent?: string | null, singularStudentWithIndeterminateArticle?: string | null, pluralStudent?: string | null, respectStudentUppercase?: boolean | null, singularMentorship?: string | null, singularMentorshipWithIndeterminateArticle?: string | null, respectMentorshipUppercase?: boolean | null, pluralMentorship?: string | null, singularSchool?: string | null, singularSchoolWithIndeterminateArticle?: string | null, pluralSchool?: string | null, respectSchoolUppercase?: boolean | null } | null } };

export type SharedCachedProfileDataFieldsFragment = { __typename?: 'CachedUserProfileDataAttributeValue', id: string, values: Array<string>, profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null } };

export type SharedProfileDataFieldsFragment = { __typename?: 'UserProfileData', profileAttribute: { __typename?: 'ProfileAttribute', id: string, name: string, profileAttributeType?: ProfileAttributeType | null }, values: Array<{ __typename?: 'UserProfileAttributeValue', id: string, openResponse?: string | null, profileAttributeValue: { __typename?: 'ProfileAttributeValue', value: string, id: string }, userProfileAttributeValueUpdate: { __typename?: 'UserProfileAttributeValueUpdate', id: string, source: ProfileAttributeSource, createdAt: any } }> };

export type SurveyParticipantDataQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type SurveyParticipantDataQuery = { __typename?: 'Query', participant: { __typename?: 'Mentor', id: string, program: { __typename?: 'Program', id: string, segment: ProgramSegment, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, shortName: string } } } } | { __typename?: 'Student', id: string, program: { __typename?: 'Program', id: string, segment: ProgramSegment, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, shortName: string } } } } };

export type ConversationTopicsQueryVariables = Exact<{
  segment: ProgramSegment;
  programId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
}>;


export type ConversationTopicsQuery = { __typename?: 'Query', conversationTopics: Array<ConversationTopic> };

export type ProgramSegmentQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type ProgramSegmentQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, segment: ProgramSegment, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, shortName: string } } } };

export type CounterpartsQuestionQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type CounterpartsQuestionQuery = { __typename?: 'Query', participant: { __typename: 'Mentor', id: string, mentorships: Array<{ __typename?: 'Mentorship', id: string, student: { __typename: 'Student', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }, mentor: { __typename: 'Mentor', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } }> } | { __typename: 'Student', id: string, mentorships: Array<{ __typename?: 'Mentorship', id: string, student: { __typename: 'Student', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }, mentor: { __typename: 'Mentor', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } }> } };

export type FlagCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<FlagCategoryFilter>;
}>;


export type FlagCategoriesQuery = { __typename?: 'Query', flagCategories: Array<{ __typename?: 'FlagCategory', id: string, name: string, identifier: string, label: string }> };

export type ParticipantSurveyResponsesQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ParticipantSurveyResponsesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, surveyResponses: Array<{ __typename?: 'SurveyResponse', id: string, context: { __typename?: 'SurveyResponseContext', participantId?: string | null, mentorshipChatGroupId?: string | null, mentorshipId?: string | null } }> } };

export type MentorChatGroupsQueryVariables = Exact<{
  mentorId: Scalars['ID']['input'];
}>;


export type MentorChatGroupsQuery = { __typename?: 'Query', mentor: { __typename?: 'Mentor', id: string, mentorships: Array<{ __typename?: 'Mentorship', id: string, isMatched: boolean, chatGroup?: { __typename?: 'MentorshipChatGroup', id: string } | null, student: { __typename?: 'Student', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } }> } };

export type PostSessionSurveyCareerQuestionQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
  mentorshipId: Scalars['ID']['input'];
}>;


export type PostSessionSurveyCareerQuestionQuery = { __typename?: 'Query', participant: { __typename: 'Mentor', id: string, program: { __typename?: 'Program', id: string, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, name: string } } } } | { __typename: 'Student', id: string, program: { __typename?: 'Program', id: string, programSequence: { __typename?: 'ProgramSequence', id: string, school: { __typename?: 'School', id: string, name: string } } } }, mentorship: { __typename?: 'Mentorship', id: string, student: { __typename?: 'Student', id: string, programGoal?: string | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }, mentor: { __typename?: 'Mentor', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } } };

export type SurveyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  participantId?: InputMaybe<Scalars['ID']['input']>;
  surveyCustomRenderOverride?: InputMaybe<SurveyCustomRenderOverride>;
  questionFilter?: InputMaybe<SurveyQuestionFilter>;
}>;


export type SurveyQuery = { __typename?: 'Query', survey: { __typename?: 'Survey', id: string, name: string, description?: string | null, surveyType?: SurveyType | null, questions: Array<{ __typename?: 'SurveyQuestion', id: string, qid?: string | null, index: number, customizations?: any | null, createdInAdminTool: boolean, template: { __typename?: 'SurveyQuestionTemplate', id: string, templateId: SurveyQuestionTemplateId } }> } };

export type SaveSurveyResponseMutationVariables = Exact<{
  inputResponse: SurveyResponseInput;
}>;


export type SaveSurveyResponseMutation = { __typename?: 'Mutation', saveSurveyResponse?: { __typename?: 'SaveSurveyResponsePayload', errors: Array<InvalidSurveyResponseInputError>, response?: { __typename?: 'SurveyResponse', id: string, context: { __typename?: 'SurveyResponseContext', participantId?: string | null, mentorshipId?: string | null, mentorshipChatGroupId?: string | null } } | null, user: { __typename?: 'User', id: string, participants: Array<{ __typename?: 'Mentor', id: string, mentorships: Array<{ __typename?: 'Mentorship', id: string, studentIsDisengaged: boolean, mentorIsDisengaged: boolean, mentorConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, studentConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }> }>, surveyResponses: Array<{ __typename?: 'SurveyResponse', id: string, survey: { __typename?: 'Survey', id: string } }> } | { __typename?: 'Student', id: string, mentorships: Array<{ __typename?: 'Mentorship', id: string, studentIsDisengaged: boolean, mentorIsDisengaged: boolean, mentorConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, studentConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }> }>, surveyResponses: Array<{ __typename?: 'SurveyResponse', id: string, survey: { __typename?: 'Survey', id: string } }> }>, surveyResponses: Array<{ __typename?: 'SurveyResponse', id: string, survey: { __typename?: 'Survey', id: string } }> } } | null };

export type UserInfoForAdminAnalyticsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserInfoForAdminAnalyticsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, email?: string | null, firstName: string, lastName: string, createdAt?: any | null, activeShearwaterAdministrator?: { __typename?: 'ShearwaterAdministrator', id: string, updatedAt: any, deactivatedAt?: any | null } | null } };

export type UserInfoForAnalyticsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type UserInfoForAnalyticsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, email?: string | null, isPartner: boolean, isAdmin: boolean, firstName: string, lastName: string, createdAt?: any | null, partners: Array<{ __typename?: 'Partner', id: string, organizationType?: OrganizationType | null, higherEdCategory?: HigherEdCategory | null, higherEdRole?: HigherEdRole | null, programSequence: { __typename?: 'ProgramSequence', id: string, name: string, school: { __typename?: 'School', id: string }, programs: Array<{ __typename?: 'Program', id: string, startDate: any, endDate: any }> } }>, participants: Array<{ __typename?: 'Mentor', id: string, registrationDate: any, program: { __typename?: 'Program', id: string } } | { __typename?: 'Student', id: string, registrationDate: any, program: { __typename?: 'Program', id: string } }> }, program: { __typename?: 'Program', id: string, name: string, currentPhase: ProgramPhase, endDate: any, startDate: any, flagContactEmail?: string | null, secondaryFlagContactCcEmails?: string | null, matchingCap?: number | null, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null, programs: Array<{ __typename?: 'Program', id: string, createdAt: any, startDate: any, endDate: any }>, school: { __typename?: 'School', id: string, name: string, publicOrPrivate?: PublicOrPrivate | null, isMinorityServingInstitution?: boolean | null, twoOrFourYear?: HigherEducation | null } } } };

export type ParticipantUserInfoForAnalyticsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ParticipantUserInfoForAnalyticsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, email?: string | null, isPartner: boolean, isAdmin: boolean, firstName: string, lastName: string, createdAt?: any | null, contacts: Array<{ __typename?: 'MentorContact', id: string } | { __typename?: 'StudentContact', id: string }>, participants: Array<{ __typename: 'Mentor', id: string, registrationDate: any, registered: boolean, mentorships: Array<{ __typename?: 'Mentorship', id: string, matchDate: any, isMatched: boolean, mentorConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, studentConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, student: { __typename?: 'Student', id: string }, mentor: { __typename?: 'Mentor', id: string }, flags: { __typename?: 'FlagConnection', totalCount: number } }>, program: { __typename?: 'Program', id: string, startDate: any, endDate: any, currentPhase: ProgramPhase, currentStage: ProgramStage, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null, school: { __typename?: 'School', id: string } } } } | { __typename: 'Student', id: string, registrationDate: any, registered: boolean, mentorships: Array<{ __typename?: 'Mentorship', id: string, matchDate: any, isMatched: boolean, mentorConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, studentConversationLogs: Array<{ __typename?: 'ConversationLog', id: string }>, student: { __typename?: 'Student', id: string }, mentor: { __typename?: 'Mentor', id: string }, flags: { __typename?: 'FlagConnection', totalCount: number } }>, program: { __typename?: 'Program', id: string, startDate: any, endDate: any, currentPhase: ProgramPhase, currentStage: ProgramStage, programSequence: { __typename?: 'ProgramSequence', id: string, higherEdSegment?: ProgramSegment | null, school: { __typename?: 'School', id: string } } } }> } };

export type CachedParticipantSurveyResponsesQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
  context?: InputMaybe<SurveyResponseContextFilter>;
}>;


export type CachedParticipantSurveyResponsesQuery = { __typename?: 'Query', participant: { __typename?: 'Mentor', id: string, surveyResponses: Array<{ __typename?: 'SurveyResponse', id: string }> } | { __typename?: 'Student', id: string, surveyResponses: Array<{ __typename?: 'SurveyResponse', id: string }> } };

export const ProgramFieldsForAdminDashboardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"programFieldsForAdminDashboard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Program"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"allowMenteeSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"allowMentorSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"currentPhase"}},{"kind":"Field","name":{"kind":"Name","value":"alertDismissals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alertTypeIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"alertMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"snoozeUntil"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessOperator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfactionReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programSatisfaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorAverage"}},{"kind":"Field","name":{"kind":"Name","value":"studentAverage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"segmentSatisfaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorAverage"}},{"kind":"Field","name":{"kind":"Name","value":"studentAverage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousProgramSatisfaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorAverage"}},{"kind":"Field","name":{"kind":"Name","value":"studentAverage"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentlyMatchedStudents"},"name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currentlyMatched"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ProgramFieldsForAdminDashboardFragment, unknown>;
export const ProgramFieldsForAdminDashboardAllProgramsListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"programFieldsForAdminDashboardAllProgramsList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Program"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currentPhase"}},{"kind":"Field","name":{"kind":"Name","value":"allowMenteeSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"allowMentorSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"alertDismissals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alertTypeIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"alertMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"snoozeUntil"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessOperator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentlyMatchedStudents"},"name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currentlyMatched"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ProgramFieldsForAdminDashboardAllProgramsListFragment, unknown>;
export const SharedProfileDataFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<SharedProfileDataFieldsFragment, unknown>;
export const UserProfileDataFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileDataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<UserProfileDataFragmentFragment, unknown>;
export const SharedCachedProfileDataFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedCachedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}}]} as unknown as DocumentNode<SharedCachedProfileDataFieldsFragment, unknown>;
export const MatchingProfileDataFieldsWithCustomFallbacksFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataMajor"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataTransferStatus"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataSupermentorOptIn"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedCachedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}}]} as unknown as DocumentNode<MatchingProfileDataFieldsWithCustomFallbacksFragment, unknown>;
export const MentorUserProfileDataFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MentorUserProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"user"}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_age"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_school_position"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"within_institution"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"all_programs"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"none"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":true}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataMentorCapacity"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedCachedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataMajor"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataTransferStatus"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataSupermentorOptIn"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<MentorUserProfileDataFieldsFragment, unknown>;
export const StudentUserProfileDataFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StudentUserProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menteeAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menteeCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"user"}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_age"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_grade_level"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"within_institution"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"all_programs"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"none"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":true}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedCachedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataMajor"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataTransferStatus"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataSupermentorOptIn"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<StudentUserProfileDataFieldsFragment, unknown>;
export const ParticipantDashboardHomeCallToActionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParticipantDashboardHomeCallToActionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSignInAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMentorInChatGroup"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"completedMatchingSurveyAt"}},{"kind":"Field","name":{"kind":"Name","value":"pushedThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"prioritizedAndPendingForRematching"}},{"kind":"Field","name":{"kind":"Name","value":"matchingLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mentor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allowedToSkipMatchingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"requiredTrainingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"mentorTrainingCourseLink"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMatched"}},{"kind":"Field","name":{"kind":"Name","value":"matchDate"}},{"kind":"Field","name":{"kind":"Name","value":"unmatchDate"}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantDashboardHomeCallToActionFragmentFragment, unknown>;
export const ParticipantProfileDataFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParticipantProfileDataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantProfileDataFragmentFragment, unknown>;
export const UserNameFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserNameFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<UserNameFragmentFragment, unknown>;
export const MentorshipDetailsUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MentorshipDetailsUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInUrl"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<MentorshipDetailsUserFragment, unknown>;
export const MessageTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MessageTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}}]}}]}}]} as unknown as DocumentNode<MessageTemplateQuery, MessageTemplateQueryVariables>;
export const AllProgramsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllProgramsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AllProgramsListQuery, AllProgramsListQueryVariables>;
export const DistinctParticipantsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distinctParticipantsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCountOfDistinctUsers"}}]}}]}}]} as unknown as DocumentNode<DistinctParticipantsCountQuery, DistinctParticipantsCountQueryVariables>;
export const DistinctContactsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distinctContactsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCountOfDistinctUsers"}}]}}]}}]} as unknown as DocumentNode<DistinctContactsCountQuery, DistinctContactsCountQueryVariables>;
export const DistinctPartnersCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distinctPartnersCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"programIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCountOfDistinctUsers"}}]}}]}}]} as unknown as DocumentNode<DistinctPartnersCountQuery, DistinctPartnersCountQueryVariables>;
export const DistinctAdminUsersCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"distinctAdminUsersCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isAdmin"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<DistinctAdminUsersCountQuery, DistinctAdminUsersCountQueryVariables>;
export const CreateNewOutreachTopicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewOutreachTopic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTopicInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTopic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createTopicInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateNewOutreachTopicMutation, CreateNewOutreachTopicMutationVariables>;
export const UpdateOutreachTopicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOutreachTopic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTopicInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTopic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updatedTopicInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"programSegment"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"topicMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"hoursDelayAfterMessage"}},{"kind":"Field","name":{"kind":"Name","value":"preferredMedium"}},{"kind":"Field","name":{"kind":"Name","value":"emailTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"smsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"topicConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOutreachTopicMutation, UpdateOutreachTopicMutationVariables>;
export const EditCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EditCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outreachTopic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"programSegment"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"topicMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"hoursDelayAfterMessage"}},{"kind":"Field","name":{"kind":"Name","value":"preferredMedium"}},{"kind":"Field","name":{"kind":"Name","value":"emailTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"smsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"topicConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<EditCampaignQuery, EditCampaignQueryVariables>;
export const CampaignsListTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CampaignsListTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outreachTopics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CampaignsListTotalsQuery, CampaignsListTotalsQueryVariables>;
export const CampaignsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CampaignsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TopicsSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TopicsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outreachTopics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"programSegment"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"topicConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programTopics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topicMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"hoursDelayAfterMessage"}},{"kind":"Field","name":{"kind":"Name","value":"preferredMedium"}},{"kind":"Field","name":{"kind":"Name","value":"emailTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"smsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CampaignsListQuery, CampaignsListQueryVariables>;
export const IndividualCampaignProgramsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IndividualCampaignPrograms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TopicsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outreachTopics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programTopics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessOperator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IndividualCampaignProgramsQuery, IndividualCampaignProgramsQueryVariables>;
export const UserStateVariablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserStateVariables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userState"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserState"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterList"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserStateFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userStateVariables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userState"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userState"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterList"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterList"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"previewValue"}}]}}]}}]} as unknown as DocumentNode<UserStateVariablesQuery, UserStateVariablesQueryVariables>;
export const CreateEmailTemplateSavedRowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEmailTemplateSavedRow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateEmailTemplateSavedRowInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEmailTemplateSavedRow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newRowInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailTemplateSavedRow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"templateEditorData"}}]}}]}}]}}]} as unknown as DocumentNode<CreateEmailTemplateSavedRowMutation, CreateEmailTemplateSavedRowMutationVariables>;
export const AllActiveProgramsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllActiveProgramsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AllActiveProgramsListQuery, AllActiveProgramsListQueryVariables>;
export const CustomMessageTypeTemplateRequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomMessageTypeTemplateRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customMessageTypeTemplateRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageType"}},{"kind":"Field","name":{"kind":"Name","value":"messageCategory"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}}]}}]}}]}}]} as unknown as DocumentNode<CustomMessageTypeTemplateRequirementsQuery, CustomMessageTypeTemplateRequirementsQueryVariables>;
export const TemplateDetailsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplateDetailsData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplateTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"skeletonMessageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"templateEditorData"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<TemplateDetailsDataQuery, TemplateDetailsDataQueryVariables>;
export const CreateMessageTemplateTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMessageTemplateTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMessageTemplateTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplateTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMessageTemplateTagMutation, CreateMessageTemplateTagMutationVariables>;
export const CreateSkeletonMessageTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSkeletonMessageTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateEditorData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSkeletonMessageTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skeletonMessageTemplateInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"templateEditorData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateEditorData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skeletonMessageTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"templateEditorData"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSkeletonMessageTemplateMutation, CreateSkeletonMessageTemplateMutationVariables>;
export const SendBulkMessageByCsvDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendBulkMessageByCsv"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"File"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendBulkMessageByCsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"templateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"batchActionId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<SendBulkMessageByCsvMutation, SendBulkMessageByCsvMutationVariables>;
export const SendTestMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendTestMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendTestMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"templateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<SendTestMessageMutation, SendTestMessageMutationVariables>;
export const CreateMessageTemplateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateMessageTemplateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]} as unknown as DocumentNode<CreateMessageTemplateUserQuery, CreateMessageTemplateUserQueryVariables>;
export const CreateSmsTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSmsTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smsTemplateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSmsTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSmsTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createSmsTemplateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smsTemplateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"programSegment"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageType"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateSmsTemplateMutation, CreateSmsTemplateMutationVariables>;
export const CreateEmailTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEmailTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateEmailTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEmailTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createEmailTemplateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"programSegment"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageType"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"templateEditorData"}},{"kind":"Field","name":{"kind":"Name","value":"subjectLine"}},{"kind":"Field","name":{"kind":"Name","value":"preheaderText"}}]}}]}}]}}]} as unknown as DocumentNode<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>;
export const EditMessageTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EditMessageTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"programSegment"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageType"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateEditorData"}},{"kind":"Field","name":{"kind":"Name","value":"subjectLine"}},{"kind":"Field","name":{"kind":"Name","value":"preheaderText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<EditMessageTemplateQuery, EditMessageTemplateQueryVariables>;
export const UpdateEmailTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEmailTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEmailTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmailTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updatedEmailTemplateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"programSegment"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageType"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"templateEditorData"}},{"kind":"Field","name":{"kind":"Name","value":"subjectLine"}},{"kind":"Field","name":{"kind":"Name","value":"preheaderText"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>;
export const UpdateSmsTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSmsTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSmsTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSmsTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updatedSmsTemplateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"programSegment"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageType"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSmsTemplateMutation, UpdateSmsTemplateMutationVariables>;
export const MessageTemplateTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"messageTemplateTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplateTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MessageTemplateTagsQuery, MessageTemplateTagsQueryVariables>;
export const AddMessageTemplatesTagsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addMessageTemplatesTagsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagsToCreate"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addMessageTemplatesTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagsToCreate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagsToCreate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddMessageTemplatesTagsByIdsMutation, AddMessageTemplatesTagsByIdsMutationVariables>;
export const AddMessageTemplatesTagsByFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addMessageTemplatesTagsByFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageTemplatesFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagsToCreate"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addMessageTemplatesTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byFilterSelection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagsToCreate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagsToCreate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddMessageTemplatesTagsByFiltersMutation, AddMessageTemplatesTagsByFiltersMutationVariables>;
export const DuplicateTemplatesInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DuplicateTemplatesInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageTemplatesFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplateTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"messageTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"tagCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<DuplicateTemplatesInfoQuery, DuplicateTemplatesInfoQueryVariables>;
export const DuplicateMessageTemplatesFromIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateMessageTemplatesFromIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIdsToAdd"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIdsToRemove"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDefault"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateMessageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagIdsToAdd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIdsToAdd"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagIdsToRemove"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIdsToRemove"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDefault"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDefault"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newMessageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DuplicateMessageTemplatesFromIdsMutation, DuplicateMessageTemplatesFromIdsMutationVariables>;
export const DuplicateMessageTemplatesFromFilterSelectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateMessageTemplatesFromFilterSelection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageTemplatesFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIdsToAdd"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIdsToRemove"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDefault"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateMessageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byFilterSelection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagIdsToAdd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIdsToAdd"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagIdsToRemove"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIdsToRemove"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDefault"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDefault"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newMessageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DuplicateMessageTemplatesFromFilterSelectionMutation, DuplicateMessageTemplatesFromFilterSelectionMutationVariables>;
export const MessageTemplateTagsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MessageTemplateTagsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageTemplatesFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"tagCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<MessageTemplateTagsCountQuery, MessageTemplateTagsCountQueryVariables>;
export const RemoveMessageTemplatesTagsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeMessageTemplatesTagsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMessageTemplatesTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveMessageTemplatesTagsByIdsMutation, RemoveMessageTemplatesTagsByIdsMutationVariables>;
export const RemoveMessageTemplatesTagsByFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeMessageTemplatesTagsByFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageTemplatesFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMessageTemplatesTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byFilterSelection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveMessageTemplatesTagsByFiltersMutation, RemoveMessageTemplatesTagsByFiltersMutationVariables>;
export const MessageTemplatesListTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MessageTemplatesListTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"tagCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<MessageTemplatesListTotalsQuery, MessageTemplatesListTotalsQueryVariables>;
export const MessageTemplatesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MessageTemplatesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageTemplatesFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageTemplatesSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"programSegment"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"lastEditedAt"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}}]}}]}}]}}]} as unknown as DocumentNode<MessageTemplatesListQuery, MessageTemplatesListQueryVariables>;
export const ArchiveRestoreMessageTemplatesByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"archiveRestoreMessageTemplatesByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"setArchived"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveRestoreMessageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"setArchived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"setArchived"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ArchiveRestoreMessageTemplatesByIdsMutation, ArchiveRestoreMessageTemplatesByIdsMutationVariables>;
export const ArchiveRestoreMessageTemplatesByFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"archiveRestoreMessageTemplatesByFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageTemplatesFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"setArchived"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveRestoreMessageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byFilterSelection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"setArchived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"setArchived"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ArchiveRestoreMessageTemplatesByFiltersMutation, ArchiveRestoreMessageTemplatesByFiltersMutationVariables>;
export const ActiveCampaignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActiveCampaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outreachTopics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topicMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"smsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActiveCampaignsQuery, ActiveCampaignsQueryVariables>;
export const MatchedUsersReportExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MatchedUsersReportExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enrollment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csvExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchedUsersReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"enrollment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enrollment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<MatchedUsersReportExportQuery, MatchedUsersReportExportQueryVariables>;
export const MenteeMentorQuotesExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MenteeMentorQuotesExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"analyzeSentiment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csvExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menteeMentorQuotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"analyzeSentiment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"analyzeSentiment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<MenteeMentorQuotesExportQuery, MenteeMentorQuotesExportQueryVariables>;
export const SurveyResponsesExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveyResponsesExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeProgramProfileData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"context"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvExportContextInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csvExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyResponses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeProgramProfileData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeProgramProfileData"}}},{"kind":"Argument","name":{"kind":"Name","value":"csvExportContext"},"value":{"kind":"Variable","name":{"kind":"Name","value":"context"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]}}]} as unknown as DocumentNode<SurveyResponsesExportQuery, SurveyResponsesExportQueryVariables>;
export const WrittenTestimonialsExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WrittenTestimonialsExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"analyzeSentiment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csvExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writtenTestimonials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"analyzeSentiment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"analyzeSentiment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<WrittenTestimonialsExportQuery, WrittenTestimonialsExportQueryVariables>;
export const UserLogoForAdminHeaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserLogoForAdminHeader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarHeight"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarWidth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarHeight"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarWidth"}}}]}}]}]}}]}}]}}]} as unknown as DocumentNode<UserLogoForAdminHeaderQuery, UserLogoForAdminHeaderQueryVariables>;
export const DismissProgramAlertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissProgramAlert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramAlertDismissalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissProgramAlert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dismissalInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alertDismissals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alertTypeIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"snoozeUntil"}},{"kind":"Field","name":{"kind":"Name","value":"alertMetadata"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DismissProgramAlertMutation, DismissProgramAlertMutationVariables>;
export const ReactivateProgramAlertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReactivateProgramAlert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alertTypeIdentifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reactivateProgramAlert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"alertTypeIdentifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alertTypeIdentifier"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alertDismissals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alertTypeIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"snoozeUntil"}},{"kind":"Field","name":{"kind":"Name","value":"alertMetadata"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReactivateProgramAlertMutation, ReactivateProgramAlertMutationVariables>;
export const ProgramInfoForAdminDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramInfoForAdminDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"programsAsPSO"},"name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"partnerSuccessOperatorIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"userId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"programFieldsForAdminDashboard"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"programsAsPSM"},"name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"partnerSuccessManagerIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"userId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"programFieldsForAdminDashboard"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"programFieldsForAdminDashboard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Program"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"allowMenteeSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"allowMentorSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"currentPhase"}},{"kind":"Field","name":{"kind":"Name","value":"alertDismissals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alertTypeIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"alertMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"snoozeUntil"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessOperator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"satisfactionReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programSatisfaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorAverage"}},{"kind":"Field","name":{"kind":"Name","value":"studentAverage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"segmentSatisfaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorAverage"}},{"kind":"Field","name":{"kind":"Name","value":"studentAverage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousProgramSatisfaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorAverage"}},{"kind":"Field","name":{"kind":"Name","value":"studentAverage"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentlyMatchedStudents"},"name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currentlyMatched"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ProgramInfoForAdminDashboardQuery, ProgramInfoForAdminDashboardQueryVariables>;
export const AdminPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeShearwaterAdministrator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}}]}}]}}]}}]} as unknown as DocumentNode<AdminPermissionsQuery, AdminPermissionsQueryVariables>;
export const TargetingCriteriaUserCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TargetingCriteriaUserCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCountOfDistinctUsers"}}]}}]}}]} as unknown as DocumentNode<TargetingCriteriaUserCountQuery, TargetingCriteriaUserCountQueryVariables>;
export const ProgramSelectDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramSelectData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ProgramSelectDataQuery, ProgramSelectDataQueryVariables>;
export const CreateMicroSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMicroSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMicroSurveyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMicroSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"microSurveyInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"microSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customizations"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"targetingCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludeProgramIds"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"engaged"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateMicroSurveyMutation, CreateMicroSurveyMutationVariables>;
export const ManageMicroSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ManageMicroSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"microSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customizations"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"targetingCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludeProgramIds"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"engaged"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ManageMicroSurveyQuery, ManageMicroSurveyQueryVariables>;
export const UpdateMicroSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMicroSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMicroSurveyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMicroSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"microSurvey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"microSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customizations"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"targetingCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludeProgramIds"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"engaged"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMicroSurveyMutation, UpdateMicroSurveyMutationVariables>;
export const AllMicroSurveysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllMicroSurveys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MicroSurveysFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MicroSurveysSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"microSurveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}}]}}]}}]}}]} as unknown as DocumentNode<AllMicroSurveysQuery, AllMicroSurveysQueryVariables>;
export const UpdateCourseNewTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCourseNewTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateCourseNewTaskInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCourseNewTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCourseNewTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateCourseNewTaskInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateCourseNewTaskInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"segmentTags"}},{"kind":"Field","name":{"kind":"Name","value":"internalTaskName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssigneeEntity"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipCredential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credential"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CourseTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCourseNewTaskMutation, UpdateCourseNewTaskMutationVariables>;
export const UpdateClickLinkNewTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClickLinkNewTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateClickLinkNewTaskInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateClickLinkNewTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClickLinkNewTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateClickLinkNewTaskInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateClickLinkNewTaskInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"segmentTags"}},{"kind":"Field","name":{"kind":"Name","value":"internalTaskName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssigneeEntity"}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateClickLinkNewTaskMutation, UpdateClickLinkNewTaskMutationVariables>;
export const NewTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"segmentTags"}},{"kind":"Field","name":{"kind":"Name","value":"internalTaskName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssigneeEntity"}},{"kind":"Field","name":{"kind":"Name","value":"requiredForMatching"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipCredential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credential"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CourseTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewTaskQuery, NewTaskQueryVariables>;
export const NewTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NewTasksFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NewTasksSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalTaskName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssigneeEntity"}},{"kind":"Field","name":{"kind":"Name","value":"requiredForMatching"}},{"kind":"Field","name":{"kind":"Name","value":"segmentTags"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipCredential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credential"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CourseTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentSurveyTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"programStage"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewTasksQuery, NewTasksQueryVariables>;
export const AdminDashboardAllProgramsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardAllProgramsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramsSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"programFieldsForAdminDashboardAllProgramsList"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"programFieldsForAdminDashboardAllProgramsList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Program"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currentPhase"}},{"kind":"Field","name":{"kind":"Name","value":"allowMenteeSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"allowMentorSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"alertDismissals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alertTypeIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"alertMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"snoozeUntil"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessOperator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentlyMatchedStudents"},"name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currentlyMatched"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AdminDashboardAllProgramsListQuery, AdminDashboardAllProgramsListQueryVariables>;
export const UpdateSchoolInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSchoolInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSchoolInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSchoolInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"schoolInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"institutionType"}},{"kind":"Field","name":{"kind":"Name","value":"institutionRegion"}},{"kind":"Field","name":{"kind":"Name","value":"isMinorityServingInstitution"}},{"kind":"Field","name":{"kind":"Name","value":"twoOrFourYear"}},{"kind":"Field","name":{"kind":"Name","value":"publicOrPrivate"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSchoolInfoMutation, UpdateSchoolInfoMutationVariables>;
export const AdminDashboardSchoolInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardSchoolInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"schoolId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"school"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"schoolId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"institutionType"}},{"kind":"Field","name":{"kind":"Name","value":"institutionRegion"}},{"kind":"Field","name":{"kind":"Name","value":"isMinorityServingInstitution"}},{"kind":"Field","name":{"kind":"Name","value":"twoOrFourYear"}},{"kind":"Field","name":{"kind":"Name","value":"publicOrPrivate"}},{"kind":"Field","name":{"kind":"Name","value":"ssoBrand"}},{"kind":"Field","name":{"kind":"Name","value":"ssoEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"ssoTestingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"ssoRequiredForPartners"}},{"kind":"Field","name":{"kind":"Name","value":"ssoProviderIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"programSequences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"mentorLoginMode"}},{"kind":"Field","name":{"kind":"Name","value":"menteeLoginMode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardSchoolInfoQuery, AdminDashboardSchoolInfoQueryVariables>;
export const UpdateSsoConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSsoConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSchoolInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSchoolInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"schoolInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ssoEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"ssoTestingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"ssoProviderIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"ssoRequiredForPartners"}},{"kind":"Field","name":{"kind":"Name","value":"ssoBrand"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSsoConfigurationMutation, UpdateSsoConfigurationMutationVariables>;
export const SendSsoTestingTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendSsoTestingTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"schoolId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendSsoTestingTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"schoolId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"schoolId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programSequenceId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SendSsoTestingTemplateMutation, SendSsoTestingTemplateMutationVariables>;
export const LatestSsoSessionDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LatestSsoSessionData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"schoolId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"school"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"schoolId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"omniauthCredentialLatestSessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"institutionId"}},{"kind":"Field","name":{"kind":"Name","value":"lastAuthAt"}}]}}]}}]}}]} as unknown as DocumentNode<LatestSsoSessionDataQuery, LatestSsoSessionDataQueryVariables>;
export const AdminDashboardSchoolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardSchool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"school"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"institutionType"}},{"kind":"Field","name":{"kind":"Name","value":"nameOfSchoolIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"programSequences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardSchoolQuery, AdminDashboardSchoolQueryVariables>;
export const AllSchoolsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllSchools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AllSchoolsQuery, AllSchoolsQueryVariables>;
export const AdminDashboardProgramSequenceDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardProgramSequenceDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programSequenceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programSequences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"programSequenceId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"urlSlug"}},{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardProgramSequenceDetailsQuery, AdminDashboardProgramSequenceDetailsQueryVariables>;
export const UpdateProgramSequenceInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramSequenceInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramSequenceInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramSequenceInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programSequenceInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"urlSlug"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramSequenceInfoMutation, UpdateProgramSequenceInfoMutationVariables>;
export const CreateProgramSequenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProgramSequence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProgramSequenceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProgramSequence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programSequenceInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProgramSequenceMutation, CreateProgramSequenceMutationVariables>;
export const AdminDashboardSchoolProgramSequencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardSchoolProgramSequences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramSequencesFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramSequencesSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programSequences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"urlSlug"}},{"kind":"Field","name":{"kind":"Name","value":"menteeRecruitmentLink"}},{"kind":"Field","name":{"kind":"Name","value":"mentorRecruitmentLink"}},{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardSchoolProgramSequencesQuery, AdminDashboardSchoolProgramSequencesQueryVariables>;
export const DeleteProgramSequenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProgramSequence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProgramSequence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeleteProgramSequenceMutation, DeleteProgramSequenceMutationVariables>;
export const DuplicateProgramSequenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateProgramSequence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateProgramSequence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DuplicateProgramSequenceMutation, DuplicateProgramSequenceMutationVariables>;
export const CreateProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProgramInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"isTestProgram"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplateProgram"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateProgramMutation, CreateProgramMutationVariables>;
export const AdminUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isAdmin"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<AdminUsersQuery, AdminUsersQueryVariables>;
export const UpdateProgramAdminsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramAdmins"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramAdminsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramAdmins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programAdmins"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessOperator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"universityRelationsDirector"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramAdminsMutation, UpdateProgramAdminsMutationVariables>;
export const CreatePartnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePartner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePartnerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPartner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePartnerMutation, CreatePartnerMutationVariables>;
export const AdminDashboardCheckIfUserExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardCheckIfUserExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primaryEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardCheckIfUserExistsQuery, AdminDashboardCheckIfUserExistsQueryVariables>;
export const UpdateProgramFlagEmailPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramFlagEmailPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nonPriorityFlagEmailEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramFlagEmailPreferencesMutation, UpdateProgramFlagEmailPreferencesMutationVariables>;
export const UpdateProgramFlagEmailPreferencesProgramTopicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramFlagEmailPreferencesProgramTopic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramTopicInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramTopic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateProgramTopicInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programTopic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramFlagEmailPreferencesProgramTopicMutation, UpdateProgramFlagEmailPreferencesProgramTopicMutationVariables>;
export const UpdateProgramFlagContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramFlagContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramFlagContactsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramFlagContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programFlagContacts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flagContactFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"flagContactLastName"}},{"kind":"Field","name":{"kind":"Name","value":"flagContactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryFlagContactCcEmails"}},{"kind":"Field","name":{"kind":"Name","value":"sendFlagsToExternalContact"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramFlagContactsMutation, UpdateProgramFlagContactsMutationVariables>;
export const FlagContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FlagContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"flagCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<FlagContactsQuery, FlagContactsQueryVariables>;
export const DeleteFlagContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFlagContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFlagContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeleteFlagContactMutation, DeleteFlagContactMutationVariables>;
export const UpdateMentorPointPersonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMentorPointPerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramPointPeopleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramPointPeople"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programPointPeople"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentorPointPersonTitle"}},{"kind":"Field","name":{"kind":"Name","value":"mentorPointPersonFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"mentorPointPersonLastName"}},{"kind":"Field","name":{"kind":"Name","value":"mentorPointPersonEmail"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMentorPointPersonMutation, UpdateMentorPointPersonMutationVariables>;
export const CreateFlagContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFlagContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFlagContactInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFlagContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"flagContactInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"flagCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateFlagContactMutation, CreateFlagContactMutationVariables>;
export const UpdateFlagContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFlagContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagContactInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFlagContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"flagContactInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"flagCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateFlagContactMutation, UpdateFlagContactMutationVariables>;
export const UpdateStudentPointPersonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStudentPointPerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramPointPeopleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramPointPeople"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programPointPeople"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"studentPointPersonTitle"}},{"kind":"Field","name":{"kind":"Name","value":"studentPointPersonFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"studentPointPersonLastName"}},{"kind":"Field","name":{"kind":"Name","value":"studentPointPersonEmail"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateStudentPointPersonMutation, UpdateStudentPointPersonMutationVariables>;
export const AdminDashboardProgramAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardProgramAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"relatedProgramSequences"},"name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"studentPointPersonTitle"}},{"kind":"Field","name":{"kind":"Name","value":"studentPointPersonFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"studentPointPersonLastName"}},{"kind":"Field","name":{"kind":"Name","value":"studentPointPersonEmail"}},{"kind":"Field","name":{"kind":"Name","value":"mentorPointPersonTitle"}},{"kind":"Field","name":{"kind":"Name","value":"mentorPointPersonFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"mentorPointPersonLastName"}},{"kind":"Field","name":{"kind":"Name","value":"mentorPointPersonEmail"}},{"kind":"Field","name":{"kind":"Name","value":"flagContactFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"flagContactLastName"}},{"kind":"Field","name":{"kind":"Name","value":"flagContactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryFlagContactCcEmails"}},{"kind":"Field","name":{"kind":"Name","value":"sendFlagsToExternalContact"}},{"kind":"Field","name":{"kind":"Name","value":"nonPriorityFlagEmailEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessOperator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"universityRelationsDirector"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"programTopics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardProgramAdminQuery, AdminDashboardProgramAdminQueryVariables>;
export const UnmatchParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnmatchParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"File"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unmatchReason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnmatchReason"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unmatchNotes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendUnmatchEmails"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unmatchParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"unmatchReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unmatchReason"}}},{"kind":"Argument","name":{"kind":"Name","value":"unmatchNotes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unmatchNotes"}}},{"kind":"Argument","name":{"kind":"Name","value":"sendUnmatchEmails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendUnmatchEmails"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchActionId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UnmatchParticipantsMutation, UnmatchParticipantsMutationVariables>;
export const UpdateParticipantsMatchingLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateParticipantsMatchingLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"File"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"action"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MatchingLabelAction"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"labelKinds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MatchingLabelKindTypes"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateParticipantsMatchingLabels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"Variable","name":{"kind":"Name","value":"action"}}},{"kind":"Argument","name":{"kind":"Name","value":"labelKinds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"labelKinds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchActionId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateParticipantsMatchingLabelsMutation, UpdateParticipantsMatchingLabelsMutationVariables>;
export const CreateProgramAutomatchingDefaultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProgramAutomatchingDefault"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"automatchingDefaultId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProgramAutomatchingDefault"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"automatchingDefaultId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"automatchingDefaultId"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programAutomatchingDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"automatchingDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchingCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithoutTraining"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithoutMatchingSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithoutMatchingSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"sharedTransferStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesUnder17"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithFreeResponses"}},{"kind":"Field","name":{"kind":"Name","value":"requireMenteeSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"requireMentorSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentMenteeMatchingCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"onlyEnrollmentOptInMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeAvailableToMatchEnrollmentMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithMentorships"}},{"kind":"Field","name":{"kind":"Name","value":"includeEverMatchedEnrollmentMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWhoHaveBeenUnmatched"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWhoHaveBeenUnmatched"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWhoArePushedThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWhoArePushedThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"hardMatchQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectHardMatchQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleSelectHardMatchQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"autoMatchingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"standardScoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"supermentorScoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"mentorCapacityCap"}},{"kind":"Field","name":{"kind":"Name","value":"standardMatching"}},{"kind":"Field","name":{"kind":"Name","value":"supermentorMatching"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupMatchingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minGroupSize"}},{"kind":"Field","name":{"kind":"Name","value":"maxGroupSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProgramAutomatchingDefaultMutation, CreateProgramAutomatchingDefaultMutationVariables>;
export const AutomatchingDefaultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutomatchingDefaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"automatchingDefaults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<AutomatchingDefaultsQuery, AutomatchingDefaultsQueryVariables>;
export const AutoSuggestMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AutoSuggestMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AutoSuggestMatchesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoSuggestMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"autoMatchOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batchId"}}]}}]}}]} as unknown as DocumentNode<AutoSuggestMatchesMutation, AutoSuggestMatchesMutationVariables>;
export const SuggestedBatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SuggestedBatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SuggestedBatchFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SuggestedBatchSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestedBatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"strategyType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"adminUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchingCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sharedMajor"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithoutTraining"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithoutMatchingSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithoutMatchingSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"sharedTransferStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesUnder17"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithFreeResponses"}},{"kind":"Field","name":{"kind":"Name","value":"requireMenteeSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"requireMentorSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentMenteeMatchingCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"onlyEnrollmentOptInMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeAvailableToMatchEnrollmentMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithMentorships"}},{"kind":"Field","name":{"kind":"Name","value":"includeEverMatchedEnrollmentMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWhoHaveBeenUnmatched"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWhoHaveBeenUnmatched"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWhoArePushedThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWhoArePushedThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"hardMatchQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectHardMatchQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleSelectHardMatchQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionsWeights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}},{"kind":"Field","name":{"kind":"Name","value":"autoMatchingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"supermentorScoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"standardScoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"mentorCapacityCap"}},{"kind":"Field","name":{"kind":"Name","value":"supermentorMatching"}},{"kind":"Field","name":{"kind":"Name","value":"standardMatching"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupMatchingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxGroupSize"}},{"kind":"Field","name":{"kind":"Name","value":"minGroupSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"overview"}}]}}]}}]}}]} as unknown as DocumentNode<SuggestedBatchesQuery, SuggestedBatchesQueryVariables>;
export const DeleteSuggestedBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSuggestedBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"batchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSuggestedBatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"batchId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedId"}}]}}]}}]} as unknown as DocumentNode<DeleteSuggestedBatchMutation, DeleteSuggestedBatchMutationVariables>;
export const MakeBatchMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MakeBatchMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"makeBatchMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"suggestedBatchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestedBatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<MakeBatchMatchesMutation, MakeBatchMatchesMutationVariables>;
export const SaveBatchMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveBatchMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveBatchMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"suggestedBatchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestedBatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<SaveBatchMatchesMutation, SaveBatchMatchesMutationVariables>;
export const CreateProgramAutomatchingConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProgramAutomatchingConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"configuration"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProgramAutomatchingConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProgramAutomatchingConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"configuration"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programAutomatchingConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchingCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithoutTraining"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithoutMatchingSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithoutMatchingSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"sharedTransferStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sharedMajor"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesUnder17"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithFreeResponses"}},{"kind":"Field","name":{"kind":"Name","value":"requireMenteeSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"requireMentorSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentMenteeMatchingCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"onlyEnrollmentOptInMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeAvailableToMatchEnrollmentMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithMentorships"}},{"kind":"Field","name":{"kind":"Name","value":"includeEverMatchedEnrollmentMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWhoHaveBeenUnmatched"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWhoHaveBeenUnmatched"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWhoArePushedThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWhoArePushedThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"hardMatchQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectHardMatchQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleSelectHardMatchQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"autoMatchingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"standardScoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"supermentorScoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"mentorCapacityCap"}},{"kind":"Field","name":{"kind":"Name","value":"standardMatching"}},{"kind":"Field","name":{"kind":"Name","value":"supermentorMatching"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupMatchingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minGroupSize"}},{"kind":"Field","name":{"kind":"Name","value":"maxGroupSize"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProgramAutomatchingConfigurationMutation, CreateProgramAutomatchingConfigurationMutationVariables>;
export const ProgramAutomatchingDefaultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramAutomatchingDefault"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programAutomatchingDefault"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"automatchingDefault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchingCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithoutTraining"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithoutMatchingSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithoutMatchingSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"sharedTransferStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesUnder17"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithFreeResponses"}},{"kind":"Field","name":{"kind":"Name","value":"requireMenteeSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"requireMentorSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentMenteeMatchingCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"onlyEnrollmentOptInMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeAvailableToMatchEnrollmentMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithMentorships"}},{"kind":"Field","name":{"kind":"Name","value":"includeEverMatchedEnrollmentMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWhoHaveBeenUnmatched"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWhoHaveBeenUnmatched"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWhoArePushedThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWhoArePushedThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"hardMatchQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectHardMatchQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleSelectHardMatchQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"autoMatchingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"standardScoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"supermentorScoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"mentorCapacityCap"}},{"kind":"Field","name":{"kind":"Name","value":"standardMatching"}},{"kind":"Field","name":{"kind":"Name","value":"supermentorMatching"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupMatchingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minGroupSize"}},{"kind":"Field","name":{"kind":"Name","value":"maxGroupSize"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionsWeights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramAutomatchingDefaultQuery, ProgramAutomatchingDefaultQueryVariables>;
export const ProgramAutomatchingConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramAutomatchingConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programAutomatchingConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchingCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithoutTraining"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithoutMatchingSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithoutMatchingSurveys"}},{"kind":"Field","name":{"kind":"Name","value":"sharedTransferStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesUnder17"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithFreeResponses"}},{"kind":"Field","name":{"kind":"Name","value":"requireMenteeSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"requireMentorSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWithSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithSupermentorOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentMenteeMatchingCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"onlyEnrollmentOptInMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeAvailableToMatchEnrollmentMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWithMentorships"}},{"kind":"Field","name":{"kind":"Name","value":"includeEverMatchedEnrollmentMentees"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWhoHaveBeenUnmatched"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWhoHaveBeenUnmatched"}},{"kind":"Field","name":{"kind":"Name","value":"includeMenteesWhoArePushedThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"includeMentorsWhoArePushedThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"hardMatchQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectHardMatchQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SingleSelectHardMatchQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"autoMatchingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"standardScoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"supermentorScoreThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"mentorCapacityCap"}},{"kind":"Field","name":{"kind":"Name","value":"standardMatching"}},{"kind":"Field","name":{"kind":"Name","value":"supermentorMatching"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupMatchingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minGroupSize"}},{"kind":"Field","name":{"kind":"Name","value":"maxGroupSize"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionsWeights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramAutomatchingConfigurationQuery, ProgramAutomatchingConfigurationQueryVariables>;
export const ProgramMatchingEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramMatchingEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allowMatching"}}]}}]}}]} as unknown as DocumentNode<ProgramMatchingEnabledQuery, ProgramMatchingEnabledQueryVariables>;
export const ProgramCountOfPrioritizedAndPendingForRematchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramCountOfPrioritizedAndPendingForRematch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPrioritizedAndPendingForRematching"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPrioritizedAndPendingForRematching"}}]}}]}}]}}]} as unknown as DocumentNode<ProgramCountOfPrioritizedAndPendingForRematchQuery, ProgramCountOfPrioritizedAndPendingForRematchQueryVariables>;
export const UpdateProgramMatchingEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramMatchingEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allowMatching"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramMatchingEnabledMutation, UpdateProgramMatchingEnabledMutationVariables>;
export const SelectedContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectedContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactsFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"activationStatusChangedAt"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}}]}}]}}]}}]} as unknown as DocumentNode<SelectedContactsQuery, SelectedContactsQueryVariables>;
export const DeleteContactsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteContactsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProgramContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfContactsDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteContactsByIdsMutation, DeleteContactsByIdsMutationVariables>;
export const DeleteContactsByFilterSelectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteContactsByFilterSelection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProgramContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byFilterSelection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfContactsDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteContactsByFilterSelectionMutation, DeleteContactsByFilterSelectionMutationVariables>;
export const StartFirstWaveRecruitmentByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"startFirstWaveRecruitmentByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startFirstWaveRecruitment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfContactsActivated"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]} as unknown as DocumentNode<StartFirstWaveRecruitmentByIdsMutation, StartFirstWaveRecruitmentByIdsMutationVariables>;
export const StartFirstWaveRecruitmentByFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"startFirstWaveRecruitmentByFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startFirstWaveRecruitment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byFilterSelection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfContactsActivated"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]} as unknown as DocumentNode<StartFirstWaveRecruitmentByFiltersMutation, StartFirstWaveRecruitmentByFiltersMutationVariables>;
export const StartSecondWaveRecruitmentByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"startSecondWaveRecruitmentByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startSecondWaveRecruitment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfContactsActivated"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]} as unknown as DocumentNode<StartSecondWaveRecruitmentByIdsMutation, StartSecondWaveRecruitmentByIdsMutationVariables>;
export const StartSecondWaveRecruitmentByFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"startSecondWaveRecruitmentByFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startSecondWaveRecruitment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byFilterSelection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfContactsActivated"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]} as unknown as DocumentNode<StartSecondWaveRecruitmentByFiltersMutation, StartSecondWaveRecruitmentByFiltersMutationVariables>;
export const StopRecruitmentByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"stopRecruitmentByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stopRecruitment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfContactsDeactivated"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]} as unknown as DocumentNode<StopRecruitmentByIdsMutation, StopRecruitmentByIdsMutationVariables>;
export const StopRecruitmentByFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"stopRecruitmentByFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stopRecruitment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byFilterSelection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfContactsDeactivated"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]} as unknown as DocumentNode<StopRecruitmentByFiltersMutation, StopRecruitmentByFiltersMutationVariables>;
export const ProgramContactsSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramContactsSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"usesNewCommunications"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"mentorContactCount"}},{"kind":"Field","name":{"kind":"Name","value":"studentContactCount"}},{"kind":"Field","name":{"kind":"Name","value":"notActivatedCount"}},{"kind":"Field","name":{"kind":"Name","value":"activatedCount"}},{"kind":"Field","name":{"kind":"Name","value":"secondWaveCount"}},{"kind":"Field","name":{"kind":"Name","value":"registeredCount"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedByUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batchActionIds"}}]}}]}}]}}]} as unknown as DocumentNode<ProgramContactsSummaryQuery, ProgramContactsSummaryQueryVariables>;
export const FilteredProgramContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilteredProgramContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactsSort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactsSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"usesNewCommunications"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactsFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactsSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"mentorContactCount"}},{"kind":"Field","name":{"kind":"Name","value":"studentContactCount"}},{"kind":"Field","name":{"kind":"Name","value":"notActivatedCount"}},{"kind":"Field","name":{"kind":"Name","value":"activatedCount"}},{"kind":"Field","name":{"kind":"Name","value":"secondWaveCount"}},{"kind":"Field","name":{"kind":"Name","value":"registeredCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserProfileDataFragment"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploadedDate"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"a2pSmses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"activationStatusChangedAt"}},{"kind":"Field","name":{"kind":"Name","value":"batchActionId"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfileDataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<FilteredProgramContactsQuery, FilteredProgramContactsQueryVariables>;
export const UpdateProgramOutreachStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramOutreachStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentStage"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramOutreachStageMutation, UpdateProgramOutreachStageMutationVariables>;
export const CreateProgramTopicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProgramTopic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProgramTopicInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProgramTopic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createProgramTopicInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programTopic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateProgramTopicMutation, CreateProgramTopicMutationVariables>;
export const DeleteProgramTopicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProgramTopic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProgramTopic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeleteProgramTopicMutation, DeleteProgramTopicMutationVariables>;
export const UpdateProgramTopicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramTopic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramTopicInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramTopic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateProgramTopicInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programTopic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramTopicMutation, UpdateProgramTopicMutationVariables>;
export const ProgramTopicsForProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramTopicsForProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramTopicsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramTopicsSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"programTopics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"lastEditedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usesNewCommunications"}}]}}]}}]} as unknown as DocumentNode<ProgramTopicsForProgramQuery, ProgramTopicsForProgramQueryVariables>;
export const ProgramCommunicationsAvailableCampaignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramCommunicationsAvailableCampaigns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TopicCollectionInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outreachTopicCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"topics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramCommunicationsAvailableCampaignsQuery, ProgramCommunicationsAvailableCampaignsQueryVariables>;
export const UpdateProgramTopicsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramTopics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programTopics"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramTopicsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramTopics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programTopics"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programTopics"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programTopics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"delayBeforeRestart"}},{"kind":"Field","name":{"kind":"Name","value":"lastEditedAt"}},{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}},{"kind":"Field","name":{"kind":"Name","value":"hoursDelayBeforeRestart"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"topicConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramTopicsMutation, UpdateProgramTopicsMutationVariables>;
export const UpdateProgramCommunicationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramCommunicationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramCommunicationSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramCommunicationSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateProgramCommunicationSettingsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"communicationMediumPreference"}},{"kind":"Field","name":{"kind":"Name","value":"usesNewCommunications"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramCommunicationSettingsMutation, UpdateProgramCommunicationSettingsMutationVariables>;
export const MessageTemplatesForProgramConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MessageTemplatesForProgramConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageTemplatesFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageTemplatesSort"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageType"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}}]}}]}}]}}]} as unknown as DocumentNode<MessageTemplatesForProgramConfigurationQuery, MessageTemplatesForProgramConfigurationQueryVariables>;
export const UpdateProgramCustomMessageTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramCustomMessageTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programCustomMessageTemplates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramCustomMessageTemplatesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramCustomMessageTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programCustomMessageTemplates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programCustomMessageTemplates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageType"}},{"kind":"Field","name":{"kind":"Name","value":"messageTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramCustomMessageTemplatesMutation, UpdateProgramCustomMessageTemplatesMutationVariables>;
export const ProgramContentInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramContentInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"reRecruitedMentorsCanSkipMatchingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"currentStage"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messageTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customMessageType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programTopics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"delayBeforeRestart"}},{"kind":"Field","name":{"kind":"Name","value":"lastEditedAt"}},{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userState"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"hoursDelayBeforeRestart"}},{"kind":"Field","name":{"kind":"Name","value":"topicConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorTrainingTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"programSpecific"}},{"kind":"Field","name":{"kind":"Name","value":"toBeCompletedAs"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleTrainingTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calendlyUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usesNewCommunications"}},{"kind":"Field","name":{"kind":"Name","value":"communicationMediumPreference"}},{"kind":"Field","name":{"kind":"Name","value":"defaultProfileImage"}},{"kind":"Field","name":{"kind":"Name","value":"programTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"showAll"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"programSpecific"}},{"kind":"Field","name":{"kind":"Name","value":"toBeCompletedAs"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleTrainingTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calendlyUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TakeSurveyTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TakeExternalLinkTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WatchVideoTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wistiaVideoId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}},{"kind":"Field","name":{"kind":"Name","value":"menteeQuizTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"showMatchingSurveysToPartner"}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"migrated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"migrated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorPostSessionSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentPostSessionSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<ProgramContentInfoQuery, ProgramContentInfoQueryVariables>;
export const ProgramMatchingSurveyCommunicationActivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramMatchingSurveyCommunicationActivities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityLogsSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityLogsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"activityLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"loggableActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PartnerNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramMatchingSurveyCommunicationActivitiesQuery, ProgramMatchingSurveyCommunicationActivitiesQueryVariables>;
export const SendPartnerNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPartnerNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPartnerNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"templateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successRecipients"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SendPartnerNotificationsMutation, SendPartnerNotificationsMutationVariables>;
export const RegisteredPartnersInProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RegisteredPartnersInProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"registered"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RegisteredPartnersInProgramQuery, RegisteredPartnersInProgramQueryVariables>;
export const MatchingSurveyPartnerNotificationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MatchingSurveyPartnerNotificationPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templatesFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageTemplatesFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterInitial"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityLogsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterUpdate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityLogsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityLogsSort"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templatesFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"lastInitialNotification"},"name":{"kind":"Name","value":"activityLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterInitial"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastUpdateNotification"},"name":{"kind":"Name","value":"activityLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterUpdate"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MatchingSurveyPartnerNotificationPreferencesQuery, MatchingSurveyPartnerNotificationPreferencesQueryVariables>;
export const CustomQuestionsOnProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomQuestionsOnProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyQuestionFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"customizations"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"customizations"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomQuestionsOnProgramQuery, CustomQuestionsOnProgramQueryVariables>;
export const QuestionRestrictedOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QuestionRestrictedOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyQuestionRestrictedOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"qid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<QuestionRestrictedOptionsQuery, QuestionRestrictedOptionsQueryVariables>;
export const BaseSurveyQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BaseSurveyQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveysFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"customizations"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BaseSurveyQuestionsQuery, BaseSurveyQuestionsQueryVariables>;
export const CreateMatchingSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMatchingSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMatchingSurveyInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customQuestionInputData"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyCustomizationQuestionInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMatchingSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matchingSurveyOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}},{"kind":"Argument","name":{"kind":"Name","value":"customQuestionsFromAdminTool"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customQuestionInputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateMatchingSurveyMutation, CreateMatchingSurveyMutationVariables>;
export const PreviewMatchingSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PreviewMatchingSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BaseMatchingSurveyInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customQuestionInputData"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyCustomizationQuestionInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewMatchingSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matchingSurveyOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}},{"kind":"Argument","name":{"kind":"Name","value":"customQuestionsFromAdminTool"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customQuestionInputData"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"menteeSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"previewParticipantFromSameProgram"}}]}}]}}]} as unknown as DocumentNode<PreviewMatchingSurveyMutation, PreviewMatchingSurveyMutationVariables>;
export const CreateOrEnableNewProgramTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrEnableNewProgramTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newTaskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assigneeEntity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssigneeEntity"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrEnableNewProgramTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"newTaskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newTaskId"}}},{"kind":"Argument","name":{"kind":"Name","value":"assigneeEntity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assigneeEntity"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newProgramTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"assigneeEntity"}},{"kind":"Field","name":{"kind":"Name","value":"behavior"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"programId"}},{"kind":"Field","name":{"kind":"Name","value":"newTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalTaskName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateOrEnableNewProgramTaskMutation, CreateOrEnableNewProgramTaskMutationVariables>;
export const ExistingRequiredTrainingNewProgramTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExistingRequiredTrainingNewProgramTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newProgramTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"programIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"programId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"behaviors"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"mentor_training","block":false}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"enabled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<ExistingRequiredTrainingNewProgramTasksQuery, ExistingRequiredTrainingNewProgramTasksQueryVariables>;
export const GetSurveyDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSurveyDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessmentAreasForSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetSurveyDetailsQuery, GetSurveyDetailsQueryVariables>;
export const NewSurveysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewSurveys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveysFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"migrated"}},{"kind":"Field","name":{"kind":"Name","value":"surveyType"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<NewSurveysQuery, NewSurveysQueryVariables>;
export const MenteeQuizExternalLinkTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"menteeQuizExternalLinkTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"EXTERNAL_LINK_TASK"}},{"kind":"ObjectField","name":{"kind":"Name","value":"isMenteeQuiz"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MenteeQuizExternalLinkTasksQuery, MenteeQuizExternalLinkTasksQueryVariables>;
export const UpdateProgramSurveysAndQuizzesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramSurveysAndQuizzes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSurveysAndQuizzesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSurveysAndQuizzes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surveysAndQuizzes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"menteeQuizTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"migrated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"migrated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showMatchingSurveysToPartner"}},{"kind":"Field","name":{"kind":"Name","value":"mentorPostSessionSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentPostSessionSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramSurveysAndQuizzesMutation, UpdateProgramSurveysAndQuizzesMutationVariables>;
export const TasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<TasksQuery, TasksQueryVariables>;
export const CreateProgramTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProgramTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programTaskInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProgramTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProgramTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programTaskInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programTaskInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateProgramTaskMutation, CreateProgramTaskMutationVariables>;
export const CoursesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Courses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coursesSort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CoursesSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coursesSort"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<CoursesQuery, CoursesQueryVariables>;
export const CreateNewCourseTaskAndNewProgramTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewCourseTaskAndNewProgramTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newCourseTaskAndNewProgramTaskInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewCourseTaskAndNewProgramTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNewCourseTaskAndNewProgramTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newCourseTaskAndNewProgramTaskInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newCourseTaskAndNewProgramTaskInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newProgramTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duplicateTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalTaskName"}},{"kind":"Field","name":{"kind":"Name","value":"segmentTags"}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CourseTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentSurveyTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"programStage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateNewTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateNewCourseTaskAndNewProgramTaskMutation, CreateNewCourseTaskAndNewProgramTaskMutationVariables>;
export const AvailableCoursesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailableCourses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contextTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"course"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalTaskName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CourseTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentSurveyTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"programStage"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AvailableCoursesQuery, AvailableCoursesQueryVariables>;
export const ProgramLiveTrainingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramLiveTraining"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentorTrainingTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramLiveTrainingQuery, ProgramLiveTrainingQueryVariables>;
export const CreateNewLinkTaskAndNewProgramTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewLinkTaskAndNewProgramTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newLinkTaskAndNewProgramTaskInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewLinkTaskAndNewProgramTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNewLinkTaskAndNewProgramTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newLinkTaskAndNewProgramTaskInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newLinkTaskAndNewProgramTaskInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newProgramTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duplicateTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalTaskName"}},{"kind":"Field","name":{"kind":"Name","value":"segmentTags"}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CourseTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentSurveyTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"programStage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateNewTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateNewLinkTaskAndNewProgramTaskMutation, CreateNewLinkTaskAndNewProgramTaskMutationVariables>;
export const ProgramShortNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramShortName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]} as unknown as DocumentNode<ProgramShortNameQuery, ProgramShortNameQueryVariables>;
export const UpdateAssessmentSurveyNewProgramTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAssessmentSurveyNewProgramTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateAssessmentSurveyNewProgramTaskInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssessmentSurveyNewProgramTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssessmentSurveyNewProgramTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateAssessmentSurveyNewProgramTaskInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateAssessmentSurveyNewProgramTaskInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newProgramTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"assigneeEntity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAssessmentSurveyNewProgramTaskMutation, UpdateAssessmentSurveyNewProgramTaskMutationVariables>;
export const UpdateClickLinkNewProgramTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClickLinkNewProgramTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateClickLinkNewProgramTaskInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateClickLinkNewProgramTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClickLinkNewProgramTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateClickLinkNewProgramTaskInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateClickLinkNewProgramTaskInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newProgramTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"assigneeEntity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateClickLinkNewProgramTaskMutation, UpdateClickLinkNewProgramTaskMutationVariables>;
export const CourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Course"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"course"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CourseQuery, CourseQueryVariables>;
export const UpdateCourseNewProgramTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCourseNewProgramTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateCourseNewProgramTaskInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCourseNewProgramTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCourseNewProgramTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateCourseNewProgramTaskInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateCourseNewProgramTaskInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newProgramTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"behavior"}},{"kind":"Field","name":{"kind":"Name","value":"assigneeEntity"}},{"kind":"Field","name":{"kind":"Name","value":"newTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CourseTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseId"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCourseNewProgramTaskMutation, UpdateCourseNewProgramTaskMutationVariables>;
export const GetNewProgramTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNewProgramTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newProgramTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"behavior"}},{"kind":"Field","name":{"kind":"Name","value":"assigneeEntity"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"newTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalTaskName"}},{"kind":"Field","name":{"kind":"Name","value":"segmentTags"}},{"kind":"Field","name":{"kind":"Name","value":"requiredForMatching"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipCredential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credential"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CourseTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentSurveyTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"programStage"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetNewProgramTaskQuery, GetNewProgramTaskQueryVariables>;
export const ParticipantDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstParticipantCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"registeredMentorCount"},"name":{"kind":"Name","value":"mentors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"registered"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"MENTORS"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"registeredStudentCount"},"name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"registered"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"STUDENTS"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantDetailsQuery, ParticipantDetailsQueryVariables>;
export const UpdateProgramTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programTask"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"toBeCompletedAs"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramTaskMutation, UpdateProgramTaskMutationVariables>;
export const DeleteProgramTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProgramTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProgramTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentorTrainingTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"programSpecific"}},{"kind":"Field","name":{"kind":"Name","value":"toBeCompletedAs"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"customCallToAction"}},{"kind":"Field","name":{"kind":"Name","value":"customAfterCallToAction"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleTrainingTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calendlyUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"programTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"showAll"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"programSpecific"}},{"kind":"Field","name":{"kind":"Name","value":"toBeCompletedAs"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TakeSurveyTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TakeExternalLinkTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WatchVideoTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wistiaVideoId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProgramTaskMutation, DeleteProgramTaskMutationVariables>;
export const ProgramTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewProgramTasksFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewProgramTasksSort"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newProgramTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"assigneeEntity"}},{"kind":"Field","name":{"kind":"Name","value":"behavior"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"programId"}},{"kind":"Field","name":{"kind":"Name","value":"newTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"segmentTags"}},{"kind":"Field","name":{"kind":"Name","value":"internalTaskName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssigneeEntity"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipCredential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credential"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CourseTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentSurveyTaskContext"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"programStage"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramTasksQuery, ProgramTasksQueryVariables>;
export const DisableNewProgramTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisableNewProgramTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disableNewProgramTaskInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DisableNewProgramTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disableNewProgramTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"disableNewProgramTaskInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disableNewProgramTaskInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newProgramTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"assigneeEntity"}},{"kind":"Field","name":{"kind":"Name","value":"behavior"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"programId"}},{"kind":"Field","name":{"kind":"Name","value":"newTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalTaskName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DisableNewProgramTaskMutation, DisableNewProgramTaskMutationVariables>;
export const AdminDashboardMentorshipEngagementDataExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardMentorshipEngagementDataExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csvExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorshipEngagementData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardMentorshipEngagementDataExportQuery, AdminDashboardMentorshipEngagementDataExportQueryVariables>;
export const ProgramSurveyResponsesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramSurveyResponsesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyResponses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"surveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ProgramSurveyResponsesCountQuery, ProgramSurveyResponsesCountQueryVariables>;
export const ProgramSurveysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramSurveys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currentPhase"}},{"kind":"Field","name":{"kind":"Name","value":"studentOpeningAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentMidAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentEndAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorOpeningAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMidAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorEndAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorPostSessionSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentPostSessionSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProgramSurveysQuery, ProgramSurveysQueryVariables>;
export const CompileRowsForProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompileRowsForProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originalTexts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programCompiledTexts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"originalTexts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalTexts"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}]}]}}]} as unknown as DocumentNode<CompileRowsForProgramQuery, CompileRowsForProgramQueryVariables>;
export const CreateProgramResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProgramResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programResourceInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProgramResourceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProgramResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programResourceInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programResourceInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programResource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateProgramResourceMutation, CreateProgramResourceMutationVariables>;
export const UpdateProgramAuthenticationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramAuthenticationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"menteeLoginMode"}},{"kind":"Field","name":{"kind":"Name","value":"mentorLoginMode"}},{"kind":"Field","name":{"kind":"Name","value":"mentorType"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramAuthenticationSettingsMutation, UpdateProgramAuthenticationSettingsMutationVariables>;
export const UpdateProgramInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isTestProgram"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplateProgram"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"accountNotes"}},{"kind":"Field","name":{"kind":"Name","value":"defaultProfileImage"}},{"kind":"Field","name":{"kind":"Name","value":"programInfoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"programLogo"}},{"kind":"Field","name":{"kind":"Name","value":"sftpExportEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nonPriorityFlagEmailEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramInfoMutation, UpdateProgramInfoMutationVariables>;
export const RegisteredParticipantsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RegisteredParticipantsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"programIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"programId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"registered"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<RegisteredParticipantsCountQuery, RegisteredParticipantsCountQueryVariables>;
export const UpdateProgramSignUpSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramSignUpSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allowMentorSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"allowMenteeSignUp"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramSignUpSettingsMutation, UpdateProgramSignUpSettingsMutationVariables>;
export const UpdateProgramCustomLabelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramCustomLabel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramCustomLabelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramCustomLabel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateProgramCustomLabelInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"menteeRecruitmentLink"}},{"kind":"Field","name":{"kind":"Name","value":"mentorRecruitmentLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programCustomLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"singularMentor"}},{"kind":"Field","name":{"kind":"Name","value":"singularMentorWithIndeterminateArticle"}},{"kind":"Field","name":{"kind":"Name","value":"pluralMentor"}},{"kind":"Field","name":{"kind":"Name","value":"respectMentorUppercase"}},{"kind":"Field","name":{"kind":"Name","value":"singularMentee"}},{"kind":"Field","name":{"kind":"Name","value":"singularMenteeWithIndeterminateArticle"}},{"kind":"Field","name":{"kind":"Name","value":"pluralMentee"}},{"kind":"Field","name":{"kind":"Name","value":"respectMenteeUppercase"}},{"kind":"Field","name":{"kind":"Name","value":"singularStudent"}},{"kind":"Field","name":{"kind":"Name","value":"singularStudentWithIndeterminateArticle"}},{"kind":"Field","name":{"kind":"Name","value":"pluralStudent"}},{"kind":"Field","name":{"kind":"Name","value":"respectStudentUppercase"}},{"kind":"Field","name":{"kind":"Name","value":"singularMentorship"}},{"kind":"Field","name":{"kind":"Name","value":"singularMentorshipWithIndeterminateArticle"}},{"kind":"Field","name":{"kind":"Name","value":"respectMentorshipUppercase"}},{"kind":"Field","name":{"kind":"Name","value":"pluralMentorship"}},{"kind":"Field","name":{"kind":"Name","value":"singularSchool"}},{"kind":"Field","name":{"kind":"Name","value":"singularSchoolWithIndeterminateArticle"}},{"kind":"Field","name":{"kind":"Name","value":"pluralSchool"}},{"kind":"Field","name":{"kind":"Name","value":"respectSchoolUppercase"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramCustomLabelMutation, UpdateProgramCustomLabelMutationVariables>;
export const ProgramResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programResources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramResourcesQuery, ProgramResourcesQueryVariables>;
export const DeleteProgramResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProgramResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProgramResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programResources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProgramResourceMutation, DeleteProgramResourceMutationVariables>;
export const UpdateProgramSetupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramSetup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramSetupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramSetup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programSetup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"mentorType"}},{"kind":"Field","name":{"kind":"Name","value":"matchingCap"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceOpportunityId"}},{"kind":"Field","name":{"kind":"Name","value":"cohorts"}},{"kind":"Field","name":{"kind":"Name","value":"mentorLoginMode"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"programGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programTopics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramSetupMutation, UpdateProgramSetupMutationVariables>;
export const AllProgramSequencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllProgramSequences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programSequences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AllProgramSequencesQuery, AllProgramSequencesQueryVariables>;
export const AdminDashboardProgramDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardProgramDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"accountNotes"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"mentorType"}},{"kind":"Field","name":{"kind":"Name","value":"matchingCap"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceOpportunityId"}},{"kind":"Field","name":{"kind":"Name","value":"cohorts"}},{"kind":"Field","name":{"kind":"Name","value":"isTestProgram"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplateProgram"}},{"kind":"Field","name":{"kind":"Name","value":"mentorLoginMode"}},{"kind":"Field","name":{"kind":"Name","value":"menteeLoginMode"}},{"kind":"Field","name":{"kind":"Name","value":"allowMentorSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"allowMenteeSignUp"}},{"kind":"Field","name":{"kind":"Name","value":"allowsMenteesToPushThemselvesThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"defaultProfileImage"}},{"kind":"Field","name":{"kind":"Name","value":"programInfoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"programLogo"}},{"kind":"Field","name":{"kind":"Name","value":"programGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ssoEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"menteeRecruitmentLink"}},{"kind":"Field","name":{"kind":"Name","value":"mentorRecruitmentLink"}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardProgramDetailsQuery, AdminDashboardProgramDetailsQueryVariables>;
export const ConfigureFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfigureFlags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"configureFlagsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigureFlagsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configureFlags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configureFlagsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"configureFlagsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"showMentorsFlags"}},{"kind":"Field","name":{"kind":"Name","value":"programFlagCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}},{"kind":"Field","name":{"kind":"Name","value":"customDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"flagCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"smsCharacter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customSmsCharacter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flagCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"smsCharacter"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ConfigureFlagsMutation, ConfigureFlagsMutationVariables>;
export const FlagConfigurationDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FlagConfigurationData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"showMentorsFlags"}},{"kind":"Field","name":{"kind":"Name","value":"programFlagCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}},{"kind":"Field","name":{"kind":"Name","value":"customDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"flagCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"smsCharacter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customSmsCharacter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flagCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"smsCharacter"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagCategoriesSubmitted"}}]}}]}}]} as unknown as DocumentNode<FlagConfigurationDataQuery, FlagConfigurationDataQueryVariables>;
export const EngagementDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EngagementData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isMatched"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCountWithZeroConversations"}},{"kind":"Field","name":{"kind":"Name","value":"totalCountWithThreeOrMoreConversations"}},{"kind":"Field","name":{"kind":"Name","value":"totalCountWithConversationInTheLast30Days"}},{"kind":"Field","name":{"kind":"Name","value":"totalCountUsingSmsRelay"}},{"kind":"Field","name":{"kind":"Name","value":"totalCountMentorsDisengaged"}},{"kind":"Field","name":{"kind":"Name","value":"totalCountMenteesDisengaged"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagementBenchmarkData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorshipsInPreviousProgramWith0Conversations"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipsInPreviousProgramWith3OrMoreConversations"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipsInPreviousProgramUsingSmsRelay"}},{"kind":"Field","name":{"kind":"Name","value":"disengagedMentorsInPreviousProgram"}},{"kind":"Field","name":{"kind":"Name","value":"disengagedMenteesInPreviousProgram"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<EngagementDataQuery, EngagementDataQueryVariables>;
export const ProgramContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramContext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"trainingMode"}},{"kind":"Field","name":{"kind":"Name","value":"currentPhase"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorContactCount"}},{"kind":"Field","name":{"kind":"Name","value":"studentContactCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"previousPrograms"},"name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramContextQuery, ProgramContextQueryVariables>;
export const ParticipantsCountForDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantsCountFor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentProgramFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includePreviousProgramQueries"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"previousProgramFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeSegmentQueries"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"segmentFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currentProgramParticipantsCount"},"name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentProgramFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"previousProgramParticipantsCount"},"name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"previousProgramFilter"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includePreviousProgramQueries"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"segmentParticipantsCount"},"name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"segmentFilter"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeSegmentQueries"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ParticipantsCountForQuery, ParticipantsCountForQueryVariables>;
export const ProgramMatchingGoalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramMatchingGoal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}}]}}]}}]} as unknown as DocumentNode<ProgramMatchingGoalQuery, ProgramMatchingGoalQueryVariables>;
export const ContactsCsvForDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContactsCsvFor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactsFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribedFromEmails"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribedFromSmses"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploadedDate"}}]}}]}}]}}]} as unknown as DocumentNode<ContactsCsvForQuery, ContactsCsvForQueryVariables>;
export const MentorsCsvForDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MentorsCsvFor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantsFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribedFromEmails"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribedFromSmses"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"completedMatchingSurveyAt"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mentor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredTrainingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastCompletedRequiredTrainingAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MentorsCsvForQuery, MentorsCsvForQueryVariables>;
export const StudentsCsvForDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudentsCsvFor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantsFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribedFromEmails"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribedFromSmses"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"completedMatchingSurveyAt"}}]}}]}}]}}]} as unknown as DocumentNode<StudentsCsvForQuery, StudentsCsvForQueryVariables>;
export const AdminDashboardCompletedTrainingProgramInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardCompletedTrainingProgramInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"requiredMentorTrainingCredential"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardCompletedTrainingProgramInfoQuery, AdminDashboardCompletedTrainingProgramInfoQueryVariables>;
export const CredentialedMentorsCsvForDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CredentialedMentorsCsvFor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantsFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credential"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribedFromEmails"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribedFromSmses"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipCredentials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"credentials"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"credential"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipCredential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credential"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedMatchingSurveyAt"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}}]}}]}}]}}]} as unknown as DocumentNode<CredentialedMentorsCsvForQuery, CredentialedMentorsCsvForQueryVariables>;
export const AdminDashboardCredentialedParticipantMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardCredentialedParticipantMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCredentialed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"EnumValue","value":"MILLENNIUM"}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalRegistered"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"EnumValue","value":"MILLENNIUM"}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardCredentialedParticipantMetricsQuery, AdminDashboardCredentialedParticipantMetricsQueryVariables>;
export const OpenMentorSlotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OpenMentorSlots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfOpenMentorSlots"}}]}}]}}]} as unknown as DocumentNode<OpenMentorSlotsQuery, OpenMentorSlotsQueryVariables>;
export const BatchRegisterExistingUsersAdminActionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BatchRegisterExistingUsersAdminActionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adminActionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adminActionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"performedAt"}},{"kind":"Field","name":{"kind":"Name","value":"resultingChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"changedObjectTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"REGISTRANT"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"changedObjectEventTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CREATE"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"changes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"}},{"kind":"Field","name":{"kind":"Name","value":"originalValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mentor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Student"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BatchRegisterExistingUsersAdminActionListQuery, BatchRegisterExistingUsersAdminActionListQueryVariables>;
export const ActivateContactsAdminActionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActivateContactsAdminActionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adminActionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adminActionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"performedAt"}},{"kind":"Field","name":{"kind":"Name","value":"resultingChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"changedObjectTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CONTACT"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"changedObjectEventTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"UPDATE"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"changes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"}},{"kind":"Field","name":{"kind":"Name","value":"originalValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usesNewCommunications"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActivateContactsAdminActionListQuery, ActivateContactsAdminActionListQueryVariables>;
export const ContactUploadAdminActionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContactUploadAdminActionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adminActionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adminActionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"performedAt"}},{"kind":"Field","name":{"kind":"Name","value":"resultingChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"changedObjectTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CONTACT"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"changedObjectEventTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CREATE"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"changes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"}},{"kind":"Field","name":{"kind":"Name","value":"originalValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackedObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContactUploadAdminActionListQuery, ContactUploadAdminActionListQueryVariables>;
export const ProgramTrackingSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramTrackingSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminActionsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"adminUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionTypes"}}]}}]}}]} as unknown as DocumentNode<ProgramTrackingSummaryQuery, ProgramTrackingSummaryQueryVariables>;
export const ProgramTrackingHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramTrackingHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminActionsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminActionsSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionTypes"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"performedAt"}},{"kind":"Field","name":{"kind":"Name","value":"adminUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resultingChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedObjectTypeCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackedObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramTopic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramCustomMessageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageType"}},{"kind":"Field","name":{"kind":"Name","value":"messageTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"changes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"}},{"kind":"Field","name":{"kind":"Name","value":"originalValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramTrackingHistoryQuery, ProgramTrackingHistoryQueryVariables>;
export const ProgramMilestonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramMilestones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"menteeContactUpload"},"name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"STUDENT_CONTACTS"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"UPLOADED_DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedDate"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mentorContactUpload"},"name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"MENTOR_CONTACTS"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"UPLOADED_DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedDate"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"menteeContactActivation"},"name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activationStatus"},"value":{"kind":"EnumValue","value":"ACTIVATED"}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"STUDENT_CONTACTS"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"ACTIVATED_DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activationStatusChangedAt"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mentorContactActivation"},"name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activationStatus"},"value":{"kind":"EnumValue","value":"ACTIVATED"}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"MENTOR_CONTACTS"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"ACTIVATED_DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activationStatusChangedAt"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"firstMenteeRegistration"},"name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"registered"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"firstMentorRegistration"},"name":{"kind":"Name","value":"mentors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"registered"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"firstMatch"},"name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matchDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"matchingCap"}},{"kind":"Field","name":{"kind":"Name","value":"programGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matchingCapReachedDate"}},{"kind":"Field","name":{"kind":"Name","value":"matchingGoalReachedDate"}},{"kind":"Field","name":{"kind":"Name","value":"studentOpeningAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentMidAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentEndAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramMilestonesQuery, ProgramMilestonesQueryVariables>;
export const AdminActionsForProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminActionsForProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"types"},"value":{"kind":"EnumValue","value":"UPDATE_PROGRAM"}},{"kind":"ObjectField","name":{"kind":"Name","value":"relevantToProgramIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"PERFORMED_DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"performedAt"}},{"kind":"Field","name":{"kind":"Name","value":"resultingChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"changes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attribute"}},{"kind":"Field","name":{"kind":"Name","value":"originalValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminActionsForProgramQuery, AdminActionsForProgramQueryVariables>;
export const AdminDashboardProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currentPhase"}},{"kind":"Field","name":{"kind":"Name","value":"usesNewCommunications"}},{"kind":"Field","name":{"kind":"Name","value":"allowMatching"}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessOperator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardProgramQuery, AdminDashboardProgramQueryVariables>;
export const ProgramSequenceForNewProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramSequenceForNewProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programSequenceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programSequences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"programSequenceId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"urlSlug"}},{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramSequenceForNewProgramQuery, ProgramSequenceForNewProgramQueryVariables>;
export const TemplateProgramsOnSpecificHigherEdSegmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplateProgramsOnSpecificHigherEdSegment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<TemplateProgramsOnSpecificHigherEdSegmentQuery, TemplateProgramsOnSpecificHigherEdSegmentQueryVariables>;
export const DuplicateProgramForSpecificSchoolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateProgramForSpecificSchool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toProgramSequenceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duplicateLegacyTasks"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"toProgramSequenceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toProgramSequenceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"duplicateLegacyTasks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duplicateLegacyTasks"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"successMessages"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DuplicateProgramForSpecificSchoolMutation, DuplicateProgramForSpecificSchoolMutationVariables>;
export const AddContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"File"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchActionId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<AddContactsMutation, AddContactsMutationVariables>;
export const AddContactsToExistingUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddContactsToExistingUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"File"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addContactsToExistingUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchActionId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<AddContactsToExistingUsersMutation, AddContactsToExistingUsersMutationVariables>;
export const AddContactsFromExistingProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddContactsFromExistingProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromProgramId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"existingPool"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExistingPoolEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addContactsFromExistingProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromProgramId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromProgramId"}}},{"kind":"Argument","name":{"kind":"Name","value":"existingPool"},"value":{"kind":"Variable","name":{"kind":"Name","value":"existingPool"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchActionId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<AddContactsFromExistingProgramMutation, AddContactsFromExistingProgramMutationVariables>;
export const AddParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"File"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromAnotherProgram"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"participantType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantType"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromAnotherProgram"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromAnotherProgram"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchActionId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<AddParticipantsMutation, AddParticipantsMutationVariables>;
export const ChangeMentorTrainingStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeMentorTrainingStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"File"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainingStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorTrainingStatusEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeMentorTrainingStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"trainingStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainingStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchActionId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<ChangeMentorTrainingStatusMutation, ChangeMentorTrainingStatusMutationVariables>;
export const DenylistEmailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DenylistEmails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"File"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denylistEmails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchActionId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DenylistEmailsMutation, DenylistEmailsMutationVariables>;
export const AdminDashboardProgramTogglesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardProgramToggles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"askForMenteeSidInSignup"}},{"kind":"Field","name":{"kind":"Name","value":"reRecruitedMentorsCanSkipMatchingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"usesNewCommunications"}},{"kind":"Field","name":{"kind":"Name","value":"allowsMenteesToPushThemselvesThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"menteeLoginMode"}}]}}]}}]} as unknown as DocumentNode<AdminDashboardProgramTogglesQuery, AdminDashboardProgramTogglesQueryVariables>;
export const UpdateMenteeMentorSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMenteeMentorSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMenteeMentorSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMenteeMentorSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"settings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"askForMenteeSidInSignup"}},{"kind":"Field","name":{"kind":"Name","value":"reRecruitedMentorsCanSkipMatchingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"usesNewCommunications"}},{"kind":"Field","name":{"kind":"Name","value":"allowsMenteesToPushThemselvesThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"menteeLoginMode"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMenteeMentorSettingsMutation, UpdateMenteeMentorSettingsMutationVariables>;
export const MoveParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoveParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"File"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destinationProgramId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reasonForMove"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"destinationProgramId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destinationProgramId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reasonForMove"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reasonForMove"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchActionId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<MoveParticipantsMutation, MoveParticipantsMutationVariables>;
export const AdminDashboardProgramProfileAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardProgramProfileAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programProfileAttributeCategoriesProgramId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MCID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programProfileAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"programProfileAttributeCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programProfileAttributeCategoriesProgramId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardProgramProfileAttributesQuery, AdminDashboardProgramProfileAttributesQueryVariables>;
export const ParticipantsProfileDataCsvExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantsProfileDataCsvExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvExportContext"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvExportContextInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileDataColumns"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsProfileDataColumnInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csvExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participantsProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"csvExportContext"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvExportContext"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileDataColumns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileDataColumns"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantsProfileDataCsvExportQuery, ParticipantsProfileDataCsvExportQueryVariables>;
export const UpdateProgramPrivacySettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramPrivacySettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shareMentorEmail"}},{"kind":"Field","name":{"kind":"Name","value":"shareMentorPhone"}},{"kind":"Field","name":{"kind":"Name","value":"shareMenteeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"shareMenteePhone"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramPrivacySettingsMutation, UpdateProgramPrivacySettingsMutationVariables>;
export const AdminDashboardProgramProfileAttributeSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardProgramProfileAttributeSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"programProfileAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardExports"}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardFilters"}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardProgramIntelligenceChart"}},{"kind":"Field","name":{"kind":"Name","value":"defaultSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardExports"}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardFilters"}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardProgramIntelligenceChart"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardProgramProfileAttributeSettingsQuery, AdminDashboardProgramProfileAttributeSettingsQueryVariables>;
export const UpdateProgramProfileAttributeSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramProfileAttributeSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramProfileAttributeInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedProgramProfileAttributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programProfileAttributesInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedProgramProfileAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardExports"}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardFilters"}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardProgramIntelligenceChart"}},{"kind":"Field","name":{"kind":"Name","value":"defaultSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardExports"}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardFilters"}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardProgramIntelligenceChart"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programProfileAttributeId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramProfileAttributeSettingsMutation, UpdateProgramProfileAttributeSettingsMutationVariables>;
export const ProgramPrivacySettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"programPrivacySettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shareMentorEmail"}},{"kind":"Field","name":{"kind":"Name","value":"shareMentorPhone"}},{"kind":"Field","name":{"kind":"Name","value":"shareMenteeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"shareMenteePhone"}}]}}]}}]} as unknown as DocumentNode<ProgramPrivacySettingsQuery, ProgramPrivacySettingsQueryVariables>;
export const ProgramProfileAttributesForUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramProfileAttributesForUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programProfileAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramProfileAttributesForUploadQuery, ProgramProfileAttributesForUploadQueryVariables>;
export const UpdateProgramProfileAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramProfileAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadUserProfileDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uploadUserProfileDataInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchActionId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateProgramProfileAttributesMutation, UpdateProgramProfileAttributesMutationVariables>;
export const ActiveProgramSftpStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActiveProgramSftpStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"sftpExportEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"sftpPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"awsUsername"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActiveProgramSftpStatusQuery, ActiveProgramSftpStatusQueryVariables>;
export const SetupSftpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetupSftp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setupSftp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"publicKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSuccess"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sftpExportEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"sftpPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"awsUsername"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetupSftpMutation, SetupSftpMutationVariables>;
export const SftpS3ObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sftpS3Objects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"awsUsername"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programNamePrefix"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sftpS3Objects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"awsUsername"},"value":{"kind":"Variable","name":{"kind":"Name","value":"awsUsername"}}},{"kind":"Argument","name":{"kind":"Name","value":"programNamePrefix"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programNamePrefix"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"keyWithoutPrefix"}}]}}]}}]} as unknown as DocumentNode<SftpS3ObjectsQuery, SftpS3ObjectsQueryVariables>;
export const SftpCsvExportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SftpCsvExports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"s3Key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sftpCsvExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csvExportInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"s3Key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"s3Key"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]}}]} as unknown as DocumentNode<SftpCsvExportsQuery, SftpCsvExportsQueryVariables>;
export const CreateSchoolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSchool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSchoolInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSchool"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"schoolInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSchoolMutation, CreateSchoolMutationVariables>;
export const AdminDashboardSchoolProgramsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardSchoolPrograms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramsSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currentPhase"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFlagContactRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessOperator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardSchoolProgramsQuery, AdminDashboardSchoolProgramsQueryVariables>;
export const DeleteProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeleteProgramMutation, DeleteProgramMutationVariables>;
export const DuplicateProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"successMessages"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DuplicateProgramMutation, DuplicateProgramMutationVariables>;
export const AdminDashboardSchoolsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboardSchoolsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SchoolsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SchoolsSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"institutionType"}},{"kind":"Field","name":{"kind":"Name","value":"publicOrPrivate"}},{"kind":"Field","name":{"kind":"Name","value":"twoOrFourYear"}},{"kind":"Field","name":{"kind":"Name","value":"institutionRegion"}},{"kind":"Field","name":{"kind":"Name","value":"isMinorityServingInstitution"}},{"kind":"Field","name":{"kind":"Name","value":"programSequences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardSchoolsListQuery, AdminDashboardSchoolsListQueryVariables>;
export const DeleteSchoolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSchool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSchool"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeleteSchoolMutation, DeleteSchoolMutationVariables>;
export const AdminDataExportsAvailableSurveysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDataExportsAvailableSurveys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"surveyType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AdminDataExportsAvailableSurveysQuery, AdminDataExportsAvailableSurveysQueryVariables>;
export const ProgramActionItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramActionItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fourDaysAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activationStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivationStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentPhase"}},{"kind":"Field","name":{"kind":"Name","value":"currentStage"}},{"kind":"Field","name":{"kind":"Name","value":"programLogo"}},{"kind":"Field","name":{"kind":"Name","value":"programGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matchingCap"}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessOperator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultProfileImage"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usesNewCommunications"}},{"kind":"Field","alias":{"kind":"Name","value":"studentContacts"},"name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"STUDENT_CONTACTS"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mentorContacts"},"name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"MENTOR_CONTACTS"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pendingStudentContactsNewComms"},"name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"STUDENT_CONTACTS"}},{"kind":"ObjectField","name":{"kind":"Name","value":"uploadedBefore"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fourDaysAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"activationStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activationStatus"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pendingMentorContactsNewComms"},"name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"MENTOR_CONTACTS"}},{"kind":"ObjectField","name":{"kind":"Name","value":"uploadedBefore"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fourDaysAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"activationStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activationStatus"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramActionItemsQuery, ProgramActionItemsQueryVariables>;
export const ProgramBenchmarkProgramListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramBenchmarkProgramList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramBenchmarkProgramListQuery, ProgramBenchmarkProgramListQueryVariables>;
export const ProgramBenchmarkDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramBenchmarkData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"satisfactionReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programSatisfaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorAverage"}},{"kind":"Field","name":{"kind":"Name","value":"studentAverage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"segmentSatisfaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorAverage"}},{"kind":"Field","name":{"kind":"Name","value":"studentAverage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousProgramSatisfaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorAverage"}},{"kind":"Field","name":{"kind":"Name","value":"studentAverage"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mentorContacts"},"name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"MENTOR_CONTACTS"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"studentContacts"},"name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"STUDENT_CONTACTS"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCountHavingCompletedMatchingSurvey"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"allStudents"},"name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCountHavingCompletedMatchingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"totalCountHavingSignedUpForTraining"}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementBenchmarkData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorshipsInPreviousProgramEngagedInLast30Days"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipsInPreviousProgramWith3OrMoreConversations"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipsInPreviousProgramWith0Conversations"}},{"kind":"Field","name":{"kind":"Name","value":"totalCountWithConversationInTheLast30Days"}},{"kind":"Field","name":{"kind":"Name","value":"totalCountWithThreeOrMoreConversations"}},{"kind":"Field","name":{"kind":"Name","value":"totalCountWithZeroConversations"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramBenchmarkDataQuery, ProgramBenchmarkDataQueryVariables>;
export const UserInfoForApmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInfoForApm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isPartner"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserInfoForApmQuery, UserInfoForApmQueryVariables>;
export const ContentfulModuleResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContentfulModuleResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPartner"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"participantGoals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resourceIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"id"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"topics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentfulModuleResource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"contentfulUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToMentor"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToMentee"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"examples"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContentfulModuleResourceQuery, ContentfulModuleResourceQueryVariables>;
export const MakeMatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MakeMatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allowRematch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"makeMatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mentorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"studentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"allowRematch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allowRematch"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Student"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"MATCHED"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mentor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capacity"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedSavedMatchId"}},{"kind":"Field","name":{"kind":"Name","value":"showAllowRematchConfirm"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<MakeMatchMutation, MakeMatchMutationVariables>;
export const MatchingDashboardProgramDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"matchingDashboardProgramData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"createdInAdminTool"}},{"kind":"Field","name":{"kind":"Name","value":"questionMdDisplay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"displayOnMatchingDashboard"}},{"kind":"Field","name":{"kind":"Name","value":"sortable"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"createdInAdminTool"}},{"kind":"Field","name":{"kind":"Name","value":"questionMdDisplay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"displayOnMatchingDashboard"}},{"kind":"Field","name":{"kind":"Name","value":"sortable"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MatchingDashboardProgramDataQuery, MatchingDashboardProgramDataQueryVariables>;
export const UpdateProgramNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgramNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgramInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProgramNotesMutation, UpdateProgramNotesMutationVariables>;
export const MarkParticipantMatchingHoldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkParticipantMatchingHold"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMatchingLabel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"participantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"matchingLabelKind"},"value":{"kind":"EnumValue","value":"MATCHING_HOLD"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matchingLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MarkParticipantMatchingHoldMutation, MarkParticipantMatchingHoldMutationVariables>;
export const RemoveParticipantMatchingHoldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveParticipantMatchingHold"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMatchingLabel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"participantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"matchingLabelKind"},"value":{"kind":"EnumValue","value":"MATCHING_HOLD"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matchingLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveParticipantMatchingHoldMutation, RemoveParticipantMatchingHoldMutationVariables>;
export const MatchingDashboardMentorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MatchingDashboardMentors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"majorAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"majorCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MentorUserProfileDataFields"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSpecificAttributes"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mentor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"MATCHED"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"megaphoneGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSupermentorGroup"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"completedMatchingSurveyAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastCompletedRequiredTrainingAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matchingLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedCachedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataMajor"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataTransferStatus"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataSupermentorOptIn"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MentorUserProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"user"}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_age"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_school_position"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"within_institution"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"all_programs"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"none"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":true}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataMentorCapacity"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<MatchingDashboardMentorsQuery, MatchingDashboardMentorsQueryVariables>;
export const MatchingDashboardMenteesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MatchingDashboardMentees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"menteeCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"menteeAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"majorAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"majorCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StudentUserProfileDataFields"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSpecificAttributes"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Student"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedMatchingSurveyAt"}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"MATCHED"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matchingLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedCachedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataMajor"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataTransferStatus"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataSupermentorOptIn"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StudentUserProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menteeAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menteeCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"user"}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_age"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_grade_level"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"within_institution"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"all_programs"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"none"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":true}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"}}]}}]} as unknown as DocumentNode<MatchingDashboardMenteesQuery, MatchingDashboardMenteesQueryVariables>;
export const UpdateParticipantNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateParticipantNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateParticipant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"participantInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateParticipantNotesMutation, UpdateParticipantNotesMutationVariables>;
export const CreateSavedMatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSavedMatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MatchingSource"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSavedMatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mentorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorId"}}},{"kind":"Argument","name":{"kind":"Name","value":"studentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedMatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"savedMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"savedMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSavedMatchMutation, CreateSavedMatchMutationVariables>;
export const MatchingDashboardSelectableProgramsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MatchingDashboardSelectablePrograms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramsSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MatchingDashboardSelectableProgramsQuery, MatchingDashboardSelectableProgramsQueryVariables>;
export const AutomaticSavedMatchesAggregateDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"automaticSavedMatchesAggregateData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sources"},"value":{"kind":"EnumValue","value":"AUTOMATIC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"queuedToBeMatched"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"adminUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uniquePrograms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"autoMatchStrategies"}}]}}]}}]} as unknown as DocumentNode<AutomaticSavedMatchesAggregateDataQuery, AutomaticSavedMatchesAggregateDataQueryVariables>;
export const SavedMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SavedMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SavedMatchesFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SavedMatchesSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"menteeCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"menteeAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"majorAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"majorCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MentorUserProfileDataFields"}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"megaphoneGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSupermentorGroup"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StudentUserProfileDataFields"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"autoMatchStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedCachedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataMajor"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataTransferStatus"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataSupermentorOptIn"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MentorUserProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"user"}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_age"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_school_position"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"within_institution"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"all_programs"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"none"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":true}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataMentorCapacity"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StudentUserProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menteeAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menteeCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"user"}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_age"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_grade_level"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"within_institution"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"all_programs"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"none"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":true}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"}}]}}]} as unknown as DocumentNode<SavedMatchesQuery, SavedMatchesQueryVariables>;
export const SavedMatchDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SavedMatchDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"savedMatchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"menteeCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"menteeAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"majorAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"majorCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityAttribute"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityCacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedMatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"savedMatchId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"additionalProgramSortingCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedMatchingSurveyAt"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StudentUserProfileDataFields"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSpecificAttributes"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MentorUserProfileDataFields"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSpecificAttributes"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedCachedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataMajor"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"majorCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataTransferStatus"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferStatusCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataSupermentorOptIn"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supermentorOptInCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StudentUserProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menteeAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menteeCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"user"}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_age"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_grade_level"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"within_institution"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"all_programs"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"none"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":true}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MentorUserProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"user"}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_age"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attributeType"},"value":{"kind":"EnumValue","value":"last_reported_school_position"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"within_institution"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"all_programs"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherPrograms"},"value":{"kind":"EnumValue","value":"none"}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowFallbackToOtherSource"},"value":{"kind":"BooleanValue","value":true}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatchingProfileDataFieldsWithCustomFallbacks"}},{"kind":"Field","alias":{"kind":"Name","value":"userProfileDataMentorCapacity"},"name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityAttribute"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorCapacityCacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<SavedMatchDetailsQuery, SavedMatchDetailsQueryVariables>;
export const DeleteSavedMatchesFromIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSavedMatchesFromIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"savedMatchIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSavedMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"savedMatchIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedCount"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSavedMatchesFromIdsMutation, DeleteSavedMatchesFromIdsMutationVariables>;
export const DeleteSavedMatchesFromFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSavedMatchesFromFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SavedMatchesFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"totalCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSavedMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"totalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"totalCount"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedCount"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSavedMatchesFromFilterMutation, DeleteSavedMatchesFromFilterMutationVariables>;
export const MakeSavedGroupMatchesFromIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MakeSavedGroupMatchesFromIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"savedMatchIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isSupermentorGroup"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addToExistingGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"makeSavedGroupMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"savedMatchIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"isSupermentorGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isSupermentorGroup"}}},{"kind":"Argument","name":{"kind":"Name","value":"addToExistingGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addToExistingGroup"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queuedGroupsCount"}},{"kind":"Field","name":{"kind":"Name","value":"queuedMatchesCount"}},{"kind":"Field","name":{"kind":"Name","value":"savedMatchIds"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MakeSavedGroupMatchesFromIdsMutation, MakeSavedGroupMatchesFromIdsMutationVariables>;
export const MakeSavedGroupMatchesFromFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MakeSavedGroupMatchesFromFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SavedMatchesFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"totalCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isSupermentorGroup"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"makeSavedGroupMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"totalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"totalCount"}}},{"kind":"Argument","name":{"kind":"Name","value":"isSupermentorGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isSupermentorGroup"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queuedGroupsCount"}},{"kind":"Field","name":{"kind":"Name","value":"queuedMatchesCount"}},{"kind":"Field","name":{"kind":"Name","value":"savedMatchIds"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MakeSavedGroupMatchesFromFilterMutation, MakeSavedGroupMatchesFromFilterMutationVariables>;
export const MakeSavedMatchesFromIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MakeSavedMatchesFromIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"savedMatchIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"makeSavedMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"savedMatchIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queuedMatchesCount"}},{"kind":"Field","name":{"kind":"Name","value":"savedMatchIds"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MakeSavedMatchesFromIdsMutation, MakeSavedMatchesFromIdsMutationVariables>;
export const MakeSavedMatchesFromFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MakeSavedMatchesFromFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SavedMatchesFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"totalCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"makeSavedMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"totalCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"totalCount"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queuedMatchesCount"}},{"kind":"Field","name":{"kind":"Name","value":"savedMatchIds"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MakeSavedMatchesFromFilterMutation, MakeSavedMatchesFromFilterMutationVariables>;
export const ManualSavedMatchesAggregateDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"manualSavedMatchesAggregateData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sources"},"value":{"kind":"EnumValue","value":"MANUAL"}},{"kind":"ObjectField","name":{"kind":"Name","value":"queuedToBeMatched"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"adminUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uniquePrograms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorSupermentorOptInTypes"}}]}}]}}]} as unknown as DocumentNode<ManualSavedMatchesAggregateDataQuery, ManualSavedMatchesAggregateDataQueryVariables>;
export const SavedMatchesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SavedMatchesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SavedMatchesFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<SavedMatchesCountQuery, SavedMatchesCountQueryVariables>;
export const BasicMentorInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BasicMentorInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorPostSessionSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"customizations"}},{"kind":"Field","name":{"kind":"Name","value":"createdInAdminTool"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chatGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BasicMentorInfoQuery, BasicMentorInfoQueryVariables>;
export const ProgramShortNameAndTitleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramShortNameAndTitle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<ProgramShortNameAndTitleQuery, ProgramShortNameAndTitleQueryVariables>;
export const UserInfoForCommunityPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInfoForCommunityPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserInfoForCommunityPageQuery, UserInfoForCommunityPageQueryVariables>;
export const LogWatchedCommunityVideoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LogWatchedCommunityVideo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ziggeoToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logWatchedCommunityVideo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"participantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ziggeoToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ziggeoToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"taskName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<LogWatchedCommunityVideoMutation, LogWatchedCommunityVideoMutationVariables>;
export const CommunityVideosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommunityVideos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedVideoFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadedVideoSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadedVideos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"ziggeoToken"}},{"kind":"Field","name":{"kind":"Name","value":"shareWithStudents"}},{"kind":"Field","name":{"kind":"Name","value":"sharePublicly"}},{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantProfileDataFragment"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParticipantProfileDataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<CommunityVideosQuery, CommunityVideosQueryVariables>;
export const MentorChatGroupsSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MentorChatGroupsSelect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"MATCHED"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MentorChatGroupsSelectQuery, MentorChatGroupsSelectQueryVariables>;
export const FlagsForMentorshipInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FlagsForMentorshipInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<FlagsForMentorshipInfoQuery, FlagsForMentorshipInfoQueryVariables>;
export const LogConversationForMentorshipInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LogConversationForMentorshipInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantProfileDataFragment"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentPostSessionSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorPostSessionSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantProfileDataFragment"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chatGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParticipantProfileDataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<LogConversationForMentorshipInfoQuery, LogConversationForMentorshipInfoQueryVariables>;
export const ParticipantDashboardFlagsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantDashboardFlagsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ParticipantDashboardFlagsCountQuery, ParticipantDashboardFlagsCountQueryVariables>;
export const ParticipantDashboardFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantDashboardFlags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"flagCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"relabeled"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalInfo"}},{"kind":"Field","name":{"kind":"Name","value":"supportPriority"}},{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantProfileDataFragment"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"showMentorsFlags"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"programCustomLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pluralMentee"}},{"kind":"Field","name":{"kind":"Name","value":"singularSchool"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParticipantProfileDataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<ParticipantDashboardFlagsQuery, ParticipantDashboardFlagsQueryVariables>;
export const WhatIsThisInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WhatIsThisInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<WhatIsThisInfoQuery, WhatIsThisInfoQueryVariables>;
export const ProgramLogoForHeaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramLogoForHeader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarHeight"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarWidth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"isPartner"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarHeight"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarWidth"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"webappBaseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"programLogo"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramLogoForHeaderQuery, ProgramLogoForHeaderQueryVariables>;
export const ParticipantDashboardIndexDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantDashboardIndex"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarHeight"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarWidth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSignInAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMentorInChatGroup"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantDashboardHomeCallToActionFragment"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"prioritizedAndPendingForRematching"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"completedMatchingSurveyAt"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mentor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredTrainingStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"optional"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Student"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantProfileDataFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantProfileDataFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMatched"}},{"kind":"Field","name":{"kind":"Name","value":"studentIsDisengaged"}},{"kind":"Field","name":{"kind":"Name","value":"mentorIsDisengaged"}},{"kind":"Field","name":{"kind":"Name","value":"chatGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarHeight"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarWidth"}}}]}}]}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantProfileDataFragment"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"shareMenteePhone"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarHeight"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarWidth"}}}]}}]}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantProfileDataFragment"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentReachedOutAt"}},{"kind":"Field","name":{"kind":"Name","value":"mentorReachedOutAt"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParticipantDashboardHomeCallToActionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSignInAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMentorInChatGroup"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"completedMatchingSurveyAt"}},{"kind":"Field","name":{"kind":"Name","value":"pushedThroughToMatch"}},{"kind":"Field","name":{"kind":"Name","value":"prioritizedAndPendingForRematching"}},{"kind":"Field","name":{"kind":"Name","value":"matchingLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mentor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allowedToSkipMatchingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"requiredTrainingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"mentorTrainingCourseLink"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMatched"}},{"kind":"Field","name":{"kind":"Name","value":"matchDate"}},{"kind":"Field","name":{"kind":"Name","value":"unmatchDate"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParticipantProfileDataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<ParticipantDashboardIndexQuery, ParticipantDashboardIndexQueryVariables>;
export const ProgramTaskAssignmentsForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramTaskAssignmentsForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"participantIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CourseTaskAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseId"}},{"kind":"Field","name":{"kind":"Name","value":"participantId"}},{"kind":"Field","name":{"kind":"Name","value":"behavior"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClickLinkTaskAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"participantId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentSurveyTaskAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"programStage"}},{"kind":"Field","name":{"kind":"Name","value":"participantId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"completedMatchingSurveyAt"}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMatched"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mentor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainingSignupLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activityLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"loggedAtDate"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WatchedVideoLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wistiaVideoId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TookTypeformSurveyLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrainingEventLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"uploadedVideos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"writtenMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveyResponses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultProfileImage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"reRecruitedMentorsCanSkipMatchingSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"currentStage"}},{"kind":"Field","name":{"kind":"Name","value":"mentorTrainingTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"programSpecific"}},{"kind":"Field","name":{"kind":"Name","value":"toBeCompletedAs"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"customCallToAction"}},{"kind":"Field","name":{"kind":"Name","value":"customAfterCallToAction"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleTrainingTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calendlyUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TakeSurveyTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TakeExternalLinkTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WatchVideoTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wistiaVideoId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultProfileImage"}},{"kind":"Field","name":{"kind":"Name","value":"programTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"programSpecific"}},{"kind":"Field","name":{"kind":"Name","value":"toBeCompletedAs"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"customCallToAction"}},{"kind":"Field","name":{"kind":"Name","value":"customAfterCallToAction"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleTrainingTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calendlyUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TakeSurveyTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TakeExternalLinkTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WatchVideoTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wistiaVideoId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramTaskAssignmentsForUserQuery, ProgramTaskAssignmentsForUserQueryVariables>;
export const CompleteTaskAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteTaskAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskAssignmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeTaskAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskAssignmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskAssignmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskAssignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClickLinkTaskAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"participantId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompleteTaskAssignmentMutation, CompleteTaskAssignmentMutationVariables>;
export const LogTookTypeformSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LogTookTypeformSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalLinkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logTookTypeformSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"participantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"externalLinkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalLinkId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activityLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"loggedAtDate"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WatchedVideoLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wistiaVideoId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TookTypeformSurveyLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrainingEventLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LogTookTypeformSurveyMutation, LogTookTypeformSurveyMutationVariables>;
export const LogWatchedWistiaVideoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LogWatchedWistiaVideo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wistiaVideoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logWatchedWistiaVideo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"participantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"wistiaVideoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wistiaVideoId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activityLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"loggedAtDate"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WatchedVideoLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wistiaVideoId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TookTypeformSurveyLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrainingEventLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LogWatchedWistiaVideoMutation, LogWatchedWistiaVideoMutationVariables>;
export const UserInfoForParticipantDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInfoForParticipantDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"isPartner"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"showMentorsFlags"}},{"kind":"Field","name":{"kind":"Name","value":"programLogo"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserInfoForParticipantDashboardQuery, UserInfoForParticipantDashboardQueryVariables>;
export const UnmatchParticipantWithDisengagedCounterpartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnmatchParticipantWithDisengagedCounterpart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"initiatedBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnmatchInitiatedBy"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wantsRematch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unmatchReason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnmatchReason"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requesterNotes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendUnmatchingEmails"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reasonToShareWithMentee"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reasonToShareWithMentor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unmatchParticipant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mentorshipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}}},{"kind":"Argument","name":{"kind":"Name","value":"initiatedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"initiatedBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"wantsRematch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wantsRematch"}}},{"kind":"Argument","name":{"kind":"Name","value":"unmatchReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unmatchReason"}}},{"kind":"Argument","name":{"kind":"Name","value":"requesterNotes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requesterNotes"}}},{"kind":"Argument","name":{"kind":"Name","value":"sendUnmatchingEmails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendUnmatchingEmails"}}},{"kind":"Argument","name":{"kind":"Name","value":"reasonToShareWithMentee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reasonToShareWithMentee"}}},{"kind":"Argument","name":{"kind":"Name","value":"reasonToShareWithMentor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reasonToShareWithMentor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMatched"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prioritizedAndPendingForRematching"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mentor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capacity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMatched"}},{"kind":"Field","name":{"kind":"Name","value":"matchDate"}},{"kind":"Field","name":{"kind":"Name","value":"unmatchDate"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UnmatchParticipantWithDisengagedCounterpartMutation, UnmatchParticipantWithDisengagedCounterpartMutationVariables>;
export const CannotGetInTouchFlowInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CannotGetInTouchFlowInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarHeight"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarWidth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMatched"}},{"kind":"Field","name":{"kind":"Name","value":"studentIsDisengaged"}},{"kind":"Field","name":{"kind":"Name","value":"mentorIsDisengaged"}},{"kind":"Field","name":{"kind":"Name","value":"menteeSmsRelayPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mentorSmsRelayPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarHeight"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarWidth"}}}]}}]}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantProfileDataFragment"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"studentPointPersonFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"studentPointPersonLastName"}},{"kind":"Field","name":{"kind":"Name","value":"studentPointPersonTitle"}},{"kind":"Field","name":{"kind":"Name","value":"studentPointPersonEmail"}},{"kind":"Field","name":{"kind":"Name","value":"mentorPointPersonFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"mentorPointPersonLastName"}},{"kind":"Field","name":{"kind":"Name","value":"mentorPointPersonTitle"}},{"kind":"Field","name":{"kind":"Name","value":"mentorPointPersonEmail"}},{"kind":"Field","name":{"kind":"Name","value":"shareMenteeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"shareMentorEmail"}},{"kind":"Field","name":{"kind":"Name","value":"shareMenteePhone"}},{"kind":"Field","name":{"kind":"Name","value":"shareMentorPhone"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarHeight"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarWidth"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantProfileDataFragment"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParticipantProfileDataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<CannotGetInTouchFlowInfoQuery, CannotGetInTouchFlowInfoQueryVariables>;
export const ParticipantDashboardDeregistrationInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantDashboardDeregistrationInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MatchedStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deregistrationReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"grouping"}},{"kind":"Field","name":{"kind":"Name","value":"participantFacingName"}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantDashboardDeregistrationInfoQuery, ParticipantDashboardDeregistrationInfoQueryVariables>;
export const IndividualMentorshipConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IndividualMentorshipConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postSessionSurveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipContext"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyResponseContextFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyResponses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postSessionSurveyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipContext"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"surveyResponseAnswerStrings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"questionPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"subprompt"}},{"kind":"Field","name":{"kind":"Name","value":"answerString"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IndividualMentorshipConversationQuery, IndividualMentorshipConversationQueryVariables>;
export const MentorshipFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MentorshipFlags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flagsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flagsSort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programCustomLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"singularMentee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flagsFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flagsSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"flagCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"relabeled"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalInfo"}},{"kind":"Field","name":{"kind":"Name","value":"supportPriority"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MentorshipFlagsQuery, MentorshipFlagsQueryVariables>;
export const StudentGoalResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudentGoalResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentGoalIdentifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"goalIdentifiers"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"studentGoalIdentifier"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"topics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentfulModuleResource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StudentGoalResourcesQuery, StudentGoalResourcesQueryVariables>;
export const IndividualMentorshipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IndividualMentorship"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarHeight"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatarWidth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"studentIsDisengaged"}},{"kind":"Field","name":{"kind":"Name","value":"mentorIsDisengaged"}},{"kind":"Field","name":{"kind":"Name","value":"mentorConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topics"}},{"kind":"Field","name":{"kind":"Name","value":"modesOfCommunication"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topics"}},{"kind":"Field","name":{"kind":"Name","value":"modesOfCommunication"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorSmsRelayPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"menteeSmsRelayPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"chatGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarHeight"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarWidth"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorPostSessionSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentPostSessionSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shareMentorEmail"}},{"kind":"Field","name":{"kind":"Name","value":"shareMentorPhone"}},{"kind":"Field","name":{"kind":"Name","value":"shareMenteeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"shareMenteePhone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programGoal"}},{"kind":"Field","name":{"kind":"Name","value":"questionForMentor"}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantProfileDataFragment"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarHeight"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatarWidth"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantProfileDataFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParticipantProfileDataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<IndividualMentorshipQuery, IndividualMentorshipQueryVariables>;
export const UserParticipantDashboardNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userParticipantDashboardNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestOrigin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"microSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetingCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programIds"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestDashboardNotificationData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"requestOrigin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestOrigin"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayMedium"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"markdownBody"}},{"kind":"Field","name":{"kind":"Name","value":"buttonOneText"}},{"kind":"Field","name":{"kind":"Name","value":"notificationViewableType"}},{"kind":"Field","name":{"kind":"Name","value":"notificationViewableId"}}]}}]}}]}}]} as unknown as DocumentNode<UserParticipantDashboardNotificationQuery, UserParticipantDashboardNotificationQueryVariables>;
export const CreateNotificationViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNotificationView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationViewableType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationViewableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayMedium"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNotificationView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"notificationViewableType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationViewableType"}}},{"kind":"Argument","name":{"kind":"Name","value":"notificationViewableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationViewableId"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayMedium"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayMedium"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateNotificationViewMutation, CreateNotificationViewMutationVariables>;
export const IndividualResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IndividualResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"id"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<IndividualResourceQuery, IndividualResourceQueryVariables>;
export const ParticipantDashboardGoalsFilterOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantDashboardGoalsFilterOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participantGoals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"attachedToResourcesInProgramId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantDashboardGoalsFilterOptionsQuery, ParticipantDashboardGoalsFilterOptionsQueryVariables>;
export const ParticipantDashboardTopicsFilterOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantDashboardTopicsFilterOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceTopics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attachedToResourcesWithProgramIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"programId"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantDashboardTopicsFilterOptionsQuery, ParticipantDashboardTopicsFilterOptionsQueryVariables>;
export const ParticipantDashboardResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantDashboardResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramResourcesFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"topics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantDashboardResourcesQuery, ParticipantDashboardResourcesQueryVariables>;
export const UserInformationForSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInformationForSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"signedUpWithSso"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserInformationForSettingsQuery, UserInformationForSettingsQueryVariables>;
export const UpdateUserInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateUserInformationMutation, UpdateUserInformationMutationVariables>;
export const UserAvatarsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserAvatars"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]} as unknown as DocumentNode<UserAvatarsQuery, UserAvatarsQueryVariables>;
export const CurrentProgramShortNameForParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentProgramShortNameForParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentProgramShortNameForParticipantQuery, CurrentProgramShortNameForParticipantQueryVariables>;
export const SaveWrittenMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveWrittenMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareWithStudents"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sharePublicly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"NullValue"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveWrittenMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"participantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareWithStudents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareWithStudents"}}},{"kind":"Argument","name":{"kind":"Name","value":"sharePublicly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sharePublicly"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"writtenMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SaveWrittenMessageMutation, SaveWrittenMessageMutationVariables>;
export const CreateUploadedVideoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUploadedVideo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ziggeoToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sharePublicly"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareWithStudents"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUploadedVideo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"participantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ziggeoToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ziggeoToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"sharePublicly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sharePublicly"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareWithStudents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareWithStudents"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedVideos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ziggeoToken"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateUploadedVideoMutation, CreateUploadedVideoMutationVariables>;
export const EmailForParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmailForParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<EmailForParticipantQuery, EmailForParticipantQueryVariables>;
export const UserParticipantsForTaskAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserParticipantsForTaskAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registered"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"registered"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registered"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UserParticipantsForTaskAssignmentQuery, UserParticipantsForTaskAssignmentQueryVariables>;
export const PartnerDashboardActivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardActivities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityLogsSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityLogsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeMathingSurveyResponses"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"activityLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"loggableActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeMathingSurveyResponses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeMathingSurveyResponses"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mentor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNameFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Student"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNameFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Flag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNameFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNameFragment"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mentorship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNameFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNameFragment"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrainingEventLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNameFragment"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyResponseAnswerStrings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questionPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"answerString"}},{"kind":"Field","name":{"kind":"Name","value":"subprompt"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"respondent"},"name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNameFragment"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StudentContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNameFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MentorContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNameFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeregistrationStatusEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deregistrationReason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNameFragment"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentScoreResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserNameFragment"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserNameFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardActivitiesQuery, PartnerDashboardActivitiesQueryVariables>;
export const CommunityMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommunityMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WrittenMessageFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WrittenMessageSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writtenMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParticipantProfileDataFragment"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultProfileImage"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParticipantProfileDataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Participant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<CommunityMessagesQuery, CommunityMessagesQueryVariables>;
export const ProgramInfoForPartnerDashboardHeaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramInfoForPartnerDashboardHeader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"programLogo"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramInfoForPartnerDashboardHeaderQuery, ProgramInfoForPartnerDashboardHeaderQueryVariables>;
export const UserInfoForPartnerDashboardNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInfoForPartnerDashboardNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastProgramPageVisit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode<UserInfoForPartnerDashboardNotificationsQuery, UserInfoForPartnerDashboardNotificationsQueryVariables>;
export const ReviewMatchingSurveyForPartnerDashboardNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReviewMatchingSurveyForPartnerDashboardNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"occurredAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"showMatchingSurveysToPartner"}},{"kind":"Field","name":{"kind":"Name","value":"activityLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"occurredAfter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalInitialMatchingSurveyReviewNotificationCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalMatchingSurveyUpdatedReviewNotificationCount"}}]}}]}}]}}]} as unknown as DocumentNode<ReviewMatchingSurveyForPartnerDashboardNotificationsQuery, ReviewMatchingSurveyForPartnerDashboardNotificationsQueryVariables>;
export const ActivitiesForPartnerDashboardNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActivitiesForPartnerDashboardNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"occurredAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeEventTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityLogEvent"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivityLogEvent"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activityLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"occurredAfter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"excludeEventTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeEventTypes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"eventTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventTypes"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<ActivitiesForPartnerDashboardNotificationsQuery, ActivitiesForPartnerDashboardNotificationsQueryVariables>;
export const FlagsForPartnerDashboardNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FlagsForPartnerDashboardNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"occurredAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activityLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"occurredAfter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalFlagReportedCount"}}]}}]}}]}}]} as unknown as DocumentNode<FlagsForPartnerDashboardNotificationsQuery, FlagsForPartnerDashboardNotificationsQueryVariables>;
export const LowAssessmentScoresForPartnerDashboardNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LowAssessmentScoresForPartnerDashboardNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"occurredAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activityLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"occurredAfter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalLowSobAssessmentScoreSubmittedCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalLowAseAssessmentScoreSubmittedCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalLowCdseAssessmentScoreSubmittedCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalLowAhsAssessmentScoreSubmittedCount"}}]}}]}}]}}]} as unknown as DocumentNode<LowAssessmentScoresForPartnerDashboardNotificationsQuery, LowAssessmentScoresForPartnerDashboardNotificationsQueryVariables>;
export const UserInfoForUserMenuDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInfoForUserMenu"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"isPartner"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"registered"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserInfoForUserMenuQuery, UserInfoForUserMenuQueryVariables>;
export const PartnerDashboardProgramMetricsAverageAssessmentScoresDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsAverageAssessmentScores"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"intervalBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentScoresGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentScoreResponsesFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessmentScoreResponses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"averageAssessmentScore"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intervalBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsAverageAssessmentScoresQuery, PartnerDashboardProgramMetricsAverageAssessmentScoresQueryVariables>;
export const PartnerDashboardAssessmentAreaScoreDistributionChartDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardAssessmentAreaScoreDistributionChartData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardAssessmentAreaScoreDistributionChartDataQuery, PartnerDashboardAssessmentAreaScoreDistributionChartDataQueryVariables>;
export const PartnerDashboardProgramAssessmentAreasPromptsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramAssessmentAreasPrompts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programAssessmentAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enabledForMentees"}},{"kind":"Field","name":{"kind":"Name","value":"enabledForMentors"}},{"kind":"Field","name":{"kind":"Name","value":"scaleMax"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentPrompts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramAssessmentAreasPromptsQuery, PartnerDashboardProgramAssessmentAreasPromptsQueryVariables>;
export const PartnerDashboardAverageAssessmentScorePerPromptChartDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardAverageAssessmentScorePerPromptChartData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentScoreResponsesFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"intervalBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentScoresGroupBy"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessmentScoreResponses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"averageAssessmentScore"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intervalBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"sampleSize"}},{"kind":"Field","name":{"kind":"Name","value":"valueType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardAverageAssessmentScorePerPromptChartDataQuery, PartnerDashboardAverageAssessmentScorePerPromptChartDataQueryVariables>;
export const PartnerDashboardEngagementTopicConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardEngagementTopicConversations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalConversationsLogged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardEngagementTopicConversationsQuery, PartnerDashboardEngagementTopicConversationsQueryVariables>;
export const PartnerDashboardEngagementTopicFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardEngagementTopicFlags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalFlagged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardEngagementTopicFlagsQuery, PartnerDashboardEngagementTopicFlagsQueryVariables>;
export const PartnerDashboardDisengagementResolutionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardDisengagementResolutions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disengagementEventDateFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disengagementResolutions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"disengagementEventDateFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disengagementEventDateFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disengagementResolutionsAverageTimeToRematch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"disengagementEventDateFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disengagementEventDateFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"averageRematchTimeInDays"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardDisengagementResolutionsQuery, PartnerDashboardDisengagementResolutionsQueryVariables>;
export const ProgramAdditionalFunnelInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramAdditionalFunnelInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainingMode"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}}]} as unknown as DocumentNode<ProgramAdditionalFunnelInfoQuery, ProgramAdditionalFunnelInfoQueryVariables>;
export const MentorTrainingAdditionalFunnelInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MentorTrainingAdditionalFunnelInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCredentialed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"EnumValue","value":"MILLENNIUM"}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MentorTrainingAdditionalFunnelInfoQuery, MentorTrainingAdditionalFunnelInfoQueryVariables>;
export const OnboardingMenteesWaitingToBeMatchedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnboardingMenteesWaitingToBeMatched"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"statusInProgram"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"statuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"COMPLETED_ONBOARDING"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"contactsParticipantsFilter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participants"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"STUDENTS"}},{"kind":"ObjectField","name":{"kind":"Name","value":"programIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"programId"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<OnboardingMenteesWaitingToBeMatchedQuery, OnboardingMenteesWaitingToBeMatchedQueryVariables>;
export const PartnerDashboardTopMentorRecruitmentOpportunitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardTopMentorRecruitmentOpportunities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentsUsersFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorsUsersFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityArea"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityArea"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recruitmentOpportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"studentsUsersFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentsUsersFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"mentorsUsersFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorsUsersFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"opportunityArea"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityArea"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributeType"}},{"kind":"Field","name":{"kind":"Name","value":"attributeValue"}},{"kind":"Field","name":{"kind":"Name","value":"menteesWaiting"}},{"kind":"Field","name":{"kind":"Name","value":"mentorsCount"}},{"kind":"Field","name":{"kind":"Name","value":"mentorsOpenSlots"}},{"kind":"Field","name":{"kind":"Name","value":"mentorsGap"}},{"kind":"Field","name":{"kind":"Name","value":"strongestPreferenceKey"}},{"kind":"Field","name":{"kind":"Name","value":"strongestPreferenceDisplayValue"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardTopMentorRecruitmentOpportunitiesQuery, PartnerDashboardTopMentorRecruitmentOpportunitiesQueryVariables>;
export const PartnerDashboardProgramAsksStrongestPreferenceInMenteeMatchingSurveyAndProfileAttributesExistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramAsksStrongestPreferenceInMenteeMatchingSurveyAndProfileAttributesExist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asksStrongestPreferenceQuestionInMenteeMatchingSurveyAndProfileAttributesExist"}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramAsksStrongestPreferenceInMenteeMatchingSurveyAndProfileAttributesExistQuery, PartnerDashboardProgramAsksStrongestPreferenceInMenteeMatchingSurveyAndProfileAttributesExistQueryVariables>;
export const PartnerDashboardProgramHasMatchingSuveysMigratedFromOldFrameworkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramHasMatchingSuveysMigratedFromOldFramework"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasMatchingSuveysMigratedFromOldFramework"}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramHasMatchingSuveysMigratedFromOldFrameworkQuery, PartnerDashboardProgramHasMatchingSuveysMigratedFromOldFrameworkQueryVariables>;
export const RecruitmentOpportunitiesExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecruitmentOpportunitiesExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentsUsersFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorsUsersFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityArea"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityArea"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvExportContext"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvExportContextInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csvExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recruitmentOpportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"studentsUsersFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentsUsersFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"mentorsUsersFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorsUsersFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"opportunityArea"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityArea"}}},{"kind":"Argument","name":{"kind":"Name","value":"csvExportContext"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvExportContext"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<RecruitmentOpportunitiesExportQuery, RecruitmentOpportunitiesExportQueryVariables>;
export const OnboardingAndMatchingContactsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnboardingAndMatchingContactsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"intervalBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalInvited"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intervalBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OnboardingAndMatchingContactsDataQuery, OnboardingAndMatchingContactsDataQueryVariables>;
export const OnboardingAndMatchingParticipantsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnboardingAndMatchingParticipantsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"intervalBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalMatchingSurveyCompleted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intervalBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCredentialed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intervalBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalMatched"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intervalBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalRegistered"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intervalBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OnboardingAndMatchingParticipantsDataQuery, OnboardingAndMatchingParticipantsDataQueryVariables>;
export const LogProgramPageVisitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LogProgramPageVisit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProgramPageVisit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programPageVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode<LogProgramPageVisitMutation, LogProgramPageVisitMutationVariables>;
export const FilteredConversationsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilteredConversationsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantConversationContentsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participantConversationContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<FilteredConversationsCountQuery, FilteredConversationsCountQueryVariables>;
export const AllConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllConversations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantConversationContentsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantConversationContentsSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participantConversationContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"submittedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"participantConversationType"}},{"kind":"Field","name":{"kind":"Name","value":"participantConversationCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversationLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<AllConversationsQuery, AllConversationsQueryVariables>;
export const ProgramInfoForPartnerDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"programInfoForPartnerDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currentPhase"}},{"kind":"Field","name":{"kind":"Name","value":"currentStage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"programGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentOpeningAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentMidAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentEndAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorOpeningAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMidAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorEndAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programAssessmentAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enabledForMentees"}},{"kind":"Field","name":{"kind":"Name","value":"enabledForMentors"}},{"kind":"Field","name":{"kind":"Name","value":"scaleMax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredMentorTrainingCredential"}}]}}]}}]} as unknown as DocumentNode<ProgramInfoForPartnerDashboardQuery, ProgramInfoForPartnerDashboardQueryVariables>;
export const PartnerDashboardUpdateUserInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PartnerDashboardUpdateUserInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"higherEdCategory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HigherEdCategory"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"higherEdRole"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HigherEdRole"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePartner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationType"}}},{"kind":"Argument","name":{"kind":"Name","value":"higherEdCategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"higherEdCategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"higherEdRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"higherEdRole"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdCategory"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdRole"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardUpdateUserInformationMutation, PartnerDashboardUpdateUserInformationMutationVariables>;
export const SurveyInfoForPartnerDashboardExportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveyInfoForPartnerDashboardExports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentStage"}},{"kind":"Field","name":{"kind":"Name","value":"studentOpeningAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorOpeningAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentMidAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMidAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentEndAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorEndAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SurveyInfoForPartnerDashboardExportsQuery, SurveyInfoForPartnerDashboardExportsQueryVariables>;
export const ProgramMatchingSurveysExportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramMatchingSurveysExports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentorMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProgramMatchingSurveysExportsQuery, ProgramMatchingSurveysExportsQueryVariables>;
export const ProgramMicroSurveysExportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramMicroSurveysExports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"microSurveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasResponses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramMicroSurveysExportsQuery, ProgramMicroSurveysExportsQueryVariables>;
export const PartnerDashboardUsersCsvExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardUsersCsvExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvExportContext"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvExportContextInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileDataColumns"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataColumnInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstColumn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersExportFirstColumn"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resultModifiers"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersExportResultModifiers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csvExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerDashboardExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"csvExportContext"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvExportContext"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileDataColumns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileDataColumns"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstColumn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstColumn"}}},{"kind":"Argument","name":{"kind":"Name","value":"resultModifiers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resultModifiers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardUsersCsvExportQuery, PartnerDashboardUsersCsvExportQueryVariables>;
export const PartnerDashboardMentorshipsExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardMentorshipsExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileDataColumns"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataColumnInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvExportContext"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvExportContextInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeTouchpointMetrics"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resultModifiers"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsExportResultModifiers"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exportType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsExport"}},"defaultValue":{"kind":"EnumValue","value":"DEFAULT"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csvExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerDashboardExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileDataColumns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileDataColumns"}}},{"kind":"Argument","name":{"kind":"Name","value":"csvExportContext"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvExportContext"}}},{"kind":"Argument","name":{"kind":"Name","value":"exportType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exportType"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeTouchpointMetrics"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeTouchpointMetrics"}}},{"kind":"Argument","name":{"kind":"Name","value":"resultModifiers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resultModifiers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardMentorshipsExportQuery, PartnerDashboardMentorshipsExportQueryVariables>;
export const PartnerDashboardFlagsExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardFlagsExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvExportContext"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvExportContextInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileDataColumns"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataColumnInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csvExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerDashboardExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileDataColumns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileDataColumns"}}},{"kind":"Argument","name":{"kind":"Name","value":"csvExportContext"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvExportContext"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardFlagsExportQuery, PartnerDashboardFlagsExportQueryVariables>;
export const PartnerDashboardConversationsExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardConversationsExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantConversationContentsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvExportContext"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvExportContextInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileDataColumns"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataColumnInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csvExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerDashboardExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"csvExportContext"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvExportContext"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileDataColumns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileDataColumns"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardConversationsExportQuery, PartnerDashboardConversationsExportQueryVariables>;
export const PartnerDashboardExportsProgramProfileAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardExportsProgramProfileAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programProfileAttributeCategoriesProgramId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MCID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programProfileAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardExports"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"programProfileAttributeCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programProfileAttributeCategoriesProgramId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardExportsProgramProfileAttributesQuery, PartnerDashboardExportsProgramProfileAttributesQueryVariables>;
export const SurveyResponsesForExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveyResponsesForExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"context"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvExportContextInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csvExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyResponses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"csvExportContext"},"value":{"kind":"Variable","name":{"kind":"Name","value":"context"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessing"}}]}}]}}]}}]} as unknown as DocumentNode<SurveyResponsesForExportQuery, SurveyResponsesForExportQueryVariables>;
export const UpdateFlagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFlag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerNotes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFlag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerNotes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerNotes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"partnerNotes"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateFlagMutation, UpdateFlagMutationVariables>;
export const FilteredFlagsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilteredFlagsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<FilteredFlagsCountQuery, FilteredFlagsCountQueryVariables>;
export const FlagsForDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FlagsFor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"supportPriority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"partnerNotes"}},{"kind":"Field","name":{"kind":"Name","value":"additionalInfo"}},{"kind":"Field","name":{"kind":"Name","value":"flagCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"relabeled"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"submittedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participantConversationContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participantConversationType"}},{"kind":"Field","name":{"kind":"Name","value":"confidenceScore"}},{"kind":"Field","name":{"kind":"Name","value":"confidenceNotes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"participantConversationCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<FlagsForQuery, FlagsForQueryVariables>;
export const UserInfoForPartnerDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInfoForPartnerDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESCENDING"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"registered"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdRole"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdCategory"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ssoEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"ssoRequiredForPartners"}},{"kind":"Field","name":{"kind":"Name","value":"ssoProviderIdentifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"registered"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"registered"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registered"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UserInfoForPartnerDashboardQuery, UserInfoForPartnerDashboardQueryVariables>;
export const UserSsoInfoForPartnerDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSsoInfoForPartnerDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"CREATED_AT"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESCENDING"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidSsoToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}]},{"kind":"Field","name":{"kind":"Name","value":"partners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"registered"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdRole"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdCategory"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ssoEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"ssoRequiredForPartners"}},{"kind":"Field","name":{"kind":"Name","value":"ssoProviderIdentifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registered"}}]}}]}}]}}]} as unknown as DocumentNode<UserSsoInfoForPartnerDashboardQuery, UserSsoInfoForPartnerDashboardQueryVariables>;
export const MentorshipSurveyResponsesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MentorshipSurveyResponses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyResponsesFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyResponsesSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qidFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyResponseAnswerStringsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"combinedMenteeMentorSurveyResponses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveyResponseAnswerStrings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qidFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"questionPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"answerString"}},{"kind":"Field","name":{"kind":"Name","value":"subprompt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<MentorshipSurveyResponsesQuery, MentorshipSurveyResponsesQueryVariables>;
export const SendUpdateEmailDraftForMentorshipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendUpdateEmailDraftForMentorship"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendUpdateEmailDraftForMentorship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mentorshipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"notice"}}]}}]}}]} as unknown as DocumentNode<SendUpdateEmailDraftForMentorshipMutation, SendUpdateEmailDraftForMentorshipMutationVariables>;
export const ProgramMentorshipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramMentorship"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flagsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matchDate"}},{"kind":"Field","name":{"kind":"Name","value":"unmatchDate"}},{"kind":"Field","name":{"kind":"Name","value":"unmatchReason"}},{"kind":"Field","name":{"kind":"Name","value":"unmatchNotes"}},{"kind":"Field","name":{"kind":"Name","value":"commonQualities"}},{"kind":"Field","name":{"kind":"Name","value":"mentorConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flagsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastConversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"loggedAtDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answerText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MentorshipDetailsUser"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MentorshipDetailsUser"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MentorshipDetailsUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInUrl"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]} as unknown as DocumentNode<ProgramMentorshipQuery, ProgramMentorshipQueryVariables>;
export const MentorshipPriorityFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MentorshipPriorityFlags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flagsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flagsFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"additionalInfo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"flagCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"relabeled"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"submittedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<MentorshipPriorityFlagsQuery, MentorshipPriorityFlagsQueryVariables>;
export const PartnerDashboardMentorshipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardMentorships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flagsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"showMatchingSurveysToPartner"}},{"kind":"Field","name":{"kind":"Name","value":"mentorMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"migrated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"migrated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matchDate"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flagsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedCachedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}}]} as unknown as DocumentNode<PartnerDashboardMentorshipsQuery, PartnerDashboardMentorshipsQueryVariables>;
export const PartnerDashboardMentorshipsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardMentorshipsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardMentorshipsCountQuery, PartnerDashboardMentorshipsCountQueryVariables>;
export const ProgramMatchingSurveysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramMatchingSurveys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showMatchingSurveysToPartner"}}]}}]}}]} as unknown as DocumentNode<ProgramMatchingSurveysQuery, ProgramMatchingSurveysQueryVariables>;
export const DeregisterParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeregisterParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeregisterParticipantInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deregisterParticipant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deregisterParticipantInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode<DeregisterParticipantMutation, DeregisterParticipantMutationVariables>;
export const PartnerDashboardDeregistrationReasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardDeregistrationReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deregistrationReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"grouping"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardDeregistrationReasonsQuery, PartnerDashboardDeregistrationReasonsQueryVariables>;
export const ParticipantMentorshipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantMentorships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participantMentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matchDate"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversationLogsCount"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantMentorshipsQuery, ParticipantMentorshipsQueryVariables>;
export const UserParticipantAndContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserParticipantAndContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flagsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileAttributeSource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileDataFallbackRule"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"requiredMentorTrainingCredential"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipCredentials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"credentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipCredential"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credential"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackRules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackRules"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedProfileDataFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"100"}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInUrl"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userStatusInProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}]},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Student"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionForMentor"}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answerText"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMatched"}},{"kind":"Field","name":{"kind":"Name","value":"flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flagsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversationLogsCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deregistrationStatusEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"otherReasonNotes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deregistrationReason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserProfileData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openResponse"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfileAttributeValueUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<UserParticipantAndContactQuery, UserParticipantAndContactQueryVariables>;
export const ConversationTopicCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConversationTopicCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"segment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramSegment"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationTopicCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"segment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"segment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ConversationTopicCategoriesQuery, ConversationTopicCategoriesQueryVariables>;
export const PartnerDashboardParticipantsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardParticipantsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardParticipantsCountQuery, PartnerDashboardParticipantsCountQueryVariables>;
export const PartnerDashboardParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cacheSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataSettingsFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registered"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredMentorTrainingCredential"}},{"kind":"Field","name":{"kind":"Name","value":"defaultProfileImage"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cachedUserProfileData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAttributes"}}},{"kind":"Argument","name":{"kind":"Name","value":"cacheSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cacheSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SharedCachedProfileDataFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"80"}},{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"80"}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"userStatusInProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}]},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"registered"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registered"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Student"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answerKey"}},{"kind":"Field","name":{"kind":"Name","value":"answerText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uploadedDate"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SharedCachedProfileDataFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CachedUserProfileDataAttributeValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}}]} as unknown as DocumentNode<PartnerDashboardParticipantsQuery, PartnerDashboardParticipantsQueryVariables>;
export const PartnerDashboardProgramStudentGoalsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramStudentGoalsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"studentGoalsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerKey"}},{"kind":"Field","name":{"kind":"Name","value":"answerText"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramStudentGoalsListQuery, PartnerDashboardProgramStudentGoalsListQueryVariables>;
export const SurveyCustomizationsForProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveyCustomizationsForProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyQuestionFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentorMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"customizationOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"migrated"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"customizationOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"migrated"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<SurveyCustomizationsForProgramQuery, SurveyCustomizationsForProgramQueryVariables>;
export const LatestPsmForSchoolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LatestPsmForSchool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"schoolId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latestPartnerProgramForSchool"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"schoolId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"schoolId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LatestPsmForSchoolQuery, LatestPsmForSchoolQueryVariables>;
export const PartnerDashboardProgramMetricsContactsTotalInvitedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsContactsTotalInvited"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalInvited"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsContactsTotalInvitedQuery, PartnerDashboardProgramMetricsContactsTotalInvitedQueryVariables>;
export const PartnerDashboardCredentialedParticipantMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardCredentialedParticipantMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalCredentialed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardCredentialedParticipantMetricsQuery, PartnerDashboardCredentialedParticipantMetricsQueryVariables>;
export const PartnerDashboardProgramMetricsParticipantsTotalMatchedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsParticipantsTotalMatched"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalMatched"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsParticipantsTotalMatchedQuery, PartnerDashboardProgramMetricsParticipantsTotalMatchedQueryVariables>;
export const PartnerDashboardProgramMetricsParticipantsTotalMatchingSurveyCompletedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsParticipantsTotalMatchingSurveyCompleted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalMatchingSurveyCompleted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsParticipantsTotalMatchingSurveyCompletedQuery, PartnerDashboardProgramMetricsParticipantsTotalMatchingSurveyCompletedQueryVariables>;
export const PartnerDashboardProgramMetricsParticipantsTotalCompletedSurveysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsParticipantsTotalCompletedSurveys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalCompletedSurveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surveyIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsParticipantsTotalCompletedSurveysQuery, PartnerDashboardProgramMetricsParticipantsTotalCompletedSurveysQueryVariables>;
export const PartnerDashboardProgramMetricsParticipantsTotalRegisteredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsParticipantsTotalRegistered"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalRegistered"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsParticipantsTotalRegisteredQuery, PartnerDashboardProgramMetricsParticipantsTotalRegisteredQueryVariables>;
export const PartnerDashboardProgramMetricsParticipantsTotalTrainedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsParticipantsTotalTrained"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalRegistered"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsParticipantsTotalTrainedQuery, PartnerDashboardProgramMetricsParticipantsTotalTrainedQueryVariables>;
export const PartnerDashboardProgramMetricsParticipantsTotalWantsMentorshipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsParticipantsTotalWantsMentorship"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wantsMentorshipAnswer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParticipantsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalWantsMentorship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wantsMentorshipAnswer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wantsMentorshipAnswer"}}},{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsParticipantsTotalWantsMentorshipQuery, PartnerDashboardProgramMetricsParticipantsTotalWantsMentorshipQueryVariables>;
export const PartnerDashboardProgramMetricsMentorshipsTotalMatchedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsMentorshipsTotalMatched"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalMatched"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsMentorshipsTotalMatchedQuery, PartnerDashboardProgramMetricsMentorshipsTotalMatchedQueryVariables>;
export const PartnerDashboardProgramMetricsMentorshipsTotalConversationsLoggedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsMentorshipsTotalConversationsLogged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalConversationsLogged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsMentorshipsTotalConversationsLoggedQuery, PartnerDashboardProgramMetricsMentorshipsTotalConversationsLoggedQueryVariables>;
export const PartnerDashboardProgramMetricsMentorshipsTotalLoggedThreeConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsMentorshipsTotalLoggedThreeConversations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalLoggedMinimumNumberConversations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"minimumNumberConversations"},"value":{"kind":"IntValue","value":"3"}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsMentorshipsTotalLoggedThreeConversationsQuery, PartnerDashboardProgramMetricsMentorshipsTotalLoggedThreeConversationsQueryVariables>;
export const PartnerDashboardProgramMetricsMentorshipsTotalFirstUsedSmsRelayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsMentorshipsTotalFirstUsedSmsRelay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalFirstUsedSmsRelay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsMentorshipsTotalFirstUsedSmsRelayQuery, PartnerDashboardProgramMetricsMentorshipsTotalFirstUsedSmsRelayQueryVariables>;
export const PartnerDashboardProgramMetricsMentorshipsTotalSmsRelayMessagesSentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsMentorshipsTotalSmsRelayMessagesSent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MentorshipsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalSmsRelayMessagesSent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsMentorshipsTotalSmsRelayMessagesSentQuery, PartnerDashboardProgramMetricsMentorshipsTotalSmsRelayMessagesSentQueryVariables>;
export const PartnerDashboardProgramMetricsFlagsTotalFlaggedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsFlagsTotalFlagged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagsGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalFlagged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsFlagsTotalFlaggedQuery, PartnerDashboardProgramMetricsFlagsTotalFlaggedQueryVariables>;
export const PartnerDashboardProgramsRequiredMentorTrainingCredentialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramsRequiredMentorTrainingCredential"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requiredMentorTrainingCredential"}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramsRequiredMentorTrainingCredentialQuery, PartnerDashboardProgramsRequiredMentorTrainingCredentialQueryVariables>;
export const PartnerDashboardProgramMetricsUsersTotalRepliesToMcTextsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsUsersTotalRepliesToMcTexts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalRepliesToMcTextMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsUsersTotalRepliesToMcTextsQuery, PartnerDashboardProgramMetricsUsersTotalRepliesToMcTextsQueryVariables>;
export const PartnerDashboardProgramMetricsUsersTotalMinimumTouchpointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsUsersTotalMinimumTouchpoints"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minimumNumberTouchpoints"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalMinimumTouchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"minimumNumberTouchpoints"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minimumNumberTouchpoints"}}},{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsUsersTotalMinimumTouchpointsQuery, PartnerDashboardProgramMetricsUsersTotalMinimumTouchpointsQueryVariables>;
export const PartnerDashboardProgramMetricsUsersTotalZeroTouchpointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsUsersTotalZeroTouchpoints"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalZeroTouchpoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsUsersTotalZeroTouchpointsQuery, PartnerDashboardProgramMetricsUsersTotalZeroTouchpointsQueryVariables>;
export const PartnerDashboardProgramMetricsUsersTotalEnteredProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsUsersTotalEnteredProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimePeriod"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersGroupBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"totalEnteredProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"intervalBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateRange"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateRange"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxGroups"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateInTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateInTimeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsUsersTotalEnteredProgramQuery, PartnerDashboardProgramMetricsUsersTotalEnteredProgramQueryVariables>;
export const PartnerDashboardProgramMetricsProgramInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramMetricsProgramInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentPhase"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"requiredMentorTrainingCredential"}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramMetricsProgramInfoQuery, PartnerDashboardProgramMetricsProgramInfoQueryVariables>;
export const PartnerDashboardIndividualResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardIndividualResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"id"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardIndividualResourceQuery, PartnerDashboardIndividualResourceQueryVariables>;
export const PartnerDashboardGoalsFilterOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardGoalsFilterOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participantGoals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"attachedToResourcesInProgramId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardGoalsFilterOptionsQuery, PartnerDashboardGoalsFilterOptionsQueryVariables>;
export const PartnerDashboardTopicsFilterOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardTopicsFilterOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceTopics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attachedToResourcesWithProgramIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"programId"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"NAME"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardTopicsFilterOptionsQuery, PartnerDashboardTopicsFilterOptionsQueryVariables>;
export const PartnerDashboardResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramResourcesFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourcesSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"topics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardResourcesQuery, PartnerDashboardResourcesQueryVariables>;
export const PartnerDashboardProgramAssessmentAreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramAssessmentAreas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programAssessmentAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scaleMax"}},{"kind":"Field","name":{"kind":"Name","value":"scaleMin"}},{"kind":"Field","name":{"kind":"Name","value":"enabledForMentees"}},{"kind":"Field","name":{"kind":"Name","value":"enabledForMentors"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramAssessmentAreasQuery, PartnerDashboardProgramAssessmentAreasQueryVariables>;
export const ProgramAssessmentSurveysDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramAssessmentSurveysData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentStage"}},{"kind":"Field","name":{"kind":"Name","value":"studentOpeningAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentMidAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentEndAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorOpeningAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMidAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorEndAssessmentSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ProgramAssessmentSurveysDataQuery, ProgramAssessmentSurveysDataQueryVariables>;
export const PartnerDashboardProgramProfileAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerDashboardProgramProfileAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programProfileAttributeCategoriesProgramId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MCID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programProfileAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardFilters"}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardProgramIntelligenceChart"}},{"kind":"Field","name":{"kind":"Name","value":"availableInPartnerDashboardExports"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeType"}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"programProfileAttributeCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programProfileAttributeCategoriesProgramId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileAttribute"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileAttributeCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PartnerDashboardProgramProfileAttributesQuery, PartnerDashboardProgramProfileAttributesQueryVariables>;
export const UserInfoForPartnerSsoLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInfoForPartnerSsoLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"registered"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultProfileImage"}},{"kind":"Field","name":{"kind":"Name","value":"partnerSuccessManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"ssoBrand"}},{"kind":"Field","name":{"kind":"Name","value":"ssoProviderIdentifier"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserInfoForPartnerSsoLoginQuery, UserInfoForPartnerSsoLoginQueryVariables>;
export const FeatureEnabledForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeatureEnabledForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feature"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFeatureEnabledFor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"feature"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feature"}}}]}]}}]}}]} as unknown as DocumentNode<FeatureEnabledForUserQuery, FeatureEnabledForUserQueryVariables>;
export const ProgramMatchingSurveyQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramMatchingSurveyQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyQuestionFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"studentMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"customizations"}},{"kind":"Field","name":{"kind":"Name","value":"questionMdDisplay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorMatchingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"customizations"}},{"kind":"Field","name":{"kind":"Name","value":"questionMdDisplay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramMatchingSurveyQuestionsQuery, ProgramMatchingSurveyQuestionsQueryVariables>;
export const CustomLabelsForProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomLabelsForProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programCustomLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"singularMentor"}},{"kind":"Field","name":{"kind":"Name","value":"singularMentorWithIndeterminateArticle"}},{"kind":"Field","name":{"kind":"Name","value":"pluralMentor"}},{"kind":"Field","name":{"kind":"Name","value":"respectMentorUppercase"}},{"kind":"Field","name":{"kind":"Name","value":"singularMentee"}},{"kind":"Field","name":{"kind":"Name","value":"singularMenteeWithIndeterminateArticle"}},{"kind":"Field","name":{"kind":"Name","value":"pluralMentee"}},{"kind":"Field","name":{"kind":"Name","value":"respectMenteeUppercase"}},{"kind":"Field","name":{"kind":"Name","value":"singularStudent"}},{"kind":"Field","name":{"kind":"Name","value":"singularStudentWithIndeterminateArticle"}},{"kind":"Field","name":{"kind":"Name","value":"pluralStudent"}},{"kind":"Field","name":{"kind":"Name","value":"respectStudentUppercase"}},{"kind":"Field","name":{"kind":"Name","value":"singularMentorship"}},{"kind":"Field","name":{"kind":"Name","value":"singularMentorshipWithIndeterminateArticle"}},{"kind":"Field","name":{"kind":"Name","value":"respectMentorshipUppercase"}},{"kind":"Field","name":{"kind":"Name","value":"pluralMentorship"}},{"kind":"Field","name":{"kind":"Name","value":"singularSchool"}},{"kind":"Field","name":{"kind":"Name","value":"singularSchoolWithIndeterminateArticle"}},{"kind":"Field","name":{"kind":"Name","value":"pluralSchool"}},{"kind":"Field","name":{"kind":"Name","value":"respectSchoolUppercase"}}]}}]}}]}}]} as unknown as DocumentNode<CustomLabelsForProgramQuery, CustomLabelsForProgramQueryVariables>;
export const SurveyParticipantDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveyParticipantData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SurveyParticipantDataQuery, SurveyParticipantDataQueryVariables>;
export const ConversationTopicsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConversationTopics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"segment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramSegment"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationTopics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"segment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"segment"}}},{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"questionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}}}]}]}}]} as unknown as DocumentNode<ConversationTopicsQuery, ConversationTopicsQueryVariables>;
export const ProgramSegmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProgramSegment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProgramSegmentQuery, ProgramSegmentQueryVariables>;
export const CounterpartsQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CounterpartsQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"MATCHED"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CounterpartsQuestionQuery, CounterpartsQuestionQueryVariables>;
export const FlagCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FlagCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FlagCategoryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<FlagCategoriesQuery, FlagCategoriesQueryVariables>;
export const ParticipantSurveyResponsesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantSurveyResponses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyResponses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participantId"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipChatGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantSurveyResponsesQuery, ParticipantSurveyResponsesQueryVariables>;
export const MentorChatGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MentorChatGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mentor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isMatched"}},{"kind":"Field","name":{"kind":"Name","value":"chatGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MentorChatGroupsQuery, MentorChatGroupsQueryVariables>;
export const PostSessionSurveyCareerQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PostSessionSurveyCareerQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentorship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mentorshipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programGoal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PostSessionSurveyCareerQuestionQuery, PostSessionSurveyCareerQuestionQueryVariables>;
export const SurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Survey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyCustomRenderOverride"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyCustomRenderOverride"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyQuestionFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"participantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"surveyCustomRenderOverride"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyCustomRenderOverride"}}}]},{"kind":"Field","name":{"kind":"Name","value":"surveyType"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"surveyCustomRenderOverride"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyCustomRenderOverride"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qid"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customizations"}},{"kind":"Field","name":{"kind":"Name","value":"createdInAdminTool"}}]}}]}}]}}]} as unknown as DocumentNode<SurveyQuery, SurveyQueryVariables>;
export const SaveSurveyResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveSurveyResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputResponse"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyResponseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveSurveyResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"response"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputResponse"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"context"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participantId"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipId"}},{"kind":"Field","name":{"kind":"Name","value":"mentorshipChatGroupId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"studentIsDisengaged"}},{"kind":"Field","name":{"kind":"Name","value":"mentorIsDisengaged"}},{"kind":"Field","name":{"kind":"Name","value":"mentorConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveyResponses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveyResponses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SaveSurveyResponseMutation, SaveSurveyResponseMutationVariables>;
export const UserInfoForAdminAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInfoForAdminAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"activeShearwaterAdministrator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<UserInfoForAdminAnalyticsQuery, UserInfoForAdminAnalyticsQueryVariables>;
export const UserInfoForAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInfoForAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isPartner"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdCategory"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdRole"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currentPhase"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"flagContactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryFlagContactCcEmails"}},{"kind":"Field","name":{"kind":"Name","value":"matchingCap"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}},{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"publicOrPrivate"}},{"kind":"Field","name":{"kind":"Name","value":"isMinorityServingInstitution"}},{"kind":"Field","name":{"kind":"Name","value":"twoOrFourYear"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserInfoForAnalyticsQuery, UserInfoForAnalyticsQueryVariables>;
export const ParticipantUserInfoForAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantUserInfoForAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isPartner"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"mentorships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matchDate"}},{"kind":"Field","name":{"kind":"Name","value":"isMatched"}},{"kind":"Field","name":{"kind":"Name","value":"mentorConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentConversationLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentPhase"}},{"kind":"Field","name":{"kind":"Name","value":"currentStage"}},{"kind":"Field","name":{"kind":"Name","value":"programSequence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"higherEdSegment"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantUserInfoForAnalyticsQuery, ParticipantUserInfoForAnalyticsQueryVariables>;
export const CachedParticipantSurveyResponsesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CachedParticipantSurveyResponses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"context"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyResponseContextFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surveyResponses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"context"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CachedParticipantSurveyResponsesQuery, CachedParticipantSurveyResponsesQueryVariables>;
import { IntrospectionQuery } from 'graphql';
export default {
  "__schema": {
    "queryType": {
      "name": "Query",
      "kind": "OBJECT"
    },
    "mutationType": {
      "name": "Mutation",
      "kind": "OBJECT"
    },
    "subscriptionType": null,
    "types": [
      {
        "kind": "OBJECT",
        "name": "A2pSms",
        "fields": [
          {
            "name": "content",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "sentAtDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ActivityLog",
        "fields": [
          {
            "name": "eventType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "loggableActivity",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "UNION",
                "name": "LoggableActivity",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "includeMathingSurveyResponses",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "occurredAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ActivityLogConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ActivityLogEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ActivityLog",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalAssessmentSurveySubmittedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalConnectedViaP2pRelayCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalConversationReportedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalFlagReportedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalInitialMatchingSurveyReviewNotificationCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalInvitedAsMenteeCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalInvitedAsMentorCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalLowAhsAssessmentScoreSubmittedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalLowAseAssessmentScoreSubmittedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalLowCdseAssessmentScoreSubmittedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalLowSobAssessmentScoreSubmittedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalLowSrAssessmentScoreSubmittedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalMatchingSurveyUpdatedReviewNotificationCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalMenteeDeregisteredCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalMentorCompletedTrainingCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalMentorDeregisteredCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalMentorMatchingSurveyCompletedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalMentorSignedUpForTrainingCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalMentorshipUnmatchedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalNewMentorshipCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalRegisteredAsMenteeCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalRegisteredAsMentorCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalStudentMatchingSurveyCompletedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ActivityLogEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "ActivityLog",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AddContactsFromExistingProgramPayload",
        "fields": [
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AddContactsPayload",
        "fields": [
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AddContactsToExistingUsersPayload",
        "fields": [
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AddMessageTemplatesTags",
        "fields": [
          {
            "name": "byFilterSelection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AddMessageTemplatesTagsByFilterSelectionPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "tagIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "tagsToCreate",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "byIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AddMessageTemplatesTagsByIdsPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "ids",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "tagIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "tagsToCreate",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AddMessageTemplatesTagsByFilterSelectionPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "messageTemplates",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "MessageTemplate",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfMessageTemplatesUpdated",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AddMessageTemplatesTagsByIdsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "messageTemplates",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "MessageTemplate",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfMessageTemplatesUpdated",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AddParticipantsPayload",
        "fields": [
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AdminAction",
        "fields": [
          {
            "name": "adminUser",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "performedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "resultingChanges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ObjectChangesetConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AdminActionConnection",
        "fields": [
          {
            "name": "actionTypes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "adminUsers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "User",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "AdminActionEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AdminAction",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AdminActionEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "AdminAction",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AffectedObjectTypeCount",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "eventType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "objectType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ArchiveRestoreMessageTemplates",
        "fields": [
          {
            "name": "byFilterSelection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ArchiveRestoreMessageTemplatesByFilterSelectionPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "setArchived",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "byIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ArchiveRestoreMessageTemplatesByIdsPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "ids",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "setArchived",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ArchiveRestoreMessageTemplatesByFilterSelectionPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "messageTemplates",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "MessageTemplate",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfMessageTemplatesUpdated",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ArchiveRestoreMessageTemplatesByIdsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "messageTemplates",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "MessageTemplate",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfMessageTemplatesUpdated",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssessmentArea",
        "fields": [
          {
            "name": "assessmentPrompts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssessmentPrompt",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "identifier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssessmentPrompt",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "identifier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "text",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssessmentScoreResponse",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssessmentScoreResponsesMetrics",
        "fields": [
          {
            "name": "averageAssessmentScore",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssessmentSurveyTaskAssignment",
        "fields": [
          {
            "name": "behavior",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "participantId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "position",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "programStage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "surveyId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "TaskAssignment"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AssessmentSurveyTaskContext",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "newTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewTask",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "programStage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "surveyId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AutoMatchSettings",
        "fields": [
          {
            "name": "mentorCapacityCap",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "scoreThreshold",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "standardMatching",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "standardScoreThreshold",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "supermentorMatching",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "supermentorScoreThreshold",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AutoSuggestMatchesPayload",
        "fields": [
          {
            "name": "batchId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AutomatchingDefault",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "identifier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "settings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuggestedBatchSettings",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CachedUserProfileDataAttributeValue",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "profileAttribute",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProfileAttribute",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "values",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ChangeMentorTrainingStatusPayload",
        "fields": [
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ClickLinkTaskAssignment",
        "fields": [
          {
            "name": "behavior",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "participantId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "position",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "TaskAssignment"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CompleteTaskAssignmentPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "taskAssignment",
            "type": {
              "kind": "INTERFACE",
              "name": "TaskAssignment",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ConfigureFlagsError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ConfigureFlagsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ConfigureFlagsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INTERFACE",
        "name": "Contact",
        "fields": [
          {
            "name": "a2pSmses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "A2pSms",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "activationStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "activationStatusChangedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "notes",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "registered",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "uploadedBy",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "uploadedDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "MentorContact"
          },
          {
            "kind": "OBJECT",
            "name": "StudentContact"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ContactConnection",
        "fields": [
          {
            "name": "activatedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "batchActionIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ContactEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "mentorContactCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INTERFACE",
                    "name": "Contact",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "notActivatedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "registeredCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "secondWaveCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "studentContactCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountOfDistinctUsers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "uploadedByUsers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "User",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContactEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "INTERFACE",
              "name": "Contact",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContactsMetrics",
        "fields": [
          {
            "name": "totalInvited",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContentfulModuleResource",
        "fields": [
          {
            "name": "contentfulUrl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "icon",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "identifier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "sections",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ContentfulModuleSection",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContentfulModuleSection",
        "fields": [
          {
            "name": "examples",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ContentfulModuleSection",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "options",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ContentfulModuleSection",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "text",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "visibleToMentee",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "visibleToMentor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "Context",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AssessmentSurveyTaskContext"
          },
          {
            "kind": "OBJECT",
            "name": "CourseTaskContext"
          },
          {
            "kind": "OBJECT",
            "name": "LinkTaskContext"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ConversationLog",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "loggedAtDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentorship",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Mentorship",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "modesOfCommunication",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "topics",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Country",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Course",
        "fields": [
          {
            "name": "active",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "externalServiceId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "published",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "serviceName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "slug",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CourseConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "CourseEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Course",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CourseEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "Course",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CourseTaskAssignment",
        "fields": [
          {
            "name": "behavior",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "courseId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "participantId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "position",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "TaskAssignment"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CourseTaskContext",
        "fields": [
          {
            "name": "courseId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "newTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewTask",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateEmailTemplatePayload",
        "fields": [
          {
            "name": "emailTemplate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmailTemplate",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateEmailTemplateSavedRowPayload",
        "fields": [
          {
            "name": "emailTemplateSavedRow",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmailTemplateSavedRow",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateFlagContactPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "flagContacts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "FlagContact",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateMatchingLabelPayload",
        "fields": [
          {
            "name": "matchingLabel",
            "type": {
              "kind": "OBJECT",
              "name": "MatchingLabel",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "participant",
            "type": {
              "kind": "INTERFACE",
              "name": "Participant",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateMatchingSurveyPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "surveys",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Survey",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateMessageTemplateTagPayload",
        "fields": [
          {
            "name": "messageTemplateTag",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmailTemplate",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateMicroSurveyPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "microSurvey",
            "type": {
              "kind": "OBJECT",
              "name": "MicroSurvey",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateNewCourseTaskAndNewProgramTaskPayload",
        "fields": [
          {
            "name": "duplicateTasks",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "NewTask",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DuplicateError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "newProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewProgramTask",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "newTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewTask",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateNewLinkTaskAndNewProgramTaskPayload",
        "fields": [
          {
            "name": "duplicateTasks",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "NewTask",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DuplicateError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "newProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewProgramTask",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "newTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewTask",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateNotificationViewPayload",
        "fields": [
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateOrEnableNewProgramTaskPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "newProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewProgramTask",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreatePartnerPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "partners",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Partner",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProgramAutomatchingConfigurationPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "programAutomatchingConfiguration",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramAutomatchingConfiguration",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProgramAutomatchingDefaultPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "programAutomatchingDefault",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramAutomatchingDefault",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProgramError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProgramPageVisitPayload",
        "fields": [
          {
            "name": "programPageVisit",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramPageVisit",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProgramPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CreateProgramError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProgramResourceError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProgramResourcePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CreateProgramResourceError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "programResource",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramResource",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProgramSequenceError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProgramSequencePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CreateProgramSequenceError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "programSequence",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramSequence",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProgramTaskPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "programTask",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramTask",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateProgramTopicPayload",
        "fields": [
          {
            "name": "programTopic",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramTopic",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateSavedMatchPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "savedMatch",
            "type": {
              "kind": "OBJECT",
              "name": "SavedMatch",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateSchoolError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateSchoolPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CreateSchoolError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "school",
            "type": {
              "kind": "OBJECT",
              "name": "School",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateSkeletonMessageTemplatePayload",
        "fields": [
          {
            "name": "skeletonMessageTemplate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SkeletonMessageTemplate",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateSmsTemplatePayload",
        "fields": [
          {
            "name": "smsTemplate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SmsTemplate",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateTopicPayload",
        "fields": [
          {
            "name": "topic",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Topic",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateUploadedVideoPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "participant",
            "type": {
              "kind": "INTERFACE",
              "name": "Participant",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CsvExport",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          },
          {
            "name": "filename",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isProcessing",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CsvExports",
        "fields": [
          {
            "name": "matchedUsersReport",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CsvExport",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "endDate",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "enrollment",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "startDate",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "menteeMentorQuotes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CsvExport",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "analyzeSentiment",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "programIds",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "mentorshipEngagementData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CsvExport",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "participantsProfileData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CsvExport",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "csvExportContext",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "profileDataColumns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "partnerDashboardExports",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PartnerDashboardExports",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "recruitmentOpportunities",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CsvExport",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "csvExportContext",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "mentorsUsersFilter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "opportunityArea",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "studentsUsersFilter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "surveyResponses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CsvExport",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "csvExportContext",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "includeProgramProfileData",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "surveyId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "writtenTestimonials",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CsvExport",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "analyzeSentiment",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "programIds",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CustomMessageTypeTemplateRequirement",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "customMessageType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "messageCategory",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "messageType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "userState",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CustomMessageTypeTemplateRequirementConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomMessageTypeTemplateRequirementEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CustomMessageTypeTemplateRequirement",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CustomMessageTypeTemplateRequirementEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "CustomMessageTypeTemplateRequirement",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteContacts",
        "fields": [
          {
            "name": "byFilterSelection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeleteContactsByFilterSelectionPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "byIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeleteContactsByIdsPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "ids",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteContactsByFilterSelectionPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfContactsDeleted",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteContactsByIdsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfContactsDeleted",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteFlagContactPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteMatchingLabelPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "participant",
            "type": {
              "kind": "INTERFACE",
              "name": "Participant",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteProgramPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteProgramResourcePayload",
        "fields": [
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteProgramSequencePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteProgramTaskPayload",
        "fields": [
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "programSequence",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramSequence",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteProgramTopicPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteSavedMatches",
        "fields": [
          {
            "name": "byFilter",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeleteSavedMatchesByFilterPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "totalCount",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "byIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeleteSavedMatchesByIdsPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "ids",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteSavedMatchesByFilterPayload",
        "fields": [
          {
            "name": "deletedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteSavedMatchesByIdsPayload",
        "fields": [
          {
            "name": "deletedCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteSchoolPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeleteSuggestedBatchPayload",
        "fields": [
          {
            "name": "deletedId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DenylistEmailsPayload",
        "fields": [
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeregisterParticipantPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "participant",
            "type": {
              "kind": "INTERFACE",
              "name": "Participant",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeregistrationReason",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "grouping",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "identifier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "participantFacingName",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeregistrationReasonConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeregistrationReasonEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DeregistrationReason",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeregistrationReasonEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "DeregistrationReason",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DeregistrationStatusEvent",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "deregistrationReason",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeregistrationReason",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "kind",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "otherReasonNotes",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "participant",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "Participant",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DisableNewProgramTaskPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "newProgramTask",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "NewProgramTask",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DisengagementResolutionsAverageTimeToRematchResult",
        "fields": [
          {
            "name": "averageRematchTimeInDays",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DisengagementResolutionsMetricsResult",
        "fields": [
          {
            "name": "metric",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DismissProgramAlertPayload",
        "fields": [
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DuplicateError",
        "fields": [
          {
            "name": "duplicateNewTaskId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DuplicateMessageTemplates",
        "fields": [
          {
            "name": "byFilterSelection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DuplicateMessageTemplatesByFilterSelectionPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "isDefault",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "tagIdsToAdd",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "tagIdsToRemove",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "byIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DuplicateMessageTemplatesByIdsPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "ids",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "isDefault",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "tagIdsToAdd",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "tagIdsToRemove",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DuplicateMessageTemplatesByFilterSelectionPayload",
        "fields": [
          {
            "name": "newMessageTemplates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MessageTemplateConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DuplicateMessageTemplatesByIdsPayload",
        "fields": [
          {
            "name": "newMessageTemplates",
            "type": {
              "kind": "OBJECT",
              "name": "MessageTemplateConnection",
              "ofType": null
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DuplicateProgramPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "successMessages",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DuplicateProgramSequencePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "programSequence",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramSequence",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DwhParticipantsMetrics",
        "fields": [
          {
            "name": "menteesRegistered",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentorsRegistered",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "participantsRegistered",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "programId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "programName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DwhParticipantsMetricsConnection",
        "fields": [
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DwhParticipantsMetrics",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalMenteesRegisteredCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalMentorsRegisteredCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalParticipantsRegisteredCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DwhQueryableMetrics",
        "fields": [
          {
            "name": "participants",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DwhParticipantsMetricsConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "EmailTemplate",
        "fields": [
          {
            "name": "archivedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "category",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "content",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "createdBy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "customMessageType",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "identifier",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "isDefault",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastEditedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastEditedBy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "messageType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "preheaderText",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "programSegment",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "subjectLine",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "tags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MessageTemplateTag",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "templateEditorData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "userState",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "MessageTemplate"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "EmailTemplateSavedRow",
        "fields": [
          {
            "name": "category",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "templateEditorData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "EngagementBenchmarkData",
        "fields": [
          {
            "name": "disengagedMenteesInPreviousProgram",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "disengagedMentorsInPreviousProgram",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentorshipsInPreviousProgramEngagedInLast30Days",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentorshipsInPreviousProgramUsingSmsRelay",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentorshipsInPreviousProgramWith0Conversations",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentorshipsInPreviousProgramWith3OrMoreConversations",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "totalCountWithConversationInTheLast30Days",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "totalCountWithThreeOrMoreConversations",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "totalCountWithZeroConversations",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "totalMenteesInPreviousProgram",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "totalMentorsInPreviousProgram",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "totalMentorshipsForPreviousProgram",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Error",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ExternalLink",
        "fields": [
          {
            "name": "href",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "kind",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Flag",
        "fields": [
          {
            "name": "additionalInfo",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "flagCategories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FlagCategory",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "relabeled",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentorship",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Mentorship",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "participantConversationContent",
            "type": {
              "kind": "OBJECT",
              "name": "ParticipantConversationContent",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "partnerNotes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "submittedBy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "supportPriority",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FlagCategory",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "identifier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "label",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "smsCharacter",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FlagConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "FlagEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "flagCategoriesSubmitted",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Flag",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FlagContact",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "flagCategories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FlagCategory",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FlagEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "Flag",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FlagPageVisit",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FlagPageVisitConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "FlagPageVisitEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FlagPageVisit",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FlagPageVisitEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "FlagPageVisit",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FlagsMetrics",
        "fields": [
          {
            "name": "totalFlagged",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Goal",
        "fields": [
          {
            "name": "archived",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "identifier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GoalConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "GoalEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Goal",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GoalEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "Goal",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GroupMatchingSettings",
        "fields": [
          {
            "name": "maxGroupSize",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "minGroupSize",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "HardMatchQuestion",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "MultiSelectHardMatchQuestion"
          },
          {
            "kind": "OBJECT",
            "name": "SingleSelectHardMatchQuestion"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Image",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "resize",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Interval",
        "fields": [
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "group",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "sampleSize",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "valueType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "LinkTaskContext",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "newTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewTask",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INTERFACE",
        "name": "Log",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "loggedAtDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "TookTypeformSurveyLog"
          },
          {
            "kind": "OBJECT",
            "name": "TrainingEventLog"
          },
          {
            "kind": "OBJECT",
            "name": "WatchedCommunityVideoLog"
          },
          {
            "kind": "OBJECT",
            "name": "WatchedVideoLog"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "LogTookTypeformSurveyPayload",
        "fields": [
          {
            "name": "participant",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "Participant",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "LogWatchedCommunityVideoPayload",
        "fields": [
          {
            "name": "participant",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "Participant",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "LogWatchedWistiaVideoPayload",
        "fields": [
          {
            "name": "participant",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "Participant",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "LoggableActivity",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AssessmentScoreResponse"
          },
          {
            "kind": "OBJECT",
            "name": "DeregistrationStatusEvent"
          },
          {
            "kind": "OBJECT",
            "name": "Flag"
          },
          {
            "kind": "OBJECT",
            "name": "Mentor"
          },
          {
            "kind": "OBJECT",
            "name": "MentorContact"
          },
          {
            "kind": "OBJECT",
            "name": "Mentorship"
          },
          {
            "kind": "OBJECT",
            "name": "PartnerNotification"
          },
          {
            "kind": "OBJECT",
            "name": "Student"
          },
          {
            "kind": "OBJECT",
            "name": "StudentContact"
          },
          {
            "kind": "OBJECT",
            "name": "SurveyResponse"
          },
          {
            "kind": "OBJECT",
            "name": "TrainingEventLog"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MakeBatchMatchesPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "suggestedBatch",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuggestedBatch",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MakeMatchPayload",
        "fields": [
          {
            "name": "deletedSavedMatchId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "mentor",
            "type": {
              "kind": "OBJECT",
              "name": "Mentor",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "showAllowRematchConfirm",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "student",
            "type": {
              "kind": "OBJECT",
              "name": "Student",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MakeSavedGroupMatches",
        "fields": [
          {
            "name": "byFilter",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MakeSavedGroupMatchesByFilterPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "isSupermentorGroup",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "totalCount",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "byIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MakeSavedGroupMatchesByIdsPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "addToExistingGroup",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "ids",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "isSupermentorGroup",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MakeSavedGroupMatchesByFilterPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "queuedGroupsCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "queuedMatchesCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "savedMatchIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MakeSavedGroupMatchesByIdsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "queuedGroupsCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "queuedMatchesCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "savedMatchIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MakeSavedMatches",
        "fields": [
          {
            "name": "byFilter",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MakeSavedMatchesByFilterPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "totalCount",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "byIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MakeSavedMatchesByIdsPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "ids",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MakeSavedMatchesByFilterPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "queuedMatchesCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "savedMatchIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MakeSavedMatchesByIdsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "queuedMatchesCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "savedMatchIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MarkParticipantReachedOutPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "mentorship",
            "type": {
              "kind": "OBJECT",
              "name": "Mentorship",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "participant",
            "type": {
              "kind": "INTERFACE",
              "name": "Participant",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MatchingCriteria",
        "fields": [
          {
            "name": "enrollmentMenteeMatchingCriteria",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hardMatchQuestions",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "HardMatchQuestion",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "includeAvailableToMatchEnrollmentMentees",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "includeEverMatchedEnrollmentMentees",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "includeMenteesUnder17",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "includeMenteesWhoArePushedThroughToMatch",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "includeMenteesWhoHaveBeenUnmatched",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "includeMenteesWithFreeResponses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "includeMenteesWithSupermentorOptIn",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "includeMenteesWithoutMatchingSurveys",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "includeMentorsWhoArePushedThroughToMatch",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "includeMentorsWhoHaveBeenUnmatched",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "includeMentorsWithMentorships",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "includeMentorsWithSupermentorOptIn",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "includeMentorsWithoutMatchingSurveys",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "includeMentorsWithoutTraining",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "onlyEnrollmentOptInMentees",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "requireMenteeSupermentorOptIn",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "requireMentorSupermentorOptIn",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "sharedMajor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "sharedTransferStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MatchingLabel",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "kind",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "participant",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "Participant",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Mentor",
        "fields": [
          {
            "name": "activityLogs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INTERFACE",
                    "name": "Log",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "allowedToSkipMatchingSurvey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "avatar",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "avatarImage",
            "type": {
              "kind": "OBJECT",
              "name": "Image",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "cachedUserProfileData",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CachedUserProfileDataAttributeValue",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "attributes",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "cacheSettings",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "capacity",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "completedMatchingSurveyAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "deregisterDate",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "deregistrationStatusEvents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DeregistrationStatusEvent",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastCompletedRequiredTrainingAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "matchingLabels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MatchingLabel",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "mentorTrainingCourseLink",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentorships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Mentorship",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "status",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "notes",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "participantMentorships",
            "type": {
              "kind": "OBJECT",
              "name": "MentorshipConnection",
              "ofType": null
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "prioritizedAndPendingForRematching",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "pushedThroughToMatch",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "registered",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "registrationDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "requiredTrainingStatus",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "savedMatches",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SavedMatch",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "supermentorOptIn",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "surveyResponses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SurveyResponse",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "context",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "surveyId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "trainingSignupLink",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "uploadedVideos",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UploadedVideo",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "onlySharable",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "userProfileData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserProfileData",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "attributes",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "fallbackRules",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "source",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "webappBaseUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "writtenMessages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WrittenMessage",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Participant"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MentorContact",
        "fields": [
          {
            "name": "a2pSmses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "A2pSms",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "activationStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "activationStatusChangedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "notes",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "registered",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "uploadedBy",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "uploadedDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Contact"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Mentorship",
        "fields": [
          {
            "name": "chatGroup",
            "type": {
              "kind": "OBJECT",
              "name": "MentorshipChatGroup",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "combinedMenteeMentorSurveyResponses",
            "type": {
              "kind": "OBJECT",
              "name": "SurveyResponseConnection",
              "ofType": null
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "commonQualities",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          },
          {
            "name": "commonQualitiesSentence",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "conversationLogsCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "flags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FlagConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isMatched",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastConversation",
            "type": {
              "kind": "OBJECT",
              "name": "ConversationLog",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "matchDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "megaphoneGroup",
            "type": {
              "kind": "OBJECT",
              "name": "MentorshipMegaphoneGroup",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "menteeSmsRelayPhoneNumber",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Mentor",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "mentorConversationLogs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ConversationLog",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "mentorIsDisengaged",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentorReachedOutAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentorSmsRelayPhoneNumber",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "score",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "source",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "student",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Student",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "studentConversationLogs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ConversationLog",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "studentIsDisengaged",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "studentReachedOutAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "unmatchDate",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "unmatchInitiatedBy",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "unmatchNotes",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "unmatchReason",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MentorshipChatGroup",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MentorshipConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "MentorshipEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Mentorship",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountMenteesDisengaged",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountMentorsDisengaged",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountUsingSmsRelay",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountWithConversationInTheLast30Days",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountWithThreeOrMoreConversations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountWithZeroConversations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MentorshipCredential",
        "fields": [
          {
            "name": "credential",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MentorshipEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "Mentorship",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MentorshipMegaphoneGroup",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isSupermentorGroup",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MentorshipsMetrics",
        "fields": [
          {
            "name": "totalConversationsLogged",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "totalFirstUsedSmsRelay",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "totalLoggedMinimumNumberConversations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "minimumNumberConversations",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "totalMatched",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "totalSmsRelayMessagesSent",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INTERFACE",
        "name": "MessageTemplate",
        "fields": [
          {
            "name": "archivedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "category",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "content",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "createdBy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "customMessageType",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "identifier",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "isDefault",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastEditedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastEditedBy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "messageType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "programSegment",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "tags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MessageTemplateTag",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "userState",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "EmailTemplate"
          },
          {
            "kind": "OBJECT",
            "name": "SmsTemplate"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MessageTemplateConnection",
        "fields": [
          {
            "name": "defaultCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "MessageTemplateEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INTERFACE",
                    "name": "MessageTemplate",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "tagCounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MessageTemplateTagCount",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MessageTemplateEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "INTERFACE",
              "name": "MessageTemplate",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MessageTemplateTag",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MessageTemplateTagConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "MessageTemplateTagEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MessageTemplateTag",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MessageTemplateTagCount",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "tag",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MessageTemplateTag",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MessageTemplateTagEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "MessageTemplateTag",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MicroSurvey",
        "fields": [
          {
            "name": "expireAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "startAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "survey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Survey",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "targetingCriteria",
            "type": {
              "kind": "OBJECT",
              "name": "MicroSurveyTargetingCriteria",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MicroSurveyConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "MicroSurveyEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MicroSurvey",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MicroSurveyEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "MicroSurvey",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MicroSurveyTargetingCriteria",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "participants",
            "type": {
              "kind": "OBJECT",
              "name": "ParticipantsFilterCriteria",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MoveParticipantsPayload",
        "fields": [
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MultiSelectHardMatchQuestion",
        "fields": [
          {
            "name": "matchType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "qid",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Mutation",
        "fields": [
          {
            "name": "addContacts",
            "type": {
              "kind": "OBJECT",
              "name": "AddContactsPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "contactType",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "file",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "addContactsFromExistingProgram",
            "type": {
              "kind": "OBJECT",
              "name": "AddContactsFromExistingProgramPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "contactType",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "existingPool",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "fromProgramId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "addContactsToExistingUsers",
            "type": {
              "kind": "OBJECT",
              "name": "AddContactsToExistingUsersPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "contactType",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "file",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "addMessageTemplatesTags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AddMessageTemplatesTags",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "addParticipants",
            "type": {
              "kind": "OBJECT",
              "name": "AddParticipantsPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "file",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "fromAnotherProgram",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "participantType",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "archiveRestoreMessageTemplates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ArchiveRestoreMessageTemplates",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "autoSuggestMatches",
            "type": {
              "kind": "OBJECT",
              "name": "AutoSuggestMatchesPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "autoMatchOptions",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "changeMentorTrainingStatus",
            "type": {
              "kind": "OBJECT",
              "name": "ChangeMentorTrainingStatusPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "file",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "trainingStatus",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "completeTaskAssignment",
            "type": {
              "kind": "OBJECT",
              "name": "CompleteTaskAssignmentPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "taskAssignmentId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "configureFlags",
            "type": {
              "kind": "OBJECT",
              "name": "ConfigureFlagsPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "configureFlagsInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createEmailTemplate",
            "type": {
              "kind": "OBJECT",
              "name": "CreateEmailTemplatePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "createEmailTemplateInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createEmailTemplateSavedRow",
            "type": {
              "kind": "OBJECT",
              "name": "CreateEmailTemplateSavedRowPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "newRowInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createFlagContact",
            "type": {
              "kind": "OBJECT",
              "name": "CreateFlagContactPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "flagContactInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createMatchingLabel",
            "type": {
              "kind": "OBJECT",
              "name": "CreateMatchingLabelPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "matchingLabelKind",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "participantId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createMatchingSurvey",
            "type": {
              "kind": "OBJECT",
              "name": "CreateMatchingSurveyPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "customQuestionsFromAdminTool",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "matchingSurveyOptions",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createMessageTemplateTag",
            "type": {
              "kind": "OBJECT",
              "name": "CreateMessageTemplateTagPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "name",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createMicroSurvey",
            "type": {
              "kind": "OBJECT",
              "name": "CreateMicroSurveyPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "microSurveyInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createNewCourseTaskAndNewProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "CreateNewCourseTaskAndNewProgramTaskPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "newCourseTaskAndNewProgramTaskInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createNewLinkTaskAndNewProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "CreateNewLinkTaskAndNewProgramTaskPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "newLinkTaskAndNewProgramTaskInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createNotificationView",
            "type": {
              "kind": "OBJECT",
              "name": "CreateNotificationViewPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "displayMedium",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "notificationViewableId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "notificationViewableType",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "userId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createOrEnableNewProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "CreateOrEnableNewProgramTaskPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "assigneeEntity",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "displayName",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "newTaskId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createPartner",
            "type": {
              "kind": "OBJECT",
              "name": "CreatePartnerPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "partnerInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createProgram",
            "type": {
              "kind": "OBJECT",
              "name": "CreateProgramPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createProgramAutomatchingConfiguration",
            "type": {
              "kind": "OBJECT",
              "name": "CreateProgramAutomatchingConfigurationPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "configuration",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createProgramAutomatchingDefault",
            "type": {
              "kind": "OBJECT",
              "name": "CreateProgramAutomatchingDefaultPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "automatchingDefaultId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createProgramPageVisit",
            "type": {
              "kind": "OBJECT",
              "name": "CreateProgramPageVisitPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "path",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "userId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createProgramResource",
            "type": {
              "kind": "OBJECT",
              "name": "CreateProgramResourcePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programResourceInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createProgramSequence",
            "type": {
              "kind": "OBJECT",
              "name": "CreateProgramSequencePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programSequenceInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "CreateProgramTaskPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programTaskInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createProgramTopic",
            "type": {
              "kind": "OBJECT",
              "name": "CreateProgramTopicPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "createProgramTopicInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createSavedMatch",
            "type": {
              "kind": "OBJECT",
              "name": "CreateSavedMatchPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "mentorId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "source",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "studentId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createSchool",
            "type": {
              "kind": "OBJECT",
              "name": "CreateSchoolPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "schoolInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createSkeletonMessageTemplate",
            "type": {
              "kind": "OBJECT",
              "name": "CreateSkeletonMessageTemplatePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "skeletonMessageTemplateInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createSmsTemplate",
            "type": {
              "kind": "OBJECT",
              "name": "CreateSmsTemplatePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "createSmsTemplateInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createTopic",
            "type": {
              "kind": "OBJECT",
              "name": "CreateTopicPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "createTopicInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "createUploadedVideo",
            "type": {
              "kind": "OBJECT",
              "name": "CreateUploadedVideoPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "fileSize",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "fileType",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "participantId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "sharePublicly",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "shareWithStudents",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "ziggeoToken",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteFlagContact",
            "type": {
              "kind": "OBJECT",
              "name": "DeleteFlagContactPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteMatchingLabel",
            "type": {
              "kind": "OBJECT",
              "name": "DeleteMatchingLabelPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "matchingLabelKind",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "participantId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteProgram",
            "type": {
              "kind": "OBJECT",
              "name": "DeleteProgramPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteProgramContacts",
            "type": {
              "kind": "OBJECT",
              "name": "DeleteContacts",
              "ofType": null
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteProgramResource",
            "type": {
              "kind": "OBJECT",
              "name": "DeleteProgramResourcePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteProgramSequence",
            "type": {
              "kind": "OBJECT",
              "name": "DeleteProgramSequencePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "DeleteProgramTaskPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteProgramTopic",
            "type": {
              "kind": "OBJECT",
              "name": "DeleteProgramTopicPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteSavedMatches",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeleteSavedMatches",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "deleteSchool",
            "type": {
              "kind": "OBJECT",
              "name": "DeleteSchoolPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deleteSuggestedBatch",
            "type": {
              "kind": "OBJECT",
              "name": "DeleteSuggestedBatchPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "denylistEmails",
            "type": {
              "kind": "OBJECT",
              "name": "DenylistEmailsPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "file",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "deregisterParticipant",
            "type": {
              "kind": "OBJECT",
              "name": "DeregisterParticipantPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "deregisterParticipantInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "disableNewProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "DisableNewProgramTaskPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "disableNewProgramTaskInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "dismissProgramAlert",
            "type": {
              "kind": "OBJECT",
              "name": "DismissProgramAlertPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "dismissalInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "duplicateMessageTemplates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DuplicateMessageTemplates",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "duplicateProgram",
            "type": {
              "kind": "OBJECT",
              "name": "DuplicateProgramPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "duplicateLegacyTasks",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "toProgramSequenceId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "duplicateProgramSequence",
            "type": {
              "kind": "OBJECT",
              "name": "DuplicateProgramSequencePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "logTookTypeformSurvey",
            "type": {
              "kind": "OBJECT",
              "name": "LogTookTypeformSurveyPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "externalLinkId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "participantId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "logWatchedCommunityVideo",
            "type": {
              "kind": "OBJECT",
              "name": "LogWatchedCommunityVideoPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "participantId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "taskName",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "ziggeoToken",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "logWatchedWistiaVideo",
            "type": {
              "kind": "OBJECT",
              "name": "LogWatchedWistiaVideoPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "participantId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "wistiaVideoId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "makeBatchMatches",
            "type": {
              "kind": "OBJECT",
              "name": "MakeBatchMatchesPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "suggestedBatchId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "makeMatch",
            "type": {
              "kind": "OBJECT",
              "name": "MakeMatchPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "allowRematch",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "mentorId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "studentId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "makeSavedGroupMatches",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MakeSavedGroupMatches",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "makeSavedMatches",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MakeSavedMatches",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "markParticipantReachedOut",
            "type": {
              "kind": "OBJECT",
              "name": "MarkParticipantReachedOutPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "mentorshipId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "participantId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "moveParticipants",
            "type": {
              "kind": "OBJECT",
              "name": "MoveParticipantsPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "destinationProgramId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "file",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "reasonForMove",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "previewMatchingSurvey",
            "type": {
              "kind": "OBJECT",
              "name": "PreviewMatchingSurveyPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "customQuestionsFromAdminTool",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "matchingSurveyOptions",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "reactivateProgramAlert",
            "type": {
              "kind": "OBJECT",
              "name": "ReactivateProgramAlertPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "alertTypeIdentifier",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "removeMessageTemplatesTags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RemoveMessageTemplatesTags",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "saveBatchMatches",
            "type": {
              "kind": "OBJECT",
              "name": "SaveBatchMatchesPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "suggestedBatchId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "saveSurveyResponse",
            "type": {
              "kind": "OBJECT",
              "name": "SaveSurveyResponsePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "response",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "saveWrittenMessage",
            "type": {
              "kind": "OBJECT",
              "name": "SaveWrittenMessagePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "content",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "participantId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "sharePublicly",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "shareWithStudents",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "sendBulkMessageByCsv",
            "type": {
              "kind": "OBJECT",
              "name": "SendBulkMessageByCsvPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "file",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "templateId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "sendPartnerNotifications",
            "type": {
              "kind": "OBJECT",
              "name": "SendPartnerNotificationsPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "recipients",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "templateId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "sendSsoTestingTemplate",
            "type": {
              "kind": "OBJECT",
              "name": "SendSsoTestingTemplatePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "schoolId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "sendTestMessage",
            "type": {
              "kind": "OBJECT",
              "name": "SendTestMessagePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "email",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "phone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "recipientId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "templateId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "sendUpdateEmailDraftForMentorship",
            "type": {
              "kind": "OBJECT",
              "name": "SendUpdateEmailDraftForMentorshipPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "mentorshipId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "setupSftp",
            "type": {
              "kind": "OBJECT",
              "name": "SetupSftpPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "publicKey",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "startFirstWaveRecruitment",
            "type": {
              "kind": "OBJECT",
              "name": "StartFirstWaveRecruitment",
              "ofType": null
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "startSecondWaveRecruitment",
            "type": {
              "kind": "OBJECT",
              "name": "StartSecondWaveRecruitment",
              "ofType": null
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "stopRecruitment",
            "type": {
              "kind": "OBJECT",
              "name": "StopRecruitment",
              "ofType": null
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "unmatchParticipant",
            "type": {
              "kind": "OBJECT",
              "name": "UnmatchParticipantPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "initiatedBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "mentorshipId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "reasonToShareWithMentee",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "reasonToShareWithMentor",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "requesterNotes",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sendUnmatchingEmails",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "unmatchNotes",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "unmatchReason",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "wantsRematch",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "unmatchParticipants",
            "type": {
              "kind": "OBJECT",
              "name": "UnmatchParticipantsPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "file",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "sendUnmatchEmails",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "unmatchNotes",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "unmatchReason",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateAssessmentSurveyNewProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateAssessmentSurveyNewProgramTaskPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "updateAssessmentSurveyNewProgramTaskInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateClickLinkNewProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateClickLinkNewProgramTaskPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "updateClickLinkNewProgramTaskInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateClickLinkNewTask",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateClickLinkNewTaskPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "updateClickLinkNewTaskInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateCourseNewProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateCourseNewProgramTaskPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "updateCourseNewProgramTaskInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateCourseNewTask",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateCourseNewTaskPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "updateCourseNewTaskInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateEmailTemplate",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateEmailTemplatePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "updatedEmailTemplateInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateFlag",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateFlagPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "partnerNotes",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "status",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateFlagContact",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateFlagContactPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "flagContactInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateMenteeMentorSettings",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateMenteeMentorSettingsPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "settings",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateMicroSurvey",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateMicroSurveyPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "microSurvey",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateNewProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateNewProgramTaskPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "updateNewProgramTaskInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateParticipant",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateParticipantPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "participantInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateParticipantsMatchingLabels",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateParticipantsMatchingLabelsPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "action",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "file",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "labelKinds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updatePartner",
            "type": {
              "kind": "OBJECT",
              "name": "UpdatePartnerPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "higherEdCategory",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "higherEdRole",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "organizationType",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "userInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProgramAdmins",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateProgramAdminsPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programAdmins",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProgramCommunicationSettings",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateProgramCommunicationSettingsPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "updateProgramCommunicationSettingsInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProgramCustomLabel",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateProgramCustomLabelPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "updateProgramCustomLabelInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProgramCustomMessageTemplates",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateProgramCustomMessageTemplatesPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programCustomMessageTemplates",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProgramFlagContacts",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateProgramFlagContactsPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programFlagContacts",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProgramInfo",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateProgramInfoPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programInfo",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProgramPointPeople",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateProgramPointPeoplePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programPointPeople",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProgramSequenceInfo",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateProgramSequenceInfoPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programSequenceInfo",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProgramSetup",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateProgramSetupPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programSetup",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateProgramTaskPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programTask",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProgramTopic",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateProgramTopicPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "updateProgramTopicInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateProgramTopics",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateProgramTopicsPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programTopics",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateSchoolInfo",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateSchoolInfoPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "schoolInfo",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateSmsTemplate",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateSmsTemplatePayload",
              "ofType": null
            },
            "args": [
              {
                "name": "updatedSmsTemplateInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateSurveysAndQuizzes",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateSurveysAndQuizzesPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "surveysAndQuizzes",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateTopic",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateTopicPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "updatedTopicInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updateUser",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateUserPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "userInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "updatedProgramProfileAttributes",
            "type": {
              "kind": "OBJECT",
              "name": "UpdateProgramProfileAttributesPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "programProfileAttributesInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "uploadUserProfileData",
            "type": {
              "kind": "OBJECT",
              "name": "UploadUserProfileDataPayload",
              "ofType": null
            },
            "args": [
              {
                "name": "uploadUserProfileDataInput",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NewProgramTask",
        "fields": [
          {
            "name": "assigneeEntity",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "behavior",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "enabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "newTask",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "NewTask",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "programId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "taskAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INTERFACE",
                    "name": "TaskAssignment",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NewProgramTaskConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "NewProgramTaskEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "NewProgramTask",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NewProgramTaskEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "NewProgramTask",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NewTask",
        "fields": [
          {
            "name": "context",
            "type": {
              "kind": "UNION",
              "name": "Context",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "defaultAssigneeEntity",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "defaultDisplayName",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "internalTaskName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentorshipCredential",
            "type": {
              "kind": "OBJECT",
              "name": "MentorshipCredential",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "requiredForMatching",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "segmentTags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NewTaskConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "NewTaskEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "NewTask",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NewTaskEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "NewTask",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NotificationData",
        "fields": [
          {
            "name": "buttonOneText",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "displayMedium",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "imageUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "markdownBody",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "notificationViewableId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "notificationViewableType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ObjectChange",
        "fields": [
          {
            "name": "attribute",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "newValue",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "originalValue",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ObjectChangeset",
        "fields": [
          {
            "name": "adminAction",
            "type": {
              "kind": "OBJECT",
              "name": "AdminAction",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "changes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ObjectChange",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "eventType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "trackedObject",
            "type": {
              "kind": "UNION",
              "name": "TrackedObject",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ObjectChangesetConnection",
        "fields": [
          {
            "name": "affectedObjectTypeCounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AffectedObjectTypeCount",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ObjectChangesetEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ObjectChangeset",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ObjectChangesetEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "ObjectChangeset",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "OmniauthCredentialLatestSession",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "firstName",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "institutionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "lastAuthAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "lastName",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "omniauthCredentialId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PageInfo",
        "fields": [
          {
            "name": "endCursor",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hasNextPage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "hasPreviousPage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "startCursor",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INTERFACE",
        "name": "Participant",
        "fields": [
          {
            "name": "activityLogs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INTERFACE",
                    "name": "Log",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "avatar",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "avatarImage",
            "type": {
              "kind": "OBJECT",
              "name": "Image",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "cachedUserProfileData",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CachedUserProfileDataAttributeValue",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "attributes",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "cacheSettings",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "completedMatchingSurveyAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "deregisterDate",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "deregistrationStatusEvents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DeregistrationStatusEvent",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "matchingLabels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MatchingLabel",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "mentorships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Mentorship",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "status",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "notes",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "participantMentorships",
            "type": {
              "kind": "OBJECT",
              "name": "MentorshipConnection",
              "ofType": null
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "prioritizedAndPendingForRematching",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "pushedThroughToMatch",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "registered",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "registrationDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "supermentorOptIn",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "surveyResponses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SurveyResponse",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "context",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "surveyId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "uploadedVideos",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UploadedVideo",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "onlySharable",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "userProfileData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserProfileData",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "attributes",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "fallbackRules",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "source",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "webappBaseUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "writtenMessages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WrittenMessage",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "Mentor"
          },
          {
            "kind": "OBJECT",
            "name": "Student"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ParticipantConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ParticipantEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INTERFACE",
                    "name": "Participant",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountHavingAttendedTraining",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "onlyProgramsWithTraining",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "totalCountHavingCompletedMatchingSurvey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountHavingNotAttendedTraining",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountHavingNotCompletedMatchingSurvey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountHavingNotSignedUpForTraining",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountHavingSignedUpForTraining",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountInProgramsWithTraining",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountOfDistinctUsers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalPrioritizedAndPendingForRematching",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ParticipantConversationCategory",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "identifier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "label",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ParticipantConversationContent",
        "fields": [
          {
            "name": "confidenceNotes",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "confidenceScore",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "conversationLog",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ConversationLog",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "flag",
            "type": {
              "kind": "OBJECT",
              "name": "Flag",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "participantConversationCategories",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ParticipantConversationCategory",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "participantConversationType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "submittedBy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ParticipantConversationContentConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ParticipantConversationContentEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ParticipantConversationContent",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ParticipantConversationContentEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "ParticipantConversationContent",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ParticipantEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "INTERFACE",
              "name": "Participant",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ParticipantsFilterCriteria",
        "fields": [
          {
            "name": "availableToBeMatched",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "completedMatchingSurvey",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "currentlyMatched",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "engaged",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "everMatched",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "excludeProgramIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "programIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          },
          {
            "name": "registered",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "segment",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "signedUpForTraining",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ParticipantsMetrics",
        "fields": [
          {
            "name": "totalCompletedSurveys",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "surveyIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "totalCredentialed",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "useRegistrationDate",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "totalMatched",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "totalMatchingSurveyCompleted",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "totalRegistered",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "totalWantsMentorship",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "wantsMentorshipAnswer",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Partner",
        "fields": [
          {
            "name": "executiveHigherEdRole",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "facultyHigherEdRole",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "higherEdCategory",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "higherEdRole",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "organizationType",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "programSequence",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramSequence",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "registered",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "staffHigherEdRole",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PartnerConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "PartnerEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Partner",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "totalCountOfDistinctUsers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PartnerDashboardExports",
        "fields": [
          {
            "name": "conversations",
            "type": {
              "kind": "OBJECT",
              "name": "CsvExport",
              "ofType": null
            },
            "args": [
              {
                "name": "csvExportContext",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "profileDataColumns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "flags",
            "type": {
              "kind": "OBJECT",
              "name": "CsvExport",
              "ofType": null
            },
            "args": [
              {
                "name": "csvExportContext",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "profileDataColumns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "mentorships",
            "type": {
              "kind": "OBJECT",
              "name": "CsvExport",
              "ofType": null
            },
            "args": [
              {
                "name": "csvExportContext",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "exportType",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "includeTouchpointMetrics",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "profileDataColumns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "resultModifiers",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CsvExport",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "csvExportContext",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "firstColumn",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "profileDataColumns",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "resultModifiers",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PartnerEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "Partner",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PartnerNotification",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "partner",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Partner",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "sender",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PreviewMatchingSurveyPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "menteeSurvey",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentorSurvey",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "previewParticipantFromSameProgram",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Profile",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "programSpecificAttributes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileAttribute",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "profileAttributeType",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "profileAttributeValues",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProfileAttributeValue",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileAttributeCategory",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "profileAttributeCategoryItems",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProfileAttributeCategoryItem",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileAttributeCategoryItem",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "profileAttributeCategory",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProfileAttributeCategory",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProfileAttributeValue",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "profileAttribute",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProfileAttribute",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Program",
        "fields": [
          {
            "name": "accountNotes",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "active",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "activityLogs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ActivityLogConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "additionalFlagContactRecipients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FlagContact",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "alertDismissals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProgramAlertDismissal",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "allowMatching",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "allowMenteeSignUp",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "allowMentorSignUp",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "allowsMenteesToPushThemselvesThroughToMatch",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "askForMenteeSidInSignup",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "asksStrongestPreferenceQuestionInMenteeMatchingSurveyAndProfileAttributesExist",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "cohorts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          },
          {
            "name": "communicationMediumPreference",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "contacts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ContactConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "currentPhase",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "currentStage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "customMessageTemplates",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProgramCustomMessageTemplate",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "defaultProfileImage",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "endDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "engagementBenchmarkData",
            "type": {
              "kind": "OBJECT",
              "name": "EngagementBenchmarkData",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "engagementChartUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "firstParticipantCreatedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "flagContactEmail",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "flagContactFirstName",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "flagContactLastName",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "flagPageVisits",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FlagPageVisitConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "hasMatchingSuveysMigratedFromOldFramework",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isTemplateProgram",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isTestProgram",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "matchingCap",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "matchingCapReachedDate",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "matchingGoalReachedDate",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "menteeLoginMode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentorEndAssessmentSurvey",
            "type": {
              "kind": "OBJECT",
              "name": "Survey",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "mentorLoginMode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentorMatchingSurvey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Survey",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "mentorMidAssessmentSurvey",
            "type": {
              "kind": "OBJECT",
              "name": "Survey",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "mentorOpeningAssessmentSurvey",
            "type": {
              "kind": "OBJECT",
              "name": "Survey",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "mentorPointPersonEmail",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentorPointPersonFirstName",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentorPointPersonLastName",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentorPointPersonTitle",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentorPostSessionSurvey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Survey",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "mentorTrainingTask",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramTask",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "mentorType",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ParticipantConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "mentorships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MentorshipConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "nonPriorityFlagEmailEnabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "notes",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "numberOfOpenMentorSlots",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "partnerSuccessManager",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "partnerSuccessOperator",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "programAssessmentAreas",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProgramAssessmentArea",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "programCustomLabel",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramCustomLabel",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "programFlagCategories",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ProgramFlagCategory",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "programGoal",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramGoal",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "programInfoUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "programLogo",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "programProfileAttributes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProgramProfileAttribute",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "programRecruitmentAndOnboardingDashboardUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "programResources",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramResourceConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "programSequence",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramSequence",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "programTasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProgramTask",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "showAll",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "programTopics",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramTopicConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "reRecruitedMentorsCanSkipMatchingSurvey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "requiredMentorTrainingCredential",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "resources",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "salesforceOpportunityId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "satisfactionBenchmarkChartUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "satisfactionReport",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SatisfactionReport",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "secondaryFlagContactCcEmails",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "segment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "sendFlagsToExternalContact",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "sftpExportEnabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "sftpPrefix",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "shareMenteeEmail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "shareMenteePhone",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "shareMentorEmail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "shareMentorPhone",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "shortName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "showMatchingSurveysToPartner",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "showMentorsFlags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "startDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "studentEndAssessmentSurvey",
            "type": {
              "kind": "OBJECT",
              "name": "Survey",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "studentGoalsList",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "StudentGoalsList",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "studentMatchingSurvey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Survey",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "studentMidAssessmentSurvey",
            "type": {
              "kind": "OBJECT",
              "name": "Survey",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "studentOpeningAssessmentSurvey",
            "type": {
              "kind": "OBJECT",
              "name": "Survey",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "studentPointPersonEmail",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "studentPointPersonFirstName",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "studentPointPersonLastName",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "studentPointPersonTitle",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "studentPostSessionSurvey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Survey",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "students",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ParticipantConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "trainingMode",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "universityRelationsDirector",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "usesNewCommunications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramAlertDismissal",
        "fields": [
          {
            "name": "alertMetadata",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "alertTypeIdentifier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "dismissedBy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "snoozeUntil",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramAssessmentArea",
        "fields": [
          {
            "name": "assessmentArea",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AssessmentArea",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "enabledForMentees",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "enabledForMentors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "scaleMax",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "scaleMin",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramAutomatchingConfiguration",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "settings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuggestedBatchSettings",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "shearwaterAdministrator",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ShearwaterAdministrator",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramAutomatchingDefault",
        "fields": [
          {
            "name": "automatchingDefault",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AutomatchingDefault",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "shearwaterAdministrator",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ShearwaterAdministrator",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Program",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramCustomLabel",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "pluralMentee",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "pluralMentor",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "pluralMentorship",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "pluralSchool",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "pluralStudent",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "respectMenteeUppercase",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "respectMentorUppercase",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "respectMentorshipUppercase",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "respectSchoolUppercase",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "respectStudentUppercase",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "singularMentee",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "singularMenteeWithIndeterminateArticle",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "singularMentor",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "singularMentorWithIndeterminateArticle",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "singularMentorship",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "singularMentorshipWithIndeterminateArticle",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "singularSchool",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "singularSchoolWithIndeterminateArticle",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "singularStudent",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "singularStudentWithIndeterminateArticle",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramCustomMessageTemplate",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "customMessageType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "messageTemplate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "MessageTemplate",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramFlagCategory",
        "fields": [
          {
            "name": "customDisplayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "customSmsCharacter",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "flagCategory",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FlagCategory",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isVisible",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramGoal",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "target",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramPageVisit",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramProfileAttribute",
        "fields": [
          {
            "name": "availableInPartnerDashboardExports",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "availableInPartnerDashboardFilters",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "availableInPartnerDashboardProgramIntelligenceChart",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "defaultSettings",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramProfileAttributeDefaultSettings",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "profileAttribute",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProfileAttribute",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramProfileAttributeCategoryResult",
        "fields": [
          {
            "name": "profileAttribute",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProfileAttribute",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "profileAttributeCategories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProfileAttributeCategory",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramProfileAttributeDefaultSettings",
        "fields": [
          {
            "name": "availableInPartnerDashboardExports",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "availableInPartnerDashboardFilters",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "availableInPartnerDashboardProgramIntelligenceChart",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramProfileAttributeUnableToBeUpdated",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "programProfileAttributeId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramResource",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "uploadedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramResourceConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramResourceEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramResource",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramResourceEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramResource",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramSequence",
        "fields": [
          {
            "name": "flagCategories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FlagCategory",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "higherEdSegment",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "kind",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "menteeQuizTask",
            "type": {
              "kind": "OBJECT",
              "name": "TakeExternalLinkTask",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "menteeRecruitmentLink",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentorMatchingSurvey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Survey",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "mentorRecruitmentLink",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "partners",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Partner",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "registered",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "programs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Program",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "school",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "School",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "studentMatchingSurvey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Survey",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "urlSlug",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramSequenceConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramSequenceEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProgramSequence",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramSequenceEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramSequence",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramTask",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "position",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "programSequence",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramSequence",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "programSpecific",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "required",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "task",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "Task",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "toBeCompletedAs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramTopic",
        "fields": [
          {
            "name": "active",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "delayBeforeRestart",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "endDate",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "hoursBetweenOutreach",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastEditedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "startDate",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "topic",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Topic",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramTopicConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramTopicEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProgramTopic",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgramTopicEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramTopic",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Query",
        "fields": [
          {
            "name": "adminAction",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AdminAction",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "adminActions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AdminActionConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "assessmentAreasForSurvey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssessmentArea",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "surveyId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "automatchingDefaults",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AutomatchingDefault",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "contacts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ContactConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "conversationTopicCategories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ParticipantConversationCategory",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "segment",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "conversationTopics",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "questionId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "segment",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "country",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Country",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "course",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Course",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "courses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CourseConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "csvExports",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CsvExports",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "customMessageTypeTemplateRequirements",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomMessageTypeTemplateRequirementConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "deregistrationReasons",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeregistrationReasonConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "flagCategories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FlagCategory",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "flagContacts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "FlagContact",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "flags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FlagConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "matchingLabel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MatchingLabel",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "mentor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Mentor",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "mentorship",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Mentorship",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "mentorships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MentorshipConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "messageTemplate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "MessageTemplate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "messageTemplateTags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MessageTemplateTagConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "messageTemplates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MessageTemplateConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "metrics",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "QueryableMetrics",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "microSurvey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MicroSurvey",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "microSurveys",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MicroSurveyConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "newProgramTask",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "NewProgramTask",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "newProgramTasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "NewProgramTaskConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "newTask",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "NewTask",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "newTasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "NewTaskConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "outreachTopic",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Topic",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "outreachTopicCollections",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TopicCollection",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "filters",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "outreachTopics",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TopicConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "participant",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "Participant",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "participantConversationCategories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ParticipantConversationCategory",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "participantConversationContents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ParticipantConversationContentConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "participantGoals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GoalConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "participants",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ParticipantConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "partner",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Partner",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "partners",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PartnerConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "programAutomatchingConfiguration",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramAutomatchingConfiguration",
              "ofType": null
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "programAutomatchingDefault",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramAutomatchingDefault",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "programCompiledTexts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": [
              {
                "name": "originalTexts",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "programProfileAttributeCategories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProgramProfileAttributeCategoryResult",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "programSequences",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramSequenceConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "programTopic",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramTopic",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "programs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "resource",
            "type": {
              "kind": "OBJECT",
              "name": "Resource",
              "ofType": null
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "resourceTopics",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceTopicConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "resources",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "savedMatch",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SavedMatch",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "savedMatches",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SavedMatchConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "school",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "School",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "schools",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SchoolConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "sftpCsvExports",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SftpCsvExports",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "sftpS3Objects",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "S3Object",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "awsUsername",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programNamePrefix",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "skeletonMessageTemplate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SkeletonMessageTemplate",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "skeletonMessageTemplates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SkeletonMessageTemplateConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "stateMachine",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "StateMachine",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "stateMachines",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "StateMachineConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "student",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Student",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "suggestedBatch",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuggestedBatch",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "suggestedBatches",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuggestedBatchConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "suggestedMatch",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuggestedMatch",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "suggestedMatches",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuggestedMatchConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "survey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Survey",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "surveyQuestionRestrictedOptions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SurveyQuestionRestrictedOptionConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "qid",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "surveyResponses",
            "type": {
              "kind": "OBJECT",
              "name": "SurveyResponseConnection",
              "ofType": null
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "surveys",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SurveyConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "taskAssignments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INTERFACE",
                    "name": "TaskAssignment",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "participantIds",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "userId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "tasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TaskConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "uploadedVideos",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UploadedVideoConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "userStateVariables",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserStateVariable",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "filterList",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "userState",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "warehouseMetrics",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DwhQueryableMetrics",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "writtenMessages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "WrittenMessageConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "QueryableMetrics",
        "fields": [
          {
            "name": "assessmentScoreResponses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AssessmentScoreResponsesMetrics",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "contacts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ContactsMetrics",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "disengagementResolutions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DisengagementResolutionsMetricsResult",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "disengagementEventDateFilter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "disengagementResolutionsAverageTimeToRematch",
            "type": {
              "kind": "OBJECT",
              "name": "DisengagementResolutionsAverageTimeToRematchResult",
              "ofType": null
            },
            "args": [
              {
                "name": "disengagementEventDateFilter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "flags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FlagsMetrics",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "mentorships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MentorshipsMetrics",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "participants",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ParticipantsMetrics",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "recruitmentOpportunities",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "RecruitmentOpportunitiesMetricsResult",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "limit",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "mentorsUsersFilter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "opportunityArea",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "studentsUsersFilter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UsersMetrics",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "QuestionWeight",
        "fields": [
          {
            "name": "qid",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "weight",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ReactivateProgramAlertPayload",
        "fields": [
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RecruitmentOpportunitiesMetricsResult",
        "fields": [
          {
            "name": "attributeType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "attributeValue",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "menteesWaiting",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentorsCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentorsGap",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentorsOpenSlots",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "strongestPreferenceDisplayValue",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "strongestPreferenceKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RemoveMessageTemplatesTags",
        "fields": [
          {
            "name": "byFilterSelection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RemoveMessageTemplatesTagsByFilterSelectionPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "tagIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "byIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RemoveMessageTemplatesTagsByIdsPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "ids",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "tagIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RemoveMessageTemplatesTagsByFilterSelectionPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "messageTemplates",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "MessageTemplate",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfMessageTemplatesUpdated",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RemoveMessageTemplatesTagsByIdsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "messageTemplates",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "MessageTemplate",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfMessageTemplatesUpdated",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Resource",
        "fields": [
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "resourceType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "resourceable",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "UNION",
                "name": "Resourceable",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "topics",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ResourceTopic",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ResourceConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Resource",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ResourceEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "Resource",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ResourceTopic",
        "fields": [
          {
            "name": "archived",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ResourceTopicConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceTopicEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResourceTopic",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ResourceTopicEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "ResourceTopic",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "Resourceable",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ContentfulModuleResource"
          },
          {
            "kind": "OBJECT",
            "name": "SupportServiceResource"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "S3Object",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "keyWithoutPrefix",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SatisfactionAverage",
        "fields": [
          {
            "name": "mentorAverage",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "studentAverage",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SatisfactionReport",
        "fields": [
          {
            "name": "previousProgramSatisfaction",
            "type": {
              "kind": "OBJECT",
              "name": "SatisfactionAverage",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "programSatisfaction",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SatisfactionAverage",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "segmentSatisfaction",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SatisfactionAverage",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SaveBatchMatchesPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "suggestedBatch",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuggestedBatch",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SaveSurveyResponsePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "response",
            "type": {
              "kind": "OBJECT",
              "name": "SurveyResponse",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SaveWrittenMessagePayload",
        "fields": [
          {
            "name": "participant",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "Participant",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SavedMatch",
        "fields": [
          {
            "name": "additionalProgramSortingCriteria",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "adminUser",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "autoMatchStrategy",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Mentor",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "score",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "source",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "student",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Student",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SavedMatchConnection",
        "fields": [
          {
            "name": "adminUsers",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "User",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "autoMatchStrategies",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          },
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "SavedMatchEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "mentorSupermentorOptInTypes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SavedMatch",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "uniquePrograms",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Program",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SavedMatchEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "SavedMatch",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ScheduleTrainingTask",
        "fields": [
          {
            "name": "calendlyUrl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "customAfterCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "customCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "prompt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Task"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "School",
        "fields": [
          {
            "name": "awsUsername",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "institutionRegion",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "institutionType",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "isMinorityServingInstitution",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "logo",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "nameOfSchoolIdentifier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "omniauthCredentialLatestSessions",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "OmniauthCredentialLatestSession",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "programSequences",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProgramSequence",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "publicOrPrivate",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "shortName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "ssoBrand",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "ssoEnabled",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "ssoProviderIdentifier",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "ssoRequiredForPartners",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "ssoTestingEnabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "subdomain",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "twoOrFourYear",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SchoolConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "SchoolEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "School",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SchoolEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "School",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SchoolIdentifier",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "identificationString",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "providedBy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "school",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "School",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SendBulkMessageByCsvPayload",
        "fields": [
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "templateId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SendPartnerNotificationsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Error",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "successRecipients",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SendSsoTestingTemplatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Error",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "programSequenceId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SendTestMessagePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "templateId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SendUpdateEmailDraftForMentorshipPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "notice",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SetupSftpPayload",
        "fields": [
          {
            "name": "isSuccess",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SftpCsvExports",
        "fields": [
          {
            "name": "csvExportInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CsvExport",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "s3Key",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ShearwaterAdministrator",
        "fields": [
          {
            "name": "asanaId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "deactivatedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "permissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "salesforceUserId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SingleSelectHardMatchQuestion",
        "fields": [
          {
            "name": "matchType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "qid",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SkeletonMessageTemplate",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastEditedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "templateEditorData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SkeletonMessageTemplateConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "SkeletonMessageTemplateEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SkeletonMessageTemplate",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SkeletonMessageTemplateEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "SkeletonMessageTemplate",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SmsTemplate",
        "fields": [
          {
            "name": "archivedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "category",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "content",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "createdBy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "customMessageType",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "identifier",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "isDefault",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastEditedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastEditedBy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "messageType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "programSegment",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "tags",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MessageTemplateTag",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "userState",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "MessageTemplate"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "StartFirstWaveRecruitment",
        "fields": [
          {
            "name": "byFilterSelection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "StartFirstWaveRecruitmentByFilterSelectionPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "byIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "StartFirstWaveRecruitmentByIdsPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "ids",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StartFirstWaveRecruitmentByFilterSelectionPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfContactsActivated",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StartFirstWaveRecruitmentByIdsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfContactsActivated",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StartSecondWaveRecruitment",
        "fields": [
          {
            "name": "byFilterSelection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "StartSecondWaveRecruitmentByFilterSelectionPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "byIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "StartSecondWaveRecruitmentByIdsPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "ids",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StartSecondWaveRecruitmentByFilterSelectionPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfContactsActivated",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StartSecondWaveRecruitmentByIdsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfContactsActivated",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StateMachine",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "identifier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "metadata",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "schema",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StateMachineConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "StateMachineEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "StateMachine",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StateMachineEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "StateMachine",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StopRecruitment",
        "fields": [
          {
            "name": "byFilterSelection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "StopRecruitmentByFilterSelectionPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "byIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "StopRecruitmentByIdsPayload",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "ids",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StopRecruitmentByFilterSelectionPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfContactsDeactivated",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StopRecruitmentByIdsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "numberOfContactsDeactivated",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Student",
        "fields": [
          {
            "name": "activityLogs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INTERFACE",
                    "name": "Log",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "avatar",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "avatarImage",
            "type": {
              "kind": "OBJECT",
              "name": "Image",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "cachedUserProfileData",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CachedUserProfileDataAttributeValue",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "attributes",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "cacheSettings",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "completedMatchingSurveyAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "deregisterDate",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "deregistrationStatusEvents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DeregistrationStatusEvent",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "desiredMentoringSupport",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "goals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "StudentGoal",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "matchingLabels",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MatchingLabel",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "mentorships",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Mentorship",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "status",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "notes",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "participantMentorships",
            "type": {
              "kind": "OBJECT",
              "name": "MentorshipConnection",
              "ofType": null
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "sort",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "prioritizedAndPendingForRematching",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "programGoal",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "pushedThroughToMatch",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "questionForMentor",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "registered",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "registrationDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "rematchDate",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "savedMatches",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SavedMatch",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "supermentorOptIn",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "surveyResponses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SurveyResponse",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "context",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "surveyId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "uploadedVideos",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UploadedVideo",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "onlySharable",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "userProfileData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserProfileData",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "attributes",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "fallbackRules",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "source",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "webappBaseUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "writtenMessages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WrittenMessage",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Participant"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "StudentContact",
        "fields": [
          {
            "name": "a2pSmses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "A2pSms",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "activationStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "activationStatusChangedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "notes",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "registered",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "uploadedBy",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "uploadedDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Contact"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "StudentGoal",
        "fields": [
          {
            "name": "answer",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SurveyAnswer",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "answerKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "answerText",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "goal",
            "type": {
              "kind": "OBJECT",
              "name": "Goal",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StudentGoalsList",
        "fields": [
          {
            "name": "answerKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "answerText",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SuggestedBatch",
        "fields": [
          {
            "name": "adminUser",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "overview",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "settings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuggestedBatchSettings",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "strategyType",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SuggestedBatchConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuggestedBatchEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SuggestedBatch",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SuggestedBatchEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "SuggestedBatch",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SuggestedBatchSettings",
        "fields": [
          {
            "name": "autoMatchingSettings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AutoMatchSettings",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "groupMatchingSettings",
            "type": {
              "kind": "OBJECT",
              "name": "GroupMatchingSettings",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "matchingCriteria",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MatchingCriteria",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "programId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "questionsWeights",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "QuestionWeight",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SuggestedMatch",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "matchScore",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Mentor",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "student",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Student",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "suggestedBatch",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuggestedBatch",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SuggestedMatchConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuggestedMatchEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SuggestedMatch",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SuggestedMatchEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "SuggestedMatch",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SupportServiceResource",
        "fields": [
          {
            "name": "additionalInfo",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "address",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "categories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "contactEmail",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "contactName",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "contactPhone",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "phone",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Survey",
        "fields": [
          {
            "name": "archived",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "participantId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "surveyCustomRenderOverride",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "hasResponses",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "migrated",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "questions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SurveyQuestion",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "participantId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "qids",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "qidsToExclude",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "surveyCustomRenderOverride",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "userId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "surveyType",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyAnswer",
        "fields": [
          {
            "name": "answerJson",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "question",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SurveyQuestion",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "SurveyEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Survey",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "Survey",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyQuestion",
        "fields": [
          {
            "name": "createdInAdminTool",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "customizationOptions",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SurveyQuestionCustomizationOption",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "customizations",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "index",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isBaseQuestion",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "optional",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "qid",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "questionMdDisplay",
            "type": {
              "kind": "OBJECT",
              "name": "SurveyQuestionMdDisplay",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "template",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SurveyQuestionTemplate",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyQuestionCustomizationOption",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "text",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyQuestionMdDisplay",
        "fields": [
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "displayOnMatchingDashboard",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "question",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SurveyQuestion",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "sortable",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyQuestionRestrictedOption",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "label",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyQuestionRestrictedOptionConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "SurveyQuestionRestrictedOptionEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SurveyQuestionRestrictedOption",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyQuestionRestrictedOptionEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "SurveyQuestionRestrictedOption",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyQuestionTemplate",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "templateId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyResponse",
        "fields": [
          {
            "name": "answers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SurveyAnswer",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "withVariablesReplaced",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "context",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SurveyResponseContext",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentorship",
            "type": {
              "kind": "OBJECT",
              "name": "Mentorship",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "participant",
            "type": {
              "kind": "INTERFACE",
              "name": "Participant",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "submittedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "survey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Survey",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "surveyResponseAnswerStrings",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SurveyResponseAnswerStrings",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyResponseAnswerStrings",
        "fields": [
          {
            "name": "answerString",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "qid",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "questionPrompt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "subprompt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "surveyResponseAnswerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyResponseConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "SurveyResponseEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SurveyResponse",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyResponseContext",
        "fields": [
          {
            "name": "mentorshipChatGroupId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentorshipId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "participantId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyResponseEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "SurveyResponse",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TakeExternalLinkTask",
        "fields": [
          {
            "name": "customAfterCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "customCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "externalLink",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExternalLink",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "prompt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Task"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "TakeSurveyTask",
        "fields": [
          {
            "name": "customAfterCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "customCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "prompt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "survey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Survey",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Task"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Task",
        "fields": [
          {
            "name": "customAfterCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "customCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "prompt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ScheduleTrainingTask"
          },
          {
            "kind": "OBJECT",
            "name": "TakeExternalLinkTask"
          },
          {
            "kind": "OBJECT",
            "name": "TakeSurveyTask"
          },
          {
            "kind": "OBJECT",
            "name": "UploadPhotoTask"
          },
          {
            "kind": "OBJECT",
            "name": "UploadVideoTask"
          },
          {
            "kind": "OBJECT",
            "name": "WatchVideoTask"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "TaskAssignment",
        "fields": [
          {
            "name": "behavior",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "participantId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "position",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AssessmentSurveyTaskAssignment"
          },
          {
            "kind": "OBJECT",
            "name": "ClickLinkTaskAssignment"
          },
          {
            "kind": "OBJECT",
            "name": "CourseTaskAssignment"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "TaskConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "TaskEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INTERFACE",
                    "name": "Task",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TaskEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "INTERFACE",
              "name": "Task",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TookTypeformSurveyLog",
        "fields": [
          {
            "name": "externalLink",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExternalLink",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "loggedAtDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Log"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Topic",
        "fields": [
          {
            "name": "archivedAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "category",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "hoursDelayBeforeRestart",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isDefault",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "priority",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "programSegment",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "programTopics",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramTopicConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "topicConditions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TopicCondition",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "topicMessages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TopicMessage",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "userState",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TopicCollection",
        "fields": [
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "topics",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TopicConnection",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TopicCondition",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "key",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "topics",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Topic",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TopicConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "TopicEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Topic",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TopicEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "Topic",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TopicMessage",
        "fields": [
          {
            "name": "emailTemplate",
            "type": {
              "kind": "OBJECT",
              "name": "EmailTemplate",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "hoursDelayAfterMessage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "index",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "preferredMedium",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "smsTemplate",
            "type": {
              "kind": "OBJECT",
              "name": "SmsTemplate",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "TrackedObject",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "Mentor"
          },
          {
            "kind": "OBJECT",
            "name": "MentorContact"
          },
          {
            "kind": "OBJECT",
            "name": "Mentorship"
          },
          {
            "kind": "OBJECT",
            "name": "MicroSurvey"
          },
          {
            "kind": "OBJECT",
            "name": "Program"
          },
          {
            "kind": "OBJECT",
            "name": "ProgramAlertDismissal"
          },
          {
            "kind": "OBJECT",
            "name": "ProgramCustomMessageTemplate"
          },
          {
            "kind": "OBJECT",
            "name": "ProgramGoal"
          },
          {
            "kind": "OBJECT",
            "name": "ProgramSequence"
          },
          {
            "kind": "OBJECT",
            "name": "ProgramTask"
          },
          {
            "kind": "OBJECT",
            "name": "ProgramTopic"
          },
          {
            "kind": "OBJECT",
            "name": "SavedMatch"
          },
          {
            "kind": "OBJECT",
            "name": "SchoolIdentifier"
          },
          {
            "kind": "OBJECT",
            "name": "Student"
          },
          {
            "kind": "OBJECT",
            "name": "StudentContact"
          },
          {
            "kind": "OBJECT",
            "name": "User"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "TrainingEventLog",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "kind",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "loggedAtDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "participant",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "Participant",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Log"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UnmatchParticipantPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "mentorship",
            "type": {
              "kind": "OBJECT",
              "name": "Mentorship",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "participant",
            "type": {
              "kind": "INTERFACE",
              "name": "Participant",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UnmatchParticipantsPayload",
        "fields": [
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateAssessmentSurveyNewProgramTaskPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "newProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewProgramTask",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateClickLinkNewProgramTaskPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "newProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewProgramTask",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateClickLinkNewTaskPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "newTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewTask",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateCourseNewProgramTaskPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "newProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewProgramTask",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateCourseNewTaskPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "newTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewTask",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateEmailTemplatePayload",
        "fields": [
          {
            "name": "emailTemplate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmailTemplate",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateFlagContactPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "flagContact",
            "type": {
              "kind": "OBJECT",
              "name": "FlagContact",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateFlagPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "flag",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Flag",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateMenteeMentorSettingsError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateMenteeMentorSettingsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UpdateMenteeMentorSettingsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateMicroSurveyPayload",
        "fields": [
          {
            "name": "microSurvey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MicroSurvey",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateNewProgramTaskPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "newProgramTask",
            "type": {
              "kind": "OBJECT",
              "name": "NewProgramTask",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateParticipantPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "participant",
            "type": {
              "kind": "INTERFACE",
              "name": "Participant",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateParticipantsMatchingLabelsPayload",
        "fields": [
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdatePartnerPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "partner",
            "type": {
              "kind": "OBJECT",
              "name": "Partner",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramAdminsError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramAdminsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UpdateProgramAdminsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramCommunicationSettingsPayload",
        "fields": [
          {
            "name": "program",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Program",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramCustomLabelPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Error",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramCustomMessageTemplatesError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramCustomMessageTemplatesPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UpdateProgramCustomMessageTemplatesError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramFlagContactsError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramFlagContactsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UpdateProgramFlagContactsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramInfoError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramInfoPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UpdateProgramInfoError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramPointPeopleError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramPointPeoplePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UpdateProgramPointPeopleError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramProfileAttributesPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProgramProfileAttributeUnableToBeUpdated",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "updatedProgramProfileAttributes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProgramProfileAttribute",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramSequenceInfoError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramSequenceInfoPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UpdateProgramSequenceInfoError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "programSequence",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramSequence",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramSetupError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramSetupPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UpdateProgramSetupError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramTaskPayload",
        "fields": [
          {
            "name": "programTask",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramTask",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramTopicPayload",
        "fields": [
          {
            "name": "programTopic",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProgramTopic",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramTopicsError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProgramTopicsPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UpdateProgramTopicsError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateSchoolInfoError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateSchoolInfoPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UpdateSchoolInfoError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "school",
            "type": {
              "kind": "OBJECT",
              "name": "School",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateSmsTemplatePayload",
        "fields": [
          {
            "name": "smsTemplate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SmsTemplate",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateSurveysAndQuizzesError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateSurveysAndQuizzesPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UpdateSurveysAndQuizzesError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "program",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateTopicPayload",
        "fields": [
          {
            "name": "topic",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Topic",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUserPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UploadPhotoTask",
        "fields": [
          {
            "name": "customAfterCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "customCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "prompt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Task"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UploadUserProfileDataPayload",
        "fields": [
          {
            "name": "batchActionId",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UploadVideoTask",
        "fields": [
          {
            "name": "customAfterCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "customCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "prompt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Task"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UploadedVideo",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "participant",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "Participant",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "sharePublicly",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "shareWithStudents",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "ziggeoToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UploadedVideoConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "UploadedVideoEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UploadedVideo",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UploadedVideoEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "UploadedVideo",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "User",
        "fields": [
          {
            "name": "activeShearwaterAdministrator",
            "type": {
              "kind": "OBJECT",
              "name": "ShearwaterAdministrator",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "avatar",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "avatarImage",
            "type": {
              "kind": "OBJECT",
              "name": "Image",
              "ofType": null
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "cachedUserProfileData",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CachedUserProfileDataAttributeValue",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "attributes",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "cacheSettings",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "contacts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INTERFACE",
                    "name": "Contact",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "facebookUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "hasValidSsoToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "instagramUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "isAdmin",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isFeatureEnabledFor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": [
              {
                "name": "feature",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "isMentorInChatGroup",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "isPartner",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "lastProgramPageVisit",
            "type": {
              "kind": "OBJECT",
              "name": "ProgramPageVisit",
              "ofType": null
            },
            "args": [
              {
                "name": "path",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "lastSignInAt",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "latestDashboardNotificationData",
            "type": {
              "kind": "OBJECT",
              "name": "NotificationData",
              "ofType": null
            },
            "args": [
              {
                "name": "requestOrigin",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "latestPartnerProgramForSchool",
            "type": {
              "kind": "OBJECT",
              "name": "Program",
              "ofType": null
            },
            "args": [
              {
                "name": "schoolId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "linkedInUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "mentorshipCredentials",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserMentorshipCredential",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "credentials",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "microSurvey",
            "type": {
              "kind": "OBJECT",
              "name": "MicroSurvey",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "participants",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INTERFACE",
                    "name": "Participant",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "registered",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "partners",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Partner",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "registered",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "phone",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "phoneCountry",
            "type": {
              "kind": "OBJECT",
              "name": "Country",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "profile",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Profile",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "schoolIdentifiers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SchoolIdentifier",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "signedUpWithSso",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "surveyResponses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SurveyResponse",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "context",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "surveyId",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              }
            ]
          },
          {
            "name": "twitterUrl",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "unsubscribedFromEmails",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "unsubscribedFromSmses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "userProfileData",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "UserProfileData",
                  "ofType": null
                }
              }
            },
            "args": [
              {
                "name": "attributes",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              },
              {
                "name": "fallbackRules",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "Any"
                    }
                  }
                }
              },
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "source",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          },
          {
            "name": "userStatusInProgram",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": [
              {
                "name": "programId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "User",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserMentorshipCredential",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "mentorshipCredential",
            "type": {
              "kind": "OBJECT",
              "name": "MentorshipCredential",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserProfileAttributeValue",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "openResponse",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "profileAttributeValue",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProfileAttributeValue",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "userProfileAttributeValueUpdate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserProfileAttributeValueUpdate",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserProfileAttributeValueUpdate",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "programId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "source",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserProfileData",
        "fields": [
          {
            "name": "profileAttribute",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProfileAttribute",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "values",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UserProfileAttributeValue",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserStateVariable",
        "fields": [
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "previewValue",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UsersMetrics",
        "fields": [
          {
            "name": "totalEnteredProgram",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "programIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "totalMinimumTouchpoints",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "minimumNumberTouchpoints",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "programIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "totalRepliesToMcTextMessages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "programIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          },
          {
            "name": "totalZeroTouchpoints",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Interval",
                    "ofType": null
                  }
                }
              }
            },
            "args": [
              {
                "name": "aggregateInTimeZone",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "dateRange",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "groupBy",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "intervalBy",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Any"
                  }
                }
              },
              {
                "name": "maxGroups",
                "type": {
                  "kind": "SCALAR",
                  "name": "Any"
                }
              },
              {
                "name": "programIds",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "Any"
                      }
                    }
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "WatchVideoTask",
        "fields": [
          {
            "name": "customAfterCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "customCallToAction",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "Any"
            },
            "args": []
          },
          {
            "name": "prompt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "wistiaVideoId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Task"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "WatchedCommunityVideoLog",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "loggedAtDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "ziggeoToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Log"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "WatchedVideoLog",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "loggedAtDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "wistiaVideoId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Log"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "WrittenMessage",
        "fields": [
          {
            "name": "content",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "participant",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "Participant",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "WrittenMessageConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "WrittenMessageEdge",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "WrittenMessage",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "WrittenMessageEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Any"
              }
            },
            "args": []
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "WrittenMessage",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "SCALAR",
        "name": "Any"
      }
    ],
    "directives": []
  }
} as unknown as IntrospectionQuery;
export type WithTypename<T extends { __typename?: any }> = Partial<T> & { __typename: NonNullable<T['__typename']> };

export type GraphCacheKeysConfig = {
  A2pSms?: (data: WithTypename<A2pSms>) => null | string,
  ActivityLog?: (data: WithTypename<ActivityLog>) => null | string,
  ActivityLogConnection?: (data: WithTypename<ActivityLogConnection>) => null | string,
  ActivityLogEdge?: (data: WithTypename<ActivityLogEdge>) => null | string,
  AddContactsFromExistingProgramPayload?: (data: WithTypename<AddContactsFromExistingProgramPayload>) => null | string,
  AddContactsPayload?: (data: WithTypename<AddContactsPayload>) => null | string,
  AddContactsToExistingUsersPayload?: (data: WithTypename<AddContactsToExistingUsersPayload>) => null | string,
  AddMessageTemplatesTags?: (data: WithTypename<AddMessageTemplatesTags>) => null | string,
  AddMessageTemplatesTagsByFilterSelectionPayload?: (data: WithTypename<AddMessageTemplatesTagsByFilterSelectionPayload>) => null | string,
  AddMessageTemplatesTagsByIdsPayload?: (data: WithTypename<AddMessageTemplatesTagsByIdsPayload>) => null | string,
  AddParticipantsPayload?: (data: WithTypename<AddParticipantsPayload>) => null | string,
  AdminAction?: (data: WithTypename<AdminAction>) => null | string,
  AdminActionConnection?: (data: WithTypename<AdminActionConnection>) => null | string,
  AdminActionEdge?: (data: WithTypename<AdminActionEdge>) => null | string,
  AffectedObjectTypeCount?: (data: WithTypename<AffectedObjectTypeCount>) => null | string,
  ArchiveRestoreMessageTemplates?: (data: WithTypename<ArchiveRestoreMessageTemplates>) => null | string,
  ArchiveRestoreMessageTemplatesByFilterSelectionPayload?: (data: WithTypename<ArchiveRestoreMessageTemplatesByFilterSelectionPayload>) => null | string,
  ArchiveRestoreMessageTemplatesByIdsPayload?: (data: WithTypename<ArchiveRestoreMessageTemplatesByIdsPayload>) => null | string,
  AssessmentArea?: (data: WithTypename<AssessmentArea>) => null | string,
  AssessmentPrompt?: (data: WithTypename<AssessmentPrompt>) => null | string,
  AssessmentScoreResponse?: (data: WithTypename<AssessmentScoreResponse>) => null | string,
  AssessmentScoreResponsesMetrics?: (data: WithTypename<AssessmentScoreResponsesMetrics>) => null | string,
  AssessmentSurveyTaskAssignment?: (data: WithTypename<AssessmentSurveyTaskAssignment>) => null | string,
  AssessmentSurveyTaskContext?: (data: WithTypename<AssessmentSurveyTaskContext>) => null | string,
  AutoMatchSettings?: (data: WithTypename<AutoMatchSettings>) => null | string,
  AutoSuggestMatchesPayload?: (data: WithTypename<AutoSuggestMatchesPayload>) => null | string,
  AutomatchingDefault?: (data: WithTypename<AutomatchingDefault>) => null | string,
  CachedUserProfileDataAttributeValue?: (data: WithTypename<CachedUserProfileDataAttributeValue>) => null | string,
  ChangeMentorTrainingStatusPayload?: (data: WithTypename<ChangeMentorTrainingStatusPayload>) => null | string,
  ClickLinkTaskAssignment?: (data: WithTypename<ClickLinkTaskAssignment>) => null | string,
  CompleteTaskAssignmentPayload?: (data: WithTypename<CompleteTaskAssignmentPayload>) => null | string,
  ConfigureFlagsError?: (data: WithTypename<ConfigureFlagsError>) => null | string,
  ConfigureFlagsPayload?: (data: WithTypename<ConfigureFlagsPayload>) => null | string,
  ContactConnection?: (data: WithTypename<ContactConnection>) => null | string,
  ContactEdge?: (data: WithTypename<ContactEdge>) => null | string,
  ContactsMetrics?: (data: WithTypename<ContactsMetrics>) => null | string,
  ContentfulModuleResource?: (data: WithTypename<ContentfulModuleResource>) => null | string,
  ContentfulModuleSection?: (data: WithTypename<ContentfulModuleSection>) => null | string,
  ConversationLog?: (data: WithTypename<ConversationLog>) => null | string,
  Country?: (data: WithTypename<Country>) => null | string,
  Course?: (data: WithTypename<Course>) => null | string,
  CourseConnection?: (data: WithTypename<CourseConnection>) => null | string,
  CourseEdge?: (data: WithTypename<CourseEdge>) => null | string,
  CourseTaskAssignment?: (data: WithTypename<CourseTaskAssignment>) => null | string,
  CourseTaskContext?: (data: WithTypename<CourseTaskContext>) => null | string,
  CreateEmailTemplatePayload?: (data: WithTypename<CreateEmailTemplatePayload>) => null | string,
  CreateEmailTemplateSavedRowPayload?: (data: WithTypename<CreateEmailTemplateSavedRowPayload>) => null | string,
  CreateFlagContactPayload?: (data: WithTypename<CreateFlagContactPayload>) => null | string,
  CreateMatchingLabelPayload?: (data: WithTypename<CreateMatchingLabelPayload>) => null | string,
  CreateMatchingSurveyPayload?: (data: WithTypename<CreateMatchingSurveyPayload>) => null | string,
  CreateMessageTemplateTagPayload?: (data: WithTypename<CreateMessageTemplateTagPayload>) => null | string,
  CreateMicroSurveyPayload?: (data: WithTypename<CreateMicroSurveyPayload>) => null | string,
  CreateNewCourseTaskAndNewProgramTaskPayload?: (data: WithTypename<CreateNewCourseTaskAndNewProgramTaskPayload>) => null | string,
  CreateNewLinkTaskAndNewProgramTaskPayload?: (data: WithTypename<CreateNewLinkTaskAndNewProgramTaskPayload>) => null | string,
  CreateNotificationViewPayload?: (data: WithTypename<CreateNotificationViewPayload>) => null | string,
  CreateOrEnableNewProgramTaskPayload?: (data: WithTypename<CreateOrEnableNewProgramTaskPayload>) => null | string,
  CreatePartnerPayload?: (data: WithTypename<CreatePartnerPayload>) => null | string,
  CreateProgramAutomatchingConfigurationPayload?: (data: WithTypename<CreateProgramAutomatchingConfigurationPayload>) => null | string,
  CreateProgramAutomatchingDefaultPayload?: (data: WithTypename<CreateProgramAutomatchingDefaultPayload>) => null | string,
  CreateProgramError?: (data: WithTypename<CreateProgramError>) => null | string,
  CreateProgramPageVisitPayload?: (data: WithTypename<CreateProgramPageVisitPayload>) => null | string,
  CreateProgramPayload?: (data: WithTypename<CreateProgramPayload>) => null | string,
  CreateProgramResourceError?: (data: WithTypename<CreateProgramResourceError>) => null | string,
  CreateProgramResourcePayload?: (data: WithTypename<CreateProgramResourcePayload>) => null | string,
  CreateProgramSequenceError?: (data: WithTypename<CreateProgramSequenceError>) => null | string,
  CreateProgramSequencePayload?: (data: WithTypename<CreateProgramSequencePayload>) => null | string,
  CreateProgramTaskPayload?: (data: WithTypename<CreateProgramTaskPayload>) => null | string,
  CreateProgramTopicPayload?: (data: WithTypename<CreateProgramTopicPayload>) => null | string,
  CreateSavedMatchPayload?: (data: WithTypename<CreateSavedMatchPayload>) => null | string,
  CreateSchoolError?: (data: WithTypename<CreateSchoolError>) => null | string,
  CreateSchoolPayload?: (data: WithTypename<CreateSchoolPayload>) => null | string,
  CreateSkeletonMessageTemplatePayload?: (data: WithTypename<CreateSkeletonMessageTemplatePayload>) => null | string,
  CreateSmsTemplatePayload?: (data: WithTypename<CreateSmsTemplatePayload>) => null | string,
  CreateTopicPayload?: (data: WithTypename<CreateTopicPayload>) => null | string,
  CreateUploadedVideoPayload?: (data: WithTypename<CreateUploadedVideoPayload>) => null | string,
  CsvExport?: (data: WithTypename<CsvExport>) => null | string,
  CsvExports?: (data: WithTypename<CsvExports>) => null | string,
  CustomMessageTypeTemplateRequirement?: (data: WithTypename<CustomMessageTypeTemplateRequirement>) => null | string,
  CustomMessageTypeTemplateRequirementConnection?: (data: WithTypename<CustomMessageTypeTemplateRequirementConnection>) => null | string,
  CustomMessageTypeTemplateRequirementEdge?: (data: WithTypename<CustomMessageTypeTemplateRequirementEdge>) => null | string,
  DeleteContacts?: (data: WithTypename<DeleteContacts>) => null | string,
  DeleteContactsByFilterSelectionPayload?: (data: WithTypename<DeleteContactsByFilterSelectionPayload>) => null | string,
  DeleteContactsByIdsPayload?: (data: WithTypename<DeleteContactsByIdsPayload>) => null | string,
  DeleteFlagContactPayload?: (data: WithTypename<DeleteFlagContactPayload>) => null | string,
  DeleteMatchingLabelPayload?: (data: WithTypename<DeleteMatchingLabelPayload>) => null | string,
  DeleteProgramPayload?: (data: WithTypename<DeleteProgramPayload>) => null | string,
  DeleteProgramResourcePayload?: (data: WithTypename<DeleteProgramResourcePayload>) => null | string,
  DeleteProgramSequencePayload?: (data: WithTypename<DeleteProgramSequencePayload>) => null | string,
  DeleteProgramTaskPayload?: (data: WithTypename<DeleteProgramTaskPayload>) => null | string,
  DeleteProgramTopicPayload?: (data: WithTypename<DeleteProgramTopicPayload>) => null | string,
  DeleteSavedMatches?: (data: WithTypename<DeleteSavedMatches>) => null | string,
  DeleteSavedMatchesByFilterPayload?: (data: WithTypename<DeleteSavedMatchesByFilterPayload>) => null | string,
  DeleteSavedMatchesByIdsPayload?: (data: WithTypename<DeleteSavedMatchesByIdsPayload>) => null | string,
  DeleteSchoolPayload?: (data: WithTypename<DeleteSchoolPayload>) => null | string,
  DeleteSuggestedBatchPayload?: (data: WithTypename<DeleteSuggestedBatchPayload>) => null | string,
  DenylistEmailsPayload?: (data: WithTypename<DenylistEmailsPayload>) => null | string,
  DeregisterParticipantPayload?: (data: WithTypename<DeregisterParticipantPayload>) => null | string,
  DeregistrationReason?: (data: WithTypename<DeregistrationReason>) => null | string,
  DeregistrationReasonConnection?: (data: WithTypename<DeregistrationReasonConnection>) => null | string,
  DeregistrationReasonEdge?: (data: WithTypename<DeregistrationReasonEdge>) => null | string,
  DeregistrationStatusEvent?: (data: WithTypename<DeregistrationStatusEvent>) => null | string,
  DisableNewProgramTaskPayload?: (data: WithTypename<DisableNewProgramTaskPayload>) => null | string,
  DisengagementResolutionsAverageTimeToRematchResult?: (data: WithTypename<DisengagementResolutionsAverageTimeToRematchResult>) => null | string,
  DisengagementResolutionsMetricsResult?: (data: WithTypename<DisengagementResolutionsMetricsResult>) => null | string,
  DismissProgramAlertPayload?: (data: WithTypename<DismissProgramAlertPayload>) => null | string,
  DuplicateError?: (data: WithTypename<DuplicateError>) => null | string,
  DuplicateMessageTemplates?: (data: WithTypename<DuplicateMessageTemplates>) => null | string,
  DuplicateMessageTemplatesByFilterSelectionPayload?: (data: WithTypename<DuplicateMessageTemplatesByFilterSelectionPayload>) => null | string,
  DuplicateMessageTemplatesByIdsPayload?: (data: WithTypename<DuplicateMessageTemplatesByIdsPayload>) => null | string,
  DuplicateProgramPayload?: (data: WithTypename<DuplicateProgramPayload>) => null | string,
  DuplicateProgramSequencePayload?: (data: WithTypename<DuplicateProgramSequencePayload>) => null | string,
  DwhParticipantsMetrics?: (data: WithTypename<DwhParticipantsMetrics>) => null | string,
  DwhParticipantsMetricsConnection?: (data: WithTypename<DwhParticipantsMetricsConnection>) => null | string,
  DwhQueryableMetrics?: (data: WithTypename<DwhQueryableMetrics>) => null | string,
  EmailTemplate?: (data: WithTypename<EmailTemplate>) => null | string,
  EmailTemplateSavedRow?: (data: WithTypename<EmailTemplateSavedRow>) => null | string,
  EngagementBenchmarkData?: (data: WithTypename<EngagementBenchmarkData>) => null | string,
  Error?: (data: WithTypename<Error>) => null | string,
  ExternalLink?: (data: WithTypename<ExternalLink>) => null | string,
  Flag?: (data: WithTypename<Flag>) => null | string,
  FlagCategory?: (data: WithTypename<FlagCategory>) => null | string,
  FlagConnection?: (data: WithTypename<FlagConnection>) => null | string,
  FlagContact?: (data: WithTypename<FlagContact>) => null | string,
  FlagEdge?: (data: WithTypename<FlagEdge>) => null | string,
  FlagPageVisit?: (data: WithTypename<FlagPageVisit>) => null | string,
  FlagPageVisitConnection?: (data: WithTypename<FlagPageVisitConnection>) => null | string,
  FlagPageVisitEdge?: (data: WithTypename<FlagPageVisitEdge>) => null | string,
  FlagsMetrics?: (data: WithTypename<FlagsMetrics>) => null | string,
  Goal?: (data: WithTypename<Goal>) => null | string,
  GoalConnection?: (data: WithTypename<GoalConnection>) => null | string,
  GoalEdge?: (data: WithTypename<GoalEdge>) => null | string,
  GroupMatchingSettings?: (data: WithTypename<GroupMatchingSettings>) => null | string,
  Image?: (data: WithTypename<Image>) => null | string,
  Interval?: (data: WithTypename<Interval>) => null | string,
  LinkTaskContext?: (data: WithTypename<LinkTaskContext>) => null | string,
  LogTookTypeformSurveyPayload?: (data: WithTypename<LogTookTypeformSurveyPayload>) => null | string,
  LogWatchedCommunityVideoPayload?: (data: WithTypename<LogWatchedCommunityVideoPayload>) => null | string,
  LogWatchedWistiaVideoPayload?: (data: WithTypename<LogWatchedWistiaVideoPayload>) => null | string,
  MakeBatchMatchesPayload?: (data: WithTypename<MakeBatchMatchesPayload>) => null | string,
  MakeMatchPayload?: (data: WithTypename<MakeMatchPayload>) => null | string,
  MakeSavedGroupMatches?: (data: WithTypename<MakeSavedGroupMatches>) => null | string,
  MakeSavedGroupMatchesByFilterPayload?: (data: WithTypename<MakeSavedGroupMatchesByFilterPayload>) => null | string,
  MakeSavedGroupMatchesByIdsPayload?: (data: WithTypename<MakeSavedGroupMatchesByIdsPayload>) => null | string,
  MakeSavedMatches?: (data: WithTypename<MakeSavedMatches>) => null | string,
  MakeSavedMatchesByFilterPayload?: (data: WithTypename<MakeSavedMatchesByFilterPayload>) => null | string,
  MakeSavedMatchesByIdsPayload?: (data: WithTypename<MakeSavedMatchesByIdsPayload>) => null | string,
  MarkParticipantReachedOutPayload?: (data: WithTypename<MarkParticipantReachedOutPayload>) => null | string,
  MatchingCriteria?: (data: WithTypename<MatchingCriteria>) => null | string,
  MatchingLabel?: (data: WithTypename<MatchingLabel>) => null | string,
  Mentor?: (data: WithTypename<Mentor>) => null | string,
  MentorContact?: (data: WithTypename<MentorContact>) => null | string,
  Mentorship?: (data: WithTypename<Mentorship>) => null | string,
  MentorshipChatGroup?: (data: WithTypename<MentorshipChatGroup>) => null | string,
  MentorshipConnection?: (data: WithTypename<MentorshipConnection>) => null | string,
  MentorshipCredential?: (data: WithTypename<MentorshipCredential>) => null | string,
  MentorshipEdge?: (data: WithTypename<MentorshipEdge>) => null | string,
  MentorshipMegaphoneGroup?: (data: WithTypename<MentorshipMegaphoneGroup>) => null | string,
  MentorshipsMetrics?: (data: WithTypename<MentorshipsMetrics>) => null | string,
  MessageTemplateConnection?: (data: WithTypename<MessageTemplateConnection>) => null | string,
  MessageTemplateEdge?: (data: WithTypename<MessageTemplateEdge>) => null | string,
  MessageTemplateTag?: (data: WithTypename<MessageTemplateTag>) => null | string,
  MessageTemplateTagConnection?: (data: WithTypename<MessageTemplateTagConnection>) => null | string,
  MessageTemplateTagCount?: (data: WithTypename<MessageTemplateTagCount>) => null | string,
  MessageTemplateTagEdge?: (data: WithTypename<MessageTemplateTagEdge>) => null | string,
  MicroSurvey?: (data: WithTypename<MicroSurvey>) => null | string,
  MicroSurveyConnection?: (data: WithTypename<MicroSurveyConnection>) => null | string,
  MicroSurveyEdge?: (data: WithTypename<MicroSurveyEdge>) => null | string,
  MicroSurveyTargetingCriteria?: (data: WithTypename<MicroSurveyTargetingCriteria>) => null | string,
  MoveParticipantsPayload?: (data: WithTypename<MoveParticipantsPayload>) => null | string,
  MultiSelectHardMatchQuestion?: (data: WithTypename<MultiSelectHardMatchQuestion>) => null | string,
  NewProgramTask?: (data: WithTypename<NewProgramTask>) => null | string,
  NewProgramTaskConnection?: (data: WithTypename<NewProgramTaskConnection>) => null | string,
  NewProgramTaskEdge?: (data: WithTypename<NewProgramTaskEdge>) => null | string,
  NewTask?: (data: WithTypename<NewTask>) => null | string,
  NewTaskConnection?: (data: WithTypename<NewTaskConnection>) => null | string,
  NewTaskEdge?: (data: WithTypename<NewTaskEdge>) => null | string,
  NotificationData?: (data: WithTypename<NotificationData>) => null | string,
  ObjectChange?: (data: WithTypename<ObjectChange>) => null | string,
  ObjectChangeset?: (data: WithTypename<ObjectChangeset>) => null | string,
  ObjectChangesetConnection?: (data: WithTypename<ObjectChangesetConnection>) => null | string,
  ObjectChangesetEdge?: (data: WithTypename<ObjectChangesetEdge>) => null | string,
  OmniauthCredentialLatestSession?: (data: WithTypename<OmniauthCredentialLatestSession>) => null | string,
  PageInfo?: (data: WithTypename<PageInfo>) => null | string,
  ParticipantConnection?: (data: WithTypename<ParticipantConnection>) => null | string,
  ParticipantConversationCategory?: (data: WithTypename<ParticipantConversationCategory>) => null | string,
  ParticipantConversationContent?: (data: WithTypename<ParticipantConversationContent>) => null | string,
  ParticipantConversationContentConnection?: (data: WithTypename<ParticipantConversationContentConnection>) => null | string,
  ParticipantConversationContentEdge?: (data: WithTypename<ParticipantConversationContentEdge>) => null | string,
  ParticipantEdge?: (data: WithTypename<ParticipantEdge>) => null | string,
  ParticipantsFilterCriteria?: (data: WithTypename<ParticipantsFilterCriteria>) => null | string,
  ParticipantsMetrics?: (data: WithTypename<ParticipantsMetrics>) => null | string,
  Partner?: (data: WithTypename<Partner>) => null | string,
  PartnerConnection?: (data: WithTypename<PartnerConnection>) => null | string,
  PartnerDashboardExports?: (data: WithTypename<PartnerDashboardExports>) => null | string,
  PartnerEdge?: (data: WithTypename<PartnerEdge>) => null | string,
  PartnerNotification?: (data: WithTypename<PartnerNotification>) => null | string,
  PreviewMatchingSurveyPayload?: (data: WithTypename<PreviewMatchingSurveyPayload>) => null | string,
  Profile?: (data: WithTypename<Profile>) => null | string,
  ProfileAttribute?: (data: WithTypename<ProfileAttribute>) => null | string,
  ProfileAttributeCategory?: (data: WithTypename<ProfileAttributeCategory>) => null | string,
  ProfileAttributeCategoryItem?: (data: WithTypename<ProfileAttributeCategoryItem>) => null | string,
  ProfileAttributeValue?: (data: WithTypename<ProfileAttributeValue>) => null | string,
  Program?: (data: WithTypename<Program>) => null | string,
  ProgramAlertDismissal?: (data: WithTypename<ProgramAlertDismissal>) => null | string,
  ProgramAssessmentArea?: (data: WithTypename<ProgramAssessmentArea>) => null | string,
  ProgramAutomatchingConfiguration?: (data: WithTypename<ProgramAutomatchingConfiguration>) => null | string,
  ProgramAutomatchingDefault?: (data: WithTypename<ProgramAutomatchingDefault>) => null | string,
  ProgramConnection?: (data: WithTypename<ProgramConnection>) => null | string,
  ProgramCustomLabel?: (data: WithTypename<ProgramCustomLabel>) => null | string,
  ProgramCustomMessageTemplate?: (data: WithTypename<ProgramCustomMessageTemplate>) => null | string,
  ProgramEdge?: (data: WithTypename<ProgramEdge>) => null | string,
  ProgramFlagCategory?: (data: WithTypename<ProgramFlagCategory>) => null | string,
  ProgramGoal?: (data: WithTypename<ProgramGoal>) => null | string,
  ProgramPageVisit?: (data: WithTypename<ProgramPageVisit>) => null | string,
  ProgramProfileAttribute?: (data: WithTypename<ProgramProfileAttribute>) => null | string,
  ProgramProfileAttributeCategoryResult?: (data: WithTypename<ProgramProfileAttributeCategoryResult>) => null | string,
  ProgramProfileAttributeDefaultSettings?: (data: WithTypename<ProgramProfileAttributeDefaultSettings>) => null | string,
  ProgramProfileAttributeUnableToBeUpdated?: (data: WithTypename<ProgramProfileAttributeUnableToBeUpdated>) => null | string,
  ProgramResource?: (data: WithTypename<ProgramResource>) => null | string,
  ProgramResourceConnection?: (data: WithTypename<ProgramResourceConnection>) => null | string,
  ProgramResourceEdge?: (data: WithTypename<ProgramResourceEdge>) => null | string,
  ProgramSequence?: (data: WithTypename<ProgramSequence>) => null | string,
  ProgramSequenceConnection?: (data: WithTypename<ProgramSequenceConnection>) => null | string,
  ProgramSequenceEdge?: (data: WithTypename<ProgramSequenceEdge>) => null | string,
  ProgramTask?: (data: WithTypename<ProgramTask>) => null | string,
  ProgramTopic?: (data: WithTypename<ProgramTopic>) => null | string,
  ProgramTopicConnection?: (data: WithTypename<ProgramTopicConnection>) => null | string,
  ProgramTopicEdge?: (data: WithTypename<ProgramTopicEdge>) => null | string,
  QueryableMetrics?: (data: WithTypename<QueryableMetrics>) => null | string,
  QuestionWeight?: (data: WithTypename<QuestionWeight>) => null | string,
  ReactivateProgramAlertPayload?: (data: WithTypename<ReactivateProgramAlertPayload>) => null | string,
  RecruitmentOpportunitiesMetricsResult?: (data: WithTypename<RecruitmentOpportunitiesMetricsResult>) => null | string,
  RemoveMessageTemplatesTags?: (data: WithTypename<RemoveMessageTemplatesTags>) => null | string,
  RemoveMessageTemplatesTagsByFilterSelectionPayload?: (data: WithTypename<RemoveMessageTemplatesTagsByFilterSelectionPayload>) => null | string,
  RemoveMessageTemplatesTagsByIdsPayload?: (data: WithTypename<RemoveMessageTemplatesTagsByIdsPayload>) => null | string,
  Resource?: (data: WithTypename<Resource>) => null | string,
  ResourceConnection?: (data: WithTypename<ResourceConnection>) => null | string,
  ResourceEdge?: (data: WithTypename<ResourceEdge>) => null | string,
  ResourceTopic?: (data: WithTypename<ResourceTopic>) => null | string,
  ResourceTopicConnection?: (data: WithTypename<ResourceTopicConnection>) => null | string,
  ResourceTopicEdge?: (data: WithTypename<ResourceTopicEdge>) => null | string,
  S3Object?: (data: WithTypename<S3Object>) => null | string,
  SatisfactionAverage?: (data: WithTypename<SatisfactionAverage>) => null | string,
  SatisfactionReport?: (data: WithTypename<SatisfactionReport>) => null | string,
  SaveBatchMatchesPayload?: (data: WithTypename<SaveBatchMatchesPayload>) => null | string,
  SaveSurveyResponsePayload?: (data: WithTypename<SaveSurveyResponsePayload>) => null | string,
  SaveWrittenMessagePayload?: (data: WithTypename<SaveWrittenMessagePayload>) => null | string,
  SavedMatch?: (data: WithTypename<SavedMatch>) => null | string,
  SavedMatchConnection?: (data: WithTypename<SavedMatchConnection>) => null | string,
  SavedMatchEdge?: (data: WithTypename<SavedMatchEdge>) => null | string,
  ScheduleTrainingTask?: (data: WithTypename<ScheduleTrainingTask>) => null | string,
  School?: (data: WithTypename<School>) => null | string,
  SchoolConnection?: (data: WithTypename<SchoolConnection>) => null | string,
  SchoolEdge?: (data: WithTypename<SchoolEdge>) => null | string,
  SchoolIdentifier?: (data: WithTypename<SchoolIdentifier>) => null | string,
  SendBulkMessageByCsvPayload?: (data: WithTypename<SendBulkMessageByCsvPayload>) => null | string,
  SendPartnerNotificationsPayload?: (data: WithTypename<SendPartnerNotificationsPayload>) => null | string,
  SendSsoTestingTemplatePayload?: (data: WithTypename<SendSsoTestingTemplatePayload>) => null | string,
  SendTestMessagePayload?: (data: WithTypename<SendTestMessagePayload>) => null | string,
  SendUpdateEmailDraftForMentorshipPayload?: (data: WithTypename<SendUpdateEmailDraftForMentorshipPayload>) => null | string,
  SetupSftpPayload?: (data: WithTypename<SetupSftpPayload>) => null | string,
  SftpCsvExports?: (data: WithTypename<SftpCsvExports>) => null | string,
  ShearwaterAdministrator?: (data: WithTypename<ShearwaterAdministrator>) => null | string,
  SingleSelectHardMatchQuestion?: (data: WithTypename<SingleSelectHardMatchQuestion>) => null | string,
  SkeletonMessageTemplate?: (data: WithTypename<SkeletonMessageTemplate>) => null | string,
  SkeletonMessageTemplateConnection?: (data: WithTypename<SkeletonMessageTemplateConnection>) => null | string,
  SkeletonMessageTemplateEdge?: (data: WithTypename<SkeletonMessageTemplateEdge>) => null | string,
  SmsTemplate?: (data: WithTypename<SmsTemplate>) => null | string,
  StartFirstWaveRecruitment?: (data: WithTypename<StartFirstWaveRecruitment>) => null | string,
  StartFirstWaveRecruitmentByFilterSelectionPayload?: (data: WithTypename<StartFirstWaveRecruitmentByFilterSelectionPayload>) => null | string,
  StartFirstWaveRecruitmentByIdsPayload?: (data: WithTypename<StartFirstWaveRecruitmentByIdsPayload>) => null | string,
  StartSecondWaveRecruitment?: (data: WithTypename<StartSecondWaveRecruitment>) => null | string,
  StartSecondWaveRecruitmentByFilterSelectionPayload?: (data: WithTypename<StartSecondWaveRecruitmentByFilterSelectionPayload>) => null | string,
  StartSecondWaveRecruitmentByIdsPayload?: (data: WithTypename<StartSecondWaveRecruitmentByIdsPayload>) => null | string,
  StateMachine?: (data: WithTypename<StateMachine>) => null | string,
  StateMachineConnection?: (data: WithTypename<StateMachineConnection>) => null | string,
  StateMachineEdge?: (data: WithTypename<StateMachineEdge>) => null | string,
  StopRecruitment?: (data: WithTypename<StopRecruitment>) => null | string,
  StopRecruitmentByFilterSelectionPayload?: (data: WithTypename<StopRecruitmentByFilterSelectionPayload>) => null | string,
  StopRecruitmentByIdsPayload?: (data: WithTypename<StopRecruitmentByIdsPayload>) => null | string,
  Student?: (data: WithTypename<Student>) => null | string,
  StudentContact?: (data: WithTypename<StudentContact>) => null | string,
  StudentGoal?: (data: WithTypename<StudentGoal>) => null | string,
  StudentGoalsList?: (data: WithTypename<StudentGoalsList>) => null | string,
  SuggestedBatch?: (data: WithTypename<SuggestedBatch>) => null | string,
  SuggestedBatchConnection?: (data: WithTypename<SuggestedBatchConnection>) => null | string,
  SuggestedBatchEdge?: (data: WithTypename<SuggestedBatchEdge>) => null | string,
  SuggestedBatchSettings?: (data: WithTypename<SuggestedBatchSettings>) => null | string,
  SuggestedMatch?: (data: WithTypename<SuggestedMatch>) => null | string,
  SuggestedMatchConnection?: (data: WithTypename<SuggestedMatchConnection>) => null | string,
  SuggestedMatchEdge?: (data: WithTypename<SuggestedMatchEdge>) => null | string,
  SupportServiceResource?: (data: WithTypename<SupportServiceResource>) => null | string,
  Survey?: (data: WithTypename<Survey>) => null | string,
  SurveyAnswer?: (data: WithTypename<SurveyAnswer>) => null | string,
  SurveyConnection?: (data: WithTypename<SurveyConnection>) => null | string,
  SurveyEdge?: (data: WithTypename<SurveyEdge>) => null | string,
  SurveyQuestion?: (data: WithTypename<SurveyQuestion>) => null | string,
  SurveyQuestionCustomizationOption?: (data: WithTypename<SurveyQuestionCustomizationOption>) => null | string,
  SurveyQuestionMdDisplay?: (data: WithTypename<SurveyQuestionMdDisplay>) => null | string,
  SurveyQuestionRestrictedOption?: (data: WithTypename<SurveyQuestionRestrictedOption>) => null | string,
  SurveyQuestionRestrictedOptionConnection?: (data: WithTypename<SurveyQuestionRestrictedOptionConnection>) => null | string,
  SurveyQuestionRestrictedOptionEdge?: (data: WithTypename<SurveyQuestionRestrictedOptionEdge>) => null | string,
  SurveyQuestionTemplate?: (data: WithTypename<SurveyQuestionTemplate>) => null | string,
  SurveyResponse?: (data: WithTypename<SurveyResponse>) => null | string,
  SurveyResponseAnswerStrings?: (data: WithTypename<SurveyResponseAnswerStrings>) => null | string,
  SurveyResponseConnection?: (data: WithTypename<SurveyResponseConnection>) => null | string,
  SurveyResponseContext?: (data: WithTypename<SurveyResponseContext>) => null | string,
  SurveyResponseEdge?: (data: WithTypename<SurveyResponseEdge>) => null | string,
  TakeExternalLinkTask?: (data: WithTypename<TakeExternalLinkTask>) => null | string,
  TakeSurveyTask?: (data: WithTypename<TakeSurveyTask>) => null | string,
  TaskConnection?: (data: WithTypename<TaskConnection>) => null | string,
  TaskEdge?: (data: WithTypename<TaskEdge>) => null | string,
  TookTypeformSurveyLog?: (data: WithTypename<TookTypeformSurveyLog>) => null | string,
  Topic?: (data: WithTypename<Topic>) => null | string,
  TopicCollection?: (data: WithTypename<TopicCollection>) => null | string,
  TopicCondition?: (data: WithTypename<TopicCondition>) => null | string,
  TopicConnection?: (data: WithTypename<TopicConnection>) => null | string,
  TopicEdge?: (data: WithTypename<TopicEdge>) => null | string,
  TopicMessage?: (data: WithTypename<TopicMessage>) => null | string,
  TrainingEventLog?: (data: WithTypename<TrainingEventLog>) => null | string,
  UnmatchParticipantPayload?: (data: WithTypename<UnmatchParticipantPayload>) => null | string,
  UnmatchParticipantsPayload?: (data: WithTypename<UnmatchParticipantsPayload>) => null | string,
  UpdateAssessmentSurveyNewProgramTaskPayload?: (data: WithTypename<UpdateAssessmentSurveyNewProgramTaskPayload>) => null | string,
  UpdateClickLinkNewProgramTaskPayload?: (data: WithTypename<UpdateClickLinkNewProgramTaskPayload>) => null | string,
  UpdateClickLinkNewTaskPayload?: (data: WithTypename<UpdateClickLinkNewTaskPayload>) => null | string,
  UpdateCourseNewProgramTaskPayload?: (data: WithTypename<UpdateCourseNewProgramTaskPayload>) => null | string,
  UpdateCourseNewTaskPayload?: (data: WithTypename<UpdateCourseNewTaskPayload>) => null | string,
  UpdateEmailTemplatePayload?: (data: WithTypename<UpdateEmailTemplatePayload>) => null | string,
  UpdateFlagContactPayload?: (data: WithTypename<UpdateFlagContactPayload>) => null | string,
  UpdateFlagPayload?: (data: WithTypename<UpdateFlagPayload>) => null | string,
  UpdateMenteeMentorSettingsError?: (data: WithTypename<UpdateMenteeMentorSettingsError>) => null | string,
  UpdateMenteeMentorSettingsPayload?: (data: WithTypename<UpdateMenteeMentorSettingsPayload>) => null | string,
  UpdateMicroSurveyPayload?: (data: WithTypename<UpdateMicroSurveyPayload>) => null | string,
  UpdateNewProgramTaskPayload?: (data: WithTypename<UpdateNewProgramTaskPayload>) => null | string,
  UpdateParticipantPayload?: (data: WithTypename<UpdateParticipantPayload>) => null | string,
  UpdateParticipantsMatchingLabelsPayload?: (data: WithTypename<UpdateParticipantsMatchingLabelsPayload>) => null | string,
  UpdatePartnerPayload?: (data: WithTypename<UpdatePartnerPayload>) => null | string,
  UpdateProgramAdminsError?: (data: WithTypename<UpdateProgramAdminsError>) => null | string,
  UpdateProgramAdminsPayload?: (data: WithTypename<UpdateProgramAdminsPayload>) => null | string,
  UpdateProgramCommunicationSettingsPayload?: (data: WithTypename<UpdateProgramCommunicationSettingsPayload>) => null | string,
  UpdateProgramCustomLabelPayload?: (data: WithTypename<UpdateProgramCustomLabelPayload>) => null | string,
  UpdateProgramCustomMessageTemplatesError?: (data: WithTypename<UpdateProgramCustomMessageTemplatesError>) => null | string,
  UpdateProgramCustomMessageTemplatesPayload?: (data: WithTypename<UpdateProgramCustomMessageTemplatesPayload>) => null | string,
  UpdateProgramFlagContactsError?: (data: WithTypename<UpdateProgramFlagContactsError>) => null | string,
  UpdateProgramFlagContactsPayload?: (data: WithTypename<UpdateProgramFlagContactsPayload>) => null | string,
  UpdateProgramInfoError?: (data: WithTypename<UpdateProgramInfoError>) => null | string,
  UpdateProgramInfoPayload?: (data: WithTypename<UpdateProgramInfoPayload>) => null | string,
  UpdateProgramPointPeopleError?: (data: WithTypename<UpdateProgramPointPeopleError>) => null | string,
  UpdateProgramPointPeoplePayload?: (data: WithTypename<UpdateProgramPointPeoplePayload>) => null | string,
  UpdateProgramProfileAttributesPayload?: (data: WithTypename<UpdateProgramProfileAttributesPayload>) => null | string,
  UpdateProgramSequenceInfoError?: (data: WithTypename<UpdateProgramSequenceInfoError>) => null | string,
  UpdateProgramSequenceInfoPayload?: (data: WithTypename<UpdateProgramSequenceInfoPayload>) => null | string,
  UpdateProgramSetupError?: (data: WithTypename<UpdateProgramSetupError>) => null | string,
  UpdateProgramSetupPayload?: (data: WithTypename<UpdateProgramSetupPayload>) => null | string,
  UpdateProgramTaskPayload?: (data: WithTypename<UpdateProgramTaskPayload>) => null | string,
  UpdateProgramTopicPayload?: (data: WithTypename<UpdateProgramTopicPayload>) => null | string,
  UpdateProgramTopicsError?: (data: WithTypename<UpdateProgramTopicsError>) => null | string,
  UpdateProgramTopicsPayload?: (data: WithTypename<UpdateProgramTopicsPayload>) => null | string,
  UpdateSchoolInfoError?: (data: WithTypename<UpdateSchoolInfoError>) => null | string,
  UpdateSchoolInfoPayload?: (data: WithTypename<UpdateSchoolInfoPayload>) => null | string,
  UpdateSmsTemplatePayload?: (data: WithTypename<UpdateSmsTemplatePayload>) => null | string,
  UpdateSurveysAndQuizzesError?: (data: WithTypename<UpdateSurveysAndQuizzesError>) => null | string,
  UpdateSurveysAndQuizzesPayload?: (data: WithTypename<UpdateSurveysAndQuizzesPayload>) => null | string,
  UpdateTopicPayload?: (data: WithTypename<UpdateTopicPayload>) => null | string,
  UpdateUserPayload?: (data: WithTypename<UpdateUserPayload>) => null | string,
  UploadPhotoTask?: (data: WithTypename<UploadPhotoTask>) => null | string,
  UploadUserProfileDataPayload?: (data: WithTypename<UploadUserProfileDataPayload>) => null | string,
  UploadVideoTask?: (data: WithTypename<UploadVideoTask>) => null | string,
  UploadedVideo?: (data: WithTypename<UploadedVideo>) => null | string,
  UploadedVideoConnection?: (data: WithTypename<UploadedVideoConnection>) => null | string,
  UploadedVideoEdge?: (data: WithTypename<UploadedVideoEdge>) => null | string,
  User?: (data: WithTypename<User>) => null | string,
  UserConnection?: (data: WithTypename<UserConnection>) => null | string,
  UserEdge?: (data: WithTypename<UserEdge>) => null | string,
  UserMentorshipCredential?: (data: WithTypename<UserMentorshipCredential>) => null | string,
  UserProfileAttributeValue?: (data: WithTypename<UserProfileAttributeValue>) => null | string,
  UserProfileAttributeValueUpdate?: (data: WithTypename<UserProfileAttributeValueUpdate>) => null | string,
  UserProfileData?: (data: WithTypename<UserProfileData>) => null | string,
  UserStateVariable?: (data: WithTypename<UserStateVariable>) => null | string,
  UsersMetrics?: (data: WithTypename<UsersMetrics>) => null | string,
  WatchVideoTask?: (data: WithTypename<WatchVideoTask>) => null | string,
  WatchedCommunityVideoLog?: (data: WithTypename<WatchedCommunityVideoLog>) => null | string,
  WatchedVideoLog?: (data: WithTypename<WatchedVideoLog>) => null | string,
  WrittenMessage?: (data: WithTypename<WrittenMessage>) => null | string,
  WrittenMessageConnection?: (data: WithTypename<WrittenMessageConnection>) => null | string,
  WrittenMessageEdge?: (data: WithTypename<WrittenMessageEdge>) => null | string
}

export type GraphCacheResolvers = {
  Query?: {
    adminAction?: GraphCacheResolver<WithTypename<Query>, QueryAdminActionArgs, WithTypename<AdminAction> | string>,
    adminActions?: GraphCacheResolver<WithTypename<Query>, QueryAdminActionsArgs, WithTypename<AdminActionConnection> | string>,
    assessmentAreasForSurvey?: GraphCacheResolver<WithTypename<Query>, QueryAssessmentAreasForSurveyArgs, Array<WithTypename<AssessmentArea> | string>>,
    automatchingDefaults?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<AutomatchingDefault> | string>>,
    contacts?: GraphCacheResolver<WithTypename<Query>, QueryContactsArgs, WithTypename<ContactConnection> | string>,
    conversationTopicCategories?: GraphCacheResolver<WithTypename<Query>, QueryConversationTopicCategoriesArgs, Array<WithTypename<ParticipantConversationCategory> | string>>,
    conversationTopics?: GraphCacheResolver<WithTypename<Query>, QueryConversationTopicsArgs, Array<ConversationTopic | string>>,
    country?: GraphCacheResolver<WithTypename<Query>, QueryCountryArgs, WithTypename<Country> | string>,
    course?: GraphCacheResolver<WithTypename<Query>, QueryCourseArgs, WithTypename<Course> | string>,
    courses?: GraphCacheResolver<WithTypename<Query>, QueryCoursesArgs, WithTypename<CourseConnection> | string>,
    csvExports?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<CsvExports> | string>,
    customMessageTypeTemplateRequirements?: GraphCacheResolver<WithTypename<Query>, QueryCustomMessageTypeTemplateRequirementsArgs, WithTypename<CustomMessageTypeTemplateRequirementConnection> | string>,
    deregistrationReasons?: GraphCacheResolver<WithTypename<Query>, QueryDeregistrationReasonsArgs, WithTypename<DeregistrationReasonConnection> | string>,
    flagCategories?: GraphCacheResolver<WithTypename<Query>, QueryFlagCategoriesArgs, Array<WithTypename<FlagCategory> | string>>,
    flagContacts?: GraphCacheResolver<WithTypename<Query>, QueryFlagContactsArgs, Array<WithTypename<FlagContact> | string>>,
    flags?: GraphCacheResolver<WithTypename<Query>, QueryFlagsArgs, WithTypename<FlagConnection> | string>,
    matchingLabel?: GraphCacheResolver<WithTypename<Query>, QueryMatchingLabelArgs, WithTypename<MatchingLabel> | string>,
    mentor?: GraphCacheResolver<WithTypename<Query>, QueryMentorArgs, WithTypename<Mentor> | string>,
    mentorship?: GraphCacheResolver<WithTypename<Query>, QueryMentorshipArgs, WithTypename<Mentorship> | string>,
    mentorships?: GraphCacheResolver<WithTypename<Query>, QueryMentorshipsArgs, WithTypename<MentorshipConnection> | string>,
    messageTemplate?: GraphCacheResolver<WithTypename<Query>, QueryMessageTemplateArgs, WithTypename<EmailTemplate> | WithTypename<SmsTemplate> | string>,
    messageTemplateTags?: GraphCacheResolver<WithTypename<Query>, QueryMessageTemplateTagsArgs, WithTypename<MessageTemplateTagConnection> | string>,
    messageTemplates?: GraphCacheResolver<WithTypename<Query>, QueryMessageTemplatesArgs, WithTypename<MessageTemplateConnection> | string>,
    metrics?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<QueryableMetrics> | string>,
    microSurvey?: GraphCacheResolver<WithTypename<Query>, QueryMicroSurveyArgs, WithTypename<MicroSurvey> | string>,
    microSurveys?: GraphCacheResolver<WithTypename<Query>, QueryMicroSurveysArgs, WithTypename<MicroSurveyConnection> | string>,
    newProgramTask?: GraphCacheResolver<WithTypename<Query>, QueryNewProgramTaskArgs, WithTypename<NewProgramTask> | string>,
    newProgramTasks?: GraphCacheResolver<WithTypename<Query>, QueryNewProgramTasksArgs, WithTypename<NewProgramTaskConnection> | string>,
    newTask?: GraphCacheResolver<WithTypename<Query>, QueryNewTaskArgs, WithTypename<NewTask> | string>,
    newTasks?: GraphCacheResolver<WithTypename<Query>, QueryNewTasksArgs, WithTypename<NewTaskConnection> | string>,
    outreachTopic?: GraphCacheResolver<WithTypename<Query>, QueryOutreachTopicArgs, WithTypename<Topic> | string>,
    outreachTopicCollections?: GraphCacheResolver<WithTypename<Query>, QueryOutreachTopicCollectionsArgs, Array<WithTypename<TopicCollection> | string>>,
    outreachTopics?: GraphCacheResolver<WithTypename<Query>, QueryOutreachTopicsArgs, WithTypename<TopicConnection> | string>,
    participant?: GraphCacheResolver<WithTypename<Query>, QueryParticipantArgs, WithTypename<Mentor> | WithTypename<Student> | string>,
    participantConversationCategories?: GraphCacheResolver<WithTypename<Query>, QueryParticipantConversationCategoriesArgs, Array<WithTypename<ParticipantConversationCategory> | string>>,
    participantConversationContents?: GraphCacheResolver<WithTypename<Query>, QueryParticipantConversationContentsArgs, WithTypename<ParticipantConversationContentConnection> | string>,
    participantGoals?: GraphCacheResolver<WithTypename<Query>, QueryParticipantGoalsArgs, WithTypename<GoalConnection> | string>,
    participants?: GraphCacheResolver<WithTypename<Query>, QueryParticipantsArgs, WithTypename<ParticipantConnection> | string>,
    partner?: GraphCacheResolver<WithTypename<Query>, QueryPartnerArgs, WithTypename<Partner> | string>,
    partners?: GraphCacheResolver<WithTypename<Query>, QueryPartnersArgs, WithTypename<PartnerConnection> | string>,
    program?: GraphCacheResolver<WithTypename<Query>, QueryProgramArgs, WithTypename<Program> | string>,
    programAutomatchingConfiguration?: GraphCacheResolver<WithTypename<Query>, QueryProgramAutomatchingConfigurationArgs, WithTypename<ProgramAutomatchingConfiguration> | string>,
    programAutomatchingDefault?: GraphCacheResolver<WithTypename<Query>, QueryProgramAutomatchingDefaultArgs, WithTypename<ProgramAutomatchingDefault> | string>,
    programCompiledTexts?: GraphCacheResolver<WithTypename<Query>, QueryProgramCompiledTextsArgs, Array<Scalars['String'] | string>>,
    programProfileAttributeCategories?: GraphCacheResolver<WithTypename<Query>, QueryProgramProfileAttributeCategoriesArgs, Array<WithTypename<ProgramProfileAttributeCategoryResult> | string>>,
    programSequences?: GraphCacheResolver<WithTypename<Query>, QueryProgramSequencesArgs, WithTypename<ProgramSequenceConnection> | string>,
    programTopic?: GraphCacheResolver<WithTypename<Query>, QueryProgramTopicArgs, WithTypename<ProgramTopic> | string>,
    programs?: GraphCacheResolver<WithTypename<Query>, QueryProgramsArgs, WithTypename<ProgramConnection> | string>,
    resource?: GraphCacheResolver<WithTypename<Query>, QueryResourceArgs, WithTypename<Resource> | string>,
    resourceTopics?: GraphCacheResolver<WithTypename<Query>, QueryResourceTopicsArgs, WithTypename<ResourceTopicConnection> | string>,
    resources?: GraphCacheResolver<WithTypename<Query>, QueryResourcesArgs, WithTypename<ResourceConnection> | string>,
    savedMatch?: GraphCacheResolver<WithTypename<Query>, QuerySavedMatchArgs, WithTypename<SavedMatch> | string>,
    savedMatches?: GraphCacheResolver<WithTypename<Query>, QuerySavedMatchesArgs, WithTypename<SavedMatchConnection> | string>,
    school?: GraphCacheResolver<WithTypename<Query>, QuerySchoolArgs, WithTypename<School> | string>,
    schools?: GraphCacheResolver<WithTypename<Query>, QuerySchoolsArgs, WithTypename<SchoolConnection> | string>,
    sftpCsvExports?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<SftpCsvExports> | string>,
    sftpS3Objects?: GraphCacheResolver<WithTypename<Query>, QuerySftpS3ObjectsArgs, Array<WithTypename<S3Object> | string>>,
    skeletonMessageTemplate?: GraphCacheResolver<WithTypename<Query>, QuerySkeletonMessageTemplateArgs, WithTypename<SkeletonMessageTemplate> | string>,
    skeletonMessageTemplates?: GraphCacheResolver<WithTypename<Query>, QuerySkeletonMessageTemplatesArgs, WithTypename<SkeletonMessageTemplateConnection> | string>,
    stateMachine?: GraphCacheResolver<WithTypename<Query>, QueryStateMachineArgs, WithTypename<StateMachine> | string>,
    stateMachines?: GraphCacheResolver<WithTypename<Query>, QueryStateMachinesArgs, WithTypename<StateMachineConnection> | string>,
    student?: GraphCacheResolver<WithTypename<Query>, QueryStudentArgs, WithTypename<Student> | string>,
    suggestedBatch?: GraphCacheResolver<WithTypename<Query>, QuerySuggestedBatchArgs, WithTypename<SuggestedBatch> | string>,
    suggestedBatches?: GraphCacheResolver<WithTypename<Query>, QuerySuggestedBatchesArgs, WithTypename<SuggestedBatchConnection> | string>,
    suggestedMatch?: GraphCacheResolver<WithTypename<Query>, QuerySuggestedMatchArgs, WithTypename<SuggestedMatch> | string>,
    suggestedMatches?: GraphCacheResolver<WithTypename<Query>, QuerySuggestedMatchesArgs, WithTypename<SuggestedMatchConnection> | string>,
    survey?: GraphCacheResolver<WithTypename<Query>, QuerySurveyArgs, WithTypename<Survey> | string>,
    surveyQuestionRestrictedOptions?: GraphCacheResolver<WithTypename<Query>, QuerySurveyQuestionRestrictedOptionsArgs, WithTypename<SurveyQuestionRestrictedOptionConnection> | string>,
    surveyResponses?: GraphCacheResolver<WithTypename<Query>, QuerySurveyResponsesArgs, WithTypename<SurveyResponseConnection> | string>,
    surveys?: GraphCacheResolver<WithTypename<Query>, QuerySurveysArgs, WithTypename<SurveyConnection> | string>,
    taskAssignments?: GraphCacheResolver<WithTypename<Query>, QueryTaskAssignmentsArgs, Array<WithTypename<AssessmentSurveyTaskAssignment> | WithTypename<ClickLinkTaskAssignment> | WithTypename<CourseTaskAssignment> | string>>,
    tasks?: GraphCacheResolver<WithTypename<Query>, QueryTasksArgs, WithTypename<TaskConnection> | string>,
    uploadedVideos?: GraphCacheResolver<WithTypename<Query>, QueryUploadedVideosArgs, WithTypename<UploadedVideoConnection> | string>,
    user?: GraphCacheResolver<WithTypename<Query>, QueryUserArgs, WithTypename<User> | string>,
    userStateVariables?: GraphCacheResolver<WithTypename<Query>, QueryUserStateVariablesArgs, Array<WithTypename<UserStateVariable> | string>>,
    users?: GraphCacheResolver<WithTypename<Query>, QueryUsersArgs, WithTypename<UserConnection> | string>,
    warehouseMetrics?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<DwhQueryableMetrics> | string>,
    writtenMessages?: GraphCacheResolver<WithTypename<Query>, QueryWrittenMessagesArgs, WithTypename<WrittenMessageConnection> | string>
  },
  A2pSms?: {
    content?: GraphCacheResolver<WithTypename<A2pSms>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<A2pSms>, Record<string, never>, Scalars['ID'] | string>,
    sentAtDate?: GraphCacheResolver<WithTypename<A2pSms>, Record<string, never>, Scalars['ISO8601DateTime'] | string>
  },
  ActivityLog?: {
    eventType?: GraphCacheResolver<WithTypename<ActivityLog>, Record<string, never>, ActivityLogEvent | string>,
    id?: GraphCacheResolver<WithTypename<ActivityLog>, Record<string, never>, Scalars['ID'] | string>,
    loggableActivity?: GraphCacheResolver<WithTypename<ActivityLog>, ActivityLogLoggableActivityArgs, WithTypename<LoggableActivity> | string>,
    occurredAt?: GraphCacheResolver<WithTypename<ActivityLog>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    program?: GraphCacheResolver<WithTypename<ActivityLog>, Record<string, never>, WithTypename<Program> | string>
  },
  ActivityLogConnection?: {
    edges?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Array<WithTypename<ActivityLogEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Array<WithTypename<ActivityLog> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalAssessmentSurveySubmittedCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalConnectedViaP2pRelayCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalConversationReportedCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalFlagReportedCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalInitialMatchingSurveyReviewNotificationCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalInvitedAsMenteeCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalInvitedAsMentorCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalLowAhsAssessmentScoreSubmittedCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalLowAseAssessmentScoreSubmittedCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalLowCdseAssessmentScoreSubmittedCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalLowSobAssessmentScoreSubmittedCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalLowSrAssessmentScoreSubmittedCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalMatchingSurveyUpdatedReviewNotificationCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalMenteeDeregisteredCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalMentorCompletedTrainingCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalMentorDeregisteredCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalMentorMatchingSurveyCompletedCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalMentorSignedUpForTrainingCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalMentorshipUnmatchedCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalNewMentorshipCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalRegisteredAsMenteeCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalRegisteredAsMentorCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalStudentMatchingSurveyCompletedCount?: GraphCacheResolver<WithTypename<ActivityLogConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  ActivityLogEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ActivityLogEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<ActivityLogEdge>, Record<string, never>, WithTypename<ActivityLog> | string>
  },
  AddContactsFromExistingProgramPayload?: {
    batchActionId?: GraphCacheResolver<WithTypename<AddContactsFromExistingProgramPayload>, Record<string, never>, Scalars['ID'] | string>,
    errors?: GraphCacheResolver<WithTypename<AddContactsFromExistingProgramPayload>, Record<string, never>, Scalars['String'] | string>
  },
  AddContactsPayload?: {
    batchActionId?: GraphCacheResolver<WithTypename<AddContactsPayload>, Record<string, never>, Scalars['ID'] | string>,
    errors?: GraphCacheResolver<WithTypename<AddContactsPayload>, Record<string, never>, Scalars['String'] | string>
  },
  AddContactsToExistingUsersPayload?: {
    batchActionId?: GraphCacheResolver<WithTypename<AddContactsToExistingUsersPayload>, Record<string, never>, Scalars['ID'] | string>,
    errors?: GraphCacheResolver<WithTypename<AddContactsToExistingUsersPayload>, Record<string, never>, Scalars['String'] | string>
  },
  AddMessageTemplatesTags?: {
    byFilterSelection?: GraphCacheResolver<WithTypename<AddMessageTemplatesTags>, AddMessageTemplatesTagsByFilterSelectionArgs, WithTypename<AddMessageTemplatesTagsByFilterSelectionPayload> | string>,
    byIds?: GraphCacheResolver<WithTypename<AddMessageTemplatesTags>, AddMessageTemplatesTagsByIdsArgs, WithTypename<AddMessageTemplatesTagsByIdsPayload> | string>
  },
  AddMessageTemplatesTagsByFilterSelectionPayload?: {
    errors?: GraphCacheResolver<WithTypename<AddMessageTemplatesTagsByFilterSelectionPayload>, Record<string, never>, Array<MessageTemplateTagsNotAbleToBeAddedError | string>>,
    messageTemplates?: GraphCacheResolver<WithTypename<AddMessageTemplatesTagsByFilterSelectionPayload>, Record<string, never>, Array<WithTypename<EmailTemplate> | WithTypename<SmsTemplate> | string>>,
    numberOfMessageTemplatesUpdated?: GraphCacheResolver<WithTypename<AddMessageTemplatesTagsByFilterSelectionPayload>, Record<string, never>, Scalars['Int'] | string>
  },
  AddMessageTemplatesTagsByIdsPayload?: {
    errors?: GraphCacheResolver<WithTypename<AddMessageTemplatesTagsByIdsPayload>, Record<string, never>, Array<MessageTemplateTagsNotAbleToBeAddedError | string>>,
    messageTemplates?: GraphCacheResolver<WithTypename<AddMessageTemplatesTagsByIdsPayload>, Record<string, never>, Array<WithTypename<EmailTemplate> | WithTypename<SmsTemplate> | string>>,
    numberOfMessageTemplatesUpdated?: GraphCacheResolver<WithTypename<AddMessageTemplatesTagsByIdsPayload>, Record<string, never>, Scalars['Int'] | string>
  },
  AddParticipantsPayload?: {
    batchActionId?: GraphCacheResolver<WithTypename<AddParticipantsPayload>, Record<string, never>, Scalars['ID'] | string>,
    errors?: GraphCacheResolver<WithTypename<AddParticipantsPayload>, Record<string, never>, Scalars['String'] | string>
  },
  AdminAction?: {
    adminUser?: GraphCacheResolver<WithTypename<AdminAction>, Record<string, never>, WithTypename<User> | string>,
    id?: GraphCacheResolver<WithTypename<AdminAction>, Record<string, never>, Scalars['ID'] | string>,
    performedAt?: GraphCacheResolver<WithTypename<AdminAction>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    resultingChanges?: GraphCacheResolver<WithTypename<AdminAction>, AdminActionResultingChangesArgs, WithTypename<ObjectChangesetConnection> | string>,
    type?: GraphCacheResolver<WithTypename<AdminAction>, Record<string, never>, AdminActionType | string>
  },
  AdminActionConnection?: {
    actionTypes?: GraphCacheResolver<WithTypename<AdminActionConnection>, Record<string, never>, Array<AdminActionType | string>>,
    adminUsers?: GraphCacheResolver<WithTypename<AdminActionConnection>, Record<string, never>, Array<WithTypename<User> | string>>,
    edges?: GraphCacheResolver<WithTypename<AdminActionConnection>, Record<string, never>, Array<WithTypename<AdminActionEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<AdminActionConnection>, Record<string, never>, Array<WithTypename<AdminAction> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<AdminActionConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<AdminActionConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  AdminActionEdge?: {
    cursor?: GraphCacheResolver<WithTypename<AdminActionEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<AdminActionEdge>, Record<string, never>, WithTypename<AdminAction> | string>
  },
  AffectedObjectTypeCount?: {
    count?: GraphCacheResolver<WithTypename<AffectedObjectTypeCount>, Record<string, never>, Scalars['Int'] | string>,
    eventType?: GraphCacheResolver<WithTypename<AffectedObjectTypeCount>, Record<string, never>, ObjectChangeEvent | string>,
    objectType?: GraphCacheResolver<WithTypename<AffectedObjectTypeCount>, Record<string, never>, AffectedObject | string>
  },
  ArchiveRestoreMessageTemplates?: {
    byFilterSelection?: GraphCacheResolver<WithTypename<ArchiveRestoreMessageTemplates>, ArchiveRestoreMessageTemplatesByFilterSelectionArgs, WithTypename<ArchiveRestoreMessageTemplatesByFilterSelectionPayload> | string>,
    byIds?: GraphCacheResolver<WithTypename<ArchiveRestoreMessageTemplates>, ArchiveRestoreMessageTemplatesByIdsArgs, WithTypename<ArchiveRestoreMessageTemplatesByIdsPayload> | string>
  },
  ArchiveRestoreMessageTemplatesByFilterSelectionPayload?: {
    errors?: GraphCacheResolver<WithTypename<ArchiveRestoreMessageTemplatesByFilterSelectionPayload>, Record<string, never>, Array<ArchiveRestoreMessageTemplatesError | string>>,
    messageTemplates?: GraphCacheResolver<WithTypename<ArchiveRestoreMessageTemplatesByFilterSelectionPayload>, Record<string, never>, Array<WithTypename<EmailTemplate> | WithTypename<SmsTemplate> | string>>,
    numberOfMessageTemplatesUpdated?: GraphCacheResolver<WithTypename<ArchiveRestoreMessageTemplatesByFilterSelectionPayload>, Record<string, never>, Scalars['Int'] | string>
  },
  ArchiveRestoreMessageTemplatesByIdsPayload?: {
    errors?: GraphCacheResolver<WithTypename<ArchiveRestoreMessageTemplatesByIdsPayload>, Record<string, never>, Array<ArchiveRestoreMessageTemplatesError | string>>,
    messageTemplates?: GraphCacheResolver<WithTypename<ArchiveRestoreMessageTemplatesByIdsPayload>, Record<string, never>, Array<WithTypename<EmailTemplate> | WithTypename<SmsTemplate> | string>>,
    numberOfMessageTemplatesUpdated?: GraphCacheResolver<WithTypename<ArchiveRestoreMessageTemplatesByIdsPayload>, Record<string, never>, Scalars['Int'] | string>
  },
  AssessmentArea?: {
    assessmentPrompts?: GraphCacheResolver<WithTypename<AssessmentArea>, AssessmentAreaAssessmentPromptsArgs, Array<WithTypename<AssessmentPrompt> | string>>,
    id?: GraphCacheResolver<WithTypename<AssessmentArea>, Record<string, never>, Scalars['ID'] | string>,
    identifier?: GraphCacheResolver<WithTypename<AssessmentArea>, Record<string, never>, AssessmentAreaIdentifier | string>,
    name?: GraphCacheResolver<WithTypename<AssessmentArea>, Record<string, never>, Scalars['String'] | string>
  },
  AssessmentPrompt?: {
    id?: GraphCacheResolver<WithTypename<AssessmentPrompt>, Record<string, never>, Scalars['ID'] | string>,
    identifier?: GraphCacheResolver<WithTypename<AssessmentPrompt>, Record<string, never>, Scalars['String'] | string>,
    text?: GraphCacheResolver<WithTypename<AssessmentPrompt>, Record<string, never>, Scalars['String'] | string>
  },
  AssessmentScoreResponse?: {
    id?: GraphCacheResolver<WithTypename<AssessmentScoreResponse>, Record<string, never>, Scalars['ID'] | string>,
    program?: GraphCacheResolver<WithTypename<AssessmentScoreResponse>, Record<string, never>, WithTypename<Program> | string>,
    user?: GraphCacheResolver<WithTypename<AssessmentScoreResponse>, Record<string, never>, WithTypename<User> | string>
  },
  AssessmentScoreResponsesMetrics?: {
    averageAssessmentScore?: GraphCacheResolver<WithTypename<AssessmentScoreResponsesMetrics>, AssessmentScoreResponsesMetricsAverageAssessmentScoreArgs, Array<WithTypename<Interval> | string>>
  },
  AssessmentSurveyTaskAssignment?: {
    behavior?: GraphCacheResolver<WithTypename<AssessmentSurveyTaskAssignment>, Record<string, never>, Behavior | string>,
    displayName?: GraphCacheResolver<WithTypename<AssessmentSurveyTaskAssignment>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<AssessmentSurveyTaskAssignment>, Record<string, never>, Scalars['ID'] | string>,
    participantId?: GraphCacheResolver<WithTypename<AssessmentSurveyTaskAssignment>, Record<string, never>, Scalars['ID'] | string>,
    position?: GraphCacheResolver<WithTypename<AssessmentSurveyTaskAssignment>, Record<string, never>, Scalars['Int'] | string>,
    programStage?: GraphCacheResolver<WithTypename<AssessmentSurveyTaskAssignment>, Record<string, never>, AssessmentSurveyProgramStage | string>,
    status?: GraphCacheResolver<WithTypename<AssessmentSurveyTaskAssignment>, Record<string, never>, TaskAssignmentStatus | string>,
    surveyId?: GraphCacheResolver<WithTypename<AssessmentSurveyTaskAssignment>, Record<string, never>, Scalars['ID'] | string>,
    userId?: GraphCacheResolver<WithTypename<AssessmentSurveyTaskAssignment>, Record<string, never>, Scalars['ID'] | string>
  },
  AssessmentSurveyTaskContext?: {
    id?: GraphCacheResolver<WithTypename<AssessmentSurveyTaskContext>, Record<string, never>, Scalars['ID'] | string>,
    newTask?: GraphCacheResolver<WithTypename<AssessmentSurveyTaskContext>, Record<string, never>, WithTypename<NewTask> | string>,
    programStage?: GraphCacheResolver<WithTypename<AssessmentSurveyTaskContext>, Record<string, never>, AssessmentSurveyProgramStage | string>,
    surveyId?: GraphCacheResolver<WithTypename<AssessmentSurveyTaskContext>, Record<string, never>, Scalars['ID'] | string>
  },
  AutoMatchSettings?: {
    mentorCapacityCap?: GraphCacheResolver<WithTypename<AutoMatchSettings>, Record<string, never>, Scalars['Int'] | string>,
    scoreThreshold?: GraphCacheResolver<WithTypename<AutoMatchSettings>, Record<string, never>, Scalars['Int'] | string>,
    standardMatching?: GraphCacheResolver<WithTypename<AutoMatchSettings>, Record<string, never>, Scalars['Boolean'] | string>,
    standardScoreThreshold?: GraphCacheResolver<WithTypename<AutoMatchSettings>, Record<string, never>, Scalars['Int'] | string>,
    supermentorMatching?: GraphCacheResolver<WithTypename<AutoMatchSettings>, Record<string, never>, Scalars['Boolean'] | string>,
    supermentorScoreThreshold?: GraphCacheResolver<WithTypename<AutoMatchSettings>, Record<string, never>, Scalars['Int'] | string>
  },
  AutoSuggestMatchesPayload?: {
    batchId?: GraphCacheResolver<WithTypename<AutoSuggestMatchesPayload>, Record<string, never>, Scalars['String'] | string>,
    errors?: GraphCacheResolver<WithTypename<AutoSuggestMatchesPayload>, Record<string, never>, Array<WithTypename<Error> | string>>
  },
  AutomatchingDefault?: {
    createdAt?: GraphCacheResolver<WithTypename<AutomatchingDefault>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    displayName?: GraphCacheResolver<WithTypename<AutomatchingDefault>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<AutomatchingDefault>, Record<string, never>, Scalars['ID'] | string>,
    identifier?: GraphCacheResolver<WithTypename<AutomatchingDefault>, Record<string, never>, Scalars['String'] | string>,
    settings?: GraphCacheResolver<WithTypename<AutomatchingDefault>, Record<string, never>, WithTypename<SuggestedBatchSettings> | string>,
    updatedAt?: GraphCacheResolver<WithTypename<AutomatchingDefault>, Record<string, never>, Scalars['ISO8601DateTime'] | string>
  },
  CachedUserProfileDataAttributeValue?: {
    id?: GraphCacheResolver<WithTypename<CachedUserProfileDataAttributeValue>, Record<string, never>, Scalars['ID'] | string>,
    profileAttribute?: GraphCacheResolver<WithTypename<CachedUserProfileDataAttributeValue>, Record<string, never>, WithTypename<ProfileAttribute> | string>,
    values?: GraphCacheResolver<WithTypename<CachedUserProfileDataAttributeValue>, Record<string, never>, Array<Scalars['String'] | string>>
  },
  ChangeMentorTrainingStatusPayload?: {
    batchActionId?: GraphCacheResolver<WithTypename<ChangeMentorTrainingStatusPayload>, Record<string, never>, Scalars['ID'] | string>,
    errors?: GraphCacheResolver<WithTypename<ChangeMentorTrainingStatusPayload>, Record<string, never>, Scalars['String'] | string>
  },
  ClickLinkTaskAssignment?: {
    behavior?: GraphCacheResolver<WithTypename<ClickLinkTaskAssignment>, Record<string, never>, Behavior | string>,
    displayName?: GraphCacheResolver<WithTypename<ClickLinkTaskAssignment>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<ClickLinkTaskAssignment>, Record<string, never>, Scalars['ID'] | string>,
    participantId?: GraphCacheResolver<WithTypename<ClickLinkTaskAssignment>, Record<string, never>, Scalars['ID'] | string>,
    position?: GraphCacheResolver<WithTypename<ClickLinkTaskAssignment>, Record<string, never>, Scalars['Int'] | string>,
    status?: GraphCacheResolver<WithTypename<ClickLinkTaskAssignment>, Record<string, never>, TaskAssignmentStatus | string>,
    url?: GraphCacheResolver<WithTypename<ClickLinkTaskAssignment>, Record<string, never>, Scalars['String'] | string>,
    userId?: GraphCacheResolver<WithTypename<ClickLinkTaskAssignment>, Record<string, never>, Scalars['ID'] | string>
  },
  CompleteTaskAssignmentPayload?: {
    errors?: GraphCacheResolver<WithTypename<CompleteTaskAssignmentPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    taskAssignment?: GraphCacheResolver<WithTypename<CompleteTaskAssignmentPayload>, Record<string, never>, WithTypename<AssessmentSurveyTaskAssignment> | WithTypename<ClickLinkTaskAssignment> | WithTypename<CourseTaskAssignment> | string>
  },
  ConfigureFlagsError?: {
    message?: GraphCacheResolver<WithTypename<ConfigureFlagsError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<ConfigureFlagsError>, Record<string, never>, Scalars['String'] | string>
  },
  ConfigureFlagsPayload?: {
    errors?: GraphCacheResolver<WithTypename<ConfigureFlagsPayload>, Record<string, never>, Array<WithTypename<ConfigureFlagsError> | string>>,
    program?: GraphCacheResolver<WithTypename<ConfigureFlagsPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  ContactConnection?: {
    activatedCount?: GraphCacheResolver<WithTypename<ContactConnection>, Record<string, never>, Scalars['Int'] | string>,
    batchActionIds?: GraphCacheResolver<WithTypename<ContactConnection>, Record<string, never>, Array<Scalars['String'] | string>>,
    edges?: GraphCacheResolver<WithTypename<ContactConnection>, Record<string, never>, Array<WithTypename<ContactEdge> | string>>,
    mentorContactCount?: GraphCacheResolver<WithTypename<ContactConnection>, Record<string, never>, Scalars['Int'] | string>,
    nodes?: GraphCacheResolver<WithTypename<ContactConnection>, Record<string, never>, Array<WithTypename<MentorContact> | WithTypename<StudentContact> | string>>,
    notActivatedCount?: GraphCacheResolver<WithTypename<ContactConnection>, Record<string, never>, Scalars['Int'] | string>,
    pageInfo?: GraphCacheResolver<WithTypename<ContactConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    registeredCount?: GraphCacheResolver<WithTypename<ContactConnection>, Record<string, never>, Scalars['Int'] | string>,
    secondWaveCount?: GraphCacheResolver<WithTypename<ContactConnection>, Record<string, never>, Scalars['Int'] | string>,
    studentContactCount?: GraphCacheResolver<WithTypename<ContactConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCount?: GraphCacheResolver<WithTypename<ContactConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountOfDistinctUsers?: GraphCacheResolver<WithTypename<ContactConnection>, Record<string, never>, Scalars['Int'] | string>,
    uploadedByUsers?: GraphCacheResolver<WithTypename<ContactConnection>, Record<string, never>, Array<WithTypename<User> | string>>
  },
  ContactEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ContactEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<ContactEdge>, Record<string, never>, WithTypename<MentorContact> | WithTypename<StudentContact> | string>
  },
  ContactsMetrics?: {
    totalInvited?: GraphCacheResolver<WithTypename<ContactsMetrics>, ContactsMetricsTotalInvitedArgs, Array<WithTypename<Interval> | string>>
  },
  ContentfulModuleResource?: {
    contentfulUrl?: GraphCacheResolver<WithTypename<ContentfulModuleResource>, Record<string, never>, Scalars['String'] | string>,
    icon?: GraphCacheResolver<WithTypename<ContentfulModuleResource>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<ContentfulModuleResource>, Record<string, never>, Scalars['ID'] | string>,
    identifier?: GraphCacheResolver<WithTypename<ContentfulModuleResource>, Record<string, never>, Scalars['String'] | string>,
    sections?: GraphCacheResolver<WithTypename<ContentfulModuleResource>, Record<string, never>, Array<WithTypename<ContentfulModuleSection> | string>>
  },
  ContentfulModuleSection?: {
    examples?: GraphCacheResolver<WithTypename<ContentfulModuleSection>, Record<string, never>, Array<WithTypename<ContentfulModuleSection> | string>>,
    id?: GraphCacheResolver<WithTypename<ContentfulModuleSection>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<ContentfulModuleSection>, Record<string, never>, Scalars['String'] | string>,
    options?: GraphCacheResolver<WithTypename<ContentfulModuleSection>, Record<string, never>, Array<WithTypename<ContentfulModuleSection> | string>>,
    text?: GraphCacheResolver<WithTypename<ContentfulModuleSection>, Record<string, never>, Scalars['String'] | string>,
    visibleToMentee?: GraphCacheResolver<WithTypename<ContentfulModuleSection>, Record<string, never>, Scalars['Boolean'] | string>,
    visibleToMentor?: GraphCacheResolver<WithTypename<ContentfulModuleSection>, Record<string, never>, Scalars['Boolean'] | string>
  },
  ConversationLog?: {
    createdAt?: GraphCacheResolver<WithTypename<ConversationLog>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<ConversationLog>, Record<string, never>, Scalars['ID'] | string>,
    loggedAtDate?: GraphCacheResolver<WithTypename<ConversationLog>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    mentorship?: GraphCacheResolver<WithTypename<ConversationLog>, Record<string, never>, WithTypename<Mentorship> | string>,
    modesOfCommunication?: GraphCacheResolver<WithTypename<ConversationLog>, Record<string, never>, Array<ModeOfCommunication | string>>,
    topics?: GraphCacheResolver<WithTypename<ConversationLog>, Record<string, never>, Array<ConversationTopic | string>>
  },
  Country?: {
    code?: GraphCacheResolver<WithTypename<Country>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Country>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<Country>, Record<string, never>, Scalars['String'] | string>
  },
  Course?: {
    active?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['Boolean'] | string>,
    externalServiceId?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String'] | string>,
    published?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['Boolean'] | string>,
    serviceName?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String'] | string>,
    slug?: GraphCacheResolver<WithTypename<Course>, Record<string, never>, Scalars['String'] | string>
  },
  CourseConnection?: {
    edges?: GraphCacheResolver<WithTypename<CourseConnection>, Record<string, never>, Array<WithTypename<CourseEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<CourseConnection>, Record<string, never>, Array<WithTypename<Course> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<CourseConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<CourseConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  CourseEdge?: {
    cursor?: GraphCacheResolver<WithTypename<CourseEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<CourseEdge>, Record<string, never>, WithTypename<Course> | string>
  },
  CourseTaskAssignment?: {
    behavior?: GraphCacheResolver<WithTypename<CourseTaskAssignment>, Record<string, never>, Behavior | string>,
    courseId?: GraphCacheResolver<WithTypename<CourseTaskAssignment>, Record<string, never>, Scalars['ID'] | string>,
    displayName?: GraphCacheResolver<WithTypename<CourseTaskAssignment>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<CourseTaskAssignment>, Record<string, never>, Scalars['ID'] | string>,
    participantId?: GraphCacheResolver<WithTypename<CourseTaskAssignment>, Record<string, never>, Scalars['ID'] | string>,
    position?: GraphCacheResolver<WithTypename<CourseTaskAssignment>, Record<string, never>, Scalars['Int'] | string>,
    status?: GraphCacheResolver<WithTypename<CourseTaskAssignment>, Record<string, never>, TaskAssignmentStatus | string>,
    userId?: GraphCacheResolver<WithTypename<CourseTaskAssignment>, Record<string, never>, Scalars['ID'] | string>
  },
  CourseTaskContext?: {
    courseId?: GraphCacheResolver<WithTypename<CourseTaskContext>, Record<string, never>, Scalars['ID'] | string>,
    id?: GraphCacheResolver<WithTypename<CourseTaskContext>, Record<string, never>, Scalars['ID'] | string>,
    newTask?: GraphCacheResolver<WithTypename<CourseTaskContext>, Record<string, never>, WithTypename<NewTask> | string>
  },
  CreateEmailTemplatePayload?: {
    emailTemplate?: GraphCacheResolver<WithTypename<CreateEmailTemplatePayload>, Record<string, never>, WithTypename<EmailTemplate> | string>
  },
  CreateEmailTemplateSavedRowPayload?: {
    emailTemplateSavedRow?: GraphCacheResolver<WithTypename<CreateEmailTemplateSavedRowPayload>, Record<string, never>, WithTypename<EmailTemplateSavedRow> | string>
  },
  CreateFlagContactPayload?: {
    errors?: GraphCacheResolver<WithTypename<CreateFlagContactPayload>, Record<string, never>, Array<InvalidFlagContactInputError | string>>,
    flagContacts?: GraphCacheResolver<WithTypename<CreateFlagContactPayload>, Record<string, never>, Array<WithTypename<FlagContact> | string>>
  },
  CreateMatchingLabelPayload?: {
    matchingLabel?: GraphCacheResolver<WithTypename<CreateMatchingLabelPayload>, Record<string, never>, WithTypename<MatchingLabel> | string>,
    participant?: GraphCacheResolver<WithTypename<CreateMatchingLabelPayload>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  CreateMatchingSurveyPayload?: {
    errors?: GraphCacheResolver<WithTypename<CreateMatchingSurveyPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    program?: GraphCacheResolver<WithTypename<CreateMatchingSurveyPayload>, Record<string, never>, WithTypename<Program> | string>,
    surveys?: GraphCacheResolver<WithTypename<CreateMatchingSurveyPayload>, Record<string, never>, Array<WithTypename<Survey> | string>>
  },
  CreateMessageTemplateTagPayload?: {
    messageTemplateTag?: GraphCacheResolver<WithTypename<CreateMessageTemplateTagPayload>, Record<string, never>, WithTypename<EmailTemplate> | string>
  },
  CreateMicroSurveyPayload?: {
    errors?: GraphCacheResolver<WithTypename<CreateMicroSurveyPayload>, Record<string, never>, Array<Scalars['String'] | string>>,
    microSurvey?: GraphCacheResolver<WithTypename<CreateMicroSurveyPayload>, Record<string, never>, WithTypename<MicroSurvey> | string>
  },
  CreateNewCourseTaskAndNewProgramTaskPayload?: {
    duplicateTasks?: GraphCacheResolver<WithTypename<CreateNewCourseTaskAndNewProgramTaskPayload>, Record<string, never>, Array<WithTypename<NewTask> | string>>,
    errors?: GraphCacheResolver<WithTypename<CreateNewCourseTaskAndNewProgramTaskPayload>, Record<string, never>, Array<WithTypename<DuplicateError> | string>>,
    newProgramTask?: GraphCacheResolver<WithTypename<CreateNewCourseTaskAndNewProgramTaskPayload>, Record<string, never>, WithTypename<NewProgramTask> | string>,
    newTask?: GraphCacheResolver<WithTypename<CreateNewCourseTaskAndNewProgramTaskPayload>, Record<string, never>, WithTypename<NewTask> | string>
  },
  CreateNewLinkTaskAndNewProgramTaskPayload?: {
    duplicateTasks?: GraphCacheResolver<WithTypename<CreateNewLinkTaskAndNewProgramTaskPayload>, Record<string, never>, Array<WithTypename<NewTask> | string>>,
    errors?: GraphCacheResolver<WithTypename<CreateNewLinkTaskAndNewProgramTaskPayload>, Record<string, never>, Array<WithTypename<DuplicateError> | string>>,
    newProgramTask?: GraphCacheResolver<WithTypename<CreateNewLinkTaskAndNewProgramTaskPayload>, Record<string, never>, WithTypename<NewProgramTask> | string>,
    newTask?: GraphCacheResolver<WithTypename<CreateNewLinkTaskAndNewProgramTaskPayload>, Record<string, never>, WithTypename<NewTask> | string>
  },
  CreateNotificationViewPayload?: {
    user?: GraphCacheResolver<WithTypename<CreateNotificationViewPayload>, Record<string, never>, WithTypename<User> | string>
  },
  CreateOrEnableNewProgramTaskPayload?: {
    errors?: GraphCacheResolver<WithTypename<CreateOrEnableNewProgramTaskPayload>, Record<string, never>, Array<Scalars['String'] | string>>,
    newProgramTask?: GraphCacheResolver<WithTypename<CreateOrEnableNewProgramTaskPayload>, Record<string, never>, WithTypename<NewProgramTask> | string>
  },
  CreatePartnerPayload?: {
    errors?: GraphCacheResolver<WithTypename<CreatePartnerPayload>, Record<string, never>, Array<InvalidPartnerInputError | string>>,
    partners?: GraphCacheResolver<WithTypename<CreatePartnerPayload>, Record<string, never>, Array<WithTypename<Partner> | string>>
  },
  CreateProgramAutomatchingConfigurationPayload?: {
    errors?: GraphCacheResolver<WithTypename<CreateProgramAutomatchingConfigurationPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    programAutomatchingConfiguration?: GraphCacheResolver<WithTypename<CreateProgramAutomatchingConfigurationPayload>, Record<string, never>, WithTypename<ProgramAutomatchingConfiguration> | string>
  },
  CreateProgramAutomatchingDefaultPayload?: {
    errors?: GraphCacheResolver<WithTypename<CreateProgramAutomatchingDefaultPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    programAutomatchingDefault?: GraphCacheResolver<WithTypename<CreateProgramAutomatchingDefaultPayload>, Record<string, never>, WithTypename<ProgramAutomatchingDefault> | string>
  },
  CreateProgramError?: {
    message?: GraphCacheResolver<WithTypename<CreateProgramError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<CreateProgramError>, Record<string, never>, CreateProgramErrorPaths | string>
  },
  CreateProgramPageVisitPayload?: {
    programPageVisit?: GraphCacheResolver<WithTypename<CreateProgramPageVisitPayload>, Record<string, never>, WithTypename<ProgramPageVisit> | string>
  },
  CreateProgramPayload?: {
    errors?: GraphCacheResolver<WithTypename<CreateProgramPayload>, Record<string, never>, Array<WithTypename<CreateProgramError> | string>>,
    program?: GraphCacheResolver<WithTypename<CreateProgramPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  CreateProgramResourceError?: {
    message?: GraphCacheResolver<WithTypename<CreateProgramResourceError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<CreateProgramResourceError>, Record<string, never>, CreateProgramResourceErrorPaths | string>
  },
  CreateProgramResourcePayload?: {
    errors?: GraphCacheResolver<WithTypename<CreateProgramResourcePayload>, Record<string, never>, Array<WithTypename<CreateProgramResourceError> | string>>,
    programResource?: GraphCacheResolver<WithTypename<CreateProgramResourcePayload>, Record<string, never>, WithTypename<ProgramResource> | string>,
    user?: GraphCacheResolver<WithTypename<CreateProgramResourcePayload>, Record<string, never>, WithTypename<User> | string>
  },
  CreateProgramSequenceError?: {
    message?: GraphCacheResolver<WithTypename<CreateProgramSequenceError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<CreateProgramSequenceError>, Record<string, never>, CreateProgramSequenceErrorPaths | string>
  },
  CreateProgramSequencePayload?: {
    errors?: GraphCacheResolver<WithTypename<CreateProgramSequencePayload>, Record<string, never>, Array<WithTypename<CreateProgramSequenceError> | string>>,
    programSequence?: GraphCacheResolver<WithTypename<CreateProgramSequencePayload>, Record<string, never>, WithTypename<ProgramSequence> | string>
  },
  CreateProgramTaskPayload?: {
    errors?: GraphCacheResolver<WithTypename<CreateProgramTaskPayload>, Record<string, never>, Array<Scalars['String'] | string>>,
    programTask?: GraphCacheResolver<WithTypename<CreateProgramTaskPayload>, Record<string, never>, WithTypename<ProgramTask> | string>
  },
  CreateProgramTopicPayload?: {
    programTopic?: GraphCacheResolver<WithTypename<CreateProgramTopicPayload>, Record<string, never>, WithTypename<ProgramTopic> | string>
  },
  CreateSavedMatchPayload?: {
    errors?: GraphCacheResolver<WithTypename<CreateSavedMatchPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    savedMatch?: GraphCacheResolver<WithTypename<CreateSavedMatchPayload>, Record<string, never>, WithTypename<SavedMatch> | string>
  },
  CreateSchoolError?: {
    message?: GraphCacheResolver<WithTypename<CreateSchoolError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<CreateSchoolError>, Record<string, never>, CreateSchoolErrorPaths | string>
  },
  CreateSchoolPayload?: {
    errors?: GraphCacheResolver<WithTypename<CreateSchoolPayload>, Record<string, never>, Array<WithTypename<CreateSchoolError> | string>>,
    school?: GraphCacheResolver<WithTypename<CreateSchoolPayload>, Record<string, never>, WithTypename<School> | string>
  },
  CreateSkeletonMessageTemplatePayload?: {
    skeletonMessageTemplate?: GraphCacheResolver<WithTypename<CreateSkeletonMessageTemplatePayload>, Record<string, never>, WithTypename<SkeletonMessageTemplate> | string>
  },
  CreateSmsTemplatePayload?: {
    smsTemplate?: GraphCacheResolver<WithTypename<CreateSmsTemplatePayload>, Record<string, never>, WithTypename<SmsTemplate> | string>
  },
  CreateTopicPayload?: {
    topic?: GraphCacheResolver<WithTypename<CreateTopicPayload>, Record<string, never>, WithTypename<Topic> | string>
  },
  CreateUploadedVideoPayload?: {
    errors?: GraphCacheResolver<WithTypename<CreateUploadedVideoPayload>, Record<string, never>, Array<Scalars['String'] | string>>,
    participant?: GraphCacheResolver<WithTypename<CreateUploadedVideoPayload>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  CsvExport?: {
    errors?: GraphCacheResolver<WithTypename<CsvExport>, Record<string, never>, Array<Scalars['String'] | string>>,
    filename?: GraphCacheResolver<WithTypename<CsvExport>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<CsvExport>, Record<string, never>, Scalars['ID'] | string>,
    isProcessing?: GraphCacheResolver<WithTypename<CsvExport>, Record<string, never>, Scalars['Boolean'] | string>,
    url?: GraphCacheResolver<WithTypename<CsvExport>, Record<string, never>, Scalars['String'] | string>
  },
  CsvExports?: {
    matchedUsersReport?: GraphCacheResolver<WithTypename<CsvExports>, CsvExportsMatchedUsersReportArgs, WithTypename<CsvExport> | string>,
    menteeMentorQuotes?: GraphCacheResolver<WithTypename<CsvExports>, CsvExportsMenteeMentorQuotesArgs, WithTypename<CsvExport> | string>,
    mentorshipEngagementData?: GraphCacheResolver<WithTypename<CsvExports>, CsvExportsMentorshipEngagementDataArgs, WithTypename<CsvExport> | string>,
    participantsProfileData?: GraphCacheResolver<WithTypename<CsvExports>, CsvExportsParticipantsProfileDataArgs, WithTypename<CsvExport> | string>,
    partnerDashboardExports?: GraphCacheResolver<WithTypename<CsvExports>, Record<string, never>, WithTypename<PartnerDashboardExports> | string>,
    recruitmentOpportunities?: GraphCacheResolver<WithTypename<CsvExports>, CsvExportsRecruitmentOpportunitiesArgs, WithTypename<CsvExport> | string>,
    surveyResponses?: GraphCacheResolver<WithTypename<CsvExports>, CsvExportsSurveyResponsesArgs, WithTypename<CsvExport> | string>,
    writtenTestimonials?: GraphCacheResolver<WithTypename<CsvExports>, CsvExportsWrittenTestimonialsArgs, WithTypename<CsvExport> | string>
  },
  CustomMessageTypeTemplateRequirement?: {
    createdAt?: GraphCacheResolver<WithTypename<CustomMessageTypeTemplateRequirement>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    customMessageType?: GraphCacheResolver<WithTypename<CustomMessageTypeTemplateRequirement>, Record<string, never>, ProgramCustomMessage | string>,
    id?: GraphCacheResolver<WithTypename<CustomMessageTypeTemplateRequirement>, Record<string, never>, Scalars['ID'] | string>,
    messageCategory?: GraphCacheResolver<WithTypename<CustomMessageTypeTemplateRequirement>, Record<string, never>, MessageCategory | string>,
    messageType?: GraphCacheResolver<WithTypename<CustomMessageTypeTemplateRequirement>, Record<string, never>, Message | string>,
    updatedAt?: GraphCacheResolver<WithTypename<CustomMessageTypeTemplateRequirement>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    userState?: GraphCacheResolver<WithTypename<CustomMessageTypeTemplateRequirement>, Record<string, never>, UserState | string>
  },
  CustomMessageTypeTemplateRequirementConnection?: {
    edges?: GraphCacheResolver<WithTypename<CustomMessageTypeTemplateRequirementConnection>, Record<string, never>, Array<WithTypename<CustomMessageTypeTemplateRequirementEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<CustomMessageTypeTemplateRequirementConnection>, Record<string, never>, Array<WithTypename<CustomMessageTypeTemplateRequirement> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<CustomMessageTypeTemplateRequirementConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<CustomMessageTypeTemplateRequirementConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  CustomMessageTypeTemplateRequirementEdge?: {
    cursor?: GraphCacheResolver<WithTypename<CustomMessageTypeTemplateRequirementEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<CustomMessageTypeTemplateRequirementEdge>, Record<string, never>, WithTypename<CustomMessageTypeTemplateRequirement> | string>
  },
  DeleteContacts?: {
    byFilterSelection?: GraphCacheResolver<WithTypename<DeleteContacts>, DeleteContactsByFilterSelectionArgs, WithTypename<DeleteContactsByFilterSelectionPayload> | string>,
    byIds?: GraphCacheResolver<WithTypename<DeleteContacts>, DeleteContactsByIdsArgs, WithTypename<DeleteContactsByIdsPayload> | string>
  },
  DeleteContactsByFilterSelectionPayload?: {
    errors?: GraphCacheResolver<WithTypename<DeleteContactsByFilterSelectionPayload>, Record<string, never>, Array<ContactsNotAbleToBeDeletedError | string>>,
    numberOfContactsDeleted?: GraphCacheResolver<WithTypename<DeleteContactsByFilterSelectionPayload>, Record<string, never>, Scalars['Int'] | string>,
    program?: GraphCacheResolver<WithTypename<DeleteContactsByFilterSelectionPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  DeleteContactsByIdsPayload?: {
    errors?: GraphCacheResolver<WithTypename<DeleteContactsByIdsPayload>, Record<string, never>, Array<ContactsNotAbleToBeDeletedError | string>>,
    numberOfContactsDeleted?: GraphCacheResolver<WithTypename<DeleteContactsByIdsPayload>, Record<string, never>, Scalars['Int'] | string>,
    program?: GraphCacheResolver<WithTypename<DeleteContactsByIdsPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  DeleteFlagContactPayload?: {
    errors?: GraphCacheResolver<WithTypename<DeleteFlagContactPayload>, Record<string, never>, Array<Scalars['String'] | string>>
  },
  DeleteMatchingLabelPayload?: {
    errors?: GraphCacheResolver<WithTypename<DeleteMatchingLabelPayload>, Record<string, never>, Array<DeleteMatchingLabelError | string>>,
    participant?: GraphCacheResolver<WithTypename<DeleteMatchingLabelPayload>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  DeleteProgramPayload?: {
    errors?: GraphCacheResolver<WithTypename<DeleteProgramPayload>, Record<string, never>, Array<ProgramNotAbleToBeDeletedError | string>>
  },
  DeleteProgramResourcePayload?: {
    program?: GraphCacheResolver<WithTypename<DeleteProgramResourcePayload>, Record<string, never>, WithTypename<Program> | string>
  },
  DeleteProgramSequencePayload?: {
    errors?: GraphCacheResolver<WithTypename<DeleteProgramSequencePayload>, Record<string, never>, Array<ProgramSequenceNotAbleToBeDeletedError | string>>
  },
  DeleteProgramTaskPayload?: {
    program?: GraphCacheResolver<WithTypename<DeleteProgramTaskPayload>, Record<string, never>, WithTypename<Program> | string>,
    programSequence?: GraphCacheResolver<WithTypename<DeleteProgramTaskPayload>, Record<string, never>, WithTypename<ProgramSequence> | string>
  },
  DeleteProgramTopicPayload?: {
    errors?: GraphCacheResolver<WithTypename<DeleteProgramTopicPayload>, Record<string, never>, Array<ProgramTopicNotAbleToBeDeletedError | string>>
  },
  DeleteSavedMatches?: {
    byFilter?: GraphCacheResolver<WithTypename<DeleteSavedMatches>, DeleteSavedMatchesByFilterArgs, WithTypename<DeleteSavedMatchesByFilterPayload> | string>,
    byIds?: GraphCacheResolver<WithTypename<DeleteSavedMatches>, DeleteSavedMatchesByIdsArgs, WithTypename<DeleteSavedMatchesByIdsPayload> | string>
  },
  DeleteSavedMatchesByFilterPayload?: {
    deletedCount?: GraphCacheResolver<WithTypename<DeleteSavedMatchesByFilterPayload>, Record<string, never>, Scalars['Int'] | string>,
    errors?: GraphCacheResolver<WithTypename<DeleteSavedMatchesByFilterPayload>, Record<string, never>, Array<WithTypename<Error> | string>>
  },
  DeleteSavedMatchesByIdsPayload?: {
    deletedCount?: GraphCacheResolver<WithTypename<DeleteSavedMatchesByIdsPayload>, Record<string, never>, Scalars['Int'] | string>,
    errors?: GraphCacheResolver<WithTypename<DeleteSavedMatchesByIdsPayload>, Record<string, never>, Array<WithTypename<Error> | string>>
  },
  DeleteSchoolPayload?: {
    errors?: GraphCacheResolver<WithTypename<DeleteSchoolPayload>, Record<string, never>, Array<SchoolNotAbleToBeDeletedError | string>>
  },
  DeleteSuggestedBatchPayload?: {
    deletedId?: GraphCacheResolver<WithTypename<DeleteSuggestedBatchPayload>, Record<string, never>, Scalars['ID'] | string>
  },
  DenylistEmailsPayload?: {
    batchActionId?: GraphCacheResolver<WithTypename<DenylistEmailsPayload>, Record<string, never>, Scalars['ID'] | string>,
    errors?: GraphCacheResolver<WithTypename<DenylistEmailsPayload>, Record<string, never>, Scalars['String'] | string>
  },
  DeregisterParticipantPayload?: {
    errors?: GraphCacheResolver<WithTypename<DeregisterParticipantPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    participant?: GraphCacheResolver<WithTypename<DeregisterParticipantPayload>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  DeregistrationReason?: {
    createdAt?: GraphCacheResolver<WithTypename<DeregistrationReason>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    grouping?: GraphCacheResolver<WithTypename<DeregistrationReason>, Record<string, never>, GroupingEnum | string>,
    id?: GraphCacheResolver<WithTypename<DeregistrationReason>, Record<string, never>, Scalars['ID'] | string>,
    identifier?: GraphCacheResolver<WithTypename<DeregistrationReason>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<DeregistrationReason>, Record<string, never>, Scalars['String'] | string>,
    participantFacingName?: GraphCacheResolver<WithTypename<DeregistrationReason>, Record<string, never>, Scalars['String'] | string>
  },
  DeregistrationReasonConnection?: {
    edges?: GraphCacheResolver<WithTypename<DeregistrationReasonConnection>, Record<string, never>, Array<WithTypename<DeregistrationReasonEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<DeregistrationReasonConnection>, Record<string, never>, Array<WithTypename<DeregistrationReason> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<DeregistrationReasonConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<DeregistrationReasonConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  DeregistrationReasonEdge?: {
    cursor?: GraphCacheResolver<WithTypename<DeregistrationReasonEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<DeregistrationReasonEdge>, Record<string, never>, WithTypename<DeregistrationReason> | string>
  },
  DeregistrationStatusEvent?: {
    createdAt?: GraphCacheResolver<WithTypename<DeregistrationStatusEvent>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    deregistrationReason?: GraphCacheResolver<WithTypename<DeregistrationStatusEvent>, Record<string, never>, WithTypename<DeregistrationReason> | string>,
    id?: GraphCacheResolver<WithTypename<DeregistrationStatusEvent>, Record<string, never>, Scalars['ID'] | string>,
    kind?: GraphCacheResolver<WithTypename<DeregistrationStatusEvent>, Record<string, never>, Scalars['String'] | string>,
    otherReasonNotes?: GraphCacheResolver<WithTypename<DeregistrationStatusEvent>, Record<string, never>, Scalars['String'] | string>,
    participant?: GraphCacheResolver<WithTypename<DeregistrationStatusEvent>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  DisableNewProgramTaskPayload?: {
    errors?: GraphCacheResolver<WithTypename<DisableNewProgramTaskPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    newProgramTask?: GraphCacheResolver<WithTypename<DisableNewProgramTaskPayload>, Record<string, never>, WithTypename<NewProgramTask> | string>
  },
  DisengagementResolutionsAverageTimeToRematchResult?: {
    averageRematchTimeInDays?: GraphCacheResolver<WithTypename<DisengagementResolutionsAverageTimeToRematchResult>, Record<string, never>, Scalars['Float'] | string>
  },
  DisengagementResolutionsMetricsResult?: {
    metric?: GraphCacheResolver<WithTypename<DisengagementResolutionsMetricsResult>, Record<string, never>, Scalars['String'] | string>,
    value?: GraphCacheResolver<WithTypename<DisengagementResolutionsMetricsResult>, Record<string, never>, Scalars['Int'] | string>
  },
  DismissProgramAlertPayload?: {
    program?: GraphCacheResolver<WithTypename<DismissProgramAlertPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  DuplicateError?: {
    duplicateNewTaskId?: GraphCacheResolver<WithTypename<DuplicateError>, Record<string, never>, Scalars['ID'] | string>,
    message?: GraphCacheResolver<WithTypename<DuplicateError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<DuplicateError>, Record<string, never>, Scalars['String'] | string>
  },
  DuplicateMessageTemplates?: {
    byFilterSelection?: GraphCacheResolver<WithTypename<DuplicateMessageTemplates>, DuplicateMessageTemplatesByFilterSelectionArgs, WithTypename<DuplicateMessageTemplatesByFilterSelectionPayload> | string>,
    byIds?: GraphCacheResolver<WithTypename<DuplicateMessageTemplates>, DuplicateMessageTemplatesByIdsArgs, WithTypename<DuplicateMessageTemplatesByIdsPayload> | string>
  },
  DuplicateMessageTemplatesByFilterSelectionPayload?: {
    newMessageTemplates?: GraphCacheResolver<WithTypename<DuplicateMessageTemplatesByFilterSelectionPayload>, DuplicateMessageTemplatesByFilterSelectionPayloadNewMessageTemplatesArgs, WithTypename<MessageTemplateConnection> | string>
  },
  DuplicateMessageTemplatesByIdsPayload?: {
    newMessageTemplates?: GraphCacheResolver<WithTypename<DuplicateMessageTemplatesByIdsPayload>, DuplicateMessageTemplatesByIdsPayloadNewMessageTemplatesArgs, WithTypename<MessageTemplateConnection> | string>
  },
  DuplicateProgramPayload?: {
    errors?: GraphCacheResolver<WithTypename<DuplicateProgramPayload>, Record<string, never>, Array<Scalars['String'] | string>>,
    program?: GraphCacheResolver<WithTypename<DuplicateProgramPayload>, Record<string, never>, WithTypename<Program> | string>,
    successMessages?: GraphCacheResolver<WithTypename<DuplicateProgramPayload>, Record<string, never>, Array<Scalars['String'] | string>>
  },
  DuplicateProgramSequencePayload?: {
    errors?: GraphCacheResolver<WithTypename<DuplicateProgramSequencePayload>, Record<string, never>, Array<Scalars['String'] | string>>,
    programSequence?: GraphCacheResolver<WithTypename<DuplicateProgramSequencePayload>, Record<string, never>, WithTypename<ProgramSequence> | string>
  },
  DwhParticipantsMetrics?: {
    menteesRegistered?: GraphCacheResolver<WithTypename<DwhParticipantsMetrics>, Record<string, never>, Scalars['Int'] | string>,
    mentorsRegistered?: GraphCacheResolver<WithTypename<DwhParticipantsMetrics>, Record<string, never>, Scalars['Int'] | string>,
    participantsRegistered?: GraphCacheResolver<WithTypename<DwhParticipantsMetrics>, Record<string, never>, Scalars['Int'] | string>,
    programId?: GraphCacheResolver<WithTypename<DwhParticipantsMetrics>, Record<string, never>, Scalars['ID'] | string>,
    programName?: GraphCacheResolver<WithTypename<DwhParticipantsMetrics>, Record<string, never>, Scalars['String'] | string>
  },
  DwhParticipantsMetricsConnection?: {
    nodes?: GraphCacheResolver<WithTypename<DwhParticipantsMetricsConnection>, Record<string, never>, Array<WithTypename<DwhParticipantsMetrics> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<DwhParticipantsMetricsConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalMenteesRegisteredCount?: GraphCacheResolver<WithTypename<DwhParticipantsMetricsConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalMentorsRegisteredCount?: GraphCacheResolver<WithTypename<DwhParticipantsMetricsConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalParticipantsRegisteredCount?: GraphCacheResolver<WithTypename<DwhParticipantsMetricsConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  DwhQueryableMetrics?: {
    participants?: GraphCacheResolver<WithTypename<DwhQueryableMetrics>, DwhQueryableMetricsParticipantsArgs, WithTypename<DwhParticipantsMetricsConnection> | string>
  },
  EmailTemplate?: {
    archivedAt?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    category?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, MessageCategory | string>,
    content?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    createdBy?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, WithTypename<User> | string>,
    customMessageType?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, ProgramCustomMessage | string>,
    id?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, Scalars['ID'] | string>,
    identifier?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, Scalars['String'] | string>,
    isDefault?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, Scalars['Boolean'] | string>,
    lastEditedAt?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    lastEditedBy?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, WithTypename<User> | string>,
    messageType?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, Message | string>,
    name?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, Scalars['String'] | string>,
    preheaderText?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, Scalars['String'] | string>,
    programSegment?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, ProgramSegment | string>,
    subjectLine?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, Scalars['String'] | string>,
    tags?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, Array<WithTypename<MessageTemplateTag> | string>>,
    templateEditorData?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, Scalars['JSON'] | string>,
    userState?: GraphCacheResolver<WithTypename<EmailTemplate>, Record<string, never>, UserState | string>
  },
  EmailTemplateSavedRow?: {
    category?: GraphCacheResolver<WithTypename<EmailTemplateSavedRow>, Record<string, never>, EmailTemplateSavedRowCategory | string>,
    id?: GraphCacheResolver<WithTypename<EmailTemplateSavedRow>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<EmailTemplateSavedRow>, Record<string, never>, Scalars['String'] | string>,
    templateEditorData?: GraphCacheResolver<WithTypename<EmailTemplateSavedRow>, Record<string, never>, Scalars['JSON'] | string>
  },
  EngagementBenchmarkData?: {
    disengagedMenteesInPreviousProgram?: GraphCacheResolver<WithTypename<EngagementBenchmarkData>, Record<string, never>, Scalars['Int'] | string>,
    disengagedMentorsInPreviousProgram?: GraphCacheResolver<WithTypename<EngagementBenchmarkData>, Record<string, never>, Scalars['Int'] | string>,
    mentorshipsInPreviousProgramEngagedInLast30Days?: GraphCacheResolver<WithTypename<EngagementBenchmarkData>, Record<string, never>, Scalars['Int'] | string>,
    mentorshipsInPreviousProgramUsingSmsRelay?: GraphCacheResolver<WithTypename<EngagementBenchmarkData>, Record<string, never>, Scalars['Int'] | string>,
    mentorshipsInPreviousProgramWith0Conversations?: GraphCacheResolver<WithTypename<EngagementBenchmarkData>, Record<string, never>, Scalars['Int'] | string>,
    mentorshipsInPreviousProgramWith3OrMoreConversations?: GraphCacheResolver<WithTypename<EngagementBenchmarkData>, Record<string, never>, Scalars['Int'] | string>,
    totalCountWithConversationInTheLast30Days?: GraphCacheResolver<WithTypename<EngagementBenchmarkData>, Record<string, never>, Scalars['Int'] | string>,
    totalCountWithThreeOrMoreConversations?: GraphCacheResolver<WithTypename<EngagementBenchmarkData>, Record<string, never>, Scalars['Int'] | string>,
    totalCountWithZeroConversations?: GraphCacheResolver<WithTypename<EngagementBenchmarkData>, Record<string, never>, Scalars['Int'] | string>,
    totalMenteesInPreviousProgram?: GraphCacheResolver<WithTypename<EngagementBenchmarkData>, Record<string, never>, Scalars['Int'] | string>,
    totalMentorsInPreviousProgram?: GraphCacheResolver<WithTypename<EngagementBenchmarkData>, Record<string, never>, Scalars['Int'] | string>,
    totalMentorshipsForPreviousProgram?: GraphCacheResolver<WithTypename<EngagementBenchmarkData>, Record<string, never>, Scalars['Int'] | string>
  },
  Error?: {
    message?: GraphCacheResolver<WithTypename<Error>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<Error>, Record<string, never>, Scalars['String'] | string>
  },
  ExternalLink?: {
    href?: GraphCacheResolver<WithTypename<ExternalLink>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<ExternalLink>, Record<string, never>, Scalars['ID'] | string>,
    kind?: GraphCacheResolver<WithTypename<ExternalLink>, Record<string, never>, ExternalLinkKind | string>,
    name?: GraphCacheResolver<WithTypename<ExternalLink>, Record<string, never>, Scalars['String'] | string>
  },
  Flag?: {
    additionalInfo?: GraphCacheResolver<WithTypename<Flag>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Flag>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    flagCategories?: GraphCacheResolver<WithTypename<Flag>, FlagFlagCategoriesArgs, Array<WithTypename<FlagCategory> | string>>,
    id?: GraphCacheResolver<WithTypename<Flag>, Record<string, never>, Scalars['ID'] | string>,
    mentorship?: GraphCacheResolver<WithTypename<Flag>, Record<string, never>, WithTypename<Mentorship> | string>,
    participantConversationContent?: GraphCacheResolver<WithTypename<Flag>, Record<string, never>, WithTypename<ParticipantConversationContent> | string>,
    partnerNotes?: GraphCacheResolver<WithTypename<Flag>, Record<string, never>, Scalars['String'] | string>,
    status?: GraphCacheResolver<WithTypename<Flag>, Record<string, never>, FlagStatus | string>,
    submittedBy?: GraphCacheResolver<WithTypename<Flag>, Record<string, never>, WithTypename<User> | string>,
    supportPriority?: GraphCacheResolver<WithTypename<Flag>, Record<string, never>, SupportPriority | string>
  },
  FlagCategory?: {
    id?: GraphCacheResolver<WithTypename<FlagCategory>, Record<string, never>, Scalars['ID'] | string>,
    identifier?: GraphCacheResolver<WithTypename<FlagCategory>, Record<string, never>, Scalars['String'] | string>,
    label?: GraphCacheResolver<WithTypename<FlagCategory>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<FlagCategory>, Record<string, never>, Scalars['String'] | string>,
    smsCharacter?: GraphCacheResolver<WithTypename<FlagCategory>, Record<string, never>, Scalars['String'] | string>
  },
  FlagConnection?: {
    edges?: GraphCacheResolver<WithTypename<FlagConnection>, Record<string, never>, Array<WithTypename<FlagEdge> | string>>,
    flagCategoriesSubmitted?: GraphCacheResolver<WithTypename<FlagConnection>, Record<string, never>, Array<Scalars['String'] | string>>,
    nodes?: GraphCacheResolver<WithTypename<FlagConnection>, Record<string, never>, Array<WithTypename<Flag> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<FlagConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<FlagConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  FlagContact?: {
    email?: GraphCacheResolver<WithTypename<FlagContact>, Record<string, never>, Scalars['String'] | string>,
    firstName?: GraphCacheResolver<WithTypename<FlagContact>, Record<string, never>, Scalars['String'] | string>,
    flagCategories?: GraphCacheResolver<WithTypename<FlagContact>, FlagContactFlagCategoriesArgs, Array<WithTypename<FlagCategory> | string>>,
    id?: GraphCacheResolver<WithTypename<FlagContact>, Record<string, never>, Scalars['ID'] | string>,
    lastName?: GraphCacheResolver<WithTypename<FlagContact>, Record<string, never>, Scalars['String'] | string>
  },
  FlagEdge?: {
    cursor?: GraphCacheResolver<WithTypename<FlagEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<FlagEdge>, Record<string, never>, WithTypename<Flag> | string>
  },
  FlagPageVisit?: {
    createdAt?: GraphCacheResolver<WithTypename<FlagPageVisit>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<FlagPageVisit>, Record<string, never>, Scalars['ID'] | string>
  },
  FlagPageVisitConnection?: {
    edges?: GraphCacheResolver<WithTypename<FlagPageVisitConnection>, Record<string, never>, Array<WithTypename<FlagPageVisitEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<FlagPageVisitConnection>, Record<string, never>, Array<WithTypename<FlagPageVisit> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<FlagPageVisitConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<FlagPageVisitConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  FlagPageVisitEdge?: {
    cursor?: GraphCacheResolver<WithTypename<FlagPageVisitEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<FlagPageVisitEdge>, Record<string, never>, WithTypename<FlagPageVisit> | string>
  },
  FlagsMetrics?: {
    totalFlagged?: GraphCacheResolver<WithTypename<FlagsMetrics>, FlagsMetricsTotalFlaggedArgs, Array<WithTypename<Interval> | string>>
  },
  Goal?: {
    archived?: GraphCacheResolver<WithTypename<Goal>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<Goal>, Record<string, never>, Scalars['ID'] | string>,
    identifier?: GraphCacheResolver<WithTypename<Goal>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<Goal>, Record<string, never>, Scalars['String'] | string>
  },
  GoalConnection?: {
    edges?: GraphCacheResolver<WithTypename<GoalConnection>, Record<string, never>, Array<WithTypename<GoalEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<GoalConnection>, Record<string, never>, Array<WithTypename<Goal> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<GoalConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<GoalConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  GoalEdge?: {
    cursor?: GraphCacheResolver<WithTypename<GoalEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<GoalEdge>, Record<string, never>, WithTypename<Goal> | string>
  },
  GroupMatchingSettings?: {
    maxGroupSize?: GraphCacheResolver<WithTypename<GroupMatchingSettings>, Record<string, never>, Scalars['Int'] | string>,
    minGroupSize?: GraphCacheResolver<WithTypename<GroupMatchingSettings>, Record<string, never>, Scalars['Int'] | string>
  },
  Image?: {
    id?: GraphCacheResolver<WithTypename<Image>, Record<string, never>, Scalars['ID'] | string>,
    url?: GraphCacheResolver<WithTypename<Image>, ImageUrlArgs, Scalars['String'] | string>
  },
  Interval?: {
    date?: GraphCacheResolver<WithTypename<Interval>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    group?: GraphCacheResolver<WithTypename<Interval>, Record<string, never>, Scalars['String'] | string>,
    sampleSize?: GraphCacheResolver<WithTypename<Interval>, Record<string, never>, Scalars['Int'] | string>,
    value?: GraphCacheResolver<WithTypename<Interval>, Record<string, never>, Scalars['Float'] | string>,
    valueType?: GraphCacheResolver<WithTypename<Interval>, Record<string, never>, IntervalValue | string>
  },
  LinkTaskContext?: {
    id?: GraphCacheResolver<WithTypename<LinkTaskContext>, Record<string, never>, Scalars['ID'] | string>,
    newTask?: GraphCacheResolver<WithTypename<LinkTaskContext>, Record<string, never>, WithTypename<NewTask> | string>,
    url?: GraphCacheResolver<WithTypename<LinkTaskContext>, Record<string, never>, Scalars['String'] | string>
  },
  LogTookTypeformSurveyPayload?: {
    participant?: GraphCacheResolver<WithTypename<LogTookTypeformSurveyPayload>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  LogWatchedCommunityVideoPayload?: {
    participant?: GraphCacheResolver<WithTypename<LogWatchedCommunityVideoPayload>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  LogWatchedWistiaVideoPayload?: {
    participant?: GraphCacheResolver<WithTypename<LogWatchedWistiaVideoPayload>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  MakeBatchMatchesPayload?: {
    errors?: GraphCacheResolver<WithTypename<MakeBatchMatchesPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    suggestedBatch?: GraphCacheResolver<WithTypename<MakeBatchMatchesPayload>, Record<string, never>, WithTypename<SuggestedBatch> | string>
  },
  MakeMatchPayload?: {
    deletedSavedMatchId?: GraphCacheResolver<WithTypename<MakeMatchPayload>, Record<string, never>, Scalars['ID'] | string>,
    errors?: GraphCacheResolver<WithTypename<MakeMatchPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    mentor?: GraphCacheResolver<WithTypename<MakeMatchPayload>, Record<string, never>, WithTypename<Mentor> | string>,
    showAllowRematchConfirm?: GraphCacheResolver<WithTypename<MakeMatchPayload>, Record<string, never>, Scalars['Boolean'] | string>,
    student?: GraphCacheResolver<WithTypename<MakeMatchPayload>, Record<string, never>, WithTypename<Student> | string>
  },
  MakeSavedGroupMatches?: {
    byFilter?: GraphCacheResolver<WithTypename<MakeSavedGroupMatches>, MakeSavedGroupMatchesByFilterArgs, WithTypename<MakeSavedGroupMatchesByFilterPayload> | string>,
    byIds?: GraphCacheResolver<WithTypename<MakeSavedGroupMatches>, MakeSavedGroupMatchesByIdsArgs, WithTypename<MakeSavedGroupMatchesByIdsPayload> | string>
  },
  MakeSavedGroupMatchesByFilterPayload?: {
    errors?: GraphCacheResolver<WithTypename<MakeSavedGroupMatchesByFilterPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    queuedGroupsCount?: GraphCacheResolver<WithTypename<MakeSavedGroupMatchesByFilterPayload>, Record<string, never>, Scalars['Int'] | string>,
    queuedMatchesCount?: GraphCacheResolver<WithTypename<MakeSavedGroupMatchesByFilterPayload>, Record<string, never>, Scalars['Int'] | string>,
    savedMatchIds?: GraphCacheResolver<WithTypename<MakeSavedGroupMatchesByFilterPayload>, Record<string, never>, Array<Scalars['ID'] | string>>
  },
  MakeSavedGroupMatchesByIdsPayload?: {
    errors?: GraphCacheResolver<WithTypename<MakeSavedGroupMatchesByIdsPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    queuedGroupsCount?: GraphCacheResolver<WithTypename<MakeSavedGroupMatchesByIdsPayload>, Record<string, never>, Scalars['Int'] | string>,
    queuedMatchesCount?: GraphCacheResolver<WithTypename<MakeSavedGroupMatchesByIdsPayload>, Record<string, never>, Scalars['Int'] | string>,
    savedMatchIds?: GraphCacheResolver<WithTypename<MakeSavedGroupMatchesByIdsPayload>, Record<string, never>, Array<Scalars['ID'] | string>>
  },
  MakeSavedMatches?: {
    byFilter?: GraphCacheResolver<WithTypename<MakeSavedMatches>, MakeSavedMatchesByFilterArgs, WithTypename<MakeSavedMatchesByFilterPayload> | string>,
    byIds?: GraphCacheResolver<WithTypename<MakeSavedMatches>, MakeSavedMatchesByIdsArgs, WithTypename<MakeSavedMatchesByIdsPayload> | string>
  },
  MakeSavedMatchesByFilterPayload?: {
    errors?: GraphCacheResolver<WithTypename<MakeSavedMatchesByFilterPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    queuedMatchesCount?: GraphCacheResolver<WithTypename<MakeSavedMatchesByFilterPayload>, Record<string, never>, Scalars['Int'] | string>,
    savedMatchIds?: GraphCacheResolver<WithTypename<MakeSavedMatchesByFilterPayload>, Record<string, never>, Array<Scalars['ID'] | string>>
  },
  MakeSavedMatchesByIdsPayload?: {
    errors?: GraphCacheResolver<WithTypename<MakeSavedMatchesByIdsPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    queuedMatchesCount?: GraphCacheResolver<WithTypename<MakeSavedMatchesByIdsPayload>, Record<string, never>, Scalars['Int'] | string>,
    savedMatchIds?: GraphCacheResolver<WithTypename<MakeSavedMatchesByIdsPayload>, Record<string, never>, Array<Scalars['ID'] | string>>
  },
  MarkParticipantReachedOutPayload?: {
    errors?: GraphCacheResolver<WithTypename<MarkParticipantReachedOutPayload>, Record<string, never>, Array<InvalidMarkParticipantReachedOutError | string>>,
    mentorship?: GraphCacheResolver<WithTypename<MarkParticipantReachedOutPayload>, Record<string, never>, WithTypename<Mentorship> | string>,
    participant?: GraphCacheResolver<WithTypename<MarkParticipantReachedOutPayload>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  MatchingCriteria?: {
    enrollmentMenteeMatchingCriteria?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, EnrollmentMenteeMatchingCriteria | string>,
    hardMatchQuestions?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Array<WithTypename<HardMatchQuestion> | string>>,
    includeAvailableToMatchEnrollmentMentees?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    includeEverMatchedEnrollmentMentees?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    includeMenteesUnder17?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    includeMenteesWhoArePushedThroughToMatch?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    includeMenteesWhoHaveBeenUnmatched?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    includeMenteesWithFreeResponses?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    includeMenteesWithSupermentorOptIn?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    includeMenteesWithoutMatchingSurveys?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    includeMentorsWhoArePushedThroughToMatch?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    includeMentorsWhoHaveBeenUnmatched?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    includeMentorsWithMentorships?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    includeMentorsWithSupermentorOptIn?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    includeMentorsWithoutMatchingSurveys?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    includeMentorsWithoutTraining?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    onlyEnrollmentOptInMentees?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    requireMenteeSupermentorOptIn?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    requireMentorSupermentorOptIn?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    sharedMajor?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    sharedTransferStatus?: GraphCacheResolver<WithTypename<MatchingCriteria>, Record<string, never>, Scalars['Boolean'] | string>
  },
  MatchingLabel?: {
    createdAt?: GraphCacheResolver<WithTypename<MatchingLabel>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<MatchingLabel>, Record<string, never>, Scalars['ID'] | string>,
    kind?: GraphCacheResolver<WithTypename<MatchingLabel>, Record<string, never>, MatchingLabelKindTypes | string>,
    participant?: GraphCacheResolver<WithTypename<MatchingLabel>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  Mentor?: {
    activityLogs?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Array<WithTypename<TookTypeformSurveyLog> | WithTypename<TrainingEventLog> | WithTypename<WatchedCommunityVideoLog> | WithTypename<WatchedVideoLog> | string>>,
    allowedToSkipMatchingSurvey?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['Boolean'] | string>,
    avatar?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['String'] | string>,
    avatarImage?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, WithTypename<Image> | string>,
    cachedUserProfileData?: GraphCacheResolver<WithTypename<Mentor>, MentorCachedUserProfileDataArgs, Array<WithTypename<CachedUserProfileDataAttributeValue> | string>>,
    capacity?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['Int'] | string>,
    completedMatchingSurveyAt?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    deregisterDate?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    deregistrationStatusEvents?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Array<WithTypename<DeregistrationStatusEvent> | string>>,
    id?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['ID'] | string>,
    lastCompletedRequiredTrainingAt?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    matchingLabels?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Array<WithTypename<MatchingLabel> | string>>,
    mentorTrainingCourseLink?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['String'] | string>,
    mentorships?: GraphCacheResolver<WithTypename<Mentor>, MentorMentorshipsArgs, Array<WithTypename<Mentorship> | string>>,
    notes?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['String'] | string>,
    participantMentorships?: GraphCacheResolver<WithTypename<Mentor>, MentorParticipantMentorshipsArgs, WithTypename<MentorshipConnection> | string>,
    prioritizedAndPendingForRematching?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['Boolean'] | string>,
    program?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, WithTypename<Program> | string>,
    pushedThroughToMatch?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['Boolean'] | string>,
    registered?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['Boolean'] | string>,
    registrationDate?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    requiredTrainingStatus?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['String'] | string>,
    savedMatches?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Array<WithTypename<SavedMatch> | string>>,
    supermentorOptIn?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['String'] | string>,
    surveyResponses?: GraphCacheResolver<WithTypename<Mentor>, MentorSurveyResponsesArgs, Array<WithTypename<SurveyResponse> | string>>,
    trainingSignupLink?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['String'] | string>,
    uploadedVideos?: GraphCacheResolver<WithTypename<Mentor>, MentorUploadedVideosArgs, Array<WithTypename<UploadedVideo> | string>>,
    user?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, WithTypename<User> | string>,
    userProfileData?: GraphCacheResolver<WithTypename<Mentor>, MentorUserProfileDataArgs, Array<WithTypename<UserProfileData> | string>>,
    webappBaseUrl?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Scalars['String'] | string>,
    writtenMessages?: GraphCacheResolver<WithTypename<Mentor>, Record<string, never>, Array<WithTypename<WrittenMessage> | string>>
  },
  MentorContact?: {
    a2pSmses?: GraphCacheResolver<WithTypename<MentorContact>, Record<string, never>, Array<WithTypename<A2pSms> | string>>,
    activationStatus?: GraphCacheResolver<WithTypename<MentorContact>, Record<string, never>, ActivationStatus | string>,
    activationStatusChangedAt?: GraphCacheResolver<WithTypename<MentorContact>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    batchActionId?: GraphCacheResolver<WithTypename<MentorContact>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<MentorContact>, Record<string, never>, Scalars['ID'] | string>,
    notes?: GraphCacheResolver<WithTypename<MentorContact>, Record<string, never>, Scalars['String'] | string>,
    program?: GraphCacheResolver<WithTypename<MentorContact>, Record<string, never>, WithTypename<Program> | string>,
    registered?: GraphCacheResolver<WithTypename<MentorContact>, Record<string, never>, Scalars['Boolean'] | string>,
    uploadedBy?: GraphCacheResolver<WithTypename<MentorContact>, Record<string, never>, WithTypename<User> | string>,
    uploadedDate?: GraphCacheResolver<WithTypename<MentorContact>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    user?: GraphCacheResolver<WithTypename<MentorContact>, Record<string, never>, WithTypename<User> | string>
  },
  Mentorship?: {
    chatGroup?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, WithTypename<MentorshipChatGroup> | string>,
    combinedMenteeMentorSurveyResponses?: GraphCacheResolver<WithTypename<Mentorship>, MentorshipCombinedMenteeMentorSurveyResponsesArgs, WithTypename<SurveyResponseConnection> | string>,
    commonQualities?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Array<Scalars['String'] | string>>,
    commonQualitiesSentence?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['String'] | string>,
    conversationLogsCount?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['Int'] | string>,
    flags?: GraphCacheResolver<WithTypename<Mentorship>, MentorshipFlagsArgs, WithTypename<FlagConnection> | string>,
    id?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['ID'] | string>,
    isMatched?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['Boolean'] | string>,
    lastConversation?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, WithTypename<ConversationLog> | string>,
    matchDate?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    megaphoneGroup?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, WithTypename<MentorshipMegaphoneGroup> | string>,
    menteeSmsRelayPhoneNumber?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['String'] | string>,
    mentor?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, WithTypename<Mentor> | string>,
    mentorConversationLogs?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Array<WithTypename<ConversationLog> | string>>,
    mentorIsDisengaged?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['Boolean'] | string>,
    mentorReachedOutAt?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    mentorSmsRelayPhoneNumber?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['String'] | string>,
    score?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['Int'] | string>,
    source?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, MatchingSource | string>,
    student?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, WithTypename<Student> | string>,
    studentConversationLogs?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Array<WithTypename<ConversationLog> | string>>,
    studentIsDisengaged?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['Boolean'] | string>,
    studentReachedOutAt?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    unmatchDate?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    unmatchInitiatedBy?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['String'] | string>,
    unmatchNotes?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, Scalars['String'] | string>,
    unmatchReason?: GraphCacheResolver<WithTypename<Mentorship>, Record<string, never>, UnmatchReason | string>
  },
  MentorshipChatGroup?: {
    id?: GraphCacheResolver<WithTypename<MentorshipChatGroup>, Record<string, never>, Scalars['ID'] | string>
  },
  MentorshipConnection?: {
    edges?: GraphCacheResolver<WithTypename<MentorshipConnection>, Record<string, never>, Array<WithTypename<MentorshipEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<MentorshipConnection>, Record<string, never>, Array<WithTypename<Mentorship> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<MentorshipConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<MentorshipConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountMenteesDisengaged?: GraphCacheResolver<WithTypename<MentorshipConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountMentorsDisengaged?: GraphCacheResolver<WithTypename<MentorshipConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountUsingSmsRelay?: GraphCacheResolver<WithTypename<MentorshipConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountWithConversationInTheLast30Days?: GraphCacheResolver<WithTypename<MentorshipConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountWithThreeOrMoreConversations?: GraphCacheResolver<WithTypename<MentorshipConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountWithZeroConversations?: GraphCacheResolver<WithTypename<MentorshipConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  MentorshipCredential?: {
    credential?: GraphCacheResolver<WithTypename<MentorshipCredential>, Record<string, never>, MentorshipCredentialCredentials | string>,
    id?: GraphCacheResolver<WithTypename<MentorshipCredential>, Record<string, never>, Scalars['ID'] | string>
  },
  MentorshipEdge?: {
    cursor?: GraphCacheResolver<WithTypename<MentorshipEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<MentorshipEdge>, Record<string, never>, WithTypename<Mentorship> | string>
  },
  MentorshipMegaphoneGroup?: {
    id?: GraphCacheResolver<WithTypename<MentorshipMegaphoneGroup>, Record<string, never>, Scalars['ID'] | string>,
    isSupermentorGroup?: GraphCacheResolver<WithTypename<MentorshipMegaphoneGroup>, Record<string, never>, Scalars['Boolean'] | string>
  },
  MentorshipsMetrics?: {
    totalConversationsLogged?: GraphCacheResolver<WithTypename<MentorshipsMetrics>, MentorshipsMetricsTotalConversationsLoggedArgs, Array<WithTypename<Interval> | string>>,
    totalFirstUsedSmsRelay?: GraphCacheResolver<WithTypename<MentorshipsMetrics>, MentorshipsMetricsTotalFirstUsedSmsRelayArgs, Array<WithTypename<Interval> | string>>,
    totalLoggedMinimumNumberConversations?: GraphCacheResolver<WithTypename<MentorshipsMetrics>, MentorshipsMetricsTotalLoggedMinimumNumberConversationsArgs, Array<WithTypename<Interval> | string>>,
    totalMatched?: GraphCacheResolver<WithTypename<MentorshipsMetrics>, MentorshipsMetricsTotalMatchedArgs, Array<WithTypename<Interval> | string>>,
    totalSmsRelayMessagesSent?: GraphCacheResolver<WithTypename<MentorshipsMetrics>, MentorshipsMetricsTotalSmsRelayMessagesSentArgs, Array<WithTypename<Interval> | string>>
  },
  MessageTemplateConnection?: {
    defaultCount?: GraphCacheResolver<WithTypename<MessageTemplateConnection>, Record<string, never>, Scalars['Int'] | string>,
    edges?: GraphCacheResolver<WithTypename<MessageTemplateConnection>, Record<string, never>, Array<WithTypename<MessageTemplateEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<MessageTemplateConnection>, Record<string, never>, Array<WithTypename<EmailTemplate> | WithTypename<SmsTemplate> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<MessageTemplateConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    tagCounts?: GraphCacheResolver<WithTypename<MessageTemplateConnection>, Record<string, never>, Array<WithTypename<MessageTemplateTagCount> | string>>,
    totalCount?: GraphCacheResolver<WithTypename<MessageTemplateConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  MessageTemplateEdge?: {
    cursor?: GraphCacheResolver<WithTypename<MessageTemplateEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<MessageTemplateEdge>, Record<string, never>, WithTypename<EmailTemplate> | WithTypename<SmsTemplate> | string>
  },
  MessageTemplateTag?: {
    id?: GraphCacheResolver<WithTypename<MessageTemplateTag>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<MessageTemplateTag>, Record<string, never>, Scalars['String'] | string>
  },
  MessageTemplateTagConnection?: {
    edges?: GraphCacheResolver<WithTypename<MessageTemplateTagConnection>, Record<string, never>, Array<WithTypename<MessageTemplateTagEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<MessageTemplateTagConnection>, Record<string, never>, Array<WithTypename<MessageTemplateTag> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<MessageTemplateTagConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<MessageTemplateTagConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  MessageTemplateTagCount?: {
    count?: GraphCacheResolver<WithTypename<MessageTemplateTagCount>, Record<string, never>, Scalars['Int'] | string>,
    tag?: GraphCacheResolver<WithTypename<MessageTemplateTagCount>, Record<string, never>, WithTypename<MessageTemplateTag> | string>
  },
  MessageTemplateTagEdge?: {
    cursor?: GraphCacheResolver<WithTypename<MessageTemplateTagEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<MessageTemplateTagEdge>, Record<string, never>, WithTypename<MessageTemplateTag> | string>
  },
  MicroSurvey?: {
    expireAt?: GraphCacheResolver<WithTypename<MicroSurvey>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<MicroSurvey>, Record<string, never>, Scalars['ID'] | string>,
    startAt?: GraphCacheResolver<WithTypename<MicroSurvey>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    survey?: GraphCacheResolver<WithTypename<MicroSurvey>, Record<string, never>, WithTypename<Survey> | string>,
    targetingCriteria?: GraphCacheResolver<WithTypename<MicroSurvey>, Record<string, never>, WithTypename<MicroSurveyTargetingCriteria> | string>
  },
  MicroSurveyConnection?: {
    edges?: GraphCacheResolver<WithTypename<MicroSurveyConnection>, Record<string, never>, Array<WithTypename<MicroSurveyEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<MicroSurveyConnection>, Record<string, never>, Array<WithTypename<MicroSurvey> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<MicroSurveyConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<MicroSurveyConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  MicroSurveyEdge?: {
    cursor?: GraphCacheResolver<WithTypename<MicroSurveyEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<MicroSurveyEdge>, Record<string, never>, WithTypename<MicroSurvey> | string>
  },
  MicroSurveyTargetingCriteria?: {
    id?: GraphCacheResolver<WithTypename<MicroSurveyTargetingCriteria>, Record<string, never>, Scalars['ID'] | string>,
    participants?: GraphCacheResolver<WithTypename<MicroSurveyTargetingCriteria>, Record<string, never>, WithTypename<ParticipantsFilterCriteria> | string>
  },
  MoveParticipantsPayload?: {
    batchActionId?: GraphCacheResolver<WithTypename<MoveParticipantsPayload>, Record<string, never>, Scalars['ID'] | string>,
    errors?: GraphCacheResolver<WithTypename<MoveParticipantsPayload>, Record<string, never>, Scalars['String'] | string>
  },
  MultiSelectHardMatchQuestion?: {
    matchType?: GraphCacheResolver<WithTypename<MultiSelectHardMatchQuestion>, Record<string, never>, MultiSelectHardMatchQuestionMatch | string>,
    qid?: GraphCacheResolver<WithTypename<MultiSelectHardMatchQuestion>, Record<string, never>, Scalars['String'] | string>
  },
  NewProgramTask?: {
    assigneeEntity?: GraphCacheResolver<WithTypename<NewProgramTask>, Record<string, never>, AssigneeEntity | string>,
    behavior?: GraphCacheResolver<WithTypename<NewProgramTask>, Record<string, never>, Behavior | string>,
    displayName?: GraphCacheResolver<WithTypename<NewProgramTask>, Record<string, never>, Scalars['String'] | string>,
    enabled?: GraphCacheResolver<WithTypename<NewProgramTask>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<NewProgramTask>, Record<string, never>, Scalars['ID'] | string>,
    newTask?: GraphCacheResolver<WithTypename<NewProgramTask>, Record<string, never>, WithTypename<NewTask> | string>,
    programId?: GraphCacheResolver<WithTypename<NewProgramTask>, Record<string, never>, Scalars['ID'] | string>,
    taskAssignments?: GraphCacheResolver<WithTypename<NewProgramTask>, Record<string, never>, Array<WithTypename<AssessmentSurveyTaskAssignment> | WithTypename<ClickLinkTaskAssignment> | WithTypename<CourseTaskAssignment> | string>>
  },
  NewProgramTaskConnection?: {
    edges?: GraphCacheResolver<WithTypename<NewProgramTaskConnection>, Record<string, never>, Array<WithTypename<NewProgramTaskEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<NewProgramTaskConnection>, Record<string, never>, Array<WithTypename<NewProgramTask> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<NewProgramTaskConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<NewProgramTaskConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  NewProgramTaskEdge?: {
    cursor?: GraphCacheResolver<WithTypename<NewProgramTaskEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<NewProgramTaskEdge>, Record<string, never>, WithTypename<NewProgramTask> | string>
  },
  NewTask?: {
    context?: GraphCacheResolver<WithTypename<NewTask>, Record<string, never>, WithTypename<Context> | string>,
    defaultAssigneeEntity?: GraphCacheResolver<WithTypename<NewTask>, Record<string, never>, AssigneeEntity | string>,
    defaultDisplayName?: GraphCacheResolver<WithTypename<NewTask>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<NewTask>, Record<string, never>, Scalars['ID'] | string>,
    internalTaskName?: GraphCacheResolver<WithTypename<NewTask>, Record<string, never>, Scalars['String'] | string>,
    mentorshipCredential?: GraphCacheResolver<WithTypename<NewTask>, Record<string, never>, WithTypename<MentorshipCredential> | string>,
    requiredForMatching?: GraphCacheResolver<WithTypename<NewTask>, Record<string, never>, Scalars['Boolean'] | string>,
    segmentTags?: GraphCacheResolver<WithTypename<NewTask>, Record<string, never>, Array<NewTaskSegmentTag | string>>
  },
  NewTaskConnection?: {
    edges?: GraphCacheResolver<WithTypename<NewTaskConnection>, Record<string, never>, Array<WithTypename<NewTaskEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<NewTaskConnection>, Record<string, never>, Array<WithTypename<NewTask> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<NewTaskConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<NewTaskConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  NewTaskEdge?: {
    cursor?: GraphCacheResolver<WithTypename<NewTaskEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<NewTaskEdge>, Record<string, never>, WithTypename<NewTask> | string>
  },
  NotificationData?: {
    buttonOneText?: GraphCacheResolver<WithTypename<NotificationData>, Record<string, never>, Scalars['String'] | string>,
    displayMedium?: GraphCacheResolver<WithTypename<NotificationData>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<NotificationData>, Record<string, never>, Scalars['ID'] | string>,
    imageUrl?: GraphCacheResolver<WithTypename<NotificationData>, Record<string, never>, Scalars['String'] | string>,
    markdownBody?: GraphCacheResolver<WithTypename<NotificationData>, Record<string, never>, Scalars['String'] | string>,
    notificationViewableId?: GraphCacheResolver<WithTypename<NotificationData>, Record<string, never>, Scalars['ID'] | string>,
    notificationViewableType?: GraphCacheResolver<WithTypename<NotificationData>, Record<string, never>, Scalars['String'] | string>
  },
  ObjectChange?: {
    attribute?: GraphCacheResolver<WithTypename<ObjectChange>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<ObjectChange>, Record<string, never>, Scalars['ID'] | string>,
    newValue?: GraphCacheResolver<WithTypename<ObjectChange>, Record<string, never>, Scalars['String'] | string>,
    originalValue?: GraphCacheResolver<WithTypename<ObjectChange>, Record<string, never>, Scalars['String'] | string>
  },
  ObjectChangeset?: {
    adminAction?: GraphCacheResolver<WithTypename<ObjectChangeset>, Record<string, never>, WithTypename<AdminAction> | string>,
    changes?: GraphCacheResolver<WithTypename<ObjectChangeset>, Record<string, never>, Array<WithTypename<ObjectChange> | string>>,
    eventType?: GraphCacheResolver<WithTypename<ObjectChangeset>, Record<string, never>, ObjectChangeEvent | string>,
    id?: GraphCacheResolver<WithTypename<ObjectChangeset>, Record<string, never>, Scalars['ID'] | string>,
    trackedObject?: GraphCacheResolver<WithTypename<ObjectChangeset>, Record<string, never>, WithTypename<TrackedObject> | string>
  },
  ObjectChangesetConnection?: {
    affectedObjectTypeCounts?: GraphCacheResolver<WithTypename<ObjectChangesetConnection>, Record<string, never>, Array<WithTypename<AffectedObjectTypeCount> | string>>,
    edges?: GraphCacheResolver<WithTypename<ObjectChangesetConnection>, Record<string, never>, Array<WithTypename<ObjectChangesetEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<ObjectChangesetConnection>, Record<string, never>, Array<WithTypename<ObjectChangeset> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<ObjectChangesetConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<ObjectChangesetConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  ObjectChangesetEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ObjectChangesetEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<ObjectChangesetEdge>, Record<string, never>, WithTypename<ObjectChangeset> | string>
  },
  OmniauthCredentialLatestSession?: {
    createdAt?: GraphCacheResolver<WithTypename<OmniauthCredentialLatestSession>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    email?: GraphCacheResolver<WithTypename<OmniauthCredentialLatestSession>, Record<string, never>, Scalars['String'] | string>,
    firstName?: GraphCacheResolver<WithTypename<OmniauthCredentialLatestSession>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<OmniauthCredentialLatestSession>, Record<string, never>, Scalars['ID'] | string>,
    institutionId?: GraphCacheResolver<WithTypename<OmniauthCredentialLatestSession>, Record<string, never>, Scalars['String'] | string>,
    lastAuthAt?: GraphCacheResolver<WithTypename<OmniauthCredentialLatestSession>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    lastName?: GraphCacheResolver<WithTypename<OmniauthCredentialLatestSession>, Record<string, never>, Scalars['String'] | string>,
    omniauthCredentialId?: GraphCacheResolver<WithTypename<OmniauthCredentialLatestSession>, Record<string, never>, Scalars['ID'] | string>,
    updatedAt?: GraphCacheResolver<WithTypename<OmniauthCredentialLatestSession>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    userId?: GraphCacheResolver<WithTypename<OmniauthCredentialLatestSession>, Record<string, never>, Scalars['ID'] | string>
  },
  PageInfo?: {
    endCursor?: GraphCacheResolver<WithTypename<PageInfo>, Record<string, never>, Scalars['String'] | string>,
    hasNextPage?: GraphCacheResolver<WithTypename<PageInfo>, Record<string, never>, Scalars['Boolean'] | string>,
    hasPreviousPage?: GraphCacheResolver<WithTypename<PageInfo>, Record<string, never>, Scalars['Boolean'] | string>,
    startCursor?: GraphCacheResolver<WithTypename<PageInfo>, Record<string, never>, Scalars['String'] | string>
  },
  ParticipantConnection?: {
    edges?: GraphCacheResolver<WithTypename<ParticipantConnection>, Record<string, never>, Array<WithTypename<ParticipantEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<ParticipantConnection>, Record<string, never>, Array<WithTypename<Mentor> | WithTypename<Student> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<ParticipantConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<ParticipantConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountHavingAttendedTraining?: GraphCacheResolver<WithTypename<ParticipantConnection>, ParticipantConnectionTotalCountHavingAttendedTrainingArgs, Scalars['Int'] | string>,
    totalCountHavingCompletedMatchingSurvey?: GraphCacheResolver<WithTypename<ParticipantConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountHavingNotAttendedTraining?: GraphCacheResolver<WithTypename<ParticipantConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountHavingNotCompletedMatchingSurvey?: GraphCacheResolver<WithTypename<ParticipantConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountHavingNotSignedUpForTraining?: GraphCacheResolver<WithTypename<ParticipantConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountHavingSignedUpForTraining?: GraphCacheResolver<WithTypename<ParticipantConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountInProgramsWithTraining?: GraphCacheResolver<WithTypename<ParticipantConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountOfDistinctUsers?: GraphCacheResolver<WithTypename<ParticipantConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalPrioritizedAndPendingForRematching?: GraphCacheResolver<WithTypename<ParticipantConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  ParticipantConversationCategory?: {
    id?: GraphCacheResolver<WithTypename<ParticipantConversationCategory>, Record<string, never>, Scalars['ID'] | string>,
    identifier?: GraphCacheResolver<WithTypename<ParticipantConversationCategory>, Record<string, never>, Scalars['String'] | string>,
    label?: GraphCacheResolver<WithTypename<ParticipantConversationCategory>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<ParticipantConversationCategory>, Record<string, never>, Scalars['String'] | string>
  },
  ParticipantConversationContent?: {
    confidenceNotes?: GraphCacheResolver<WithTypename<ParticipantConversationContent>, Record<string, never>, Scalars['String'] | string>,
    confidenceScore?: GraphCacheResolver<WithTypename<ParticipantConversationContent>, Record<string, never>, Scalars['Int'] | string>,
    conversationLog?: GraphCacheResolver<WithTypename<ParticipantConversationContent>, Record<string, never>, WithTypename<ConversationLog> | string>,
    createdAt?: GraphCacheResolver<WithTypename<ParticipantConversationContent>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    flag?: GraphCacheResolver<WithTypename<ParticipantConversationContent>, Record<string, never>, WithTypename<Flag> | string>,
    id?: GraphCacheResolver<WithTypename<ParticipantConversationContent>, Record<string, never>, Scalars['ID'] | string>,
    participantConversationCategories?: GraphCacheResolver<WithTypename<ParticipantConversationContent>, Record<string, never>, Array<WithTypename<ParticipantConversationCategory> | string>>,
    participantConversationType?: GraphCacheResolver<WithTypename<ParticipantConversationContent>, Record<string, never>, ParticipantConversation | string>,
    submittedBy?: GraphCacheResolver<WithTypename<ParticipantConversationContent>, Record<string, never>, WithTypename<User> | string>
  },
  ParticipantConversationContentConnection?: {
    edges?: GraphCacheResolver<WithTypename<ParticipantConversationContentConnection>, Record<string, never>, Array<WithTypename<ParticipantConversationContentEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<ParticipantConversationContentConnection>, Record<string, never>, Array<WithTypename<ParticipantConversationContent> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<ParticipantConversationContentConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<ParticipantConversationContentConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  ParticipantConversationContentEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ParticipantConversationContentEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<ParticipantConversationContentEdge>, Record<string, never>, WithTypename<ParticipantConversationContent> | string>
  },
  ParticipantEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ParticipantEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<ParticipantEdge>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  ParticipantsFilterCriteria?: {
    availableToBeMatched?: GraphCacheResolver<WithTypename<ParticipantsFilterCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    completedMatchingSurvey?: GraphCacheResolver<WithTypename<ParticipantsFilterCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    currentlyMatched?: GraphCacheResolver<WithTypename<ParticipantsFilterCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    engaged?: GraphCacheResolver<WithTypename<ParticipantsFilterCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    everMatched?: GraphCacheResolver<WithTypename<ParticipantsFilterCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    excludeProgramIds?: GraphCacheResolver<WithTypename<ParticipantsFilterCriteria>, Record<string, never>, Array<Scalars['ID'] | string>>,
    id?: GraphCacheResolver<WithTypename<ParticipantsFilterCriteria>, Record<string, never>, Scalars['ID'] | string>,
    programIds?: GraphCacheResolver<WithTypename<ParticipantsFilterCriteria>, Record<string, never>, Array<Scalars['ID'] | string>>,
    registered?: GraphCacheResolver<WithTypename<ParticipantsFilterCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    segment?: GraphCacheResolver<WithTypename<ParticipantsFilterCriteria>, Record<string, never>, ProgramSegment | string>,
    signedUpForTraining?: GraphCacheResolver<WithTypename<ParticipantsFilterCriteria>, Record<string, never>, Scalars['Boolean'] | string>,
    type?: GraphCacheResolver<WithTypename<ParticipantsFilterCriteria>, Record<string, never>, ParticipantTypeFilter | string>
  },
  ParticipantsMetrics?: {
    totalCompletedSurveys?: GraphCacheResolver<WithTypename<ParticipantsMetrics>, ParticipantsMetricsTotalCompletedSurveysArgs, Array<WithTypename<Interval> | string>>,
    totalCredentialed?: GraphCacheResolver<WithTypename<ParticipantsMetrics>, ParticipantsMetricsTotalCredentialedArgs, Array<WithTypename<Interval> | string>>,
    totalMatched?: GraphCacheResolver<WithTypename<ParticipantsMetrics>, ParticipantsMetricsTotalMatchedArgs, Array<WithTypename<Interval> | string>>,
    totalMatchingSurveyCompleted?: GraphCacheResolver<WithTypename<ParticipantsMetrics>, ParticipantsMetricsTotalMatchingSurveyCompletedArgs, Array<WithTypename<Interval> | string>>,
    totalRegistered?: GraphCacheResolver<WithTypename<ParticipantsMetrics>, ParticipantsMetricsTotalRegisteredArgs, Array<WithTypename<Interval> | string>>,
    totalWantsMentorship?: GraphCacheResolver<WithTypename<ParticipantsMetrics>, ParticipantsMetricsTotalWantsMentorshipArgs, Array<WithTypename<Interval> | string>>
  },
  Partner?: {
    executiveHigherEdRole?: GraphCacheResolver<WithTypename<Partner>, Record<string, never>, ExecutiveHigherEdRole | string>,
    facultyHigherEdRole?: GraphCacheResolver<WithTypename<Partner>, Record<string, never>, FacultyHigherEdRole | string>,
    higherEdCategory?: GraphCacheResolver<WithTypename<Partner>, Record<string, never>, HigherEdCategory | string>,
    higherEdRole?: GraphCacheResolver<WithTypename<Partner>, Record<string, never>, HigherEdRole | string>,
    id?: GraphCacheResolver<WithTypename<Partner>, Record<string, never>, Scalars['ID'] | string>,
    organizationType?: GraphCacheResolver<WithTypename<Partner>, Record<string, never>, OrganizationType | string>,
    programSequence?: GraphCacheResolver<WithTypename<Partner>, Record<string, never>, WithTypename<ProgramSequence> | string>,
    registered?: GraphCacheResolver<WithTypename<Partner>, Record<string, never>, Scalars['Boolean'] | string>,
    staffHigherEdRole?: GraphCacheResolver<WithTypename<Partner>, Record<string, never>, StaffHigherEdRole | string>,
    user?: GraphCacheResolver<WithTypename<Partner>, Record<string, never>, WithTypename<User> | string>
  },
  PartnerConnection?: {
    edges?: GraphCacheResolver<WithTypename<PartnerConnection>, Record<string, never>, Array<WithTypename<PartnerEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<PartnerConnection>, Record<string, never>, Array<WithTypename<Partner> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<PartnerConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<PartnerConnection>, Record<string, never>, Scalars['Int'] | string>,
    totalCountOfDistinctUsers?: GraphCacheResolver<WithTypename<PartnerConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  PartnerDashboardExports?: {
    conversations?: GraphCacheResolver<WithTypename<PartnerDashboardExports>, PartnerDashboardExportsConversationsArgs, WithTypename<CsvExport> | string>,
    flags?: GraphCacheResolver<WithTypename<PartnerDashboardExports>, PartnerDashboardExportsFlagsArgs, WithTypename<CsvExport> | string>,
    mentorships?: GraphCacheResolver<WithTypename<PartnerDashboardExports>, PartnerDashboardExportsMentorshipsArgs, WithTypename<CsvExport> | string>,
    users?: GraphCacheResolver<WithTypename<PartnerDashboardExports>, PartnerDashboardExportsUsersArgs, WithTypename<CsvExport> | string>
  },
  PartnerEdge?: {
    cursor?: GraphCacheResolver<WithTypename<PartnerEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<PartnerEdge>, Record<string, never>, WithTypename<Partner> | string>
  },
  PartnerNotification?: {
    id?: GraphCacheResolver<WithTypename<PartnerNotification>, Record<string, never>, Scalars['ID'] | string>,
    partner?: GraphCacheResolver<WithTypename<PartnerNotification>, Record<string, never>, WithTypename<Partner> | string>,
    program?: GraphCacheResolver<WithTypename<PartnerNotification>, Record<string, never>, WithTypename<Program> | string>,
    sender?: GraphCacheResolver<WithTypename<PartnerNotification>, Record<string, never>, WithTypename<User> | string>
  },
  PreviewMatchingSurveyPayload?: {
    errors?: GraphCacheResolver<WithTypename<PreviewMatchingSurveyPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    menteeSurvey?: GraphCacheResolver<WithTypename<PreviewMatchingSurveyPayload>, Record<string, never>, Scalars['JSON'] | string>,
    mentorSurvey?: GraphCacheResolver<WithTypename<PreviewMatchingSurveyPayload>, Record<string, never>, Scalars['JSON'] | string>,
    previewParticipantFromSameProgram?: GraphCacheResolver<WithTypename<PreviewMatchingSurveyPayload>, Record<string, never>, Scalars['Boolean'] | string>
  },
  Profile?: {
    id?: GraphCacheResolver<WithTypename<Profile>, Record<string, never>, Scalars['ID'] | string>,
    programSpecificAttributes?: GraphCacheResolver<WithTypename<Profile>, Record<string, never>, Scalars['JSON'] | string>
  },
  ProfileAttribute?: {
    id?: GraphCacheResolver<WithTypename<ProfileAttribute>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<ProfileAttribute>, Record<string, never>, Scalars['String'] | string>,
    profileAttributeType?: GraphCacheResolver<WithTypename<ProfileAttribute>, Record<string, never>, ProfileAttributeType | string>,
    profileAttributeValues?: GraphCacheResolver<WithTypename<ProfileAttribute>, Record<string, never>, Array<WithTypename<ProfileAttributeValue> | string>>
  },
  ProfileAttributeCategory?: {
    id?: GraphCacheResolver<WithTypename<ProfileAttributeCategory>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<ProfileAttributeCategory>, Record<string, never>, Scalars['String'] | string>,
    profileAttributeCategoryItems?: GraphCacheResolver<WithTypename<ProfileAttributeCategory>, Record<string, never>, Array<WithTypename<ProfileAttributeCategoryItem> | string>>
  },
  ProfileAttributeCategoryItem?: {
    id?: GraphCacheResolver<WithTypename<ProfileAttributeCategoryItem>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<ProfileAttributeCategoryItem>, Record<string, never>, Scalars['String'] | string>,
    profileAttributeCategory?: GraphCacheResolver<WithTypename<ProfileAttributeCategoryItem>, Record<string, never>, WithTypename<ProfileAttributeCategory> | string>
  },
  ProfileAttributeValue?: {
    id?: GraphCacheResolver<WithTypename<ProfileAttributeValue>, Record<string, never>, Scalars['ID'] | string>,
    profileAttribute?: GraphCacheResolver<WithTypename<ProfileAttributeValue>, Record<string, never>, WithTypename<ProfileAttribute> | string>,
    value?: GraphCacheResolver<WithTypename<ProfileAttributeValue>, Record<string, never>, Scalars['String'] | string>
  },
  Program?: {
    accountNotes?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    active?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    activityLogs?: GraphCacheResolver<WithTypename<Program>, ProgramActivityLogsArgs, WithTypename<ActivityLogConnection> | string>,
    additionalFlagContactRecipients?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Array<WithTypename<FlagContact> | string>>,
    alertDismissals?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Array<WithTypename<ProgramAlertDismissal> | string>>,
    allowMatching?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    allowMenteeSignUp?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    allowMentorSignUp?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    allowsMenteesToPushThemselvesThroughToMatch?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    askForMenteeSidInSignup?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    asksStrongestPreferenceQuestionInMenteeMatchingSurveyAndProfileAttributesExist?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    cohorts?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Array<ProgramCohort | string>>,
    communicationMediumPreference?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Message | string>,
    contacts?: GraphCacheResolver<WithTypename<Program>, ProgramContactsArgs, WithTypename<ContactConnection> | string>,
    createdAt?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    currentPhase?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, ProgramPhase | string>,
    currentStage?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, ProgramStage | string>,
    customMessageTemplates?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Array<WithTypename<ProgramCustomMessageTemplate> | string>>,
    defaultProfileImage?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    endDate?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['ISO8601Date'] | string>,
    engagementBenchmarkData?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<EngagementBenchmarkData> | string>,
    engagementChartUrl?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    firstParticipantCreatedAt?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['ISO8601Date'] | string>,
    flagContactEmail?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    flagContactFirstName?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    flagContactLastName?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    flagPageVisits?: GraphCacheResolver<WithTypename<Program>, ProgramFlagPageVisitsArgs, WithTypename<FlagPageVisitConnection> | string>,
    hasMatchingSuveysMigratedFromOldFramework?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['ID'] | string>,
    isTemplateProgram?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    isTestProgram?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    matchingCap?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Int'] | string>,
    matchingCapReachedDate?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    matchingGoalReachedDate?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    menteeLoginMode?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, ProgramMenteeLoginMode | string>,
    mentorEndAssessmentSurvey?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<Survey> | string>,
    mentorLoginMode?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, ProgramMentorLoginMode | string>,
    mentorMatchingSurvey?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<Survey> | string>,
    mentorMidAssessmentSurvey?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<Survey> | string>,
    mentorOpeningAssessmentSurvey?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<Survey> | string>,
    mentorPointPersonEmail?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    mentorPointPersonFirstName?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    mentorPointPersonLastName?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    mentorPointPersonTitle?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    mentorPostSessionSurvey?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<Survey> | string>,
    mentorTrainingTask?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<ProgramTask> | string>,
    mentorType?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, MentorTypes | string>,
    mentors?: GraphCacheResolver<WithTypename<Program>, ProgramMentorsArgs, WithTypename<ParticipantConnection> | string>,
    mentorships?: GraphCacheResolver<WithTypename<Program>, ProgramMentorshipsArgs, WithTypename<MentorshipConnection> | string>,
    name?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    nonPriorityFlagEmailEnabled?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    notes?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    numberOfOpenMentorSlots?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Int'] | string>,
    partnerSuccessManager?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<User> | string>,
    partnerSuccessOperator?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<User> | string>,
    programAssessmentAreas?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Array<WithTypename<ProgramAssessmentArea> | string>>,
    programCustomLabel?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<ProgramCustomLabel> | string>,
    programFlagCategories?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Array<WithTypename<ProgramFlagCategory> | string>>,
    programGoal?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<ProgramGoal> | string>,
    programInfoUrl?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    programLogo?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    programProfileAttributes?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Array<WithTypename<ProgramProfileAttribute> | string>>,
    programRecruitmentAndOnboardingDashboardUrl?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    programResources?: GraphCacheResolver<WithTypename<Program>, ProgramProgramResourcesArgs, WithTypename<ProgramResourceConnection> | string>,
    programSequence?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<ProgramSequence> | string>,
    programTasks?: GraphCacheResolver<WithTypename<Program>, ProgramProgramTasksArgs, Array<WithTypename<ProgramTask> | string>>,
    programTopics?: GraphCacheResolver<WithTypename<Program>, ProgramProgramTopicsArgs, WithTypename<ProgramTopicConnection> | string>,
    reRecruitedMentorsCanSkipMatchingSurvey?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    requiredMentorTrainingCredential?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    resources?: GraphCacheResolver<WithTypename<Program>, ProgramResourcesArgs, WithTypename<ResourceConnection> | string>,
    salesforceOpportunityId?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    satisfactionBenchmarkChartUrl?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    satisfactionReport?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<SatisfactionReport> | string>,
    secondaryFlagContactCcEmails?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    segment?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, ProgramSegment | string>,
    sendFlagsToExternalContact?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    sftpExportEnabled?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    sftpPrefix?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    shareMenteeEmail?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    shareMenteePhone?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    shareMentorEmail?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    shareMentorPhone?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    shortName?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    showMatchingSurveysToPartner?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    showMentorsFlags?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>,
    startDate?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['ISO8601Date'] | string>,
    studentEndAssessmentSurvey?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<Survey> | string>,
    studentGoalsList?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Array<WithTypename<StudentGoalsList> | string>>,
    studentMatchingSurvey?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<Survey> | string>,
    studentMidAssessmentSurvey?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<Survey> | string>,
    studentOpeningAssessmentSurvey?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<Survey> | string>,
    studentPointPersonEmail?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    studentPointPersonFirstName?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    studentPointPersonLastName?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    studentPointPersonTitle?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    studentPostSessionSurvey?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<Survey> | string>,
    students?: GraphCacheResolver<WithTypename<Program>, ProgramStudentsArgs, WithTypename<ParticipantConnection> | string>,
    title?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['String'] | string>,
    trainingMode?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, ProgramTrainingMode | string>,
    universityRelationsDirector?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, WithTypename<User> | string>,
    usesNewCommunications?: GraphCacheResolver<WithTypename<Program>, Record<string, never>, Scalars['Boolean'] | string>
  },
  ProgramAlertDismissal?: {
    alertMetadata?: GraphCacheResolver<WithTypename<ProgramAlertDismissal>, Record<string, never>, Scalars['JSON'] | string>,
    alertTypeIdentifier?: GraphCacheResolver<WithTypename<ProgramAlertDismissal>, Record<string, never>, Scalars['String'] | string>,
    dismissedBy?: GraphCacheResolver<WithTypename<ProgramAlertDismissal>, Record<string, never>, WithTypename<User> | string>,
    id?: GraphCacheResolver<WithTypename<ProgramAlertDismissal>, Record<string, never>, Scalars['ID'] | string>,
    snoozeUntil?: GraphCacheResolver<WithTypename<ProgramAlertDismissal>, Record<string, never>, Scalars['ISO8601DateTime'] | string>
  },
  ProgramAssessmentArea?: {
    assessmentArea?: GraphCacheResolver<WithTypename<ProgramAssessmentArea>, Record<string, never>, WithTypename<AssessmentArea> | string>,
    enabledForMentees?: GraphCacheResolver<WithTypename<ProgramAssessmentArea>, Record<string, never>, Scalars['Boolean'] | string>,
    enabledForMentors?: GraphCacheResolver<WithTypename<ProgramAssessmentArea>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<ProgramAssessmentArea>, Record<string, never>, Scalars['ID'] | string>,
    scaleMax?: GraphCacheResolver<WithTypename<ProgramAssessmentArea>, Record<string, never>, Scalars['Int'] | string>,
    scaleMin?: GraphCacheResolver<WithTypename<ProgramAssessmentArea>, Record<string, never>, Scalars['Int'] | string>
  },
  ProgramAutomatchingConfiguration?: {
    createdAt?: GraphCacheResolver<WithTypename<ProgramAutomatchingConfiguration>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<ProgramAutomatchingConfiguration>, Record<string, never>, Scalars['ID'] | string>,
    program?: GraphCacheResolver<WithTypename<ProgramAutomatchingConfiguration>, Record<string, never>, WithTypename<Program> | string>,
    settings?: GraphCacheResolver<WithTypename<ProgramAutomatchingConfiguration>, Record<string, never>, WithTypename<SuggestedBatchSettings> | string>,
    shearwaterAdministrator?: GraphCacheResolver<WithTypename<ProgramAutomatchingConfiguration>, Record<string, never>, WithTypename<ShearwaterAdministrator> | string>,
    updatedAt?: GraphCacheResolver<WithTypename<ProgramAutomatchingConfiguration>, Record<string, never>, Scalars['ISO8601DateTime'] | string>
  },
  ProgramAutomatchingDefault?: {
    automatchingDefault?: GraphCacheResolver<WithTypename<ProgramAutomatchingDefault>, Record<string, never>, WithTypename<AutomatchingDefault> | string>,
    createdAt?: GraphCacheResolver<WithTypename<ProgramAutomatchingDefault>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<ProgramAutomatchingDefault>, Record<string, never>, Scalars['ID'] | string>,
    program?: GraphCacheResolver<WithTypename<ProgramAutomatchingDefault>, Record<string, never>, WithTypename<Program> | string>,
    shearwaterAdministrator?: GraphCacheResolver<WithTypename<ProgramAutomatchingDefault>, Record<string, never>, WithTypename<ShearwaterAdministrator> | string>,
    updatedAt?: GraphCacheResolver<WithTypename<ProgramAutomatchingDefault>, Record<string, never>, Scalars['ISO8601DateTime'] | string>
  },
  ProgramConnection?: {
    edges?: GraphCacheResolver<WithTypename<ProgramConnection>, Record<string, never>, Array<WithTypename<ProgramEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<ProgramConnection>, Record<string, never>, Array<WithTypename<Program> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<ProgramConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<ProgramConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  ProgramCustomLabel?: {
    id?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['ID'] | string>,
    pluralMentee?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    pluralMentor?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    pluralMentorship?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    pluralSchool?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    pluralStudent?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    program?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, WithTypename<Program> | string>,
    respectMenteeUppercase?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['Boolean'] | string>,
    respectMentorUppercase?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['Boolean'] | string>,
    respectMentorshipUppercase?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['Boolean'] | string>,
    respectSchoolUppercase?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['Boolean'] | string>,
    respectStudentUppercase?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['Boolean'] | string>,
    singularMentee?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    singularMenteeWithIndeterminateArticle?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    singularMentor?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    singularMentorWithIndeterminateArticle?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    singularMentorship?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    singularMentorshipWithIndeterminateArticle?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    singularSchool?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    singularSchoolWithIndeterminateArticle?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    singularStudent?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>,
    singularStudentWithIndeterminateArticle?: GraphCacheResolver<WithTypename<ProgramCustomLabel>, Record<string, never>, Scalars['String'] | string>
  },
  ProgramCustomMessageTemplate?: {
    createdAt?: GraphCacheResolver<WithTypename<ProgramCustomMessageTemplate>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    customMessageType?: GraphCacheResolver<WithTypename<ProgramCustomMessageTemplate>, Record<string, never>, ProgramCustomMessage | string>,
    id?: GraphCacheResolver<WithTypename<ProgramCustomMessageTemplate>, Record<string, never>, Scalars['ID'] | string>,
    messageTemplate?: GraphCacheResolver<WithTypename<ProgramCustomMessageTemplate>, Record<string, never>, WithTypename<EmailTemplate> | WithTypename<SmsTemplate> | string>,
    program?: GraphCacheResolver<WithTypename<ProgramCustomMessageTemplate>, Record<string, never>, WithTypename<Program> | string>,
    updatedAt?: GraphCacheResolver<WithTypename<ProgramCustomMessageTemplate>, Record<string, never>, Scalars['ISO8601DateTime'] | string>
  },
  ProgramEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ProgramEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<ProgramEdge>, Record<string, never>, WithTypename<Program> | string>
  },
  ProgramFlagCategory?: {
    customDisplayName?: GraphCacheResolver<WithTypename<ProgramFlagCategory>, Record<string, never>, Scalars['String'] | string>,
    customSmsCharacter?: GraphCacheResolver<WithTypename<ProgramFlagCategory>, Record<string, never>, Scalars['String'] | string>,
    flagCategory?: GraphCacheResolver<WithTypename<ProgramFlagCategory>, Record<string, never>, WithTypename<FlagCategory> | string>,
    id?: GraphCacheResolver<WithTypename<ProgramFlagCategory>, Record<string, never>, Scalars['ID'] | string>,
    isVisible?: GraphCacheResolver<WithTypename<ProgramFlagCategory>, Record<string, never>, Scalars['Boolean'] | string>
  },
  ProgramGoal?: {
    id?: GraphCacheResolver<WithTypename<ProgramGoal>, Record<string, never>, Scalars['ID'] | string>,
    program?: GraphCacheResolver<WithTypename<ProgramGoal>, Record<string, never>, WithTypename<Program> | string>,
    target?: GraphCacheResolver<WithTypename<ProgramGoal>, Record<string, never>, Scalars['Int'] | string>,
    type?: GraphCacheResolver<WithTypename<ProgramGoal>, Record<string, never>, ProgramGoalTypes | string>
  },
  ProgramPageVisit?: {
    createdAt?: GraphCacheResolver<WithTypename<ProgramPageVisit>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<ProgramPageVisit>, Record<string, never>, Scalars['ID'] | string>,
    path?: GraphCacheResolver<WithTypename<ProgramPageVisit>, Record<string, never>, Scalars['String'] | string>,
    program?: GraphCacheResolver<WithTypename<ProgramPageVisit>, Record<string, never>, WithTypename<Program> | string>,
    user?: GraphCacheResolver<WithTypename<ProgramPageVisit>, Record<string, never>, WithTypename<User> | string>
  },
  ProgramProfileAttribute?: {
    availableInPartnerDashboardExports?: GraphCacheResolver<WithTypename<ProgramProfileAttribute>, Record<string, never>, Scalars['Boolean'] | string>,
    availableInPartnerDashboardFilters?: GraphCacheResolver<WithTypename<ProgramProfileAttribute>, Record<string, never>, Scalars['Boolean'] | string>,
    availableInPartnerDashboardProgramIntelligenceChart?: GraphCacheResolver<WithTypename<ProgramProfileAttribute>, Record<string, never>, Scalars['Boolean'] | string>,
    defaultSettings?: GraphCacheResolver<WithTypename<ProgramProfileAttribute>, Record<string, never>, WithTypename<ProgramProfileAttributeDefaultSettings> | string>,
    id?: GraphCacheResolver<WithTypename<ProgramProfileAttribute>, Record<string, never>, Scalars['ID'] | string>,
    profileAttribute?: GraphCacheResolver<WithTypename<ProgramProfileAttribute>, Record<string, never>, WithTypename<ProfileAttribute> | string>
  },
  ProgramProfileAttributeCategoryResult?: {
    profileAttribute?: GraphCacheResolver<WithTypename<ProgramProfileAttributeCategoryResult>, Record<string, never>, WithTypename<ProfileAttribute> | string>,
    profileAttributeCategories?: GraphCacheResolver<WithTypename<ProgramProfileAttributeCategoryResult>, Record<string, never>, Array<WithTypename<ProfileAttributeCategory> | string>>
  },
  ProgramProfileAttributeDefaultSettings?: {
    availableInPartnerDashboardExports?: GraphCacheResolver<WithTypename<ProgramProfileAttributeDefaultSettings>, Record<string, never>, Scalars['Boolean'] | string>,
    availableInPartnerDashboardFilters?: GraphCacheResolver<WithTypename<ProgramProfileAttributeDefaultSettings>, Record<string, never>, Scalars['Boolean'] | string>,
    availableInPartnerDashboardProgramIntelligenceChart?: GraphCacheResolver<WithTypename<ProgramProfileAttributeDefaultSettings>, Record<string, never>, Scalars['Boolean'] | string>,
    name?: GraphCacheResolver<WithTypename<ProgramProfileAttributeDefaultSettings>, Record<string, never>, Scalars['String'] | string>
  },
  ProgramProfileAttributeUnableToBeUpdated?: {
    errors?: GraphCacheResolver<WithTypename<ProgramProfileAttributeUnableToBeUpdated>, Record<string, never>, Array<ProgramProfileAttributeUpdateError | string>>,
    programProfileAttributeId?: GraphCacheResolver<WithTypename<ProgramProfileAttributeUnableToBeUpdated>, Record<string, never>, Scalars['MCID'] | string>
  },
  ProgramResource?: {
    id?: GraphCacheResolver<WithTypename<ProgramResource>, Record<string, never>, Scalars['ID'] | string>,
    title?: GraphCacheResolver<WithTypename<ProgramResource>, Record<string, never>, Scalars['String'] | string>,
    uploadedAt?: GraphCacheResolver<WithTypename<ProgramResource>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    url?: GraphCacheResolver<WithTypename<ProgramResource>, Record<string, never>, Scalars['String'] | string>,
    user?: GraphCacheResolver<WithTypename<ProgramResource>, Record<string, never>, WithTypename<User> | string>
  },
  ProgramResourceConnection?: {
    edges?: GraphCacheResolver<WithTypename<ProgramResourceConnection>, Record<string, never>, Array<WithTypename<ProgramResourceEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<ProgramResourceConnection>, Record<string, never>, Array<WithTypename<ProgramResource> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<ProgramResourceConnection>, Record<string, never>, WithTypename<PageInfo> | string>
  },
  ProgramResourceEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ProgramResourceEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<ProgramResourceEdge>, Record<string, never>, WithTypename<ProgramResource> | string>
  },
  ProgramSequence?: {
    flagCategories?: GraphCacheResolver<WithTypename<ProgramSequence>, Record<string, never>, Array<WithTypename<FlagCategory> | string>>,
    higherEdSegment?: GraphCacheResolver<WithTypename<ProgramSequence>, Record<string, never>, ProgramSegment | string>,
    id?: GraphCacheResolver<WithTypename<ProgramSequence>, Record<string, never>, Scalars['ID'] | string>,
    kind?: GraphCacheResolver<WithTypename<ProgramSequence>, Record<string, never>, ProgramSequenceKindTypes | string>,
    menteeQuizTask?: GraphCacheResolver<WithTypename<ProgramSequence>, Record<string, never>, WithTypename<TakeExternalLinkTask> | string>,
    menteeRecruitmentLink?: GraphCacheResolver<WithTypename<ProgramSequence>, Record<string, never>, Scalars['String'] | string>,
    mentorMatchingSurvey?: GraphCacheResolver<WithTypename<ProgramSequence>, Record<string, never>, WithTypename<Survey> | string>,
    mentorRecruitmentLink?: GraphCacheResolver<WithTypename<ProgramSequence>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<ProgramSequence>, Record<string, never>, Scalars['String'] | string>,
    partners?: GraphCacheResolver<WithTypename<ProgramSequence>, ProgramSequencePartnersArgs, Array<WithTypename<Partner> | string>>,
    programs?: GraphCacheResolver<WithTypename<ProgramSequence>, Record<string, never>, Array<WithTypename<Program> | string>>,
    school?: GraphCacheResolver<WithTypename<ProgramSequence>, Record<string, never>, WithTypename<School> | string>,
    studentMatchingSurvey?: GraphCacheResolver<WithTypename<ProgramSequence>, Record<string, never>, WithTypename<Survey> | string>,
    urlSlug?: GraphCacheResolver<WithTypename<ProgramSequence>, Record<string, never>, Scalars['String'] | string>
  },
  ProgramSequenceConnection?: {
    edges?: GraphCacheResolver<WithTypename<ProgramSequenceConnection>, Record<string, never>, Array<WithTypename<ProgramSequenceEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<ProgramSequenceConnection>, Record<string, never>, Array<WithTypename<ProgramSequence> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<ProgramSequenceConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<ProgramSequenceConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  ProgramSequenceEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ProgramSequenceEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<ProgramSequenceEdge>, Record<string, never>, WithTypename<ProgramSequence> | string>
  },
  ProgramTask?: {
    id?: GraphCacheResolver<WithTypename<ProgramTask>, Record<string, never>, Scalars['ID'] | string>,
    position?: GraphCacheResolver<WithTypename<ProgramTask>, Record<string, never>, Scalars['Int'] | string>,
    programSequence?: GraphCacheResolver<WithTypename<ProgramTask>, Record<string, never>, WithTypename<ProgramSequence> | string>,
    programSpecific?: GraphCacheResolver<WithTypename<ProgramTask>, Record<string, never>, Scalars['Boolean'] | string>,
    required?: GraphCacheResolver<WithTypename<ProgramTask>, Record<string, never>, Scalars['Boolean'] | string>,
    task?: GraphCacheResolver<WithTypename<ProgramTask>, Record<string, never>, WithTypename<ScheduleTrainingTask> | WithTypename<TakeExternalLinkTask> | WithTypename<TakeSurveyTask> | WithTypename<UploadPhotoTask> | WithTypename<UploadVideoTask> | WithTypename<WatchVideoTask> | string>,
    toBeCompletedAs?: GraphCacheResolver<WithTypename<ProgramTask>, Record<string, never>, TaskParticipantRole | string>
  },
  ProgramTopic?: {
    active?: GraphCacheResolver<WithTypename<ProgramTopic>, Record<string, never>, Scalars['Boolean'] | string>,
    delayBeforeRestart?: GraphCacheResolver<WithTypename<ProgramTopic>, Record<string, never>, Scalars['Int'] | string>,
    endDate?: GraphCacheResolver<WithTypename<ProgramTopic>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    hoursBetweenOutreach?: GraphCacheResolver<WithTypename<ProgramTopic>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<ProgramTopic>, Record<string, never>, Scalars['ID'] | string>,
    lastEditedAt?: GraphCacheResolver<WithTypename<ProgramTopic>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    name?: GraphCacheResolver<WithTypename<ProgramTopic>, Record<string, never>, Scalars['String'] | string>,
    program?: GraphCacheResolver<WithTypename<ProgramTopic>, Record<string, never>, WithTypename<Program> | string>,
    startDate?: GraphCacheResolver<WithTypename<ProgramTopic>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    topic?: GraphCacheResolver<WithTypename<ProgramTopic>, Record<string, never>, WithTypename<Topic> | string>
  },
  ProgramTopicConnection?: {
    edges?: GraphCacheResolver<WithTypename<ProgramTopicConnection>, Record<string, never>, Array<WithTypename<ProgramTopicEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<ProgramTopicConnection>, Record<string, never>, Array<WithTypename<ProgramTopic> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<ProgramTopicConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<ProgramTopicConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  ProgramTopicEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ProgramTopicEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<ProgramTopicEdge>, Record<string, never>, WithTypename<ProgramTopic> | string>
  },
  QueryableMetrics?: {
    assessmentScoreResponses?: GraphCacheResolver<WithTypename<QueryableMetrics>, QueryableMetricsAssessmentScoreResponsesArgs, WithTypename<AssessmentScoreResponsesMetrics> | string>,
    contacts?: GraphCacheResolver<WithTypename<QueryableMetrics>, QueryableMetricsContactsArgs, WithTypename<ContactsMetrics> | string>,
    disengagementResolutions?: GraphCacheResolver<WithTypename<QueryableMetrics>, QueryableMetricsDisengagementResolutionsArgs, Array<WithTypename<DisengagementResolutionsMetricsResult> | string>>,
    disengagementResolutionsAverageTimeToRematch?: GraphCacheResolver<WithTypename<QueryableMetrics>, QueryableMetricsDisengagementResolutionsAverageTimeToRematchArgs, WithTypename<DisengagementResolutionsAverageTimeToRematchResult> | string>,
    flags?: GraphCacheResolver<WithTypename<QueryableMetrics>, QueryableMetricsFlagsArgs, WithTypename<FlagsMetrics> | string>,
    mentorships?: GraphCacheResolver<WithTypename<QueryableMetrics>, QueryableMetricsMentorshipsArgs, WithTypename<MentorshipsMetrics> | string>,
    participants?: GraphCacheResolver<WithTypename<QueryableMetrics>, QueryableMetricsParticipantsArgs, WithTypename<ParticipantsMetrics> | string>,
    recruitmentOpportunities?: GraphCacheResolver<WithTypename<QueryableMetrics>, QueryableMetricsRecruitmentOpportunitiesArgs, Array<WithTypename<RecruitmentOpportunitiesMetricsResult> | string>>,
    users?: GraphCacheResolver<WithTypename<QueryableMetrics>, QueryableMetricsUsersArgs, WithTypename<UsersMetrics> | string>
  },
  QuestionWeight?: {
    qid?: GraphCacheResolver<WithTypename<QuestionWeight>, Record<string, never>, Scalars['String'] | string>,
    weight?: GraphCacheResolver<WithTypename<QuestionWeight>, Record<string, never>, Scalars['Int'] | string>
  },
  ReactivateProgramAlertPayload?: {
    program?: GraphCacheResolver<WithTypename<ReactivateProgramAlertPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  RecruitmentOpportunitiesMetricsResult?: {
    attributeType?: GraphCacheResolver<WithTypename<RecruitmentOpportunitiesMetricsResult>, Record<string, never>, Scalars['String'] | string>,
    attributeValue?: GraphCacheResolver<WithTypename<RecruitmentOpportunitiesMetricsResult>, Record<string, never>, Scalars['String'] | string>,
    menteesWaiting?: GraphCacheResolver<WithTypename<RecruitmentOpportunitiesMetricsResult>, Record<string, never>, Scalars['Int'] | string>,
    mentorsCount?: GraphCacheResolver<WithTypename<RecruitmentOpportunitiesMetricsResult>, Record<string, never>, Scalars['Int'] | string>,
    mentorsGap?: GraphCacheResolver<WithTypename<RecruitmentOpportunitiesMetricsResult>, Record<string, never>, Scalars['Int'] | string>,
    mentorsOpenSlots?: GraphCacheResolver<WithTypename<RecruitmentOpportunitiesMetricsResult>, Record<string, never>, Scalars['Int'] | string>,
    strongestPreferenceDisplayValue?: GraphCacheResolver<WithTypename<RecruitmentOpportunitiesMetricsResult>, Record<string, never>, Scalars['String'] | string>,
    strongestPreferenceKey?: GraphCacheResolver<WithTypename<RecruitmentOpportunitiesMetricsResult>, Record<string, never>, Scalars['String'] | string>
  },
  RemoveMessageTemplatesTags?: {
    byFilterSelection?: GraphCacheResolver<WithTypename<RemoveMessageTemplatesTags>, RemoveMessageTemplatesTagsByFilterSelectionArgs, WithTypename<RemoveMessageTemplatesTagsByFilterSelectionPayload> | string>,
    byIds?: GraphCacheResolver<WithTypename<RemoveMessageTemplatesTags>, RemoveMessageTemplatesTagsByIdsArgs, WithTypename<RemoveMessageTemplatesTagsByIdsPayload> | string>
  },
  RemoveMessageTemplatesTagsByFilterSelectionPayload?: {
    errors?: GraphCacheResolver<WithTypename<RemoveMessageTemplatesTagsByFilterSelectionPayload>, Record<string, never>, Array<MessageTemplateTagsNotAbleToBeRemovedError | string>>,
    messageTemplates?: GraphCacheResolver<WithTypename<RemoveMessageTemplatesTagsByFilterSelectionPayload>, Record<string, never>, Array<WithTypename<EmailTemplate> | WithTypename<SmsTemplate> | string>>,
    numberOfMessageTemplatesUpdated?: GraphCacheResolver<WithTypename<RemoveMessageTemplatesTagsByFilterSelectionPayload>, Record<string, never>, Scalars['Int'] | string>
  },
  RemoveMessageTemplatesTagsByIdsPayload?: {
    errors?: GraphCacheResolver<WithTypename<RemoveMessageTemplatesTagsByIdsPayload>, Record<string, never>, Array<MessageTemplateTagsNotAbleToBeRemovedError | string>>,
    messageTemplates?: GraphCacheResolver<WithTypename<RemoveMessageTemplatesTagsByIdsPayload>, Record<string, never>, Array<WithTypename<EmailTemplate> | WithTypename<SmsTemplate> | string>>,
    numberOfMessageTemplatesUpdated?: GraphCacheResolver<WithTypename<RemoveMessageTemplatesTagsByIdsPayload>, Record<string, never>, Scalars['Int'] | string>
  },
  Resource?: {
    description?: GraphCacheResolver<WithTypename<Resource>, Record<string, never>, Scalars['String'] | string>,
    displayName?: GraphCacheResolver<WithTypename<Resource>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Resource>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<Resource>, Record<string, never>, Scalars['String'] | string>,
    resourceType?: GraphCacheResolver<WithTypename<Resource>, Record<string, never>, ResourceType | string>,
    resourceable?: GraphCacheResolver<WithTypename<Resource>, Record<string, never>, WithTypename<Resourceable> | string>,
    topics?: GraphCacheResolver<WithTypename<Resource>, Record<string, never>, Array<WithTypename<ResourceTopic> | string>>
  },
  ResourceConnection?: {
    edges?: GraphCacheResolver<WithTypename<ResourceConnection>, Record<string, never>, Array<WithTypename<ResourceEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<ResourceConnection>, Record<string, never>, Array<WithTypename<Resource> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<ResourceConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<ResourceConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  ResourceEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ResourceEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<ResourceEdge>, Record<string, never>, WithTypename<Resource> | string>
  },
  ResourceTopic?: {
    archived?: GraphCacheResolver<WithTypename<ResourceTopic>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<ResourceTopic>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<ResourceTopic>, Record<string, never>, Scalars['String'] | string>
  },
  ResourceTopicConnection?: {
    edges?: GraphCacheResolver<WithTypename<ResourceTopicConnection>, Record<string, never>, Array<WithTypename<ResourceTopicEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<ResourceTopicConnection>, Record<string, never>, Array<WithTypename<ResourceTopic> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<ResourceTopicConnection>, Record<string, never>, WithTypename<PageInfo> | string>
  },
  ResourceTopicEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ResourceTopicEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<ResourceTopicEdge>, Record<string, never>, WithTypename<ResourceTopic> | string>
  },
  S3Object?: {
    id?: GraphCacheResolver<WithTypename<S3Object>, Record<string, never>, Scalars['ID'] | string>,
    key?: GraphCacheResolver<WithTypename<S3Object>, Record<string, never>, Scalars['String'] | string>,
    keyWithoutPrefix?: GraphCacheResolver<WithTypename<S3Object>, Record<string, never>, Scalars['String'] | string>
  },
  SatisfactionAverage?: {
    mentorAverage?: GraphCacheResolver<WithTypename<SatisfactionAverage>, Record<string, never>, Scalars['Float'] | string>,
    studentAverage?: GraphCacheResolver<WithTypename<SatisfactionAverage>, Record<string, never>, Scalars['Float'] | string>
  },
  SatisfactionReport?: {
    previousProgramSatisfaction?: GraphCacheResolver<WithTypename<SatisfactionReport>, Record<string, never>, WithTypename<SatisfactionAverage> | string>,
    programSatisfaction?: GraphCacheResolver<WithTypename<SatisfactionReport>, Record<string, never>, WithTypename<SatisfactionAverage> | string>,
    segmentSatisfaction?: GraphCacheResolver<WithTypename<SatisfactionReport>, Record<string, never>, WithTypename<SatisfactionAverage> | string>
  },
  SaveBatchMatchesPayload?: {
    errors?: GraphCacheResolver<WithTypename<SaveBatchMatchesPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    suggestedBatch?: GraphCacheResolver<WithTypename<SaveBatchMatchesPayload>, Record<string, never>, WithTypename<SuggestedBatch> | string>
  },
  SaveSurveyResponsePayload?: {
    errors?: GraphCacheResolver<WithTypename<SaveSurveyResponsePayload>, Record<string, never>, Array<InvalidSurveyResponseInputError | string>>,
    response?: GraphCacheResolver<WithTypename<SaveSurveyResponsePayload>, Record<string, never>, WithTypename<SurveyResponse> | string>,
    user?: GraphCacheResolver<WithTypename<SaveSurveyResponsePayload>, Record<string, never>, WithTypename<User> | string>
  },
  SaveWrittenMessagePayload?: {
    participant?: GraphCacheResolver<WithTypename<SaveWrittenMessagePayload>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  SavedMatch?: {
    additionalProgramSortingCriteria?: GraphCacheResolver<WithTypename<SavedMatch>, Record<string, never>, Scalars['JSON'] | string>,
    adminUser?: GraphCacheResolver<WithTypename<SavedMatch>, Record<string, never>, WithTypename<User> | string>,
    autoMatchStrategy?: GraphCacheResolver<WithTypename<SavedMatch>, Record<string, never>, AutoMatchStrategy | string>,
    createdAt?: GraphCacheResolver<WithTypename<SavedMatch>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<SavedMatch>, Record<string, never>, Scalars['ID'] | string>,
    mentor?: GraphCacheResolver<WithTypename<SavedMatch>, Record<string, never>, WithTypename<Mentor> | string>,
    score?: GraphCacheResolver<WithTypename<SavedMatch>, Record<string, never>, Scalars['Int'] | string>,
    source?: GraphCacheResolver<WithTypename<SavedMatch>, Record<string, never>, MatchingSource | string>,
    student?: GraphCacheResolver<WithTypename<SavedMatch>, Record<string, never>, WithTypename<Student> | string>
  },
  SavedMatchConnection?: {
    adminUsers?: GraphCacheResolver<WithTypename<SavedMatchConnection>, Record<string, never>, Array<WithTypename<User> | string>>,
    autoMatchStrategies?: GraphCacheResolver<WithTypename<SavedMatchConnection>, Record<string, never>, Array<AutoMatchStrategy | string>>,
    edges?: GraphCacheResolver<WithTypename<SavedMatchConnection>, Record<string, never>, Array<WithTypename<SavedMatchEdge> | string>>,
    mentorSupermentorOptInTypes?: GraphCacheResolver<WithTypename<SavedMatchConnection>, Record<string, never>, Array<SupermentorOptInAnswer | string>>,
    nodes?: GraphCacheResolver<WithTypename<SavedMatchConnection>, Record<string, never>, Array<WithTypename<SavedMatch> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<SavedMatchConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<SavedMatchConnection>, Record<string, never>, Scalars['Int'] | string>,
    uniquePrograms?: GraphCacheResolver<WithTypename<SavedMatchConnection>, Record<string, never>, Array<WithTypename<Program> | string>>
  },
  SavedMatchEdge?: {
    cursor?: GraphCacheResolver<WithTypename<SavedMatchEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<SavedMatchEdge>, Record<string, never>, WithTypename<SavedMatch> | string>
  },
  ScheduleTrainingTask?: {
    calendlyUrl?: GraphCacheResolver<WithTypename<ScheduleTrainingTask>, Record<string, never>, Scalars['String'] | string>,
    customAfterCallToAction?: GraphCacheResolver<WithTypename<ScheduleTrainingTask>, Record<string, never>, Scalars['String'] | string>,
    customCallToAction?: GraphCacheResolver<WithTypename<ScheduleTrainingTask>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<ScheduleTrainingTask>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<ScheduleTrainingTask>, Record<string, never>, Scalars['String'] | string>,
    prompt?: GraphCacheResolver<WithTypename<ScheduleTrainingTask>, Record<string, never>, Scalars['String'] | string>
  },
  School?: {
    awsUsername?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Scalars['ID'] | string>,
    institutionRegion?: GraphCacheResolver<WithTypename<School>, Record<string, never>, InstitutionRegion | string>,
    institutionType?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Institution | string>,
    isMinorityServingInstitution?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Scalars['Boolean'] | string>,
    logo?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Scalars['String'] | string>,
    nameOfSchoolIdentifier?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Scalars['String'] | string>,
    omniauthCredentialLatestSessions?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Array<WithTypename<OmniauthCredentialLatestSession> | string>>,
    programSequences?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Array<WithTypename<ProgramSequence> | string>>,
    publicOrPrivate?: GraphCacheResolver<WithTypename<School>, Record<string, never>, PublicOrPrivate | string>,
    shortName?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Scalars['String'] | string>,
    ssoBrand?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Scalars['String'] | string>,
    ssoEnabled?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Scalars['Boolean'] | string>,
    ssoProviderIdentifier?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Scalars['String'] | string>,
    ssoRequiredForPartners?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Scalars['Boolean'] | string>,
    ssoTestingEnabled?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Scalars['Boolean'] | string>,
    subdomain?: GraphCacheResolver<WithTypename<School>, Record<string, never>, Scalars['String'] | string>,
    twoOrFourYear?: GraphCacheResolver<WithTypename<School>, Record<string, never>, HigherEducation | string>
  },
  SchoolConnection?: {
    edges?: GraphCacheResolver<WithTypename<SchoolConnection>, Record<string, never>, Array<WithTypename<SchoolEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<SchoolConnection>, Record<string, never>, Array<WithTypename<School> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<SchoolConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<SchoolConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  SchoolEdge?: {
    cursor?: GraphCacheResolver<WithTypename<SchoolEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<SchoolEdge>, Record<string, never>, WithTypename<School> | string>
  },
  SchoolIdentifier?: {
    id?: GraphCacheResolver<WithTypename<SchoolIdentifier>, Record<string, never>, Scalars['ID'] | string>,
    identificationString?: GraphCacheResolver<WithTypename<SchoolIdentifier>, Record<string, never>, Scalars['String'] | string>,
    providedBy?: GraphCacheResolver<WithTypename<SchoolIdentifier>, Record<string, never>, SchoolIdentifierProvider | string>,
    school?: GraphCacheResolver<WithTypename<SchoolIdentifier>, Record<string, never>, WithTypename<School> | string>
  },
  SendBulkMessageByCsvPayload?: {
    batchActionId?: GraphCacheResolver<WithTypename<SendBulkMessageByCsvPayload>, Record<string, never>, Scalars['ID'] | string>,
    errors?: GraphCacheResolver<WithTypename<SendBulkMessageByCsvPayload>, Record<string, never>, Scalars['String'] | string>,
    templateId?: GraphCacheResolver<WithTypename<SendBulkMessageByCsvPayload>, Record<string, never>, Scalars['ID'] | string>
  },
  SendPartnerNotificationsPayload?: {
    errors?: GraphCacheResolver<WithTypename<SendPartnerNotificationsPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    successRecipients?: GraphCacheResolver<WithTypename<SendPartnerNotificationsPayload>, Record<string, never>, Array<Scalars['ID'] | string>>
  },
  SendSsoTestingTemplatePayload?: {
    errors?: GraphCacheResolver<WithTypename<SendSsoTestingTemplatePayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    programSequenceId?: GraphCacheResolver<WithTypename<SendSsoTestingTemplatePayload>, Record<string, never>, Scalars['ID'] | string>
  },
  SendTestMessagePayload?: {
    errors?: GraphCacheResolver<WithTypename<SendTestMessagePayload>, Record<string, never>, Scalars['String'] | string>,
    templateId?: GraphCacheResolver<WithTypename<SendTestMessagePayload>, Record<string, never>, Scalars['ID'] | string>
  },
  SendUpdateEmailDraftForMentorshipPayload?: {
    errors?: GraphCacheResolver<WithTypename<SendUpdateEmailDraftForMentorshipPayload>, Record<string, never>, Scalars['String'] | string>,
    notice?: GraphCacheResolver<WithTypename<SendUpdateEmailDraftForMentorshipPayload>, Record<string, never>, Scalars['String'] | string>
  },
  SetupSftpPayload?: {
    isSuccess?: GraphCacheResolver<WithTypename<SetupSftpPayload>, Record<string, never>, Scalars['Boolean'] | string>,
    program?: GraphCacheResolver<WithTypename<SetupSftpPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  SftpCsvExports?: {
    csvExportInfo?: GraphCacheResolver<WithTypename<SftpCsvExports>, SftpCsvExportsCsvExportInfoArgs, WithTypename<CsvExport> | string>
  },
  ShearwaterAdministrator?: {
    asanaId?: GraphCacheResolver<WithTypename<ShearwaterAdministrator>, Record<string, never>, Scalars['ID'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<ShearwaterAdministrator>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    deactivatedAt?: GraphCacheResolver<WithTypename<ShearwaterAdministrator>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<ShearwaterAdministrator>, Record<string, never>, Scalars['ID'] | string>,
    permissions?: GraphCacheResolver<WithTypename<ShearwaterAdministrator>, Record<string, never>, Array<Permission | string>>,
    salesforceUserId?: GraphCacheResolver<WithTypename<ShearwaterAdministrator>, Record<string, never>, Scalars['ID'] | string>,
    updatedAt?: GraphCacheResolver<WithTypename<ShearwaterAdministrator>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    user?: GraphCacheResolver<WithTypename<ShearwaterAdministrator>, Record<string, never>, WithTypename<User> | string>
  },
  SingleSelectHardMatchQuestion?: {
    matchType?: GraphCacheResolver<WithTypename<SingleSelectHardMatchQuestion>, Record<string, never>, SingleSelectHardMatchQuestionMatch | string>,
    qid?: GraphCacheResolver<WithTypename<SingleSelectHardMatchQuestion>, Record<string, never>, Scalars['String'] | string>
  },
  SkeletonMessageTemplate?: {
    createdAt?: GraphCacheResolver<WithTypename<SkeletonMessageTemplate>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<SkeletonMessageTemplate>, Record<string, never>, Scalars['ID'] | string>,
    lastEditedAt?: GraphCacheResolver<WithTypename<SkeletonMessageTemplate>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    name?: GraphCacheResolver<WithTypename<SkeletonMessageTemplate>, Record<string, never>, Scalars['String'] | string>,
    templateEditorData?: GraphCacheResolver<WithTypename<SkeletonMessageTemplate>, Record<string, never>, Scalars['JSON'] | string>
  },
  SkeletonMessageTemplateConnection?: {
    edges?: GraphCacheResolver<WithTypename<SkeletonMessageTemplateConnection>, Record<string, never>, Array<WithTypename<SkeletonMessageTemplateEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<SkeletonMessageTemplateConnection>, Record<string, never>, Array<WithTypename<SkeletonMessageTemplate> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<SkeletonMessageTemplateConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<SkeletonMessageTemplateConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  SkeletonMessageTemplateEdge?: {
    cursor?: GraphCacheResolver<WithTypename<SkeletonMessageTemplateEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<SkeletonMessageTemplateEdge>, Record<string, never>, WithTypename<SkeletonMessageTemplate> | string>
  },
  SmsTemplate?: {
    archivedAt?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    category?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, MessageCategory | string>,
    content?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, Scalars['String'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    createdBy?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, WithTypename<User> | string>,
    customMessageType?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, ProgramCustomMessage | string>,
    id?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, Scalars['ID'] | string>,
    identifier?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, Scalars['String'] | string>,
    isDefault?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, Scalars['Boolean'] | string>,
    lastEditedAt?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    lastEditedBy?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, WithTypename<User> | string>,
    messageType?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, Message | string>,
    name?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, Scalars['String'] | string>,
    programSegment?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, ProgramSegment | string>,
    tags?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, Array<WithTypename<MessageTemplateTag> | string>>,
    userState?: GraphCacheResolver<WithTypename<SmsTemplate>, Record<string, never>, UserState | string>
  },
  StartFirstWaveRecruitment?: {
    byFilterSelection?: GraphCacheResolver<WithTypename<StartFirstWaveRecruitment>, StartFirstWaveRecruitmentByFilterSelectionArgs, WithTypename<StartFirstWaveRecruitmentByFilterSelectionPayload> | string>,
    byIds?: GraphCacheResolver<WithTypename<StartFirstWaveRecruitment>, StartFirstWaveRecruitmentByIdsArgs, WithTypename<StartFirstWaveRecruitmentByIdsPayload> | string>
  },
  StartFirstWaveRecruitmentByFilterSelectionPayload?: {
    errors?: GraphCacheResolver<WithTypename<StartFirstWaveRecruitmentByFilterSelectionPayload>, Record<string, never>, Array<ContactsNotAbleToBeActivatedError | string>>,
    numberOfContactsActivated?: GraphCacheResolver<WithTypename<StartFirstWaveRecruitmentByFilterSelectionPayload>, Record<string, never>, Scalars['Int'] | string>,
    program?: GraphCacheResolver<WithTypename<StartFirstWaveRecruitmentByFilterSelectionPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  StartFirstWaveRecruitmentByIdsPayload?: {
    errors?: GraphCacheResolver<WithTypename<StartFirstWaveRecruitmentByIdsPayload>, Record<string, never>, Array<ContactsNotAbleToBeActivatedError | string>>,
    numberOfContactsActivated?: GraphCacheResolver<WithTypename<StartFirstWaveRecruitmentByIdsPayload>, Record<string, never>, Scalars['Int'] | string>,
    program?: GraphCacheResolver<WithTypename<StartFirstWaveRecruitmentByIdsPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  StartSecondWaveRecruitment?: {
    byFilterSelection?: GraphCacheResolver<WithTypename<StartSecondWaveRecruitment>, StartSecondWaveRecruitmentByFilterSelectionArgs, WithTypename<StartSecondWaveRecruitmentByFilterSelectionPayload> | string>,
    byIds?: GraphCacheResolver<WithTypename<StartSecondWaveRecruitment>, StartSecondWaveRecruitmentByIdsArgs, WithTypename<StartSecondWaveRecruitmentByIdsPayload> | string>
  },
  StartSecondWaveRecruitmentByFilterSelectionPayload?: {
    errors?: GraphCacheResolver<WithTypename<StartSecondWaveRecruitmentByFilterSelectionPayload>, Record<string, never>, Array<ContactsNotAbleToBeActivatedError | string>>,
    numberOfContactsActivated?: GraphCacheResolver<WithTypename<StartSecondWaveRecruitmentByFilterSelectionPayload>, Record<string, never>, Scalars['Int'] | string>,
    program?: GraphCacheResolver<WithTypename<StartSecondWaveRecruitmentByFilterSelectionPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  StartSecondWaveRecruitmentByIdsPayload?: {
    errors?: GraphCacheResolver<WithTypename<StartSecondWaveRecruitmentByIdsPayload>, Record<string, never>, Array<ContactsNotAbleToBeActivatedError | string>>,
    numberOfContactsActivated?: GraphCacheResolver<WithTypename<StartSecondWaveRecruitmentByIdsPayload>, Record<string, never>, Scalars['Int'] | string>,
    program?: GraphCacheResolver<WithTypename<StartSecondWaveRecruitmentByIdsPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  StateMachine?: {
    id?: GraphCacheResolver<WithTypename<StateMachine>, Record<string, never>, Scalars['ID'] | string>,
    identifier?: GraphCacheResolver<WithTypename<StateMachine>, Record<string, never>, Scalars['String'] | string>,
    metadata?: GraphCacheResolver<WithTypename<StateMachine>, Record<string, never>, Scalars['JSON'] | string>,
    schema?: GraphCacheResolver<WithTypename<StateMachine>, Record<string, never>, Scalars['JSON'] | string>
  },
  StateMachineConnection?: {
    edges?: GraphCacheResolver<WithTypename<StateMachineConnection>, Record<string, never>, Array<WithTypename<StateMachineEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<StateMachineConnection>, Record<string, never>, Array<WithTypename<StateMachine> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<StateMachineConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<StateMachineConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  StateMachineEdge?: {
    cursor?: GraphCacheResolver<WithTypename<StateMachineEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<StateMachineEdge>, Record<string, never>, WithTypename<StateMachine> | string>
  },
  StopRecruitment?: {
    byFilterSelection?: GraphCacheResolver<WithTypename<StopRecruitment>, StopRecruitmentByFilterSelectionArgs, WithTypename<StopRecruitmentByFilterSelectionPayload> | string>,
    byIds?: GraphCacheResolver<WithTypename<StopRecruitment>, StopRecruitmentByIdsArgs, WithTypename<StopRecruitmentByIdsPayload> | string>
  },
  StopRecruitmentByFilterSelectionPayload?: {
    errors?: GraphCacheResolver<WithTypename<StopRecruitmentByFilterSelectionPayload>, Record<string, never>, Array<ContactsNotAbleToBeDeactivatedError | string>>,
    numberOfContactsDeactivated?: GraphCacheResolver<WithTypename<StopRecruitmentByFilterSelectionPayload>, Record<string, never>, Scalars['Int'] | string>,
    program?: GraphCacheResolver<WithTypename<StopRecruitmentByFilterSelectionPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  StopRecruitmentByIdsPayload?: {
    errors?: GraphCacheResolver<WithTypename<StopRecruitmentByIdsPayload>, Record<string, never>, Array<ContactsNotAbleToBeDeactivatedError | string>>,
    numberOfContactsDeactivated?: GraphCacheResolver<WithTypename<StopRecruitmentByIdsPayload>, Record<string, never>, Scalars['Int'] | string>,
    program?: GraphCacheResolver<WithTypename<StopRecruitmentByIdsPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  Student?: {
    activityLogs?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Array<WithTypename<TookTypeformSurveyLog> | WithTypename<TrainingEventLog> | WithTypename<WatchedCommunityVideoLog> | WithTypename<WatchedVideoLog> | string>>,
    avatar?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['String'] | string>,
    avatarImage?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, WithTypename<Image> | string>,
    cachedUserProfileData?: GraphCacheResolver<WithTypename<Student>, StudentCachedUserProfileDataArgs, Array<WithTypename<CachedUserProfileDataAttributeValue> | string>>,
    completedMatchingSurveyAt?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    createdAt?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    deregisterDate?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    deregistrationStatusEvents?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Array<WithTypename<DeregistrationStatusEvent> | string>>,
    desiredMentoringSupport?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Array<Scalars['String'] | string>>,
    goals?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Array<WithTypename<StudentGoal> | string>>,
    id?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['ID'] | string>,
    matchingLabels?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Array<WithTypename<MatchingLabel> | string>>,
    mentorships?: GraphCacheResolver<WithTypename<Student>, StudentMentorshipsArgs, Array<WithTypename<Mentorship> | string>>,
    notes?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['String'] | string>,
    participantMentorships?: GraphCacheResolver<WithTypename<Student>, StudentParticipantMentorshipsArgs, WithTypename<MentorshipConnection> | string>,
    prioritizedAndPendingForRematching?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['Boolean'] | string>,
    program?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, WithTypename<Program> | string>,
    programGoal?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['String'] | string>,
    pushedThroughToMatch?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['Boolean'] | string>,
    questionForMentor?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['String'] | string>,
    registered?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['Boolean'] | string>,
    registrationDate?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    rematchDate?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    savedMatches?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Array<WithTypename<SavedMatch> | string>>,
    supermentorOptIn?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['String'] | string>,
    surveyResponses?: GraphCacheResolver<WithTypename<Student>, StudentSurveyResponsesArgs, Array<WithTypename<SurveyResponse> | string>>,
    uploadedVideos?: GraphCacheResolver<WithTypename<Student>, StudentUploadedVideosArgs, Array<WithTypename<UploadedVideo> | string>>,
    user?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, WithTypename<User> | string>,
    userProfileData?: GraphCacheResolver<WithTypename<Student>, StudentUserProfileDataArgs, Array<WithTypename<UserProfileData> | string>>,
    webappBaseUrl?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Scalars['String'] | string>,
    writtenMessages?: GraphCacheResolver<WithTypename<Student>, Record<string, never>, Array<WithTypename<WrittenMessage> | string>>
  },
  StudentContact?: {
    a2pSmses?: GraphCacheResolver<WithTypename<StudentContact>, Record<string, never>, Array<WithTypename<A2pSms> | string>>,
    activationStatus?: GraphCacheResolver<WithTypename<StudentContact>, Record<string, never>, ActivationStatus | string>,
    activationStatusChangedAt?: GraphCacheResolver<WithTypename<StudentContact>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    batchActionId?: GraphCacheResolver<WithTypename<StudentContact>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<StudentContact>, Record<string, never>, Scalars['ID'] | string>,
    notes?: GraphCacheResolver<WithTypename<StudentContact>, Record<string, never>, Scalars['String'] | string>,
    program?: GraphCacheResolver<WithTypename<StudentContact>, Record<string, never>, WithTypename<Program> | string>,
    registered?: GraphCacheResolver<WithTypename<StudentContact>, Record<string, never>, Scalars['Boolean'] | string>,
    uploadedBy?: GraphCacheResolver<WithTypename<StudentContact>, Record<string, never>, WithTypename<User> | string>,
    uploadedDate?: GraphCacheResolver<WithTypename<StudentContact>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    user?: GraphCacheResolver<WithTypename<StudentContact>, Record<string, never>, WithTypename<User> | string>
  },
  StudentGoal?: {
    answer?: GraphCacheResolver<WithTypename<StudentGoal>, Record<string, never>, WithTypename<SurveyAnswer> | string>,
    answerKey?: GraphCacheResolver<WithTypename<StudentGoal>, Record<string, never>, Scalars['String'] | string>,
    answerText?: GraphCacheResolver<WithTypename<StudentGoal>, Record<string, never>, Scalars['String'] | string>,
    goal?: GraphCacheResolver<WithTypename<StudentGoal>, Record<string, never>, WithTypename<Goal> | string>,
    id?: GraphCacheResolver<WithTypename<StudentGoal>, Record<string, never>, Scalars['ID'] | string>
  },
  StudentGoalsList?: {
    answerKey?: GraphCacheResolver<WithTypename<StudentGoalsList>, Record<string, never>, Scalars['String'] | string>,
    answerText?: GraphCacheResolver<WithTypename<StudentGoalsList>, Record<string, never>, Scalars['String'] | string>
  },
  SuggestedBatch?: {
    adminUser?: GraphCacheResolver<WithTypename<SuggestedBatch>, Record<string, never>, WithTypename<User> | string>,
    createdAt?: GraphCacheResolver<WithTypename<SuggestedBatch>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<SuggestedBatch>, Record<string, never>, Scalars['ID'] | string>,
    overview?: GraphCacheResolver<WithTypename<SuggestedBatch>, Record<string, never>, Scalars['JSON'] | string>,
    program?: GraphCacheResolver<WithTypename<SuggestedBatch>, Record<string, never>, WithTypename<Program> | string>,
    settings?: GraphCacheResolver<WithTypename<SuggestedBatch>, Record<string, never>, WithTypename<SuggestedBatchSettings> | string>,
    status?: GraphCacheResolver<WithTypename<SuggestedBatch>, Record<string, never>, SuggestedBatchStatus | string>,
    strategyType?: GraphCacheResolver<WithTypename<SuggestedBatch>, Record<string, never>, AutoMatchStrategy | string>
  },
  SuggestedBatchConnection?: {
    edges?: GraphCacheResolver<WithTypename<SuggestedBatchConnection>, Record<string, never>, Array<WithTypename<SuggestedBatchEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<SuggestedBatchConnection>, Record<string, never>, Array<WithTypename<SuggestedBatch> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<SuggestedBatchConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<SuggestedBatchConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  SuggestedBatchEdge?: {
    cursor?: GraphCacheResolver<WithTypename<SuggestedBatchEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<SuggestedBatchEdge>, Record<string, never>, WithTypename<SuggestedBatch> | string>
  },
  SuggestedBatchSettings?: {
    autoMatchingSettings?: GraphCacheResolver<WithTypename<SuggestedBatchSettings>, Record<string, never>, WithTypename<AutoMatchSettings> | string>,
    groupMatchingSettings?: GraphCacheResolver<WithTypename<SuggestedBatchSettings>, Record<string, never>, WithTypename<GroupMatchingSettings> | string>,
    matchingCriteria?: GraphCacheResolver<WithTypename<SuggestedBatchSettings>, Record<string, never>, WithTypename<MatchingCriteria> | string>,
    programId?: GraphCacheResolver<WithTypename<SuggestedBatchSettings>, Record<string, never>, Scalars['ID'] | string>,
    questionsWeights?: GraphCacheResolver<WithTypename<SuggestedBatchSettings>, Record<string, never>, Array<WithTypename<QuestionWeight> | string>>
  },
  SuggestedMatch?: {
    createdAt?: GraphCacheResolver<WithTypename<SuggestedMatch>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<SuggestedMatch>, Record<string, never>, Scalars['ID'] | string>,
    matchScore?: GraphCacheResolver<WithTypename<SuggestedMatch>, Record<string, never>, Scalars['Float'] | string>,
    mentor?: GraphCacheResolver<WithTypename<SuggestedMatch>, Record<string, never>, WithTypename<Mentor> | string>,
    student?: GraphCacheResolver<WithTypename<SuggestedMatch>, Record<string, never>, WithTypename<Student> | string>,
    suggestedBatch?: GraphCacheResolver<WithTypename<SuggestedMatch>, Record<string, never>, WithTypename<SuggestedBatch> | string>
  },
  SuggestedMatchConnection?: {
    edges?: GraphCacheResolver<WithTypename<SuggestedMatchConnection>, Record<string, never>, Array<WithTypename<SuggestedMatchEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<SuggestedMatchConnection>, Record<string, never>, Array<WithTypename<SuggestedMatch> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<SuggestedMatchConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<SuggestedMatchConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  SuggestedMatchEdge?: {
    cursor?: GraphCacheResolver<WithTypename<SuggestedMatchEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<SuggestedMatchEdge>, Record<string, never>, WithTypename<SuggestedMatch> | string>
  },
  SupportServiceResource?: {
    additionalInfo?: GraphCacheResolver<WithTypename<SupportServiceResource>, Record<string, never>, Scalars['String'] | string>,
    address?: GraphCacheResolver<WithTypename<SupportServiceResource>, Record<string, never>, Scalars['String'] | string>,
    categories?: GraphCacheResolver<WithTypename<SupportServiceResource>, Record<string, never>, Array<SupportServiceCategory | string>>,
    contactEmail?: GraphCacheResolver<WithTypename<SupportServiceResource>, Record<string, never>, Scalars['String'] | string>,
    contactName?: GraphCacheResolver<WithTypename<SupportServiceResource>, Record<string, never>, Scalars['String'] | string>,
    contactPhone?: GraphCacheResolver<WithTypename<SupportServiceResource>, Record<string, never>, Scalars['String'] | string>,
    description?: GraphCacheResolver<WithTypename<SupportServiceResource>, Record<string, never>, Scalars['String'] | string>,
    email?: GraphCacheResolver<WithTypename<SupportServiceResource>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<SupportServiceResource>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<SupportServiceResource>, Record<string, never>, Scalars['String'] | string>,
    phone?: GraphCacheResolver<WithTypename<SupportServiceResource>, Record<string, never>, Scalars['String'] | string>,
    url?: GraphCacheResolver<WithTypename<SupportServiceResource>, Record<string, never>, Scalars['String'] | string>
  },
  Survey?: {
    archived?: GraphCacheResolver<WithTypename<Survey>, Record<string, never>, Scalars['Boolean'] | string>,
    description?: GraphCacheResolver<WithTypename<Survey>, SurveyDescriptionArgs, Scalars['String'] | string>,
    hasResponses?: GraphCacheResolver<WithTypename<Survey>, SurveyHasResponsesArgs, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<Survey>, Record<string, never>, Scalars['ID'] | string>,
    migrated?: GraphCacheResolver<WithTypename<Survey>, Record<string, never>, Scalars['Boolean'] | string>,
    name?: GraphCacheResolver<WithTypename<Survey>, Record<string, never>, Scalars['String'] | string>,
    questions?: GraphCacheResolver<WithTypename<Survey>, SurveyQuestionsArgs, Array<WithTypename<SurveyQuestion> | string>>,
    surveyType?: GraphCacheResolver<WithTypename<Survey>, Record<string, never>, SurveyType | string>
  },
  SurveyAnswer?: {
    answerJson?: GraphCacheResolver<WithTypename<SurveyAnswer>, Record<string, never>, Scalars['JSON'] | string>,
    id?: GraphCacheResolver<WithTypename<SurveyAnswer>, Record<string, never>, Scalars['ID'] | string>,
    question?: GraphCacheResolver<WithTypename<SurveyAnswer>, Record<string, never>, WithTypename<SurveyQuestion> | string>
  },
  SurveyConnection?: {
    edges?: GraphCacheResolver<WithTypename<SurveyConnection>, Record<string, never>, Array<WithTypename<SurveyEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<SurveyConnection>, Record<string, never>, Array<WithTypename<Survey> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<SurveyConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<SurveyConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  SurveyEdge?: {
    cursor?: GraphCacheResolver<WithTypename<SurveyEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<SurveyEdge>, Record<string, never>, WithTypename<Survey> | string>
  },
  SurveyQuestion?: {
    createdInAdminTool?: GraphCacheResolver<WithTypename<SurveyQuestion>, Record<string, never>, Scalars['Boolean'] | string>,
    customizationOptions?: GraphCacheResolver<WithTypename<SurveyQuestion>, Record<string, never>, Array<WithTypename<SurveyQuestionCustomizationOption> | string>>,
    customizations?: GraphCacheResolver<WithTypename<SurveyQuestion>, Record<string, never>, Scalars['JSON'] | string>,
    id?: GraphCacheResolver<WithTypename<SurveyQuestion>, Record<string, never>, Scalars['ID'] | string>,
    index?: GraphCacheResolver<WithTypename<SurveyQuestion>, Record<string, never>, Scalars['Int'] | string>,
    isBaseQuestion?: GraphCacheResolver<WithTypename<SurveyQuestion>, Record<string, never>, Scalars['Boolean'] | string>,
    optional?: GraphCacheResolver<WithTypename<SurveyQuestion>, Record<string, never>, Scalars['Boolean'] | string>,
    qid?: GraphCacheResolver<WithTypename<SurveyQuestion>, Record<string, never>, Scalars['String'] | string>,
    questionMdDisplay?: GraphCacheResolver<WithTypename<SurveyQuestion>, Record<string, never>, WithTypename<SurveyQuestionMdDisplay> | string>,
    template?: GraphCacheResolver<WithTypename<SurveyQuestion>, Record<string, never>, WithTypename<SurveyQuestionTemplate> | string>
  },
  SurveyQuestionCustomizationOption?: {
    id?: GraphCacheResolver<WithTypename<SurveyQuestionCustomizationOption>, Record<string, never>, Scalars['ID'] | string>,
    text?: GraphCacheResolver<WithTypename<SurveyQuestionCustomizationOption>, Record<string, never>, Scalars['String'] | string>
  },
  SurveyQuestionMdDisplay?: {
    displayName?: GraphCacheResolver<WithTypename<SurveyQuestionMdDisplay>, Record<string, never>, Scalars['String'] | string>,
    displayOnMatchingDashboard?: GraphCacheResolver<WithTypename<SurveyQuestionMdDisplay>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<SurveyQuestionMdDisplay>, Record<string, never>, Scalars['ID'] | string>,
    question?: GraphCacheResolver<WithTypename<SurveyQuestionMdDisplay>, Record<string, never>, WithTypename<SurveyQuestion> | string>,
    sortable?: GraphCacheResolver<WithTypename<SurveyQuestionMdDisplay>, Record<string, never>, Scalars['Boolean'] | string>
  },
  SurveyQuestionRestrictedOption?: {
    id?: GraphCacheResolver<WithTypename<SurveyQuestionRestrictedOption>, Record<string, never>, Scalars['String'] | string>,
    label?: GraphCacheResolver<WithTypename<SurveyQuestionRestrictedOption>, Record<string, never>, Scalars['String'] | string>
  },
  SurveyQuestionRestrictedOptionConnection?: {
    edges?: GraphCacheResolver<WithTypename<SurveyQuestionRestrictedOptionConnection>, Record<string, never>, Array<WithTypename<SurveyQuestionRestrictedOptionEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<SurveyQuestionRestrictedOptionConnection>, Record<string, never>, Array<WithTypename<SurveyQuestionRestrictedOption> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<SurveyQuestionRestrictedOptionConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<SurveyQuestionRestrictedOptionConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  SurveyQuestionRestrictedOptionEdge?: {
    cursor?: GraphCacheResolver<WithTypename<SurveyQuestionRestrictedOptionEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<SurveyQuestionRestrictedOptionEdge>, Record<string, never>, WithTypename<SurveyQuestionRestrictedOption> | string>
  },
  SurveyQuestionTemplate?: {
    id?: GraphCacheResolver<WithTypename<SurveyQuestionTemplate>, Record<string, never>, Scalars['ID'] | string>,
    templateId?: GraphCacheResolver<WithTypename<SurveyQuestionTemplate>, Record<string, never>, SurveyQuestionTemplateId | string>
  },
  SurveyResponse?: {
    answers?: GraphCacheResolver<WithTypename<SurveyResponse>, SurveyResponseAnswersArgs, Array<WithTypename<SurveyAnswer> | string>>,
    context?: GraphCacheResolver<WithTypename<SurveyResponse>, Record<string, never>, WithTypename<SurveyResponseContext> | string>,
    id?: GraphCacheResolver<WithTypename<SurveyResponse>, Record<string, never>, Scalars['ID'] | string>,
    mentorship?: GraphCacheResolver<WithTypename<SurveyResponse>, Record<string, never>, WithTypename<Mentorship> | string>,
    participant?: GraphCacheResolver<WithTypename<SurveyResponse>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>,
    submittedAt?: GraphCacheResolver<WithTypename<SurveyResponse>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    survey?: GraphCacheResolver<WithTypename<SurveyResponse>, Record<string, never>, WithTypename<Survey> | string>,
    surveyResponseAnswerStrings?: GraphCacheResolver<WithTypename<SurveyResponse>, SurveyResponseSurveyResponseAnswerStringsArgs, Array<WithTypename<SurveyResponseAnswerStrings> | string>>
  },
  SurveyResponseAnswerStrings?: {
    answerString?: GraphCacheResolver<WithTypename<SurveyResponseAnswerStrings>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<SurveyResponseAnswerStrings>, Record<string, never>, Scalars['ID'] | string>,
    qid?: GraphCacheResolver<WithTypename<SurveyResponseAnswerStrings>, Record<string, never>, Scalars['String'] | string>,
    questionPrompt?: GraphCacheResolver<WithTypename<SurveyResponseAnswerStrings>, Record<string, never>, Scalars['String'] | string>,
    subprompt?: GraphCacheResolver<WithTypename<SurveyResponseAnswerStrings>, Record<string, never>, Scalars['String'] | string>,
    surveyResponseAnswerId?: GraphCacheResolver<WithTypename<SurveyResponseAnswerStrings>, Record<string, never>, Scalars['ID'] | string>
  },
  SurveyResponseConnection?: {
    edges?: GraphCacheResolver<WithTypename<SurveyResponseConnection>, Record<string, never>, Array<WithTypename<SurveyResponseEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<SurveyResponseConnection>, Record<string, never>, Array<WithTypename<SurveyResponse> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<SurveyResponseConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<SurveyResponseConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  SurveyResponseContext?: {
    mentorshipChatGroupId?: GraphCacheResolver<WithTypename<SurveyResponseContext>, Record<string, never>, Scalars['ID'] | string>,
    mentorshipId?: GraphCacheResolver<WithTypename<SurveyResponseContext>, Record<string, never>, Scalars['ID'] | string>,
    participantId?: GraphCacheResolver<WithTypename<SurveyResponseContext>, Record<string, never>, Scalars['ID'] | string>
  },
  SurveyResponseEdge?: {
    cursor?: GraphCacheResolver<WithTypename<SurveyResponseEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<SurveyResponseEdge>, Record<string, never>, WithTypename<SurveyResponse> | string>
  },
  TakeExternalLinkTask?: {
    customAfterCallToAction?: GraphCacheResolver<WithTypename<TakeExternalLinkTask>, Record<string, never>, Scalars['String'] | string>,
    customCallToAction?: GraphCacheResolver<WithTypename<TakeExternalLinkTask>, Record<string, never>, Scalars['String'] | string>,
    externalLink?: GraphCacheResolver<WithTypename<TakeExternalLinkTask>, Record<string, never>, WithTypename<ExternalLink> | string>,
    id?: GraphCacheResolver<WithTypename<TakeExternalLinkTask>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<TakeExternalLinkTask>, Record<string, never>, Scalars['String'] | string>,
    prompt?: GraphCacheResolver<WithTypename<TakeExternalLinkTask>, Record<string, never>, Scalars['String'] | string>
  },
  TakeSurveyTask?: {
    customAfterCallToAction?: GraphCacheResolver<WithTypename<TakeSurveyTask>, Record<string, never>, Scalars['String'] | string>,
    customCallToAction?: GraphCacheResolver<WithTypename<TakeSurveyTask>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<TakeSurveyTask>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<TakeSurveyTask>, Record<string, never>, Scalars['String'] | string>,
    prompt?: GraphCacheResolver<WithTypename<TakeSurveyTask>, Record<string, never>, Scalars['String'] | string>,
    survey?: GraphCacheResolver<WithTypename<TakeSurveyTask>, Record<string, never>, WithTypename<Survey> | string>
  },
  TaskConnection?: {
    edges?: GraphCacheResolver<WithTypename<TaskConnection>, Record<string, never>, Array<WithTypename<TaskEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<TaskConnection>, Record<string, never>, Array<WithTypename<ScheduleTrainingTask> | WithTypename<TakeExternalLinkTask> | WithTypename<TakeSurveyTask> | WithTypename<UploadPhotoTask> | WithTypename<UploadVideoTask> | WithTypename<WatchVideoTask> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<TaskConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<TaskConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  TaskEdge?: {
    cursor?: GraphCacheResolver<WithTypename<TaskEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<TaskEdge>, Record<string, never>, WithTypename<ScheduleTrainingTask> | WithTypename<TakeExternalLinkTask> | WithTypename<TakeSurveyTask> | WithTypename<UploadPhotoTask> | WithTypename<UploadVideoTask> | WithTypename<WatchVideoTask> | string>
  },
  TookTypeformSurveyLog?: {
    externalLink?: GraphCacheResolver<WithTypename<TookTypeformSurveyLog>, Record<string, never>, WithTypename<ExternalLink> | string>,
    id?: GraphCacheResolver<WithTypename<TookTypeformSurveyLog>, Record<string, never>, Scalars['ID'] | string>,
    loggedAtDate?: GraphCacheResolver<WithTypename<TookTypeformSurveyLog>, Record<string, never>, Scalars['ISO8601DateTime'] | string>
  },
  Topic?: {
    archivedAt?: GraphCacheResolver<WithTypename<Topic>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    category?: GraphCacheResolver<WithTypename<Topic>, Record<string, never>, TopicCategory | string>,
    hoursDelayBeforeRestart?: GraphCacheResolver<WithTypename<Topic>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<Topic>, Record<string, never>, Scalars['ID'] | string>,
    isDefault?: GraphCacheResolver<WithTypename<Topic>, Record<string, never>, Scalars['Boolean'] | string>,
    name?: GraphCacheResolver<WithTypename<Topic>, Record<string, never>, Scalars['String'] | string>,
    priority?: GraphCacheResolver<WithTypename<Topic>, Record<string, never>, Scalars['Float'] | string>,
    programSegment?: GraphCacheResolver<WithTypename<Topic>, Record<string, never>, ProgramSegment | string>,
    programTopics?: GraphCacheResolver<WithTypename<Topic>, TopicProgramTopicsArgs, WithTypename<ProgramTopicConnection> | string>,
    topicConditions?: GraphCacheResolver<WithTypename<Topic>, Record<string, never>, Array<WithTypename<TopicCondition> | string>>,
    topicMessages?: GraphCacheResolver<WithTypename<Topic>, Record<string, never>, Array<WithTypename<TopicMessage> | string>>,
    userState?: GraphCacheResolver<WithTypename<Topic>, Record<string, never>, UserState | string>
  },
  TopicCollection?: {
    key?: GraphCacheResolver<WithTypename<TopicCollection>, Record<string, never>, Scalars['String'] | string>,
    topics?: GraphCacheResolver<WithTypename<TopicCollection>, TopicCollectionTopicsArgs, WithTypename<TopicConnection> | string>
  },
  TopicCondition?: {
    id?: GraphCacheResolver<WithTypename<TopicCondition>, Record<string, never>, Scalars['ID'] | string>,
    key?: GraphCacheResolver<WithTypename<TopicCondition>, Record<string, never>, TopicConditionKey | string>,
    topics?: GraphCacheResolver<WithTypename<TopicCondition>, Record<string, never>, Array<WithTypename<Topic> | string>>,
    value?: GraphCacheResolver<WithTypename<TopicCondition>, Record<string, never>, Scalars['Boolean'] | string>
  },
  TopicConnection?: {
    edges?: GraphCacheResolver<WithTypename<TopicConnection>, Record<string, never>, Array<WithTypename<TopicEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<TopicConnection>, Record<string, never>, Array<WithTypename<Topic> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<TopicConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<TopicConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  TopicEdge?: {
    cursor?: GraphCacheResolver<WithTypename<TopicEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<TopicEdge>, Record<string, never>, WithTypename<Topic> | string>
  },
  TopicMessage?: {
    emailTemplate?: GraphCacheResolver<WithTypename<TopicMessage>, Record<string, never>, WithTypename<EmailTemplate> | string>,
    hoursDelayAfterMessage?: GraphCacheResolver<WithTypename<TopicMessage>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<TopicMessage>, Record<string, never>, Scalars['ID'] | string>,
    index?: GraphCacheResolver<WithTypename<TopicMessage>, Record<string, never>, Scalars['Int'] | string>,
    preferredMedium?: GraphCacheResolver<WithTypename<TopicMessage>, Record<string, never>, Message | string>,
    smsTemplate?: GraphCacheResolver<WithTypename<TopicMessage>, Record<string, never>, WithTypename<SmsTemplate> | string>
  },
  TrainingEventLog?: {
    id?: GraphCacheResolver<WithTypename<TrainingEventLog>, Record<string, never>, Scalars['ID'] | string>,
    kind?: GraphCacheResolver<WithTypename<TrainingEventLog>, Record<string, never>, TrainingEvent | string>,
    loggedAtDate?: GraphCacheResolver<WithTypename<TrainingEventLog>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    participant?: GraphCacheResolver<WithTypename<TrainingEventLog>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  UnmatchParticipantPayload?: {
    errors?: GraphCacheResolver<WithTypename<UnmatchParticipantPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    mentorship?: GraphCacheResolver<WithTypename<UnmatchParticipantPayload>, Record<string, never>, WithTypename<Mentorship> | string>,
    participant?: GraphCacheResolver<WithTypename<UnmatchParticipantPayload>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  UnmatchParticipantsPayload?: {
    batchActionId?: GraphCacheResolver<WithTypename<UnmatchParticipantsPayload>, Record<string, never>, Scalars['ID'] | string>,
    errors?: GraphCacheResolver<WithTypename<UnmatchParticipantsPayload>, Record<string, never>, Scalars['String'] | string>
  },
  UpdateAssessmentSurveyNewProgramTaskPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateAssessmentSurveyNewProgramTaskPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    newProgramTask?: GraphCacheResolver<WithTypename<UpdateAssessmentSurveyNewProgramTaskPayload>, Record<string, never>, WithTypename<NewProgramTask> | string>
  },
  UpdateClickLinkNewProgramTaskPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateClickLinkNewProgramTaskPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    newProgramTask?: GraphCacheResolver<WithTypename<UpdateClickLinkNewProgramTaskPayload>, Record<string, never>, WithTypename<NewProgramTask> | string>
  },
  UpdateClickLinkNewTaskPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateClickLinkNewTaskPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    newTask?: GraphCacheResolver<WithTypename<UpdateClickLinkNewTaskPayload>, Record<string, never>, WithTypename<NewTask> | string>
  },
  UpdateCourseNewProgramTaskPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateCourseNewProgramTaskPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    newProgramTask?: GraphCacheResolver<WithTypename<UpdateCourseNewProgramTaskPayload>, Record<string, never>, WithTypename<NewProgramTask> | string>
  },
  UpdateCourseNewTaskPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateCourseNewTaskPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    newTask?: GraphCacheResolver<WithTypename<UpdateCourseNewTaskPayload>, Record<string, never>, WithTypename<NewTask> | string>
  },
  UpdateEmailTemplatePayload?: {
    emailTemplate?: GraphCacheResolver<WithTypename<UpdateEmailTemplatePayload>, Record<string, never>, WithTypename<EmailTemplate> | string>
  },
  UpdateFlagContactPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateFlagContactPayload>, Record<string, never>, Array<InvalidFlagContactInputError | string>>,
    flagContact?: GraphCacheResolver<WithTypename<UpdateFlagContactPayload>, Record<string, never>, WithTypename<FlagContact> | string>
  },
  UpdateFlagPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateFlagPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    flag?: GraphCacheResolver<WithTypename<UpdateFlagPayload>, Record<string, never>, WithTypename<Flag> | string>
  },
  UpdateMenteeMentorSettingsError?: {
    message?: GraphCacheResolver<WithTypename<UpdateMenteeMentorSettingsError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<UpdateMenteeMentorSettingsError>, Record<string, never>, UpdateMenteeMentorSettingsErrorPaths | string>
  },
  UpdateMenteeMentorSettingsPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateMenteeMentorSettingsPayload>, Record<string, never>, Array<WithTypename<UpdateMenteeMentorSettingsError> | string>>,
    program?: GraphCacheResolver<WithTypename<UpdateMenteeMentorSettingsPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  UpdateMicroSurveyPayload?: {
    microSurvey?: GraphCacheResolver<WithTypename<UpdateMicroSurveyPayload>, Record<string, never>, WithTypename<MicroSurvey> | string>
  },
  UpdateNewProgramTaskPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateNewProgramTaskPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    newProgramTask?: GraphCacheResolver<WithTypename<UpdateNewProgramTaskPayload>, Record<string, never>, WithTypename<NewProgramTask> | string>
  },
  UpdateParticipantPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateParticipantPayload>, Record<string, never>, Array<InvalidParticipantInputError | string>>,
    participant?: GraphCacheResolver<WithTypename<UpdateParticipantPayload>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  UpdateParticipantsMatchingLabelsPayload?: {
    batchActionId?: GraphCacheResolver<WithTypename<UpdateParticipantsMatchingLabelsPayload>, Record<string, never>, Scalars['ID'] | string>,
    errors?: GraphCacheResolver<WithTypename<UpdateParticipantsMatchingLabelsPayload>, Record<string, never>, Scalars['String'] | string>
  },
  UpdatePartnerPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdatePartnerPayload>, Record<string, never>, Array<InvalidUserInputError | string>>,
    partner?: GraphCacheResolver<WithTypename<UpdatePartnerPayload>, Record<string, never>, WithTypename<Partner> | string>,
    user?: GraphCacheResolver<WithTypename<UpdatePartnerPayload>, Record<string, never>, WithTypename<User> | string>
  },
  UpdateProgramAdminsError?: {
    message?: GraphCacheResolver<WithTypename<UpdateProgramAdminsError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<UpdateProgramAdminsError>, Record<string, never>, UpdateProgramAdminsErrorPaths | string>
  },
  UpdateProgramAdminsPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateProgramAdminsPayload>, Record<string, never>, Array<WithTypename<UpdateProgramAdminsError> | string>>,
    program?: GraphCacheResolver<WithTypename<UpdateProgramAdminsPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  UpdateProgramCommunicationSettingsPayload?: {
    program?: GraphCacheResolver<WithTypename<UpdateProgramCommunicationSettingsPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  UpdateProgramCustomLabelPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateProgramCustomLabelPayload>, Record<string, never>, Array<WithTypename<Error> | string>>,
    program?: GraphCacheResolver<WithTypename<UpdateProgramCustomLabelPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  UpdateProgramCustomMessageTemplatesError?: {
    message?: GraphCacheResolver<WithTypename<UpdateProgramCustomMessageTemplatesError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<UpdateProgramCustomMessageTemplatesError>, Record<string, never>, UpdateProgramCustomMessageTemplatesErrorPaths | string>
  },
  UpdateProgramCustomMessageTemplatesPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateProgramCustomMessageTemplatesPayload>, Record<string, never>, Array<WithTypename<UpdateProgramCustomMessageTemplatesError> | string>>,
    program?: GraphCacheResolver<WithTypename<UpdateProgramCustomMessageTemplatesPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  UpdateProgramFlagContactsError?: {
    message?: GraphCacheResolver<WithTypename<UpdateProgramFlagContactsError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<UpdateProgramFlagContactsError>, Record<string, never>, UpdateProgramFlagContactsErrorPaths | string>
  },
  UpdateProgramFlagContactsPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateProgramFlagContactsPayload>, Record<string, never>, Array<WithTypename<UpdateProgramFlagContactsError> | string>>,
    program?: GraphCacheResolver<WithTypename<UpdateProgramFlagContactsPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  UpdateProgramInfoError?: {
    message?: GraphCacheResolver<WithTypename<UpdateProgramInfoError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<UpdateProgramInfoError>, Record<string, never>, UpdateProgramInfoErrorPaths | string>
  },
  UpdateProgramInfoPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateProgramInfoPayload>, Record<string, never>, Array<WithTypename<UpdateProgramInfoError> | string>>,
    program?: GraphCacheResolver<WithTypename<UpdateProgramInfoPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  UpdateProgramPointPeopleError?: {
    message?: GraphCacheResolver<WithTypename<UpdateProgramPointPeopleError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<UpdateProgramPointPeopleError>, Record<string, never>, UpdateProgramPointPeopleErrorPaths | string>
  },
  UpdateProgramPointPeoplePayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateProgramPointPeoplePayload>, Record<string, never>, Array<WithTypename<UpdateProgramPointPeopleError> | string>>,
    program?: GraphCacheResolver<WithTypename<UpdateProgramPointPeoplePayload>, Record<string, never>, WithTypename<Program> | string>
  },
  UpdateProgramProfileAttributesPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateProgramProfileAttributesPayload>, Record<string, never>, Array<WithTypename<ProgramProfileAttributeUnableToBeUpdated> | string>>,
    updatedProgramProfileAttributes?: GraphCacheResolver<WithTypename<UpdateProgramProfileAttributesPayload>, Record<string, never>, Array<WithTypename<ProgramProfileAttribute> | string>>
  },
  UpdateProgramSequenceInfoError?: {
    message?: GraphCacheResolver<WithTypename<UpdateProgramSequenceInfoError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<UpdateProgramSequenceInfoError>, Record<string, never>, UpdateProgramSequenceInfoErrorPaths | string>
  },
  UpdateProgramSequenceInfoPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateProgramSequenceInfoPayload>, Record<string, never>, Array<WithTypename<UpdateProgramSequenceInfoError> | string>>,
    programSequence?: GraphCacheResolver<WithTypename<UpdateProgramSequenceInfoPayload>, Record<string, never>, WithTypename<ProgramSequence> | string>
  },
  UpdateProgramSetupError?: {
    message?: GraphCacheResolver<WithTypename<UpdateProgramSetupError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<UpdateProgramSetupError>, Record<string, never>, UpdateProgramSetupErrorPaths | string>
  },
  UpdateProgramSetupPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateProgramSetupPayload>, Record<string, never>, Array<WithTypename<UpdateProgramSetupError> | string>>,
    program?: GraphCacheResolver<WithTypename<UpdateProgramSetupPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  UpdateProgramTaskPayload?: {
    programTask?: GraphCacheResolver<WithTypename<UpdateProgramTaskPayload>, Record<string, never>, WithTypename<ProgramTask> | string>
  },
  UpdateProgramTopicPayload?: {
    programTopic?: GraphCacheResolver<WithTypename<UpdateProgramTopicPayload>, Record<string, never>, WithTypename<ProgramTopic> | string>
  },
  UpdateProgramTopicsError?: {
    message?: GraphCacheResolver<WithTypename<UpdateProgramTopicsError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<UpdateProgramTopicsError>, Record<string, never>, UpdateProgramTopicsErrorPaths | string>
  },
  UpdateProgramTopicsPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateProgramTopicsPayload>, Record<string, never>, Array<WithTypename<UpdateProgramTopicsError> | string>>,
    program?: GraphCacheResolver<WithTypename<UpdateProgramTopicsPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  UpdateSchoolInfoError?: {
    message?: GraphCacheResolver<WithTypename<UpdateSchoolInfoError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<UpdateSchoolInfoError>, Record<string, never>, UpdateSchoolInfoErrorPaths | string>
  },
  UpdateSchoolInfoPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateSchoolInfoPayload>, Record<string, never>, Array<WithTypename<UpdateSchoolInfoError> | string>>,
    school?: GraphCacheResolver<WithTypename<UpdateSchoolInfoPayload>, Record<string, never>, WithTypename<School> | string>
  },
  UpdateSmsTemplatePayload?: {
    smsTemplate?: GraphCacheResolver<WithTypename<UpdateSmsTemplatePayload>, Record<string, never>, WithTypename<SmsTemplate> | string>
  },
  UpdateSurveysAndQuizzesError?: {
    message?: GraphCacheResolver<WithTypename<UpdateSurveysAndQuizzesError>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<UpdateSurveysAndQuizzesError>, Record<string, never>, UpdateSurveysAndQuizzesErrorPaths | string>
  },
  UpdateSurveysAndQuizzesPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateSurveysAndQuizzesPayload>, Record<string, never>, Array<WithTypename<UpdateSurveysAndQuizzesError> | string>>,
    program?: GraphCacheResolver<WithTypename<UpdateSurveysAndQuizzesPayload>, Record<string, never>, WithTypename<Program> | string>
  },
  UpdateTopicPayload?: {
    topic?: GraphCacheResolver<WithTypename<UpdateTopicPayload>, Record<string, never>, WithTypename<Topic> | string>
  },
  UpdateUserPayload?: {
    errors?: GraphCacheResolver<WithTypename<UpdateUserPayload>, Record<string, never>, Array<InvalidUserInputError | string>>,
    user?: GraphCacheResolver<WithTypename<UpdateUserPayload>, Record<string, never>, WithTypename<User> | string>
  },
  UploadPhotoTask?: {
    customAfterCallToAction?: GraphCacheResolver<WithTypename<UploadPhotoTask>, Record<string, never>, Scalars['String'] | string>,
    customCallToAction?: GraphCacheResolver<WithTypename<UploadPhotoTask>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<UploadPhotoTask>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<UploadPhotoTask>, Record<string, never>, Scalars['String'] | string>,
    prompt?: GraphCacheResolver<WithTypename<UploadPhotoTask>, Record<string, never>, Scalars['String'] | string>
  },
  UploadUserProfileDataPayload?: {
    batchActionId?: GraphCacheResolver<WithTypename<UploadUserProfileDataPayload>, Record<string, never>, Scalars['ID'] | string>,
    errors?: GraphCacheResolver<WithTypename<UploadUserProfileDataPayload>, Record<string, never>, Scalars['String'] | string>
  },
  UploadVideoTask?: {
    customAfterCallToAction?: GraphCacheResolver<WithTypename<UploadVideoTask>, Record<string, never>, Scalars['String'] | string>,
    customCallToAction?: GraphCacheResolver<WithTypename<UploadVideoTask>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<UploadVideoTask>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<UploadVideoTask>, Record<string, never>, Scalars['String'] | string>,
    prompt?: GraphCacheResolver<WithTypename<UploadVideoTask>, Record<string, never>, Scalars['String'] | string>
  },
  UploadedVideo?: {
    id?: GraphCacheResolver<WithTypename<UploadedVideo>, Record<string, never>, Scalars['ID'] | string>,
    participant?: GraphCacheResolver<WithTypename<UploadedVideo>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>,
    sharePublicly?: GraphCacheResolver<WithTypename<UploadedVideo>, Record<string, never>, Scalars['Boolean'] | string>,
    shareWithStudents?: GraphCacheResolver<WithTypename<UploadedVideo>, Record<string, never>, Scalars['Boolean'] | string>,
    url?: GraphCacheResolver<WithTypename<UploadedVideo>, Record<string, never>, Scalars['String'] | string>,
    ziggeoToken?: GraphCacheResolver<WithTypename<UploadedVideo>, Record<string, never>, Scalars['String'] | string>
  },
  UploadedVideoConnection?: {
    edges?: GraphCacheResolver<WithTypename<UploadedVideoConnection>, Record<string, never>, Array<WithTypename<UploadedVideoEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<UploadedVideoConnection>, Record<string, never>, Array<WithTypename<UploadedVideo> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<UploadedVideoConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<UploadedVideoConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  UploadedVideoEdge?: {
    cursor?: GraphCacheResolver<WithTypename<UploadedVideoEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<UploadedVideoEdge>, Record<string, never>, WithTypename<UploadedVideo> | string>
  },
  User?: {
    activeShearwaterAdministrator?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<ShearwaterAdministrator> | string>,
    avatar?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    avatarImage?: GraphCacheResolver<WithTypename<User>, UserAvatarImageArgs, WithTypename<Image> | string>,
    cachedUserProfileData?: GraphCacheResolver<WithTypename<User>, UserCachedUserProfileDataArgs, Array<WithTypename<CachedUserProfileDataAttributeValue> | string>>,
    contacts?: GraphCacheResolver<WithTypename<User>, UserContactsArgs, Array<WithTypename<MentorContact> | WithTypename<StudentContact> | string>>,
    createdAt?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    email?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    facebookUrl?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    firstName?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    hasValidSsoToken?: GraphCacheResolver<WithTypename<User>, UserHasValidSsoTokenArgs, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['ID'] | string>,
    instagramUrl?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    isAdmin?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Boolean'] | string>,
    isFeatureEnabledFor?: GraphCacheResolver<WithTypename<User>, UserIsFeatureEnabledForArgs, Scalars['Boolean'] | string>,
    isMentorInChatGroup?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Boolean'] | string>,
    isPartner?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Boolean'] | string>,
    lastName?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    lastProgramPageVisit?: GraphCacheResolver<WithTypename<User>, UserLastProgramPageVisitArgs, WithTypename<ProgramPageVisit> | string>,
    lastSignInAt?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    latestDashboardNotificationData?: GraphCacheResolver<WithTypename<User>, UserLatestDashboardNotificationDataArgs, WithTypename<NotificationData> | string>,
    latestPartnerProgramForSchool?: GraphCacheResolver<WithTypename<User>, UserLatestPartnerProgramForSchoolArgs, WithTypename<Program> | string>,
    linkedInUrl?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    mentorshipCredentials?: GraphCacheResolver<WithTypename<User>, UserMentorshipCredentialsArgs, Array<WithTypename<UserMentorshipCredential> | string>>,
    microSurvey?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<MicroSurvey> | string>,
    participants?: GraphCacheResolver<WithTypename<User>, UserParticipantsArgs, Array<WithTypename<Mentor> | WithTypename<Student> | string>>,
    partners?: GraphCacheResolver<WithTypename<User>, UserPartnersArgs, Array<WithTypename<Partner> | string>>,
    phone?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    phoneCountry?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<Country> | string>,
    profile?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<Profile> | string>,
    schoolIdentifiers?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Array<WithTypename<SchoolIdentifier> | string>>,
    signedUpWithSso?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Boolean'] | string>,
    surveyResponses?: GraphCacheResolver<WithTypename<User>, UserSurveyResponsesArgs, Array<WithTypename<SurveyResponse> | string>>,
    twitterUrl?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    unsubscribedFromEmails?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Boolean'] | string>,
    unsubscribedFromSmses?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['Boolean'] | string>,
    userProfileData?: GraphCacheResolver<WithTypename<User>, UserUserProfileDataArgs, Array<WithTypename<UserProfileData> | string>>,
    userStatusInProgram?: GraphCacheResolver<WithTypename<User>, UserUserStatusInProgramArgs, UserProgramStatus | string>
  },
  UserConnection?: {
    edges?: GraphCacheResolver<WithTypename<UserConnection>, Record<string, never>, Array<WithTypename<UserEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<UserConnection>, Record<string, never>, Array<WithTypename<User> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<UserConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<UserConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  UserEdge?: {
    cursor?: GraphCacheResolver<WithTypename<UserEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<UserEdge>, Record<string, never>, WithTypename<User> | string>
  },
  UserMentorshipCredential?: {
    createdAt?: GraphCacheResolver<WithTypename<UserMentorshipCredential>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<UserMentorshipCredential>, Record<string, never>, Scalars['ID'] | string>,
    mentorshipCredential?: GraphCacheResolver<WithTypename<UserMentorshipCredential>, Record<string, never>, WithTypename<MentorshipCredential> | string>,
    updatedAt?: GraphCacheResolver<WithTypename<UserMentorshipCredential>, Record<string, never>, Scalars['ISO8601DateTime'] | string>
  },
  UserProfileAttributeValue?: {
    id?: GraphCacheResolver<WithTypename<UserProfileAttributeValue>, Record<string, never>, Scalars['ID'] | string>,
    openResponse?: GraphCacheResolver<WithTypename<UserProfileAttributeValue>, Record<string, never>, Scalars['String'] | string>,
    profileAttributeValue?: GraphCacheResolver<WithTypename<UserProfileAttributeValue>, Record<string, never>, WithTypename<ProfileAttributeValue> | string>,
    userProfileAttributeValueUpdate?: GraphCacheResolver<WithTypename<UserProfileAttributeValue>, Record<string, never>, WithTypename<UserProfileAttributeValueUpdate> | string>
  },
  UserProfileAttributeValueUpdate?: {
    createdAt?: GraphCacheResolver<WithTypename<UserProfileAttributeValueUpdate>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<UserProfileAttributeValueUpdate>, Record<string, never>, Scalars['ID'] | string>,
    programId?: GraphCacheResolver<WithTypename<UserProfileAttributeValueUpdate>, Record<string, never>, Scalars['ID'] | string>,
    source?: GraphCacheResolver<WithTypename<UserProfileAttributeValueUpdate>, Record<string, never>, ProfileAttributeSource | string>
  },
  UserProfileData?: {
    profileAttribute?: GraphCacheResolver<WithTypename<UserProfileData>, Record<string, never>, WithTypename<ProfileAttribute> | string>,
    values?: GraphCacheResolver<WithTypename<UserProfileData>, Record<string, never>, Array<WithTypename<UserProfileAttributeValue> | string>>
  },
  UserStateVariable?: {
    name?: GraphCacheResolver<WithTypename<UserStateVariable>, Record<string, never>, Scalars['String'] | string>,
    path?: GraphCacheResolver<WithTypename<UserStateVariable>, Record<string, never>, Scalars['String'] | string>,
    previewValue?: GraphCacheResolver<WithTypename<UserStateVariable>, Record<string, never>, Scalars['String'] | string>
  },
  UsersMetrics?: {
    totalEnteredProgram?: GraphCacheResolver<WithTypename<UsersMetrics>, UsersMetricsTotalEnteredProgramArgs, Array<WithTypename<Interval> | string>>,
    totalMinimumTouchpoints?: GraphCacheResolver<WithTypename<UsersMetrics>, UsersMetricsTotalMinimumTouchpointsArgs, Array<WithTypename<Interval> | string>>,
    totalRepliesToMcTextMessages?: GraphCacheResolver<WithTypename<UsersMetrics>, UsersMetricsTotalRepliesToMcTextMessagesArgs, Array<WithTypename<Interval> | string>>,
    totalZeroTouchpoints?: GraphCacheResolver<WithTypename<UsersMetrics>, UsersMetricsTotalZeroTouchpointsArgs, Array<WithTypename<Interval> | string>>
  },
  WatchVideoTask?: {
    customAfterCallToAction?: GraphCacheResolver<WithTypename<WatchVideoTask>, Record<string, never>, Scalars['String'] | string>,
    customCallToAction?: GraphCacheResolver<WithTypename<WatchVideoTask>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<WatchVideoTask>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<WatchVideoTask>, Record<string, never>, Scalars['String'] | string>,
    prompt?: GraphCacheResolver<WithTypename<WatchVideoTask>, Record<string, never>, Scalars['String'] | string>,
    wistiaVideoId?: GraphCacheResolver<WithTypename<WatchVideoTask>, Record<string, never>, Scalars['String'] | string>
  },
  WatchedCommunityVideoLog?: {
    id?: GraphCacheResolver<WithTypename<WatchedCommunityVideoLog>, Record<string, never>, Scalars['ID'] | string>,
    loggedAtDate?: GraphCacheResolver<WithTypename<WatchedCommunityVideoLog>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    ziggeoToken?: GraphCacheResolver<WithTypename<WatchedCommunityVideoLog>, Record<string, never>, Scalars['String'] | string>
  },
  WatchedVideoLog?: {
    id?: GraphCacheResolver<WithTypename<WatchedVideoLog>, Record<string, never>, Scalars['ID'] | string>,
    loggedAtDate?: GraphCacheResolver<WithTypename<WatchedVideoLog>, Record<string, never>, Scalars['ISO8601DateTime'] | string>,
    wistiaVideoId?: GraphCacheResolver<WithTypename<WatchedVideoLog>, Record<string, never>, Scalars['String'] | string>
  },
  WrittenMessage?: {
    content?: GraphCacheResolver<WithTypename<WrittenMessage>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<WrittenMessage>, Record<string, never>, Scalars['ID'] | string>,
    participant?: GraphCacheResolver<WithTypename<WrittenMessage>, Record<string, never>, WithTypename<Mentor> | WithTypename<Student> | string>
  },
  WrittenMessageConnection?: {
    edges?: GraphCacheResolver<WithTypename<WrittenMessageConnection>, Record<string, never>, Array<WithTypename<WrittenMessageEdge> | string>>,
    nodes?: GraphCacheResolver<WithTypename<WrittenMessageConnection>, Record<string, never>, Array<WithTypename<WrittenMessage> | string>>,
    pageInfo?: GraphCacheResolver<WithTypename<WrittenMessageConnection>, Record<string, never>, WithTypename<PageInfo> | string>,
    totalCount?: GraphCacheResolver<WithTypename<WrittenMessageConnection>, Record<string, never>, Scalars['Int'] | string>
  },
  WrittenMessageEdge?: {
    cursor?: GraphCacheResolver<WithTypename<WrittenMessageEdge>, Record<string, never>, Scalars['String'] | string>,
    node?: GraphCacheResolver<WithTypename<WrittenMessageEdge>, Record<string, never>, WithTypename<WrittenMessage> | string>
  }
};

export type GraphCacheOptimisticUpdaters = {
  addContacts?: GraphCacheOptimisticMutationResolver<MutationAddContactsArgs, Maybe<WithTypename<AddContactsPayload>>>,
  addContactsFromExistingProgram?: GraphCacheOptimisticMutationResolver<MutationAddContactsFromExistingProgramArgs, Maybe<WithTypename<AddContactsFromExistingProgramPayload>>>,
  addContactsToExistingUsers?: GraphCacheOptimisticMutationResolver<MutationAddContactsToExistingUsersArgs, Maybe<WithTypename<AddContactsToExistingUsersPayload>>>,
  addMessageTemplatesTags?: GraphCacheOptimisticMutationResolver<Record<string, never>, WithTypename<AddMessageTemplatesTags>>,
  addParticipants?: GraphCacheOptimisticMutationResolver<MutationAddParticipantsArgs, Maybe<WithTypename<AddParticipantsPayload>>>,
  archiveRestoreMessageTemplates?: GraphCacheOptimisticMutationResolver<Record<string, never>, WithTypename<ArchiveRestoreMessageTemplates>>,
  autoSuggestMatches?: GraphCacheOptimisticMutationResolver<MutationAutoSuggestMatchesArgs, Maybe<WithTypename<AutoSuggestMatchesPayload>>>,
  changeMentorTrainingStatus?: GraphCacheOptimisticMutationResolver<MutationChangeMentorTrainingStatusArgs, Maybe<WithTypename<ChangeMentorTrainingStatusPayload>>>,
  completeTaskAssignment?: GraphCacheOptimisticMutationResolver<MutationCompleteTaskAssignmentArgs, Maybe<WithTypename<CompleteTaskAssignmentPayload>>>,
  configureFlags?: GraphCacheOptimisticMutationResolver<MutationConfigureFlagsArgs, Maybe<WithTypename<ConfigureFlagsPayload>>>,
  createEmailTemplate?: GraphCacheOptimisticMutationResolver<MutationCreateEmailTemplateArgs, Maybe<WithTypename<CreateEmailTemplatePayload>>>,
  createEmailTemplateSavedRow?: GraphCacheOptimisticMutationResolver<MutationCreateEmailTemplateSavedRowArgs, Maybe<WithTypename<CreateEmailTemplateSavedRowPayload>>>,
  createFlagContact?: GraphCacheOptimisticMutationResolver<MutationCreateFlagContactArgs, Maybe<WithTypename<CreateFlagContactPayload>>>,
  createMatchingLabel?: GraphCacheOptimisticMutationResolver<MutationCreateMatchingLabelArgs, Maybe<WithTypename<CreateMatchingLabelPayload>>>,
  createMatchingSurvey?: GraphCacheOptimisticMutationResolver<MutationCreateMatchingSurveyArgs, Maybe<WithTypename<CreateMatchingSurveyPayload>>>,
  createMessageTemplateTag?: GraphCacheOptimisticMutationResolver<MutationCreateMessageTemplateTagArgs, Maybe<WithTypename<CreateMessageTemplateTagPayload>>>,
  createMicroSurvey?: GraphCacheOptimisticMutationResolver<MutationCreateMicroSurveyArgs, Maybe<WithTypename<CreateMicroSurveyPayload>>>,
  createNewCourseTaskAndNewProgramTask?: GraphCacheOptimisticMutationResolver<MutationCreateNewCourseTaskAndNewProgramTaskArgs, Maybe<WithTypename<CreateNewCourseTaskAndNewProgramTaskPayload>>>,
  createNewLinkTaskAndNewProgramTask?: GraphCacheOptimisticMutationResolver<MutationCreateNewLinkTaskAndNewProgramTaskArgs, Maybe<WithTypename<CreateNewLinkTaskAndNewProgramTaskPayload>>>,
  createNotificationView?: GraphCacheOptimisticMutationResolver<MutationCreateNotificationViewArgs, Maybe<WithTypename<CreateNotificationViewPayload>>>,
  createOrEnableNewProgramTask?: GraphCacheOptimisticMutationResolver<MutationCreateOrEnableNewProgramTaskArgs, Maybe<WithTypename<CreateOrEnableNewProgramTaskPayload>>>,
  createPartner?: GraphCacheOptimisticMutationResolver<MutationCreatePartnerArgs, Maybe<WithTypename<CreatePartnerPayload>>>,
  createProgram?: GraphCacheOptimisticMutationResolver<MutationCreateProgramArgs, Maybe<WithTypename<CreateProgramPayload>>>,
  createProgramAutomatchingConfiguration?: GraphCacheOptimisticMutationResolver<MutationCreateProgramAutomatchingConfigurationArgs, Maybe<WithTypename<CreateProgramAutomatchingConfigurationPayload>>>,
  createProgramAutomatchingDefault?: GraphCacheOptimisticMutationResolver<MutationCreateProgramAutomatchingDefaultArgs, Maybe<WithTypename<CreateProgramAutomatchingDefaultPayload>>>,
  createProgramPageVisit?: GraphCacheOptimisticMutationResolver<MutationCreateProgramPageVisitArgs, Maybe<WithTypename<CreateProgramPageVisitPayload>>>,
  createProgramResource?: GraphCacheOptimisticMutationResolver<MutationCreateProgramResourceArgs, Maybe<WithTypename<CreateProgramResourcePayload>>>,
  createProgramSequence?: GraphCacheOptimisticMutationResolver<MutationCreateProgramSequenceArgs, Maybe<WithTypename<CreateProgramSequencePayload>>>,
  createProgramTask?: GraphCacheOptimisticMutationResolver<MutationCreateProgramTaskArgs, Maybe<WithTypename<CreateProgramTaskPayload>>>,
  createProgramTopic?: GraphCacheOptimisticMutationResolver<MutationCreateProgramTopicArgs, Maybe<WithTypename<CreateProgramTopicPayload>>>,
  createSavedMatch?: GraphCacheOptimisticMutationResolver<MutationCreateSavedMatchArgs, Maybe<WithTypename<CreateSavedMatchPayload>>>,
  createSchool?: GraphCacheOptimisticMutationResolver<MutationCreateSchoolArgs, Maybe<WithTypename<CreateSchoolPayload>>>,
  createSkeletonMessageTemplate?: GraphCacheOptimisticMutationResolver<MutationCreateSkeletonMessageTemplateArgs, Maybe<WithTypename<CreateSkeletonMessageTemplatePayload>>>,
  createSmsTemplate?: GraphCacheOptimisticMutationResolver<MutationCreateSmsTemplateArgs, Maybe<WithTypename<CreateSmsTemplatePayload>>>,
  createTopic?: GraphCacheOptimisticMutationResolver<MutationCreateTopicArgs, Maybe<WithTypename<CreateTopicPayload>>>,
  createUploadedVideo?: GraphCacheOptimisticMutationResolver<MutationCreateUploadedVideoArgs, Maybe<WithTypename<CreateUploadedVideoPayload>>>,
  deleteFlagContact?: GraphCacheOptimisticMutationResolver<MutationDeleteFlagContactArgs, Maybe<WithTypename<DeleteFlagContactPayload>>>,
  deleteMatchingLabel?: GraphCacheOptimisticMutationResolver<MutationDeleteMatchingLabelArgs, Maybe<WithTypename<DeleteMatchingLabelPayload>>>,
  deleteProgram?: GraphCacheOptimisticMutationResolver<MutationDeleteProgramArgs, Maybe<WithTypename<DeleteProgramPayload>>>,
  deleteProgramContacts?: GraphCacheOptimisticMutationResolver<MutationDeleteProgramContactsArgs, Maybe<WithTypename<DeleteContacts>>>,
  deleteProgramResource?: GraphCacheOptimisticMutationResolver<MutationDeleteProgramResourceArgs, Maybe<WithTypename<DeleteProgramResourcePayload>>>,
  deleteProgramSequence?: GraphCacheOptimisticMutationResolver<MutationDeleteProgramSequenceArgs, Maybe<WithTypename<DeleteProgramSequencePayload>>>,
  deleteProgramTask?: GraphCacheOptimisticMutationResolver<MutationDeleteProgramTaskArgs, Maybe<WithTypename<DeleteProgramTaskPayload>>>,
  deleteProgramTopic?: GraphCacheOptimisticMutationResolver<MutationDeleteProgramTopicArgs, Maybe<WithTypename<DeleteProgramTopicPayload>>>,
  deleteSavedMatches?: GraphCacheOptimisticMutationResolver<Record<string, never>, WithTypename<DeleteSavedMatches>>,
  deleteSchool?: GraphCacheOptimisticMutationResolver<MutationDeleteSchoolArgs, Maybe<WithTypename<DeleteSchoolPayload>>>,
  deleteSuggestedBatch?: GraphCacheOptimisticMutationResolver<MutationDeleteSuggestedBatchArgs, Maybe<WithTypename<DeleteSuggestedBatchPayload>>>,
  denylistEmails?: GraphCacheOptimisticMutationResolver<MutationDenylistEmailsArgs, Maybe<WithTypename<DenylistEmailsPayload>>>,
  deregisterParticipant?: GraphCacheOptimisticMutationResolver<MutationDeregisterParticipantArgs, Maybe<WithTypename<DeregisterParticipantPayload>>>,
  disableNewProgramTask?: GraphCacheOptimisticMutationResolver<MutationDisableNewProgramTaskArgs, Maybe<WithTypename<DisableNewProgramTaskPayload>>>,
  dismissProgramAlert?: GraphCacheOptimisticMutationResolver<MutationDismissProgramAlertArgs, Maybe<WithTypename<DismissProgramAlertPayload>>>,
  duplicateMessageTemplates?: GraphCacheOptimisticMutationResolver<Record<string, never>, WithTypename<DuplicateMessageTemplates>>,
  duplicateProgram?: GraphCacheOptimisticMutationResolver<MutationDuplicateProgramArgs, Maybe<WithTypename<DuplicateProgramPayload>>>,
  duplicateProgramSequence?: GraphCacheOptimisticMutationResolver<MutationDuplicateProgramSequenceArgs, Maybe<WithTypename<DuplicateProgramSequencePayload>>>,
  logTookTypeformSurvey?: GraphCacheOptimisticMutationResolver<MutationLogTookTypeformSurveyArgs, Maybe<WithTypename<LogTookTypeformSurveyPayload>>>,
  logWatchedCommunityVideo?: GraphCacheOptimisticMutationResolver<MutationLogWatchedCommunityVideoArgs, Maybe<WithTypename<LogWatchedCommunityVideoPayload>>>,
  logWatchedWistiaVideo?: GraphCacheOptimisticMutationResolver<MutationLogWatchedWistiaVideoArgs, Maybe<WithTypename<LogWatchedWistiaVideoPayload>>>,
  makeBatchMatches?: GraphCacheOptimisticMutationResolver<MutationMakeBatchMatchesArgs, Maybe<WithTypename<MakeBatchMatchesPayload>>>,
  makeMatch?: GraphCacheOptimisticMutationResolver<MutationMakeMatchArgs, Maybe<WithTypename<MakeMatchPayload>>>,
  makeSavedGroupMatches?: GraphCacheOptimisticMutationResolver<Record<string, never>, WithTypename<MakeSavedGroupMatches>>,
  makeSavedMatches?: GraphCacheOptimisticMutationResolver<Record<string, never>, WithTypename<MakeSavedMatches>>,
  markParticipantReachedOut?: GraphCacheOptimisticMutationResolver<MutationMarkParticipantReachedOutArgs, Maybe<WithTypename<MarkParticipantReachedOutPayload>>>,
  moveParticipants?: GraphCacheOptimisticMutationResolver<MutationMoveParticipantsArgs, Maybe<WithTypename<MoveParticipantsPayload>>>,
  previewMatchingSurvey?: GraphCacheOptimisticMutationResolver<MutationPreviewMatchingSurveyArgs, Maybe<WithTypename<PreviewMatchingSurveyPayload>>>,
  reactivateProgramAlert?: GraphCacheOptimisticMutationResolver<MutationReactivateProgramAlertArgs, Maybe<WithTypename<ReactivateProgramAlertPayload>>>,
  removeMessageTemplatesTags?: GraphCacheOptimisticMutationResolver<Record<string, never>, WithTypename<RemoveMessageTemplatesTags>>,
  saveBatchMatches?: GraphCacheOptimisticMutationResolver<MutationSaveBatchMatchesArgs, Maybe<WithTypename<SaveBatchMatchesPayload>>>,
  saveSurveyResponse?: GraphCacheOptimisticMutationResolver<MutationSaveSurveyResponseArgs, Maybe<WithTypename<SaveSurveyResponsePayload>>>,
  saveWrittenMessage?: GraphCacheOptimisticMutationResolver<MutationSaveWrittenMessageArgs, Maybe<WithTypename<SaveWrittenMessagePayload>>>,
  sendBulkMessageByCsv?: GraphCacheOptimisticMutationResolver<MutationSendBulkMessageByCsvArgs, Maybe<WithTypename<SendBulkMessageByCsvPayload>>>,
  sendPartnerNotifications?: GraphCacheOptimisticMutationResolver<MutationSendPartnerNotificationsArgs, Maybe<WithTypename<SendPartnerNotificationsPayload>>>,
  sendSsoTestingTemplate?: GraphCacheOptimisticMutationResolver<MutationSendSsoTestingTemplateArgs, Maybe<WithTypename<SendSsoTestingTemplatePayload>>>,
  sendTestMessage?: GraphCacheOptimisticMutationResolver<MutationSendTestMessageArgs, Maybe<WithTypename<SendTestMessagePayload>>>,
  sendUpdateEmailDraftForMentorship?: GraphCacheOptimisticMutationResolver<MutationSendUpdateEmailDraftForMentorshipArgs, Maybe<WithTypename<SendUpdateEmailDraftForMentorshipPayload>>>,
  setupSftp?: GraphCacheOptimisticMutationResolver<MutationSetupSftpArgs, Maybe<WithTypename<SetupSftpPayload>>>,
  startFirstWaveRecruitment?: GraphCacheOptimisticMutationResolver<MutationStartFirstWaveRecruitmentArgs, Maybe<WithTypename<StartFirstWaveRecruitment>>>,
  startSecondWaveRecruitment?: GraphCacheOptimisticMutationResolver<MutationStartSecondWaveRecruitmentArgs, Maybe<WithTypename<StartSecondWaveRecruitment>>>,
  stopRecruitment?: GraphCacheOptimisticMutationResolver<MutationStopRecruitmentArgs, Maybe<WithTypename<StopRecruitment>>>,
  unmatchParticipant?: GraphCacheOptimisticMutationResolver<MutationUnmatchParticipantArgs, Maybe<WithTypename<UnmatchParticipantPayload>>>,
  unmatchParticipants?: GraphCacheOptimisticMutationResolver<MutationUnmatchParticipantsArgs, Maybe<WithTypename<UnmatchParticipantsPayload>>>,
  updateAssessmentSurveyNewProgramTask?: GraphCacheOptimisticMutationResolver<MutationUpdateAssessmentSurveyNewProgramTaskArgs, Maybe<WithTypename<UpdateAssessmentSurveyNewProgramTaskPayload>>>,
  updateClickLinkNewProgramTask?: GraphCacheOptimisticMutationResolver<MutationUpdateClickLinkNewProgramTaskArgs, Maybe<WithTypename<UpdateClickLinkNewProgramTaskPayload>>>,
  updateClickLinkNewTask?: GraphCacheOptimisticMutationResolver<MutationUpdateClickLinkNewTaskArgs, Maybe<WithTypename<UpdateClickLinkNewTaskPayload>>>,
  updateCourseNewProgramTask?: GraphCacheOptimisticMutationResolver<MutationUpdateCourseNewProgramTaskArgs, Maybe<WithTypename<UpdateCourseNewProgramTaskPayload>>>,
  updateCourseNewTask?: GraphCacheOptimisticMutationResolver<MutationUpdateCourseNewTaskArgs, Maybe<WithTypename<UpdateCourseNewTaskPayload>>>,
  updateEmailTemplate?: GraphCacheOptimisticMutationResolver<MutationUpdateEmailTemplateArgs, Maybe<WithTypename<UpdateEmailTemplatePayload>>>,
  updateFlag?: GraphCacheOptimisticMutationResolver<MutationUpdateFlagArgs, Maybe<WithTypename<UpdateFlagPayload>>>,
  updateFlagContact?: GraphCacheOptimisticMutationResolver<MutationUpdateFlagContactArgs, Maybe<WithTypename<UpdateFlagContactPayload>>>,
  updateMenteeMentorSettings?: GraphCacheOptimisticMutationResolver<MutationUpdateMenteeMentorSettingsArgs, Maybe<WithTypename<UpdateMenteeMentorSettingsPayload>>>,
  updateMicroSurvey?: GraphCacheOptimisticMutationResolver<MutationUpdateMicroSurveyArgs, Maybe<WithTypename<UpdateMicroSurveyPayload>>>,
  updateNewProgramTask?: GraphCacheOptimisticMutationResolver<MutationUpdateNewProgramTaskArgs, Maybe<WithTypename<UpdateNewProgramTaskPayload>>>,
  updateParticipant?: GraphCacheOptimisticMutationResolver<MutationUpdateParticipantArgs, Maybe<WithTypename<UpdateParticipantPayload>>>,
  updateParticipantsMatchingLabels?: GraphCacheOptimisticMutationResolver<MutationUpdateParticipantsMatchingLabelsArgs, Maybe<WithTypename<UpdateParticipantsMatchingLabelsPayload>>>,
  updatePartner?: GraphCacheOptimisticMutationResolver<MutationUpdatePartnerArgs, Maybe<WithTypename<UpdatePartnerPayload>>>,
  updateProgramAdmins?: GraphCacheOptimisticMutationResolver<MutationUpdateProgramAdminsArgs, Maybe<WithTypename<UpdateProgramAdminsPayload>>>,
  updateProgramCommunicationSettings?: GraphCacheOptimisticMutationResolver<MutationUpdateProgramCommunicationSettingsArgs, Maybe<WithTypename<UpdateProgramCommunicationSettingsPayload>>>,
  updateProgramCustomLabel?: GraphCacheOptimisticMutationResolver<MutationUpdateProgramCustomLabelArgs, Maybe<WithTypename<UpdateProgramCustomLabelPayload>>>,
  updateProgramCustomMessageTemplates?: GraphCacheOptimisticMutationResolver<MutationUpdateProgramCustomMessageTemplatesArgs, Maybe<WithTypename<UpdateProgramCustomMessageTemplatesPayload>>>,
  updateProgramFlagContacts?: GraphCacheOptimisticMutationResolver<MutationUpdateProgramFlagContactsArgs, Maybe<WithTypename<UpdateProgramFlagContactsPayload>>>,
  updateProgramInfo?: GraphCacheOptimisticMutationResolver<MutationUpdateProgramInfoArgs, Maybe<WithTypename<UpdateProgramInfoPayload>>>,
  updateProgramPointPeople?: GraphCacheOptimisticMutationResolver<MutationUpdateProgramPointPeopleArgs, Maybe<WithTypename<UpdateProgramPointPeoplePayload>>>,
  updateProgramSequenceInfo?: GraphCacheOptimisticMutationResolver<MutationUpdateProgramSequenceInfoArgs, Maybe<WithTypename<UpdateProgramSequenceInfoPayload>>>,
  updateProgramSetup?: GraphCacheOptimisticMutationResolver<MutationUpdateProgramSetupArgs, Maybe<WithTypename<UpdateProgramSetupPayload>>>,
  updateProgramTask?: GraphCacheOptimisticMutationResolver<MutationUpdateProgramTaskArgs, Maybe<WithTypename<UpdateProgramTaskPayload>>>,
  updateProgramTopic?: GraphCacheOptimisticMutationResolver<MutationUpdateProgramTopicArgs, Maybe<WithTypename<UpdateProgramTopicPayload>>>,
  updateProgramTopics?: GraphCacheOptimisticMutationResolver<MutationUpdateProgramTopicsArgs, Maybe<WithTypename<UpdateProgramTopicsPayload>>>,
  updateSchoolInfo?: GraphCacheOptimisticMutationResolver<MutationUpdateSchoolInfoArgs, Maybe<WithTypename<UpdateSchoolInfoPayload>>>,
  updateSmsTemplate?: GraphCacheOptimisticMutationResolver<MutationUpdateSmsTemplateArgs, Maybe<WithTypename<UpdateSmsTemplatePayload>>>,
  updateSurveysAndQuizzes?: GraphCacheOptimisticMutationResolver<MutationUpdateSurveysAndQuizzesArgs, Maybe<WithTypename<UpdateSurveysAndQuizzesPayload>>>,
  updateTopic?: GraphCacheOptimisticMutationResolver<MutationUpdateTopicArgs, Maybe<WithTypename<UpdateTopicPayload>>>,
  updateUser?: GraphCacheOptimisticMutationResolver<MutationUpdateUserArgs, Maybe<WithTypename<UpdateUserPayload>>>,
  updatedProgramProfileAttributes?: GraphCacheOptimisticMutationResolver<MutationUpdatedProgramProfileAttributesArgs, Maybe<WithTypename<UpdateProgramProfileAttributesPayload>>>,
  uploadUserProfileData?: GraphCacheOptimisticMutationResolver<MutationUploadUserProfileDataArgs, Maybe<WithTypename<UploadUserProfileDataPayload>>>
};

export type GraphCacheUpdaters = {
  Query?: {
    adminAction?: GraphCacheUpdateResolver<{ adminAction: WithTypename<AdminAction> }, QueryAdminActionArgs>,
    adminActions?: GraphCacheUpdateResolver<{ adminActions: WithTypename<AdminActionConnection> }, QueryAdminActionsArgs>,
    assessmentAreasForSurvey?: GraphCacheUpdateResolver<{ assessmentAreasForSurvey: Array<WithTypename<AssessmentArea>> }, QueryAssessmentAreasForSurveyArgs>,
    automatchingDefaults?: GraphCacheUpdateResolver<{ automatchingDefaults: Array<WithTypename<AutomatchingDefault>> }, Record<string, never>>,
    contacts?: GraphCacheUpdateResolver<{ contacts: WithTypename<ContactConnection> }, QueryContactsArgs>,
    conversationTopicCategories?: GraphCacheUpdateResolver<{ conversationTopicCategories: Array<WithTypename<ParticipantConversationCategory>> }, QueryConversationTopicCategoriesArgs>,
    conversationTopics?: GraphCacheUpdateResolver<{ conversationTopics: Array<ConversationTopic> }, QueryConversationTopicsArgs>,
    country?: GraphCacheUpdateResolver<{ country: WithTypename<Country> }, QueryCountryArgs>,
    course?: GraphCacheUpdateResolver<{ course: WithTypename<Course> }, QueryCourseArgs>,
    courses?: GraphCacheUpdateResolver<{ courses: WithTypename<CourseConnection> }, QueryCoursesArgs>,
    csvExports?: GraphCacheUpdateResolver<{ csvExports: WithTypename<CsvExports> }, Record<string, never>>,
    customMessageTypeTemplateRequirements?: GraphCacheUpdateResolver<{ customMessageTypeTemplateRequirements: WithTypename<CustomMessageTypeTemplateRequirementConnection> }, QueryCustomMessageTypeTemplateRequirementsArgs>,
    deregistrationReasons?: GraphCacheUpdateResolver<{ deregistrationReasons: WithTypename<DeregistrationReasonConnection> }, QueryDeregistrationReasonsArgs>,
    flagCategories?: GraphCacheUpdateResolver<{ flagCategories: Array<WithTypename<FlagCategory>> }, QueryFlagCategoriesArgs>,
    flagContacts?: GraphCacheUpdateResolver<{ flagContacts: Array<WithTypename<FlagContact>> }, QueryFlagContactsArgs>,
    flags?: GraphCacheUpdateResolver<{ flags: WithTypename<FlagConnection> }, QueryFlagsArgs>,
    matchingLabel?: GraphCacheUpdateResolver<{ matchingLabel: WithTypename<MatchingLabel> }, QueryMatchingLabelArgs>,
    mentor?: GraphCacheUpdateResolver<{ mentor: WithTypename<Mentor> }, QueryMentorArgs>,
    mentorship?: GraphCacheUpdateResolver<{ mentorship: WithTypename<Mentorship> }, QueryMentorshipArgs>,
    mentorships?: GraphCacheUpdateResolver<{ mentorships: WithTypename<MentorshipConnection> }, QueryMentorshipsArgs>,
    messageTemplate?: GraphCacheUpdateResolver<{ messageTemplate: WithTypename<EmailTemplate> | WithTypename<SmsTemplate> }, QueryMessageTemplateArgs>,
    messageTemplateTags?: GraphCacheUpdateResolver<{ messageTemplateTags: WithTypename<MessageTemplateTagConnection> }, QueryMessageTemplateTagsArgs>,
    messageTemplates?: GraphCacheUpdateResolver<{ messageTemplates: WithTypename<MessageTemplateConnection> }, QueryMessageTemplatesArgs>,
    metrics?: GraphCacheUpdateResolver<{ metrics: WithTypename<QueryableMetrics> }, Record<string, never>>,
    microSurvey?: GraphCacheUpdateResolver<{ microSurvey: WithTypename<MicroSurvey> }, QueryMicroSurveyArgs>,
    microSurveys?: GraphCacheUpdateResolver<{ microSurveys: WithTypename<MicroSurveyConnection> }, QueryMicroSurveysArgs>,
    newProgramTask?: GraphCacheUpdateResolver<{ newProgramTask: WithTypename<NewProgramTask> }, QueryNewProgramTaskArgs>,
    newProgramTasks?: GraphCacheUpdateResolver<{ newProgramTasks: WithTypename<NewProgramTaskConnection> }, QueryNewProgramTasksArgs>,
    newTask?: GraphCacheUpdateResolver<{ newTask: WithTypename<NewTask> }, QueryNewTaskArgs>,
    newTasks?: GraphCacheUpdateResolver<{ newTasks: WithTypename<NewTaskConnection> }, QueryNewTasksArgs>,
    outreachTopic?: GraphCacheUpdateResolver<{ outreachTopic: WithTypename<Topic> }, QueryOutreachTopicArgs>,
    outreachTopicCollections?: GraphCacheUpdateResolver<{ outreachTopicCollections: Array<WithTypename<TopicCollection>> }, QueryOutreachTopicCollectionsArgs>,
    outreachTopics?: GraphCacheUpdateResolver<{ outreachTopics: WithTypename<TopicConnection> }, QueryOutreachTopicsArgs>,
    participant?: GraphCacheUpdateResolver<{ participant: WithTypename<Mentor> | WithTypename<Student> }, QueryParticipantArgs>,
    participantConversationCategories?: GraphCacheUpdateResolver<{ participantConversationCategories: Array<WithTypename<ParticipantConversationCategory>> }, QueryParticipantConversationCategoriesArgs>,
    participantConversationContents?: GraphCacheUpdateResolver<{ participantConversationContents: WithTypename<ParticipantConversationContentConnection> }, QueryParticipantConversationContentsArgs>,
    participantGoals?: GraphCacheUpdateResolver<{ participantGoals: WithTypename<GoalConnection> }, QueryParticipantGoalsArgs>,
    participants?: GraphCacheUpdateResolver<{ participants: WithTypename<ParticipantConnection> }, QueryParticipantsArgs>,
    partner?: GraphCacheUpdateResolver<{ partner: WithTypename<Partner> }, QueryPartnerArgs>,
    partners?: GraphCacheUpdateResolver<{ partners: WithTypename<PartnerConnection> }, QueryPartnersArgs>,
    program?: GraphCacheUpdateResolver<{ program: WithTypename<Program> }, QueryProgramArgs>,
    programAutomatchingConfiguration?: GraphCacheUpdateResolver<{ programAutomatchingConfiguration: Maybe<WithTypename<ProgramAutomatchingConfiguration>> }, QueryProgramAutomatchingConfigurationArgs>,
    programAutomatchingDefault?: GraphCacheUpdateResolver<{ programAutomatchingDefault: WithTypename<ProgramAutomatchingDefault> }, QueryProgramAutomatchingDefaultArgs>,
    programCompiledTexts?: GraphCacheUpdateResolver<{ programCompiledTexts: Array<Scalars['String']> }, QueryProgramCompiledTextsArgs>,
    programProfileAttributeCategories?: GraphCacheUpdateResolver<{ programProfileAttributeCategories: Array<WithTypename<ProgramProfileAttributeCategoryResult>> }, QueryProgramProfileAttributeCategoriesArgs>,
    programSequences?: GraphCacheUpdateResolver<{ programSequences: WithTypename<ProgramSequenceConnection> }, QueryProgramSequencesArgs>,
    programTopic?: GraphCacheUpdateResolver<{ programTopic: WithTypename<ProgramTopic> }, QueryProgramTopicArgs>,
    programs?: GraphCacheUpdateResolver<{ programs: WithTypename<ProgramConnection> }, QueryProgramsArgs>,
    resource?: GraphCacheUpdateResolver<{ resource: Maybe<WithTypename<Resource>> }, QueryResourceArgs>,
    resourceTopics?: GraphCacheUpdateResolver<{ resourceTopics: WithTypename<ResourceTopicConnection> }, QueryResourceTopicsArgs>,
    resources?: GraphCacheUpdateResolver<{ resources: WithTypename<ResourceConnection> }, QueryResourcesArgs>,
    savedMatch?: GraphCacheUpdateResolver<{ savedMatch: WithTypename<SavedMatch> }, QuerySavedMatchArgs>,
    savedMatches?: GraphCacheUpdateResolver<{ savedMatches: WithTypename<SavedMatchConnection> }, QuerySavedMatchesArgs>,
    school?: GraphCacheUpdateResolver<{ school: WithTypename<School> }, QuerySchoolArgs>,
    schools?: GraphCacheUpdateResolver<{ schools: WithTypename<SchoolConnection> }, QuerySchoolsArgs>,
    sftpCsvExports?: GraphCacheUpdateResolver<{ sftpCsvExports: WithTypename<SftpCsvExports> }, Record<string, never>>,
    sftpS3Objects?: GraphCacheUpdateResolver<{ sftpS3Objects: Maybe<Array<WithTypename<S3Object>>> }, QuerySftpS3ObjectsArgs>,
    skeletonMessageTemplate?: GraphCacheUpdateResolver<{ skeletonMessageTemplate: WithTypename<SkeletonMessageTemplate> }, QuerySkeletonMessageTemplateArgs>,
    skeletonMessageTemplates?: GraphCacheUpdateResolver<{ skeletonMessageTemplates: WithTypename<SkeletonMessageTemplateConnection> }, QuerySkeletonMessageTemplatesArgs>,
    stateMachine?: GraphCacheUpdateResolver<{ stateMachine: WithTypename<StateMachine> }, QueryStateMachineArgs>,
    stateMachines?: GraphCacheUpdateResolver<{ stateMachines: WithTypename<StateMachineConnection> }, QueryStateMachinesArgs>,
    student?: GraphCacheUpdateResolver<{ student: WithTypename<Student> }, QueryStudentArgs>,
    suggestedBatch?: GraphCacheUpdateResolver<{ suggestedBatch: WithTypename<SuggestedBatch> }, QuerySuggestedBatchArgs>,
    suggestedBatches?: GraphCacheUpdateResolver<{ suggestedBatches: WithTypename<SuggestedBatchConnection> }, QuerySuggestedBatchesArgs>,
    suggestedMatch?: GraphCacheUpdateResolver<{ suggestedMatch: WithTypename<SuggestedMatch> }, QuerySuggestedMatchArgs>,
    suggestedMatches?: GraphCacheUpdateResolver<{ suggestedMatches: WithTypename<SuggestedMatchConnection> }, QuerySuggestedMatchesArgs>,
    survey?: GraphCacheUpdateResolver<{ survey: WithTypename<Survey> }, QuerySurveyArgs>,
    surveyQuestionRestrictedOptions?: GraphCacheUpdateResolver<{ surveyQuestionRestrictedOptions: WithTypename<SurveyQuestionRestrictedOptionConnection> }, QuerySurveyQuestionRestrictedOptionsArgs>,
    surveyResponses?: GraphCacheUpdateResolver<{ surveyResponses: Maybe<WithTypename<SurveyResponseConnection>> }, QuerySurveyResponsesArgs>,
    surveys?: GraphCacheUpdateResolver<{ surveys: WithTypename<SurveyConnection> }, QuerySurveysArgs>,
    taskAssignments?: GraphCacheUpdateResolver<{ taskAssignments: Array<WithTypename<AssessmentSurveyTaskAssignment> | WithTypename<ClickLinkTaskAssignment> | WithTypename<CourseTaskAssignment>> }, QueryTaskAssignmentsArgs>,
    tasks?: GraphCacheUpdateResolver<{ tasks: WithTypename<TaskConnection> }, QueryTasksArgs>,
    uploadedVideos?: GraphCacheUpdateResolver<{ uploadedVideos: WithTypename<UploadedVideoConnection> }, QueryUploadedVideosArgs>,
    user?: GraphCacheUpdateResolver<{ user: WithTypename<User> }, QueryUserArgs>,
    userStateVariables?: GraphCacheUpdateResolver<{ userStateVariables: Array<WithTypename<UserStateVariable>> }, QueryUserStateVariablesArgs>,
    users?: GraphCacheUpdateResolver<{ users: WithTypename<UserConnection> }, QueryUsersArgs>,
    warehouseMetrics?: GraphCacheUpdateResolver<{ warehouseMetrics: WithTypename<DwhQueryableMetrics> }, Record<string, never>>,
    writtenMessages?: GraphCacheUpdateResolver<{ writtenMessages: WithTypename<WrittenMessageConnection> }, QueryWrittenMessagesArgs>
  },
  Mutation?: {
    addContacts?: GraphCacheUpdateResolver<{ addContacts: Maybe<WithTypename<AddContactsPayload>> }, MutationAddContactsArgs>,
    addContactsFromExistingProgram?: GraphCacheUpdateResolver<{ addContactsFromExistingProgram: Maybe<WithTypename<AddContactsFromExistingProgramPayload>> }, MutationAddContactsFromExistingProgramArgs>,
    addContactsToExistingUsers?: GraphCacheUpdateResolver<{ addContactsToExistingUsers: Maybe<WithTypename<AddContactsToExistingUsersPayload>> }, MutationAddContactsToExistingUsersArgs>,
    addMessageTemplatesTags?: GraphCacheUpdateResolver<{ addMessageTemplatesTags: WithTypename<AddMessageTemplatesTags> }, Record<string, never>>,
    addParticipants?: GraphCacheUpdateResolver<{ addParticipants: Maybe<WithTypename<AddParticipantsPayload>> }, MutationAddParticipantsArgs>,
    archiveRestoreMessageTemplates?: GraphCacheUpdateResolver<{ archiveRestoreMessageTemplates: WithTypename<ArchiveRestoreMessageTemplates> }, Record<string, never>>,
    autoSuggestMatches?: GraphCacheUpdateResolver<{ autoSuggestMatches: Maybe<WithTypename<AutoSuggestMatchesPayload>> }, MutationAutoSuggestMatchesArgs>,
    changeMentorTrainingStatus?: GraphCacheUpdateResolver<{ changeMentorTrainingStatus: Maybe<WithTypename<ChangeMentorTrainingStatusPayload>> }, MutationChangeMentorTrainingStatusArgs>,
    completeTaskAssignment?: GraphCacheUpdateResolver<{ completeTaskAssignment: Maybe<WithTypename<CompleteTaskAssignmentPayload>> }, MutationCompleteTaskAssignmentArgs>,
    configureFlags?: GraphCacheUpdateResolver<{ configureFlags: Maybe<WithTypename<ConfigureFlagsPayload>> }, MutationConfigureFlagsArgs>,
    createEmailTemplate?: GraphCacheUpdateResolver<{ createEmailTemplate: Maybe<WithTypename<CreateEmailTemplatePayload>> }, MutationCreateEmailTemplateArgs>,
    createEmailTemplateSavedRow?: GraphCacheUpdateResolver<{ createEmailTemplateSavedRow: Maybe<WithTypename<CreateEmailTemplateSavedRowPayload>> }, MutationCreateEmailTemplateSavedRowArgs>,
    createFlagContact?: GraphCacheUpdateResolver<{ createFlagContact: Maybe<WithTypename<CreateFlagContactPayload>> }, MutationCreateFlagContactArgs>,
    createMatchingLabel?: GraphCacheUpdateResolver<{ createMatchingLabel: Maybe<WithTypename<CreateMatchingLabelPayload>> }, MutationCreateMatchingLabelArgs>,
    createMatchingSurvey?: GraphCacheUpdateResolver<{ createMatchingSurvey: Maybe<WithTypename<CreateMatchingSurveyPayload>> }, MutationCreateMatchingSurveyArgs>,
    createMessageTemplateTag?: GraphCacheUpdateResolver<{ createMessageTemplateTag: Maybe<WithTypename<CreateMessageTemplateTagPayload>> }, MutationCreateMessageTemplateTagArgs>,
    createMicroSurvey?: GraphCacheUpdateResolver<{ createMicroSurvey: Maybe<WithTypename<CreateMicroSurveyPayload>> }, MutationCreateMicroSurveyArgs>,
    createNewCourseTaskAndNewProgramTask?: GraphCacheUpdateResolver<{ createNewCourseTaskAndNewProgramTask: Maybe<WithTypename<CreateNewCourseTaskAndNewProgramTaskPayload>> }, MutationCreateNewCourseTaskAndNewProgramTaskArgs>,
    createNewLinkTaskAndNewProgramTask?: GraphCacheUpdateResolver<{ createNewLinkTaskAndNewProgramTask: Maybe<WithTypename<CreateNewLinkTaskAndNewProgramTaskPayload>> }, MutationCreateNewLinkTaskAndNewProgramTaskArgs>,
    createNotificationView?: GraphCacheUpdateResolver<{ createNotificationView: Maybe<WithTypename<CreateNotificationViewPayload>> }, MutationCreateNotificationViewArgs>,
    createOrEnableNewProgramTask?: GraphCacheUpdateResolver<{ createOrEnableNewProgramTask: Maybe<WithTypename<CreateOrEnableNewProgramTaskPayload>> }, MutationCreateOrEnableNewProgramTaskArgs>,
    createPartner?: GraphCacheUpdateResolver<{ createPartner: Maybe<WithTypename<CreatePartnerPayload>> }, MutationCreatePartnerArgs>,
    createProgram?: GraphCacheUpdateResolver<{ createProgram: Maybe<WithTypename<CreateProgramPayload>> }, MutationCreateProgramArgs>,
    createProgramAutomatchingConfiguration?: GraphCacheUpdateResolver<{ createProgramAutomatchingConfiguration: Maybe<WithTypename<CreateProgramAutomatchingConfigurationPayload>> }, MutationCreateProgramAutomatchingConfigurationArgs>,
    createProgramAutomatchingDefault?: GraphCacheUpdateResolver<{ createProgramAutomatchingDefault: Maybe<WithTypename<CreateProgramAutomatchingDefaultPayload>> }, MutationCreateProgramAutomatchingDefaultArgs>,
    createProgramPageVisit?: GraphCacheUpdateResolver<{ createProgramPageVisit: Maybe<WithTypename<CreateProgramPageVisitPayload>> }, MutationCreateProgramPageVisitArgs>,
    createProgramResource?: GraphCacheUpdateResolver<{ createProgramResource: Maybe<WithTypename<CreateProgramResourcePayload>> }, MutationCreateProgramResourceArgs>,
    createProgramSequence?: GraphCacheUpdateResolver<{ createProgramSequence: Maybe<WithTypename<CreateProgramSequencePayload>> }, MutationCreateProgramSequenceArgs>,
    createProgramTask?: GraphCacheUpdateResolver<{ createProgramTask: Maybe<WithTypename<CreateProgramTaskPayload>> }, MutationCreateProgramTaskArgs>,
    createProgramTopic?: GraphCacheUpdateResolver<{ createProgramTopic: Maybe<WithTypename<CreateProgramTopicPayload>> }, MutationCreateProgramTopicArgs>,
    createSavedMatch?: GraphCacheUpdateResolver<{ createSavedMatch: Maybe<WithTypename<CreateSavedMatchPayload>> }, MutationCreateSavedMatchArgs>,
    createSchool?: GraphCacheUpdateResolver<{ createSchool: Maybe<WithTypename<CreateSchoolPayload>> }, MutationCreateSchoolArgs>,
    createSkeletonMessageTemplate?: GraphCacheUpdateResolver<{ createSkeletonMessageTemplate: Maybe<WithTypename<CreateSkeletonMessageTemplatePayload>> }, MutationCreateSkeletonMessageTemplateArgs>,
    createSmsTemplate?: GraphCacheUpdateResolver<{ createSmsTemplate: Maybe<WithTypename<CreateSmsTemplatePayload>> }, MutationCreateSmsTemplateArgs>,
    createTopic?: GraphCacheUpdateResolver<{ createTopic: Maybe<WithTypename<CreateTopicPayload>> }, MutationCreateTopicArgs>,
    createUploadedVideo?: GraphCacheUpdateResolver<{ createUploadedVideo: Maybe<WithTypename<CreateUploadedVideoPayload>> }, MutationCreateUploadedVideoArgs>,
    deleteFlagContact?: GraphCacheUpdateResolver<{ deleteFlagContact: Maybe<WithTypename<DeleteFlagContactPayload>> }, MutationDeleteFlagContactArgs>,
    deleteMatchingLabel?: GraphCacheUpdateResolver<{ deleteMatchingLabel: Maybe<WithTypename<DeleteMatchingLabelPayload>> }, MutationDeleteMatchingLabelArgs>,
    deleteProgram?: GraphCacheUpdateResolver<{ deleteProgram: Maybe<WithTypename<DeleteProgramPayload>> }, MutationDeleteProgramArgs>,
    deleteProgramContacts?: GraphCacheUpdateResolver<{ deleteProgramContacts: Maybe<WithTypename<DeleteContacts>> }, MutationDeleteProgramContactsArgs>,
    deleteProgramResource?: GraphCacheUpdateResolver<{ deleteProgramResource: Maybe<WithTypename<DeleteProgramResourcePayload>> }, MutationDeleteProgramResourceArgs>,
    deleteProgramSequence?: GraphCacheUpdateResolver<{ deleteProgramSequence: Maybe<WithTypename<DeleteProgramSequencePayload>> }, MutationDeleteProgramSequenceArgs>,
    deleteProgramTask?: GraphCacheUpdateResolver<{ deleteProgramTask: Maybe<WithTypename<DeleteProgramTaskPayload>> }, MutationDeleteProgramTaskArgs>,
    deleteProgramTopic?: GraphCacheUpdateResolver<{ deleteProgramTopic: Maybe<WithTypename<DeleteProgramTopicPayload>> }, MutationDeleteProgramTopicArgs>,
    deleteSavedMatches?: GraphCacheUpdateResolver<{ deleteSavedMatches: WithTypename<DeleteSavedMatches> }, Record<string, never>>,
    deleteSchool?: GraphCacheUpdateResolver<{ deleteSchool: Maybe<WithTypename<DeleteSchoolPayload>> }, MutationDeleteSchoolArgs>,
    deleteSuggestedBatch?: GraphCacheUpdateResolver<{ deleteSuggestedBatch: Maybe<WithTypename<DeleteSuggestedBatchPayload>> }, MutationDeleteSuggestedBatchArgs>,
    denylistEmails?: GraphCacheUpdateResolver<{ denylistEmails: Maybe<WithTypename<DenylistEmailsPayload>> }, MutationDenylistEmailsArgs>,
    deregisterParticipant?: GraphCacheUpdateResolver<{ deregisterParticipant: Maybe<WithTypename<DeregisterParticipantPayload>> }, MutationDeregisterParticipantArgs>,
    disableNewProgramTask?: GraphCacheUpdateResolver<{ disableNewProgramTask: Maybe<WithTypename<DisableNewProgramTaskPayload>> }, MutationDisableNewProgramTaskArgs>,
    dismissProgramAlert?: GraphCacheUpdateResolver<{ dismissProgramAlert: Maybe<WithTypename<DismissProgramAlertPayload>> }, MutationDismissProgramAlertArgs>,
    duplicateMessageTemplates?: GraphCacheUpdateResolver<{ duplicateMessageTemplates: WithTypename<DuplicateMessageTemplates> }, Record<string, never>>,
    duplicateProgram?: GraphCacheUpdateResolver<{ duplicateProgram: Maybe<WithTypename<DuplicateProgramPayload>> }, MutationDuplicateProgramArgs>,
    duplicateProgramSequence?: GraphCacheUpdateResolver<{ duplicateProgramSequence: Maybe<WithTypename<DuplicateProgramSequencePayload>> }, MutationDuplicateProgramSequenceArgs>,
    logTookTypeformSurvey?: GraphCacheUpdateResolver<{ logTookTypeformSurvey: Maybe<WithTypename<LogTookTypeformSurveyPayload>> }, MutationLogTookTypeformSurveyArgs>,
    logWatchedCommunityVideo?: GraphCacheUpdateResolver<{ logWatchedCommunityVideo: Maybe<WithTypename<LogWatchedCommunityVideoPayload>> }, MutationLogWatchedCommunityVideoArgs>,
    logWatchedWistiaVideo?: GraphCacheUpdateResolver<{ logWatchedWistiaVideo: Maybe<WithTypename<LogWatchedWistiaVideoPayload>> }, MutationLogWatchedWistiaVideoArgs>,
    makeBatchMatches?: GraphCacheUpdateResolver<{ makeBatchMatches: Maybe<WithTypename<MakeBatchMatchesPayload>> }, MutationMakeBatchMatchesArgs>,
    makeMatch?: GraphCacheUpdateResolver<{ makeMatch: Maybe<WithTypename<MakeMatchPayload>> }, MutationMakeMatchArgs>,
    makeSavedGroupMatches?: GraphCacheUpdateResolver<{ makeSavedGroupMatches: WithTypename<MakeSavedGroupMatches> }, Record<string, never>>,
    makeSavedMatches?: GraphCacheUpdateResolver<{ makeSavedMatches: WithTypename<MakeSavedMatches> }, Record<string, never>>,
    markParticipantReachedOut?: GraphCacheUpdateResolver<{ markParticipantReachedOut: Maybe<WithTypename<MarkParticipantReachedOutPayload>> }, MutationMarkParticipantReachedOutArgs>,
    moveParticipants?: GraphCacheUpdateResolver<{ moveParticipants: Maybe<WithTypename<MoveParticipantsPayload>> }, MutationMoveParticipantsArgs>,
    previewMatchingSurvey?: GraphCacheUpdateResolver<{ previewMatchingSurvey: Maybe<WithTypename<PreviewMatchingSurveyPayload>> }, MutationPreviewMatchingSurveyArgs>,
    reactivateProgramAlert?: GraphCacheUpdateResolver<{ reactivateProgramAlert: Maybe<WithTypename<ReactivateProgramAlertPayload>> }, MutationReactivateProgramAlertArgs>,
    removeMessageTemplatesTags?: GraphCacheUpdateResolver<{ removeMessageTemplatesTags: WithTypename<RemoveMessageTemplatesTags> }, Record<string, never>>,
    saveBatchMatches?: GraphCacheUpdateResolver<{ saveBatchMatches: Maybe<WithTypename<SaveBatchMatchesPayload>> }, MutationSaveBatchMatchesArgs>,
    saveSurveyResponse?: GraphCacheUpdateResolver<{ saveSurveyResponse: Maybe<WithTypename<SaveSurveyResponsePayload>> }, MutationSaveSurveyResponseArgs>,
    saveWrittenMessage?: GraphCacheUpdateResolver<{ saveWrittenMessage: Maybe<WithTypename<SaveWrittenMessagePayload>> }, MutationSaveWrittenMessageArgs>,
    sendBulkMessageByCsv?: GraphCacheUpdateResolver<{ sendBulkMessageByCsv: Maybe<WithTypename<SendBulkMessageByCsvPayload>> }, MutationSendBulkMessageByCsvArgs>,
    sendPartnerNotifications?: GraphCacheUpdateResolver<{ sendPartnerNotifications: Maybe<WithTypename<SendPartnerNotificationsPayload>> }, MutationSendPartnerNotificationsArgs>,
    sendSsoTestingTemplate?: GraphCacheUpdateResolver<{ sendSsoTestingTemplate: Maybe<WithTypename<SendSsoTestingTemplatePayload>> }, MutationSendSsoTestingTemplateArgs>,
    sendTestMessage?: GraphCacheUpdateResolver<{ sendTestMessage: Maybe<WithTypename<SendTestMessagePayload>> }, MutationSendTestMessageArgs>,
    sendUpdateEmailDraftForMentorship?: GraphCacheUpdateResolver<{ sendUpdateEmailDraftForMentorship: Maybe<WithTypename<SendUpdateEmailDraftForMentorshipPayload>> }, MutationSendUpdateEmailDraftForMentorshipArgs>,
    setupSftp?: GraphCacheUpdateResolver<{ setupSftp: Maybe<WithTypename<SetupSftpPayload>> }, MutationSetupSftpArgs>,
    startFirstWaveRecruitment?: GraphCacheUpdateResolver<{ startFirstWaveRecruitment: Maybe<WithTypename<StartFirstWaveRecruitment>> }, MutationStartFirstWaveRecruitmentArgs>,
    startSecondWaveRecruitment?: GraphCacheUpdateResolver<{ startSecondWaveRecruitment: Maybe<WithTypename<StartSecondWaveRecruitment>> }, MutationStartSecondWaveRecruitmentArgs>,
    stopRecruitment?: GraphCacheUpdateResolver<{ stopRecruitment: Maybe<WithTypename<StopRecruitment>> }, MutationStopRecruitmentArgs>,
    unmatchParticipant?: GraphCacheUpdateResolver<{ unmatchParticipant: Maybe<WithTypename<UnmatchParticipantPayload>> }, MutationUnmatchParticipantArgs>,
    unmatchParticipants?: GraphCacheUpdateResolver<{ unmatchParticipants: Maybe<WithTypename<UnmatchParticipantsPayload>> }, MutationUnmatchParticipantsArgs>,
    updateAssessmentSurveyNewProgramTask?: GraphCacheUpdateResolver<{ updateAssessmentSurveyNewProgramTask: Maybe<WithTypename<UpdateAssessmentSurveyNewProgramTaskPayload>> }, MutationUpdateAssessmentSurveyNewProgramTaskArgs>,
    updateClickLinkNewProgramTask?: GraphCacheUpdateResolver<{ updateClickLinkNewProgramTask: Maybe<WithTypename<UpdateClickLinkNewProgramTaskPayload>> }, MutationUpdateClickLinkNewProgramTaskArgs>,
    updateClickLinkNewTask?: GraphCacheUpdateResolver<{ updateClickLinkNewTask: Maybe<WithTypename<UpdateClickLinkNewTaskPayload>> }, MutationUpdateClickLinkNewTaskArgs>,
    updateCourseNewProgramTask?: GraphCacheUpdateResolver<{ updateCourseNewProgramTask: Maybe<WithTypename<UpdateCourseNewProgramTaskPayload>> }, MutationUpdateCourseNewProgramTaskArgs>,
    updateCourseNewTask?: GraphCacheUpdateResolver<{ updateCourseNewTask: Maybe<WithTypename<UpdateCourseNewTaskPayload>> }, MutationUpdateCourseNewTaskArgs>,
    updateEmailTemplate?: GraphCacheUpdateResolver<{ updateEmailTemplate: Maybe<WithTypename<UpdateEmailTemplatePayload>> }, MutationUpdateEmailTemplateArgs>,
    updateFlag?: GraphCacheUpdateResolver<{ updateFlag: Maybe<WithTypename<UpdateFlagPayload>> }, MutationUpdateFlagArgs>,
    updateFlagContact?: GraphCacheUpdateResolver<{ updateFlagContact: Maybe<WithTypename<UpdateFlagContactPayload>> }, MutationUpdateFlagContactArgs>,
    updateMenteeMentorSettings?: GraphCacheUpdateResolver<{ updateMenteeMentorSettings: Maybe<WithTypename<UpdateMenteeMentorSettingsPayload>> }, MutationUpdateMenteeMentorSettingsArgs>,
    updateMicroSurvey?: GraphCacheUpdateResolver<{ updateMicroSurvey: Maybe<WithTypename<UpdateMicroSurveyPayload>> }, MutationUpdateMicroSurveyArgs>,
    updateNewProgramTask?: GraphCacheUpdateResolver<{ updateNewProgramTask: Maybe<WithTypename<UpdateNewProgramTaskPayload>> }, MutationUpdateNewProgramTaskArgs>,
    updateParticipant?: GraphCacheUpdateResolver<{ updateParticipant: Maybe<WithTypename<UpdateParticipantPayload>> }, MutationUpdateParticipantArgs>,
    updateParticipantsMatchingLabels?: GraphCacheUpdateResolver<{ updateParticipantsMatchingLabels: Maybe<WithTypename<UpdateParticipantsMatchingLabelsPayload>> }, MutationUpdateParticipantsMatchingLabelsArgs>,
    updatePartner?: GraphCacheUpdateResolver<{ updatePartner: Maybe<WithTypename<UpdatePartnerPayload>> }, MutationUpdatePartnerArgs>,
    updateProgramAdmins?: GraphCacheUpdateResolver<{ updateProgramAdmins: Maybe<WithTypename<UpdateProgramAdminsPayload>> }, MutationUpdateProgramAdminsArgs>,
    updateProgramCommunicationSettings?: GraphCacheUpdateResolver<{ updateProgramCommunicationSettings: Maybe<WithTypename<UpdateProgramCommunicationSettingsPayload>> }, MutationUpdateProgramCommunicationSettingsArgs>,
    updateProgramCustomLabel?: GraphCacheUpdateResolver<{ updateProgramCustomLabel: Maybe<WithTypename<UpdateProgramCustomLabelPayload>> }, MutationUpdateProgramCustomLabelArgs>,
    updateProgramCustomMessageTemplates?: GraphCacheUpdateResolver<{ updateProgramCustomMessageTemplates: Maybe<WithTypename<UpdateProgramCustomMessageTemplatesPayload>> }, MutationUpdateProgramCustomMessageTemplatesArgs>,
    updateProgramFlagContacts?: GraphCacheUpdateResolver<{ updateProgramFlagContacts: Maybe<WithTypename<UpdateProgramFlagContactsPayload>> }, MutationUpdateProgramFlagContactsArgs>,
    updateProgramInfo?: GraphCacheUpdateResolver<{ updateProgramInfo: Maybe<WithTypename<UpdateProgramInfoPayload>> }, MutationUpdateProgramInfoArgs>,
    updateProgramPointPeople?: GraphCacheUpdateResolver<{ updateProgramPointPeople: Maybe<WithTypename<UpdateProgramPointPeoplePayload>> }, MutationUpdateProgramPointPeopleArgs>,
    updateProgramSequenceInfo?: GraphCacheUpdateResolver<{ updateProgramSequenceInfo: Maybe<WithTypename<UpdateProgramSequenceInfoPayload>> }, MutationUpdateProgramSequenceInfoArgs>,
    updateProgramSetup?: GraphCacheUpdateResolver<{ updateProgramSetup: Maybe<WithTypename<UpdateProgramSetupPayload>> }, MutationUpdateProgramSetupArgs>,
    updateProgramTask?: GraphCacheUpdateResolver<{ updateProgramTask: Maybe<WithTypename<UpdateProgramTaskPayload>> }, MutationUpdateProgramTaskArgs>,
    updateProgramTopic?: GraphCacheUpdateResolver<{ updateProgramTopic: Maybe<WithTypename<UpdateProgramTopicPayload>> }, MutationUpdateProgramTopicArgs>,
    updateProgramTopics?: GraphCacheUpdateResolver<{ updateProgramTopics: Maybe<WithTypename<UpdateProgramTopicsPayload>> }, MutationUpdateProgramTopicsArgs>,
    updateSchoolInfo?: GraphCacheUpdateResolver<{ updateSchoolInfo: Maybe<WithTypename<UpdateSchoolInfoPayload>> }, MutationUpdateSchoolInfoArgs>,
    updateSmsTemplate?: GraphCacheUpdateResolver<{ updateSmsTemplate: Maybe<WithTypename<UpdateSmsTemplatePayload>> }, MutationUpdateSmsTemplateArgs>,
    updateSurveysAndQuizzes?: GraphCacheUpdateResolver<{ updateSurveysAndQuizzes: Maybe<WithTypename<UpdateSurveysAndQuizzesPayload>> }, MutationUpdateSurveysAndQuizzesArgs>,
    updateTopic?: GraphCacheUpdateResolver<{ updateTopic: Maybe<WithTypename<UpdateTopicPayload>> }, MutationUpdateTopicArgs>,
    updateUser?: GraphCacheUpdateResolver<{ updateUser: Maybe<WithTypename<UpdateUserPayload>> }, MutationUpdateUserArgs>,
    updatedProgramProfileAttributes?: GraphCacheUpdateResolver<{ updatedProgramProfileAttributes: Maybe<WithTypename<UpdateProgramProfileAttributesPayload>> }, MutationUpdatedProgramProfileAttributesArgs>,
    uploadUserProfileData?: GraphCacheUpdateResolver<{ uploadUserProfileData: Maybe<WithTypename<UploadUserProfileDataPayload>> }, MutationUploadUserProfileDataArgs>
  },
  Subscription?: {},
  A2pSms?: {
    content?: GraphCacheUpdateResolver<Maybe<WithTypename<A2pSms>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<A2pSms>>, Record<string, never>>,
    sentAtDate?: GraphCacheUpdateResolver<Maybe<WithTypename<A2pSms>>, Record<string, never>>
  },
  ActivityLog?: {
    eventType?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLog>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLog>>, Record<string, never>>,
    loggableActivity?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLog>>, ActivityLogLoggableActivityArgs>,
    occurredAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLog>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLog>>, Record<string, never>>
  },
  ActivityLogConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalAssessmentSurveySubmittedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalConnectedViaP2pRelayCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalConversationReportedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalFlagReportedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalInitialMatchingSurveyReviewNotificationCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalInvitedAsMenteeCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalInvitedAsMentorCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalLowAhsAssessmentScoreSubmittedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalLowAseAssessmentScoreSubmittedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalLowCdseAssessmentScoreSubmittedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalLowSobAssessmentScoreSubmittedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalLowSrAssessmentScoreSubmittedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalMatchingSurveyUpdatedReviewNotificationCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalMenteeDeregisteredCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalMentorCompletedTrainingCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalMentorDeregisteredCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalMentorMatchingSurveyCompletedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalMentorSignedUpForTrainingCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalMentorshipUnmatchedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalNewMentorshipCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalRegisteredAsMenteeCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalRegisteredAsMentorCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>,
    totalStudentMatchingSurveyCompletedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogConnection>>, Record<string, never>>
  },
  ActivityLogEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<ActivityLogEdge>>, Record<string, never>>
  },
  AddContactsFromExistingProgramPayload?: {
    batchActionId?: GraphCacheUpdateResolver<Maybe<WithTypename<AddContactsFromExistingProgramPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<AddContactsFromExistingProgramPayload>>, Record<string, never>>
  },
  AddContactsPayload?: {
    batchActionId?: GraphCacheUpdateResolver<Maybe<WithTypename<AddContactsPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<AddContactsPayload>>, Record<string, never>>
  },
  AddContactsToExistingUsersPayload?: {
    batchActionId?: GraphCacheUpdateResolver<Maybe<WithTypename<AddContactsToExistingUsersPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<AddContactsToExistingUsersPayload>>, Record<string, never>>
  },
  AddMessageTemplatesTags?: {
    byFilterSelection?: GraphCacheUpdateResolver<Maybe<WithTypename<AddMessageTemplatesTags>>, AddMessageTemplatesTagsByFilterSelectionArgs>,
    byIds?: GraphCacheUpdateResolver<Maybe<WithTypename<AddMessageTemplatesTags>>, AddMessageTemplatesTagsByIdsArgs>
  },
  AddMessageTemplatesTagsByFilterSelectionPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<AddMessageTemplatesTagsByFilterSelectionPayload>>, Record<string, never>>,
    messageTemplates?: GraphCacheUpdateResolver<Maybe<WithTypename<AddMessageTemplatesTagsByFilterSelectionPayload>>, Record<string, never>>,
    numberOfMessageTemplatesUpdated?: GraphCacheUpdateResolver<Maybe<WithTypename<AddMessageTemplatesTagsByFilterSelectionPayload>>, Record<string, never>>
  },
  AddMessageTemplatesTagsByIdsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<AddMessageTemplatesTagsByIdsPayload>>, Record<string, never>>,
    messageTemplates?: GraphCacheUpdateResolver<Maybe<WithTypename<AddMessageTemplatesTagsByIdsPayload>>, Record<string, never>>,
    numberOfMessageTemplatesUpdated?: GraphCacheUpdateResolver<Maybe<WithTypename<AddMessageTemplatesTagsByIdsPayload>>, Record<string, never>>
  },
  AddParticipantsPayload?: {
    batchActionId?: GraphCacheUpdateResolver<Maybe<WithTypename<AddParticipantsPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<AddParticipantsPayload>>, Record<string, never>>
  },
  AdminAction?: {
    adminUser?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminAction>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminAction>>, Record<string, never>>,
    performedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminAction>>, Record<string, never>>,
    resultingChanges?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminAction>>, AdminActionResultingChangesArgs>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminAction>>, Record<string, never>>
  },
  AdminActionConnection?: {
    actionTypes?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminActionConnection>>, Record<string, never>>,
    adminUsers?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminActionConnection>>, Record<string, never>>,
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminActionConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminActionConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminActionConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminActionConnection>>, Record<string, never>>
  },
  AdminActionEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminActionEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<AdminActionEdge>>, Record<string, never>>
  },
  AffectedObjectTypeCount?: {
    count?: GraphCacheUpdateResolver<Maybe<WithTypename<AffectedObjectTypeCount>>, Record<string, never>>,
    eventType?: GraphCacheUpdateResolver<Maybe<WithTypename<AffectedObjectTypeCount>>, Record<string, never>>,
    objectType?: GraphCacheUpdateResolver<Maybe<WithTypename<AffectedObjectTypeCount>>, Record<string, never>>
  },
  ArchiveRestoreMessageTemplates?: {
    byFilterSelection?: GraphCacheUpdateResolver<Maybe<WithTypename<ArchiveRestoreMessageTemplates>>, ArchiveRestoreMessageTemplatesByFilterSelectionArgs>,
    byIds?: GraphCacheUpdateResolver<Maybe<WithTypename<ArchiveRestoreMessageTemplates>>, ArchiveRestoreMessageTemplatesByIdsArgs>
  },
  ArchiveRestoreMessageTemplatesByFilterSelectionPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<ArchiveRestoreMessageTemplatesByFilterSelectionPayload>>, Record<string, never>>,
    messageTemplates?: GraphCacheUpdateResolver<Maybe<WithTypename<ArchiveRestoreMessageTemplatesByFilterSelectionPayload>>, Record<string, never>>,
    numberOfMessageTemplatesUpdated?: GraphCacheUpdateResolver<Maybe<WithTypename<ArchiveRestoreMessageTemplatesByFilterSelectionPayload>>, Record<string, never>>
  },
  ArchiveRestoreMessageTemplatesByIdsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<ArchiveRestoreMessageTemplatesByIdsPayload>>, Record<string, never>>,
    messageTemplates?: GraphCacheUpdateResolver<Maybe<WithTypename<ArchiveRestoreMessageTemplatesByIdsPayload>>, Record<string, never>>,
    numberOfMessageTemplatesUpdated?: GraphCacheUpdateResolver<Maybe<WithTypename<ArchiveRestoreMessageTemplatesByIdsPayload>>, Record<string, never>>
  },
  AssessmentArea?: {
    assessmentPrompts?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentArea>>, AssessmentAreaAssessmentPromptsArgs>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentArea>>, Record<string, never>>,
    identifier?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentArea>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentArea>>, Record<string, never>>
  },
  AssessmentPrompt?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentPrompt>>, Record<string, never>>,
    identifier?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentPrompt>>, Record<string, never>>,
    text?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentPrompt>>, Record<string, never>>
  },
  AssessmentScoreResponse?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentScoreResponse>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentScoreResponse>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentScoreResponse>>, Record<string, never>>
  },
  AssessmentScoreResponsesMetrics?: {
    averageAssessmentScore?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentScoreResponsesMetrics>>, AssessmentScoreResponsesMetricsAverageAssessmentScoreArgs>
  },
  AssessmentSurveyTaskAssignment?: {
    behavior?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentSurveyTaskAssignment>>, Record<string, never>>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentSurveyTaskAssignment>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentSurveyTaskAssignment>>, Record<string, never>>,
    participantId?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentSurveyTaskAssignment>>, Record<string, never>>,
    position?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentSurveyTaskAssignment>>, Record<string, never>>,
    programStage?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentSurveyTaskAssignment>>, Record<string, never>>,
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentSurveyTaskAssignment>>, Record<string, never>>,
    surveyId?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentSurveyTaskAssignment>>, Record<string, never>>,
    userId?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentSurveyTaskAssignment>>, Record<string, never>>
  },
  AssessmentSurveyTaskContext?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentSurveyTaskContext>>, Record<string, never>>,
    newTask?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentSurveyTaskContext>>, Record<string, never>>,
    programStage?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentSurveyTaskContext>>, Record<string, never>>,
    surveyId?: GraphCacheUpdateResolver<Maybe<WithTypename<AssessmentSurveyTaskContext>>, Record<string, never>>
  },
  AutoMatchSettings?: {
    mentorCapacityCap?: GraphCacheUpdateResolver<Maybe<WithTypename<AutoMatchSettings>>, Record<string, never>>,
    scoreThreshold?: GraphCacheUpdateResolver<Maybe<WithTypename<AutoMatchSettings>>, Record<string, never>>,
    standardMatching?: GraphCacheUpdateResolver<Maybe<WithTypename<AutoMatchSettings>>, Record<string, never>>,
    standardScoreThreshold?: GraphCacheUpdateResolver<Maybe<WithTypename<AutoMatchSettings>>, Record<string, never>>,
    supermentorMatching?: GraphCacheUpdateResolver<Maybe<WithTypename<AutoMatchSettings>>, Record<string, never>>,
    supermentorScoreThreshold?: GraphCacheUpdateResolver<Maybe<WithTypename<AutoMatchSettings>>, Record<string, never>>
  },
  AutoSuggestMatchesPayload?: {
    batchId?: GraphCacheUpdateResolver<Maybe<WithTypename<AutoSuggestMatchesPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<AutoSuggestMatchesPayload>>, Record<string, never>>
  },
  AutomatchingDefault?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<AutomatchingDefault>>, Record<string, never>>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<AutomatchingDefault>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AutomatchingDefault>>, Record<string, never>>,
    identifier?: GraphCacheUpdateResolver<Maybe<WithTypename<AutomatchingDefault>>, Record<string, never>>,
    settings?: GraphCacheUpdateResolver<Maybe<WithTypename<AutomatchingDefault>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<AutomatchingDefault>>, Record<string, never>>
  },
  CachedUserProfileDataAttributeValue?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CachedUserProfileDataAttributeValue>>, Record<string, never>>,
    profileAttribute?: GraphCacheUpdateResolver<Maybe<WithTypename<CachedUserProfileDataAttributeValue>>, Record<string, never>>,
    values?: GraphCacheUpdateResolver<Maybe<WithTypename<CachedUserProfileDataAttributeValue>>, Record<string, never>>
  },
  ChangeMentorTrainingStatusPayload?: {
    batchActionId?: GraphCacheUpdateResolver<Maybe<WithTypename<ChangeMentorTrainingStatusPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<ChangeMentorTrainingStatusPayload>>, Record<string, never>>
  },
  ClickLinkTaskAssignment?: {
    behavior?: GraphCacheUpdateResolver<Maybe<WithTypename<ClickLinkTaskAssignment>>, Record<string, never>>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<ClickLinkTaskAssignment>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ClickLinkTaskAssignment>>, Record<string, never>>,
    participantId?: GraphCacheUpdateResolver<Maybe<WithTypename<ClickLinkTaskAssignment>>, Record<string, never>>,
    position?: GraphCacheUpdateResolver<Maybe<WithTypename<ClickLinkTaskAssignment>>, Record<string, never>>,
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<ClickLinkTaskAssignment>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<ClickLinkTaskAssignment>>, Record<string, never>>,
    userId?: GraphCacheUpdateResolver<Maybe<WithTypename<ClickLinkTaskAssignment>>, Record<string, never>>
  },
  CompleteTaskAssignmentPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CompleteTaskAssignmentPayload>>, Record<string, never>>,
    taskAssignment?: GraphCacheUpdateResolver<Maybe<WithTypename<CompleteTaskAssignmentPayload>>, Record<string, never>>
  },
  ConfigureFlagsError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<ConfigureFlagsError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<ConfigureFlagsError>>, Record<string, never>>
  },
  ConfigureFlagsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<ConfigureFlagsPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<ConfigureFlagsPayload>>, Record<string, never>>
  },
  ContactConnection?: {
    activatedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactConnection>>, Record<string, never>>,
    batchActionIds?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactConnection>>, Record<string, never>>,
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactConnection>>, Record<string, never>>,
    mentorContactCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactConnection>>, Record<string, never>>,
    notActivatedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactConnection>>, Record<string, never>>,
    registeredCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactConnection>>, Record<string, never>>,
    secondWaveCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactConnection>>, Record<string, never>>,
    studentContactCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactConnection>>, Record<string, never>>,
    totalCountOfDistinctUsers?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactConnection>>, Record<string, never>>,
    uploadedByUsers?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactConnection>>, Record<string, never>>
  },
  ContactEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactEdge>>, Record<string, never>>
  },
  ContactsMetrics?: {
    totalInvited?: GraphCacheUpdateResolver<Maybe<WithTypename<ContactsMetrics>>, ContactsMetricsTotalInvitedArgs>
  },
  ContentfulModuleResource?: {
    contentfulUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentfulModuleResource>>, Record<string, never>>,
    icon?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentfulModuleResource>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentfulModuleResource>>, Record<string, never>>,
    identifier?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentfulModuleResource>>, Record<string, never>>,
    sections?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentfulModuleResource>>, Record<string, never>>
  },
  ContentfulModuleSection?: {
    examples?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentfulModuleSection>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentfulModuleSection>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentfulModuleSection>>, Record<string, never>>,
    options?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentfulModuleSection>>, Record<string, never>>,
    text?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentfulModuleSection>>, Record<string, never>>,
    visibleToMentee?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentfulModuleSection>>, Record<string, never>>,
    visibleToMentor?: GraphCacheUpdateResolver<Maybe<WithTypename<ContentfulModuleSection>>, Record<string, never>>
  },
  ConversationLog?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ConversationLog>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ConversationLog>>, Record<string, never>>,
    loggedAtDate?: GraphCacheUpdateResolver<Maybe<WithTypename<ConversationLog>>, Record<string, never>>,
    mentorship?: GraphCacheUpdateResolver<Maybe<WithTypename<ConversationLog>>, Record<string, never>>,
    modesOfCommunication?: GraphCacheUpdateResolver<Maybe<WithTypename<ConversationLog>>, Record<string, never>>,
    topics?: GraphCacheUpdateResolver<Maybe<WithTypename<ConversationLog>>, Record<string, never>>
  },
  Country?: {
    code?: GraphCacheUpdateResolver<Maybe<WithTypename<Country>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Country>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Country>>, Record<string, never>>
  },
  Course?: {
    active?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    externalServiceId?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    published?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    serviceName?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>,
    slug?: GraphCacheUpdateResolver<Maybe<WithTypename<Course>>, Record<string, never>>
  },
  CourseConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseConnection>>, Record<string, never>>
  },
  CourseEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseEdge>>, Record<string, never>>
  },
  CourseTaskAssignment?: {
    behavior?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseTaskAssignment>>, Record<string, never>>,
    courseId?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseTaskAssignment>>, Record<string, never>>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseTaskAssignment>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseTaskAssignment>>, Record<string, never>>,
    participantId?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseTaskAssignment>>, Record<string, never>>,
    position?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseTaskAssignment>>, Record<string, never>>,
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseTaskAssignment>>, Record<string, never>>,
    userId?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseTaskAssignment>>, Record<string, never>>
  },
  CourseTaskContext?: {
    courseId?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseTaskContext>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseTaskContext>>, Record<string, never>>,
    newTask?: GraphCacheUpdateResolver<Maybe<WithTypename<CourseTaskContext>>, Record<string, never>>
  },
  CreateEmailTemplatePayload?: {
    emailTemplate?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateEmailTemplatePayload>>, Record<string, never>>
  },
  CreateEmailTemplateSavedRowPayload?: {
    emailTemplateSavedRow?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateEmailTemplateSavedRowPayload>>, Record<string, never>>
  },
  CreateFlagContactPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateFlagContactPayload>>, Record<string, never>>,
    flagContacts?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateFlagContactPayload>>, Record<string, never>>
  },
  CreateMatchingLabelPayload?: {
    matchingLabel?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateMatchingLabelPayload>>, Record<string, never>>,
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateMatchingLabelPayload>>, Record<string, never>>
  },
  CreateMatchingSurveyPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateMatchingSurveyPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateMatchingSurveyPayload>>, Record<string, never>>,
    surveys?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateMatchingSurveyPayload>>, Record<string, never>>
  },
  CreateMessageTemplateTagPayload?: {
    messageTemplateTag?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateMessageTemplateTagPayload>>, Record<string, never>>
  },
  CreateMicroSurveyPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateMicroSurveyPayload>>, Record<string, never>>,
    microSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateMicroSurveyPayload>>, Record<string, never>>
  },
  CreateNewCourseTaskAndNewProgramTaskPayload?: {
    duplicateTasks?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateNewCourseTaskAndNewProgramTaskPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateNewCourseTaskAndNewProgramTaskPayload>>, Record<string, never>>,
    newProgramTask?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateNewCourseTaskAndNewProgramTaskPayload>>, Record<string, never>>,
    newTask?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateNewCourseTaskAndNewProgramTaskPayload>>, Record<string, never>>
  },
  CreateNewLinkTaskAndNewProgramTaskPayload?: {
    duplicateTasks?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateNewLinkTaskAndNewProgramTaskPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateNewLinkTaskAndNewProgramTaskPayload>>, Record<string, never>>,
    newProgramTask?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateNewLinkTaskAndNewProgramTaskPayload>>, Record<string, never>>,
    newTask?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateNewLinkTaskAndNewProgramTaskPayload>>, Record<string, never>>
  },
  CreateNotificationViewPayload?: {
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateNotificationViewPayload>>, Record<string, never>>
  },
  CreateOrEnableNewProgramTaskPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateOrEnableNewProgramTaskPayload>>, Record<string, never>>,
    newProgramTask?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateOrEnableNewProgramTaskPayload>>, Record<string, never>>
  },
  CreatePartnerPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreatePartnerPayload>>, Record<string, never>>,
    partners?: GraphCacheUpdateResolver<Maybe<WithTypename<CreatePartnerPayload>>, Record<string, never>>
  },
  CreateProgramAutomatchingConfigurationPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramAutomatchingConfigurationPayload>>, Record<string, never>>,
    programAutomatchingConfiguration?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramAutomatchingConfigurationPayload>>, Record<string, never>>
  },
  CreateProgramAutomatchingDefaultPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramAutomatchingDefaultPayload>>, Record<string, never>>,
    programAutomatchingDefault?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramAutomatchingDefaultPayload>>, Record<string, never>>
  },
  CreateProgramError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramError>>, Record<string, never>>
  },
  CreateProgramPageVisitPayload?: {
    programPageVisit?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramPageVisitPayload>>, Record<string, never>>
  },
  CreateProgramPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramPayload>>, Record<string, never>>
  },
  CreateProgramResourceError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramResourceError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramResourceError>>, Record<string, never>>
  },
  CreateProgramResourcePayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramResourcePayload>>, Record<string, never>>,
    programResource?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramResourcePayload>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramResourcePayload>>, Record<string, never>>
  },
  CreateProgramSequenceError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramSequenceError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramSequenceError>>, Record<string, never>>
  },
  CreateProgramSequencePayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramSequencePayload>>, Record<string, never>>,
    programSequence?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramSequencePayload>>, Record<string, never>>
  },
  CreateProgramTaskPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramTaskPayload>>, Record<string, never>>,
    programTask?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramTaskPayload>>, Record<string, never>>
  },
  CreateProgramTopicPayload?: {
    programTopic?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateProgramTopicPayload>>, Record<string, never>>
  },
  CreateSavedMatchPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateSavedMatchPayload>>, Record<string, never>>,
    savedMatch?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateSavedMatchPayload>>, Record<string, never>>
  },
  CreateSchoolError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateSchoolError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateSchoolError>>, Record<string, never>>
  },
  CreateSchoolPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateSchoolPayload>>, Record<string, never>>,
    school?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateSchoolPayload>>, Record<string, never>>
  },
  CreateSkeletonMessageTemplatePayload?: {
    skeletonMessageTemplate?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateSkeletonMessageTemplatePayload>>, Record<string, never>>
  },
  CreateSmsTemplatePayload?: {
    smsTemplate?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateSmsTemplatePayload>>, Record<string, never>>
  },
  CreateTopicPayload?: {
    topic?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateTopicPayload>>, Record<string, never>>
  },
  CreateUploadedVideoPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateUploadedVideoPayload>>, Record<string, never>>,
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateUploadedVideoPayload>>, Record<string, never>>
  },
  CsvExport?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<CsvExport>>, Record<string, never>>,
    filename?: GraphCacheUpdateResolver<Maybe<WithTypename<CsvExport>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CsvExport>>, Record<string, never>>,
    isProcessing?: GraphCacheUpdateResolver<Maybe<WithTypename<CsvExport>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<CsvExport>>, Record<string, never>>
  },
  CsvExports?: {
    matchedUsersReport?: GraphCacheUpdateResolver<Maybe<WithTypename<CsvExports>>, CsvExportsMatchedUsersReportArgs>,
    menteeMentorQuotes?: GraphCacheUpdateResolver<Maybe<WithTypename<CsvExports>>, CsvExportsMenteeMentorQuotesArgs>,
    mentorshipEngagementData?: GraphCacheUpdateResolver<Maybe<WithTypename<CsvExports>>, CsvExportsMentorshipEngagementDataArgs>,
    participantsProfileData?: GraphCacheUpdateResolver<Maybe<WithTypename<CsvExports>>, CsvExportsParticipantsProfileDataArgs>,
    partnerDashboardExports?: GraphCacheUpdateResolver<Maybe<WithTypename<CsvExports>>, Record<string, never>>,
    recruitmentOpportunities?: GraphCacheUpdateResolver<Maybe<WithTypename<CsvExports>>, CsvExportsRecruitmentOpportunitiesArgs>,
    surveyResponses?: GraphCacheUpdateResolver<Maybe<WithTypename<CsvExports>>, CsvExportsSurveyResponsesArgs>,
    writtenTestimonials?: GraphCacheUpdateResolver<Maybe<WithTypename<CsvExports>>, CsvExportsWrittenTestimonialsArgs>
  },
  CustomMessageTypeTemplateRequirement?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomMessageTypeTemplateRequirement>>, Record<string, never>>,
    customMessageType?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomMessageTypeTemplateRequirement>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomMessageTypeTemplateRequirement>>, Record<string, never>>,
    messageCategory?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomMessageTypeTemplateRequirement>>, Record<string, never>>,
    messageType?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomMessageTypeTemplateRequirement>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomMessageTypeTemplateRequirement>>, Record<string, never>>,
    userState?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomMessageTypeTemplateRequirement>>, Record<string, never>>
  },
  CustomMessageTypeTemplateRequirementConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomMessageTypeTemplateRequirementConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomMessageTypeTemplateRequirementConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomMessageTypeTemplateRequirementConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomMessageTypeTemplateRequirementConnection>>, Record<string, never>>
  },
  CustomMessageTypeTemplateRequirementEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomMessageTypeTemplateRequirementEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<CustomMessageTypeTemplateRequirementEdge>>, Record<string, never>>
  },
  DeleteContacts?: {
    byFilterSelection?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteContacts>>, DeleteContactsByFilterSelectionArgs>,
    byIds?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteContacts>>, DeleteContactsByIdsArgs>
  },
  DeleteContactsByFilterSelectionPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteContactsByFilterSelectionPayload>>, Record<string, never>>,
    numberOfContactsDeleted?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteContactsByFilterSelectionPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteContactsByFilterSelectionPayload>>, Record<string, never>>
  },
  DeleteContactsByIdsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteContactsByIdsPayload>>, Record<string, never>>,
    numberOfContactsDeleted?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteContactsByIdsPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteContactsByIdsPayload>>, Record<string, never>>
  },
  DeleteFlagContactPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteFlagContactPayload>>, Record<string, never>>
  },
  DeleteMatchingLabelPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteMatchingLabelPayload>>, Record<string, never>>,
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteMatchingLabelPayload>>, Record<string, never>>
  },
  DeleteProgramPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteProgramPayload>>, Record<string, never>>
  },
  DeleteProgramResourcePayload?: {
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteProgramResourcePayload>>, Record<string, never>>
  },
  DeleteProgramSequencePayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteProgramSequencePayload>>, Record<string, never>>
  },
  DeleteProgramTaskPayload?: {
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteProgramTaskPayload>>, Record<string, never>>,
    programSequence?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteProgramTaskPayload>>, Record<string, never>>
  },
  DeleteProgramTopicPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteProgramTopicPayload>>, Record<string, never>>
  },
  DeleteSavedMatches?: {
    byFilter?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteSavedMatches>>, DeleteSavedMatchesByFilterArgs>,
    byIds?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteSavedMatches>>, DeleteSavedMatchesByIdsArgs>
  },
  DeleteSavedMatchesByFilterPayload?: {
    deletedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteSavedMatchesByFilterPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteSavedMatchesByFilterPayload>>, Record<string, never>>
  },
  DeleteSavedMatchesByIdsPayload?: {
    deletedCount?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteSavedMatchesByIdsPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteSavedMatchesByIdsPayload>>, Record<string, never>>
  },
  DeleteSchoolPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteSchoolPayload>>, Record<string, never>>
  },
  DeleteSuggestedBatchPayload?: {
    deletedId?: GraphCacheUpdateResolver<Maybe<WithTypename<DeleteSuggestedBatchPayload>>, Record<string, never>>
  },
  DenylistEmailsPayload?: {
    batchActionId?: GraphCacheUpdateResolver<Maybe<WithTypename<DenylistEmailsPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DenylistEmailsPayload>>, Record<string, never>>
  },
  DeregisterParticipantPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregisterParticipantPayload>>, Record<string, never>>,
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregisterParticipantPayload>>, Record<string, never>>
  },
  DeregistrationReason?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationReason>>, Record<string, never>>,
    grouping?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationReason>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationReason>>, Record<string, never>>,
    identifier?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationReason>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationReason>>, Record<string, never>>,
    participantFacingName?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationReason>>, Record<string, never>>
  },
  DeregistrationReasonConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationReasonConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationReasonConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationReasonConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationReasonConnection>>, Record<string, never>>
  },
  DeregistrationReasonEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationReasonEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationReasonEdge>>, Record<string, never>>
  },
  DeregistrationStatusEvent?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationStatusEvent>>, Record<string, never>>,
    deregistrationReason?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationStatusEvent>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationStatusEvent>>, Record<string, never>>,
    kind?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationStatusEvent>>, Record<string, never>>,
    otherReasonNotes?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationStatusEvent>>, Record<string, never>>,
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<DeregistrationStatusEvent>>, Record<string, never>>
  },
  DisableNewProgramTaskPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DisableNewProgramTaskPayload>>, Record<string, never>>,
    newProgramTask?: GraphCacheUpdateResolver<Maybe<WithTypename<DisableNewProgramTaskPayload>>, Record<string, never>>
  },
  DisengagementResolutionsAverageTimeToRematchResult?: {
    averageRematchTimeInDays?: GraphCacheUpdateResolver<Maybe<WithTypename<DisengagementResolutionsAverageTimeToRematchResult>>, Record<string, never>>
  },
  DisengagementResolutionsMetricsResult?: {
    metric?: GraphCacheUpdateResolver<Maybe<WithTypename<DisengagementResolutionsMetricsResult>>, Record<string, never>>,
    value?: GraphCacheUpdateResolver<Maybe<WithTypename<DisengagementResolutionsMetricsResult>>, Record<string, never>>
  },
  DismissProgramAlertPayload?: {
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<DismissProgramAlertPayload>>, Record<string, never>>
  },
  DuplicateError?: {
    duplicateNewTaskId?: GraphCacheUpdateResolver<Maybe<WithTypename<DuplicateError>>, Record<string, never>>,
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<DuplicateError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<DuplicateError>>, Record<string, never>>
  },
  DuplicateMessageTemplates?: {
    byFilterSelection?: GraphCacheUpdateResolver<Maybe<WithTypename<DuplicateMessageTemplates>>, DuplicateMessageTemplatesByFilterSelectionArgs>,
    byIds?: GraphCacheUpdateResolver<Maybe<WithTypename<DuplicateMessageTemplates>>, DuplicateMessageTemplatesByIdsArgs>
  },
  DuplicateMessageTemplatesByFilterSelectionPayload?: {
    newMessageTemplates?: GraphCacheUpdateResolver<Maybe<WithTypename<DuplicateMessageTemplatesByFilterSelectionPayload>>, DuplicateMessageTemplatesByFilterSelectionPayloadNewMessageTemplatesArgs>
  },
  DuplicateMessageTemplatesByIdsPayload?: {
    newMessageTemplates?: GraphCacheUpdateResolver<Maybe<WithTypename<DuplicateMessageTemplatesByIdsPayload>>, DuplicateMessageTemplatesByIdsPayloadNewMessageTemplatesArgs>
  },
  DuplicateProgramPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DuplicateProgramPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<DuplicateProgramPayload>>, Record<string, never>>,
    successMessages?: GraphCacheUpdateResolver<Maybe<WithTypename<DuplicateProgramPayload>>, Record<string, never>>
  },
  DuplicateProgramSequencePayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<DuplicateProgramSequencePayload>>, Record<string, never>>,
    programSequence?: GraphCacheUpdateResolver<Maybe<WithTypename<DuplicateProgramSequencePayload>>, Record<string, never>>
  },
  DwhParticipantsMetrics?: {
    menteesRegistered?: GraphCacheUpdateResolver<Maybe<WithTypename<DwhParticipantsMetrics>>, Record<string, never>>,
    mentorsRegistered?: GraphCacheUpdateResolver<Maybe<WithTypename<DwhParticipantsMetrics>>, Record<string, never>>,
    participantsRegistered?: GraphCacheUpdateResolver<Maybe<WithTypename<DwhParticipantsMetrics>>, Record<string, never>>,
    programId?: GraphCacheUpdateResolver<Maybe<WithTypename<DwhParticipantsMetrics>>, Record<string, never>>,
    programName?: GraphCacheUpdateResolver<Maybe<WithTypename<DwhParticipantsMetrics>>, Record<string, never>>
  },
  DwhParticipantsMetricsConnection?: {
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<DwhParticipantsMetricsConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<DwhParticipantsMetricsConnection>>, Record<string, never>>,
    totalMenteesRegisteredCount?: GraphCacheUpdateResolver<Maybe<WithTypename<DwhParticipantsMetricsConnection>>, Record<string, never>>,
    totalMentorsRegisteredCount?: GraphCacheUpdateResolver<Maybe<WithTypename<DwhParticipantsMetricsConnection>>, Record<string, never>>,
    totalParticipantsRegisteredCount?: GraphCacheUpdateResolver<Maybe<WithTypename<DwhParticipantsMetricsConnection>>, Record<string, never>>
  },
  DwhQueryableMetrics?: {
    participants?: GraphCacheUpdateResolver<Maybe<WithTypename<DwhQueryableMetrics>>, DwhQueryableMetricsParticipantsArgs>
  },
  EmailTemplate?: {
    archivedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    category?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    content?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    createdBy?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    customMessageType?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    identifier?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    isDefault?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    lastEditedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    lastEditedBy?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    messageType?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    preheaderText?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    programSegment?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    subjectLine?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    tags?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    templateEditorData?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>,
    userState?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplate>>, Record<string, never>>
  },
  EmailTemplateSavedRow?: {
    category?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplateSavedRow>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplateSavedRow>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplateSavedRow>>, Record<string, never>>,
    templateEditorData?: GraphCacheUpdateResolver<Maybe<WithTypename<EmailTemplateSavedRow>>, Record<string, never>>
  },
  EngagementBenchmarkData?: {
    disengagedMenteesInPreviousProgram?: GraphCacheUpdateResolver<Maybe<WithTypename<EngagementBenchmarkData>>, Record<string, never>>,
    disengagedMentorsInPreviousProgram?: GraphCacheUpdateResolver<Maybe<WithTypename<EngagementBenchmarkData>>, Record<string, never>>,
    mentorshipsInPreviousProgramEngagedInLast30Days?: GraphCacheUpdateResolver<Maybe<WithTypename<EngagementBenchmarkData>>, Record<string, never>>,
    mentorshipsInPreviousProgramUsingSmsRelay?: GraphCacheUpdateResolver<Maybe<WithTypename<EngagementBenchmarkData>>, Record<string, never>>,
    mentorshipsInPreviousProgramWith0Conversations?: GraphCacheUpdateResolver<Maybe<WithTypename<EngagementBenchmarkData>>, Record<string, never>>,
    mentorshipsInPreviousProgramWith3OrMoreConversations?: GraphCacheUpdateResolver<Maybe<WithTypename<EngagementBenchmarkData>>, Record<string, never>>,
    totalCountWithConversationInTheLast30Days?: GraphCacheUpdateResolver<Maybe<WithTypename<EngagementBenchmarkData>>, Record<string, never>>,
    totalCountWithThreeOrMoreConversations?: GraphCacheUpdateResolver<Maybe<WithTypename<EngagementBenchmarkData>>, Record<string, never>>,
    totalCountWithZeroConversations?: GraphCacheUpdateResolver<Maybe<WithTypename<EngagementBenchmarkData>>, Record<string, never>>,
    totalMenteesInPreviousProgram?: GraphCacheUpdateResolver<Maybe<WithTypename<EngagementBenchmarkData>>, Record<string, never>>,
    totalMentorsInPreviousProgram?: GraphCacheUpdateResolver<Maybe<WithTypename<EngagementBenchmarkData>>, Record<string, never>>,
    totalMentorshipsForPreviousProgram?: GraphCacheUpdateResolver<Maybe<WithTypename<EngagementBenchmarkData>>, Record<string, never>>
  },
  Error?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<Error>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<Error>>, Record<string, never>>
  },
  ExternalLink?: {
    href?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalLink>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalLink>>, Record<string, never>>,
    kind?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalLink>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ExternalLink>>, Record<string, never>>
  },
  Flag?: {
    additionalInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<Flag>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Flag>>, Record<string, never>>,
    flagCategories?: GraphCacheUpdateResolver<Maybe<WithTypename<Flag>>, FlagFlagCategoriesArgs>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Flag>>, Record<string, never>>,
    mentorship?: GraphCacheUpdateResolver<Maybe<WithTypename<Flag>>, Record<string, never>>,
    participantConversationContent?: GraphCacheUpdateResolver<Maybe<WithTypename<Flag>>, Record<string, never>>,
    partnerNotes?: GraphCacheUpdateResolver<Maybe<WithTypename<Flag>>, Record<string, never>>,
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<Flag>>, Record<string, never>>,
    submittedBy?: GraphCacheUpdateResolver<Maybe<WithTypename<Flag>>, Record<string, never>>,
    supportPriority?: GraphCacheUpdateResolver<Maybe<WithTypename<Flag>>, Record<string, never>>
  },
  FlagCategory?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagCategory>>, Record<string, never>>,
    identifier?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagCategory>>, Record<string, never>>,
    label?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagCategory>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagCategory>>, Record<string, never>>,
    smsCharacter?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagCategory>>, Record<string, never>>
  },
  FlagConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagConnection>>, Record<string, never>>,
    flagCategoriesSubmitted?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagConnection>>, Record<string, never>>
  },
  FlagContact?: {
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagContact>>, Record<string, never>>,
    firstName?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagContact>>, Record<string, never>>,
    flagCategories?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagContact>>, FlagContactFlagCategoriesArgs>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagContact>>, Record<string, never>>,
    lastName?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagContact>>, Record<string, never>>
  },
  FlagEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagEdge>>, Record<string, never>>
  },
  FlagPageVisit?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagPageVisit>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagPageVisit>>, Record<string, never>>
  },
  FlagPageVisitConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagPageVisitConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagPageVisitConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagPageVisitConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagPageVisitConnection>>, Record<string, never>>
  },
  FlagPageVisitEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagPageVisitEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagPageVisitEdge>>, Record<string, never>>
  },
  FlagsMetrics?: {
    totalFlagged?: GraphCacheUpdateResolver<Maybe<WithTypename<FlagsMetrics>>, FlagsMetricsTotalFlaggedArgs>
  },
  Goal?: {
    archived?: GraphCacheUpdateResolver<Maybe<WithTypename<Goal>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Goal>>, Record<string, never>>,
    identifier?: GraphCacheUpdateResolver<Maybe<WithTypename<Goal>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Goal>>, Record<string, never>>
  },
  GoalConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<GoalConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<GoalConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<GoalConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<GoalConnection>>, Record<string, never>>
  },
  GoalEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<GoalEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<GoalEdge>>, Record<string, never>>
  },
  GroupMatchingSettings?: {
    maxGroupSize?: GraphCacheUpdateResolver<Maybe<WithTypename<GroupMatchingSettings>>, Record<string, never>>,
    minGroupSize?: GraphCacheUpdateResolver<Maybe<WithTypename<GroupMatchingSettings>>, Record<string, never>>
  },
  Image?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Image>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<Image>>, ImageUrlArgs>
  },
  Interval?: {
    date?: GraphCacheUpdateResolver<Maybe<WithTypename<Interval>>, Record<string, never>>,
    group?: GraphCacheUpdateResolver<Maybe<WithTypename<Interval>>, Record<string, never>>,
    sampleSize?: GraphCacheUpdateResolver<Maybe<WithTypename<Interval>>, Record<string, never>>,
    value?: GraphCacheUpdateResolver<Maybe<WithTypename<Interval>>, Record<string, never>>,
    valueType?: GraphCacheUpdateResolver<Maybe<WithTypename<Interval>>, Record<string, never>>
  },
  LinkTaskContext?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<LinkTaskContext>>, Record<string, never>>,
    newTask?: GraphCacheUpdateResolver<Maybe<WithTypename<LinkTaskContext>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<LinkTaskContext>>, Record<string, never>>
  },
  LogTookTypeformSurveyPayload?: {
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<LogTookTypeformSurveyPayload>>, Record<string, never>>
  },
  LogWatchedCommunityVideoPayload?: {
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<LogWatchedCommunityVideoPayload>>, Record<string, never>>
  },
  LogWatchedWistiaVideoPayload?: {
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<LogWatchedWistiaVideoPayload>>, Record<string, never>>
  },
  MakeBatchMatchesPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeBatchMatchesPayload>>, Record<string, never>>,
    suggestedBatch?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeBatchMatchesPayload>>, Record<string, never>>
  },
  MakeMatchPayload?: {
    deletedSavedMatchId?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeMatchPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeMatchPayload>>, Record<string, never>>,
    mentor?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeMatchPayload>>, Record<string, never>>,
    showAllowRematchConfirm?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeMatchPayload>>, Record<string, never>>,
    student?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeMatchPayload>>, Record<string, never>>
  },
  MakeSavedGroupMatches?: {
    byFilter?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedGroupMatches>>, MakeSavedGroupMatchesByFilterArgs>,
    byIds?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedGroupMatches>>, MakeSavedGroupMatchesByIdsArgs>
  },
  MakeSavedGroupMatchesByFilterPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedGroupMatchesByFilterPayload>>, Record<string, never>>,
    queuedGroupsCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedGroupMatchesByFilterPayload>>, Record<string, never>>,
    queuedMatchesCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedGroupMatchesByFilterPayload>>, Record<string, never>>,
    savedMatchIds?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedGroupMatchesByFilterPayload>>, Record<string, never>>
  },
  MakeSavedGroupMatchesByIdsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedGroupMatchesByIdsPayload>>, Record<string, never>>,
    queuedGroupsCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedGroupMatchesByIdsPayload>>, Record<string, never>>,
    queuedMatchesCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedGroupMatchesByIdsPayload>>, Record<string, never>>,
    savedMatchIds?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedGroupMatchesByIdsPayload>>, Record<string, never>>
  },
  MakeSavedMatches?: {
    byFilter?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedMatches>>, MakeSavedMatchesByFilterArgs>,
    byIds?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedMatches>>, MakeSavedMatchesByIdsArgs>
  },
  MakeSavedMatchesByFilterPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedMatchesByFilterPayload>>, Record<string, never>>,
    queuedMatchesCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedMatchesByFilterPayload>>, Record<string, never>>,
    savedMatchIds?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedMatchesByFilterPayload>>, Record<string, never>>
  },
  MakeSavedMatchesByIdsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedMatchesByIdsPayload>>, Record<string, never>>,
    queuedMatchesCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedMatchesByIdsPayload>>, Record<string, never>>,
    savedMatchIds?: GraphCacheUpdateResolver<Maybe<WithTypename<MakeSavedMatchesByIdsPayload>>, Record<string, never>>
  },
  MarkParticipantReachedOutPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<MarkParticipantReachedOutPayload>>, Record<string, never>>,
    mentorship?: GraphCacheUpdateResolver<Maybe<WithTypename<MarkParticipantReachedOutPayload>>, Record<string, never>>,
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<MarkParticipantReachedOutPayload>>, Record<string, never>>
  },
  MatchingCriteria?: {
    enrollmentMenteeMatchingCriteria?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    hardMatchQuestions?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeAvailableToMatchEnrollmentMentees?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeEverMatchedEnrollmentMentees?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeMenteesUnder17?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeMenteesWhoArePushedThroughToMatch?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeMenteesWhoHaveBeenUnmatched?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeMenteesWithFreeResponses?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeMenteesWithSupermentorOptIn?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeMenteesWithoutMatchingSurveys?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeMentorsWhoArePushedThroughToMatch?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeMentorsWhoHaveBeenUnmatched?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeMentorsWithMentorships?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeMentorsWithSupermentorOptIn?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeMentorsWithoutMatchingSurveys?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    includeMentorsWithoutTraining?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    onlyEnrollmentOptInMentees?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    requireMenteeSupermentorOptIn?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    requireMentorSupermentorOptIn?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    sharedMajor?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>,
    sharedTransferStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingCriteria>>, Record<string, never>>
  },
  MatchingLabel?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingLabel>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingLabel>>, Record<string, never>>,
    kind?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingLabel>>, Record<string, never>>,
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<MatchingLabel>>, Record<string, never>>
  },
  Mentor?: {
    activityLogs?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    allowedToSkipMatchingSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    avatar?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    avatarImage?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    cachedUserProfileData?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, MentorCachedUserProfileDataArgs>,
    capacity?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    completedMatchingSurveyAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    deregisterDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    deregistrationStatusEvents?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    lastCompletedRequiredTrainingAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    matchingLabels?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    mentorTrainingCourseLink?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    mentorships?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, MentorMentorshipsArgs>,
    notes?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    participantMentorships?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, MentorParticipantMentorshipsArgs>,
    prioritizedAndPendingForRematching?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    pushedThroughToMatch?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    registered?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    registrationDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    requiredTrainingStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    savedMatches?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    supermentorOptIn?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    surveyResponses?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, MentorSurveyResponsesArgs>,
    trainingSignupLink?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    uploadedVideos?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, MentorUploadedVideosArgs>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    userProfileData?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, MentorUserProfileDataArgs>,
    webappBaseUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>,
    writtenMessages?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentor>>, Record<string, never>>
  },
  MentorContact?: {
    a2pSmses?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorContact>>, Record<string, never>>,
    activationStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorContact>>, Record<string, never>>,
    activationStatusChangedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorContact>>, Record<string, never>>,
    batchActionId?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorContact>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorContact>>, Record<string, never>>,
    notes?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorContact>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorContact>>, Record<string, never>>,
    registered?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorContact>>, Record<string, never>>,
    uploadedBy?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorContact>>, Record<string, never>>,
    uploadedDate?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorContact>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorContact>>, Record<string, never>>
  },
  Mentorship?: {
    chatGroup?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    combinedMenteeMentorSurveyResponses?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, MentorshipCombinedMenteeMentorSurveyResponsesArgs>,
    commonQualities?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    commonQualitiesSentence?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    conversationLogsCount?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    flags?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, MentorshipFlagsArgs>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    isMatched?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    lastConversation?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    matchDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    megaphoneGroup?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    menteeSmsRelayPhoneNumber?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    mentor?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    mentorConversationLogs?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    mentorIsDisengaged?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    mentorReachedOutAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    mentorSmsRelayPhoneNumber?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    score?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    source?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    student?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    studentConversationLogs?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    studentIsDisengaged?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    studentReachedOutAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    unmatchDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    unmatchInitiatedBy?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    unmatchNotes?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>,
    unmatchReason?: GraphCacheUpdateResolver<Maybe<WithTypename<Mentorship>>, Record<string, never>>
  },
  MentorshipChatGroup?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipChatGroup>>, Record<string, never>>
  },
  MentorshipConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipConnection>>, Record<string, never>>,
    totalCountMenteesDisengaged?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipConnection>>, Record<string, never>>,
    totalCountMentorsDisengaged?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipConnection>>, Record<string, never>>,
    totalCountUsingSmsRelay?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipConnection>>, Record<string, never>>,
    totalCountWithConversationInTheLast30Days?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipConnection>>, Record<string, never>>,
    totalCountWithThreeOrMoreConversations?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipConnection>>, Record<string, never>>,
    totalCountWithZeroConversations?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipConnection>>, Record<string, never>>
  },
  MentorshipCredential?: {
    credential?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipCredential>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipCredential>>, Record<string, never>>
  },
  MentorshipEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipEdge>>, Record<string, never>>
  },
  MentorshipMegaphoneGroup?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipMegaphoneGroup>>, Record<string, never>>,
    isSupermentorGroup?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipMegaphoneGroup>>, Record<string, never>>
  },
  MentorshipsMetrics?: {
    totalConversationsLogged?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipsMetrics>>, MentorshipsMetricsTotalConversationsLoggedArgs>,
    totalFirstUsedSmsRelay?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipsMetrics>>, MentorshipsMetricsTotalFirstUsedSmsRelayArgs>,
    totalLoggedMinimumNumberConversations?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipsMetrics>>, MentorshipsMetricsTotalLoggedMinimumNumberConversationsArgs>,
    totalMatched?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipsMetrics>>, MentorshipsMetricsTotalMatchedArgs>,
    totalSmsRelayMessagesSent?: GraphCacheUpdateResolver<Maybe<WithTypename<MentorshipsMetrics>>, MentorshipsMetricsTotalSmsRelayMessagesSentArgs>
  },
  MessageTemplateConnection?: {
    defaultCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateConnection>>, Record<string, never>>,
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateConnection>>, Record<string, never>>,
    tagCounts?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateConnection>>, Record<string, never>>
  },
  MessageTemplateEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateEdge>>, Record<string, never>>
  },
  MessageTemplateTag?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateTag>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateTag>>, Record<string, never>>
  },
  MessageTemplateTagConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateTagConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateTagConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateTagConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateTagConnection>>, Record<string, never>>
  },
  MessageTemplateTagCount?: {
    count?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateTagCount>>, Record<string, never>>,
    tag?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateTagCount>>, Record<string, never>>
  },
  MessageTemplateTagEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateTagEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<MessageTemplateTagEdge>>, Record<string, never>>
  },
  MicroSurvey?: {
    expireAt?: GraphCacheUpdateResolver<Maybe<WithTypename<MicroSurvey>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MicroSurvey>>, Record<string, never>>,
    startAt?: GraphCacheUpdateResolver<Maybe<WithTypename<MicroSurvey>>, Record<string, never>>,
    survey?: GraphCacheUpdateResolver<Maybe<WithTypename<MicroSurvey>>, Record<string, never>>,
    targetingCriteria?: GraphCacheUpdateResolver<Maybe<WithTypename<MicroSurvey>>, Record<string, never>>
  },
  MicroSurveyConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<MicroSurveyConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<MicroSurveyConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<MicroSurveyConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<MicroSurveyConnection>>, Record<string, never>>
  },
  MicroSurveyEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<MicroSurveyEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<MicroSurveyEdge>>, Record<string, never>>
  },
  MicroSurveyTargetingCriteria?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MicroSurveyTargetingCriteria>>, Record<string, never>>,
    participants?: GraphCacheUpdateResolver<Maybe<WithTypename<MicroSurveyTargetingCriteria>>, Record<string, never>>
  },
  MoveParticipantsPayload?: {
    batchActionId?: GraphCacheUpdateResolver<Maybe<WithTypename<MoveParticipantsPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<MoveParticipantsPayload>>, Record<string, never>>
  },
  MultiSelectHardMatchQuestion?: {
    matchType?: GraphCacheUpdateResolver<Maybe<WithTypename<MultiSelectHardMatchQuestion>>, Record<string, never>>,
    qid?: GraphCacheUpdateResolver<Maybe<WithTypename<MultiSelectHardMatchQuestion>>, Record<string, never>>
  },
  NewProgramTask?: {
    assigneeEntity?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTask>>, Record<string, never>>,
    behavior?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTask>>, Record<string, never>>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTask>>, Record<string, never>>,
    enabled?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTask>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTask>>, Record<string, never>>,
    newTask?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTask>>, Record<string, never>>,
    programId?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTask>>, Record<string, never>>,
    taskAssignments?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTask>>, Record<string, never>>
  },
  NewProgramTaskConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTaskConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTaskConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTaskConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTaskConnection>>, Record<string, never>>
  },
  NewProgramTaskEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTaskEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<NewProgramTaskEdge>>, Record<string, never>>
  },
  NewTask?: {
    context?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTask>>, Record<string, never>>,
    defaultAssigneeEntity?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTask>>, Record<string, never>>,
    defaultDisplayName?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTask>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTask>>, Record<string, never>>,
    internalTaskName?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTask>>, Record<string, never>>,
    mentorshipCredential?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTask>>, Record<string, never>>,
    requiredForMatching?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTask>>, Record<string, never>>,
    segmentTags?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTask>>, Record<string, never>>
  },
  NewTaskConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTaskConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTaskConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTaskConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTaskConnection>>, Record<string, never>>
  },
  NewTaskEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTaskEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<NewTaskEdge>>, Record<string, never>>
  },
  NotificationData?: {
    buttonOneText?: GraphCacheUpdateResolver<Maybe<WithTypename<NotificationData>>, Record<string, never>>,
    displayMedium?: GraphCacheUpdateResolver<Maybe<WithTypename<NotificationData>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<NotificationData>>, Record<string, never>>,
    imageUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<NotificationData>>, Record<string, never>>,
    markdownBody?: GraphCacheUpdateResolver<Maybe<WithTypename<NotificationData>>, Record<string, never>>,
    notificationViewableId?: GraphCacheUpdateResolver<Maybe<WithTypename<NotificationData>>, Record<string, never>>,
    notificationViewableType?: GraphCacheUpdateResolver<Maybe<WithTypename<NotificationData>>, Record<string, never>>
  },
  ObjectChange?: {
    attribute?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChange>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChange>>, Record<string, never>>,
    newValue?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChange>>, Record<string, never>>,
    originalValue?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChange>>, Record<string, never>>
  },
  ObjectChangeset?: {
    adminAction?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChangeset>>, Record<string, never>>,
    changes?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChangeset>>, Record<string, never>>,
    eventType?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChangeset>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChangeset>>, Record<string, never>>,
    trackedObject?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChangeset>>, Record<string, never>>
  },
  ObjectChangesetConnection?: {
    affectedObjectTypeCounts?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChangesetConnection>>, Record<string, never>>,
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChangesetConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChangesetConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChangesetConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChangesetConnection>>, Record<string, never>>
  },
  ObjectChangesetEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChangesetEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<ObjectChangesetEdge>>, Record<string, never>>
  },
  OmniauthCredentialLatestSession?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<OmniauthCredentialLatestSession>>, Record<string, never>>,
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<OmniauthCredentialLatestSession>>, Record<string, never>>,
    firstName?: GraphCacheUpdateResolver<Maybe<WithTypename<OmniauthCredentialLatestSession>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<OmniauthCredentialLatestSession>>, Record<string, never>>,
    institutionId?: GraphCacheUpdateResolver<Maybe<WithTypename<OmniauthCredentialLatestSession>>, Record<string, never>>,
    lastAuthAt?: GraphCacheUpdateResolver<Maybe<WithTypename<OmniauthCredentialLatestSession>>, Record<string, never>>,
    lastName?: GraphCacheUpdateResolver<Maybe<WithTypename<OmniauthCredentialLatestSession>>, Record<string, never>>,
    omniauthCredentialId?: GraphCacheUpdateResolver<Maybe<WithTypename<OmniauthCredentialLatestSession>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<OmniauthCredentialLatestSession>>, Record<string, never>>,
    userId?: GraphCacheUpdateResolver<Maybe<WithTypename<OmniauthCredentialLatestSession>>, Record<string, never>>
  },
  PageInfo?: {
    endCursor?: GraphCacheUpdateResolver<Maybe<WithTypename<PageInfo>>, Record<string, never>>,
    hasNextPage?: GraphCacheUpdateResolver<Maybe<WithTypename<PageInfo>>, Record<string, never>>,
    hasPreviousPage?: GraphCacheUpdateResolver<Maybe<WithTypename<PageInfo>>, Record<string, never>>,
    startCursor?: GraphCacheUpdateResolver<Maybe<WithTypename<PageInfo>>, Record<string, never>>
  },
  ParticipantConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConnection>>, Record<string, never>>,
    totalCountHavingAttendedTraining?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConnection>>, ParticipantConnectionTotalCountHavingAttendedTrainingArgs>,
    totalCountHavingCompletedMatchingSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConnection>>, Record<string, never>>,
    totalCountHavingNotAttendedTraining?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConnection>>, Record<string, never>>,
    totalCountHavingNotCompletedMatchingSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConnection>>, Record<string, never>>,
    totalCountHavingNotSignedUpForTraining?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConnection>>, Record<string, never>>,
    totalCountHavingSignedUpForTraining?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConnection>>, Record<string, never>>,
    totalCountInProgramsWithTraining?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConnection>>, Record<string, never>>,
    totalCountOfDistinctUsers?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConnection>>, Record<string, never>>,
    totalPrioritizedAndPendingForRematching?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConnection>>, Record<string, never>>
  },
  ParticipantConversationCategory?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationCategory>>, Record<string, never>>,
    identifier?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationCategory>>, Record<string, never>>,
    label?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationCategory>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationCategory>>, Record<string, never>>
  },
  ParticipantConversationContent?: {
    confidenceNotes?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContent>>, Record<string, never>>,
    confidenceScore?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContent>>, Record<string, never>>,
    conversationLog?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContent>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContent>>, Record<string, never>>,
    flag?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContent>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContent>>, Record<string, never>>,
    participantConversationCategories?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContent>>, Record<string, never>>,
    participantConversationType?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContent>>, Record<string, never>>,
    submittedBy?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContent>>, Record<string, never>>
  },
  ParticipantConversationContentConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContentConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContentConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContentConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContentConnection>>, Record<string, never>>
  },
  ParticipantConversationContentEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContentEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantConversationContentEdge>>, Record<string, never>>
  },
  ParticipantEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantEdge>>, Record<string, never>>
  },
  ParticipantsFilterCriteria?: {
    availableToBeMatched?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsFilterCriteria>>, Record<string, never>>,
    completedMatchingSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsFilterCriteria>>, Record<string, never>>,
    currentlyMatched?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsFilterCriteria>>, Record<string, never>>,
    engaged?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsFilterCriteria>>, Record<string, never>>,
    everMatched?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsFilterCriteria>>, Record<string, never>>,
    excludeProgramIds?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsFilterCriteria>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsFilterCriteria>>, Record<string, never>>,
    programIds?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsFilterCriteria>>, Record<string, never>>,
    registered?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsFilterCriteria>>, Record<string, never>>,
    segment?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsFilterCriteria>>, Record<string, never>>,
    signedUpForTraining?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsFilterCriteria>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsFilterCriteria>>, Record<string, never>>
  },
  ParticipantsMetrics?: {
    totalCompletedSurveys?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsMetrics>>, ParticipantsMetricsTotalCompletedSurveysArgs>,
    totalCredentialed?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsMetrics>>, ParticipantsMetricsTotalCredentialedArgs>,
    totalMatched?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsMetrics>>, ParticipantsMetricsTotalMatchedArgs>,
    totalMatchingSurveyCompleted?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsMetrics>>, ParticipantsMetricsTotalMatchingSurveyCompletedArgs>,
    totalRegistered?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsMetrics>>, ParticipantsMetricsTotalRegisteredArgs>,
    totalWantsMentorship?: GraphCacheUpdateResolver<Maybe<WithTypename<ParticipantsMetrics>>, ParticipantsMetricsTotalWantsMentorshipArgs>
  },
  Partner?: {
    executiveHigherEdRole?: GraphCacheUpdateResolver<Maybe<WithTypename<Partner>>, Record<string, never>>,
    facultyHigherEdRole?: GraphCacheUpdateResolver<Maybe<WithTypename<Partner>>, Record<string, never>>,
    higherEdCategory?: GraphCacheUpdateResolver<Maybe<WithTypename<Partner>>, Record<string, never>>,
    higherEdRole?: GraphCacheUpdateResolver<Maybe<WithTypename<Partner>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Partner>>, Record<string, never>>,
    organizationType?: GraphCacheUpdateResolver<Maybe<WithTypename<Partner>>, Record<string, never>>,
    programSequence?: GraphCacheUpdateResolver<Maybe<WithTypename<Partner>>, Record<string, never>>,
    registered?: GraphCacheUpdateResolver<Maybe<WithTypename<Partner>>, Record<string, never>>,
    staffHigherEdRole?: GraphCacheUpdateResolver<Maybe<WithTypename<Partner>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<Partner>>, Record<string, never>>
  },
  PartnerConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerConnection>>, Record<string, never>>,
    totalCountOfDistinctUsers?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerConnection>>, Record<string, never>>
  },
  PartnerDashboardExports?: {
    conversations?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerDashboardExports>>, PartnerDashboardExportsConversationsArgs>,
    flags?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerDashboardExports>>, PartnerDashboardExportsFlagsArgs>,
    mentorships?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerDashboardExports>>, PartnerDashboardExportsMentorshipsArgs>,
    users?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerDashboardExports>>, PartnerDashboardExportsUsersArgs>
  },
  PartnerEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerEdge>>, Record<string, never>>
  },
  PartnerNotification?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerNotification>>, Record<string, never>>,
    partner?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerNotification>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerNotification>>, Record<string, never>>,
    sender?: GraphCacheUpdateResolver<Maybe<WithTypename<PartnerNotification>>, Record<string, never>>
  },
  PreviewMatchingSurveyPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<PreviewMatchingSurveyPayload>>, Record<string, never>>,
    menteeSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<PreviewMatchingSurveyPayload>>, Record<string, never>>,
    mentorSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<PreviewMatchingSurveyPayload>>, Record<string, never>>,
    previewParticipantFromSameProgram?: GraphCacheUpdateResolver<Maybe<WithTypename<PreviewMatchingSurveyPayload>>, Record<string, never>>
  },
  Profile?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Profile>>, Record<string, never>>,
    programSpecificAttributes?: GraphCacheUpdateResolver<Maybe<WithTypename<Profile>>, Record<string, never>>
  },
  ProfileAttribute?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProfileAttribute>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ProfileAttribute>>, Record<string, never>>,
    profileAttributeType?: GraphCacheUpdateResolver<Maybe<WithTypename<ProfileAttribute>>, Record<string, never>>,
    profileAttributeValues?: GraphCacheUpdateResolver<Maybe<WithTypename<ProfileAttribute>>, Record<string, never>>
  },
  ProfileAttributeCategory?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProfileAttributeCategory>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ProfileAttributeCategory>>, Record<string, never>>,
    profileAttributeCategoryItems?: GraphCacheUpdateResolver<Maybe<WithTypename<ProfileAttributeCategory>>, Record<string, never>>
  },
  ProfileAttributeCategoryItem?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProfileAttributeCategoryItem>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ProfileAttributeCategoryItem>>, Record<string, never>>,
    profileAttributeCategory?: GraphCacheUpdateResolver<Maybe<WithTypename<ProfileAttributeCategoryItem>>, Record<string, never>>
  },
  ProfileAttributeValue?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProfileAttributeValue>>, Record<string, never>>,
    profileAttribute?: GraphCacheUpdateResolver<Maybe<WithTypename<ProfileAttributeValue>>, Record<string, never>>,
    value?: GraphCacheUpdateResolver<Maybe<WithTypename<ProfileAttributeValue>>, Record<string, never>>
  },
  Program?: {
    accountNotes?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    active?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    activityLogs?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, ProgramActivityLogsArgs>,
    additionalFlagContactRecipients?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    alertDismissals?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    allowMatching?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    allowMenteeSignUp?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    allowMentorSignUp?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    allowsMenteesToPushThemselvesThroughToMatch?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    askForMenteeSidInSignup?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    asksStrongestPreferenceQuestionInMenteeMatchingSurveyAndProfileAttributesExist?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    cohorts?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    communicationMediumPreference?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    contacts?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, ProgramContactsArgs>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    currentPhase?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    currentStage?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    customMessageTemplates?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    defaultProfileImage?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    endDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    engagementBenchmarkData?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    engagementChartUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    firstParticipantCreatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    flagContactEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    flagContactFirstName?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    flagContactLastName?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    flagPageVisits?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, ProgramFlagPageVisitsArgs>,
    hasMatchingSuveysMigratedFromOldFramework?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    isTemplateProgram?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    isTestProgram?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    matchingCap?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    matchingCapReachedDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    matchingGoalReachedDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    menteeLoginMode?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    mentorEndAssessmentSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    mentorLoginMode?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    mentorMatchingSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    mentorMidAssessmentSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    mentorOpeningAssessmentSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    mentorPointPersonEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    mentorPointPersonFirstName?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    mentorPointPersonLastName?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    mentorPointPersonTitle?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    mentorPostSessionSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    mentorTrainingTask?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    mentorType?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    mentors?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, ProgramMentorsArgs>,
    mentorships?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, ProgramMentorshipsArgs>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    nonPriorityFlagEmailEnabled?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    notes?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    numberOfOpenMentorSlots?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    partnerSuccessManager?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    partnerSuccessOperator?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    programAssessmentAreas?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    programCustomLabel?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    programFlagCategories?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    programGoal?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    programInfoUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    programLogo?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    programProfileAttributes?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    programRecruitmentAndOnboardingDashboardUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    programResources?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, ProgramProgramResourcesArgs>,
    programSequence?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    programTasks?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, ProgramProgramTasksArgs>,
    programTopics?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, ProgramProgramTopicsArgs>,
    reRecruitedMentorsCanSkipMatchingSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    requiredMentorTrainingCredential?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    resources?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, ProgramResourcesArgs>,
    salesforceOpportunityId?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    satisfactionBenchmarkChartUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    satisfactionReport?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    secondaryFlagContactCcEmails?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    segment?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    sendFlagsToExternalContact?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    sftpExportEnabled?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    sftpPrefix?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    shareMenteeEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    shareMenteePhone?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    shareMentorEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    shareMentorPhone?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    shortName?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    showMatchingSurveysToPartner?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    showMentorsFlags?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    startDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    studentEndAssessmentSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    studentGoalsList?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    studentMatchingSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    studentMidAssessmentSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    studentOpeningAssessmentSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    studentPointPersonEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    studentPointPersonFirstName?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    studentPointPersonLastName?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    studentPointPersonTitle?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    studentPostSessionSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    students?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, ProgramStudentsArgs>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    trainingMode?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    universityRelationsDirector?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>,
    usesNewCommunications?: GraphCacheUpdateResolver<Maybe<WithTypename<Program>>, Record<string, never>>
  },
  ProgramAlertDismissal?: {
    alertMetadata?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAlertDismissal>>, Record<string, never>>,
    alertTypeIdentifier?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAlertDismissal>>, Record<string, never>>,
    dismissedBy?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAlertDismissal>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAlertDismissal>>, Record<string, never>>,
    snoozeUntil?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAlertDismissal>>, Record<string, never>>
  },
  ProgramAssessmentArea?: {
    assessmentArea?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAssessmentArea>>, Record<string, never>>,
    enabledForMentees?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAssessmentArea>>, Record<string, never>>,
    enabledForMentors?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAssessmentArea>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAssessmentArea>>, Record<string, never>>,
    scaleMax?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAssessmentArea>>, Record<string, never>>,
    scaleMin?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAssessmentArea>>, Record<string, never>>
  },
  ProgramAutomatchingConfiguration?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAutomatchingConfiguration>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAutomatchingConfiguration>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAutomatchingConfiguration>>, Record<string, never>>,
    settings?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAutomatchingConfiguration>>, Record<string, never>>,
    shearwaterAdministrator?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAutomatchingConfiguration>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAutomatchingConfiguration>>, Record<string, never>>
  },
  ProgramAutomatchingDefault?: {
    automatchingDefault?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAutomatchingDefault>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAutomatchingDefault>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAutomatchingDefault>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAutomatchingDefault>>, Record<string, never>>,
    shearwaterAdministrator?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAutomatchingDefault>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramAutomatchingDefault>>, Record<string, never>>
  },
  ProgramConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramConnection>>, Record<string, never>>
  },
  ProgramCustomLabel?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    pluralMentee?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    pluralMentor?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    pluralMentorship?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    pluralSchool?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    pluralStudent?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    respectMenteeUppercase?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    respectMentorUppercase?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    respectMentorshipUppercase?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    respectSchoolUppercase?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    respectStudentUppercase?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    singularMentee?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    singularMenteeWithIndeterminateArticle?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    singularMentor?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    singularMentorWithIndeterminateArticle?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    singularMentorship?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    singularMentorshipWithIndeterminateArticle?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    singularSchool?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    singularSchoolWithIndeterminateArticle?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    singularStudent?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>,
    singularStudentWithIndeterminateArticle?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomLabel>>, Record<string, never>>
  },
  ProgramCustomMessageTemplate?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomMessageTemplate>>, Record<string, never>>,
    customMessageType?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomMessageTemplate>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomMessageTemplate>>, Record<string, never>>,
    messageTemplate?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomMessageTemplate>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomMessageTemplate>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramCustomMessageTemplate>>, Record<string, never>>
  },
  ProgramEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramEdge>>, Record<string, never>>
  },
  ProgramFlagCategory?: {
    customDisplayName?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramFlagCategory>>, Record<string, never>>,
    customSmsCharacter?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramFlagCategory>>, Record<string, never>>,
    flagCategory?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramFlagCategory>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramFlagCategory>>, Record<string, never>>,
    isVisible?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramFlagCategory>>, Record<string, never>>
  },
  ProgramGoal?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramGoal>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramGoal>>, Record<string, never>>,
    target?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramGoal>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramGoal>>, Record<string, never>>
  },
  ProgramPageVisit?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramPageVisit>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramPageVisit>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramPageVisit>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramPageVisit>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramPageVisit>>, Record<string, never>>
  },
  ProgramProfileAttribute?: {
    availableInPartnerDashboardExports?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttribute>>, Record<string, never>>,
    availableInPartnerDashboardFilters?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttribute>>, Record<string, never>>,
    availableInPartnerDashboardProgramIntelligenceChart?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttribute>>, Record<string, never>>,
    defaultSettings?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttribute>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttribute>>, Record<string, never>>,
    profileAttribute?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttribute>>, Record<string, never>>
  },
  ProgramProfileAttributeCategoryResult?: {
    profileAttribute?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttributeCategoryResult>>, Record<string, never>>,
    profileAttributeCategories?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttributeCategoryResult>>, Record<string, never>>
  },
  ProgramProfileAttributeDefaultSettings?: {
    availableInPartnerDashboardExports?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttributeDefaultSettings>>, Record<string, never>>,
    availableInPartnerDashboardFilters?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttributeDefaultSettings>>, Record<string, never>>,
    availableInPartnerDashboardProgramIntelligenceChart?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttributeDefaultSettings>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttributeDefaultSettings>>, Record<string, never>>
  },
  ProgramProfileAttributeUnableToBeUpdated?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttributeUnableToBeUpdated>>, Record<string, never>>,
    programProfileAttributeId?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramProfileAttributeUnableToBeUpdated>>, Record<string, never>>
  },
  ProgramResource?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramResource>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramResource>>, Record<string, never>>,
    uploadedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramResource>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramResource>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramResource>>, Record<string, never>>
  },
  ProgramResourceConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramResourceConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramResourceConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramResourceConnection>>, Record<string, never>>
  },
  ProgramResourceEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramResourceEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramResourceEdge>>, Record<string, never>>
  },
  ProgramSequence?: {
    flagCategories?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, Record<string, never>>,
    higherEdSegment?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, Record<string, never>>,
    kind?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, Record<string, never>>,
    menteeQuizTask?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, Record<string, never>>,
    menteeRecruitmentLink?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, Record<string, never>>,
    mentorMatchingSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, Record<string, never>>,
    mentorRecruitmentLink?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, Record<string, never>>,
    partners?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, ProgramSequencePartnersArgs>,
    programs?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, Record<string, never>>,
    school?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, Record<string, never>>,
    studentMatchingSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, Record<string, never>>,
    urlSlug?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequence>>, Record<string, never>>
  },
  ProgramSequenceConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequenceConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequenceConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequenceConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequenceConnection>>, Record<string, never>>
  },
  ProgramSequenceEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequenceEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramSequenceEdge>>, Record<string, never>>
  },
  ProgramTask?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTask>>, Record<string, never>>,
    position?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTask>>, Record<string, never>>,
    programSequence?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTask>>, Record<string, never>>,
    programSpecific?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTask>>, Record<string, never>>,
    required?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTask>>, Record<string, never>>,
    task?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTask>>, Record<string, never>>,
    toBeCompletedAs?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTask>>, Record<string, never>>
  },
  ProgramTopic?: {
    active?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopic>>, Record<string, never>>,
    delayBeforeRestart?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopic>>, Record<string, never>>,
    endDate?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopic>>, Record<string, never>>,
    hoursBetweenOutreach?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopic>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopic>>, Record<string, never>>,
    lastEditedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopic>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopic>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopic>>, Record<string, never>>,
    startDate?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopic>>, Record<string, never>>,
    topic?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopic>>, Record<string, never>>
  },
  ProgramTopicConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopicConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopicConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopicConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopicConnection>>, Record<string, never>>
  },
  ProgramTopicEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopicEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<ProgramTopicEdge>>, Record<string, never>>
  },
  QueryableMetrics?: {
    assessmentScoreResponses?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryableMetrics>>, QueryableMetricsAssessmentScoreResponsesArgs>,
    contacts?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryableMetrics>>, QueryableMetricsContactsArgs>,
    disengagementResolutions?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryableMetrics>>, QueryableMetricsDisengagementResolutionsArgs>,
    disengagementResolutionsAverageTimeToRematch?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryableMetrics>>, QueryableMetricsDisengagementResolutionsAverageTimeToRematchArgs>,
    flags?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryableMetrics>>, QueryableMetricsFlagsArgs>,
    mentorships?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryableMetrics>>, QueryableMetricsMentorshipsArgs>,
    participants?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryableMetrics>>, QueryableMetricsParticipantsArgs>,
    recruitmentOpportunities?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryableMetrics>>, QueryableMetricsRecruitmentOpportunitiesArgs>,
    users?: GraphCacheUpdateResolver<Maybe<WithTypename<QueryableMetrics>>, QueryableMetricsUsersArgs>
  },
  QuestionWeight?: {
    qid?: GraphCacheUpdateResolver<Maybe<WithTypename<QuestionWeight>>, Record<string, never>>,
    weight?: GraphCacheUpdateResolver<Maybe<WithTypename<QuestionWeight>>, Record<string, never>>
  },
  ReactivateProgramAlertPayload?: {
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<ReactivateProgramAlertPayload>>, Record<string, never>>
  },
  RecruitmentOpportunitiesMetricsResult?: {
    attributeType?: GraphCacheUpdateResolver<Maybe<WithTypename<RecruitmentOpportunitiesMetricsResult>>, Record<string, never>>,
    attributeValue?: GraphCacheUpdateResolver<Maybe<WithTypename<RecruitmentOpportunitiesMetricsResult>>, Record<string, never>>,
    menteesWaiting?: GraphCacheUpdateResolver<Maybe<WithTypename<RecruitmentOpportunitiesMetricsResult>>, Record<string, never>>,
    mentorsCount?: GraphCacheUpdateResolver<Maybe<WithTypename<RecruitmentOpportunitiesMetricsResult>>, Record<string, never>>,
    mentorsGap?: GraphCacheUpdateResolver<Maybe<WithTypename<RecruitmentOpportunitiesMetricsResult>>, Record<string, never>>,
    mentorsOpenSlots?: GraphCacheUpdateResolver<Maybe<WithTypename<RecruitmentOpportunitiesMetricsResult>>, Record<string, never>>,
    strongestPreferenceDisplayValue?: GraphCacheUpdateResolver<Maybe<WithTypename<RecruitmentOpportunitiesMetricsResult>>, Record<string, never>>,
    strongestPreferenceKey?: GraphCacheUpdateResolver<Maybe<WithTypename<RecruitmentOpportunitiesMetricsResult>>, Record<string, never>>
  },
  RemoveMessageTemplatesTags?: {
    byFilterSelection?: GraphCacheUpdateResolver<Maybe<WithTypename<RemoveMessageTemplatesTags>>, RemoveMessageTemplatesTagsByFilterSelectionArgs>,
    byIds?: GraphCacheUpdateResolver<Maybe<WithTypename<RemoveMessageTemplatesTags>>, RemoveMessageTemplatesTagsByIdsArgs>
  },
  RemoveMessageTemplatesTagsByFilterSelectionPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<RemoveMessageTemplatesTagsByFilterSelectionPayload>>, Record<string, never>>,
    messageTemplates?: GraphCacheUpdateResolver<Maybe<WithTypename<RemoveMessageTemplatesTagsByFilterSelectionPayload>>, Record<string, never>>,
    numberOfMessageTemplatesUpdated?: GraphCacheUpdateResolver<Maybe<WithTypename<RemoveMessageTemplatesTagsByFilterSelectionPayload>>, Record<string, never>>
  },
  RemoveMessageTemplatesTagsByIdsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<RemoveMessageTemplatesTagsByIdsPayload>>, Record<string, never>>,
    messageTemplates?: GraphCacheUpdateResolver<Maybe<WithTypename<RemoveMessageTemplatesTagsByIdsPayload>>, Record<string, never>>,
    numberOfMessageTemplatesUpdated?: GraphCacheUpdateResolver<Maybe<WithTypename<RemoveMessageTemplatesTagsByIdsPayload>>, Record<string, never>>
  },
  Resource?: {
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<Resource>>, Record<string, never>>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<Resource>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Resource>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Resource>>, Record<string, never>>,
    resourceType?: GraphCacheUpdateResolver<Maybe<WithTypename<Resource>>, Record<string, never>>,
    resourceable?: GraphCacheUpdateResolver<Maybe<WithTypename<Resource>>, Record<string, never>>,
    topics?: GraphCacheUpdateResolver<Maybe<WithTypename<Resource>>, Record<string, never>>
  },
  ResourceConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceConnection>>, Record<string, never>>
  },
  ResourceEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceEdge>>, Record<string, never>>
  },
  ResourceTopic?: {
    archived?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceTopic>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceTopic>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceTopic>>, Record<string, never>>
  },
  ResourceTopicConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceTopicConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceTopicConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceTopicConnection>>, Record<string, never>>
  },
  ResourceTopicEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceTopicEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<ResourceTopicEdge>>, Record<string, never>>
  },
  S3Object?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<S3Object>>, Record<string, never>>,
    key?: GraphCacheUpdateResolver<Maybe<WithTypename<S3Object>>, Record<string, never>>,
    keyWithoutPrefix?: GraphCacheUpdateResolver<Maybe<WithTypename<S3Object>>, Record<string, never>>
  },
  SatisfactionAverage?: {
    mentorAverage?: GraphCacheUpdateResolver<Maybe<WithTypename<SatisfactionAverage>>, Record<string, never>>,
    studentAverage?: GraphCacheUpdateResolver<Maybe<WithTypename<SatisfactionAverage>>, Record<string, never>>
  },
  SatisfactionReport?: {
    previousProgramSatisfaction?: GraphCacheUpdateResolver<Maybe<WithTypename<SatisfactionReport>>, Record<string, never>>,
    programSatisfaction?: GraphCacheUpdateResolver<Maybe<WithTypename<SatisfactionReport>>, Record<string, never>>,
    segmentSatisfaction?: GraphCacheUpdateResolver<Maybe<WithTypename<SatisfactionReport>>, Record<string, never>>
  },
  SaveBatchMatchesPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<SaveBatchMatchesPayload>>, Record<string, never>>,
    suggestedBatch?: GraphCacheUpdateResolver<Maybe<WithTypename<SaveBatchMatchesPayload>>, Record<string, never>>
  },
  SaveSurveyResponsePayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<SaveSurveyResponsePayload>>, Record<string, never>>,
    response?: GraphCacheUpdateResolver<Maybe<WithTypename<SaveSurveyResponsePayload>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<SaveSurveyResponsePayload>>, Record<string, never>>
  },
  SaveWrittenMessagePayload?: {
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<SaveWrittenMessagePayload>>, Record<string, never>>
  },
  SavedMatch?: {
    additionalProgramSortingCriteria?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatch>>, Record<string, never>>,
    adminUser?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatch>>, Record<string, never>>,
    autoMatchStrategy?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatch>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatch>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatch>>, Record<string, never>>,
    mentor?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatch>>, Record<string, never>>,
    score?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatch>>, Record<string, never>>,
    source?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatch>>, Record<string, never>>,
    student?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatch>>, Record<string, never>>
  },
  SavedMatchConnection?: {
    adminUsers?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatchConnection>>, Record<string, never>>,
    autoMatchStrategies?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatchConnection>>, Record<string, never>>,
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatchConnection>>, Record<string, never>>,
    mentorSupermentorOptInTypes?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatchConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatchConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatchConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatchConnection>>, Record<string, never>>,
    uniquePrograms?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatchConnection>>, Record<string, never>>
  },
  SavedMatchEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatchEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<SavedMatchEdge>>, Record<string, never>>
  },
  ScheduleTrainingTask?: {
    calendlyUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<ScheduleTrainingTask>>, Record<string, never>>,
    customAfterCallToAction?: GraphCacheUpdateResolver<Maybe<WithTypename<ScheduleTrainingTask>>, Record<string, never>>,
    customCallToAction?: GraphCacheUpdateResolver<Maybe<WithTypename<ScheduleTrainingTask>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ScheduleTrainingTask>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<ScheduleTrainingTask>>, Record<string, never>>,
    prompt?: GraphCacheUpdateResolver<Maybe<WithTypename<ScheduleTrainingTask>>, Record<string, never>>
  },
  School?: {
    awsUsername?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    institutionRegion?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    institutionType?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    isMinorityServingInstitution?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    logo?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    nameOfSchoolIdentifier?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    omniauthCredentialLatestSessions?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    programSequences?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    publicOrPrivate?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    shortName?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    ssoBrand?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    ssoEnabled?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    ssoProviderIdentifier?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    ssoRequiredForPartners?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    ssoTestingEnabled?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    subdomain?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>,
    twoOrFourYear?: GraphCacheUpdateResolver<Maybe<WithTypename<School>>, Record<string, never>>
  },
  SchoolConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolConnection>>, Record<string, never>>
  },
  SchoolEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolEdge>>, Record<string, never>>
  },
  SchoolIdentifier?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolIdentifier>>, Record<string, never>>,
    identificationString?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolIdentifier>>, Record<string, never>>,
    providedBy?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolIdentifier>>, Record<string, never>>,
    school?: GraphCacheUpdateResolver<Maybe<WithTypename<SchoolIdentifier>>, Record<string, never>>
  },
  SendBulkMessageByCsvPayload?: {
    batchActionId?: GraphCacheUpdateResolver<Maybe<WithTypename<SendBulkMessageByCsvPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<SendBulkMessageByCsvPayload>>, Record<string, never>>,
    templateId?: GraphCacheUpdateResolver<Maybe<WithTypename<SendBulkMessageByCsvPayload>>, Record<string, never>>
  },
  SendPartnerNotificationsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<SendPartnerNotificationsPayload>>, Record<string, never>>,
    successRecipients?: GraphCacheUpdateResolver<Maybe<WithTypename<SendPartnerNotificationsPayload>>, Record<string, never>>
  },
  SendSsoTestingTemplatePayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<SendSsoTestingTemplatePayload>>, Record<string, never>>,
    programSequenceId?: GraphCacheUpdateResolver<Maybe<WithTypename<SendSsoTestingTemplatePayload>>, Record<string, never>>
  },
  SendTestMessagePayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<SendTestMessagePayload>>, Record<string, never>>,
    templateId?: GraphCacheUpdateResolver<Maybe<WithTypename<SendTestMessagePayload>>, Record<string, never>>
  },
  SendUpdateEmailDraftForMentorshipPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<SendUpdateEmailDraftForMentorshipPayload>>, Record<string, never>>,
    notice?: GraphCacheUpdateResolver<Maybe<WithTypename<SendUpdateEmailDraftForMentorshipPayload>>, Record<string, never>>
  },
  SetupSftpPayload?: {
    isSuccess?: GraphCacheUpdateResolver<Maybe<WithTypename<SetupSftpPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<SetupSftpPayload>>, Record<string, never>>
  },
  SftpCsvExports?: {
    csvExportInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<SftpCsvExports>>, SftpCsvExportsCsvExportInfoArgs>
  },
  ShearwaterAdministrator?: {
    asanaId?: GraphCacheUpdateResolver<Maybe<WithTypename<ShearwaterAdministrator>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ShearwaterAdministrator>>, Record<string, never>>,
    deactivatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ShearwaterAdministrator>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<ShearwaterAdministrator>>, Record<string, never>>,
    permissions?: GraphCacheUpdateResolver<Maybe<WithTypename<ShearwaterAdministrator>>, Record<string, never>>,
    salesforceUserId?: GraphCacheUpdateResolver<Maybe<WithTypename<ShearwaterAdministrator>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<ShearwaterAdministrator>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<ShearwaterAdministrator>>, Record<string, never>>
  },
  SingleSelectHardMatchQuestion?: {
    matchType?: GraphCacheUpdateResolver<Maybe<WithTypename<SingleSelectHardMatchQuestion>>, Record<string, never>>,
    qid?: GraphCacheUpdateResolver<Maybe<WithTypename<SingleSelectHardMatchQuestion>>, Record<string, never>>
  },
  SkeletonMessageTemplate?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<SkeletonMessageTemplate>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SkeletonMessageTemplate>>, Record<string, never>>,
    lastEditedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<SkeletonMessageTemplate>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<SkeletonMessageTemplate>>, Record<string, never>>,
    templateEditorData?: GraphCacheUpdateResolver<Maybe<WithTypename<SkeletonMessageTemplate>>, Record<string, never>>
  },
  SkeletonMessageTemplateConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<SkeletonMessageTemplateConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<SkeletonMessageTemplateConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<SkeletonMessageTemplateConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<SkeletonMessageTemplateConnection>>, Record<string, never>>
  },
  SkeletonMessageTemplateEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<SkeletonMessageTemplateEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<SkeletonMessageTemplateEdge>>, Record<string, never>>
  },
  SmsTemplate?: {
    archivedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    category?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    content?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    createdBy?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    customMessageType?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    identifier?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    isDefault?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    lastEditedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    lastEditedBy?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    messageType?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    programSegment?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    tags?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>,
    userState?: GraphCacheUpdateResolver<Maybe<WithTypename<SmsTemplate>>, Record<string, never>>
  },
  StartFirstWaveRecruitment?: {
    byFilterSelection?: GraphCacheUpdateResolver<Maybe<WithTypename<StartFirstWaveRecruitment>>, StartFirstWaveRecruitmentByFilterSelectionArgs>,
    byIds?: GraphCacheUpdateResolver<Maybe<WithTypename<StartFirstWaveRecruitment>>, StartFirstWaveRecruitmentByIdsArgs>
  },
  StartFirstWaveRecruitmentByFilterSelectionPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<StartFirstWaveRecruitmentByFilterSelectionPayload>>, Record<string, never>>,
    numberOfContactsActivated?: GraphCacheUpdateResolver<Maybe<WithTypename<StartFirstWaveRecruitmentByFilterSelectionPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<StartFirstWaveRecruitmentByFilterSelectionPayload>>, Record<string, never>>
  },
  StartFirstWaveRecruitmentByIdsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<StartFirstWaveRecruitmentByIdsPayload>>, Record<string, never>>,
    numberOfContactsActivated?: GraphCacheUpdateResolver<Maybe<WithTypename<StartFirstWaveRecruitmentByIdsPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<StartFirstWaveRecruitmentByIdsPayload>>, Record<string, never>>
  },
  StartSecondWaveRecruitment?: {
    byFilterSelection?: GraphCacheUpdateResolver<Maybe<WithTypename<StartSecondWaveRecruitment>>, StartSecondWaveRecruitmentByFilterSelectionArgs>,
    byIds?: GraphCacheUpdateResolver<Maybe<WithTypename<StartSecondWaveRecruitment>>, StartSecondWaveRecruitmentByIdsArgs>
  },
  StartSecondWaveRecruitmentByFilterSelectionPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<StartSecondWaveRecruitmentByFilterSelectionPayload>>, Record<string, never>>,
    numberOfContactsActivated?: GraphCacheUpdateResolver<Maybe<WithTypename<StartSecondWaveRecruitmentByFilterSelectionPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<StartSecondWaveRecruitmentByFilterSelectionPayload>>, Record<string, never>>
  },
  StartSecondWaveRecruitmentByIdsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<StartSecondWaveRecruitmentByIdsPayload>>, Record<string, never>>,
    numberOfContactsActivated?: GraphCacheUpdateResolver<Maybe<WithTypename<StartSecondWaveRecruitmentByIdsPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<StartSecondWaveRecruitmentByIdsPayload>>, Record<string, never>>
  },
  StateMachine?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<StateMachine>>, Record<string, never>>,
    identifier?: GraphCacheUpdateResolver<Maybe<WithTypename<StateMachine>>, Record<string, never>>,
    metadata?: GraphCacheUpdateResolver<Maybe<WithTypename<StateMachine>>, Record<string, never>>,
    schema?: GraphCacheUpdateResolver<Maybe<WithTypename<StateMachine>>, Record<string, never>>
  },
  StateMachineConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<StateMachineConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<StateMachineConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<StateMachineConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<StateMachineConnection>>, Record<string, never>>
  },
  StateMachineEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<StateMachineEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<StateMachineEdge>>, Record<string, never>>
  },
  StopRecruitment?: {
    byFilterSelection?: GraphCacheUpdateResolver<Maybe<WithTypename<StopRecruitment>>, StopRecruitmentByFilterSelectionArgs>,
    byIds?: GraphCacheUpdateResolver<Maybe<WithTypename<StopRecruitment>>, StopRecruitmentByIdsArgs>
  },
  StopRecruitmentByFilterSelectionPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<StopRecruitmentByFilterSelectionPayload>>, Record<string, never>>,
    numberOfContactsDeactivated?: GraphCacheUpdateResolver<Maybe<WithTypename<StopRecruitmentByFilterSelectionPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<StopRecruitmentByFilterSelectionPayload>>, Record<string, never>>
  },
  StopRecruitmentByIdsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<StopRecruitmentByIdsPayload>>, Record<string, never>>,
    numberOfContactsDeactivated?: GraphCacheUpdateResolver<Maybe<WithTypename<StopRecruitmentByIdsPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<StopRecruitmentByIdsPayload>>, Record<string, never>>
  },
  Student?: {
    activityLogs?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    avatar?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    avatarImage?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    cachedUserProfileData?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, StudentCachedUserProfileDataArgs>,
    completedMatchingSurveyAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    deregisterDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    deregistrationStatusEvents?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    desiredMentoringSupport?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    goals?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    matchingLabels?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    mentorships?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, StudentMentorshipsArgs>,
    notes?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    participantMentorships?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, StudentParticipantMentorshipsArgs>,
    prioritizedAndPendingForRematching?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    programGoal?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    pushedThroughToMatch?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    questionForMentor?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    registered?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    registrationDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    rematchDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    savedMatches?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    supermentorOptIn?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    surveyResponses?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, StudentSurveyResponsesArgs>,
    uploadedVideos?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, StudentUploadedVideosArgs>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    userProfileData?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, StudentUserProfileDataArgs>,
    webappBaseUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>,
    writtenMessages?: GraphCacheUpdateResolver<Maybe<WithTypename<Student>>, Record<string, never>>
  },
  StudentContact?: {
    a2pSmses?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentContact>>, Record<string, never>>,
    activationStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentContact>>, Record<string, never>>,
    activationStatusChangedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentContact>>, Record<string, never>>,
    batchActionId?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentContact>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentContact>>, Record<string, never>>,
    notes?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentContact>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentContact>>, Record<string, never>>,
    registered?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentContact>>, Record<string, never>>,
    uploadedBy?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentContact>>, Record<string, never>>,
    uploadedDate?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentContact>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentContact>>, Record<string, never>>
  },
  StudentGoal?: {
    answer?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentGoal>>, Record<string, never>>,
    answerKey?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentGoal>>, Record<string, never>>,
    answerText?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentGoal>>, Record<string, never>>,
    goal?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentGoal>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentGoal>>, Record<string, never>>
  },
  StudentGoalsList?: {
    answerKey?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentGoalsList>>, Record<string, never>>,
    answerText?: GraphCacheUpdateResolver<Maybe<WithTypename<StudentGoalsList>>, Record<string, never>>
  },
  SuggestedBatch?: {
    adminUser?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatch>>, Record<string, never>>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatch>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatch>>, Record<string, never>>,
    overview?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatch>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatch>>, Record<string, never>>,
    settings?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatch>>, Record<string, never>>,
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatch>>, Record<string, never>>,
    strategyType?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatch>>, Record<string, never>>
  },
  SuggestedBatchConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatchConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatchConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatchConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatchConnection>>, Record<string, never>>
  },
  SuggestedBatchEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatchEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatchEdge>>, Record<string, never>>
  },
  SuggestedBatchSettings?: {
    autoMatchingSettings?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatchSettings>>, Record<string, never>>,
    groupMatchingSettings?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatchSettings>>, Record<string, never>>,
    matchingCriteria?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatchSettings>>, Record<string, never>>,
    programId?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatchSettings>>, Record<string, never>>,
    questionsWeights?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedBatchSettings>>, Record<string, never>>
  },
  SuggestedMatch?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedMatch>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedMatch>>, Record<string, never>>,
    matchScore?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedMatch>>, Record<string, never>>,
    mentor?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedMatch>>, Record<string, never>>,
    student?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedMatch>>, Record<string, never>>,
    suggestedBatch?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedMatch>>, Record<string, never>>
  },
  SuggestedMatchConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedMatchConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedMatchConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedMatchConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedMatchConnection>>, Record<string, never>>
  },
  SuggestedMatchEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedMatchEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<SuggestedMatchEdge>>, Record<string, never>>
  },
  SupportServiceResource?: {
    additionalInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportServiceResource>>, Record<string, never>>,
    address?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportServiceResource>>, Record<string, never>>,
    categories?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportServiceResource>>, Record<string, never>>,
    contactEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportServiceResource>>, Record<string, never>>,
    contactName?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportServiceResource>>, Record<string, never>>,
    contactPhone?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportServiceResource>>, Record<string, never>>,
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportServiceResource>>, Record<string, never>>,
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportServiceResource>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportServiceResource>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportServiceResource>>, Record<string, never>>,
    phone?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportServiceResource>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<SupportServiceResource>>, Record<string, never>>
  },
  Survey?: {
    archived?: GraphCacheUpdateResolver<Maybe<WithTypename<Survey>>, Record<string, never>>,
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<Survey>>, SurveyDescriptionArgs>,
    hasResponses?: GraphCacheUpdateResolver<Maybe<WithTypename<Survey>>, SurveyHasResponsesArgs>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Survey>>, Record<string, never>>,
    migrated?: GraphCacheUpdateResolver<Maybe<WithTypename<Survey>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Survey>>, Record<string, never>>,
    questions?: GraphCacheUpdateResolver<Maybe<WithTypename<Survey>>, SurveyQuestionsArgs>,
    surveyType?: GraphCacheUpdateResolver<Maybe<WithTypename<Survey>>, Record<string, never>>
  },
  SurveyAnswer?: {
    answerJson?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyAnswer>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyAnswer>>, Record<string, never>>,
    question?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyAnswer>>, Record<string, never>>
  },
  SurveyConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyConnection>>, Record<string, never>>
  },
  SurveyEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyEdge>>, Record<string, never>>
  },
  SurveyQuestion?: {
    createdInAdminTool?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestion>>, Record<string, never>>,
    customizationOptions?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestion>>, Record<string, never>>,
    customizations?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestion>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestion>>, Record<string, never>>,
    index?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestion>>, Record<string, never>>,
    isBaseQuestion?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestion>>, Record<string, never>>,
    optional?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestion>>, Record<string, never>>,
    qid?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestion>>, Record<string, never>>,
    questionMdDisplay?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestion>>, Record<string, never>>,
    template?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestion>>, Record<string, never>>
  },
  SurveyQuestionCustomizationOption?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionCustomizationOption>>, Record<string, never>>,
    text?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionCustomizationOption>>, Record<string, never>>
  },
  SurveyQuestionMdDisplay?: {
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionMdDisplay>>, Record<string, never>>,
    displayOnMatchingDashboard?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionMdDisplay>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionMdDisplay>>, Record<string, never>>,
    question?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionMdDisplay>>, Record<string, never>>,
    sortable?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionMdDisplay>>, Record<string, never>>
  },
  SurveyQuestionRestrictedOption?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionRestrictedOption>>, Record<string, never>>,
    label?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionRestrictedOption>>, Record<string, never>>
  },
  SurveyQuestionRestrictedOptionConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionRestrictedOptionConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionRestrictedOptionConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionRestrictedOptionConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionRestrictedOptionConnection>>, Record<string, never>>
  },
  SurveyQuestionRestrictedOptionEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionRestrictedOptionEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionRestrictedOptionEdge>>, Record<string, never>>
  },
  SurveyQuestionTemplate?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionTemplate>>, Record<string, never>>,
    templateId?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyQuestionTemplate>>, Record<string, never>>
  },
  SurveyResponse?: {
    answers?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponse>>, SurveyResponseAnswersArgs>,
    context?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponse>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponse>>, Record<string, never>>,
    mentorship?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponse>>, Record<string, never>>,
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponse>>, Record<string, never>>,
    submittedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponse>>, Record<string, never>>,
    survey?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponse>>, Record<string, never>>,
    surveyResponseAnswerStrings?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponse>>, SurveyResponseSurveyResponseAnswerStringsArgs>
  },
  SurveyResponseAnswerStrings?: {
    answerString?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseAnswerStrings>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseAnswerStrings>>, Record<string, never>>,
    qid?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseAnswerStrings>>, Record<string, never>>,
    questionPrompt?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseAnswerStrings>>, Record<string, never>>,
    subprompt?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseAnswerStrings>>, Record<string, never>>,
    surveyResponseAnswerId?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseAnswerStrings>>, Record<string, never>>
  },
  SurveyResponseConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseConnection>>, Record<string, never>>
  },
  SurveyResponseContext?: {
    mentorshipChatGroupId?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseContext>>, Record<string, never>>,
    mentorshipId?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseContext>>, Record<string, never>>,
    participantId?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseContext>>, Record<string, never>>
  },
  SurveyResponseEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<SurveyResponseEdge>>, Record<string, never>>
  },
  TakeExternalLinkTask?: {
    customAfterCallToAction?: GraphCacheUpdateResolver<Maybe<WithTypename<TakeExternalLinkTask>>, Record<string, never>>,
    customCallToAction?: GraphCacheUpdateResolver<Maybe<WithTypename<TakeExternalLinkTask>>, Record<string, never>>,
    externalLink?: GraphCacheUpdateResolver<Maybe<WithTypename<TakeExternalLinkTask>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TakeExternalLinkTask>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<TakeExternalLinkTask>>, Record<string, never>>,
    prompt?: GraphCacheUpdateResolver<Maybe<WithTypename<TakeExternalLinkTask>>, Record<string, never>>
  },
  TakeSurveyTask?: {
    customAfterCallToAction?: GraphCacheUpdateResolver<Maybe<WithTypename<TakeSurveyTask>>, Record<string, never>>,
    customCallToAction?: GraphCacheUpdateResolver<Maybe<WithTypename<TakeSurveyTask>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TakeSurveyTask>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<TakeSurveyTask>>, Record<string, never>>,
    prompt?: GraphCacheUpdateResolver<Maybe<WithTypename<TakeSurveyTask>>, Record<string, never>>,
    survey?: GraphCacheUpdateResolver<Maybe<WithTypename<TakeSurveyTask>>, Record<string, never>>
  },
  TaskConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<TaskConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<TaskConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<TaskConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<TaskConnection>>, Record<string, never>>
  },
  TaskEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<TaskEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<TaskEdge>>, Record<string, never>>
  },
  TookTypeformSurveyLog?: {
    externalLink?: GraphCacheUpdateResolver<Maybe<WithTypename<TookTypeformSurveyLog>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TookTypeformSurveyLog>>, Record<string, never>>,
    loggedAtDate?: GraphCacheUpdateResolver<Maybe<WithTypename<TookTypeformSurveyLog>>, Record<string, never>>
  },
  Topic?: {
    archivedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<Topic>>, Record<string, never>>,
    category?: GraphCacheUpdateResolver<Maybe<WithTypename<Topic>>, Record<string, never>>,
    hoursDelayBeforeRestart?: GraphCacheUpdateResolver<Maybe<WithTypename<Topic>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Topic>>, Record<string, never>>,
    isDefault?: GraphCacheUpdateResolver<Maybe<WithTypename<Topic>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Topic>>, Record<string, never>>,
    priority?: GraphCacheUpdateResolver<Maybe<WithTypename<Topic>>, Record<string, never>>,
    programSegment?: GraphCacheUpdateResolver<Maybe<WithTypename<Topic>>, Record<string, never>>,
    programTopics?: GraphCacheUpdateResolver<Maybe<WithTypename<Topic>>, TopicProgramTopicsArgs>,
    topicConditions?: GraphCacheUpdateResolver<Maybe<WithTypename<Topic>>, Record<string, never>>,
    topicMessages?: GraphCacheUpdateResolver<Maybe<WithTypename<Topic>>, Record<string, never>>,
    userState?: GraphCacheUpdateResolver<Maybe<WithTypename<Topic>>, Record<string, never>>
  },
  TopicCollection?: {
    key?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicCollection>>, Record<string, never>>,
    topics?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicCollection>>, TopicCollectionTopicsArgs>
  },
  TopicCondition?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicCondition>>, Record<string, never>>,
    key?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicCondition>>, Record<string, never>>,
    topics?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicCondition>>, Record<string, never>>,
    value?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicCondition>>, Record<string, never>>
  },
  TopicConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicConnection>>, Record<string, never>>
  },
  TopicEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicEdge>>, Record<string, never>>
  },
  TopicMessage?: {
    emailTemplate?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicMessage>>, Record<string, never>>,
    hoursDelayAfterMessage?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicMessage>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicMessage>>, Record<string, never>>,
    index?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicMessage>>, Record<string, never>>,
    preferredMedium?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicMessage>>, Record<string, never>>,
    smsTemplate?: GraphCacheUpdateResolver<Maybe<WithTypename<TopicMessage>>, Record<string, never>>
  },
  TrainingEventLog?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TrainingEventLog>>, Record<string, never>>,
    kind?: GraphCacheUpdateResolver<Maybe<WithTypename<TrainingEventLog>>, Record<string, never>>,
    loggedAtDate?: GraphCacheUpdateResolver<Maybe<WithTypename<TrainingEventLog>>, Record<string, never>>,
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<TrainingEventLog>>, Record<string, never>>
  },
  UnmatchParticipantPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UnmatchParticipantPayload>>, Record<string, never>>,
    mentorship?: GraphCacheUpdateResolver<Maybe<WithTypename<UnmatchParticipantPayload>>, Record<string, never>>,
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<UnmatchParticipantPayload>>, Record<string, never>>
  },
  UnmatchParticipantsPayload?: {
    batchActionId?: GraphCacheUpdateResolver<Maybe<WithTypename<UnmatchParticipantsPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UnmatchParticipantsPayload>>, Record<string, never>>
  },
  UpdateAssessmentSurveyNewProgramTaskPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateAssessmentSurveyNewProgramTaskPayload>>, Record<string, never>>,
    newProgramTask?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateAssessmentSurveyNewProgramTaskPayload>>, Record<string, never>>
  },
  UpdateClickLinkNewProgramTaskPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateClickLinkNewProgramTaskPayload>>, Record<string, never>>,
    newProgramTask?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateClickLinkNewProgramTaskPayload>>, Record<string, never>>
  },
  UpdateClickLinkNewTaskPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateClickLinkNewTaskPayload>>, Record<string, never>>,
    newTask?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateClickLinkNewTaskPayload>>, Record<string, never>>
  },
  UpdateCourseNewProgramTaskPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateCourseNewProgramTaskPayload>>, Record<string, never>>,
    newProgramTask?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateCourseNewProgramTaskPayload>>, Record<string, never>>
  },
  UpdateCourseNewTaskPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateCourseNewTaskPayload>>, Record<string, never>>,
    newTask?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateCourseNewTaskPayload>>, Record<string, never>>
  },
  UpdateEmailTemplatePayload?: {
    emailTemplate?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateEmailTemplatePayload>>, Record<string, never>>
  },
  UpdateFlagContactPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateFlagContactPayload>>, Record<string, never>>,
    flagContact?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateFlagContactPayload>>, Record<string, never>>
  },
  UpdateFlagPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateFlagPayload>>, Record<string, never>>,
    flag?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateFlagPayload>>, Record<string, never>>
  },
  UpdateMenteeMentorSettingsError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateMenteeMentorSettingsError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateMenteeMentorSettingsError>>, Record<string, never>>
  },
  UpdateMenteeMentorSettingsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateMenteeMentorSettingsPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateMenteeMentorSettingsPayload>>, Record<string, never>>
  },
  UpdateMicroSurveyPayload?: {
    microSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateMicroSurveyPayload>>, Record<string, never>>
  },
  UpdateNewProgramTaskPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateNewProgramTaskPayload>>, Record<string, never>>,
    newProgramTask?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateNewProgramTaskPayload>>, Record<string, never>>
  },
  UpdateParticipantPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateParticipantPayload>>, Record<string, never>>,
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateParticipantPayload>>, Record<string, never>>
  },
  UpdateParticipantsMatchingLabelsPayload?: {
    batchActionId?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateParticipantsMatchingLabelsPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateParticipantsMatchingLabelsPayload>>, Record<string, never>>
  },
  UpdatePartnerPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdatePartnerPayload>>, Record<string, never>>,
    partner?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdatePartnerPayload>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdatePartnerPayload>>, Record<string, never>>
  },
  UpdateProgramAdminsError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramAdminsError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramAdminsError>>, Record<string, never>>
  },
  UpdateProgramAdminsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramAdminsPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramAdminsPayload>>, Record<string, never>>
  },
  UpdateProgramCommunicationSettingsPayload?: {
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramCommunicationSettingsPayload>>, Record<string, never>>
  },
  UpdateProgramCustomLabelPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramCustomLabelPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramCustomLabelPayload>>, Record<string, never>>
  },
  UpdateProgramCustomMessageTemplatesError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramCustomMessageTemplatesError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramCustomMessageTemplatesError>>, Record<string, never>>
  },
  UpdateProgramCustomMessageTemplatesPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramCustomMessageTemplatesPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramCustomMessageTemplatesPayload>>, Record<string, never>>
  },
  UpdateProgramFlagContactsError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramFlagContactsError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramFlagContactsError>>, Record<string, never>>
  },
  UpdateProgramFlagContactsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramFlagContactsPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramFlagContactsPayload>>, Record<string, never>>
  },
  UpdateProgramInfoError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramInfoError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramInfoError>>, Record<string, never>>
  },
  UpdateProgramInfoPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramInfoPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramInfoPayload>>, Record<string, never>>
  },
  UpdateProgramPointPeopleError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramPointPeopleError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramPointPeopleError>>, Record<string, never>>
  },
  UpdateProgramPointPeoplePayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramPointPeoplePayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramPointPeoplePayload>>, Record<string, never>>
  },
  UpdateProgramProfileAttributesPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramProfileAttributesPayload>>, Record<string, never>>,
    updatedProgramProfileAttributes?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramProfileAttributesPayload>>, Record<string, never>>
  },
  UpdateProgramSequenceInfoError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramSequenceInfoError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramSequenceInfoError>>, Record<string, never>>
  },
  UpdateProgramSequenceInfoPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramSequenceInfoPayload>>, Record<string, never>>,
    programSequence?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramSequenceInfoPayload>>, Record<string, never>>
  },
  UpdateProgramSetupError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramSetupError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramSetupError>>, Record<string, never>>
  },
  UpdateProgramSetupPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramSetupPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramSetupPayload>>, Record<string, never>>
  },
  UpdateProgramTaskPayload?: {
    programTask?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramTaskPayload>>, Record<string, never>>
  },
  UpdateProgramTopicPayload?: {
    programTopic?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramTopicPayload>>, Record<string, never>>
  },
  UpdateProgramTopicsError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramTopicsError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramTopicsError>>, Record<string, never>>
  },
  UpdateProgramTopicsPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramTopicsPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateProgramTopicsPayload>>, Record<string, never>>
  },
  UpdateSchoolInfoError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateSchoolInfoError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateSchoolInfoError>>, Record<string, never>>
  },
  UpdateSchoolInfoPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateSchoolInfoPayload>>, Record<string, never>>,
    school?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateSchoolInfoPayload>>, Record<string, never>>
  },
  UpdateSmsTemplatePayload?: {
    smsTemplate?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateSmsTemplatePayload>>, Record<string, never>>
  },
  UpdateSurveysAndQuizzesError?: {
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateSurveysAndQuizzesError>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateSurveysAndQuizzesError>>, Record<string, never>>
  },
  UpdateSurveysAndQuizzesPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateSurveysAndQuizzesPayload>>, Record<string, never>>,
    program?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateSurveysAndQuizzesPayload>>, Record<string, never>>
  },
  UpdateTopicPayload?: {
    topic?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateTopicPayload>>, Record<string, never>>
  },
  UpdateUserPayload?: {
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateUserPayload>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<UpdateUserPayload>>, Record<string, never>>
  },
  UploadPhotoTask?: {
    customAfterCallToAction?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadPhotoTask>>, Record<string, never>>,
    customCallToAction?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadPhotoTask>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadPhotoTask>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadPhotoTask>>, Record<string, never>>,
    prompt?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadPhotoTask>>, Record<string, never>>
  },
  UploadUserProfileDataPayload?: {
    batchActionId?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadUserProfileDataPayload>>, Record<string, never>>,
    errors?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadUserProfileDataPayload>>, Record<string, never>>
  },
  UploadVideoTask?: {
    customAfterCallToAction?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadVideoTask>>, Record<string, never>>,
    customCallToAction?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadVideoTask>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadVideoTask>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadVideoTask>>, Record<string, never>>,
    prompt?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadVideoTask>>, Record<string, never>>
  },
  UploadedVideo?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadedVideo>>, Record<string, never>>,
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadedVideo>>, Record<string, never>>,
    sharePublicly?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadedVideo>>, Record<string, never>>,
    shareWithStudents?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadedVideo>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadedVideo>>, Record<string, never>>,
    ziggeoToken?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadedVideo>>, Record<string, never>>
  },
  UploadedVideoConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadedVideoConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadedVideoConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadedVideoConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadedVideoConnection>>, Record<string, never>>
  },
  UploadedVideoEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadedVideoEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<UploadedVideoEdge>>, Record<string, never>>
  },
  User?: {
    activeShearwaterAdministrator?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    avatar?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    avatarImage?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserAvatarImageArgs>,
    cachedUserProfileData?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserCachedUserProfileDataArgs>,
    contacts?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserContactsArgs>,
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    facebookUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    firstName?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    hasValidSsoToken?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserHasValidSsoTokenArgs>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    instagramUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    isAdmin?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    isFeatureEnabledFor?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserIsFeatureEnabledForArgs>,
    isMentorInChatGroup?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    isPartner?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    lastName?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    lastProgramPageVisit?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserLastProgramPageVisitArgs>,
    lastSignInAt?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    latestDashboardNotificationData?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserLatestDashboardNotificationDataArgs>,
    latestPartnerProgramForSchool?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserLatestPartnerProgramForSchoolArgs>,
    linkedInUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    mentorshipCredentials?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserMentorshipCredentialsArgs>,
    microSurvey?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    participants?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserParticipantsArgs>,
    partners?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserPartnersArgs>,
    phone?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    phoneCountry?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    profile?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    schoolIdentifiers?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    signedUpWithSso?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    surveyResponses?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserSurveyResponsesArgs>,
    twitterUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    unsubscribedFromEmails?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    unsubscribedFromSmses?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    userProfileData?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserUserProfileDataArgs>,
    userStatusInProgram?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserUserStatusInProgramArgs>
  },
  UserConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<UserConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<UserConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<UserConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<UserConnection>>, Record<string, never>>
  },
  UserEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<UserEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<UserEdge>>, Record<string, never>>
  },
  UserMentorshipCredential?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<UserMentorshipCredential>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UserMentorshipCredential>>, Record<string, never>>,
    mentorshipCredential?: GraphCacheUpdateResolver<Maybe<WithTypename<UserMentorshipCredential>>, Record<string, never>>,
    updatedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<UserMentorshipCredential>>, Record<string, never>>
  },
  UserProfileAttributeValue?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UserProfileAttributeValue>>, Record<string, never>>,
    openResponse?: GraphCacheUpdateResolver<Maybe<WithTypename<UserProfileAttributeValue>>, Record<string, never>>,
    profileAttributeValue?: GraphCacheUpdateResolver<Maybe<WithTypename<UserProfileAttributeValue>>, Record<string, never>>,
    userProfileAttributeValueUpdate?: GraphCacheUpdateResolver<Maybe<WithTypename<UserProfileAttributeValue>>, Record<string, never>>
  },
  UserProfileAttributeValueUpdate?: {
    createdAt?: GraphCacheUpdateResolver<Maybe<WithTypename<UserProfileAttributeValueUpdate>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UserProfileAttributeValueUpdate>>, Record<string, never>>,
    programId?: GraphCacheUpdateResolver<Maybe<WithTypename<UserProfileAttributeValueUpdate>>, Record<string, never>>,
    source?: GraphCacheUpdateResolver<Maybe<WithTypename<UserProfileAttributeValueUpdate>>, Record<string, never>>
  },
  UserProfileData?: {
    profileAttribute?: GraphCacheUpdateResolver<Maybe<WithTypename<UserProfileData>>, Record<string, never>>,
    values?: GraphCacheUpdateResolver<Maybe<WithTypename<UserProfileData>>, Record<string, never>>
  },
  UserStateVariable?: {
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<UserStateVariable>>, Record<string, never>>,
    path?: GraphCacheUpdateResolver<Maybe<WithTypename<UserStateVariable>>, Record<string, never>>,
    previewValue?: GraphCacheUpdateResolver<Maybe<WithTypename<UserStateVariable>>, Record<string, never>>
  },
  UsersMetrics?: {
    totalEnteredProgram?: GraphCacheUpdateResolver<Maybe<WithTypename<UsersMetrics>>, UsersMetricsTotalEnteredProgramArgs>,
    totalMinimumTouchpoints?: GraphCacheUpdateResolver<Maybe<WithTypename<UsersMetrics>>, UsersMetricsTotalMinimumTouchpointsArgs>,
    totalRepliesToMcTextMessages?: GraphCacheUpdateResolver<Maybe<WithTypename<UsersMetrics>>, UsersMetricsTotalRepliesToMcTextMessagesArgs>,
    totalZeroTouchpoints?: GraphCacheUpdateResolver<Maybe<WithTypename<UsersMetrics>>, UsersMetricsTotalZeroTouchpointsArgs>
  },
  WatchVideoTask?: {
    customAfterCallToAction?: GraphCacheUpdateResolver<Maybe<WithTypename<WatchVideoTask>>, Record<string, never>>,
    customCallToAction?: GraphCacheUpdateResolver<Maybe<WithTypename<WatchVideoTask>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<WatchVideoTask>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<WatchVideoTask>>, Record<string, never>>,
    prompt?: GraphCacheUpdateResolver<Maybe<WithTypename<WatchVideoTask>>, Record<string, never>>,
    wistiaVideoId?: GraphCacheUpdateResolver<Maybe<WithTypename<WatchVideoTask>>, Record<string, never>>
  },
  WatchedCommunityVideoLog?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<WatchedCommunityVideoLog>>, Record<string, never>>,
    loggedAtDate?: GraphCacheUpdateResolver<Maybe<WithTypename<WatchedCommunityVideoLog>>, Record<string, never>>,
    ziggeoToken?: GraphCacheUpdateResolver<Maybe<WithTypename<WatchedCommunityVideoLog>>, Record<string, never>>
  },
  WatchedVideoLog?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<WatchedVideoLog>>, Record<string, never>>,
    loggedAtDate?: GraphCacheUpdateResolver<Maybe<WithTypename<WatchedVideoLog>>, Record<string, never>>,
    wistiaVideoId?: GraphCacheUpdateResolver<Maybe<WithTypename<WatchedVideoLog>>, Record<string, never>>
  },
  WrittenMessage?: {
    content?: GraphCacheUpdateResolver<Maybe<WithTypename<WrittenMessage>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<WrittenMessage>>, Record<string, never>>,
    participant?: GraphCacheUpdateResolver<Maybe<WithTypename<WrittenMessage>>, Record<string, never>>
  },
  WrittenMessageConnection?: {
    edges?: GraphCacheUpdateResolver<Maybe<WithTypename<WrittenMessageConnection>>, Record<string, never>>,
    nodes?: GraphCacheUpdateResolver<Maybe<WithTypename<WrittenMessageConnection>>, Record<string, never>>,
    pageInfo?: GraphCacheUpdateResolver<Maybe<WithTypename<WrittenMessageConnection>>, Record<string, never>>,
    totalCount?: GraphCacheUpdateResolver<Maybe<WithTypename<WrittenMessageConnection>>, Record<string, never>>
  },
  WrittenMessageEdge?: {
    cursor?: GraphCacheUpdateResolver<Maybe<WithTypename<WrittenMessageEdge>>, Record<string, never>>,
    node?: GraphCacheUpdateResolver<Maybe<WithTypename<WrittenMessageEdge>>, Record<string, never>>
  },
};

export type GraphCacheConfig = Parameters<typeof cacheExchange>[0] & {
  updates?: GraphCacheUpdaters,
  keys?: GraphCacheKeysConfig,
  optimistic?: GraphCacheOptimisticUpdaters,
  resolvers?: GraphCacheResolvers,
};